//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdultObservationCodesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdultObservationCodeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdultObservationCodeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdultObservationCodeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdultObservationCodeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdultObservationCodeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAdultObservationCodeForView(id: number | undefined): Observable<GetAdultObservationCodeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAdultObservationCodeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdultObservationCodeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdultObservationCodeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdultObservationCodeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdultObservationCodeForViewDto>;
        }));
    }

    protected processGetAdultObservationCodeForView(response: HttpResponseBase): Observable<GetAdultObservationCodeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdultObservationCodeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAdultObservationCodeForEdit(id: number | undefined): Observable<GetAdultObservationCodeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAdultObservationCodeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdultObservationCodeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdultObservationCodeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdultObservationCodeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdultObservationCodeForEditOutput>;
        }));
    }

    protected processGetAdultObservationCodeForEdit(response: HttpResponseBase): Observable<GetAdultObservationCodeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdultObservationCodeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditAdultObservationCodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTreeStatusForTableDropdown(): Observable<TreeStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAllTreeStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllTreeStatusForTableDropdown(response: HttpResponseBase): Observable<TreeStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @return OK
     */
    getAdultObservationCodesToExcel(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/GetAdultObservationCodesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdultObservationCodesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdultObservationCodesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdultObservationCodesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAdultObservationCodeFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/CreateAdultObservationCodeFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdultObservationCodeFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdultObservationCodeFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateAdultObservationCodeFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditAdultObservationCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdultObservationCodes/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAdultObservationCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAdultObservationCodeDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditAdultObservationCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditAdultObservationCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new globalThis.Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new globalThis.Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new globalThis.Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new globalThis.Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new globalThis.Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new globalThis.Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new globalThis.Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new globalThis.Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new globalThis.Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new globalThis.Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return OK
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new globalThis.Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BBXDestinationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isMjFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, isMjFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBBXDestinationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isMjFilter === null)
            throw new globalThis.Error("The parameter 'isMjFilter' cannot be null.");
        else if (isMjFilter !== undefined)
            url_ += "IsMjFilter=" + encodeURIComponent("" + isMjFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBBXDestinationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBBXDestinationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBBXDestinationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBBXDestinationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isMjFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, isMjFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isMjFilter === null)
            throw new globalThis.Error("The parameter 'isMjFilter' cannot be null.");
        else if (isMjFilter !== undefined)
            url_ += "IsMjFilter=" + encodeURIComponent("" + isMjFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getBBXDestinationForView(id: number | undefined): Observable<GetBBXDestinationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/GetBBXDestinationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXDestinationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXDestinationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBBXDestinationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBBXDestinationForViewDto>;
        }));
    }

    protected processGetBBXDestinationForView(response: HttpResponseBase): Observable<GetBBXDestinationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBBXDestinationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getBBXDestinationForEdit(id: number | undefined): Observable<GetBBXDestinationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/GetBBXDestinationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXDestinationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXDestinationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBBXDestinationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBBXDestinationForEditOutput>;
        }));
    }

    protected processGetBBXDestinationForEdit(response: HttpResponseBase): Observable<GetBBXDestinationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBBXDestinationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditBBXDestinationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isMjFilter (optional) 
     * @return OK
     */
    getBBXDestinationsToExcel(filter: string | undefined, nameFilter: string | undefined, isMjFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXDestinations/GetBBXDestinationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isMjFilter === null)
            throw new globalThis.Error("The parameter 'isMjFilter' cannot be null.");
        else if (isMjFilter !== undefined)
            url_ += "IsMjFilter=" + encodeURIComponent("" + isMjFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXDestinationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXDestinationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBBXDestinationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BBXManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param clone (optional) 
     * @return OK
     */
    calFasttrack(clone: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/CalFasttrack?";
        if (clone === null)
            throw new globalThis.Error("The parameter 'clone' cannot be null.");
        else if (clone !== undefined)
            url_ += "Clone=" + encodeURIComponent("" + clone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalFasttrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalFasttrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCalFasttrack(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clone (optional) 
     * @return OK
     */
    isFastTrack(clone: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/IsFastTrack?";
        if (clone === null)
            throw new globalThis.Error("The parameter 'clone' cannot be null.");
        else if (clone !== undefined)
            url_ += "Clone=" + encodeURIComponent("" + clone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsFastTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsFastTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsFastTrack(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXBBTFilter (optional) 
     * @param bBXIDFilter (optional) 
     * @param bBTIDFilter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateFilter (optional) 
     * @param origenFilter (optional) 
     * @param destineFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getEdit(filter: string | undefined, bBXBBTFilter: string | undefined, bBXIDFilter: number | undefined, bBTIDFilter: number | undefined, id: number | undefined, statusFilter: string | undefined, dateFilter: DateTime | undefined, origenFilter: number | undefined, destineFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CreateOrEditDestinoBBXDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetEdit?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXBBTFilter === null)
            throw new globalThis.Error("The parameter 'bBXBBTFilter' cannot be null.");
        else if (bBXBBTFilter !== undefined)
            url_ += "BBXBBTFilter=" + encodeURIComponent("" + bBXBBTFilter) + "&";
        if (bBXIDFilter === null)
            throw new globalThis.Error("The parameter 'bBXIDFilter' cannot be null.");
        else if (bBXIDFilter !== undefined)
            url_ += "BBXIDFilter=" + encodeURIComponent("" + bBXIDFilter) + "&";
        if (bBTIDFilter === null)
            throw new globalThis.Error("The parameter 'bBTIDFilter' cannot be null.");
        else if (bBTIDFilter !== undefined)
            url_ += "BBTIDFilter=" + encodeURIComponent("" + bBTIDFilter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent(dateFilter ? "" + dateFilter.toString() : "") + "&";
        if (origenFilter === null)
            throw new globalThis.Error("The parameter 'origenFilter' cannot be null.");
        else if (origenFilter !== undefined)
            url_ += "OrigenFilter=" + encodeURIComponent("" + origenFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditDestinoBBXDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditDestinoBBXDto>;
        }));
    }

    protected processGetEdit(response: HttpResponseBase): Observable<CreateOrEditDestinoBBXDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditDestinoBBXDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXBBTFilter (optional) 
     * @param bBXIDFilter (optional) 
     * @param bBTIDFilter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateFilter (optional) 
     * @param origenFilter (optional) 
     * @param destineFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllEdit(filter: string | undefined, bBXBBTFilter: string | undefined, bBXIDFilter: number | undefined, bBTIDFilter: number | undefined, id: number | undefined, statusFilter: string | undefined, dateFilter: DateTime | undefined, origenFilter: number | undefined, destineFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBBXManagementForViewEditDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetAllEdit?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXBBTFilter === null)
            throw new globalThis.Error("The parameter 'bBXBBTFilter' cannot be null.");
        else if (bBXBBTFilter !== undefined)
            url_ += "BBXBBTFilter=" + encodeURIComponent("" + bBXBBTFilter) + "&";
        if (bBXIDFilter === null)
            throw new globalThis.Error("The parameter 'bBXIDFilter' cannot be null.");
        else if (bBXIDFilter !== undefined)
            url_ += "BBXIDFilter=" + encodeURIComponent("" + bBXIDFilter) + "&";
        if (bBTIDFilter === null)
            throw new globalThis.Error("The parameter 'bBTIDFilter' cannot be null.");
        else if (bBTIDFilter !== undefined)
            url_ += "BBTIDFilter=" + encodeURIComponent("" + bBTIDFilter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent(dateFilter ? "" + dateFilter.toString() : "") + "&";
        if (origenFilter === null)
            throw new globalThis.Error("The parameter 'origenFilter' cannot be null.");
        else if (origenFilter !== undefined)
            url_ += "OrigenFilter=" + encodeURIComponent("" + origenFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBBXManagementForViewEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBBXManagementForViewEditDto>;
        }));
    }

    protected processGetAllEdit(response: HttpResponseBase): Observable<PagedResultDtoOfGetBBXManagementForViewEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBBXManagementForViewEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXBBTFilter (optional) 
     * @param bBXIDFilter (optional) 
     * @param bBTIDFilter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateFilter (optional) 
     * @param origenFilter (optional) 
     * @param destineFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, bBXBBTFilter: string | undefined, bBXIDFilter: number | undefined, bBTIDFilter: number | undefined, id: number | undefined, statusFilter: string | undefined, dateFilter: DateTime | undefined, origenFilter: number | undefined, destineFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBBXManagementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXBBTFilter === null)
            throw new globalThis.Error("The parameter 'bBXBBTFilter' cannot be null.");
        else if (bBXBBTFilter !== undefined)
            url_ += "BBXBBTFilter=" + encodeURIComponent("" + bBXBBTFilter) + "&";
        if (bBXIDFilter === null)
            throw new globalThis.Error("The parameter 'bBXIDFilter' cannot be null.");
        else if (bBXIDFilter !== undefined)
            url_ += "BBXIDFilter=" + encodeURIComponent("" + bBXIDFilter) + "&";
        if (bBTIDFilter === null)
            throw new globalThis.Error("The parameter 'bBTIDFilter' cannot be null.");
        else if (bBTIDFilter !== undefined)
            url_ += "BBTIDFilter=" + encodeURIComponent("" + bBTIDFilter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent(dateFilter ? "" + dateFilter.toString() : "") + "&";
        if (origenFilter === null)
            throw new globalThis.Error("The parameter 'origenFilter' cannot be null.");
        else if (origenFilter !== undefined)
            url_ += "OrigenFilter=" + encodeURIComponent("" + origenFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBBXManagementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBBXManagementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBBXManagementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBBXManagementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXBBTFilter (optional) 
     * @param bBXIDFilter (optional) 
     * @param bBTIDFilter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateFilter (optional) 
     * @param origenFilter (optional) 
     * @param destineFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllBBXManager(filter: string | undefined, bBXBBTFilter: string | undefined, bBXIDFilter: number | undefined, bBTIDFilter: number | undefined, id: number | undefined, statusFilter: string | undefined, dateFilter: DateTime | undefined, origenFilter: number | undefined, destineFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBBXManagementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetAllBBXManager?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXBBTFilter === null)
            throw new globalThis.Error("The parameter 'bBXBBTFilter' cannot be null.");
        else if (bBXBBTFilter !== undefined)
            url_ += "BBXBBTFilter=" + encodeURIComponent("" + bBXBBTFilter) + "&";
        if (bBXIDFilter === null)
            throw new globalThis.Error("The parameter 'bBXIDFilter' cannot be null.");
        else if (bBXIDFilter !== undefined)
            url_ += "BBXIDFilter=" + encodeURIComponent("" + bBXIDFilter) + "&";
        if (bBTIDFilter === null)
            throw new globalThis.Error("The parameter 'bBTIDFilter' cannot be null.");
        else if (bBTIDFilter !== undefined)
            url_ += "BBTIDFilter=" + encodeURIComponent("" + bBTIDFilter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent(dateFilter ? "" + dateFilter.toString() : "") + "&";
        if (origenFilter === null)
            throw new globalThis.Error("The parameter 'origenFilter' cannot be null.");
        else if (origenFilter !== undefined)
            url_ += "OrigenFilter=" + encodeURIComponent("" + origenFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBXManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBXManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBBXManagementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBBXManagementForViewDto>;
        }));
    }

    protected processGetAllBBXManager(response: HttpResponseBase): Observable<PagedResultDtoOfGetBBXManagementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBBXManagementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param geneticMaterial (optional) 
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(geneticMaterial: string | undefined, body: DestinoBBXDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/CreateOrEdit?";
        if (geneticMaterial === null)
            throw new globalThis.Error("The parameter 'geneticMaterial' cannot be null.");
        else if (geneticMaterial !== undefined)
            url_ += "geneticMaterial=" + encodeURIComponent("" + geneticMaterial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXBBTFilter (optional) 
     * @param bBXIDFilter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateFilter (optional) 
     * @param origenFilter (optional) 
     * @param destineFilter (optional) 
     * @return OK
     */
    getClonesToExcel(filter: string | undefined, bBXBBTFilter: string | undefined, bBXIDFilter: number | undefined, id: number | undefined, statusFilter: string | undefined, dateFilter: DateTime | undefined, origenFilter: number | undefined, destineFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetClonesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXBBTFilter === null)
            throw new globalThis.Error("The parameter 'bBXBBTFilter' cannot be null.");
        else if (bBXBBTFilter !== undefined)
            url_ += "BBXBBTFilter=" + encodeURIComponent("" + bBXBBTFilter) + "&";
        if (bBXIDFilter === null)
            throw new globalThis.Error("The parameter 'bBXIDFilter' cannot be null.");
        else if (bBXIDFilter !== undefined)
            url_ += "BBXIDFilter=" + encodeURIComponent("" + bBXIDFilter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent(dateFilter ? "" + dateFilter.toString() : "") + "&";
        if (origenFilter === null)
            throw new globalThis.Error("The parameter 'origenFilter' cannot be null.");
        else if (origenFilter !== undefined)
            url_ += "OrigenFilter=" + encodeURIComponent("" + origenFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClonesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClonesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetClonesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllStatusCloneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStatusCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetAllStatusCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfStatusCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfStatusCloneLookupTableDto>;
        }));
    }

    protected processGetAllStatusCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStatusCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStatusCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllStatusFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetAllStatusFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllStatusFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getBBXBBTFilterByPagination(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGenericFilterDto> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetBBXBBTFilterByPagination?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXBBTFilterByPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXBBTFilterByPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGenericFilterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGenericFilterDto>;
        }));
    }

    protected processGetBBXBBTFilterByPagination(response: HttpResponseBase): Observable<PagedResultDtoOfGetGenericFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGenericFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getBBXBBTFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetBBXBBTFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXBBTFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXBBTFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetBBXBBTFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getBBXBBTByFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BBXManagement/GetBBXBBTByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXBBTByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXBBTByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetBBXBBTByFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CanaletonPlantationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param canaletonFilter (optional) 
     * @param plantaMadreFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, canaletonFilter: number | undefined, plantaMadreFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCanaletonPlantationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CanaletonPlantations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (canaletonFilter === null)
            throw new globalThis.Error("The parameter 'canaletonFilter' cannot be null.");
        else if (canaletonFilter !== undefined)
            url_ += "CanaletonFilter=" + encodeURIComponent("" + canaletonFilter) + "&";
        if (plantaMadreFilter === null)
            throw new globalThis.Error("The parameter 'plantaMadreFilter' cannot be null.");
        else if (plantaMadreFilter !== undefined)
            url_ += "PlantaMadreFilter=" + encodeURIComponent("" + plantaMadreFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCanaletonPlantationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCanaletonPlantationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCanaletonPlantationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCanaletonPlantationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategorySeedOriginsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param denominationFilter (optional) 
     * @param isBulkFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, denominationFilter: string | undefined, isBulkFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCategorySeedOriginForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (denominationFilter === null)
            throw new globalThis.Error("The parameter 'denominationFilter' cannot be null.");
        else if (denominationFilter !== undefined)
            url_ += "DenominationFilter=" + encodeURIComponent("" + denominationFilter) + "&";
        if (isBulkFilter === null)
            throw new globalThis.Error("The parameter 'isBulkFilter' cannot be null.");
        else if (isBulkFilter !== undefined)
            url_ += "IsBulkFilter=" + encodeURIComponent("" + isBulkFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCategorySeedOriginForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCategorySeedOriginForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCategorySeedOriginForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCategorySeedOriginForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param denominationFilter (optional) 
     * @param isBulkFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, denominationFilter: string | undefined, isBulkFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (denominationFilter === null)
            throw new globalThis.Error("The parameter 'denominationFilter' cannot be null.");
        else if (denominationFilter !== undefined)
            url_ += "DenominationFilter=" + encodeURIComponent("" + denominationFilter) + "&";
        if (isBulkFilter === null)
            throw new globalThis.Error("The parameter 'isBulkFilter' cannot be null.");
        else if (isBulkFilter !== undefined)
            url_ += "IsBulkFilter=" + encodeURIComponent("" + isBulkFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCategorySeedOriginForView(id: number | undefined): Observable<GetCategorySeedOriginForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/GetCategorySeedOriginForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorySeedOriginForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorySeedOriginForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategorySeedOriginForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategorySeedOriginForViewDto>;
        }));
    }

    protected processGetCategorySeedOriginForView(response: HttpResponseBase): Observable<GetCategorySeedOriginForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategorySeedOriginForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCategorySeedOriginForEdit(id: number | undefined): Observable<GetCategorySeedOriginForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/GetCategorySeedOriginForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorySeedOriginForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorySeedOriginForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategorySeedOriginForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategorySeedOriginForEditOutput>;
        }));
    }

    protected processGetCategorySeedOriginForEdit(response: HttpResponseBase): Observable<GetCategorySeedOriginForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategorySeedOriginForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditCategorySeedOriginDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param denominationFilter (optional) 
     * @param isBulkFilter (optional) 
     * @return OK
     */
    getCategorySeedOriginsToExcel(filter: string | undefined, nameFilter: string | undefined, denominationFilter: string | undefined, isBulkFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/GetCategorySeedOriginsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (denominationFilter === null)
            throw new globalThis.Error("The parameter 'denominationFilter' cannot be null.");
        else if (denominationFilter !== undefined)
            url_ += "DenominationFilter=" + encodeURIComponent("" + denominationFilter) + "&";
        if (isBulkFilter === null)
            throw new globalThis.Error("The parameter 'isBulkFilter' cannot be null.");
        else if (isBulkFilter !== undefined)
            url_ += "IsBulkFilter=" + encodeURIComponent("" + isBulkFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorySeedOriginsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorySeedOriginsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCategorySeedOriginsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categorySeedOriginFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/CategorySeedOriginFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorySeedOriginFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorySeedOriginFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCategorySeedOriginFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditCategorySeedOriginDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CategorySeedOrigins/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCategorySeedOriginDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCategorySeedOriginDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditCategorySeedOriginDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditCategorySeedOriginDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategoryTrialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCategoryTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCategoryTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCategoryTrialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCategoryTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCategoryTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCategoryTrialForView(id: number | undefined): Observable<GetCategoryTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/GetCategoryTrialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryTrialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTrialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategoryTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategoryTrialForViewDto>;
        }));
    }

    protected processGetCategoryTrialForView(response: HttpResponseBase): Observable<GetCategoryTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoryTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCategoryTrialForEdit(id: number | undefined): Observable<GetCategoryTrialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/GetCategoryTrialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryTrialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTrialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategoryTrialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategoryTrialForEditOutput>;
        }));
    }

    protected processGetCategoryTrialForEdit(response: HttpResponseBase): Observable<GetCategoryTrialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoryTrialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditCategoryTrialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getCategoryTrialsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/GetCategoryTrialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryTrialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTrialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCategoryTrialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTypeCategoryTrialFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/CreateTypeCategoryTrialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTypeCategoryTrialFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTypeCategoryTrialFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTypeCategoryTrialFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditCategoryTrialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CategoryTrials/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCategoryTrialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCategoryTrialDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditCategoryTrialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditCategoryTrialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return OK
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId === null)
            throw new globalThis.Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClonesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param bBXFilter (optional) 
     * @param cloneOriginFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param creationDateFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param minCreationDateFilter (optional) 
     * @param maxCreationDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, bBXFilter: string | undefined, cloneOriginFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, treeSpecieFilter: string | undefined, creationDateFilter: DateTime | undefined, supplierNameFilter: string | undefined, minCreationDateFilter: DateTime | undefined, maxCreationDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCloneForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (cloneOriginFilter === null)
            throw new globalThis.Error("The parameter 'cloneOriginFilter' cannot be null.");
        else if (cloneOriginFilter !== undefined)
            url_ += "CloneOriginFilter=" + encodeURIComponent("" + cloneOriginFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (creationDateFilter === null)
            throw new globalThis.Error("The parameter 'creationDateFilter' cannot be null.");
        else if (creationDateFilter !== undefined)
            url_ += "CreationDateFilter=" + encodeURIComponent(creationDateFilter ? "" + creationDateFilter.toString() : "") + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        if (minCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'minCreationDateFilter' cannot be null.");
        else if (minCreationDateFilter !== undefined)
            url_ += "MinCreationDateFilter=" + encodeURIComponent(minCreationDateFilter ? "" + minCreationDateFilter.toString() : "") + "&";
        if (maxCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxCreationDateFilter' cannot be null.");
        else if (maxCreationDateFilter !== undefined)
            url_ += "MaxCreationDateFilter=" + encodeURIComponent(maxCreationDateFilter ? "" + maxCreationDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCloneForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCloneForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCloneForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCloneForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cloneFilter (optional) 
     * @return OK
     */
    getAllDistinctCloneIds(cloneFilter: string | undefined): Observable<CloneDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetAllDistinctCloneIds?";
        if (cloneFilter === null)
            throw new globalThis.Error("The parameter 'cloneFilter' cannot be null.");
        else if (cloneFilter !== undefined)
            url_ += "cloneFilter=" + encodeURIComponent("" + cloneFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctCloneIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctCloneIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CloneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CloneDto[]>;
        }));
    }

    protected processGetAllDistinctCloneIds(response: HttpResponseBase): Observable<CloneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloneDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCloneForView(id: number | undefined): Observable<GetCloneForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetCloneForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCloneForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCloneForViewDto>;
        }));
    }

    protected processGetCloneForView(response: HttpResponseBase): Observable<GetCloneForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCloneForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCloneForEdit(id: number | undefined): Observable<GetCloneForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetCloneForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCloneForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCloneForEditOutput>;
        }));
    }

    protected processGetCloneForEdit(response: HttpResponseBase): Observable<GetCloneForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCloneForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditCloneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Clones/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Clones/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXFilter (optional) 
     * @param cloneOriginFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param creationDate (optional) 
     * @param minCreationDateFilter (optional) 
     * @param maxCreationDateFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @return OK
     */
    getClonesToExcel(filter: string | undefined, bBXFilter: string | undefined, cloneOriginFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, treeSpecieFilter: string | undefined, creationDate: DateTime | undefined, minCreationDateFilter: any | undefined, maxCreationDateFilter: any | undefined, supplierNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetClonesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (cloneOriginFilter === null)
            throw new globalThis.Error("The parameter 'cloneOriginFilter' cannot be null.");
        else if (cloneOriginFilter !== undefined)
            url_ += "CloneOriginFilter=" + encodeURIComponent("" + cloneOriginFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (creationDate === null)
            throw new globalThis.Error("The parameter 'creationDate' cannot be null.");
        else if (creationDate !== undefined)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toString() : "") + "&";
        if (minCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'minCreationDateFilter' cannot be null.");
        else if (minCreationDateFilter !== undefined)
            url_ += "MinCreationDateFilter=" + encodeURIComponent("" + minCreationDateFilter) + "&";
        if (maxCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxCreationDateFilter' cannot be null.");
        else if (maxCreationDateFilter !== undefined)
            url_ += "MaxCreationDateFilter=" + encodeURIComponent("" + maxCreationDateFilter) + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClonesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClonesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetClonesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementSelectionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCloneMeasurementSelectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetAllMeasurementSelectionForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementSelectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementSelectionForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCloneMeasurementSelectionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCloneMeasurementSelectionLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementSelectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCloneMeasurementSelectionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCloneMeasurementSelectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCloneTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCloneTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCloneTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCloneTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCloneTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllBBX(body: DestinoBBXDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Clones/SetAllBBX";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetAllBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllBBXAndDestination(body: GetBBXDestinationForViewForManyDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Clones/SetAllBBXAndDestination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllBBXAndDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllBBXAndDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetAllBBXAndDestination(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setBBX(measurementId: number | undefined, body: GetBBXDestinationForViewDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Clones/SetBBX?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unSetAllBBX(body: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Clones/UnSetAllBBX";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetAllBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetAllBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetAllBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @return OK
     */
    unSetBBX(measurementId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Clones/UnSetBBX?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNextBBX(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetNextBBX";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNextBBX(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importBBXFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Clones/ImportBBXFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBBXFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBBXFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportBBXFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXFilter (optional) 
     * @param cloneOriginFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param creationDateFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param minCreationDateFilter (optional) 
     * @param maxCreationDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllImportedClones(filter: string | undefined, bBXFilter: string | undefined, cloneOriginFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, treeSpecieFilter: string | undefined, creationDateFilter: DateTime | undefined, supplierNameFilter: string | undefined, minCreationDateFilter: DateTime | undefined, maxCreationDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCloneForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetAllImportedClones?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (cloneOriginFilter === null)
            throw new globalThis.Error("The parameter 'cloneOriginFilter' cannot be null.");
        else if (cloneOriginFilter !== undefined)
            url_ += "CloneOriginFilter=" + encodeURIComponent("" + cloneOriginFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (creationDateFilter === null)
            throw new globalThis.Error("The parameter 'creationDateFilter' cannot be null.");
        else if (creationDateFilter !== undefined)
            url_ += "CreationDateFilter=" + encodeURIComponent(creationDateFilter ? "" + creationDateFilter.toString() : "") + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        if (minCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'minCreationDateFilter' cannot be null.");
        else if (minCreationDateFilter !== undefined)
            url_ += "MinCreationDateFilter=" + encodeURIComponent(minCreationDateFilter ? "" + minCreationDateFilter.toString() : "") + "&";
        if (maxCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxCreationDateFilter' cannot be null.");
        else if (maxCreationDateFilter !== undefined)
            url_ += "MaxCreationDateFilter=" + encodeURIComponent(maxCreationDateFilter ? "" + maxCreationDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllImportedClones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllImportedClones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCloneForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCloneForViewDto>;
        }));
    }

    protected processGetAllImportedClones(response: HttpResponseBase): Observable<PagedResultDtoOfGetCloneForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCloneForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBXFilter (optional) 
     * @param cloneOriginFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param creationDate (optional) 
     * @param minCreationDateFilter (optional) 
     * @param maxCreationDateFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @return OK
     */
    getImportedClonesToExcel(filter: string | undefined, bBXFilter: string | undefined, cloneOriginFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, treeSpecieFilter: string | undefined, creationDate: DateTime | undefined, minCreationDateFilter: any | undefined, maxCreationDateFilter: any | undefined, supplierNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Clones/GetImportedClonesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (cloneOriginFilter === null)
            throw new globalThis.Error("The parameter 'cloneOriginFilter' cannot be null.");
        else if (cloneOriginFilter !== undefined)
            url_ += "CloneOriginFilter=" + encodeURIComponent("" + cloneOriginFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (creationDate === null)
            throw new globalThis.Error("The parameter 'creationDate' cannot be null.");
        else if (creationDate !== undefined)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toString() : "") + "&";
        if (minCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'minCreationDateFilter' cannot be null.");
        else if (minCreationDateFilter !== undefined)
            url_ += "MinCreationDateFilter=" + encodeURIComponent("" + minCreationDateFilter) + "&";
        if (maxCreationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxCreationDateFilter' cannot be null.");
        else if (maxCreationDateFilter !== undefined)
            url_ += "MaxCreationDateFilter=" + encodeURIComponent("" + maxCreationDateFilter) + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportedClonesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportedClonesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetImportedClonesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CloneStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTrialFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, isTrialFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCloneStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTrialFilter === null)
            throw new globalThis.Error("The parameter 'isTrialFilter' cannot be null.");
        else if (isTrialFilter !== undefined)
            url_ += "isTrialFilter=" + encodeURIComponent("" + isTrialFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCloneStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCloneStatusForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCloneStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCloneStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTrialFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, isTrialFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTrialFilter === null)
            throw new globalThis.Error("The parameter 'isTrialFilter' cannot be null.");
        else if (isTrialFilter !== undefined)
            url_ += "isTrialFilter=" + encodeURIComponent("" + isTrialFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCloneStatusForView(id: number | undefined): Observable<GetCloneStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/GetCloneStatusForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneStatusForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneStatusForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCloneStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCloneStatusForViewDto>;
        }));
    }

    protected processGetCloneStatusForView(response: HttpResponseBase): Observable<GetCloneStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCloneStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCloneStatusForEdit(id: number | undefined): Observable<GetCloneStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/GetCloneStatusForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneStatusForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCloneStatusForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCloneStatusForEditOutput>;
        }));
    }

    protected processGetCloneStatusForEdit(response: HttpResponseBase): Observable<GetCloneStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCloneStatusForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditCloneStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTrialFilter (optional) 
     * @return OK
     */
    getCloneStatusesToExcel(filter: string | undefined, nameFilter: string | undefined, isTrialFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CloneStatuses/GetCloneStatusesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTrialFilter === null)
            throw new globalThis.Error("The parameter 'isTrialFilter' cannot be null.");
        else if (isTrialFilter !== undefined)
            url_ += "isTrialFilter=" + encodeURIComponent("" + isTrialFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneStatusesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCloneStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new globalThis.Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getStockMovementStockType(): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetStockMovementStockType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockMovementStockType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockMovementStockType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetStockMovementStockType(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationParameterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    getParameterValueByName(name: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ConfigurationParameter/GetParameterValueByName?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterValueByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterValueByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetParameterValueByName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ControlledCrossingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxBagNumberFilter (optional) 
     * @param minBagNumberFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param standNameFilter (optional) 
     * @param siteFilter (optional) 
     * @param maxCrossingYearFilter (optional) 
     * @param minCrossingYearFilter (optional) 
     * @param bBTMotherFilter (optional) 
     * @param specieMotherFilter (optional) 
     * @param idTreeMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idTreeFatherFilter (optional) 
     * @param bBTFatherFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param specieFilter (optional) 
     * @param maxEmasculationDateFilter (optional) 
     * @param minEmasculationDateFilter (optional) 
     * @param maxNumberOfMaskedBudsFilter (optional) 
     * @param minNumberOfMaskedBudsFilter (optional) 
     * @param maxPollinationDateFilter (optional) 
     * @param minPollinationDateFilter (optional) 
     * @param maxNumberPollinationBudsFilter (optional) 
     * @param minNumberPollinationBudsFilter (optional) 
     * @param maxBagWithdrawalDateFilter (optional) 
     * @param minBagWithdrawalDateFilter (optional) 
     * @param maxNumberCapsulesFilter (optional) 
     * @param minNumberCapsulesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxNumberHarvestedFilter (optional) 
     * @param minNumberHarvestedFilter (optional) 
     * @param maxPercentageHarvestRetentionFilter (optional) 
     * @param minPercentageHarvestRetentionFilter (optional) 
     * @param maxNumberOfSeedsFilter (optional) 
     * @param minNumberOfSeedsFilter (optional) 
     * @param operatorFilter (optional) 
     * @param bBCIdsFilter (optional) 
     * @param observationsFilter (optional) 
     * @param maxPercentageRetentionBagWithdrawalFilter (optional) 
     * @param minPercentageRetentionBagWithdrawalFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param polenBBPFilter (optional) 
     * @param seedBBS2Filter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param seedBBS3Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxBagNumberFilter: number | undefined, minBagNumberFilter: number | undefined, farmNameFilter: string | undefined, standNameFilter: string | undefined, siteFilter: string | undefined, maxCrossingYearFilter: number | undefined, minCrossingYearFilter: number | undefined, bBTMotherFilter: string | undefined, specieMotherFilter: string | undefined, idTreeMotherFilter: string | undefined, bBPFatherFilter: string | undefined, idTreeFatherFilter: string | undefined, bBTFatherFilter: string | undefined, specieFatherFilter: string | undefined, specieFilter: string | undefined, maxEmasculationDateFilter: DateTime | undefined, minEmasculationDateFilter: DateTime | undefined, maxNumberOfMaskedBudsFilter: number | undefined, minNumberOfMaskedBudsFilter: number | undefined, maxPollinationDateFilter: DateTime | undefined, minPollinationDateFilter: DateTime | undefined, maxNumberPollinationBudsFilter: number | undefined, minNumberPollinationBudsFilter: number | undefined, maxBagWithdrawalDateFilter: DateTime | undefined, minBagWithdrawalDateFilter: DateTime | undefined, maxNumberCapsulesFilter: number | undefined, minNumberCapsulesFilter: number | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxNumberHarvestedFilter: number | undefined, minNumberHarvestedFilter: number | undefined, maxPercentageHarvestRetentionFilter: number | undefined, minPercentageHarvestRetentionFilter: number | undefined, maxNumberOfSeedsFilter: number | undefined, minNumberOfSeedsFilter: number | undefined, operatorFilter: string | undefined, bBCIdsFilter: (number | undefined)[] | undefined, observationsFilter: string | undefined, maxPercentageRetentionBagWithdrawalFilter: number | undefined, minPercentageRetentionBagWithdrawalFilter: number | undefined, trialStandNameFilter: string | undefined, seedBBSFilter: string | undefined, polenBBPFilter: string | undefined, seedBBS2Filter: string | undefined, typeSpecieNameFilter: string | undefined, crossingTechniqueNameFilter: string | undefined, seedBBS3Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetControlledCrossingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxBagNumberFilter' cannot be null.");
        else if (maxBagNumberFilter !== undefined)
            url_ += "MaxBagNumberFilter=" + encodeURIComponent("" + maxBagNumberFilter) + "&";
        if (minBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'minBagNumberFilter' cannot be null.");
        else if (minBagNumberFilter !== undefined)
            url_ += "MinBagNumberFilter=" + encodeURIComponent("" + minBagNumberFilter) + "&";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        if (siteFilter === null)
            throw new globalThis.Error("The parameter 'siteFilter' cannot be null.");
        else if (siteFilter !== undefined)
            url_ += "SiteFilter=" + encodeURIComponent("" + siteFilter) + "&";
        if (maxCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'maxCrossingYearFilter' cannot be null.");
        else if (maxCrossingYearFilter !== undefined)
            url_ += "MaxCrossingYearFilter=" + encodeURIComponent("" + maxCrossingYearFilter) + "&";
        if (minCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'minCrossingYearFilter' cannot be null.");
        else if (minCrossingYearFilter !== undefined)
            url_ += "MinCrossingYearFilter=" + encodeURIComponent("" + minCrossingYearFilter) + "&";
        if (bBTMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBTMotherFilter' cannot be null.");
        else if (bBTMotherFilter !== undefined)
            url_ += "BBTMotherFilter=" + encodeURIComponent("" + bBTMotherFilter) + "&";
        if (specieMotherFilter === null)
            throw new globalThis.Error("The parameter 'specieMotherFilter' cannot be null.");
        else if (specieMotherFilter !== undefined)
            url_ += "SpecieMotherFilter=" + encodeURIComponent("" + specieMotherFilter) + "&";
        if (idTreeMotherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeMotherFilter' cannot be null.");
        else if (idTreeMotherFilter !== undefined)
            url_ += "IdTreeMotherFilter=" + encodeURIComponent("" + idTreeMotherFilter) + "&";
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            url_ += "BBPFatherFilter=" + encodeURIComponent("" + bBPFatherFilter) + "&";
        if (idTreeFatherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeFatherFilter' cannot be null.");
        else if (idTreeFatherFilter !== undefined)
            url_ += "IdTreeFatherFilter=" + encodeURIComponent("" + idTreeFatherFilter) + "&";
        if (bBTFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBTFatherFilter' cannot be null.");
        else if (bBTFatherFilter !== undefined)
            url_ += "BBTFatherFilter=" + encodeURIComponent("" + bBTFatherFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            url_ += "SpecieFatherFilter=" + encodeURIComponent("" + specieFatherFilter) + "&";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "SpecieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        if (maxEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxEmasculationDateFilter' cannot be null.");
        else if (maxEmasculationDateFilter !== undefined)
            url_ += "MaxEmasculationDateFilter=" + encodeURIComponent(maxEmasculationDateFilter ? "" + maxEmasculationDateFilter.toString() : "") + "&";
        if (minEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'minEmasculationDateFilter' cannot be null.");
        else if (minEmasculationDateFilter !== undefined)
            url_ += "MinEmasculationDateFilter=" + encodeURIComponent(minEmasculationDateFilter ? "" + minEmasculationDateFilter.toString() : "") + "&";
        if (maxNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfMaskedBudsFilter' cannot be null.");
        else if (maxNumberOfMaskedBudsFilter !== undefined)
            url_ += "MaxNumberOfMaskedBudsFilter=" + encodeURIComponent("" + maxNumberOfMaskedBudsFilter) + "&";
        if (minNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfMaskedBudsFilter' cannot be null.");
        else if (minNumberOfMaskedBudsFilter !== undefined)
            url_ += "MinNumberOfMaskedBudsFilter=" + encodeURIComponent("" + minNumberOfMaskedBudsFilter) + "&";
        if (maxPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPollinationDateFilter' cannot be null.");
        else if (maxPollinationDateFilter !== undefined)
            url_ += "MaxPollinationDateFilter=" + encodeURIComponent(maxPollinationDateFilter ? "" + maxPollinationDateFilter.toString() : "") + "&";
        if (minPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPollinationDateFilter' cannot be null.");
        else if (minPollinationDateFilter !== undefined)
            url_ += "MinPollinationDateFilter=" + encodeURIComponent(minPollinationDateFilter ? "" + minPollinationDateFilter.toString() : "") + "&";
        if (maxNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberPollinationBudsFilter' cannot be null.");
        else if (maxNumberPollinationBudsFilter !== undefined)
            url_ += "MaxNumberPollinationBudsFilter=" + encodeURIComponent("" + maxNumberPollinationBudsFilter) + "&";
        if (minNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberPollinationBudsFilter' cannot be null.");
        else if (minNumberPollinationBudsFilter !== undefined)
            url_ += "MinNumberPollinationBudsFilter=" + encodeURIComponent("" + minNumberPollinationBudsFilter) + "&";
        if (maxBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'maxBagWithdrawalDateFilter' cannot be null.");
        else if (maxBagWithdrawalDateFilter !== undefined)
            url_ += "MaxBagWithdrawalDateFilter=" + encodeURIComponent(maxBagWithdrawalDateFilter ? "" + maxBagWithdrawalDateFilter.toString() : "") + "&";
        if (minBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'minBagWithdrawalDateFilter' cannot be null.");
        else if (minBagWithdrawalDateFilter !== undefined)
            url_ += "MinBagWithdrawalDateFilter=" + encodeURIComponent(minBagWithdrawalDateFilter ? "" + minBagWithdrawalDateFilter.toString() : "") + "&";
        if (maxNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberCapsulesFilter' cannot be null.");
        else if (maxNumberCapsulesFilter !== undefined)
            url_ += "MaxNumberCapsulesFilter=" + encodeURIComponent("" + maxNumberCapsulesFilter) + "&";
        if (minNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'minNumberCapsulesFilter' cannot be null.");
        else if (minNumberCapsulesFilter !== undefined)
            url_ += "MinNumberCapsulesFilter=" + encodeURIComponent("" + minNumberCapsulesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberHarvestedFilter' cannot be null.");
        else if (maxNumberHarvestedFilter !== undefined)
            url_ += "MaxNumberHarvestedFilter=" + encodeURIComponent("" + maxNumberHarvestedFilter) + "&";
        if (minNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'minNumberHarvestedFilter' cannot be null.");
        else if (minNumberHarvestedFilter !== undefined)
            url_ += "MinNumberHarvestedFilter=" + encodeURIComponent("" + minNumberHarvestedFilter) + "&";
        if (maxPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageHarvestRetentionFilter' cannot be null.");
        else if (maxPercentageHarvestRetentionFilter !== undefined)
            url_ += "MaxPercentageHarvestRetentionFilter=" + encodeURIComponent("" + maxPercentageHarvestRetentionFilter) + "&";
        if (minPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageHarvestRetentionFilter' cannot be null.");
        else if (minPercentageHarvestRetentionFilter !== undefined)
            url_ += "MinPercentageHarvestRetentionFilter=" + encodeURIComponent("" + minPercentageHarvestRetentionFilter) + "&";
        if (maxNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfSeedsFilter' cannot be null.");
        else if (maxNumberOfSeedsFilter !== undefined)
            url_ += "MaxNumberOfSeedsFilter=" + encodeURIComponent("" + maxNumberOfSeedsFilter) + "&";
        if (minNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfSeedsFilter' cannot be null.");
        else if (minNumberOfSeedsFilter !== undefined)
            url_ += "MinNumberOfSeedsFilter=" + encodeURIComponent("" + minNumberOfSeedsFilter) + "&";
        if (operatorFilter === null)
            throw new globalThis.Error("The parameter 'operatorFilter' cannot be null.");
        else if (operatorFilter !== undefined)
            url_ += "OperatorFilter=" + encodeURIComponent("" + operatorFilter) + "&";
        if (bBCIdsFilter === null)
            throw new globalThis.Error("The parameter 'bBCIdsFilter' cannot be null.");
        else if (bBCIdsFilter !== undefined)
            bBCIdsFilter && bBCIdsFilter.forEach(item => { url_ += "BBCIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (maxPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (maxPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MaxPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + maxPercentageRetentionBagWithdrawalFilter) + "&";
        if (minPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (minPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MinPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + minPercentageRetentionBagWithdrawalFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (polenBBPFilter === null)
            throw new globalThis.Error("The parameter 'polenBBPFilter' cannot be null.");
        else if (polenBBPFilter !== undefined)
            url_ += "PolenBBPFilter=" + encodeURIComponent("" + polenBBPFilter) + "&";
        if (seedBBS2Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS2Filter' cannot be null.");
        else if (seedBBS2Filter !== undefined)
            url_ += "SeedBBS2Filter=" + encodeURIComponent("" + seedBBS2Filter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + typeSpecieNameFilter) + "&";
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + crossingTechniqueNameFilter) + "&";
        if (seedBBS3Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS3Filter' cannot be null.");
        else if (seedBBS3Filter !== undefined)
            url_ += "SeedBBS3Filter=" + encodeURIComponent("" + seedBBS3Filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetControlledCrossingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetControlledCrossingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetControlledCrossingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetControlledCrossingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbcFilter (optional) 
     * @return OK
     */
    getAllDistinctBBCIds(bbcFilter: string | undefined): Observable<ControlledCrossingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllDistinctBBCIds?";
        if (bbcFilter === null)
            throw new globalThis.Error("The parameter 'bbcFilter' cannot be null.");
        else if (bbcFilter !== undefined)
            url_ += "bbcFilter=" + encodeURIComponent("" + bbcFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBCIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBCIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlledCrossingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlledCrossingDto[]>;
        }));
    }

    protected processGetAllDistinctBBCIds(response: HttpResponseBase): Observable<ControlledCrossingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlledCrossingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbsFilter (optional) 
     * @return OK
     */
    getAllDistinctBBSs(bbsFilter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllDistinctBBSs?";
        if (bbsFilter === null)
            throw new globalThis.Error("The parameter 'bbsFilter' cannot be null.");
        else if (bbsFilter !== undefined)
            url_ += "bbsFilter=" + encodeURIComponent("" + bbsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBSs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBSs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDistinctBBSs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getControlledCrossingForView(id: number | undefined): Observable<GetControlledCrossingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetControlledCrossingForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlledCrossingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlledCrossingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetControlledCrossingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetControlledCrossingForViewDto>;
        }));
    }

    protected processGetControlledCrossingForView(response: HttpResponseBase): Observable<GetControlledCrossingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetControlledCrossingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getControlledCrossingForEdit(id: number | undefined): Observable<GetControlledCrossingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetControlledCrossingForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlledCrossingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlledCrossingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetControlledCrossingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetControlledCrossingForEditOutput>;
        }));
    }

    protected processGetControlledCrossingForEdit(response: HttpResponseBase): Observable<GetControlledCrossingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetControlledCrossingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditControlledCrossingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBagNumberFilter (optional) 
     * @param minBagNumberFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param standNameFilter (optional) 
     * @param siteFilter (optional) 
     * @param maxCrossingYearFilter (optional) 
     * @param minCrossingYearFilter (optional) 
     * @param bBTMotherFilter (optional) 
     * @param specieMotherFilter (optional) 
     * @param idTreeMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idTreeFatherFilter (optional) 
     * @param bBTFatherFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param specieFilter (optional) 
     * @param maxEmasculationDateFilter (optional) 
     * @param minEmasculationDateFilter (optional) 
     * @param maxNumberOfMaskedBudsFilter (optional) 
     * @param minNumberOfMaskedBudsFilter (optional) 
     * @param maxPollinationDateFilter (optional) 
     * @param minPollinationDateFilter (optional) 
     * @param maxNumberPollinationBudsFilter (optional) 
     * @param minNumberPollinationBudsFilter (optional) 
     * @param maxBagWithdrawalDateFilter (optional) 
     * @param minBagWithdrawalDateFilter (optional) 
     * @param maxNumberCapsulesFilter (optional) 
     * @param minNumberCapsulesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxNumberHarvestedFilter (optional) 
     * @param minNumberHarvestedFilter (optional) 
     * @param maxPercentageHarvestRetentionFilter (optional) 
     * @param minPercentageHarvestRetentionFilter (optional) 
     * @param maxNumberOfSeedsFilter (optional) 
     * @param minNumberOfSeedsFilter (optional) 
     * @param operatorFilter (optional) 
     * @param bBCIdsFilter (optional) 
     * @param observationsFilter (optional) 
     * @param maxPercentageRetentionBagWithdrawalFilter (optional) 
     * @param minPercentageRetentionBagWithdrawalFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param polenBBPFilter (optional) 
     * @param seedBBS2Filter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param seedBBS3Filter (optional) 
     * @return OK
     */
    deleteMassiveControlledCrossings(filter: string | undefined, maxBagNumberFilter: number | undefined, minBagNumberFilter: number | undefined, farmNameFilter: string | undefined, standNameFilter: string | undefined, siteFilter: string | undefined, maxCrossingYearFilter: number | undefined, minCrossingYearFilter: number | undefined, bBTMotherFilter: string | undefined, specieMotherFilter: string | undefined, idTreeMotherFilter: string | undefined, bBPFatherFilter: string | undefined, idTreeFatherFilter: string | undefined, bBTFatherFilter: string | undefined, specieFatherFilter: string | undefined, specieFilter: string | undefined, maxEmasculationDateFilter: DateTime | undefined, minEmasculationDateFilter: DateTime | undefined, maxNumberOfMaskedBudsFilter: number | undefined, minNumberOfMaskedBudsFilter: number | undefined, maxPollinationDateFilter: DateTime | undefined, minPollinationDateFilter: DateTime | undefined, maxNumberPollinationBudsFilter: number | undefined, minNumberPollinationBudsFilter: number | undefined, maxBagWithdrawalDateFilter: DateTime | undefined, minBagWithdrawalDateFilter: DateTime | undefined, maxNumberCapsulesFilter: number | undefined, minNumberCapsulesFilter: number | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxNumberHarvestedFilter: number | undefined, minNumberHarvestedFilter: number | undefined, maxPercentageHarvestRetentionFilter: number | undefined, minPercentageHarvestRetentionFilter: number | undefined, maxNumberOfSeedsFilter: number | undefined, minNumberOfSeedsFilter: number | undefined, operatorFilter: string | undefined, bBCIdsFilter: (number | undefined)[] | undefined, observationsFilter: string | undefined, maxPercentageRetentionBagWithdrawalFilter: number | undefined, minPercentageRetentionBagWithdrawalFilter: number | undefined, trialStandNameFilter: string | undefined, seedBBSFilter: string | undefined, polenBBPFilter: string | undefined, seedBBS2Filter: string | undefined, typeSpecieNameFilter: string | undefined, crossingTechniqueNameFilter: string | undefined, seedBBS3Filter: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/DeleteMassiveControlledCrossings?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxBagNumberFilter' cannot be null.");
        else if (maxBagNumberFilter !== undefined)
            url_ += "MaxBagNumberFilter=" + encodeURIComponent("" + maxBagNumberFilter) + "&";
        if (minBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'minBagNumberFilter' cannot be null.");
        else if (minBagNumberFilter !== undefined)
            url_ += "MinBagNumberFilter=" + encodeURIComponent("" + minBagNumberFilter) + "&";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        if (siteFilter === null)
            throw new globalThis.Error("The parameter 'siteFilter' cannot be null.");
        else if (siteFilter !== undefined)
            url_ += "SiteFilter=" + encodeURIComponent("" + siteFilter) + "&";
        if (maxCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'maxCrossingYearFilter' cannot be null.");
        else if (maxCrossingYearFilter !== undefined)
            url_ += "MaxCrossingYearFilter=" + encodeURIComponent("" + maxCrossingYearFilter) + "&";
        if (minCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'minCrossingYearFilter' cannot be null.");
        else if (minCrossingYearFilter !== undefined)
            url_ += "MinCrossingYearFilter=" + encodeURIComponent("" + minCrossingYearFilter) + "&";
        if (bBTMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBTMotherFilter' cannot be null.");
        else if (bBTMotherFilter !== undefined)
            url_ += "BBTMotherFilter=" + encodeURIComponent("" + bBTMotherFilter) + "&";
        if (specieMotherFilter === null)
            throw new globalThis.Error("The parameter 'specieMotherFilter' cannot be null.");
        else if (specieMotherFilter !== undefined)
            url_ += "SpecieMotherFilter=" + encodeURIComponent("" + specieMotherFilter) + "&";
        if (idTreeMotherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeMotherFilter' cannot be null.");
        else if (idTreeMotherFilter !== undefined)
            url_ += "IdTreeMotherFilter=" + encodeURIComponent("" + idTreeMotherFilter) + "&";
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            url_ += "BBPFatherFilter=" + encodeURIComponent("" + bBPFatherFilter) + "&";
        if (idTreeFatherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeFatherFilter' cannot be null.");
        else if (idTreeFatherFilter !== undefined)
            url_ += "IdTreeFatherFilter=" + encodeURIComponent("" + idTreeFatherFilter) + "&";
        if (bBTFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBTFatherFilter' cannot be null.");
        else if (bBTFatherFilter !== undefined)
            url_ += "BBTFatherFilter=" + encodeURIComponent("" + bBTFatherFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            url_ += "SpecieFatherFilter=" + encodeURIComponent("" + specieFatherFilter) + "&";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "SpecieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        if (maxEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxEmasculationDateFilter' cannot be null.");
        else if (maxEmasculationDateFilter !== undefined)
            url_ += "MaxEmasculationDateFilter=" + encodeURIComponent(maxEmasculationDateFilter ? "" + maxEmasculationDateFilter.toString() : "") + "&";
        if (minEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'minEmasculationDateFilter' cannot be null.");
        else if (minEmasculationDateFilter !== undefined)
            url_ += "MinEmasculationDateFilter=" + encodeURIComponent(minEmasculationDateFilter ? "" + minEmasculationDateFilter.toString() : "") + "&";
        if (maxNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfMaskedBudsFilter' cannot be null.");
        else if (maxNumberOfMaskedBudsFilter !== undefined)
            url_ += "MaxNumberOfMaskedBudsFilter=" + encodeURIComponent("" + maxNumberOfMaskedBudsFilter) + "&";
        if (minNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfMaskedBudsFilter' cannot be null.");
        else if (minNumberOfMaskedBudsFilter !== undefined)
            url_ += "MinNumberOfMaskedBudsFilter=" + encodeURIComponent("" + minNumberOfMaskedBudsFilter) + "&";
        if (maxPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPollinationDateFilter' cannot be null.");
        else if (maxPollinationDateFilter !== undefined)
            url_ += "MaxPollinationDateFilter=" + encodeURIComponent(maxPollinationDateFilter ? "" + maxPollinationDateFilter.toString() : "") + "&";
        if (minPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPollinationDateFilter' cannot be null.");
        else if (minPollinationDateFilter !== undefined)
            url_ += "MinPollinationDateFilter=" + encodeURIComponent(minPollinationDateFilter ? "" + minPollinationDateFilter.toString() : "") + "&";
        if (maxNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberPollinationBudsFilter' cannot be null.");
        else if (maxNumberPollinationBudsFilter !== undefined)
            url_ += "MaxNumberPollinationBudsFilter=" + encodeURIComponent("" + maxNumberPollinationBudsFilter) + "&";
        if (minNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberPollinationBudsFilter' cannot be null.");
        else if (minNumberPollinationBudsFilter !== undefined)
            url_ += "MinNumberPollinationBudsFilter=" + encodeURIComponent("" + minNumberPollinationBudsFilter) + "&";
        if (maxBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'maxBagWithdrawalDateFilter' cannot be null.");
        else if (maxBagWithdrawalDateFilter !== undefined)
            url_ += "MaxBagWithdrawalDateFilter=" + encodeURIComponent(maxBagWithdrawalDateFilter ? "" + maxBagWithdrawalDateFilter.toString() : "") + "&";
        if (minBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'minBagWithdrawalDateFilter' cannot be null.");
        else if (minBagWithdrawalDateFilter !== undefined)
            url_ += "MinBagWithdrawalDateFilter=" + encodeURIComponent(minBagWithdrawalDateFilter ? "" + minBagWithdrawalDateFilter.toString() : "") + "&";
        if (maxNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberCapsulesFilter' cannot be null.");
        else if (maxNumberCapsulesFilter !== undefined)
            url_ += "MaxNumberCapsulesFilter=" + encodeURIComponent("" + maxNumberCapsulesFilter) + "&";
        if (minNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'minNumberCapsulesFilter' cannot be null.");
        else if (minNumberCapsulesFilter !== undefined)
            url_ += "MinNumberCapsulesFilter=" + encodeURIComponent("" + minNumberCapsulesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberHarvestedFilter' cannot be null.");
        else if (maxNumberHarvestedFilter !== undefined)
            url_ += "MaxNumberHarvestedFilter=" + encodeURIComponent("" + maxNumberHarvestedFilter) + "&";
        if (minNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'minNumberHarvestedFilter' cannot be null.");
        else if (minNumberHarvestedFilter !== undefined)
            url_ += "MinNumberHarvestedFilter=" + encodeURIComponent("" + minNumberHarvestedFilter) + "&";
        if (maxPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageHarvestRetentionFilter' cannot be null.");
        else if (maxPercentageHarvestRetentionFilter !== undefined)
            url_ += "MaxPercentageHarvestRetentionFilter=" + encodeURIComponent("" + maxPercentageHarvestRetentionFilter) + "&";
        if (minPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageHarvestRetentionFilter' cannot be null.");
        else if (minPercentageHarvestRetentionFilter !== undefined)
            url_ += "MinPercentageHarvestRetentionFilter=" + encodeURIComponent("" + minPercentageHarvestRetentionFilter) + "&";
        if (maxNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfSeedsFilter' cannot be null.");
        else if (maxNumberOfSeedsFilter !== undefined)
            url_ += "MaxNumberOfSeedsFilter=" + encodeURIComponent("" + maxNumberOfSeedsFilter) + "&";
        if (minNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfSeedsFilter' cannot be null.");
        else if (minNumberOfSeedsFilter !== undefined)
            url_ += "MinNumberOfSeedsFilter=" + encodeURIComponent("" + minNumberOfSeedsFilter) + "&";
        if (operatorFilter === null)
            throw new globalThis.Error("The parameter 'operatorFilter' cannot be null.");
        else if (operatorFilter !== undefined)
            url_ += "OperatorFilter=" + encodeURIComponent("" + operatorFilter) + "&";
        if (bBCIdsFilter === null)
            throw new globalThis.Error("The parameter 'bBCIdsFilter' cannot be null.");
        else if (bBCIdsFilter !== undefined)
            bBCIdsFilter && bBCIdsFilter.forEach(item => { url_ += "BBCIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (maxPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (maxPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MaxPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + maxPercentageRetentionBagWithdrawalFilter) + "&";
        if (minPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (minPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MinPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + minPercentageRetentionBagWithdrawalFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (polenBBPFilter === null)
            throw new globalThis.Error("The parameter 'polenBBPFilter' cannot be null.");
        else if (polenBBPFilter !== undefined)
            url_ += "PolenBBPFilter=" + encodeURIComponent("" + polenBBPFilter) + "&";
        if (seedBBS2Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS2Filter' cannot be null.");
        else if (seedBBS2Filter !== undefined)
            url_ += "SeedBBS2Filter=" + encodeURIComponent("" + seedBBS2Filter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + typeSpecieNameFilter) + "&";
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + crossingTechniqueNameFilter) + "&";
        if (seedBBS3Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS3Filter' cannot be null.");
        else if (seedBBS3Filter !== undefined)
            url_ += "SeedBBS3Filter=" + encodeURIComponent("" + seedBBS3Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveControlledCrossings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveControlledCrossings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveControlledCrossings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBagNumberFilter (optional) 
     * @param minBagNumberFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param standNameFilter (optional) 
     * @param siteFilter (optional) 
     * @param maxCrossingYearFilter (optional) 
     * @param minCrossingYearFilter (optional) 
     * @param bBTMotherFilter (optional) 
     * @param specieMotherFilter (optional) 
     * @param idTreeMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idTreeFatherFilter (optional) 
     * @param bBTFatherFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param specieFilter (optional) 
     * @param maxEmasculationDateFilter (optional) 
     * @param minEmasculationDateFilter (optional) 
     * @param maxNumberOfMaskedBudsFilter (optional) 
     * @param minNumberOfMaskedBudsFilter (optional) 
     * @param maxPollinationDateFilter (optional) 
     * @param minPollinationDateFilter (optional) 
     * @param maxNumberPollinationBudsFilter (optional) 
     * @param minNumberPollinationBudsFilter (optional) 
     * @param maxBagWithdrawalDateFilter (optional) 
     * @param minBagWithdrawalDateFilter (optional) 
     * @param maxNumberCapsulesFilter (optional) 
     * @param minNumberCapsulesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxNumberHarvestedFilter (optional) 
     * @param minNumberHarvestedFilter (optional) 
     * @param maxPercentageHarvestRetentionFilter (optional) 
     * @param minPercentageHarvestRetentionFilter (optional) 
     * @param maxNumberOfSeedsFilter (optional) 
     * @param minNumberOfSeedsFilter (optional) 
     * @param operatorFilter (optional) 
     * @param bBCIdsFilter (optional) 
     * @param observationsFilter (optional) 
     * @param maxPercentageRetentionBagWithdrawalFilter (optional) 
     * @param minPercentageRetentionBagWithdrawalFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param polenBBPFilter (optional) 
     * @param seedBBS2Filter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param seedBBS3Filter (optional) 
     * @return OK
     */
    getControlledCrossingsToExcel(filter: string | undefined, maxBagNumberFilter: number | undefined, minBagNumberFilter: number | undefined, farmNameFilter: string | undefined, standNameFilter: string | undefined, siteFilter: string | undefined, maxCrossingYearFilter: number | undefined, minCrossingYearFilter: number | undefined, bBTMotherFilter: string | undefined, specieMotherFilter: string | undefined, idTreeMotherFilter: string | undefined, bBPFatherFilter: string | undefined, idTreeFatherFilter: string | undefined, bBTFatherFilter: string | undefined, specieFatherFilter: string | undefined, specieFilter: string | undefined, maxEmasculationDateFilter: DateTime | undefined, minEmasculationDateFilter: DateTime | undefined, maxNumberOfMaskedBudsFilter: number | undefined, minNumberOfMaskedBudsFilter: number | undefined, maxPollinationDateFilter: DateTime | undefined, minPollinationDateFilter: DateTime | undefined, maxNumberPollinationBudsFilter: number | undefined, minNumberPollinationBudsFilter: number | undefined, maxBagWithdrawalDateFilter: DateTime | undefined, minBagWithdrawalDateFilter: DateTime | undefined, maxNumberCapsulesFilter: number | undefined, minNumberCapsulesFilter: number | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxNumberHarvestedFilter: number | undefined, minNumberHarvestedFilter: number | undefined, maxPercentageHarvestRetentionFilter: number | undefined, minPercentageHarvestRetentionFilter: number | undefined, maxNumberOfSeedsFilter: number | undefined, minNumberOfSeedsFilter: number | undefined, operatorFilter: string | undefined, bBCIdsFilter: (number | undefined)[] | undefined, observationsFilter: string | undefined, maxPercentageRetentionBagWithdrawalFilter: number | undefined, minPercentageRetentionBagWithdrawalFilter: number | undefined, trialStandNameFilter: string | undefined, seedBBSFilter: string | undefined, polenBBPFilter: string | undefined, seedBBS2Filter: string | undefined, typeSpecieNameFilter: string | undefined, crossingTechniqueNameFilter: string | undefined, seedBBS3Filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetControlledCrossingsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxBagNumberFilter' cannot be null.");
        else if (maxBagNumberFilter !== undefined)
            url_ += "MaxBagNumberFilter=" + encodeURIComponent("" + maxBagNumberFilter) + "&";
        if (minBagNumberFilter === null)
            throw new globalThis.Error("The parameter 'minBagNumberFilter' cannot be null.");
        else if (minBagNumberFilter !== undefined)
            url_ += "MinBagNumberFilter=" + encodeURIComponent("" + minBagNumberFilter) + "&";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        if (siteFilter === null)
            throw new globalThis.Error("The parameter 'siteFilter' cannot be null.");
        else if (siteFilter !== undefined)
            url_ += "SiteFilter=" + encodeURIComponent("" + siteFilter) + "&";
        if (maxCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'maxCrossingYearFilter' cannot be null.");
        else if (maxCrossingYearFilter !== undefined)
            url_ += "MaxCrossingYearFilter=" + encodeURIComponent("" + maxCrossingYearFilter) + "&";
        if (minCrossingYearFilter === null)
            throw new globalThis.Error("The parameter 'minCrossingYearFilter' cannot be null.");
        else if (minCrossingYearFilter !== undefined)
            url_ += "MinCrossingYearFilter=" + encodeURIComponent("" + minCrossingYearFilter) + "&";
        if (bBTMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBTMotherFilter' cannot be null.");
        else if (bBTMotherFilter !== undefined)
            url_ += "BBTMotherFilter=" + encodeURIComponent("" + bBTMotherFilter) + "&";
        if (specieMotherFilter === null)
            throw new globalThis.Error("The parameter 'specieMotherFilter' cannot be null.");
        else if (specieMotherFilter !== undefined)
            url_ += "SpecieMotherFilter=" + encodeURIComponent("" + specieMotherFilter) + "&";
        if (idTreeMotherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeMotherFilter' cannot be null.");
        else if (idTreeMotherFilter !== undefined)
            url_ += "IdTreeMotherFilter=" + encodeURIComponent("" + idTreeMotherFilter) + "&";
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            url_ += "BBPFatherFilter=" + encodeURIComponent("" + bBPFatherFilter) + "&";
        if (idTreeFatherFilter === null)
            throw new globalThis.Error("The parameter 'idTreeFatherFilter' cannot be null.");
        else if (idTreeFatherFilter !== undefined)
            url_ += "IdTreeFatherFilter=" + encodeURIComponent("" + idTreeFatherFilter) + "&";
        if (bBTFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBTFatherFilter' cannot be null.");
        else if (bBTFatherFilter !== undefined)
            url_ += "BBTFatherFilter=" + encodeURIComponent("" + bBTFatherFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            url_ += "SpecieFatherFilter=" + encodeURIComponent("" + specieFatherFilter) + "&";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "SpecieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        if (maxEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxEmasculationDateFilter' cannot be null.");
        else if (maxEmasculationDateFilter !== undefined)
            url_ += "MaxEmasculationDateFilter=" + encodeURIComponent(maxEmasculationDateFilter ? "" + maxEmasculationDateFilter.toString() : "") + "&";
        if (minEmasculationDateFilter === null)
            throw new globalThis.Error("The parameter 'minEmasculationDateFilter' cannot be null.");
        else if (minEmasculationDateFilter !== undefined)
            url_ += "MinEmasculationDateFilter=" + encodeURIComponent(minEmasculationDateFilter ? "" + minEmasculationDateFilter.toString() : "") + "&";
        if (maxNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfMaskedBudsFilter' cannot be null.");
        else if (maxNumberOfMaskedBudsFilter !== undefined)
            url_ += "MaxNumberOfMaskedBudsFilter=" + encodeURIComponent("" + maxNumberOfMaskedBudsFilter) + "&";
        if (minNumberOfMaskedBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfMaskedBudsFilter' cannot be null.");
        else if (minNumberOfMaskedBudsFilter !== undefined)
            url_ += "MinNumberOfMaskedBudsFilter=" + encodeURIComponent("" + minNumberOfMaskedBudsFilter) + "&";
        if (maxPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPollinationDateFilter' cannot be null.");
        else if (maxPollinationDateFilter !== undefined)
            url_ += "MaxPollinationDateFilter=" + encodeURIComponent(maxPollinationDateFilter ? "" + maxPollinationDateFilter.toString() : "") + "&";
        if (minPollinationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPollinationDateFilter' cannot be null.");
        else if (minPollinationDateFilter !== undefined)
            url_ += "MinPollinationDateFilter=" + encodeURIComponent(minPollinationDateFilter ? "" + minPollinationDateFilter.toString() : "") + "&";
        if (maxNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberPollinationBudsFilter' cannot be null.");
        else if (maxNumberPollinationBudsFilter !== undefined)
            url_ += "MaxNumberPollinationBudsFilter=" + encodeURIComponent("" + maxNumberPollinationBudsFilter) + "&";
        if (minNumberPollinationBudsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberPollinationBudsFilter' cannot be null.");
        else if (minNumberPollinationBudsFilter !== undefined)
            url_ += "MinNumberPollinationBudsFilter=" + encodeURIComponent("" + minNumberPollinationBudsFilter) + "&";
        if (maxBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'maxBagWithdrawalDateFilter' cannot be null.");
        else if (maxBagWithdrawalDateFilter !== undefined)
            url_ += "MaxBagWithdrawalDateFilter=" + encodeURIComponent(maxBagWithdrawalDateFilter ? "" + maxBagWithdrawalDateFilter.toString() : "") + "&";
        if (minBagWithdrawalDateFilter === null)
            throw new globalThis.Error("The parameter 'minBagWithdrawalDateFilter' cannot be null.");
        else if (minBagWithdrawalDateFilter !== undefined)
            url_ += "MinBagWithdrawalDateFilter=" + encodeURIComponent(minBagWithdrawalDateFilter ? "" + minBagWithdrawalDateFilter.toString() : "") + "&";
        if (maxNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberCapsulesFilter' cannot be null.");
        else if (maxNumberCapsulesFilter !== undefined)
            url_ += "MaxNumberCapsulesFilter=" + encodeURIComponent("" + maxNumberCapsulesFilter) + "&";
        if (minNumberCapsulesFilter === null)
            throw new globalThis.Error("The parameter 'minNumberCapsulesFilter' cannot be null.");
        else if (minNumberCapsulesFilter !== undefined)
            url_ += "MinNumberCapsulesFilter=" + encodeURIComponent("" + minNumberCapsulesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberHarvestedFilter' cannot be null.");
        else if (maxNumberHarvestedFilter !== undefined)
            url_ += "MaxNumberHarvestedFilter=" + encodeURIComponent("" + maxNumberHarvestedFilter) + "&";
        if (minNumberHarvestedFilter === null)
            throw new globalThis.Error("The parameter 'minNumberHarvestedFilter' cannot be null.");
        else if (minNumberHarvestedFilter !== undefined)
            url_ += "MinNumberHarvestedFilter=" + encodeURIComponent("" + minNumberHarvestedFilter) + "&";
        if (maxPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageHarvestRetentionFilter' cannot be null.");
        else if (maxPercentageHarvestRetentionFilter !== undefined)
            url_ += "MaxPercentageHarvestRetentionFilter=" + encodeURIComponent("" + maxPercentageHarvestRetentionFilter) + "&";
        if (minPercentageHarvestRetentionFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageHarvestRetentionFilter' cannot be null.");
        else if (minPercentageHarvestRetentionFilter !== undefined)
            url_ += "MinPercentageHarvestRetentionFilter=" + encodeURIComponent("" + minPercentageHarvestRetentionFilter) + "&";
        if (maxNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'maxNumberOfSeedsFilter' cannot be null.");
        else if (maxNumberOfSeedsFilter !== undefined)
            url_ += "MaxNumberOfSeedsFilter=" + encodeURIComponent("" + maxNumberOfSeedsFilter) + "&";
        if (minNumberOfSeedsFilter === null)
            throw new globalThis.Error("The parameter 'minNumberOfSeedsFilter' cannot be null.");
        else if (minNumberOfSeedsFilter !== undefined)
            url_ += "MinNumberOfSeedsFilter=" + encodeURIComponent("" + minNumberOfSeedsFilter) + "&";
        if (operatorFilter === null)
            throw new globalThis.Error("The parameter 'operatorFilter' cannot be null.");
        else if (operatorFilter !== undefined)
            url_ += "OperatorFilter=" + encodeURIComponent("" + operatorFilter) + "&";
        if (bBCIdsFilter === null)
            throw new globalThis.Error("The parameter 'bBCIdsFilter' cannot be null.");
        else if (bBCIdsFilter !== undefined)
            bBCIdsFilter && bBCIdsFilter.forEach(item => { url_ += "BBCIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (maxPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'maxPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (maxPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MaxPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + maxPercentageRetentionBagWithdrawalFilter) + "&";
        if (minPercentageRetentionBagWithdrawalFilter === null)
            throw new globalThis.Error("The parameter 'minPercentageRetentionBagWithdrawalFilter' cannot be null.");
        else if (minPercentageRetentionBagWithdrawalFilter !== undefined)
            url_ += "MinPercentageRetentionBagWithdrawalFilter=" + encodeURIComponent("" + minPercentageRetentionBagWithdrawalFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (polenBBPFilter === null)
            throw new globalThis.Error("The parameter 'polenBBPFilter' cannot be null.");
        else if (polenBBPFilter !== undefined)
            url_ += "PolenBBPFilter=" + encodeURIComponent("" + polenBBPFilter) + "&";
        if (seedBBS2Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS2Filter' cannot be null.");
        else if (seedBBS2Filter !== undefined)
            url_ += "SeedBBS2Filter=" + encodeURIComponent("" + seedBBS2Filter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + typeSpecieNameFilter) + "&";
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + crossingTechniqueNameFilter) + "&";
        if (seedBBS3Filter === null)
            throw new globalThis.Error("The parameter 'seedBBS3Filter' cannot be null.");
        else if (seedBBS3Filter !== undefined)
            url_ += "SeedBBS3Filter=" + encodeURIComponent("" + seedBBS3Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlledCrossingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlledCrossingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetControlledCrossingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCCSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllCCSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCCSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCCSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto>;
        }));
    }

    protected processGetAllCCSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPolenForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllPolenForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolenForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolenForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto>;
        }));
    }

    protected processGetAllPolenForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingPolenLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTypeSpecieForTableDropdown(): Observable<ControlledCrossingTypeSpecieLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllTypeSpecieForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeSpecieForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeSpecieForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlledCrossingTypeSpecieLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlledCrossingTypeSpecieLookupTableDto[]>;
        }));
    }

    protected processGetAllTypeSpecieForTableDropdown(response: HttpResponseBase): Observable<ControlledCrossingTypeSpecieLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlledCrossingTypeSpecieLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCrossingTechniqueForTableDropdown(): Observable<ControlledCrossingCrossingTechniqueLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllCrossingTechniqueForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCrossingTechniqueForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCrossingTechniqueForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlledCrossingCrossingTechniqueLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlledCrossingCrossingTechniqueLookupTableDto[]>;
        }));
    }

    protected processGetAllCrossingTechniqueForTableDropdown(response: HttpResponseBase): Observable<ControlledCrossingCrossingTechniqueLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlledCrossingCrossingTechniqueLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreesForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/GetAllTreesForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreesForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreesForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreesForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createControlledCrossingsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/CreateControlledCrossingsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateControlledCrossingsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateControlledCrossingsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateControlledCrossingsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditControlledCrossingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ControlledCrossings/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditControlledCrossingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditControlledCrossingDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditControlledCrossingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditControlledCrossingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CrossingTechniquesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCrossingTechniqueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCrossingTechniqueForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCrossingTechniqueForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCrossingTechniqueForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCrossingTechniqueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCrossingTechniqueForView(id: number | undefined): Observable<GetCrossingTechniqueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/GetCrossingTechniqueForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrossingTechniqueForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrossingTechniqueForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCrossingTechniqueForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCrossingTechniqueForViewDto>;
        }));
    }

    protected processGetCrossingTechniqueForView(response: HttpResponseBase): Observable<GetCrossingTechniqueForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCrossingTechniqueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCrossingTechniqueForEdit(id: number | undefined): Observable<GetCrossingTechniqueForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/GetCrossingTechniqueForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrossingTechniqueForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrossingTechniqueForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCrossingTechniqueForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCrossingTechniqueForEditOutput>;
        }));
    }

    protected processGetCrossingTechniqueForEdit(response: HttpResponseBase): Observable<GetCrossingTechniqueForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCrossingTechniqueForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditCrossingTechniqueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getCrossingTechniquesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CrossingTechniques/GetCrossingTechniquesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrossingTechniquesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrossingTechniquesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCrossingTechniquesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDate(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDateTime(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    sendAndGetDateRange(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return OK
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DestinoBBXsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param plantMotherFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFechaFilter (optional) 
     * @param minFechaFilter (optional) 
     * @param destineFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, plantMotherFilter: string | undefined, statusFilter: string | undefined, maxFechaFilter: DateTime | undefined, minFechaFilter: DateTime | undefined, destineFilter: string | undefined, cloneBBXFilter: string | undefined, projectNameFilter: string | undefined, measurementSelectionNumberTFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDestinoBBXForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (plantMotherFilter === null)
            throw new globalThis.Error("The parameter 'plantMotherFilter' cannot be null.");
        else if (plantMotherFilter !== undefined)
            url_ += "PlantMotherFilter=" + encodeURIComponent("" + plantMotherFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFechaFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaFilter' cannot be null.");
        else if (maxFechaFilter !== undefined)
            url_ += "MaxFechaFilter=" + encodeURIComponent(maxFechaFilter ? "" + maxFechaFilter.toString() : "") + "&";
        if (minFechaFilter === null)
            throw new globalThis.Error("The parameter 'minFechaFilter' cannot be null.");
        else if (minFechaFilter !== undefined)
            url_ += "MinFechaFilter=" + encodeURIComponent(minFechaFilter ? "" + minFechaFilter.toString() : "") + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDestinoBBXForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDestinoBBXForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDestinoBBXForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDestinoBBXForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDestinoBBXForView(id: number | undefined): Observable<GetDestinoBBXForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetDestinoBBXForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinoBBXForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinoBBXForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDestinoBBXForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDestinoBBXForViewDto>;
        }));
    }

    protected processGetDestinoBBXForView(response: HttpResponseBase): Observable<GetDestinoBBXForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDestinoBBXForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDestinoBBXForEdit(id: number | undefined): Observable<GetDestinoBBXForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetDestinoBBXForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinoBBXForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinoBBXForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDestinoBBXForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDestinoBBXForEditOutput>;
        }));
    }

    protected processGetDestinoBBXForEdit(response: HttpResponseBase): Observable<GetDestinoBBXForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDestinoBBXForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditDestinoBBXDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param plantMotherFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFechaFilter (optional) 
     * @param minFechaFilter (optional) 
     * @param destineFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @return OK
     */
    getDestinoBBXsToExcel(filter: string | undefined, plantMotherFilter: string | undefined, statusFilter: string | undefined, maxFechaFilter: DateTime | undefined, minFechaFilter: DateTime | undefined, destineFilter: string | undefined, cloneBBXFilter: string | undefined, projectNameFilter: string | undefined, measurementSelectionNumberTFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetDestinoBBXsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (plantMotherFilter === null)
            throw new globalThis.Error("The parameter 'plantMotherFilter' cannot be null.");
        else if (plantMotherFilter !== undefined)
            url_ += "PlantMotherFilter=" + encodeURIComponent("" + plantMotherFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFechaFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaFilter' cannot be null.");
        else if (maxFechaFilter !== undefined)
            url_ += "MaxFechaFilter=" + encodeURIComponent(maxFechaFilter ? "" + maxFechaFilter.toString() : "") + "&";
        if (minFechaFilter === null)
            throw new globalThis.Error("The parameter 'minFechaFilter' cannot be null.");
        else if (minFechaFilter !== undefined)
            url_ += "MinFechaFilter=" + encodeURIComponent(minFechaFilter ? "" + minFechaFilter.toString() : "") + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinoBBXsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinoBBXsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetDestinoBBXsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getCloneMeasurementSelectionsForKPI(fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<PagedResultDtoOfCloneMeasurementSelectionKPIDto> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetCloneMeasurementSelectionsForKPI?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneMeasurementSelectionsForKPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneMeasurementSelectionsForKPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCloneMeasurementSelectionKPIDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCloneMeasurementSelectionKPIDto>;
        }));
    }

    protected processGetCloneMeasurementSelectionsForKPI(response: HttpResponseBase): Observable<PagedResultDtoOfCloneMeasurementSelectionKPIDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCloneMeasurementSelectionKPIDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getCloneMeasurementSelectionsForKPIToExcel(fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DestinoBBXs/GetCloneMeasurementSelectionsForKPIToExcel?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneMeasurementSelectionsForKPIToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneMeasurementSelectionsForKPIToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCloneMeasurementSelectionsForKPIToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityFullName (optional) 
     * @return OK
     */
    getAllPropertiesOfAnEntity(entityFullName: string | undefined): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllPropertiesOfAnEntity?";
        if (entityFullName === null)
            throw new globalThis.Error("The parameter 'entityFullName' cannot be null.");
        else if (entityFullName !== undefined)
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPropertiesOfAnEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPropertiesOfAnEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAllPropertiesOfAnEntity(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntitiesHasDynamicProperty(): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllEntitiesHasDynamicProperty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntitiesHasDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntitiesHasDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
        }));
    }

    protected processGetAllEntitiesHasDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyDefinitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllAllowedInputTypeNames(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllAllowedInputTypeNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAllowedInputTypeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAllowedInputTypeNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAllowedInputTypeNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntities(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllEntities(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param propertyId (optional) 
     * @return OK
     */
    getAll(entityId: string | undefined, propertyId: number | undefined): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAll?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDynamicEntityPropertyValues(entityFullName: string, entityId: string): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAllDynamicEntityPropertyValues?";
        if (entityFullName === undefined || entityFullName === null)
            throw new globalThis.Error("The parameter 'entityFullName' must be defined and cannot be null.");
        else
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDynamicEntityPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDynamicEntityPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
        }));
    }

    protected processGetAllDynamicEntityPropertyValues(response: HttpResponseBase): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllDynamicEntityPropertyValuesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertOrUpdateAllValues(body: InsertOrUpdateAllValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/InsertOrUpdateAllValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdateAllValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdateAllValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertOrUpdateAllValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cleanValues(body: CleanValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/CleanValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCleanValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    findAllowedInputType(name: string | undefined): Observable<IInputType> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/FindAllowedInputType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAllowedInputType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAllowedInputType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IInputType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IInputType>;
        }));
    }

    protected processFindAllowedInputType(response: HttpResponseBase): Observable<IInputType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IInputType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllValuesOfDynamicProperty(id: number | undefined): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/GetAllValuesOfDynamicProperty?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValuesOfDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValuesOfDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
        }));
    }

    protected processGetAllValuesOfDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new globalThis.Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new globalThis.Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new globalThis.Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentCategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentCategoryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentCategoryForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentCategoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentCategoryForView(id: number | undefined): Observable<GetExperimentCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/GetExperimentCategoryForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentCategoryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentCategoryForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentCategoryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentCategoryForViewDto>;
        }));
    }

    protected processGetExperimentCategoryForView(response: HttpResponseBase): Observable<GetExperimentCategoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentCategoryForEdit(id: number | undefined): Observable<GetExperimentCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/GetExperimentCategoryForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentCategoryForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentCategoryForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentCategoryForEditOutput>;
        }));
    }

    protected processGetExperimentCategoryForEdit(response: HttpResponseBase): Observable<GetExperimentCategoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentCategoryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentCategoriesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentCategories/GetExperimentCategoriesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentCategoriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentCategoriesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentCategoriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentClasificationstwoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentClasificationtwoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentClasificationtwoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentClasificationtwoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentClasificationtwoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentClasificationtwoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentClasificationtwoForView(id: number | undefined): Observable<GetExperimentClasificationtwoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/GetExperimentClasificationtwoForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClasificationtwoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClasificationtwoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentClasificationtwoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentClasificationtwoForViewDto>;
        }));
    }

    protected processGetExperimentClasificationtwoForView(response: HttpResponseBase): Observable<GetExperimentClasificationtwoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentClasificationtwoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentClasificationtwoForEdit(id: number | undefined): Observable<GetExperimentClasificationtwoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/GetExperimentClasificationtwoForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClasificationtwoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClasificationtwoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentClasificationtwoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentClasificationtwoForEditOutput>;
        }));
    }

    protected processGetExperimentClasificationtwoForEdit(response: HttpResponseBase): Observable<GetExperimentClasificationtwoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentClasificationtwoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentClasificationtwoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentClasificationstwoToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClasificationstwo/GetExperimentClasificationstwoToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClasificationstwoToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClasificationstwoToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentClasificationstwoToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentClassificationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param experimentCategoryNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, experimentCategoryNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentClassificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (experimentCategoryNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentCategoryNameFilter' cannot be null.");
        else if (experimentCategoryNameFilter !== undefined)
            url_ += "ExperimentCategoryNameFilter=" + encodeURIComponent("" + experimentCategoryNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentClassificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentClassificationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentClassificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentClassificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentClassificationForView(id: number | undefined): Observable<GetExperimentClassificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/GetExperimentClassificationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClassificationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClassificationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentClassificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentClassificationForViewDto>;
        }));
    }

    protected processGetExperimentClassificationForView(response: HttpResponseBase): Observable<GetExperimentClassificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentClassificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentClassificationForEdit(id: number | undefined): Observable<GetExperimentClassificationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/GetExperimentClassificationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClassificationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClassificationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentClassificationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentClassificationForEditOutput>;
        }));
    }

    protected processGetExperimentClassificationForEdit(response: HttpResponseBase): Observable<GetExperimentClassificationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentClassificationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentClassificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param experimentCategoryNameFilter (optional) 
     * @return OK
     */
    getExperimentClassificationsToExcel(filter: string | undefined, experimentCategoryNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/GetExperimentClassificationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (experimentCategoryNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentCategoryNameFilter' cannot be null.");
        else if (experimentCategoryNameFilter !== undefined)
            url_ += "ExperimentCategoryNameFilter=" + encodeURIComponent("" + experimentCategoryNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentClassificationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentClassificationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentClassificationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllExperimentCategoryForTableDropdown(): Observable<ExperimentClassificationExperimentCategoryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentClassifications/GetAllExperimentCategoryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentCategoryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentCategoryForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExperimentClassificationExperimentCategoryLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExperimentClassificationExperimentCategoryLookupTableDto[]>;
        }));
    }

    protected processGetAllExperimentCategoryForTableDropdown(response: HttpResponseBase): Observable<ExperimentClassificationExperimentCategoryLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExperimentClassificationExperimentCategoryLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentLocationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentLocationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentLocationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentLocationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentLocationForView(id: number | undefined): Observable<GetExperimentLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/GetExperimentLocationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentLocationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentLocationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentLocationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentLocationForViewDto>;
        }));
    }

    protected processGetExperimentLocationForView(response: HttpResponseBase): Observable<GetExperimentLocationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentLocationForEdit(id: number | undefined): Observable<GetExperimentLocationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/GetExperimentLocationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentLocationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentLocationForEditOutput>;
        }));
    }

    protected processGetExperimentLocationForEdit(response: HttpResponseBase): Observable<GetExperimentLocationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentLocationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentLocationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentLocationsToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentLocations/GetExperimentLocationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentLocationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentLocationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentLocationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentSpecieQuantitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentSpecieQuantityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentSpecieQuantityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentSpecieQuantityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentSpecieQuantityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentSpecieQuantityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentSpecieQuantityForView(id: number | undefined): Observable<GetExperimentSpecieQuantityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/GetExperimentSpecieQuantityForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpecieQuantityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpecieQuantityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentSpecieQuantityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentSpecieQuantityForViewDto>;
        }));
    }

    protected processGetExperimentSpecieQuantityForView(response: HttpResponseBase): Observable<GetExperimentSpecieQuantityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentSpecieQuantityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentSpecieQuantityForEdit(id: number | undefined): Observable<GetExperimentSpecieQuantityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/GetExperimentSpecieQuantityForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpecieQuantityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpecieQuantityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentSpecieQuantityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentSpecieQuantityForEditOutput>;
        }));
    }

    protected processGetExperimentSpecieQuantityForEdit(response: HttpResponseBase): Observable<GetExperimentSpecieQuantityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentSpecieQuantityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentSpecieQuantityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentSpecieQuantitiesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecieQuantities/GetExperimentSpecieQuantitiesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpecieQuantitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpecieQuantitiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentSpecieQuantitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentSpeciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentSpecieForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentSpecieForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentSpecieForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentSpecieForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentSpecieForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentSpecieForView(id: number | undefined): Observable<GetExperimentSpecieForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/GetExperimentSpecieForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpecieForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpecieForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentSpecieForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentSpecieForViewDto>;
        }));
    }

    protected processGetExperimentSpecieForView(response: HttpResponseBase): Observable<GetExperimentSpecieForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentSpecieForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentSpecieForEdit(id: number | undefined): Observable<GetExperimentSpecieForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/GetExperimentSpecieForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpecieForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpecieForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentSpecieForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentSpecieForEditOutput>;
        }));
    }

    protected processGetExperimentSpecieForEdit(response: HttpResponseBase): Observable<GetExperimentSpecieForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentSpecieForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentSpecieDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentSpeciesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentSpecies/GetExperimentSpeciesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentSpeciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentSpeciesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentSpeciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentStigmaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentStigmaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentStigma/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentStigmaForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentStigmaForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentStigmaForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentStigmaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExperimentTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExperimentTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExperimentTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExperimentTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExperimentTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExperimentTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentTypeForView(id: number | undefined): Observable<GetExperimentTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/GetExperimentTypeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentTypeForViewDto>;
        }));
    }

    protected processGetExperimentTypeForView(response: HttpResponseBase): Observable<GetExperimentTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getExperimentTypeForEdit(id: number | undefined): Observable<GetExperimentTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/GetExperimentTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExperimentTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExperimentTypeForEditOutput>;
        }));
    }

    protected processGetExperimentTypeForEdit(response: HttpResponseBase): Observable<GetExperimentTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExperimentTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditExperimentTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getExperimentTypesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ExperimentTypes/GetExperimentTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExperimentTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExperimentTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetExperimentTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileBlobStorageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAndSaveBlobFile(body: RequestFileBlobStorageDto | undefined): Observable<FileBlobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileBlobStorage/CreateAndSaveBlobFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndSaveBlobFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndSaveBlobFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileBlobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileBlobDto[]>;
        }));
    }

    protected processCreateAndSaveBlobFile(response: HttpResponseBase): Observable<FileBlobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileBlobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param isMassive (optional) 
     * @param id (optional) 
     * @return OK
     */
    deleteBlobFile(fileName: string | undefined, isMassive: boolean | undefined, id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FileBlobStorage/DeleteBlobFile?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isMassive === null)
            throw new globalThis.Error("The parameter 'isMassive' cannot be null.");
        else if (isMassive !== undefined)
            url_ += "IsMassive=" + encodeURIComponent("" + isMassive) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlobFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlobFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBlobFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadBlobFile(body: DownloadDeleteFilesBlobStorageDto | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/FileBlobStorage/DownloadBlobFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBlobFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBlobFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBlobFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Files/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFileForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFileForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFileForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFileForView(id: number | undefined): Observable<GetFileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Files/GetFileForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileForViewDto>;
        }));
    }

    protected processGetFileForView(response: HttpResponseBase): Observable<GetFileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFileForEdit(id: number | undefined): Observable<GetFileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Files/GetFileForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileForEditOutput>;
        }));
    }

    protected processGetFileForEdit(response: HttpResponseBase): Observable<GetFileForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: FileBlobDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Files/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Files/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FrostTolerancesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param minCodeFilter (optional) 
     * @param maxCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, minCodeFilter: number | undefined, maxCodeFilter: number | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFrostToleranceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFrostToleranceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFrostToleranceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFrostToleranceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFrostToleranceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param minCodeFilter (optional) 
     * @param maxCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, minCodeFilter: number | undefined, maxCodeFilter: number | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFrostToleranceForView(id: number | undefined): Observable<GetFrostToleranceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/GetFrostToleranceForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrostToleranceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrostToleranceForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFrostToleranceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFrostToleranceForViewDto>;
        }));
    }

    protected processGetFrostToleranceForView(response: HttpResponseBase): Observable<GetFrostToleranceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFrostToleranceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFrostToleranceForEdit(id: number | undefined): Observable<GetFrostToleranceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/GetFrostToleranceForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrostToleranceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrostToleranceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFrostToleranceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFrostToleranceForEditOutput>;
        }));
    }

    protected processGetFrostToleranceForEdit(response: HttpResponseBase): Observable<GetFrostToleranceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFrostToleranceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditFrostToleranceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param minCodeFilter (optional) 
     * @param maxCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getFrostTolerancesToExcel(filter: string | undefined, minCodeFilter: number | undefined, maxCodeFilter: number | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/GetFrostTolerancesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrostTolerancesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrostTolerancesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFrostTolerancesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFrostToleranceFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/CreateFrostToleranceFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFrostToleranceFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFrostToleranceFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateFrostToleranceFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditFrostToleranceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FrostTolerances/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditFrostToleranceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditFrostToleranceDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditFrostToleranceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditFrostToleranceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GenomicSeleccionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @param genomicSelectionMaterialsNameFilter (optional) 
     * @param yearFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, projectNameFilter: string | undefined, seedlingSubProjectFilter: string | undefined, genomicSelectionMaterialsNameFilter: number | undefined, yearFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGenomicSeleccionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        if (genomicSelectionMaterialsNameFilter === null)
            throw new globalThis.Error("The parameter 'genomicSelectionMaterialsNameFilter' cannot be null.");
        else if (genomicSelectionMaterialsNameFilter !== undefined)
            url_ += "GenomicSelectionMaterialsNameFilter=" + encodeURIComponent("" + genomicSelectionMaterialsNameFilter) + "&";
        if (yearFilter === null)
            throw new globalThis.Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGenomicSeleccionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGenomicSeleccionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGenomicSeleccionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGenomicSeleccionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getGenomicSeleccionForView(id: number | undefined): Observable<GetGenomicSeleccionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetGenomicSeleccionForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenomicSeleccionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenomicSeleccionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenomicSeleccionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenomicSeleccionForViewDto>;
        }));
    }

    protected processGetGenomicSeleccionForView(response: HttpResponseBase): Observable<GetGenomicSeleccionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGenomicSeleccionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getGenomicSeleccionForEdit(id: number | undefined): Observable<GetGenomicSeleccionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetGenomicSeleccionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenomicSeleccionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenomicSeleccionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenomicSeleccionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenomicSeleccionForEditOutput>;
        }));
    }

    protected processGetGenomicSeleccionForEdit(response: HttpResponseBase): Observable<GetGenomicSeleccionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGenomicSeleccionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditGenomicSeleccionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @return OK
     */
    getGenomicSeleccionsToExcel(filter: string | undefined, projectNameFilter: string | undefined, seedlingSubProjectFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetGenomicSeleccionsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenomicSeleccionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenomicSeleccionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetGenomicSeleccionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGenomicSeleccionProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGenomicSeleccionProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGenomicSeleccionProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGenomicSeleccionProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGenomicSeleccionProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedlingForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetAllSeedlingForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedlingForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedlingForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto>;
        }));
    }

    protected processGetAllSeedlingForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllYearsForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetAllYearsForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYearsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYearsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto>;
        }));
    }

    protected processGetAllYearsForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param genomicSeleccionGeneticMaterialFilter (optional) 
     * @return OK
     */
    getAllGneticMaterialForLookupTable(genomicSeleccionGeneticMaterialFilter: string | undefined): Observable<GenomicSeleccionSeedlingLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GenomicSeleccions/GetAllGneticMaterialForLookupTable?";
        if (genomicSeleccionGeneticMaterialFilter === null)
            throw new globalThis.Error("The parameter 'genomicSeleccionGeneticMaterialFilter' cannot be null.");
        else if (genomicSeleccionGeneticMaterialFilter !== undefined)
            url_ += "GenomicSeleccionGeneticMaterialFilter=" + encodeURIComponent("" + genomicSeleccionGeneticMaterialFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGneticMaterialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGneticMaterialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenomicSeleccionSeedlingLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenomicSeleccionSeedlingLookupTableDto[]>;
        }));
    }

    protected processGetAllGneticMaterialForLookupTable(response: HttpResponseBase): Observable<GenomicSeleccionSeedlingLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenomicSeleccionSeedlingLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GroupTrialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGroupTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGroupTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGroupTrialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGroupTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGroupTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getGroupTrialForView(id: number | undefined): Observable<GetGroupTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/GetGroupTrialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupTrialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupTrialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupTrialForViewDto>;
        }));
    }

    protected processGetGroupTrialForView(response: HttpResponseBase): Observable<GetGroupTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getGroupTrialForEdit(id: number | undefined): Observable<GetGroupTrialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/GetGroupTrialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupTrialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupTrialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupTrialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupTrialForEditOutput>;
        }));
    }

    protected processGetGroupTrialForEdit(response: HttpResponseBase): Observable<GetGroupTrialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupTrialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditGroupTrialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getGroupTrialsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/GetGroupTrialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupTrialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupTrialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetGroupTrialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGroupTrialFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/CreateGroupTrialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGroupTrialFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGroupTrialFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateGroupTrialFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditGroupTrialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GroupTrials/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditGroupTrialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditGroupTrialDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditGroupTrialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditGroupTrialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthcareFormulaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareFormulaDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareFormula/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareFormulaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareFormulaDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareFormulaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareFormulaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getForEdit(id: number | undefined): Observable<CreateOrEditHealthcareFormulaDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareFormula/GetForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditHealthcareFormulaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditHealthcareFormulaDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<CreateOrEditHealthcareFormulaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditHealthcareFormulaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditHealthcareFormulaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareFormula/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareFormula/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    desactivate(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareFormula/Desactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthcareMastersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationNewField(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationNewField?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationNewField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationNewField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationNewField(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationForestation(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationForestation?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationForestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationForestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationForestation(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationReforestation(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationReforestation?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationReforestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationReforestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationReforestation(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationTypeStubble(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTypeStubble?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTypeStubble(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTypeStubble(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationTypeStubble(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationPreviousForestDensity(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationPreviousForestDensity?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationPreviousForestDensity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationPreviousForestDensity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationPreviousForestDensity(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationTupDuration(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTupDuration?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTupDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTupDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationTupDuration(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationVegetationUnder(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationVegetationUnder?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationVegetationUnder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationVegetationUnder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationVegetationUnder(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestationTypeSoil(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTypeSoil?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTypeSoil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTypeSoil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllLevelInfestationTypeSoil(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllHealthcareProduct(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareProductDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllHealthcareProduct?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareProductDto>;
        }));
    }

    protected processGetAllHealthcareProduct(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllHealthcareTechnology(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllHealthcareTechnology?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareTechnology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareTechnology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllHealthcareTechnology(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllHealthcareMoment(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllHealthcareMoment?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareMoment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareMoment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllHealthcareMoment(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllEnviromentCondition(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllEnviromentCondition?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEnviromentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEnviromentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllEnviromentCondition(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllAnthill(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllAnthill?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAnthill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAnthill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllAnthill(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllNeighbor(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllNeighbor?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNeighbor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNeighbor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthcareMastersDto>;
        }));
    }

    protected processGetAllNeighbor(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthcareMastersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthcareMastersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationNewFieldForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationNewFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationNewFieldForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationNewFieldForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationNewFieldForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationNewFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationNewFieldDto>;
        }));
    }

    protected processGetLevelInfestationNewFieldForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationNewFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationNewFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationForestationForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationForestationDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationForestationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationForestationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationForestationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationForestationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationForestationDto>;
        }));
    }

    protected processGetLevelInfestationForestationForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationForestationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationForestationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationReforestationForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationReforestationDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationReforestationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationReforestationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationReforestationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationReforestationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationReforestationDto>;
        }));
    }

    protected processGetLevelInfestationReforestationForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationReforestationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationReforestationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationTypeStubbleForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationTypeStubbleDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationTypeStubbleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationTypeStubbleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationTypeStubbleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationTypeStubbleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationTypeStubbleDto>;
        }));
    }

    protected processGetLevelInfestationTypeStubbleForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationTypeStubbleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationTypeStubbleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationPreviousForestDensityForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationPreviousForestDensityDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationPreviousForestDensityForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationPreviousForestDensityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationPreviousForestDensityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationPreviousForestDensityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationPreviousForestDensityDto>;
        }));
    }

    protected processGetLevelInfestationPreviousForestDensityForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationPreviousForestDensityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationPreviousForestDensityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationTupDurationForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationTupDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationTupDurationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationTupDurationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationTupDurationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationTupDurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationTupDurationDto>;
        }));
    }

    protected processGetLevelInfestationTupDurationForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationTupDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationTupDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationVegetationUnderForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationVegetationUnderDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationVegetationUnderForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationVegetationUnderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationVegetationUnderForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationVegetationUnderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationVegetationUnderDto>;
        }));
    }

    protected processGetLevelInfestationVegetationUnderForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationVegetationUnderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationVegetationUnderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationTypeSoilForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationTypeSoilDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetLevelInfestationTypeSoilForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationTypeSoilForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationTypeSoilForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationTypeSoilDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationTypeSoilDto>;
        }));
    }

    protected processGetLevelInfestationTypeSoilForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationTypeSoilDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationTypeSoilDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHealthcareProductForEdit(id: number | undefined): Observable<CreateOrEditHealthcareProductDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetHealthcareProductForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthcareProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthcareProductForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditHealthcareProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditHealthcareProductDto>;
        }));
    }

    protected processGetHealthcareProductForEdit(response: HttpResponseBase): Observable<CreateOrEditHealthcareProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditHealthcareProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHealthcareTechnologyForEdit(id: number | undefined): Observable<CreateOrEditHealthcareTechnologyDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetHealthcareTechnologyForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthcareTechnologyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthcareTechnologyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditHealthcareTechnologyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditHealthcareTechnologyDto>;
        }));
    }

    protected processGetHealthcareTechnologyForEdit(response: HttpResponseBase): Observable<CreateOrEditHealthcareTechnologyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditHealthcareTechnologyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHealthcareMomentForEdit(id: number | undefined): Observable<CreateOrEditHealthcareMomentDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetHealthcareMomentForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthcareMomentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthcareMomentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditHealthcareMomentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditHealthcareMomentDto>;
        }));
    }

    protected processGetHealthcareMomentForEdit(response: HttpResponseBase): Observable<CreateOrEditHealthcareMomentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditHealthcareMomentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEnviromentConditionForEdit(id: number | undefined): Observable<CreateOrEditEnviromentConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetEnviromentConditionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnviromentConditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnviromentConditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditEnviromentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditEnviromentConditionDto>;
        }));
    }

    protected processGetEnviromentConditionForEdit(response: HttpResponseBase): Observable<CreateOrEditEnviromentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditEnviromentConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAnthillForEdit(id: number | undefined): Observable<CreateOrEditAnthillDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAnthillForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnthillForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnthillForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAnthillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAnthillDto>;
        }));
    }

    protected processGetAnthillForEdit(response: HttpResponseBase): Observable<CreateOrEditAnthillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAnthillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getNeighborForEdit(id: number | undefined): Observable<CreateOrEditNeighborDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetNeighborForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeighborForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeighborForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditNeighborDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditNeighborDto>;
        }));
    }

    protected processGetNeighborForEdit(response: HttpResponseBase): Observable<CreateOrEditNeighborDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditNeighborDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationNewField(body: CreateOrEditLevelInfestationNewFieldDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationNewField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationNewField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationNewField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationNewField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationForestation(body: CreateOrEditLevelInfestationForestationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationForestation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationForestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationForestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationForestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationReforestation(body: CreateOrEditLevelInfestationReforestationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationReforestation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationReforestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationReforestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationReforestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationTypeStubble(body: CreateOrEditLevelInfestationTypeStubbleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationTypeStubble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationTypeStubble(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationTypeStubble(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationTypeStubble(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationPreviousForestDensity(body: CreateOrEditLevelInfestationPreviousForestDensityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationPreviousForestDensity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationPreviousForestDensity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationPreviousForestDensity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationPreviousForestDensity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationTupDuration(body: CreateOrEditLevelInfestationTupDurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationTupDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationTupDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationTupDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationTupDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationVegetationUnder(body: CreateOrEditLevelInfestationVegetationUnderDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationVegetationUnder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationVegetationUnder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationVegetationUnder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationVegetationUnder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestationTypeSoil(body: CreateOrEditLevelInfestationTypeSoilDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditLevelInfestationTypeSoil";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestationTypeSoil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestationTypeSoil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestationTypeSoil(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditHealthcareProduct(body: CreateOrEditHealthcareProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditHealthcareProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditHealthcareProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditHealthcareProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditHealthcareProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditHealthcareTechnology(body: CreateOrEditHealthcareTechnologyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditHealthcareTechnology";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditHealthcareTechnology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditHealthcareTechnology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditHealthcareTechnology(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditHealthcareMoment(body: CreateOrEditHealthcareMomentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditHealthcareMoment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditHealthcareMoment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditHealthcareMoment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditHealthcareMoment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditEnviromentCondition(body: CreateOrEditEnviromentConditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditEnviromentCondition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditEnviromentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditEnviromentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditEnviromentCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditAnthill(body: CreateOrEditAnthillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditAnthill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAnthill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAnthill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditAnthill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditNeighbor(body: CreateOrEditNeighborDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/CreateOrEditNeighbor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditNeighbor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditNeighbor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditNeighbor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationNewField(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationNewField?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationNewField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationNewField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationNewField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationForestation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationForestation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationForestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationForestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationForestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationReforestation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationReforestation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationReforestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationReforestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationReforestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationTypeStubble(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationTypeStubble?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationTypeStubble(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationTypeStubble(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationTypeStubble(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationPreviousForestDensity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationPreviousForestDensity?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationPreviousForestDensity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationPreviousForestDensity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationPreviousForestDensity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationTupDuration(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationTupDuration?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationTupDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationTupDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationTupDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationVegetationUnder(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationVegetationUnder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationVegetationUnder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationVegetationUnder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationVegetationUnder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestationTypeSoil(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteLevelInfestationTypeSoil?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestationTypeSoil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestationTypeSoil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestationTypeSoil(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteHealthcareProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteHealthcareProduct?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHealthcareProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHealthcareProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHealthcareProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteHealthcareTechnology(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteHealthcareTechnology?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHealthcareTechnology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHealthcareTechnology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHealthcareTechnology(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteHealthcareMoment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteHealthcareMoment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHealthcareMoment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHealthcareMoment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHealthcareMoment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEnviromentCondition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteEnviromentCondition?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEnviromentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEnviromentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEnviromentCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteAnthill(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteAnthill?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAnthill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAnthill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAnthill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteNeighbor(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/DeleteNeighbor?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNeighbor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNeighbor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNeighbor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationNewFieldByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationNewFieldByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationNewFieldByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationNewFieldByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationNewFieldByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationForestationByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationForestationByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationForestationByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationForestationByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationForestationByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationReforestationByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationReforestationByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationReforestationByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationReforestationByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationReforestationByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationTypeStubbleByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTypeStubbleByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTypeStubbleByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTypeStubbleByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationTypeStubbleByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationPreviousForestDensityByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationPreviousForestDensityByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationPreviousForestDensityByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationPreviousForestDensityByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationPreviousForestDensityByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationTupDurationByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTupDurationByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTupDurationByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTupDurationByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationTupDurationByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationVegetationUnderByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationVegetationUnderByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationVegetationUnderByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationVegetationUnderByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationVegetationUnderByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllLevelInfestationTypeSoilByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllLevelInfestationTypeSoilByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestationTypeSoilByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestationTypeSoilByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllLevelInfestationTypeSoilByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllEnviromentConditionByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllEnviromentConditionByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEnviromentConditionByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEnviromentConditionByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllEnviromentConditionByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllAnthillByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllAnthillByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAnthillByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAnthillByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllAnthillByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllNeighborByFilter(filter: string | undefined): Observable<GetHealthcareMastersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthcareMasters/GetAllNeighborByFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNeighborByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNeighborByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthcareMastersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthcareMastersDto[]>;
        }));
    }

    protected processGetAllNeighborByFilter(response: HttpResponseBase): Observable<GetHealthcareMastersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHealthcareMastersDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthCheckServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getHealthChecks(): Observable<ListResultDtoOfHealthCheckItemDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCheck/GetHealthChecks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfHealthCheckItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfHealthCheckItemDto>;
        }));
    }

    protected processGetHealthChecks(response: HttpResponseBase): Observable<ListResultDtoOfHealthCheckItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfHealthCheckItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkHealth(body: HealthCheckContext | undefined): Observable<HealthCheckResult> {
        let url_ = this.baseUrl + "/api/services/app/HealthCheck/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCheckResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCheckResult>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<HealthCheckResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthDosesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param year (optional) 
     * @param regionId (optional) 
     * @param propertyId (optional) 
     * @param standStatusId (optional) 
     * @param healthcareProductNameFilter (optional) 
     * @param healthcareTechnologyNameFilter (optional) 
     * @param healthcareMomentMomentFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, year: number | undefined, regionId: number | undefined, propertyId: number | undefined, standStatusId: number | undefined, healthcareProductNameFilter: string | undefined, healthcareTechnologyNameFilter: string | undefined, healthcareMomentMomentFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthDoseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (standStatusId === null)
            throw new globalThis.Error("The parameter 'standStatusId' cannot be null.");
        else if (standStatusId !== undefined)
            url_ += "StandStatusId=" + encodeURIComponent("" + standStatusId) + "&";
        if (healthcareProductNameFilter === null)
            throw new globalThis.Error("The parameter 'healthcareProductNameFilter' cannot be null.");
        else if (healthcareProductNameFilter !== undefined)
            url_ += "HealthcareProductNameFilter=" + encodeURIComponent("" + healthcareProductNameFilter) + "&";
        if (healthcareTechnologyNameFilter === null)
            throw new globalThis.Error("The parameter 'healthcareTechnologyNameFilter' cannot be null.");
        else if (healthcareTechnologyNameFilter !== undefined)
            url_ += "HealthcareTechnologyNameFilter=" + encodeURIComponent("" + healthcareTechnologyNameFilter) + "&";
        if (healthcareMomentMomentFilter === null)
            throw new globalThis.Error("The parameter 'healthcareMomentMomentFilter' cannot be null.");
        else if (healthcareMomentMomentFilter !== undefined)
            url_ += "HealthcareMomentMomentFilter=" + encodeURIComponent("" + healthcareMomentMomentFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHealthDoseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHealthDoseForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthDoseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthDoseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHealthDoseForEdit(id: number | undefined): Observable<GetHealthDoseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetHealthDoseForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthDoseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthDoseForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHealthDoseForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHealthDoseForEditOutput>;
        }));
    }

    protected processGetHealthDoseForEdit(response: HttpResponseBase): Observable<GetHealthDoseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHealthDoseForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditHealthDoseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param year (optional) 
     * @param regionId (optional) 
     * @param propertyId (optional) 
     * @param standStatusId (optional) 
     * @param healthcareProductNameFilter (optional) 
     * @param healthcareProductIdFilter (optional) 
     * @param healthcareTechnologyNameFilter (optional) 
     * @param healthcareTechnologyIdFilter (optional) 
     * @param healthcareMomentMomentFilter (optional) 
     * @param healthcareMomentIdFilter (optional) 
     * @return OK
     */
    getHealthDosesToExcel(filter: string | undefined, year: number | undefined, regionId: number | undefined, propertyId: number | undefined, standStatusId: number | undefined, healthcareProductNameFilter: string | undefined, healthcareProductIdFilter: number | undefined, healthcareTechnologyNameFilter: string | undefined, healthcareTechnologyIdFilter: number | undefined, healthcareMomentMomentFilter: string | undefined, healthcareMomentIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetHealthDosesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (standStatusId === null)
            throw new globalThis.Error("The parameter 'standStatusId' cannot be null.");
        else if (standStatusId !== undefined)
            url_ += "StandStatusId=" + encodeURIComponent("" + standStatusId) + "&";
        if (healthcareProductNameFilter === null)
            throw new globalThis.Error("The parameter 'healthcareProductNameFilter' cannot be null.");
        else if (healthcareProductNameFilter !== undefined)
            url_ += "HealthcareProductNameFilter=" + encodeURIComponent("" + healthcareProductNameFilter) + "&";
        if (healthcareProductIdFilter === null)
            throw new globalThis.Error("The parameter 'healthcareProductIdFilter' cannot be null.");
        else if (healthcareProductIdFilter !== undefined)
            url_ += "HealthcareProductIdFilter=" + encodeURIComponent("" + healthcareProductIdFilter) + "&";
        if (healthcareTechnologyNameFilter === null)
            throw new globalThis.Error("The parameter 'healthcareTechnologyNameFilter' cannot be null.");
        else if (healthcareTechnologyNameFilter !== undefined)
            url_ += "HealthcareTechnologyNameFilter=" + encodeURIComponent("" + healthcareTechnologyNameFilter) + "&";
        if (healthcareTechnologyIdFilter === null)
            throw new globalThis.Error("The parameter 'healthcareTechnologyIdFilter' cannot be null.");
        else if (healthcareTechnologyIdFilter !== undefined)
            url_ += "HealthcareTechnologyIdFilter=" + encodeURIComponent("" + healthcareTechnologyIdFilter) + "&";
        if (healthcareMomentMomentFilter === null)
            throw new globalThis.Error("The parameter 'healthcareMomentMomentFilter' cannot be null.");
        else if (healthcareMomentMomentFilter !== undefined)
            url_ += "HealthcareMomentMomentFilter=" + encodeURIComponent("" + healthcareMomentMomentFilter) + "&";
        if (healthcareMomentIdFilter === null)
            throw new globalThis.Error("The parameter 'healthcareMomentIdFilter' cannot be null.");
        else if (healthcareMomentIdFilter !== undefined)
            url_ += "HealthcareMomentIdFilter=" + encodeURIComponent("" + healthcareMomentIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthDosesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthDosesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetHealthDosesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return OK
     */
    getAllYear(year: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllYear(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param region (optional) 
     * @return OK
     */
    getAllRegion(region: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllRegion?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param property (optional) 
     * @return OK
     */
    getAllProperty(property: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllProperty?";
        if (property === null)
            throw new globalThis.Error("The parameter 'property' cannot be null.");
        else if (property !== undefined)
            url_ += "property=" + encodeURIComponent("" + property) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllProperty(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param standStatus (optional) 
     * @return OK
     */
    getAllStandStatus(standStatus: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllStandStatus?";
        if (standStatus === null)
            throw new globalThis.Error("The parameter 'standStatus' cannot be null.");
        else if (standStatus !== undefined)
            url_ += "standStatus=" + encodeURIComponent("" + standStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStandStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStandStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllStandStatus(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllHealthcareProductForTableDropdown(): Observable<HealthDoseHealthcareProductLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllHealthcareProductForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareProductForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareProductForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthDoseHealthcareProductLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthDoseHealthcareProductLookupTableDto[]>;
        }));
    }

    protected processGetAllHealthcareProductForTableDropdown(response: HttpResponseBase): Observable<HealthDoseHealthcareProductLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthDoseHealthcareProductLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param healthcareProductId (optional) 
     * @return OK
     */
    getAllHealthcareProductDoseForTableDropdown(healthcareProductId: number | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllHealthcareProductDoseForTableDropdown?";
        if (healthcareProductId === null)
            throw new globalThis.Error("The parameter 'healthcareProductId' cannot be null.");
        else if (healthcareProductId !== undefined)
            url_ += "healthcareProductId=" + encodeURIComponent("" + healthcareProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareProductDoseForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareProductDoseForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllHealthcareProductDoseForTableDropdown(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllHealthcareTechnologyForTableDropdown(): Observable<HealthDoseHealthcareTechnologyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllHealthcareTechnologyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareTechnologyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareTechnologyForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthDoseHealthcareTechnologyLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthDoseHealthcareTechnologyLookupTableDto[]>;
        }));
    }

    protected processGetAllHealthcareTechnologyForTableDropdown(response: HttpResponseBase): Observable<HealthDoseHealthcareTechnologyLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthDoseHealthcareTechnologyLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllHealthcareMomentForTableDropdown(): Observable<HealthDoseHealthcareMomentLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/GetAllHealthcareMomentForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthcareMomentForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthcareMomentForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthDoseHealthcareMomentLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthDoseHealthcareMomentLookupTableDto[]>;
        }));
    }

    protected processGetAllHealthcareMomentForTableDropdown(response: HttpResponseBase): Observable<HealthDoseHealthcareMomentLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthDoseHealthcareMomentLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createHealthDosesFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/HealthDoses/CreateHealthDosesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHealthDosesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHealthDosesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateHealthDosesFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelperAnalizerSpecieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dap (optional) 
     * @param hT (optional) 
     * @return OK
     */
    formula1(dap: number | undefined, hT: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HelperAnalizerSpecie/Formula1?";
        if (dap === null)
            throw new globalThis.Error("The parameter 'dap' cannot be null.");
        else if (dap !== undefined)
            url_ += "dap=" + encodeURIComponent("" + dap) + "&";
        if (hT === null)
            throw new globalThis.Error("The parameter 'hT' cannot be null.");
        else if (hT !== undefined)
            url_ += "HT=" + encodeURIComponent("" + hT) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormula1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormula1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFormula1(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dap (optional) 
     * @param hT (optional) 
     * @return OK
     */
    formula2(dap: number | undefined, hT: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HelperAnalizerSpecie/Formula2?";
        if (dap === null)
            throw new globalThis.Error("The parameter 'dap' cannot be null.");
        else if (dap !== undefined)
            url_ += "dap=" + encodeURIComponent("" + dap) + "&";
        if (hT === null)
            throw new globalThis.Error("The parameter 'hT' cannot be null.");
        else if (hT !== undefined)
            url_ += "HT=" + encodeURIComponent("" + hT) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormula2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormula2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFormula2(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dap (optional) 
     * @param hT (optional) 
     * @return OK
     */
    formula3(dap: number | undefined, hT: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HelperAnalizerSpecie/Formula3?";
        if (dap === null)
            throw new globalThis.Error("The parameter 'dap' cannot be null.");
        else if (dap !== undefined)
            url_ += "dap=" + encodeURIComponent("" + dap) + "&";
        if (hT === null)
            throw new globalThis.Error("The parameter 'hT' cannot be null.");
        else if (hT !== undefined)
            url_ += "HT=" + encodeURIComponent("" + hT) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormula3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormula3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFormula3(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hT (optional) 
     * @param dap (optional) 
     * @param specie (optional) 
     * @return OK
     */
    calculoVolumen(hT: number | undefined, dap: number | undefined, specie: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HelperAnalizerSpecie/CalculoVolumen?";
        if (hT === null)
            throw new globalThis.Error("The parameter 'hT' cannot be null.");
        else if (hT !== undefined)
            url_ += "HT=" + encodeURIComponent("" + hT) + "&";
        if (dap === null)
            throw new globalThis.Error("The parameter 'dap' cannot be null.");
        else if (dap !== undefined)
            url_ += "dap=" + encodeURIComponent("" + dap) + "&";
        if (specie === null)
            throw new globalThis.Error("The parameter 'specie' cannot be null.");
        else if (specie !== undefined)
            url_ += "specie=" + encodeURIComponent("" + specie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculoVolumen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculoVolumen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculoVolumen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelperPolensServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPolenForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfHelperPolenPolenLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/HelperPolens/GetAllPolenForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolenForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolenForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelperPolenPolenLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelperPolenPolenLookupTableDto>;
        }));
    }

    protected processGetAllPolenForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfHelperPolenPolenLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelperPolenPolenLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelperSeedsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/HelperSeeds/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelperSeedSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelperTreeNameAnalizerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    getTreeDataFromName(input: string | undefined): Observable<HelperTreeNameAnalizerDto> {
        let url_ = this.baseUrl + "/api/services/app/HelperTreeNameAnalizer/GetTreeDataFromName?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeDataFromName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeDataFromName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelperTreeNameAnalizerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelperTreeNameAnalizerDto>;
        }));
    }

    protected processGetTreeDataFromName(response: HttpResponseBase): Observable<HelperTreeNameAnalizerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelperTreeNameAnalizerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new globalThis.Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InterventionFoundationsOnesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInterventionFoundationsOneForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsOnes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetInterventionFoundationsOneForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetInterventionFoundationsOneForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetInterventionFoundationsOneForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInterventionFoundationsOneForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInterventionFoundationsOneForEdit(id: number | undefined): Observable<GetInterventionFoundationsOneForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsOnes/GetInterventionFoundationsOneForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsOneForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsOneForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterventionFoundationsOneForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterventionFoundationsOneForEditOutput>;
        }));
    }

    protected processGetInterventionFoundationsOneForEdit(response: HttpResponseBase): Observable<GetInterventionFoundationsOneForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInterventionFoundationsOneForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditInterventionFoundationsOneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsOnes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsOnes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getInterventionFoundationsOnesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsOnes/GetInterventionFoundationsOnesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsOnesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsOnesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetInterventionFoundationsOnesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InterventionFoundationsThreesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInterventionFoundationsThreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsThrees/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetInterventionFoundationsThreeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetInterventionFoundationsThreeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetInterventionFoundationsThreeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInterventionFoundationsThreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInterventionFoundationsThreeForEdit(id: number | undefined): Observable<GetInterventionFoundationsThreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsThrees/GetInterventionFoundationsThreeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsThreeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsThreeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterventionFoundationsThreeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterventionFoundationsThreeForEditOutput>;
        }));
    }

    protected processGetInterventionFoundationsThreeForEdit(response: HttpResponseBase): Observable<GetInterventionFoundationsThreeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInterventionFoundationsThreeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditInterventionFoundationsThreeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsThrees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsThrees/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getInterventionFoundationsThreesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsThrees/GetInterventionFoundationsThreesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsThreesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsThreesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetInterventionFoundationsThreesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InterventionFoundationsTwosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInterventionFoundationsTwoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsTwos/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetInterventionFoundationsTwoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetInterventionFoundationsTwoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetInterventionFoundationsTwoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInterventionFoundationsTwoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInterventionFoundationsTwoForEdit(id: number | undefined): Observable<GetInterventionFoundationsTwoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsTwos/GetInterventionFoundationsTwoForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsTwoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsTwoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterventionFoundationsTwoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterventionFoundationsTwoForEditOutput>;
        }));
    }

    protected processGetInterventionFoundationsTwoForEdit(response: HttpResponseBase): Observable<GetInterventionFoundationsTwoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInterventionFoundationsTwoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditInterventionFoundationsTwoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsTwos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsTwos/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getInterventionFoundationsTwosToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InterventionFoundationsTwos/GetInterventionFoundationsTwosToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionFoundationsTwosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionFoundationsTwosToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetInterventionFoundationsTwosToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LaboratoryProjectsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLaboratoryProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLaboratoryProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLaboratoryProjectForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLaboratoryProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLaboratoryProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLaboratoryProjectForView(id: number | undefined): Observable<GetLaboratoryProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetLaboratoryProjectForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLaboratoryProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLaboratoryProjectForViewDto>;
        }));
    }

    protected processGetLaboratoryProjectForView(response: HttpResponseBase): Observable<GetLaboratoryProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLaboratoryProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLaboratoryProjectForEdit(id: number | undefined): Observable<GetLaboratoryProjectForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetLaboratoryProjectForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLaboratoryProjectForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLaboratoryProjectForEditOutput>;
        }));
    }

    protected processGetLaboratoryProjectForEdit(response: HttpResponseBase): Observable<GetLaboratoryProjectForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLaboratoryProjectForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditLaboratoryProjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getLaboratoryProjectsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetLaboratoryProjectsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLaboratoryProjectsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLaboratoryProjectTypesForDropdown(): Observable<LaboratoryProjectTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjects/GetAllLaboratoryProjectTypesForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectTypesForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectTypesForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LaboratoryProjectTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LaboratoryProjectTypeDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectTypesForDropdown(response: HttpResponseBase): Observable<LaboratoryProjectTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LaboratoryProjectTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LaboratoryProjectStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLaboratoryProjectStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLaboratoryProjectStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLaboratoryProjectStatusForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLaboratoryProjectStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLaboratoryProjectStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLaboratoryProjectStatusForView(id: number | undefined): Observable<GetLaboratoryProjectStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/GetLaboratoryProjectStatusForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectStatusForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectStatusForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLaboratoryProjectStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLaboratoryProjectStatusForViewDto>;
        }));
    }

    protected processGetLaboratoryProjectStatusForView(response: HttpResponseBase): Observable<GetLaboratoryProjectStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLaboratoryProjectStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLaboratoryProjectStatusForEdit(id: number | undefined): Observable<GetLaboratoryProjectStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/GetLaboratoryProjectStatusForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectStatusForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLaboratoryProjectStatusForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLaboratoryProjectStatusForEditOutput>;
        }));
    }

    protected processGetLaboratoryProjectStatusForEdit(response: HttpResponseBase): Observable<GetLaboratoryProjectStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLaboratoryProjectStatusForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditLaboratoryProjectStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getLaboratoryProjectStatusesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaboratoryProjectStatuses/GetLaboratoryProjectStatusesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryProjectStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryProjectStatusesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLaboratoryProjectStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return OK
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new globalThis.Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new globalThis.Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new globalThis.Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LevelInfestationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param year (optional) 
     * @param regionId (optional) 
     * @param propertyId (optional) 
     * @param standStatusId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLevelInfestations(filter: string | undefined, year: number | undefined, regionId: number | undefined, propertyId: number | undefined, standStatusId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllLevelInfestationResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetAllLevelInfestations?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (standStatusId === null)
            throw new globalThis.Error("The parameter 'standStatusId' cannot be null.");
        else if (standStatusId !== undefined)
            url_ += "StandStatusId=" + encodeURIComponent("" + standStatusId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLevelInfestations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLevelInfestations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllLevelInfestationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllLevelInfestationResponseDto>;
        }));
    }

    protected processGetAllLevelInfestations(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllLevelInfestationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllLevelInfestationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLevelInfestationsForEdit(id: number | undefined): Observable<CreateOrEditLevelInfestationDto> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetLevelInfestationsForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLevelInfestationsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLevelInfestationsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditLevelInfestationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditLevelInfestationDto>;
        }));
    }

    protected processGetLevelInfestationsForEdit(response: HttpResponseBase): Observable<CreateOrEditLevelInfestationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLevelInfestationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLevelInfestation(body: CreateOrEditLevelInfestationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/CreateOrEditLevelInfestation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLevelInfestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLevelInfestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLevelInfestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLevelInfestation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/DeleteLevelInfestation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLevelInfestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLevelInfestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLevelInfestation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return OK
     */
    getAllYear(year: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetAllYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllYear(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param region (optional) 
     * @return OK
     */
    getAllRegion(region: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetAllRegion?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param property (optional) 
     * @return OK
     */
    getAllProperty(property: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetAllProperty?";
        if (property === null)
            throw new globalThis.Error("The parameter 'property' cannot be null.");
        else if (property !== undefined)
            url_ += "property=" + encodeURIComponent("" + property) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllProperty(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param standStatus (optional) 
     * @return OK
     */
    getAllStandStatus(standStatus: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LevelInfestation/GetAllStandStatus?";
        if (standStatus === null)
            throw new globalThis.Error("The parameter 'standStatus' cannot be null.");
        else if (standStatus !== undefined)
            url_ += "standStatus=" + encodeURIComponent("" + standStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStandStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStandStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllStandStatus(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LookUpCloneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/LookUpClone/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/LookUpClone/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementPlaningOptionsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param dAPRequiredFilter (optional) 
     * @param heightRequiredFilter (optional) 
     * @param adultObservationCodeRequiredFilter (optional) 
     * @param adultObservationHeightRequiredFilter (optional) 
     * @param frostToleranceCodeRequiredFilter (optional) 
     * @param pestsAndDiseasesCodeRequiredFilter (optional) 
     * @param partialMeasurementFilter (optional) 
     * @param partialHeightFilter (optional) 
     * @param standNameFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param maxTrialAgeFilter (optional) 
     * @param minTrialAgeFilter (optional) 
     * @param regionFilter (optional) 
     * @param trialTypeFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param assignmentNameFilter (optional) 
     * @param measurementPlaningAssignmentNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, dAPRequiredFilter: number | undefined, heightRequiredFilter: number | undefined, adultObservationCodeRequiredFilter: number | undefined, adultObservationHeightRequiredFilter: number | undefined, frostToleranceCodeRequiredFilter: number | undefined, pestsAndDiseasesCodeRequiredFilter: number | undefined, partialMeasurementFilter: number | undefined, partialHeightFilter: number | undefined, standNameFilter: string | undefined, trialNumberFilter: string | undefined, maxTrialAgeFilter: number | undefined, minTrialAgeFilter: number | undefined, regionFilter: string | undefined, trialTypeFilter: string | undefined, farmNameFilter: string | undefined, statusFilter: number | undefined, assignmentNameFilter: string | undefined, measurementPlaningAssignmentNameFilter: string | undefined, trialStandNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dAPRequiredFilter === null)
            throw new globalThis.Error("The parameter 'dAPRequiredFilter' cannot be null.");
        else if (dAPRequiredFilter !== undefined)
            url_ += "DAPRequiredFilter=" + encodeURIComponent("" + dAPRequiredFilter) + "&";
        if (heightRequiredFilter === null)
            throw new globalThis.Error("The parameter 'heightRequiredFilter' cannot be null.");
        else if (heightRequiredFilter !== undefined)
            url_ += "HeightRequiredFilter=" + encodeURIComponent("" + heightRequiredFilter) + "&";
        if (adultObservationCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationCodeRequiredFilter' cannot be null.");
        else if (adultObservationCodeRequiredFilter !== undefined)
            url_ += "AdultObservationCodeRequiredFilter=" + encodeURIComponent("" + adultObservationCodeRequiredFilter) + "&";
        if (adultObservationHeightRequiredFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationHeightRequiredFilter' cannot be null.");
        else if (adultObservationHeightRequiredFilter !== undefined)
            url_ += "AdultObservationHeightRequiredFilter=" + encodeURIComponent("" + adultObservationHeightRequiredFilter) + "&";
        if (frostToleranceCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'frostToleranceCodeRequiredFilter' cannot be null.");
        else if (frostToleranceCodeRequiredFilter !== undefined)
            url_ += "FrostToleranceCodeRequiredFilter=" + encodeURIComponent("" + frostToleranceCodeRequiredFilter) + "&";
        if (pestsAndDiseasesCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'pestsAndDiseasesCodeRequiredFilter' cannot be null.");
        else if (pestsAndDiseasesCodeRequiredFilter !== undefined)
            url_ += "PestsAndDiseasesCodeRequiredFilter=" + encodeURIComponent("" + pestsAndDiseasesCodeRequiredFilter) + "&";
        if (partialMeasurementFilter === null)
            throw new globalThis.Error("The parameter 'partialMeasurementFilter' cannot be null.");
        else if (partialMeasurementFilter !== undefined)
            url_ += "PartialMeasurementFilter=" + encodeURIComponent("" + partialMeasurementFilter) + "&";
        if (partialHeightFilter === null)
            throw new globalThis.Error("The parameter 'partialHeightFilter' cannot be null.");
        else if (partialHeightFilter !== undefined)
            url_ += "PartialHeightFilter=" + encodeURIComponent("" + partialHeightFilter) + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        if (maxTrialAgeFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAgeFilter' cannot be null.");
        else if (maxTrialAgeFilter !== undefined)
            url_ += "MaxTrialAgeFilter=" + encodeURIComponent("" + maxTrialAgeFilter) + "&";
        if (minTrialAgeFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAgeFilter' cannot be null.");
        else if (minTrialAgeFilter !== undefined)
            url_ += "MinTrialAgeFilter=" + encodeURIComponent("" + minTrialAgeFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (trialTypeFilter === null)
            throw new globalThis.Error("The parameter 'trialTypeFilter' cannot be null.");
        else if (trialTypeFilter !== undefined)
            url_ += "TrialTypeFilter=" + encodeURIComponent("" + trialTypeFilter) + "&";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (assignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'assignmentNameFilter' cannot be null.");
        else if (assignmentNameFilter !== undefined)
            url_ += "AssignmentNameFilter=" + encodeURIComponent("" + assignmentNameFilter) + "&";
        if (measurementPlaningAssignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningAssignmentNameFilter' cannot be null.");
        else if (measurementPlaningAssignmentNameFilter !== undefined)
            url_ += "MeasurementPlaningAssignmentNameFilter=" + encodeURIComponent("" + measurementPlaningAssignmentNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningOptionsForView(id: number | undefined): Observable<GetMeasurementPlaningOptionsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetMeasurementPlaningOptionsForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningOptionsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningOptionsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningOptionsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningOptionsForViewDto>;
        }));
    }

    protected processGetMeasurementPlaningOptionsForView(response: HttpResponseBase): Observable<GetMeasurementPlaningOptionsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningOptionsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningOptionsForEdit(id: number | undefined): Observable<GetMeasurementPlaningOptionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetMeasurementPlaningOptionsForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningOptionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningOptionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningOptionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningOptionsForEditOutput>;
        }));
    }

    protected processGetMeasurementPlaningOptionsForEdit(response: HttpResponseBase): Observable<GetMeasurementPlaningOptionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningOptionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementPlaningOptionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param dAPRequiredFilter (optional) 
     * @param heightRequiredFilter (optional) 
     * @param adultObservationCodeRequiredFilter (optional) 
     * @param adultObservationHeightRequiredFilter (optional) 
     * @param frostToleranceCodeRequiredFilter (optional) 
     * @param pestsAndDiseasesCodeRequiredFilter (optional) 
     * @param partialMeasurementFilter (optional) 
     * @param partialHeightFilter (optional) 
     * @param standNameFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param maxTrialAgeFilter (optional) 
     * @param minTrialAgeFilter (optional) 
     * @param regionFilter (optional) 
     * @param trialTypeFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param assignmentNameFilter (optional) 
     * @param measurementPlaningAssignmentNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @return OK
     */
    getMeasurementPlaningOptionsesToExcel(filter: string | undefined, dAPRequiredFilter: number | undefined, heightRequiredFilter: number | undefined, adultObservationCodeRequiredFilter: number | undefined, adultObservationHeightRequiredFilter: number | undefined, frostToleranceCodeRequiredFilter: number | undefined, pestsAndDiseasesCodeRequiredFilter: number | undefined, partialMeasurementFilter: number | undefined, partialHeightFilter: number | undefined, standNameFilter: string | undefined, trialNumberFilter: string | undefined, maxTrialAgeFilter: number | undefined, minTrialAgeFilter: number | undefined, regionFilter: string | undefined, trialTypeFilter: string | undefined, farmNameFilter: string | undefined, statusFilter: number | undefined, assignmentNameFilter: string | undefined, measurementPlaningAssignmentNameFilter: string | undefined, trialStandNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetMeasurementPlaningOptionsesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dAPRequiredFilter === null)
            throw new globalThis.Error("The parameter 'dAPRequiredFilter' cannot be null.");
        else if (dAPRequiredFilter !== undefined)
            url_ += "DAPRequiredFilter=" + encodeURIComponent("" + dAPRequiredFilter) + "&";
        if (heightRequiredFilter === null)
            throw new globalThis.Error("The parameter 'heightRequiredFilter' cannot be null.");
        else if (heightRequiredFilter !== undefined)
            url_ += "HeightRequiredFilter=" + encodeURIComponent("" + heightRequiredFilter) + "&";
        if (adultObservationCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationCodeRequiredFilter' cannot be null.");
        else if (adultObservationCodeRequiredFilter !== undefined)
            url_ += "AdultObservationCodeRequiredFilter=" + encodeURIComponent("" + adultObservationCodeRequiredFilter) + "&";
        if (adultObservationHeightRequiredFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationHeightRequiredFilter' cannot be null.");
        else if (adultObservationHeightRequiredFilter !== undefined)
            url_ += "AdultObservationHeightRequiredFilter=" + encodeURIComponent("" + adultObservationHeightRequiredFilter) + "&";
        if (frostToleranceCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'frostToleranceCodeRequiredFilter' cannot be null.");
        else if (frostToleranceCodeRequiredFilter !== undefined)
            url_ += "FrostToleranceCodeRequiredFilter=" + encodeURIComponent("" + frostToleranceCodeRequiredFilter) + "&";
        if (pestsAndDiseasesCodeRequiredFilter === null)
            throw new globalThis.Error("The parameter 'pestsAndDiseasesCodeRequiredFilter' cannot be null.");
        else if (pestsAndDiseasesCodeRequiredFilter !== undefined)
            url_ += "PestsAndDiseasesCodeRequiredFilter=" + encodeURIComponent("" + pestsAndDiseasesCodeRequiredFilter) + "&";
        if (partialMeasurementFilter === null)
            throw new globalThis.Error("The parameter 'partialMeasurementFilter' cannot be null.");
        else if (partialMeasurementFilter !== undefined)
            url_ += "PartialMeasurementFilter=" + encodeURIComponent("" + partialMeasurementFilter) + "&";
        if (partialHeightFilter === null)
            throw new globalThis.Error("The parameter 'partialHeightFilter' cannot be null.");
        else if (partialHeightFilter !== undefined)
            url_ += "PartialHeightFilter=" + encodeURIComponent("" + partialHeightFilter) + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        if (maxTrialAgeFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAgeFilter' cannot be null.");
        else if (maxTrialAgeFilter !== undefined)
            url_ += "MaxTrialAgeFilter=" + encodeURIComponent("" + maxTrialAgeFilter) + "&";
        if (minTrialAgeFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAgeFilter' cannot be null.");
        else if (minTrialAgeFilter !== undefined)
            url_ += "MinTrialAgeFilter=" + encodeURIComponent("" + minTrialAgeFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (trialTypeFilter === null)
            throw new globalThis.Error("The parameter 'trialTypeFilter' cannot be null.");
        else if (trialTypeFilter !== undefined)
            url_ += "TrialTypeFilter=" + encodeURIComponent("" + trialTypeFilter) + "&";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (assignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'assignmentNameFilter' cannot be null.");
        else if (assignmentNameFilter !== undefined)
            url_ += "AssignmentNameFilter=" + encodeURIComponent("" + assignmentNameFilter) + "&";
        if (measurementPlaningAssignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningAssignmentNameFilter' cannot be null.");
        else if (measurementPlaningAssignmentNameFilter !== undefined)
            url_ += "MeasurementPlaningAssignmentNameFilter=" + encodeURIComponent("" + measurementPlaningAssignmentNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningOptionsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningOptionsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementPlaningOptionsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementPlaningForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetAllMeasurementPlaningForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementPlaningForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentForTrial(trialId: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetAllTreatmentForTrial?";
        if (trialId === null)
            throw new globalThis.Error("The parameter 'trialId' cannot be null.");
        else if (trialId !== undefined)
            url_ += "TrialId=" + encodeURIComponent("" + trialId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentForTrial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentForTrial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto>;
        }));
    }

    protected processGetAllTreatmentForTrial(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeNumberForTrial(trialId: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetAllTreeNumberForTrial?";
        if (trialId === null)
            throw new globalThis.Error("The parameter 'trialId' cannot be null.");
        else if (trialId !== undefined)
            url_ += "TrialId=" + encodeURIComponent("" + trialId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeNumberForTrial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeNumberForTrial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto>;
        }));
    }

    protected processGetAllTreeNumberForTrial(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningOptionses/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementPlaningsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param assignmentNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, assignmentNameFilter: string | undefined, statusFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementPlaningForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'assignmentNameFilter' cannot be null.");
        else if (assignmentNameFilter !== undefined)
            url_ += "AssignmentNameFilter=" + encodeURIComponent("" + assignmentNameFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementPlaningForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementPlaningForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementPlaningForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementPlaningForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningForView(id: number | undefined): Observable<GetMeasurementPlaningForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/GetMeasurementPlaningForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningForViewDto>;
        }));
    }

    protected processGetMeasurementPlaningForView(response: HttpResponseBase): Observable<GetMeasurementPlaningForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningForEdit(id: number | undefined): Observable<GetMeasurementPlaningForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/GetMeasurementPlaningForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningForEditOutput>;
        }));
    }

    protected processGetMeasurementPlaningForEdit(response: HttpResponseBase): Observable<GetMeasurementPlaningForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementPlaningDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assignmentNameFilter (optional) 
     * @param statusFilter (optional) 
     * @return OK
     */
    getMeasurementPlaningsToExcel(filter: string | undefined, assignmentNameFilter: string | undefined, statusFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlanings/GetMeasurementPlaningsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assignmentNameFilter === null)
            throw new globalThis.Error("The parameter 'assignmentNameFilter' cannot be null.");
        else if (assignmentNameFilter !== undefined)
            url_ += "AssignmentNameFilter=" + encodeURIComponent("" + assignmentNameFilter) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementPlaningsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementPlaningTreatmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param treatmentNameTratamentFilter (optional) 
     * @param measurementPlaningOptionsStandNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, treatmentNameTratamentFilter: string | undefined, measurementPlaningOptionsStandNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treatmentNameTratamentFilter === null)
            throw new globalThis.Error("The parameter 'treatmentNameTratamentFilter' cannot be null.");
        else if (treatmentNameTratamentFilter !== undefined)
            url_ += "TreatmentNameTratamentFilter=" + encodeURIComponent("" + treatmentNameTratamentFilter) + "&";
        if (measurementPlaningOptionsStandNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsStandNameFilter' cannot be null.");
        else if (measurementPlaningOptionsStandNameFilter !== undefined)
            url_ += "MeasurementPlaningOptionsStandNameFilter=" + encodeURIComponent("" + measurementPlaningOptionsStandNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreatmentForView(id: number | undefined): Observable<GetMeasurementPlaningTreatmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetMeasurementPlaningTreatmentForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreatmentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreatmentForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreatmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreatmentForViewDto>;
        }));
    }

    protected processGetMeasurementPlaningTreatmentForView(response: HttpResponseBase): Observable<GetMeasurementPlaningTreatmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreatmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreatmentForEdit(id: number | undefined): Observable<GetMeasurementPlaningTreatmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetMeasurementPlaningTreatmentForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreatmentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreatmentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreatmentForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreatmentForEditOutput>;
        }));
    }

    protected processGetMeasurementPlaningTreatmentForEdit(response: HttpResponseBase): Observable<GetMeasurementPlaningTreatmentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreatmentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementPlaningTreatmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param treatmentNameTratamentFilter (optional) 
     * @param measurementPlaningOptionsStandNameFilter (optional) 
     * @return OK
     */
    getMeasurementPlaningTreatmentsToExcel(filter: string | undefined, treatmentNameTratamentFilter: string | undefined, measurementPlaningOptionsStandNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetMeasurementPlaningTreatmentsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treatmentNameTratamentFilter === null)
            throw new globalThis.Error("The parameter 'treatmentNameTratamentFilter' cannot be null.");
        else if (treatmentNameTratamentFilter !== undefined)
            url_ += "TreatmentNameTratamentFilter=" + encodeURIComponent("" + treatmentNameTratamentFilter) + "&";
        if (measurementPlaningOptionsStandNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsStandNameFilter' cannot be null.");
        else if (measurementPlaningOptionsStandNameFilter !== undefined)
            url_ += "MeasurementPlaningOptionsStandNameFilter=" + encodeURIComponent("" + measurementPlaningOptionsStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreatmentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreatmentsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementPlaningTreatmentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetAllTreatmentForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementPlaningOptionsForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreatments/GetAllMeasurementPlaningOptionsForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementPlaningOptionsForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementPlaningTreeHeightNumbersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxTreeNumberFilter (optional) 
     * @param minTreeNumberFilter (optional) 
     * @param measurementPlaningOptionsStandNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxTreeNumberFilter: number | undefined, minTreeNumberFilter: number | undefined, measurementPlaningOptionsStandNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberFilter' cannot be null.");
        else if (maxTreeNumberFilter !== undefined)
            url_ += "MaxTreeNumberFilter=" + encodeURIComponent("" + maxTreeNumberFilter) + "&";
        if (minTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberFilter' cannot be null.");
        else if (minTreeNumberFilter !== undefined)
            url_ += "MinTreeNumberFilter=" + encodeURIComponent("" + minTreeNumberFilter) + "&";
        if (measurementPlaningOptionsStandNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsStandNameFilter' cannot be null.");
        else if (measurementPlaningOptionsStandNameFilter !== undefined)
            url_ += "MeasurementPlaningOptionsStandNameFilter=" + encodeURIComponent("" + measurementPlaningOptionsStandNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeHeightNumberForView(id: number | undefined): Observable<GetMeasurementPlaningTreeHeightNumberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/GetMeasurementPlaningTreeHeightNumberForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeHeightNumberForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeHeightNumberForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreeHeightNumberForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreeHeightNumberForViewDto>;
        }));
    }

    protected processGetMeasurementPlaningTreeHeightNumberForView(response: HttpResponseBase): Observable<GetMeasurementPlaningTreeHeightNumberForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreeHeightNumberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeHeightNumberForEdit(id: number | undefined): Observable<GetMeasurementPlaningTreeHeightNumberForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/GetMeasurementPlaningTreeHeightNumberForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeHeightNumberForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeHeightNumberForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreeHeightNumberForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreeHeightNumberForEditOutput>;
        }));
    }

    protected processGetMeasurementPlaningTreeHeightNumberForEdit(response: HttpResponseBase): Observable<GetMeasurementPlaningTreeHeightNumberForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreeHeightNumberForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementPlaningTreeHeightNumberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxTreeNumberFilter (optional) 
     * @param minTreeNumberFilter (optional) 
     * @param measurementPlaningOptionsStandNameFilter (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeHeightNumbersToExcel(filter: string | undefined, maxTreeNumberFilter: number | undefined, minTreeNumberFilter: number | undefined, measurementPlaningOptionsStandNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/GetMeasurementPlaningTreeHeightNumbersToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberFilter' cannot be null.");
        else if (maxTreeNumberFilter !== undefined)
            url_ += "MaxTreeNumberFilter=" + encodeURIComponent("" + maxTreeNumberFilter) + "&";
        if (minTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberFilter' cannot be null.");
        else if (minTreeNumberFilter !== undefined)
            url_ += "MinTreeNumberFilter=" + encodeURIComponent("" + minTreeNumberFilter) + "&";
        if (measurementPlaningOptionsStandNameFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsStandNameFilter' cannot be null.");
        else if (measurementPlaningOptionsStandNameFilter !== undefined)
            url_ += "MeasurementPlaningOptionsStandNameFilter=" + encodeURIComponent("" + measurementPlaningOptionsStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeHeightNumbersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeHeightNumbersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementPlaningTreeHeightNumbersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementPlaningOptionsForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeHeightNumbers/GetAllMeasurementPlaningOptionsForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementPlaningOptionsForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementPlaningTreeNumbersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxTreeNumberFilter (optional) 
     * @param minTreeNumberFilter (optional) 
     * @param measurementPlaningOptionsTrialNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxTreeNumberFilter: number | undefined, minTreeNumberFilter: number | undefined, measurementPlaningOptionsTrialNumberFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberFilter' cannot be null.");
        else if (maxTreeNumberFilter !== undefined)
            url_ += "MaxTreeNumberFilter=" + encodeURIComponent("" + maxTreeNumberFilter) + "&";
        if (minTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberFilter' cannot be null.");
        else if (minTreeNumberFilter !== undefined)
            url_ += "MinTreeNumberFilter=" + encodeURIComponent("" + minTreeNumberFilter) + "&";
        if (measurementPlaningOptionsTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsTrialNumberFilter' cannot be null.");
        else if (measurementPlaningOptionsTrialNumberFilter !== undefined)
            url_ += "MeasurementPlaningOptionsTrialNumberFilter=" + encodeURIComponent("" + measurementPlaningOptionsTrialNumberFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeNumberForView(id: number | undefined): Observable<GetMeasurementPlaningTreeNumberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/GetMeasurementPlaningTreeNumberForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeNumberForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeNumberForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreeNumberForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreeNumberForViewDto>;
        }));
    }

    protected processGetMeasurementPlaningTreeNumberForView(response: HttpResponseBase): Observable<GetMeasurementPlaningTreeNumberForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreeNumberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeNumberForEdit(id: number | undefined): Observable<GetMeasurementPlaningTreeNumberForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/GetMeasurementPlaningTreeNumberForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeNumberForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeNumberForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningTreeNumberForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningTreeNumberForEditOutput>;
        }));
    }

    protected processGetMeasurementPlaningTreeNumberForEdit(response: HttpResponseBase): Observable<GetMeasurementPlaningTreeNumberForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementPlaningTreeNumberForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementPlaningTreeNumberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxTreeNumberFilter (optional) 
     * @param minTreeNumberFilter (optional) 
     * @param measurementPlaningOptionsTrialNumberFilter (optional) 
     * @return OK
     */
    getMeasurementPlaningTreeNumbersToExcel(filter: string | undefined, maxTreeNumberFilter: number | undefined, minTreeNumberFilter: number | undefined, measurementPlaningOptionsTrialNumberFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/GetMeasurementPlaningTreeNumbersToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberFilter' cannot be null.");
        else if (maxTreeNumberFilter !== undefined)
            url_ += "MaxTreeNumberFilter=" + encodeURIComponent("" + maxTreeNumberFilter) + "&";
        if (minTreeNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberFilter' cannot be null.");
        else if (minTreeNumberFilter !== undefined)
            url_ += "MinTreeNumberFilter=" + encodeURIComponent("" + minTreeNumberFilter) + "&";
        if (measurementPlaningOptionsTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsTrialNumberFilter' cannot be null.");
        else if (measurementPlaningOptionsTrialNumberFilter !== undefined)
            url_ += "MeasurementPlaningOptionsTrialNumberFilter=" + encodeURIComponent("" + measurementPlaningOptionsTrialNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementPlaningTreeNumbersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementPlaningTreeNumbersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementPlaningTreeNumbersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementPlaningOptionsForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementPlaningTreeNumbers/GetAllMeasurementPlaningOptionsForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningOptionsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementPlaningOptionsForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementSelectionGenomicsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param destination (optional) 
     * @param isBBX (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, seedlingSubProjectFilter: string | undefined, projectNameFilter: string | undefined, destination: string | undefined, isBBX: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (destination === null)
            throw new globalThis.Error("The parameter 'destination' cannot be null.");
        else if (destination !== undefined)
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        if (isBBX === null)
            throw new globalThis.Error("The parameter 'isBBX' cannot be null.");
        else if (isBBX !== undefined)
            url_ += "isBBX=" + encodeURIComponent("" + isBBX) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionGenomicForView(id: number | undefined): Observable<GetMeasurementSelectionGenomicForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetMeasurementSelectionGenomicForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionGenomicForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionGenomicForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionGenomicForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionGenomicForViewDto>;
        }));
    }

    protected processGetMeasurementSelectionGenomicForView(response: HttpResponseBase): Observable<GetMeasurementSelectionGenomicForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionGenomicForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionGenomicForEdit(id: number | undefined): Observable<GetMeasurementSelectionGenomicForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetMeasurementSelectionGenomicForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionGenomicForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionGenomicForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionGenomicForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionGenomicForEditOutput>;
        }));
    }

    protected processGetMeasurementSelectionGenomicForEdit(response: HttpResponseBase): Observable<GetMeasurementSelectionGenomicForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionGenomicForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementSelectionGenomicDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param destination (optional) 
     * @return OK
     */
    getMeasurementSelectionGenomicsToExcel(filter: string | undefined, seedlingSubProjectFilter: string | undefined, projectNameFilter: string | undefined, destination: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetMeasurementSelectionGenomicsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (destination === null)
            throw new globalThis.Error("The parameter 'destination' cannot be null.");
        else if (destination !== undefined)
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionGenomicsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionGenomicsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementSelectionGenomicsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedlingForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetAllSeedlingForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedlingForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedlingForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto>;
        }));
    }

    protected processGetAllSeedlingForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isCreateProyect (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportMeasurementSelectionGenomicsToExcel(isCreateProyect: boolean | undefined, body: GetAllMeasurementSelectionGenomicsForExcelInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/ExportMeasurementSelectionGenomicsToExcel?";
        if (isCreateProyect === null)
            throw new globalThis.Error("The parameter 'isCreateProyect' cannot be null.");
        else if (isCreateProyect !== undefined)
            url_ += "isCreateProyect=" + encodeURIComponent("" + isCreateProyect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMeasurementSelectionGenomicsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMeasurementSelectionGenomicsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportMeasurementSelectionGenomicsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param destination (optional) 
     * @param isBBX (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllBBTCandidate(filter: string | undefined, seedlingSubProjectFilter: string | undefined, projectNameFilter: string | undefined, destination: string | undefined, isBBX: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetAllBBTCandidate?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (destination === null)
            throw new globalThis.Error("The parameter 'destination' cannot be null.");
        else if (destination !== undefined)
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        if (isBBX === null)
            throw new globalThis.Error("The parameter 'isBBX' cannot be null.");
        else if (isBBX !== undefined)
            url_ += "isBBX=" + encodeURIComponent("" + isBBX) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBTCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBTCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto>;
        }));
    }

    protected processGetAllBBTCandidate(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param seedlingSubProjectFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param destination (optional) 
     * @return OK
     */
    getBBTCandidateMeasurementSelectionGenomicsToExcel(filter: string | undefined, seedlingSubProjectFilter: string | undefined, projectNameFilter: string | undefined, destination: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetBBTCandidateMeasurementSelectionGenomicsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedlingSubProjectFilter === null)
            throw new globalThis.Error("The parameter 'seedlingSubProjectFilter' cannot be null.");
        else if (seedlingSubProjectFilter !== undefined)
            url_ += "SeedlingSubProjectFilter=" + encodeURIComponent("" + seedlingSubProjectFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (destination === null)
            throw new globalThis.Error("The parameter 'destination' cannot be null.");
        else if (destination !== undefined)
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBTCandidateMeasurementSelectionGenomicsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBTCandidateMeasurementSelectionGenomicsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBBTCandidateMeasurementSelectionGenomicsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportBBTCandidateMeasurementSelectionGenomicsToExcel(body: GetAllMeasurementSelectionGenomicsForExcelInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/ExportBBTCandidateMeasurementSelectionGenomicsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBBTCandidateMeasurementSelectionGenomicsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBBTCandidateMeasurementSelectionGenomicsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportBBTCandidateMeasurementSelectionGenomicsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllBBT(body: DestinoBBXDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/SetAllBBT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetAllBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setBBT(measurementId: number | undefined, body: GetBBXDestinationForViewDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/SetBBT?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unSetAllBBT(body: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/UnSetAllBBT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetAllBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetAllBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetAllBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @return OK
     */
    unSetBBT(measurementId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/UnSetBBT?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unSetAllBBX(body: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/UnSetAllBBX";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetAllBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetAllBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetAllBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @return OK
     */
    unSetBBX(measurementId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/UnSetBBX?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectNameFilter (optional) 
     * @param laboratoryProjectStatusNameFilter (optional) 
     * @return OK
     */
    getBBTSheetToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpecieFilter: string | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectNameFilter: string | undefined, laboratoryProjectStatusNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/GetBBTSheetToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectNameFilter' cannot be null.");
        else if (laboratoryProjectNameFilter !== undefined)
            url_ += "LaboratoryProjectNameFilter=" + encodeURIComponent("" + laboratoryProjectNameFilter) + "&";
        if (laboratoryProjectStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusNameFilter' cannot be null.");
        else if (laboratoryProjectStatusNameFilter !== undefined)
            url_ += "LaboratoryProjectStatusNameFilter=" + encodeURIComponent("" + laboratoryProjectStatusNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBTSheetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBTSheetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBBTSheetToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllBBXAndDestination(body: GetBBXDestinationForViewForManyDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/SetAllBBXAndDestination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllBBXAndDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllBBXAndDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetAllBBXAndDestination(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setBBX(measurementId: number | undefined, body: GetBBXDestinationForViewDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionGenomics/SetBBX?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementSelectionOtherProjectsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param proyectoFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param laboratoryProjectTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, proyectoFilter: string | undefined, projectNameFilter: string | undefined, laboratoryProjectTypeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (proyectoFilter === null)
            throw new globalThis.Error("The parameter 'proyectoFilter' cannot be null.");
        else if (proyectoFilter !== undefined)
            url_ += "ProyectoFilter=" + encodeURIComponent("" + proyectoFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (laboratoryProjectTypeFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypeFilter' cannot be null.");
        else if (laboratoryProjectTypeFilter !== undefined)
            url_ += "LaboratoryProjectTypeFilter=" + encodeURIComponent("" + laboratoryProjectTypeFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionOtherProjectForView(id: number | undefined): Observable<GetMeasurementSelectionOtherProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetMeasurementSelectionOtherProjectForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionOtherProjectForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionOtherProjectForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionOtherProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionOtherProjectForViewDto>;
        }));
    }

    protected processGetMeasurementSelectionOtherProjectForView(response: HttpResponseBase): Observable<GetMeasurementSelectionOtherProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionOtherProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionOtherProjectForEdit(id: number | undefined): Observable<GetMeasurementSelectionOtherProjectForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetMeasurementSelectionOtherProjectForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionOtherProjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionOtherProjectForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionOtherProjectForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionOtherProjectForEditOutput>;
        }));
    }

    protected processGetMeasurementSelectionOtherProjectForEdit(response: HttpResponseBase): Observable<GetMeasurementSelectionOtherProjectForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionOtherProjectForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementSelectionOtherProjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param proyectoFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param laboratoryProjectTypeFilter (optional) 
     * @return OK
     */
    getMeasurementSelectionOtherProjectsToExcel(filter: string | undefined, proyectoFilter: string | undefined, projectNameFilter: string | undefined, laboratoryProjectTypeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetMeasurementSelectionOtherProjectsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (proyectoFilter === null)
            throw new globalThis.Error("The parameter 'proyectoFilter' cannot be null.");
        else if (proyectoFilter !== undefined)
            url_ += "ProyectoFilter=" + encodeURIComponent("" + proyectoFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (laboratoryProjectTypeFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypeFilter' cannot be null.");
        else if (laboratoryProjectTypeFilter !== undefined)
            url_ += "LaboratoryProjectTypeFilter=" + encodeURIComponent("" + laboratoryProjectTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionOtherProjectsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionOtherProjectsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementSelectionOtherProjectsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param projectType (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, projectType: string | undefined): Observable<PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (projectType === null)
            throw new globalThis.Error("The parameter 'projectType' cannot be null.");
        else if (projectType !== undefined)
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectType (optional) 
     * @param body (optional) 
     * @return OK
     */
    createMeasurementsFromExcel(projectType: string | undefined, body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/CreateMeasurementsFromExcel?";
        if (projectType === null)
            throw new globalThis.Error("The parameter 'projectType' cannot be null.");
        else if (projectType !== undefined)
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMeasurementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMeasurementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateMeasurementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectType (optional) 
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(projectType: string | undefined, body: string | undefined): Observable<CreateOrEditMeasurementSelectionOtherProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/OnPostImportFromExcel?";
        if (projectType === null)
            throw new globalThis.Error("The parameter 'projectType' cannot be null.");
        else if (projectType !== undefined)
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditMeasurementSelectionOtherProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditMeasurementSelectionOtherProjectDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditMeasurementSelectionOtherProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditMeasurementSelectionOtherProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMeasurementSelectionOtherProjectsTemplateToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelectionOtherProjects/GetMeasurementSelectionOtherProjectsTemplateToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionOtherProjectsTemplateToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionOtherProjectsTemplateToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementSelectionOtherProjectsTemplateToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementSelectionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllBBTCandidate(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllBBTCandidate?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBTCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBTCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
        }));
    }

    protected processGetAllBBTCandidate(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllBBT(body: DestinoBBXDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/SetAllBBT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetAllBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setBBT(measurementId: number | undefined, body: GetBBXDestinationForViewDto[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/SetBBT?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unSetAllBBT(body: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/UnSetAllBBT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetAllBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetAllBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetAllBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementId (optional) 
     * @return OK
     */
    unSetBBT(measurementId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/UnSetBBT?";
        if (measurementId === null)
            throw new globalThis.Error("The parameter 'measurementId' cannot be null.");
        else if (measurementId !== undefined)
            url_ += "measurementId=" + encodeURIComponent("" + measurementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSetBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSetBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnSetBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getBBTSheetToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetBBTSheetToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBTSheetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBTSheetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBBTSheetToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllBBXCandidate(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllBBXCandidate?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBXCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBXCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
        }));
    }

    protected processGetAllBBXCandidate(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getBBXSheetToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetBBXSheetToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBXSheetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBXSheetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBBXSheetToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionForView(id: number | undefined): Observable<GetMeasurementSelectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetMeasurementSelectionForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionForViewDto>;
        }));
    }

    protected processGetMeasurementSelectionForView(response: HttpResponseBase): Observable<GetMeasurementSelectionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMeasurementSelectionForEdit(id: number | undefined): Observable<GetMeasurementSelectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetMeasurementSelectionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementSelectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementSelectionForEditOutput>;
        }));
    }

    protected processGetMeasurementSelectionForEdit(response: HttpResponseBase): Observable<GetMeasurementSelectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeasurementSelectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMeasurementSelectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassivePhenotyping(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassivePhenotyping?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassivePhenotyping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassivePhenotyping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassivePhenotyping(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveSawdust(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassiveSawdust?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveSawdust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveSawdust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveSawdust(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveClonaleSelection(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassiveClonaleSelection?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveClonaleSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveClonaleSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveClonaleSelection(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveDisc(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassiveDisc?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveDisc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveDisc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveDisc(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveBBT(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassiveBBT?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveBBT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveBBT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveBBT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveBBX(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteMassiveBBX?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveBBX(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @param projectName (optional) 
     * @param stageSelection (optional) 
     * @return OK
     */
    deleteByDate(date: DateTime | undefined, projectName: string | undefined, stageSelection: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/DeleteByDate?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        if (projectName === null)
            throw new globalThis.Error("The parameter 'projectName' cannot be null.");
        else if (projectName !== undefined)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&";
        if (stageSelection === null)
            throw new globalThis.Error("The parameter 'stageSelection' cannot be null.");
        else if (stageSelection !== undefined)
            url_ += "stageSelection=" + encodeURIComponent("" + stageSelection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteByDate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getMeasurementSelectionsToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetMeasurementSelectionsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSelectionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSelectionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMeasurementSelectionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getMassivePhenotypingTemplateToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetMassivePhenotypingTemplateToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMassivePhenotypingTemplateToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMassivePhenotypingTemplateToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMassivePhenotypingTemplateToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getLaboratorySheetToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetLaboratorySheetToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratorySheetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratorySheetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLaboratorySheetToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getMassiveClonaleSelectionTemplateToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetMassiveClonaleSelectionTemplateToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMassiveClonaleSelectionTemplateToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMassiveClonaleSelectionTemplateToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMassiveClonaleSelectionTemplateToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBV_VolFilter (optional) 
     * @param minBV_VolFilter (optional) 
     * @param stageOneSelectionFilter (optional) 
     * @param stageTwoSelectionFilter (optional) 
     * @param treeIdNameFilter (optional) 
     * @param nirCodeFilter (optional) 
     * @param maxDB_Model_Kg_m3Filter (optional) 
     * @param minDB_Model_Kg_m3Filter (optional) 
     * @param maxPilodynFilter (optional) 
     * @param minPilodynFilter (optional) 
     * @param maxRP_Model_PercentageFilter (optional) 
     * @param minRP_Model_PercentageFilter (optional) 
     * @param maxDB_Lab_Kg_m3Filter (optional) 
     * @param minDB_Lab_Kg_m3Filter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observationsFilter (optional) 
     * @param destinationFilter (optional) 
     * @param numberTFilter (optional) 
     * @param maxMaxRootingPercentageFilter (optional) 
     * @param minMaxRootingPercentageFilter (optional) 
     * @param numberXFilter (optional) 
     * @param treeSpeciesFilter (optional) 
     * @param woodSampleTypeNameFilter (optional) 
     * @param woodSampleTypeName2Filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getLaboratorySheetDiscoToExcel(filter: string | undefined, maxBV_VolFilter: number | undefined, minBV_VolFilter: number | undefined, stageOneSelectionFilter: number | undefined, stageTwoSelectionFilter: number | undefined, treeIdNameFilter: string | undefined, nirCodeFilter: string | undefined, maxDB_Model_Kg_m3Filter: number | undefined, minDB_Model_Kg_m3Filter: number | undefined, maxPilodynFilter: number | undefined, minPilodynFilter: number | undefined, maxRP_Model_PercentageFilter: number | undefined, minRP_Model_PercentageFilter: number | undefined, maxDB_Lab_Kg_m3Filter: number | undefined, minDB_Lab_Kg_m3Filter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observationsFilter: string | undefined, destinationFilter: string | undefined, numberTFilter: string | undefined, maxMaxRootingPercentageFilter: number | undefined, minMaxRootingPercentageFilter: number | undefined, numberXFilter: string | undefined, treeSpeciesFilter: string[] | undefined, woodSampleTypeNameFilter: string | undefined, woodSampleTypeName2Filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetLaboratorySheetDiscoToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'maxBV_VolFilter' cannot be null.");
        else if (maxBV_VolFilter !== undefined)
            url_ += "MaxBV_VolFilter=" + encodeURIComponent("" + maxBV_VolFilter) + "&";
        if (minBV_VolFilter === null)
            throw new globalThis.Error("The parameter 'minBV_VolFilter' cannot be null.");
        else if (minBV_VolFilter !== undefined)
            url_ += "MinBV_VolFilter=" + encodeURIComponent("" + minBV_VolFilter) + "&";
        if (stageOneSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageOneSelectionFilter' cannot be null.");
        else if (stageOneSelectionFilter !== undefined)
            url_ += "StageOneSelectionFilter=" + encodeURIComponent("" + stageOneSelectionFilter) + "&";
        if (stageTwoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'stageTwoSelectionFilter' cannot be null.");
        else if (stageTwoSelectionFilter !== undefined)
            url_ += "StageTwoSelectionFilter=" + encodeURIComponent("" + stageTwoSelectionFilter) + "&";
        if (treeIdNameFilter === null)
            throw new globalThis.Error("The parameter 'treeIdNameFilter' cannot be null.");
        else if (treeIdNameFilter !== undefined)
            url_ += "TreeIdNameFilter=" + encodeURIComponent("" + treeIdNameFilter) + "&";
        if (nirCodeFilter === null)
            throw new globalThis.Error("The parameter 'nirCodeFilter' cannot be null.");
        else if (nirCodeFilter !== undefined)
            url_ += "NirCodeFilter=" + encodeURIComponent("" + nirCodeFilter) + "&";
        if (maxDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Model_Kg_m3Filter' cannot be null.");
        else if (maxDB_Model_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Model_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Model_Kg_m3Filter) + "&";
        if (minDB_Model_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Model_Kg_m3Filter' cannot be null.");
        else if (minDB_Model_Kg_m3Filter !== undefined)
            url_ += "MinDB_Model_Kg_m3Filter=" + encodeURIComponent("" + minDB_Model_Kg_m3Filter) + "&";
        if (maxPilodynFilter === null)
            throw new globalThis.Error("The parameter 'maxPilodynFilter' cannot be null.");
        else if (maxPilodynFilter !== undefined)
            url_ += "MaxPilodynFilter=" + encodeURIComponent("" + maxPilodynFilter) + "&";
        if (minPilodynFilter === null)
            throw new globalThis.Error("The parameter 'minPilodynFilter' cannot be null.");
        else if (minPilodynFilter !== undefined)
            url_ += "MinPilodynFilter=" + encodeURIComponent("" + minPilodynFilter) + "&";
        if (maxRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Model_PercentageFilter' cannot be null.");
        else if (maxRP_Model_PercentageFilter !== undefined)
            url_ += "MaxRP_Model_PercentageFilter=" + encodeURIComponent("" + maxRP_Model_PercentageFilter) + "&";
        if (minRP_Model_PercentageFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Model_PercentageFilter' cannot be null.");
        else if (minRP_Model_PercentageFilter !== undefined)
            url_ += "MinRP_Model_PercentageFilter=" + encodeURIComponent("" + minRP_Model_PercentageFilter) + "&";
        if (maxDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_Kg_m3Filter' cannot be null.");
        else if (maxDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MaxDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + maxDB_Lab_Kg_m3Filter) + "&";
        if (minDB_Lab_Kg_m3Filter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_Kg_m3Filter' cannot be null.");
        else if (minDB_Lab_Kg_m3Filter !== undefined)
            url_ += "MinDB_Lab_Kg_m3Filter=" + encodeURIComponent("" + minDB_Lab_Kg_m3Filter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (numberTFilter === null)
            throw new globalThis.Error("The parameter 'numberTFilter' cannot be null.");
        else if (numberTFilter !== undefined)
            url_ += "NumberTFilter=" + encodeURIComponent("" + numberTFilter) + "&";
        if (maxMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxMaxRootingPercentageFilter' cannot be null.");
        else if (maxMaxRootingPercentageFilter !== undefined)
            url_ += "MaxMaxRootingPercentageFilter=" + encodeURIComponent("" + maxMaxRootingPercentageFilter) + "&";
        if (minMaxRootingPercentageFilter === null)
            throw new globalThis.Error("The parameter 'minMaxRootingPercentageFilter' cannot be null.");
        else if (minMaxRootingPercentageFilter !== undefined)
            url_ += "MinMaxRootingPercentageFilter=" + encodeURIComponent("" + minMaxRootingPercentageFilter) + "&";
        if (numberXFilter === null)
            throw new globalThis.Error("The parameter 'numberXFilter' cannot be null.");
        else if (numberXFilter !== undefined)
            url_ += "NumberXFilter=" + encodeURIComponent("" + numberXFilter) + "&";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            treeSpeciesFilter && treeSpeciesFilter.forEach(item => { url_ += "TreeSpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (woodSampleTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeNameFilter' cannot be null.");
        else if (woodSampleTypeNameFilter !== undefined)
            url_ += "WoodSampleTypeNameFilter=" + encodeURIComponent("" + woodSampleTypeNameFilter) + "&";
        if (woodSampleTypeName2Filter === null)
            throw new globalThis.Error("The parameter 'woodSampleTypeName2Filter' cannot be null.");
        else if (woodSampleTypeName2Filter !== undefined)
            url_ += "WoodSampleTypeName2Filter=" + encodeURIComponent("" + woodSampleTypeName2Filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratorySheetDiscoToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratorySheetDiscoToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLaboratorySheetDiscoToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeNotBBXBBTForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllTreeNotBBXBBTForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeNotBBXBBTForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeNotBBXBBTForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeNotBBXBBTForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWoodSampleTypeForTableDropdown(): Observable<MeasurementSelectionWoodSampleTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllWoodSampleTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWoodSampleTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWoodSampleTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementSelectionWoodSampleTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementSelectionWoodSampleTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllWoodSampleTypeForTableDropdown(response: HttpResponseBase): Observable<MeasurementSelectionWoodSampleTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementSelectionWoodSampleTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMeasurementSelectionProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMeasurementSelectionProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMeasurementSelectionProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMeasurementSelectionProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMeasurementSelectionProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLaboratoryProjectForTableDropdown(): Observable<ProjectLaboratoryProjectLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllLaboratoryProjectForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLaboratoryProjectLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLaboratoryProjectLookupTableDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectForTableDropdown(response: HttpResponseBase): Observable<ProjectLaboratoryProjectLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectLaboratoryProjectLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLaboratoryProjectStatusForTableDropdown(): Observable<ProjectLaboratoryProjectStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllLaboratoryProjectStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLaboratoryProjectStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLaboratoryProjectStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectStatusForTableDropdown(response: HttpResponseBase): Observable<ProjectLaboratoryProjectStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectLaboratoryProjectStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importLaboratorySheetAserrinFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/ImportLaboratorySheetAserrinFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLaboratorySheetAserrinFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLaboratorySheetAserrinFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportLaboratorySheetAserrinFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    laboratorySheetsAsserrinFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/LaboratorySheetsAsserrinFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLaboratorySheetsAsserrinFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLaboratorySheetsAsserrinFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processLaboratorySheetsAsserrinFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importLaboratorySheetDiscoFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/ImportLaboratorySheetDiscoFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLaboratorySheetDiscoFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLaboratorySheetDiscoFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportLaboratorySheetDiscoFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    laboratorySheetsDiscoFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/LaboratorySheetsDiscoFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLaboratorySheetsDiscoFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLaboratorySheetsDiscoFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processLaboratorySheetsDiscoFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importBBTRootingPercentageFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/ImportBBTRootingPercentageFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBBTRootingPercentageFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBBTRootingPercentageFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportBBTRootingPercentageFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectNameFilter (optional) 
     * @return OK
     */
    getAllProjectsByName(projectNameFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllProjectsByName?";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "projectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllProjectsByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param laboratoryProjectStatusFilter (optional) 
     * @return OK
     */
    getAllLaboratoryProjectStatusByName(laboratoryProjectStatusFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllLaboratoryProjectStatusByName?";
        if (laboratoryProjectStatusFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusFilter' cannot be null.");
        else if (laboratoryProjectStatusFilter !== undefined)
            url_ += "laboratoryProjectStatusFilter=" + encodeURIComponent("" + laboratoryProjectStatusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectStatusByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectStatusByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectStatusByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param treeSpeciesFilter (optional) 
     * @return OK
     */
    getAllTreeSpecieByName(treeSpeciesFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllTreeSpecieByName?";
        if (treeSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'treeSpeciesFilter' cannot be null.");
        else if (treeSpeciesFilter !== undefined)
            url_ += "treeSpeciesFilter=" + encodeURIComponent("" + treeSpeciesFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeSpecieByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeSpecieByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllTreeSpecieByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param laboratoryProjectTypeNameFilter (optional) 
     * @return OK
     */
    getAllLaboratoryProjectTypeByName(laboratoryProjectTypeNameFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementSelections/GetAllLaboratoryProjectTypeByName?";
        if (laboratoryProjectTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypeNameFilter' cannot be null.");
        else if (laboratoryProjectTypeNameFilter !== undefined)
            url_ += "laboratoryProjectTypeNameFilter=" + encodeURIComponent("" + laboratoryProjectTypeNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectTypeByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectTypeByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectTypeByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MesurementCloneEvaluationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxBloqueFilter (optional) 
     * @param minBloqueFilter (optional) 
     * @param maxSubbloqueFilter (optional) 
     * @param minSubbloqueFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxFechaMuestreoFilter (optional) 
     * @param minFechaMuestreoFilter (optional) 
     * @param maxFechaPlantacionFilter (optional) 
     * @param minFechaPlantacionFilter (optional) 
     * @param maxEdadFilter (optional) 
     * @param minEdadFilter (optional) 
     * @param maxDB_labFilter (optional) 
     * @param minDB_labFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observacionFilter (optional) 
     * @param codigo_NirFilter (optional) 
     * @param maxDB_ModeloFilter (optional) 
     * @param minDB_ModeloFilter (optional) 
     * @param maxRP_ModeloFilter (optional) 
     * @param minRP_ModeloFilter (optional) 
     * @param maxPyrodinFilter (optional) 
     * @param minPyrodinFilter (optional) 
     * @param maxRP_Lab_FRBFilter (optional) 
     * @param minRP_Lab_FRBFilter (optional) 
     * @param maxLignina_FRBFilter (optional) 
     * @param minLignina_FRBFilter (optional) 
     * @param maxCelulosa_FRBFilter (optional) 
     * @param minCelulosa_FRBFilter (optional) 
     * @param maxEXT_AC_FRBFilter (optional) 
     * @param minEXT_AC_FRBFilter (optional) 
     * @param maxConsumo_AEFilter (optional) 
     * @param minConsumo_AEFilter (optional) 
     * @param maxASHFilter (optional) 
     * @param minASHFilter (optional) 
     * @param maxExtractivesFilter (optional) 
     * @param minExtractivesFilter (optional) 
     * @param maxTotal_LigninFilter (optional) 
     * @param minTotal_LigninFilter (optional) 
     * @param maxCelulloseFilter (optional) 
     * @param minCelulloseFilter (optional) 
     * @param maxGlucomananFilter (optional) 
     * @param minGlucomananFilter (optional) 
     * @param maxOthersFilter (optional) 
     * @param minOthersFilter (optional) 
     * @param maxAIFilter (optional) 
     * @param minAIFilter (optional) 
     * @param maxBaFilter (optional) 
     * @param minBaFilter (optional) 
     * @param maxCaFilter (optional) 
     * @param minCaFilter (optional) 
     * @param maxCuFilter (optional) 
     * @param minCuFilter (optional) 
     * @param maxFeFilter (optional) 
     * @param minFeFilter (optional) 
     * @param maxKFilter (optional) 
     * @param minKFilter (optional) 
     * @param maxMgFilter (optional) 
     * @param minMgFilter (optional) 
     * @param maxMnFilter (optional) 
     * @param minMnFilter (optional) 
     * @param maxNaFilter (optional) 
     * @param minNaFilter (optional) 
     * @param maxPFilter (optional) 
     * @param minPFilter (optional) 
     * @param maxSFilter (optional) 
     * @param minSFilter (optional) 
     * @param maxSiFilter (optional) 
     * @param minSiFilter (optional) 
     * @param maxXylanFilter (optional) 
     * @param minXylanFilter (optional) 
     * @param sub_ProyectoFilter (optional) 
     * @param typeMaterialFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialOldTrialDenominationFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treeStatusNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxBloqueFilter: number | undefined, minBloqueFilter: number | undefined, maxSubbloqueFilter: number | undefined, minSubbloqueFilter: number | undefined, maxYearFilter: number | undefined, minYearFilter: number | undefined, maxFechaMuestreoFilter: DateTime | undefined, minFechaMuestreoFilter: DateTime | undefined, maxFechaPlantacionFilter: DateTime | undefined, minFechaPlantacionFilter: DateTime | undefined, maxEdadFilter: number | undefined, minEdadFilter: number | undefined, maxDB_labFilter: number | undefined, minDB_labFilter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observacionFilter: string | undefined, codigo_NirFilter: string | undefined, maxDB_ModeloFilter: number | undefined, minDB_ModeloFilter: number | undefined, maxRP_ModeloFilter: number | undefined, minRP_ModeloFilter: number | undefined, maxPyrodinFilter: number | undefined, minPyrodinFilter: number | undefined, maxRP_Lab_FRBFilter: number | undefined, minRP_Lab_FRBFilter: number | undefined, maxLignina_FRBFilter: number | undefined, minLignina_FRBFilter: number | undefined, maxCelulosa_FRBFilter: number | undefined, minCelulosa_FRBFilter: number | undefined, maxEXT_AC_FRBFilter: number | undefined, minEXT_AC_FRBFilter: number | undefined, maxConsumo_AEFilter: number | undefined, minConsumo_AEFilter: number | undefined, maxASHFilter: number | undefined, minASHFilter: number | undefined, maxExtractivesFilter: number | undefined, minExtractivesFilter: number | undefined, maxTotal_LigninFilter: number | undefined, minTotal_LigninFilter: number | undefined, maxCelulloseFilter: number | undefined, minCelulloseFilter: number | undefined, maxGlucomananFilter: number | undefined, minGlucomananFilter: number | undefined, maxOthersFilter: number | undefined, minOthersFilter: number | undefined, maxAIFilter: number | undefined, minAIFilter: number | undefined, maxBaFilter: number | undefined, minBaFilter: number | undefined, maxCaFilter: number | undefined, minCaFilter: number | undefined, maxCuFilter: number | undefined, minCuFilter: number | undefined, maxFeFilter: number | undefined, minFeFilter: number | undefined, maxKFilter: number | undefined, minKFilter: number | undefined, maxMgFilter: number | undefined, minMgFilter: number | undefined, maxMnFilter: number | undefined, minMnFilter: number | undefined, maxNaFilter: number | undefined, minNaFilter: number | undefined, maxPFilter: number | undefined, minPFilter: number | undefined, maxSFilter: number | undefined, minSFilter: number | undefined, maxSiFilter: number | undefined, minSiFilter: number | undefined, maxXylanFilter: number | undefined, minXylanFilter: number | undefined, sub_ProyectoFilter: string | undefined, typeMaterialFilter: string | undefined, projectNameFilter: string | undefined, trialOldTrialDenominationFilter: string | undefined, treeSpecieFilter: string | undefined, seedBBSFilter: string | undefined, cloneBBXFilter: string | undefined, treeStatusNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMesurementCloneEvaluationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxBloqueFilter' cannot be null.");
        else if (maxBloqueFilter !== undefined)
            url_ += "MaxBloqueFilter=" + encodeURIComponent("" + maxBloqueFilter) + "&";
        if (minBloqueFilter === null)
            throw new globalThis.Error("The parameter 'minBloqueFilter' cannot be null.");
        else if (minBloqueFilter !== undefined)
            url_ += "MinBloqueFilter=" + encodeURIComponent("" + minBloqueFilter) + "&";
        if (maxSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxSubbloqueFilter' cannot be null.");
        else if (maxSubbloqueFilter !== undefined)
            url_ += "MaxSubbloqueFilter=" + encodeURIComponent("" + maxSubbloqueFilter) + "&";
        if (minSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'minSubbloqueFilter' cannot be null.");
        else if (minSubbloqueFilter !== undefined)
            url_ += "MinSubbloqueFilter=" + encodeURIComponent("" + minSubbloqueFilter) + "&";
        if (maxYearFilter === null)
            throw new globalThis.Error("The parameter 'maxYearFilter' cannot be null.");
        else if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter === null)
            throw new globalThis.Error("The parameter 'minYearFilter' cannot be null.");
        else if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaMuestreoFilter' cannot be null.");
        else if (maxFechaMuestreoFilter !== undefined)
            url_ += "MaxFechaMuestreoFilter=" + encodeURIComponent(maxFechaMuestreoFilter ? "" + maxFechaMuestreoFilter.toString() : "") + "&";
        if (minFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaMuestreoFilter' cannot be null.");
        else if (minFechaMuestreoFilter !== undefined)
            url_ += "MinFechaMuestreoFilter=" + encodeURIComponent(minFechaMuestreoFilter ? "" + minFechaMuestreoFilter.toString() : "") + "&";
        if (maxFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaPlantacionFilter' cannot be null.");
        else if (maxFechaPlantacionFilter !== undefined)
            url_ += "MaxFechaPlantacionFilter=" + encodeURIComponent(maxFechaPlantacionFilter ? "" + maxFechaPlantacionFilter.toString() : "") + "&";
        if (minFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'minFechaPlantacionFilter' cannot be null.");
        else if (minFechaPlantacionFilter !== undefined)
            url_ += "MinFechaPlantacionFilter=" + encodeURIComponent(minFechaPlantacionFilter ? "" + minFechaPlantacionFilter.toString() : "") + "&";
        if (maxEdadFilter === null)
            throw new globalThis.Error("The parameter 'maxEdadFilter' cannot be null.");
        else if (maxEdadFilter !== undefined)
            url_ += "MaxEdadFilter=" + encodeURIComponent("" + maxEdadFilter) + "&";
        if (minEdadFilter === null)
            throw new globalThis.Error("The parameter 'minEdadFilter' cannot be null.");
        else if (minEdadFilter !== undefined)
            url_ += "MinEdadFilter=" + encodeURIComponent("" + minEdadFilter) + "&";
        if (maxDB_labFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_labFilter' cannot be null.");
        else if (maxDB_labFilter !== undefined)
            url_ += "MaxDB_labFilter=" + encodeURIComponent("" + maxDB_labFilter) + "&";
        if (minDB_labFilter === null)
            throw new globalThis.Error("The parameter 'minDB_labFilter' cannot be null.");
        else if (minDB_labFilter !== undefined)
            url_ += "MinDB_labFilter=" + encodeURIComponent("" + minDB_labFilter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observacionFilter === null)
            throw new globalThis.Error("The parameter 'observacionFilter' cannot be null.");
        else if (observacionFilter !== undefined)
            url_ += "ObservacionFilter=" + encodeURIComponent("" + observacionFilter) + "&";
        if (codigo_NirFilter === null)
            throw new globalThis.Error("The parameter 'codigo_NirFilter' cannot be null.");
        else if (codigo_NirFilter !== undefined)
            url_ += "codigo_NirFilter=" + encodeURIComponent("" + codigo_NirFilter) + "&";
        if (maxDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_ModeloFilter' cannot be null.");
        else if (maxDB_ModeloFilter !== undefined)
            url_ += "MaxDB_ModeloFilter=" + encodeURIComponent("" + maxDB_ModeloFilter) + "&";
        if (minDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minDB_ModeloFilter' cannot be null.");
        else if (minDB_ModeloFilter !== undefined)
            url_ += "MinDB_ModeloFilter=" + encodeURIComponent("" + minDB_ModeloFilter) + "&";
        if (maxRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_ModeloFilter' cannot be null.");
        else if (maxRP_ModeloFilter !== undefined)
            url_ += "MaxRP_ModeloFilter=" + encodeURIComponent("" + maxRP_ModeloFilter) + "&";
        if (minRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minRP_ModeloFilter' cannot be null.");
        else if (minRP_ModeloFilter !== undefined)
            url_ += "MinRP_ModeloFilter=" + encodeURIComponent("" + minRP_ModeloFilter) + "&";
        if (maxPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'maxPyrodinFilter' cannot be null.");
        else if (maxPyrodinFilter !== undefined)
            url_ += "MaxPyrodinFilter=" + encodeURIComponent("" + maxPyrodinFilter) + "&";
        if (minPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'minPyrodinFilter' cannot be null.");
        else if (minPyrodinFilter !== undefined)
            url_ += "MinPyrodinFilter=" + encodeURIComponent("" + minPyrodinFilter) + "&";
        if (maxRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Lab_FRBFilter' cannot be null.");
        else if (maxRP_Lab_FRBFilter !== undefined)
            url_ += "MaxRP_Lab_FRBFilter=" + encodeURIComponent("" + maxRP_Lab_FRBFilter) + "&";
        if (minRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Lab_FRBFilter' cannot be null.");
        else if (minRP_Lab_FRBFilter !== undefined)
            url_ += "MinRP_Lab_FRBFilter=" + encodeURIComponent("" + minRP_Lab_FRBFilter) + "&";
        if (maxLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxLignina_FRBFilter' cannot be null.");
        else if (maxLignina_FRBFilter !== undefined)
            url_ += "MaxLignina_FRBFilter=" + encodeURIComponent("" + maxLignina_FRBFilter) + "&";
        if (minLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minLignina_FRBFilter' cannot be null.");
        else if (minLignina_FRBFilter !== undefined)
            url_ += "MinLignina_FRBFilter=" + encodeURIComponent("" + minLignina_FRBFilter) + "&";
        if (maxCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulosa_FRBFilter' cannot be null.");
        else if (maxCelulosa_FRBFilter !== undefined)
            url_ += "MaxCelulosa_FRBFilter=" + encodeURIComponent("" + maxCelulosa_FRBFilter) + "&";
        if (minCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minCelulosa_FRBFilter' cannot be null.");
        else if (minCelulosa_FRBFilter !== undefined)
            url_ += "MinCelulosa_FRBFilter=" + encodeURIComponent("" + minCelulosa_FRBFilter) + "&";
        if (maxEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxEXT_AC_FRBFilter' cannot be null.");
        else if (maxEXT_AC_FRBFilter !== undefined)
            url_ += "MaxEXT_AC_FRBFilter=" + encodeURIComponent("" + maxEXT_AC_FRBFilter) + "&";
        if (minEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minEXT_AC_FRBFilter' cannot be null.");
        else if (minEXT_AC_FRBFilter !== undefined)
            url_ += "MinEXT_AC_FRBFilter=" + encodeURIComponent("" + minEXT_AC_FRBFilter) + "&";
        if (maxConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'maxConsumo_AEFilter' cannot be null.");
        else if (maxConsumo_AEFilter !== undefined)
            url_ += "MaxConsumo_AEFilter=" + encodeURIComponent("" + maxConsumo_AEFilter) + "&";
        if (minConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'minConsumo_AEFilter' cannot be null.");
        else if (minConsumo_AEFilter !== undefined)
            url_ += "MinConsumo_AEFilter=" + encodeURIComponent("" + minConsumo_AEFilter) + "&";
        if (maxASHFilter === null)
            throw new globalThis.Error("The parameter 'maxASHFilter' cannot be null.");
        else if (maxASHFilter !== undefined)
            url_ += "MaxASHFilter=" + encodeURIComponent("" + maxASHFilter) + "&";
        if (minASHFilter === null)
            throw new globalThis.Error("The parameter 'minASHFilter' cannot be null.");
        else if (minASHFilter !== undefined)
            url_ += "MinASHFilter=" + encodeURIComponent("" + minASHFilter) + "&";
        if (maxExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'maxExtractivesFilter' cannot be null.");
        else if (maxExtractivesFilter !== undefined)
            url_ += "MaxExtractivesFilter=" + encodeURIComponent("" + maxExtractivesFilter) + "&";
        if (minExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'minExtractivesFilter' cannot be null.");
        else if (minExtractivesFilter !== undefined)
            url_ += "MinExtractivesFilter=" + encodeURIComponent("" + minExtractivesFilter) + "&";
        if (maxTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'maxTotal_LigninFilter' cannot be null.");
        else if (maxTotal_LigninFilter !== undefined)
            url_ += "MaxTotal_LigninFilter=" + encodeURIComponent("" + maxTotal_LigninFilter) + "&";
        if (minTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'minTotal_LigninFilter' cannot be null.");
        else if (minTotal_LigninFilter !== undefined)
            url_ += "MinTotal_LigninFilter=" + encodeURIComponent("" + minTotal_LigninFilter) + "&";
        if (maxCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulloseFilter' cannot be null.");
        else if (maxCelulloseFilter !== undefined)
            url_ += "MaxCelulloseFilter=" + encodeURIComponent("" + maxCelulloseFilter) + "&";
        if (minCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'minCelulloseFilter' cannot be null.");
        else if (minCelulloseFilter !== undefined)
            url_ += "MinCelulloseFilter=" + encodeURIComponent("" + minCelulloseFilter) + "&";
        if (maxGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'maxGlucomananFilter' cannot be null.");
        else if (maxGlucomananFilter !== undefined)
            url_ += "MaxGlucomananFilter=" + encodeURIComponent("" + maxGlucomananFilter) + "&";
        if (minGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'minGlucomananFilter' cannot be null.");
        else if (minGlucomananFilter !== undefined)
            url_ += "MinGlucomananFilter=" + encodeURIComponent("" + minGlucomananFilter) + "&";
        if (maxOthersFilter === null)
            throw new globalThis.Error("The parameter 'maxOthersFilter' cannot be null.");
        else if (maxOthersFilter !== undefined)
            url_ += "MaxOthersFilter=" + encodeURIComponent("" + maxOthersFilter) + "&";
        if (minOthersFilter === null)
            throw new globalThis.Error("The parameter 'minOthersFilter' cannot be null.");
        else if (minOthersFilter !== undefined)
            url_ += "MinOthersFilter=" + encodeURIComponent("" + minOthersFilter) + "&";
        if (maxAIFilter === null)
            throw new globalThis.Error("The parameter 'maxAIFilter' cannot be null.");
        else if (maxAIFilter !== undefined)
            url_ += "MaxAIFilter=" + encodeURIComponent("" + maxAIFilter) + "&";
        if (minAIFilter === null)
            throw new globalThis.Error("The parameter 'minAIFilter' cannot be null.");
        else if (minAIFilter !== undefined)
            url_ += "MinAIFilter=" + encodeURIComponent("" + minAIFilter) + "&";
        if (maxBaFilter === null)
            throw new globalThis.Error("The parameter 'maxBaFilter' cannot be null.");
        else if (maxBaFilter !== undefined)
            url_ += "MaxBaFilter=" + encodeURIComponent("" + maxBaFilter) + "&";
        if (minBaFilter === null)
            throw new globalThis.Error("The parameter 'minBaFilter' cannot be null.");
        else if (minBaFilter !== undefined)
            url_ += "MinBaFilter=" + encodeURIComponent("" + minBaFilter) + "&";
        if (maxCaFilter === null)
            throw new globalThis.Error("The parameter 'maxCaFilter' cannot be null.");
        else if (maxCaFilter !== undefined)
            url_ += "MaxCaFilter=" + encodeURIComponent("" + maxCaFilter) + "&";
        if (minCaFilter === null)
            throw new globalThis.Error("The parameter 'minCaFilter' cannot be null.");
        else if (minCaFilter !== undefined)
            url_ += "MinCaFilter=" + encodeURIComponent("" + minCaFilter) + "&";
        if (maxCuFilter === null)
            throw new globalThis.Error("The parameter 'maxCuFilter' cannot be null.");
        else if (maxCuFilter !== undefined)
            url_ += "MaxCuFilter=" + encodeURIComponent("" + maxCuFilter) + "&";
        if (minCuFilter === null)
            throw new globalThis.Error("The parameter 'minCuFilter' cannot be null.");
        else if (minCuFilter !== undefined)
            url_ += "MinCuFilter=" + encodeURIComponent("" + minCuFilter) + "&";
        if (maxFeFilter === null)
            throw new globalThis.Error("The parameter 'maxFeFilter' cannot be null.");
        else if (maxFeFilter !== undefined)
            url_ += "MaxFeFilter=" + encodeURIComponent("" + maxFeFilter) + "&";
        if (minFeFilter === null)
            throw new globalThis.Error("The parameter 'minFeFilter' cannot be null.");
        else if (minFeFilter !== undefined)
            url_ += "MinFeFilter=" + encodeURIComponent("" + minFeFilter) + "&";
        if (maxKFilter === null)
            throw new globalThis.Error("The parameter 'maxKFilter' cannot be null.");
        else if (maxKFilter !== undefined)
            url_ += "MaxKFilter=" + encodeURIComponent("" + maxKFilter) + "&";
        if (minKFilter === null)
            throw new globalThis.Error("The parameter 'minKFilter' cannot be null.");
        else if (minKFilter !== undefined)
            url_ += "MinKFilter=" + encodeURIComponent("" + minKFilter) + "&";
        if (maxMgFilter === null)
            throw new globalThis.Error("The parameter 'maxMgFilter' cannot be null.");
        else if (maxMgFilter !== undefined)
            url_ += "MaxMgFilter=" + encodeURIComponent("" + maxMgFilter) + "&";
        if (minMgFilter === null)
            throw new globalThis.Error("The parameter 'minMgFilter' cannot be null.");
        else if (minMgFilter !== undefined)
            url_ += "MinMgFilter=" + encodeURIComponent("" + minMgFilter) + "&";
        if (maxMnFilter === null)
            throw new globalThis.Error("The parameter 'maxMnFilter' cannot be null.");
        else if (maxMnFilter !== undefined)
            url_ += "MaxMnFilter=" + encodeURIComponent("" + maxMnFilter) + "&";
        if (minMnFilter === null)
            throw new globalThis.Error("The parameter 'minMnFilter' cannot be null.");
        else if (minMnFilter !== undefined)
            url_ += "MinMnFilter=" + encodeURIComponent("" + minMnFilter) + "&";
        if (maxNaFilter === null)
            throw new globalThis.Error("The parameter 'maxNaFilter' cannot be null.");
        else if (maxNaFilter !== undefined)
            url_ += "MaxNaFilter=" + encodeURIComponent("" + maxNaFilter) + "&";
        if (minNaFilter === null)
            throw new globalThis.Error("The parameter 'minNaFilter' cannot be null.");
        else if (minNaFilter !== undefined)
            url_ += "MinNaFilter=" + encodeURIComponent("" + minNaFilter) + "&";
        if (maxPFilter === null)
            throw new globalThis.Error("The parameter 'maxPFilter' cannot be null.");
        else if (maxPFilter !== undefined)
            url_ += "MaxPFilter=" + encodeURIComponent("" + maxPFilter) + "&";
        if (minPFilter === null)
            throw new globalThis.Error("The parameter 'minPFilter' cannot be null.");
        else if (minPFilter !== undefined)
            url_ += "MinPFilter=" + encodeURIComponent("" + minPFilter) + "&";
        if (maxSFilter === null)
            throw new globalThis.Error("The parameter 'maxSFilter' cannot be null.");
        else if (maxSFilter !== undefined)
            url_ += "MaxSFilter=" + encodeURIComponent("" + maxSFilter) + "&";
        if (minSFilter === null)
            throw new globalThis.Error("The parameter 'minSFilter' cannot be null.");
        else if (minSFilter !== undefined)
            url_ += "MinSFilter=" + encodeURIComponent("" + minSFilter) + "&";
        if (maxSiFilter === null)
            throw new globalThis.Error("The parameter 'maxSiFilter' cannot be null.");
        else if (maxSiFilter !== undefined)
            url_ += "MaxSiFilter=" + encodeURIComponent("" + maxSiFilter) + "&";
        if (minSiFilter === null)
            throw new globalThis.Error("The parameter 'minSiFilter' cannot be null.");
        else if (minSiFilter !== undefined)
            url_ += "MinSiFilter=" + encodeURIComponent("" + minSiFilter) + "&";
        if (maxXylanFilter === null)
            throw new globalThis.Error("The parameter 'maxXylanFilter' cannot be null.");
        else if (maxXylanFilter !== undefined)
            url_ += "MaxXylanFilter=" + encodeURIComponent("" + maxXylanFilter) + "&";
        if (minXylanFilter === null)
            throw new globalThis.Error("The parameter 'minXylanFilter' cannot be null.");
        else if (minXylanFilter !== undefined)
            url_ += "MinXylanFilter=" + encodeURIComponent("" + minXylanFilter) + "&";
        if (sub_ProyectoFilter === null)
            throw new globalThis.Error("The parameter 'sub_ProyectoFilter' cannot be null.");
        else if (sub_ProyectoFilter !== undefined)
            url_ += "Sub_ProyectoFilter=" + encodeURIComponent("" + sub_ProyectoFilter) + "&";
        if (typeMaterialFilter === null)
            throw new globalThis.Error("The parameter 'typeMaterialFilter' cannot be null.");
        else if (typeMaterialFilter !== undefined)
            url_ += "TypeMaterialFilter=" + encodeURIComponent("" + typeMaterialFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialOldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'trialOldTrialDenominationFilter' cannot be null.");
        else if (trialOldTrialDenominationFilter !== undefined)
            url_ += "TrialOldTrialDenominationFilter=" + encodeURIComponent("" + trialOldTrialDenominationFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treeStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'treeStatusNameFilter' cannot be null.");
        else if (treeStatusNameFilter !== undefined)
            url_ += "TreeStatusNameFilter=" + encodeURIComponent("" + treeStatusNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMesurementCloneEvaluationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMesurementCloneEvaluationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMesurementCloneEvaluationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMesurementCloneEvaluationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMesurementCloneEvaluationForView(id: number | undefined): Observable<GetMesurementCloneEvaluationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetMesurementCloneEvaluationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMesurementCloneEvaluationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMesurementCloneEvaluationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMesurementCloneEvaluationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMesurementCloneEvaluationForViewDto>;
        }));
    }

    protected processGetMesurementCloneEvaluationForView(response: HttpResponseBase): Observable<GetMesurementCloneEvaluationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMesurementCloneEvaluationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMesurementCloneEvaluationForEdit(id: number | undefined): Observable<GetMesurementCloneEvaluationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetMesurementCloneEvaluationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMesurementCloneEvaluationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMesurementCloneEvaluationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMesurementCloneEvaluationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMesurementCloneEvaluationForEditOutput>;
        }));
    }

    protected processGetMesurementCloneEvaluationForEdit(response: HttpResponseBase): Observable<GetMesurementCloneEvaluationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMesurementCloneEvaluationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditMesurementCloneEvaluationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBloqueFilter (optional) 
     * @param minBloqueFilter (optional) 
     * @param maxSubbloqueFilter (optional) 
     * @param minSubbloqueFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxFechaMuestreoFilter (optional) 
     * @param minFechaMuestreoFilter (optional) 
     * @param maxFechaPlantacionFilter (optional) 
     * @param minFechaPlantacionFilter (optional) 
     * @param maxEdadFilter (optional) 
     * @param minEdadFilter (optional) 
     * @param maxDB_labFilter (optional) 
     * @param minDB_labFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observacionFilter (optional) 
     * @param codigo_NirFilter (optional) 
     * @param maxDB_ModeloFilter (optional) 
     * @param minDB_ModeloFilter (optional) 
     * @param maxRP_ModeloFilter (optional) 
     * @param minRP_ModeloFilter (optional) 
     * @param maxPyrodinFilter (optional) 
     * @param minPyrodinFilter (optional) 
     * @param maxRP_Lab_FRBFilter (optional) 
     * @param minRP_Lab_FRBFilter (optional) 
     * @param maxLignina_FRBFilter (optional) 
     * @param minLignina_FRBFilter (optional) 
     * @param maxCelulosa_FRBFilter (optional) 
     * @param minCelulosa_FRBFilter (optional) 
     * @param maxEXT_AC_FRBFilter (optional) 
     * @param minEXT_AC_FRBFilter (optional) 
     * @param maxConsumo_AEFilter (optional) 
     * @param minConsumo_AEFilter (optional) 
     * @param maxASHFilter (optional) 
     * @param minASHFilter (optional) 
     * @param maxExtractivesFilter (optional) 
     * @param minExtractivesFilter (optional) 
     * @param maxTotal_LigninFilter (optional) 
     * @param minTotal_LigninFilter (optional) 
     * @param maxCelulloseFilter (optional) 
     * @param minCelulloseFilter (optional) 
     * @param maxGlucomananFilter (optional) 
     * @param minGlucomananFilter (optional) 
     * @param maxOthersFilter (optional) 
     * @param minOthersFilter (optional) 
     * @param maxAIFilter (optional) 
     * @param minAIFilter (optional) 
     * @param maxBaFilter (optional) 
     * @param minBaFilter (optional) 
     * @param maxCaFilter (optional) 
     * @param minCaFilter (optional) 
     * @param maxCuFilter (optional) 
     * @param minCuFilter (optional) 
     * @param maxFeFilter (optional) 
     * @param minFeFilter (optional) 
     * @param maxKFilter (optional) 
     * @param minKFilter (optional) 
     * @param maxMgFilter (optional) 
     * @param minMgFilter (optional) 
     * @param maxMnFilter (optional) 
     * @param minMnFilter (optional) 
     * @param maxNaFilter (optional) 
     * @param minNaFilter (optional) 
     * @param maxPFilter (optional) 
     * @param minPFilter (optional) 
     * @param maxSFilter (optional) 
     * @param minSFilter (optional) 
     * @param maxSiFilter (optional) 
     * @param minSiFilter (optional) 
     * @param maxXylanFilter (optional) 
     * @param minXylanFilter (optional) 
     * @param sub_ProyectoFilter (optional) 
     * @param typeMaterialFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialOldTrialDenominationFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treeStatusNameFilter (optional) 
     * @return OK
     */
    deleteMassiveCloneEvaluations(filter: string | undefined, maxBloqueFilter: number | undefined, minBloqueFilter: number | undefined, maxSubbloqueFilter: number | undefined, minSubbloqueFilter: number | undefined, maxYearFilter: number | undefined, minYearFilter: number | undefined, maxFechaMuestreoFilter: DateTime | undefined, minFechaMuestreoFilter: DateTime | undefined, maxFechaPlantacionFilter: DateTime | undefined, minFechaPlantacionFilter: DateTime | undefined, maxEdadFilter: number | undefined, minEdadFilter: number | undefined, maxDB_labFilter: number | undefined, minDB_labFilter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observacionFilter: string | undefined, codigo_NirFilter: string | undefined, maxDB_ModeloFilter: number | undefined, minDB_ModeloFilter: number | undefined, maxRP_ModeloFilter: number | undefined, minRP_ModeloFilter: number | undefined, maxPyrodinFilter: number | undefined, minPyrodinFilter: number | undefined, maxRP_Lab_FRBFilter: number | undefined, minRP_Lab_FRBFilter: number | undefined, maxLignina_FRBFilter: number | undefined, minLignina_FRBFilter: number | undefined, maxCelulosa_FRBFilter: number | undefined, minCelulosa_FRBFilter: number | undefined, maxEXT_AC_FRBFilter: number | undefined, minEXT_AC_FRBFilter: number | undefined, maxConsumo_AEFilter: number | undefined, minConsumo_AEFilter: number | undefined, maxASHFilter: number | undefined, minASHFilter: number | undefined, maxExtractivesFilter: number | undefined, minExtractivesFilter: number | undefined, maxTotal_LigninFilter: number | undefined, minTotal_LigninFilter: number | undefined, maxCelulloseFilter: number | undefined, minCelulloseFilter: number | undefined, maxGlucomananFilter: number | undefined, minGlucomananFilter: number | undefined, maxOthersFilter: number | undefined, minOthersFilter: number | undefined, maxAIFilter: number | undefined, minAIFilter: number | undefined, maxBaFilter: number | undefined, minBaFilter: number | undefined, maxCaFilter: number | undefined, minCaFilter: number | undefined, maxCuFilter: number | undefined, minCuFilter: number | undefined, maxFeFilter: number | undefined, minFeFilter: number | undefined, maxKFilter: number | undefined, minKFilter: number | undefined, maxMgFilter: number | undefined, minMgFilter: number | undefined, maxMnFilter: number | undefined, minMnFilter: number | undefined, maxNaFilter: number | undefined, minNaFilter: number | undefined, maxPFilter: number | undefined, minPFilter: number | undefined, maxSFilter: number | undefined, minSFilter: number | undefined, maxSiFilter: number | undefined, minSiFilter: number | undefined, maxXylanFilter: number | undefined, minXylanFilter: number | undefined, sub_ProyectoFilter: string | undefined, typeMaterialFilter: string | undefined, projectNameFilter: string | undefined, trialOldTrialDenominationFilter: string | undefined, treeSpecieFilter: string | undefined, seedBBSFilter: string | undefined, cloneBBXFilter: string | undefined, treeStatusNameFilter: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/DeleteMassiveCloneEvaluations?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxBloqueFilter' cannot be null.");
        else if (maxBloqueFilter !== undefined)
            url_ += "MaxBloqueFilter=" + encodeURIComponent("" + maxBloqueFilter) + "&";
        if (minBloqueFilter === null)
            throw new globalThis.Error("The parameter 'minBloqueFilter' cannot be null.");
        else if (minBloqueFilter !== undefined)
            url_ += "MinBloqueFilter=" + encodeURIComponent("" + minBloqueFilter) + "&";
        if (maxSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxSubbloqueFilter' cannot be null.");
        else if (maxSubbloqueFilter !== undefined)
            url_ += "MaxSubbloqueFilter=" + encodeURIComponent("" + maxSubbloqueFilter) + "&";
        if (minSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'minSubbloqueFilter' cannot be null.");
        else if (minSubbloqueFilter !== undefined)
            url_ += "MinSubbloqueFilter=" + encodeURIComponent("" + minSubbloqueFilter) + "&";
        if (maxYearFilter === null)
            throw new globalThis.Error("The parameter 'maxYearFilter' cannot be null.");
        else if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter === null)
            throw new globalThis.Error("The parameter 'minYearFilter' cannot be null.");
        else if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaMuestreoFilter' cannot be null.");
        else if (maxFechaMuestreoFilter !== undefined)
            url_ += "MaxFechaMuestreoFilter=" + encodeURIComponent(maxFechaMuestreoFilter ? "" + maxFechaMuestreoFilter.toString() : "") + "&";
        if (minFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaMuestreoFilter' cannot be null.");
        else if (minFechaMuestreoFilter !== undefined)
            url_ += "MinFechaMuestreoFilter=" + encodeURIComponent(minFechaMuestreoFilter ? "" + minFechaMuestreoFilter.toString() : "") + "&";
        if (maxFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaPlantacionFilter' cannot be null.");
        else if (maxFechaPlantacionFilter !== undefined)
            url_ += "MaxFechaPlantacionFilter=" + encodeURIComponent(maxFechaPlantacionFilter ? "" + maxFechaPlantacionFilter.toString() : "") + "&";
        if (minFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'minFechaPlantacionFilter' cannot be null.");
        else if (minFechaPlantacionFilter !== undefined)
            url_ += "MinFechaPlantacionFilter=" + encodeURIComponent(minFechaPlantacionFilter ? "" + minFechaPlantacionFilter.toString() : "") + "&";
        if (maxEdadFilter === null)
            throw new globalThis.Error("The parameter 'maxEdadFilter' cannot be null.");
        else if (maxEdadFilter !== undefined)
            url_ += "MaxEdadFilter=" + encodeURIComponent("" + maxEdadFilter) + "&";
        if (minEdadFilter === null)
            throw new globalThis.Error("The parameter 'minEdadFilter' cannot be null.");
        else if (minEdadFilter !== undefined)
            url_ += "MinEdadFilter=" + encodeURIComponent("" + minEdadFilter) + "&";
        if (maxDB_labFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_labFilter' cannot be null.");
        else if (maxDB_labFilter !== undefined)
            url_ += "MaxDB_labFilter=" + encodeURIComponent("" + maxDB_labFilter) + "&";
        if (minDB_labFilter === null)
            throw new globalThis.Error("The parameter 'minDB_labFilter' cannot be null.");
        else if (minDB_labFilter !== undefined)
            url_ += "MinDB_labFilter=" + encodeURIComponent("" + minDB_labFilter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observacionFilter === null)
            throw new globalThis.Error("The parameter 'observacionFilter' cannot be null.");
        else if (observacionFilter !== undefined)
            url_ += "ObservacionFilter=" + encodeURIComponent("" + observacionFilter) + "&";
        if (codigo_NirFilter === null)
            throw new globalThis.Error("The parameter 'codigo_NirFilter' cannot be null.");
        else if (codigo_NirFilter !== undefined)
            url_ += "codigo_NirFilter=" + encodeURIComponent("" + codigo_NirFilter) + "&";
        if (maxDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_ModeloFilter' cannot be null.");
        else if (maxDB_ModeloFilter !== undefined)
            url_ += "MaxDB_ModeloFilter=" + encodeURIComponent("" + maxDB_ModeloFilter) + "&";
        if (minDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minDB_ModeloFilter' cannot be null.");
        else if (minDB_ModeloFilter !== undefined)
            url_ += "MinDB_ModeloFilter=" + encodeURIComponent("" + minDB_ModeloFilter) + "&";
        if (maxRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_ModeloFilter' cannot be null.");
        else if (maxRP_ModeloFilter !== undefined)
            url_ += "MaxRP_ModeloFilter=" + encodeURIComponent("" + maxRP_ModeloFilter) + "&";
        if (minRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minRP_ModeloFilter' cannot be null.");
        else if (minRP_ModeloFilter !== undefined)
            url_ += "MinRP_ModeloFilter=" + encodeURIComponent("" + minRP_ModeloFilter) + "&";
        if (maxPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'maxPyrodinFilter' cannot be null.");
        else if (maxPyrodinFilter !== undefined)
            url_ += "MaxPyrodinFilter=" + encodeURIComponent("" + maxPyrodinFilter) + "&";
        if (minPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'minPyrodinFilter' cannot be null.");
        else if (minPyrodinFilter !== undefined)
            url_ += "MinPyrodinFilter=" + encodeURIComponent("" + minPyrodinFilter) + "&";
        if (maxRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Lab_FRBFilter' cannot be null.");
        else if (maxRP_Lab_FRBFilter !== undefined)
            url_ += "MaxRP_Lab_FRBFilter=" + encodeURIComponent("" + maxRP_Lab_FRBFilter) + "&";
        if (minRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Lab_FRBFilter' cannot be null.");
        else if (minRP_Lab_FRBFilter !== undefined)
            url_ += "MinRP_Lab_FRBFilter=" + encodeURIComponent("" + minRP_Lab_FRBFilter) + "&";
        if (maxLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxLignina_FRBFilter' cannot be null.");
        else if (maxLignina_FRBFilter !== undefined)
            url_ += "MaxLignina_FRBFilter=" + encodeURIComponent("" + maxLignina_FRBFilter) + "&";
        if (minLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minLignina_FRBFilter' cannot be null.");
        else if (minLignina_FRBFilter !== undefined)
            url_ += "MinLignina_FRBFilter=" + encodeURIComponent("" + minLignina_FRBFilter) + "&";
        if (maxCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulosa_FRBFilter' cannot be null.");
        else if (maxCelulosa_FRBFilter !== undefined)
            url_ += "MaxCelulosa_FRBFilter=" + encodeURIComponent("" + maxCelulosa_FRBFilter) + "&";
        if (minCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minCelulosa_FRBFilter' cannot be null.");
        else if (minCelulosa_FRBFilter !== undefined)
            url_ += "MinCelulosa_FRBFilter=" + encodeURIComponent("" + minCelulosa_FRBFilter) + "&";
        if (maxEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxEXT_AC_FRBFilter' cannot be null.");
        else if (maxEXT_AC_FRBFilter !== undefined)
            url_ += "MaxEXT_AC_FRBFilter=" + encodeURIComponent("" + maxEXT_AC_FRBFilter) + "&";
        if (minEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minEXT_AC_FRBFilter' cannot be null.");
        else if (minEXT_AC_FRBFilter !== undefined)
            url_ += "MinEXT_AC_FRBFilter=" + encodeURIComponent("" + minEXT_AC_FRBFilter) + "&";
        if (maxConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'maxConsumo_AEFilter' cannot be null.");
        else if (maxConsumo_AEFilter !== undefined)
            url_ += "MaxConsumo_AEFilter=" + encodeURIComponent("" + maxConsumo_AEFilter) + "&";
        if (minConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'minConsumo_AEFilter' cannot be null.");
        else if (minConsumo_AEFilter !== undefined)
            url_ += "MinConsumo_AEFilter=" + encodeURIComponent("" + minConsumo_AEFilter) + "&";
        if (maxASHFilter === null)
            throw new globalThis.Error("The parameter 'maxASHFilter' cannot be null.");
        else if (maxASHFilter !== undefined)
            url_ += "MaxASHFilter=" + encodeURIComponent("" + maxASHFilter) + "&";
        if (minASHFilter === null)
            throw new globalThis.Error("The parameter 'minASHFilter' cannot be null.");
        else if (minASHFilter !== undefined)
            url_ += "MinASHFilter=" + encodeURIComponent("" + minASHFilter) + "&";
        if (maxExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'maxExtractivesFilter' cannot be null.");
        else if (maxExtractivesFilter !== undefined)
            url_ += "MaxExtractivesFilter=" + encodeURIComponent("" + maxExtractivesFilter) + "&";
        if (minExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'minExtractivesFilter' cannot be null.");
        else if (minExtractivesFilter !== undefined)
            url_ += "MinExtractivesFilter=" + encodeURIComponent("" + minExtractivesFilter) + "&";
        if (maxTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'maxTotal_LigninFilter' cannot be null.");
        else if (maxTotal_LigninFilter !== undefined)
            url_ += "MaxTotal_LigninFilter=" + encodeURIComponent("" + maxTotal_LigninFilter) + "&";
        if (minTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'minTotal_LigninFilter' cannot be null.");
        else if (minTotal_LigninFilter !== undefined)
            url_ += "MinTotal_LigninFilter=" + encodeURIComponent("" + minTotal_LigninFilter) + "&";
        if (maxCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulloseFilter' cannot be null.");
        else if (maxCelulloseFilter !== undefined)
            url_ += "MaxCelulloseFilter=" + encodeURIComponent("" + maxCelulloseFilter) + "&";
        if (minCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'minCelulloseFilter' cannot be null.");
        else if (minCelulloseFilter !== undefined)
            url_ += "MinCelulloseFilter=" + encodeURIComponent("" + minCelulloseFilter) + "&";
        if (maxGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'maxGlucomananFilter' cannot be null.");
        else if (maxGlucomananFilter !== undefined)
            url_ += "MaxGlucomananFilter=" + encodeURIComponent("" + maxGlucomananFilter) + "&";
        if (minGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'minGlucomananFilter' cannot be null.");
        else if (minGlucomananFilter !== undefined)
            url_ += "MinGlucomananFilter=" + encodeURIComponent("" + minGlucomananFilter) + "&";
        if (maxOthersFilter === null)
            throw new globalThis.Error("The parameter 'maxOthersFilter' cannot be null.");
        else if (maxOthersFilter !== undefined)
            url_ += "MaxOthersFilter=" + encodeURIComponent("" + maxOthersFilter) + "&";
        if (minOthersFilter === null)
            throw new globalThis.Error("The parameter 'minOthersFilter' cannot be null.");
        else if (minOthersFilter !== undefined)
            url_ += "MinOthersFilter=" + encodeURIComponent("" + minOthersFilter) + "&";
        if (maxAIFilter === null)
            throw new globalThis.Error("The parameter 'maxAIFilter' cannot be null.");
        else if (maxAIFilter !== undefined)
            url_ += "MaxAIFilter=" + encodeURIComponent("" + maxAIFilter) + "&";
        if (minAIFilter === null)
            throw new globalThis.Error("The parameter 'minAIFilter' cannot be null.");
        else if (minAIFilter !== undefined)
            url_ += "MinAIFilter=" + encodeURIComponent("" + minAIFilter) + "&";
        if (maxBaFilter === null)
            throw new globalThis.Error("The parameter 'maxBaFilter' cannot be null.");
        else if (maxBaFilter !== undefined)
            url_ += "MaxBaFilter=" + encodeURIComponent("" + maxBaFilter) + "&";
        if (minBaFilter === null)
            throw new globalThis.Error("The parameter 'minBaFilter' cannot be null.");
        else if (minBaFilter !== undefined)
            url_ += "MinBaFilter=" + encodeURIComponent("" + minBaFilter) + "&";
        if (maxCaFilter === null)
            throw new globalThis.Error("The parameter 'maxCaFilter' cannot be null.");
        else if (maxCaFilter !== undefined)
            url_ += "MaxCaFilter=" + encodeURIComponent("" + maxCaFilter) + "&";
        if (minCaFilter === null)
            throw new globalThis.Error("The parameter 'minCaFilter' cannot be null.");
        else if (minCaFilter !== undefined)
            url_ += "MinCaFilter=" + encodeURIComponent("" + minCaFilter) + "&";
        if (maxCuFilter === null)
            throw new globalThis.Error("The parameter 'maxCuFilter' cannot be null.");
        else if (maxCuFilter !== undefined)
            url_ += "MaxCuFilter=" + encodeURIComponent("" + maxCuFilter) + "&";
        if (minCuFilter === null)
            throw new globalThis.Error("The parameter 'minCuFilter' cannot be null.");
        else if (minCuFilter !== undefined)
            url_ += "MinCuFilter=" + encodeURIComponent("" + minCuFilter) + "&";
        if (maxFeFilter === null)
            throw new globalThis.Error("The parameter 'maxFeFilter' cannot be null.");
        else if (maxFeFilter !== undefined)
            url_ += "MaxFeFilter=" + encodeURIComponent("" + maxFeFilter) + "&";
        if (minFeFilter === null)
            throw new globalThis.Error("The parameter 'minFeFilter' cannot be null.");
        else if (minFeFilter !== undefined)
            url_ += "MinFeFilter=" + encodeURIComponent("" + minFeFilter) + "&";
        if (maxKFilter === null)
            throw new globalThis.Error("The parameter 'maxKFilter' cannot be null.");
        else if (maxKFilter !== undefined)
            url_ += "MaxKFilter=" + encodeURIComponent("" + maxKFilter) + "&";
        if (minKFilter === null)
            throw new globalThis.Error("The parameter 'minKFilter' cannot be null.");
        else if (minKFilter !== undefined)
            url_ += "MinKFilter=" + encodeURIComponent("" + minKFilter) + "&";
        if (maxMgFilter === null)
            throw new globalThis.Error("The parameter 'maxMgFilter' cannot be null.");
        else if (maxMgFilter !== undefined)
            url_ += "MaxMgFilter=" + encodeURIComponent("" + maxMgFilter) + "&";
        if (minMgFilter === null)
            throw new globalThis.Error("The parameter 'minMgFilter' cannot be null.");
        else if (minMgFilter !== undefined)
            url_ += "MinMgFilter=" + encodeURIComponent("" + minMgFilter) + "&";
        if (maxMnFilter === null)
            throw new globalThis.Error("The parameter 'maxMnFilter' cannot be null.");
        else if (maxMnFilter !== undefined)
            url_ += "MaxMnFilter=" + encodeURIComponent("" + maxMnFilter) + "&";
        if (minMnFilter === null)
            throw new globalThis.Error("The parameter 'minMnFilter' cannot be null.");
        else if (minMnFilter !== undefined)
            url_ += "MinMnFilter=" + encodeURIComponent("" + minMnFilter) + "&";
        if (maxNaFilter === null)
            throw new globalThis.Error("The parameter 'maxNaFilter' cannot be null.");
        else if (maxNaFilter !== undefined)
            url_ += "MaxNaFilter=" + encodeURIComponent("" + maxNaFilter) + "&";
        if (minNaFilter === null)
            throw new globalThis.Error("The parameter 'minNaFilter' cannot be null.");
        else if (minNaFilter !== undefined)
            url_ += "MinNaFilter=" + encodeURIComponent("" + minNaFilter) + "&";
        if (maxPFilter === null)
            throw new globalThis.Error("The parameter 'maxPFilter' cannot be null.");
        else if (maxPFilter !== undefined)
            url_ += "MaxPFilter=" + encodeURIComponent("" + maxPFilter) + "&";
        if (minPFilter === null)
            throw new globalThis.Error("The parameter 'minPFilter' cannot be null.");
        else if (minPFilter !== undefined)
            url_ += "MinPFilter=" + encodeURIComponent("" + minPFilter) + "&";
        if (maxSFilter === null)
            throw new globalThis.Error("The parameter 'maxSFilter' cannot be null.");
        else if (maxSFilter !== undefined)
            url_ += "MaxSFilter=" + encodeURIComponent("" + maxSFilter) + "&";
        if (minSFilter === null)
            throw new globalThis.Error("The parameter 'minSFilter' cannot be null.");
        else if (minSFilter !== undefined)
            url_ += "MinSFilter=" + encodeURIComponent("" + minSFilter) + "&";
        if (maxSiFilter === null)
            throw new globalThis.Error("The parameter 'maxSiFilter' cannot be null.");
        else if (maxSiFilter !== undefined)
            url_ += "MaxSiFilter=" + encodeURIComponent("" + maxSiFilter) + "&";
        if (minSiFilter === null)
            throw new globalThis.Error("The parameter 'minSiFilter' cannot be null.");
        else if (minSiFilter !== undefined)
            url_ += "MinSiFilter=" + encodeURIComponent("" + minSiFilter) + "&";
        if (maxXylanFilter === null)
            throw new globalThis.Error("The parameter 'maxXylanFilter' cannot be null.");
        else if (maxXylanFilter !== undefined)
            url_ += "MaxXylanFilter=" + encodeURIComponent("" + maxXylanFilter) + "&";
        if (minXylanFilter === null)
            throw new globalThis.Error("The parameter 'minXylanFilter' cannot be null.");
        else if (minXylanFilter !== undefined)
            url_ += "MinXylanFilter=" + encodeURIComponent("" + minXylanFilter) + "&";
        if (sub_ProyectoFilter === null)
            throw new globalThis.Error("The parameter 'sub_ProyectoFilter' cannot be null.");
        else if (sub_ProyectoFilter !== undefined)
            url_ += "Sub_ProyectoFilter=" + encodeURIComponent("" + sub_ProyectoFilter) + "&";
        if (typeMaterialFilter === null)
            throw new globalThis.Error("The parameter 'typeMaterialFilter' cannot be null.");
        else if (typeMaterialFilter !== undefined)
            url_ += "TypeMaterialFilter=" + encodeURIComponent("" + typeMaterialFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialOldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'trialOldTrialDenominationFilter' cannot be null.");
        else if (trialOldTrialDenominationFilter !== undefined)
            url_ += "TrialOldTrialDenominationFilter=" + encodeURIComponent("" + trialOldTrialDenominationFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treeStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'treeStatusNameFilter' cannot be null.");
        else if (treeStatusNameFilter !== undefined)
            url_ += "TreeStatusNameFilter=" + encodeURIComponent("" + treeStatusNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveCloneEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveCloneEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveCloneEvaluations(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param proyectName (optional) 
     * @param samplingDate (optional) 
     * @return OK
     */
    deleteMeasurementCloneEvaluationsForProjectAndSampligDate(proyectName: string | undefined, samplingDate: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/DeleteMeasurementCloneEvaluationsForProjectAndSampligDate?";
        if (proyectName === null)
            throw new globalThis.Error("The parameter 'proyectName' cannot be null.");
        else if (proyectName !== undefined)
            url_ += "ProyectName=" + encodeURIComponent("" + proyectName) + "&";
        if (samplingDate === null)
            throw new globalThis.Error("The parameter 'samplingDate' cannot be null.");
        else if (samplingDate !== undefined)
            url_ += "SamplingDate=" + encodeURIComponent(samplingDate ? "" + samplingDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMeasurementCloneEvaluationsForProjectAndSampligDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMeasurementCloneEvaluationsForProjectAndSampligDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMeasurementCloneEvaluationsForProjectAndSampligDate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBloqueFilter (optional) 
     * @param minBloqueFilter (optional) 
     * @param maxSubbloqueFilter (optional) 
     * @param minSubbloqueFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxFechaMuestreoFilter (optional) 
     * @param minFechaMuestreoFilter (optional) 
     * @param maxFechaPlantacionFilter (optional) 
     * @param minFechaPlantacionFilter (optional) 
     * @param maxEdadFilter (optional) 
     * @param minEdadFilter (optional) 
     * @param maxDB_labFilter (optional) 
     * @param minDB_labFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param observacionFilter (optional) 
     * @param codigo_NirFilter (optional) 
     * @param maxDB_ModeloFilter (optional) 
     * @param minDB_ModeloFilter (optional) 
     * @param maxRP_ModeloFilter (optional) 
     * @param minRP_ModeloFilter (optional) 
     * @param maxPyrodinFilter (optional) 
     * @param minPyrodinFilter (optional) 
     * @param maxRP_Lab_FRBFilter (optional) 
     * @param minRP_Lab_FRBFilter (optional) 
     * @param maxLignina_FRBFilter (optional) 
     * @param minLignina_FRBFilter (optional) 
     * @param maxCelulosa_FRBFilter (optional) 
     * @param minCelulosa_FRBFilter (optional) 
     * @param maxEXT_AC_FRBFilter (optional) 
     * @param minEXT_AC_FRBFilter (optional) 
     * @param maxConsumo_AEFilter (optional) 
     * @param minConsumo_AEFilter (optional) 
     * @param maxASHFilter (optional) 
     * @param minASHFilter (optional) 
     * @param maxExtractivesFilter (optional) 
     * @param minExtractivesFilter (optional) 
     * @param maxTotal_LigninFilter (optional) 
     * @param minTotal_LigninFilter (optional) 
     * @param maxCelulloseFilter (optional) 
     * @param minCelulloseFilter (optional) 
     * @param maxGlucomananFilter (optional) 
     * @param minGlucomananFilter (optional) 
     * @param maxOthersFilter (optional) 
     * @param minOthersFilter (optional) 
     * @param maxAIFilter (optional) 
     * @param minAIFilter (optional) 
     * @param maxBaFilter (optional) 
     * @param minBaFilter (optional) 
     * @param maxCaFilter (optional) 
     * @param minCaFilter (optional) 
     * @param maxCuFilter (optional) 
     * @param minCuFilter (optional) 
     * @param maxFeFilter (optional) 
     * @param minFeFilter (optional) 
     * @param maxKFilter (optional) 
     * @param minKFilter (optional) 
     * @param maxMgFilter (optional) 
     * @param minMgFilter (optional) 
     * @param maxMnFilter (optional) 
     * @param minMnFilter (optional) 
     * @param maxNaFilter (optional) 
     * @param minNaFilter (optional) 
     * @param maxPFilter (optional) 
     * @param minPFilter (optional) 
     * @param maxSFilter (optional) 
     * @param minSFilter (optional) 
     * @param maxSiFilter (optional) 
     * @param minSiFilter (optional) 
     * @param maxXylanFilter (optional) 
     * @param minXylanFilter (optional) 
     * @param sub_ProyectoFilter (optional) 
     * @param typeMaterialFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialOldTrialDenominationFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treeStatusNameFilter (optional) 
     * @return OK
     */
    getMesurementCloneEvaluationsToExcel(filter: string | undefined, maxBloqueFilter: number | undefined, minBloqueFilter: number | undefined, maxSubbloqueFilter: number | undefined, minSubbloqueFilter: number | undefined, maxYearFilter: number | undefined, minYearFilter: number | undefined, maxFechaMuestreoFilter: DateTime | undefined, minFechaMuestreoFilter: DateTime | undefined, maxFechaPlantacionFilter: DateTime | undefined, minFechaPlantacionFilter: DateTime | undefined, maxEdadFilter: number | undefined, minEdadFilter: number | undefined, maxDB_labFilter: number | undefined, minDB_labFilter: number | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, observacionFilter: string | undefined, codigo_NirFilter: string | undefined, maxDB_ModeloFilter: number | undefined, minDB_ModeloFilter: number | undefined, maxRP_ModeloFilter: number | undefined, minRP_ModeloFilter: number | undefined, maxPyrodinFilter: number | undefined, minPyrodinFilter: number | undefined, maxRP_Lab_FRBFilter: number | undefined, minRP_Lab_FRBFilter: number | undefined, maxLignina_FRBFilter: number | undefined, minLignina_FRBFilter: number | undefined, maxCelulosa_FRBFilter: number | undefined, minCelulosa_FRBFilter: number | undefined, maxEXT_AC_FRBFilter: number | undefined, minEXT_AC_FRBFilter: number | undefined, maxConsumo_AEFilter: number | undefined, minConsumo_AEFilter: number | undefined, maxASHFilter: number | undefined, minASHFilter: number | undefined, maxExtractivesFilter: number | undefined, minExtractivesFilter: number | undefined, maxTotal_LigninFilter: number | undefined, minTotal_LigninFilter: number | undefined, maxCelulloseFilter: number | undefined, minCelulloseFilter: number | undefined, maxGlucomananFilter: number | undefined, minGlucomananFilter: number | undefined, maxOthersFilter: number | undefined, minOthersFilter: number | undefined, maxAIFilter: number | undefined, minAIFilter: number | undefined, maxBaFilter: number | undefined, minBaFilter: number | undefined, maxCaFilter: number | undefined, minCaFilter: number | undefined, maxCuFilter: number | undefined, minCuFilter: number | undefined, maxFeFilter: number | undefined, minFeFilter: number | undefined, maxKFilter: number | undefined, minKFilter: number | undefined, maxMgFilter: number | undefined, minMgFilter: number | undefined, maxMnFilter: number | undefined, minMnFilter: number | undefined, maxNaFilter: number | undefined, minNaFilter: number | undefined, maxPFilter: number | undefined, minPFilter: number | undefined, maxSFilter: number | undefined, minSFilter: number | undefined, maxSiFilter: number | undefined, minSiFilter: number | undefined, maxXylanFilter: number | undefined, minXylanFilter: number | undefined, sub_ProyectoFilter: string | undefined, typeMaterialFilter: string | undefined, projectNameFilter: string | undefined, trialOldTrialDenominationFilter: string | undefined, treeSpecieFilter: string | undefined, seedBBSFilter: string | undefined, cloneBBXFilter: string | undefined, treeStatusNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetMesurementCloneEvaluationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxBloqueFilter' cannot be null.");
        else if (maxBloqueFilter !== undefined)
            url_ += "MaxBloqueFilter=" + encodeURIComponent("" + maxBloqueFilter) + "&";
        if (minBloqueFilter === null)
            throw new globalThis.Error("The parameter 'minBloqueFilter' cannot be null.");
        else if (minBloqueFilter !== undefined)
            url_ += "MinBloqueFilter=" + encodeURIComponent("" + minBloqueFilter) + "&";
        if (maxSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'maxSubbloqueFilter' cannot be null.");
        else if (maxSubbloqueFilter !== undefined)
            url_ += "MaxSubbloqueFilter=" + encodeURIComponent("" + maxSubbloqueFilter) + "&";
        if (minSubbloqueFilter === null)
            throw new globalThis.Error("The parameter 'minSubbloqueFilter' cannot be null.");
        else if (minSubbloqueFilter !== undefined)
            url_ += "MinSubbloqueFilter=" + encodeURIComponent("" + minSubbloqueFilter) + "&";
        if (maxYearFilter === null)
            throw new globalThis.Error("The parameter 'maxYearFilter' cannot be null.");
        else if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter === null)
            throw new globalThis.Error("The parameter 'minYearFilter' cannot be null.");
        else if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaMuestreoFilter' cannot be null.");
        else if (maxFechaMuestreoFilter !== undefined)
            url_ += "MaxFechaMuestreoFilter=" + encodeURIComponent(maxFechaMuestreoFilter ? "" + maxFechaMuestreoFilter.toString() : "") + "&";
        if (minFechaMuestreoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaMuestreoFilter' cannot be null.");
        else if (minFechaMuestreoFilter !== undefined)
            url_ += "MinFechaMuestreoFilter=" + encodeURIComponent(minFechaMuestreoFilter ? "" + minFechaMuestreoFilter.toString() : "") + "&";
        if (maxFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaPlantacionFilter' cannot be null.");
        else if (maxFechaPlantacionFilter !== undefined)
            url_ += "MaxFechaPlantacionFilter=" + encodeURIComponent(maxFechaPlantacionFilter ? "" + maxFechaPlantacionFilter.toString() : "") + "&";
        if (minFechaPlantacionFilter === null)
            throw new globalThis.Error("The parameter 'minFechaPlantacionFilter' cannot be null.");
        else if (minFechaPlantacionFilter !== undefined)
            url_ += "MinFechaPlantacionFilter=" + encodeURIComponent(minFechaPlantacionFilter ? "" + minFechaPlantacionFilter.toString() : "") + "&";
        if (maxEdadFilter === null)
            throw new globalThis.Error("The parameter 'maxEdadFilter' cannot be null.");
        else if (maxEdadFilter !== undefined)
            url_ += "MaxEdadFilter=" + encodeURIComponent("" + maxEdadFilter) + "&";
        if (minEdadFilter === null)
            throw new globalThis.Error("The parameter 'minEdadFilter' cannot be null.");
        else if (minEdadFilter !== undefined)
            url_ += "MinEdadFilter=" + encodeURIComponent("" + minEdadFilter) + "&";
        if (maxDB_labFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_labFilter' cannot be null.");
        else if (maxDB_labFilter !== undefined)
            url_ += "MaxDB_labFilter=" + encodeURIComponent("" + maxDB_labFilter) + "&";
        if (minDB_labFilter === null)
            throw new globalThis.Error("The parameter 'minDB_labFilter' cannot be null.");
        else if (minDB_labFilter !== undefined)
            url_ += "MinDB_labFilter=" + encodeURIComponent("" + minDB_labFilter) + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (observacionFilter === null)
            throw new globalThis.Error("The parameter 'observacionFilter' cannot be null.");
        else if (observacionFilter !== undefined)
            url_ += "ObservacionFilter=" + encodeURIComponent("" + observacionFilter) + "&";
        if (codigo_NirFilter === null)
            throw new globalThis.Error("The parameter 'codigo_NirFilter' cannot be null.");
        else if (codigo_NirFilter !== undefined)
            url_ += "codigo_NirFilter=" + encodeURIComponent("" + codigo_NirFilter) + "&";
        if (maxDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_ModeloFilter' cannot be null.");
        else if (maxDB_ModeloFilter !== undefined)
            url_ += "MaxDB_ModeloFilter=" + encodeURIComponent("" + maxDB_ModeloFilter) + "&";
        if (minDB_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minDB_ModeloFilter' cannot be null.");
        else if (minDB_ModeloFilter !== undefined)
            url_ += "MinDB_ModeloFilter=" + encodeURIComponent("" + minDB_ModeloFilter) + "&";
        if (maxRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_ModeloFilter' cannot be null.");
        else if (maxRP_ModeloFilter !== undefined)
            url_ += "MaxRP_ModeloFilter=" + encodeURIComponent("" + maxRP_ModeloFilter) + "&";
        if (minRP_ModeloFilter === null)
            throw new globalThis.Error("The parameter 'minRP_ModeloFilter' cannot be null.");
        else if (minRP_ModeloFilter !== undefined)
            url_ += "MinRP_ModeloFilter=" + encodeURIComponent("" + minRP_ModeloFilter) + "&";
        if (maxPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'maxPyrodinFilter' cannot be null.");
        else if (maxPyrodinFilter !== undefined)
            url_ += "MaxPyrodinFilter=" + encodeURIComponent("" + maxPyrodinFilter) + "&";
        if (minPyrodinFilter === null)
            throw new globalThis.Error("The parameter 'minPyrodinFilter' cannot be null.");
        else if (minPyrodinFilter !== undefined)
            url_ += "MinPyrodinFilter=" + encodeURIComponent("" + minPyrodinFilter) + "&";
        if (maxRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxRP_Lab_FRBFilter' cannot be null.");
        else if (maxRP_Lab_FRBFilter !== undefined)
            url_ += "MaxRP_Lab_FRBFilter=" + encodeURIComponent("" + maxRP_Lab_FRBFilter) + "&";
        if (minRP_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minRP_Lab_FRBFilter' cannot be null.");
        else if (minRP_Lab_FRBFilter !== undefined)
            url_ += "MinRP_Lab_FRBFilter=" + encodeURIComponent("" + minRP_Lab_FRBFilter) + "&";
        if (maxLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxLignina_FRBFilter' cannot be null.");
        else if (maxLignina_FRBFilter !== undefined)
            url_ += "MaxLignina_FRBFilter=" + encodeURIComponent("" + maxLignina_FRBFilter) + "&";
        if (minLignina_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minLignina_FRBFilter' cannot be null.");
        else if (minLignina_FRBFilter !== undefined)
            url_ += "MinLignina_FRBFilter=" + encodeURIComponent("" + minLignina_FRBFilter) + "&";
        if (maxCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulosa_FRBFilter' cannot be null.");
        else if (maxCelulosa_FRBFilter !== undefined)
            url_ += "MaxCelulosa_FRBFilter=" + encodeURIComponent("" + maxCelulosa_FRBFilter) + "&";
        if (minCelulosa_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minCelulosa_FRBFilter' cannot be null.");
        else if (minCelulosa_FRBFilter !== undefined)
            url_ += "MinCelulosa_FRBFilter=" + encodeURIComponent("" + minCelulosa_FRBFilter) + "&";
        if (maxEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxEXT_AC_FRBFilter' cannot be null.");
        else if (maxEXT_AC_FRBFilter !== undefined)
            url_ += "MaxEXT_AC_FRBFilter=" + encodeURIComponent("" + maxEXT_AC_FRBFilter) + "&";
        if (minEXT_AC_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minEXT_AC_FRBFilter' cannot be null.");
        else if (minEXT_AC_FRBFilter !== undefined)
            url_ += "MinEXT_AC_FRBFilter=" + encodeURIComponent("" + minEXT_AC_FRBFilter) + "&";
        if (maxConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'maxConsumo_AEFilter' cannot be null.");
        else if (maxConsumo_AEFilter !== undefined)
            url_ += "MaxConsumo_AEFilter=" + encodeURIComponent("" + maxConsumo_AEFilter) + "&";
        if (minConsumo_AEFilter === null)
            throw new globalThis.Error("The parameter 'minConsumo_AEFilter' cannot be null.");
        else if (minConsumo_AEFilter !== undefined)
            url_ += "MinConsumo_AEFilter=" + encodeURIComponent("" + minConsumo_AEFilter) + "&";
        if (maxASHFilter === null)
            throw new globalThis.Error("The parameter 'maxASHFilter' cannot be null.");
        else if (maxASHFilter !== undefined)
            url_ += "MaxASHFilter=" + encodeURIComponent("" + maxASHFilter) + "&";
        if (minASHFilter === null)
            throw new globalThis.Error("The parameter 'minASHFilter' cannot be null.");
        else if (minASHFilter !== undefined)
            url_ += "MinASHFilter=" + encodeURIComponent("" + minASHFilter) + "&";
        if (maxExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'maxExtractivesFilter' cannot be null.");
        else if (maxExtractivesFilter !== undefined)
            url_ += "MaxExtractivesFilter=" + encodeURIComponent("" + maxExtractivesFilter) + "&";
        if (minExtractivesFilter === null)
            throw new globalThis.Error("The parameter 'minExtractivesFilter' cannot be null.");
        else if (minExtractivesFilter !== undefined)
            url_ += "MinExtractivesFilter=" + encodeURIComponent("" + minExtractivesFilter) + "&";
        if (maxTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'maxTotal_LigninFilter' cannot be null.");
        else if (maxTotal_LigninFilter !== undefined)
            url_ += "MaxTotal_LigninFilter=" + encodeURIComponent("" + maxTotal_LigninFilter) + "&";
        if (minTotal_LigninFilter === null)
            throw new globalThis.Error("The parameter 'minTotal_LigninFilter' cannot be null.");
        else if (minTotal_LigninFilter !== undefined)
            url_ += "MinTotal_LigninFilter=" + encodeURIComponent("" + minTotal_LigninFilter) + "&";
        if (maxCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'maxCelulloseFilter' cannot be null.");
        else if (maxCelulloseFilter !== undefined)
            url_ += "MaxCelulloseFilter=" + encodeURIComponent("" + maxCelulloseFilter) + "&";
        if (minCelulloseFilter === null)
            throw new globalThis.Error("The parameter 'minCelulloseFilter' cannot be null.");
        else if (minCelulloseFilter !== undefined)
            url_ += "MinCelulloseFilter=" + encodeURIComponent("" + minCelulloseFilter) + "&";
        if (maxGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'maxGlucomananFilter' cannot be null.");
        else if (maxGlucomananFilter !== undefined)
            url_ += "MaxGlucomananFilter=" + encodeURIComponent("" + maxGlucomananFilter) + "&";
        if (minGlucomananFilter === null)
            throw new globalThis.Error("The parameter 'minGlucomananFilter' cannot be null.");
        else if (minGlucomananFilter !== undefined)
            url_ += "MinGlucomananFilter=" + encodeURIComponent("" + minGlucomananFilter) + "&";
        if (maxOthersFilter === null)
            throw new globalThis.Error("The parameter 'maxOthersFilter' cannot be null.");
        else if (maxOthersFilter !== undefined)
            url_ += "MaxOthersFilter=" + encodeURIComponent("" + maxOthersFilter) + "&";
        if (minOthersFilter === null)
            throw new globalThis.Error("The parameter 'minOthersFilter' cannot be null.");
        else if (minOthersFilter !== undefined)
            url_ += "MinOthersFilter=" + encodeURIComponent("" + minOthersFilter) + "&";
        if (maxAIFilter === null)
            throw new globalThis.Error("The parameter 'maxAIFilter' cannot be null.");
        else if (maxAIFilter !== undefined)
            url_ += "MaxAIFilter=" + encodeURIComponent("" + maxAIFilter) + "&";
        if (minAIFilter === null)
            throw new globalThis.Error("The parameter 'minAIFilter' cannot be null.");
        else if (minAIFilter !== undefined)
            url_ += "MinAIFilter=" + encodeURIComponent("" + minAIFilter) + "&";
        if (maxBaFilter === null)
            throw new globalThis.Error("The parameter 'maxBaFilter' cannot be null.");
        else if (maxBaFilter !== undefined)
            url_ += "MaxBaFilter=" + encodeURIComponent("" + maxBaFilter) + "&";
        if (minBaFilter === null)
            throw new globalThis.Error("The parameter 'minBaFilter' cannot be null.");
        else if (minBaFilter !== undefined)
            url_ += "MinBaFilter=" + encodeURIComponent("" + minBaFilter) + "&";
        if (maxCaFilter === null)
            throw new globalThis.Error("The parameter 'maxCaFilter' cannot be null.");
        else if (maxCaFilter !== undefined)
            url_ += "MaxCaFilter=" + encodeURIComponent("" + maxCaFilter) + "&";
        if (minCaFilter === null)
            throw new globalThis.Error("The parameter 'minCaFilter' cannot be null.");
        else if (minCaFilter !== undefined)
            url_ += "MinCaFilter=" + encodeURIComponent("" + minCaFilter) + "&";
        if (maxCuFilter === null)
            throw new globalThis.Error("The parameter 'maxCuFilter' cannot be null.");
        else if (maxCuFilter !== undefined)
            url_ += "MaxCuFilter=" + encodeURIComponent("" + maxCuFilter) + "&";
        if (minCuFilter === null)
            throw new globalThis.Error("The parameter 'minCuFilter' cannot be null.");
        else if (minCuFilter !== undefined)
            url_ += "MinCuFilter=" + encodeURIComponent("" + minCuFilter) + "&";
        if (maxFeFilter === null)
            throw new globalThis.Error("The parameter 'maxFeFilter' cannot be null.");
        else if (maxFeFilter !== undefined)
            url_ += "MaxFeFilter=" + encodeURIComponent("" + maxFeFilter) + "&";
        if (minFeFilter === null)
            throw new globalThis.Error("The parameter 'minFeFilter' cannot be null.");
        else if (minFeFilter !== undefined)
            url_ += "MinFeFilter=" + encodeURIComponent("" + minFeFilter) + "&";
        if (maxKFilter === null)
            throw new globalThis.Error("The parameter 'maxKFilter' cannot be null.");
        else if (maxKFilter !== undefined)
            url_ += "MaxKFilter=" + encodeURIComponent("" + maxKFilter) + "&";
        if (minKFilter === null)
            throw new globalThis.Error("The parameter 'minKFilter' cannot be null.");
        else if (minKFilter !== undefined)
            url_ += "MinKFilter=" + encodeURIComponent("" + minKFilter) + "&";
        if (maxMgFilter === null)
            throw new globalThis.Error("The parameter 'maxMgFilter' cannot be null.");
        else if (maxMgFilter !== undefined)
            url_ += "MaxMgFilter=" + encodeURIComponent("" + maxMgFilter) + "&";
        if (minMgFilter === null)
            throw new globalThis.Error("The parameter 'minMgFilter' cannot be null.");
        else if (minMgFilter !== undefined)
            url_ += "MinMgFilter=" + encodeURIComponent("" + minMgFilter) + "&";
        if (maxMnFilter === null)
            throw new globalThis.Error("The parameter 'maxMnFilter' cannot be null.");
        else if (maxMnFilter !== undefined)
            url_ += "MaxMnFilter=" + encodeURIComponent("" + maxMnFilter) + "&";
        if (minMnFilter === null)
            throw new globalThis.Error("The parameter 'minMnFilter' cannot be null.");
        else if (minMnFilter !== undefined)
            url_ += "MinMnFilter=" + encodeURIComponent("" + minMnFilter) + "&";
        if (maxNaFilter === null)
            throw new globalThis.Error("The parameter 'maxNaFilter' cannot be null.");
        else if (maxNaFilter !== undefined)
            url_ += "MaxNaFilter=" + encodeURIComponent("" + maxNaFilter) + "&";
        if (minNaFilter === null)
            throw new globalThis.Error("The parameter 'minNaFilter' cannot be null.");
        else if (minNaFilter !== undefined)
            url_ += "MinNaFilter=" + encodeURIComponent("" + minNaFilter) + "&";
        if (maxPFilter === null)
            throw new globalThis.Error("The parameter 'maxPFilter' cannot be null.");
        else if (maxPFilter !== undefined)
            url_ += "MaxPFilter=" + encodeURIComponent("" + maxPFilter) + "&";
        if (minPFilter === null)
            throw new globalThis.Error("The parameter 'minPFilter' cannot be null.");
        else if (minPFilter !== undefined)
            url_ += "MinPFilter=" + encodeURIComponent("" + minPFilter) + "&";
        if (maxSFilter === null)
            throw new globalThis.Error("The parameter 'maxSFilter' cannot be null.");
        else if (maxSFilter !== undefined)
            url_ += "MaxSFilter=" + encodeURIComponent("" + maxSFilter) + "&";
        if (minSFilter === null)
            throw new globalThis.Error("The parameter 'minSFilter' cannot be null.");
        else if (minSFilter !== undefined)
            url_ += "MinSFilter=" + encodeURIComponent("" + minSFilter) + "&";
        if (maxSiFilter === null)
            throw new globalThis.Error("The parameter 'maxSiFilter' cannot be null.");
        else if (maxSiFilter !== undefined)
            url_ += "MaxSiFilter=" + encodeURIComponent("" + maxSiFilter) + "&";
        if (minSiFilter === null)
            throw new globalThis.Error("The parameter 'minSiFilter' cannot be null.");
        else if (minSiFilter !== undefined)
            url_ += "MinSiFilter=" + encodeURIComponent("" + minSiFilter) + "&";
        if (maxXylanFilter === null)
            throw new globalThis.Error("The parameter 'maxXylanFilter' cannot be null.");
        else if (maxXylanFilter !== undefined)
            url_ += "MaxXylanFilter=" + encodeURIComponent("" + maxXylanFilter) + "&";
        if (minXylanFilter === null)
            throw new globalThis.Error("The parameter 'minXylanFilter' cannot be null.");
        else if (minXylanFilter !== undefined)
            url_ += "MinXylanFilter=" + encodeURIComponent("" + minXylanFilter) + "&";
        if (sub_ProyectoFilter === null)
            throw new globalThis.Error("The parameter 'sub_ProyectoFilter' cannot be null.");
        else if (sub_ProyectoFilter !== undefined)
            url_ += "Sub_ProyectoFilter=" + encodeURIComponent("" + sub_ProyectoFilter) + "&";
        if (typeMaterialFilter === null)
            throw new globalThis.Error("The parameter 'typeMaterialFilter' cannot be null.");
        else if (typeMaterialFilter !== undefined)
            url_ += "TypeMaterialFilter=" + encodeURIComponent("" + typeMaterialFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialOldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'trialOldTrialDenominationFilter' cannot be null.");
        else if (trialOldTrialDenominationFilter !== undefined)
            url_ += "TrialOldTrialDenominationFilter=" + encodeURIComponent("" + trialOldTrialDenominationFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treeStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'treeStatusNameFilter' cannot be null.");
        else if (treeStatusNameFilter !== undefined)
            url_ += "TreeStatusNameFilter=" + encodeURIComponent("" + treeStatusNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMesurementCloneEvaluationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMesurementCloneEvaluationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMesurementCloneEvaluationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeStatusForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllTreeStatusForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeStatusForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeStatusForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto>;
        }));
    }

    protected processGetAllTreeStatusForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWoodSampleTypeForTableDropdown(): Observable<MeasurementCloneEvaluationWoodSampleTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/GetAllWoodSampleTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWoodSampleTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWoodSampleTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementCloneEvaluationWoodSampleTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementCloneEvaluationWoodSampleTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllWoodSampleTypeForTableDropdown(response: HttpResponseBase): Observable<MeasurementCloneEvaluationWoodSampleTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementCloneEvaluationWoodSampleTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMesurementCloneEvaluationsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/CreateMesurementCloneEvaluationsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMesurementCloneEvaluationsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMesurementCloneEvaluationsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateMesurementCloneEvaluationsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditMesurementCloneEvaluationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MesurementCloneEvaluations/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditMesurementCloneEvaluationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditMesurementCloneEvaluationDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditMesurementCloneEvaluationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditMesurementCloneEvaluationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MiniGardenMapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filterType (optional) 
     * @param canaletonFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getMiniGardenMapData(filterType: string | undefined, canaletonFilter: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MiniGardenMapDataDto> {
        let url_ = this.baseUrl + "/api/services/app/MiniGardenMap/GetMiniGardenMapData?";
        if (filterType === null)
            throw new globalThis.Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (canaletonFilter === null)
            throw new globalThis.Error("The parameter 'canaletonFilter' cannot be null.");
        else if (canaletonFilter !== undefined)
            url_ += "CanaletonFilter=" + encodeURIComponent("" + canaletonFilter) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMiniGardenMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMiniGardenMapData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MiniGardenMapDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MiniGardenMapDataDto>;
        }));
    }

    protected processGetMiniGardenMapData(response: HttpResponseBase): Observable<MiniGardenMapDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MiniGardenMapDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new globalThis.Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new globalThis.Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParametersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetParameterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetParameterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetParameterForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetParameterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetParameterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getParameterForView(id: number | undefined): Observable<GetParameterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/GetParameterForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParameterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParameterForViewDto>;
        }));
    }

    protected processGetParameterForView(response: HttpResponseBase): Observable<GetParameterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParameterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getParameterForEdit(id: number | undefined): Observable<GetParameterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/GetParameterForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParameterForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParameterForEditOutput>;
        }));
    }

    protected processGetParameterForEdit(response: HttpResponseBase): Observable<GetParameterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParameterForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditParameterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getParametersToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameters/GetParametersToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParametersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParametersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetParametersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PedigreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCloneForView(id: number | undefined): Observable<GetClonePedigreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Pedigree/GetCloneForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloneForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloneForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClonePedigreeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClonePedigreeForViewDto>;
        }));
    }

    protected processGetCloneForView(response: HttpResponseBase): Observable<GetClonePedigreeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClonePedigreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    getClonePedigreeToExcel(input: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Pedigree/GetClonePedigreeToExcel?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClonePedigreeToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClonePedigreeToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetClonePedigreeToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedForView(id: number | undefined): Observable<GetSeedPedigreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Pedigree/GetSeedForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedPedigreeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedPedigreeForViewDto>;
        }));
    }

    protected processGetSeedForView(response: HttpResponseBase): Observable<GetSeedPedigreeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedPedigreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedIds (optional) 
     * @return OK
     */
    getSeedPedigreeToExcel(seedIds: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Pedigree/GetSeedPedigreeToExcel?";
        if (seedIds === null)
            throw new globalThis.Error("The parameter 'seedIds' cannot be null.");
        else if (seedIds !== undefined)
            seedIds && seedIds.forEach(item => { url_ += "seedIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedPedigreeToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedPedigreeToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedPedigreeToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PestAndDiseasesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, nameFilter: string | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPestAndDiseaseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPestAndDiseaseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPestAndDiseaseForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPestAndDiseaseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPestAndDiseaseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, nameFilter: string | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPestAndDiseaseForView(id: number | undefined): Observable<GetPestAndDiseaseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/GetPestAndDiseaseForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPestAndDiseaseForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPestAndDiseaseForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPestAndDiseaseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPestAndDiseaseForViewDto>;
        }));
    }

    protected processGetPestAndDiseaseForView(response: HttpResponseBase): Observable<GetPestAndDiseaseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPestAndDiseaseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPestAndDiseaseForEdit(id: number | undefined): Observable<GetPestAndDiseaseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/GetPestAndDiseaseForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPestAndDiseaseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPestAndDiseaseForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPestAndDiseaseForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPestAndDiseaseForEditOutput>;
        }));
    }

    protected processGetPestAndDiseaseForEdit(response: HttpResponseBase): Observable<GetPestAndDiseaseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPestAndDiseaseForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditPestAndDiseaseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @return OK
     */
    getPestAndDiseasesToExcel(filter: string | undefined, nameFilter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/GetPestAndDiseasesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPestAndDiseasesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPestAndDiseasesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPestAndDiseasesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPestAndDiseaseFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/CreatePestAndDiseaseFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePestAndDiseaseFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePestAndDiseaseFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreatePestAndDiseaseFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditPestAndDiseaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PestAndDiseases/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPestAndDiseaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPestAndDiseaseDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditPestAndDiseaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditPestAndDiseaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlannedPlantationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param year (optional) 
     * @param regionId (optional) 
     * @param propertyId (optional) 
     * @param zoneId (optional) 
     * @param vendorId (optional) 
     * @param pendings (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPlannedPlantation(filter: string | undefined, year: string | undefined, regionId: number | undefined, propertyId: number | undefined, zoneId: number | undefined, vendorId: number | undefined, pendings: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlannedPlantationHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllPlannedPlantation?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "ZoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (vendorId === null)
            throw new globalThis.Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (pendings === null)
            throw new globalThis.Error("The parameter 'pendings' cannot be null.");
        else if (pendings !== undefined)
            url_ += "Pendings=" + encodeURIComponent("" + pendings) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlannedPlantation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlannedPlantation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPlannedPlantationHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPlannedPlantationHeaderDto>;
        }));
    }

    protected processGetAllPlannedPlantation(response: HttpResponseBase): Observable<PagedResultDtoOfPlannedPlantationHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlannedPlantationHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return OK
     */
    getAllYear(year: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllYear(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param region (optional) 
     * @return OK
     */
    getAllRegion(region: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllRegion?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param property (optional) 
     * @return OK
     */
    getAllProperty(property: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllProperty?";
        if (property === null)
            throw new globalThis.Error("The parameter 'property' cannot be null.");
        else if (property !== undefined)
            url_ += "property=" + encodeURIComponent("" + property) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllProperty(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zone (optional) 
     * @return OK
     */
    getAllZone(zone: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllZone?";
        if (zone === null)
            throw new globalThis.Error("The parameter 'zone' cannot be null.");
        else if (zone !== undefined)
            url_ += "zone=" + encodeURIComponent("" + zone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllZone(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vendor (optional) 
     * @return OK
     */
    getAllVendor(vendor: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedPlantation/GetAllVendor?";
        if (vendor === null)
            throw new globalThis.Error("The parameter 'vendor' cannot be null.");
        else if (vendor !== undefined)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllVendor(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlanningTreesToMeasuresServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllAdultObservationCodeForPWA(): Observable<AdultObservationCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllAdultObservationCodeForPWA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdultObservationCodeForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdultObservationCodeForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdultObservationCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdultObservationCodeDto[]>;
        }));
    }

    protected processGetAllAdultObservationCodeForPWA(response: HttpResponseBase): Observable<AdultObservationCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdultObservationCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllYoungObservationCodeForPWA(): Observable<YoungObservationCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllYoungObservationCodeForPWA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYoungObservationCodeForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYoungObservationCodeForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YoungObservationCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YoungObservationCodeDto[]>;
        }));
    }

    protected processGetAllYoungObservationCodeForPWA(response: HttpResponseBase): Observable<YoungObservationCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(YoungObservationCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllPestAndDiseaseCodeForPWA(): Observable<PestAndDiseaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllPestAndDiseaseCodeForPWA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPestAndDiseaseCodeForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPestAndDiseaseCodeForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PestAndDiseaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PestAndDiseaseDto[]>;
        }));
    }

    protected processGetAllPestAndDiseaseCodeForPWA(response: HttpResponseBase): Observable<PestAndDiseaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PestAndDiseaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllFrostToleranceCodeForPWA(): Observable<FrostToleranceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllFrostToleranceCodeForPWA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFrostToleranceCodeForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFrostToleranceCodeForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrostToleranceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrostToleranceDto[]>;
        }));
    }

    protected processGetAllFrostToleranceCodeForPWA(response: HttpResponseBase): Observable<FrostToleranceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FrostToleranceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllMeasurementPlaningForPWA(): Observable<GetMeasurementPlaningForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllMeasurementPlaningForPWA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningForViewDto[]>;
        }));
    }

    protected processGetAllMeasurementPlaningForPWA(response: HttpResponseBase): Observable<GetMeasurementPlaningForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMeasurementPlaningForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialObservations (optional) 
     * @param body (optional) 
     * @return OK
     */
    sync(trialObservations: string | undefined, body: TreeToMeasureDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/Sync?";
        if (trialObservations === null)
            throw new globalThis.Error("The parameter 'trialObservations' cannot be null.");
        else if (trialObservations !== undefined)
            url_ += "trialObservations=" + encodeURIComponent("" + trialObservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementPlaningId (optional) 
     * @return OK
     */
    getAllMeasurementPlaningOptionsForPWA(measurementPlaningId: number | undefined): Observable<GetMeasurementPlaningOptionsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllMeasurementPlaningOptionsForPWA?";
        if (measurementPlaningId === null)
            throw new globalThis.Error("The parameter 'measurementPlaningId' cannot be null.");
        else if (measurementPlaningId !== undefined)
            url_ += "measurementPlaningId=" + encodeURIComponent("" + measurementPlaningId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementPlaningOptionsForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementPlaningOptionsForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeasurementPlaningOptionsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeasurementPlaningOptionsForViewDto[]>;
        }));
    }

    protected processGetAllMeasurementPlaningOptionsForPWA(response: HttpResponseBase): Observable<GetMeasurementPlaningOptionsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMeasurementPlaningOptionsForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param planningId (optional) 
     * @return OK
     */
    setPlanningStatusToInMeasurement(planningId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/SetPlanningStatusToInMeasurement?";
        if (planningId === null)
            throw new globalThis.Error("The parameter 'planningId' cannot be null.");
        else if (planningId !== undefined)
            url_ += "planningId=" + encodeURIComponent("" + planningId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPlanningStatusToInMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPlanningStatusToInMeasurement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPlanningStatusToInMeasurement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementPlaningOptionId (optional) 
     * @return OK
     */
    getAllTreatmentForPWA(measurementPlaningOptionId: number | undefined): Observable<GetTreatmentForPWAViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllTreatmentForPWA?";
        if (measurementPlaningOptionId === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionId' cannot be null.");
        else if (measurementPlaningOptionId !== undefined)
            url_ += "measurementPlaningOptionId=" + encodeURIComponent("" + measurementPlaningOptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentForPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentForPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentForPWAViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentForPWAViewDto[]>;
        }));
    }

    protected processGetAllTreatmentForPWA(response: HttpResponseBase): Observable<GetTreatmentForPWAViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTreatmentForPWAViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measurementPlaningOptionsId (optional) 
     * @return OK
     */
    getAllTreesToMeasureForList(measurementPlaningOptionsId: number | undefined): Observable<TreeToMeasureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanningTreesToMeasures/GetAllTreesToMeasureForList?";
        if (measurementPlaningOptionsId === null)
            throw new globalThis.Error("The parameter 'measurementPlaningOptionsId' cannot be null.");
        else if (measurementPlaningOptionsId !== undefined)
            url_ += "measurementPlaningOptionsId=" + encodeURIComponent("" + measurementPlaningOptionsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreesToMeasureForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreesToMeasureForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeToMeasureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeToMeasureDto[]>;
        }));
    }

    protected processGetAllTreesToMeasureForList(response: HttpResponseBase): Observable<TreeToMeasureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeToMeasureDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolenMixturesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param bBPCompositionNameFilter (optional) 
     * @param maxPorcentageFilter (optional) 
     * @param minPorcentageFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, bBPCompositionNameFilter: string | undefined, maxPorcentageFilter: number | undefined, minPorcentageFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPolenMixtureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBPCompositionNameFilter === null)
            throw new globalThis.Error("The parameter 'bBPCompositionNameFilter' cannot be null.");
        else if (bBPCompositionNameFilter !== undefined)
            url_ += "BBPCompositionNameFilter=" + encodeURIComponent("" + bBPCompositionNameFilter) + "&";
        if (maxPorcentageFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentageFilter' cannot be null.");
        else if (maxPorcentageFilter !== undefined)
            url_ += "MaxPorcentageFilter=" + encodeURIComponent("" + maxPorcentageFilter) + "&";
        if (minPorcentageFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentageFilter' cannot be null.");
        else if (minPorcentageFilter !== undefined)
            url_ += "MinPorcentageFilter=" + encodeURIComponent("" + minPorcentageFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPolenMixtureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPolenMixtureForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPolenMixtureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPolenMixtureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenMixtureForView(id: number | undefined): Observable<GetPolenMixtureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/GetPolenMixtureForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenMixtureForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenMixtureForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenMixtureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenMixtureForViewDto>;
        }));
    }

    protected processGetPolenMixtureForView(response: HttpResponseBase): Observable<GetPolenMixtureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenMixtureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenMixtureForEdit(id: number | undefined): Observable<GetPolenMixtureForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/GetPolenMixtureForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenMixtureForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenMixtureForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenMixtureForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenMixtureForEditOutput>;
        }));
    }

    protected processGetPolenMixtureForEdit(response: HttpResponseBase): Observable<GetPolenMixtureForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenMixtureForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditPolenMixtureDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBPCompositionNameFilter (optional) 
     * @param maxPorcentageFilter (optional) 
     * @param minPorcentageFilter (optional) 
     * @return OK
     */
    getPolenMixturesToExcel(filter: string | undefined, bBPCompositionNameFilter: string | undefined, maxPorcentageFilter: number | undefined, minPorcentageFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenMixtures/GetPolenMixturesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBPCompositionNameFilter === null)
            throw new globalThis.Error("The parameter 'bBPCompositionNameFilter' cannot be null.");
        else if (bBPCompositionNameFilter !== undefined)
            url_ += "BBPCompositionNameFilter=" + encodeURIComponent("" + bBPCompositionNameFilter) + "&";
        if (maxPorcentageFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentageFilter' cannot be null.");
        else if (maxPorcentageFilter !== undefined)
            url_ += "MaxPorcentageFilter=" + encodeURIComponent("" + maxPorcentageFilter) + "&";
        if (minPorcentageFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentageFilter' cannot be null.");
        else if (minPorcentageFilter !== undefined)
            url_ += "MinPorcentageFilter=" + encodeURIComponent("" + minPorcentageFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenMixturesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenMixturesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPolenMixturesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolensServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param polenIdsFilter (optional) 
     * @param maxPolenNumberFilter (optional) 
     * @param minPolenNumberFilter (optional) 
     * @param physicalBBSTreeIdFilter (optional) 
     * @param bBSFilter (optional) 
     * @param physicalBBXTreeIdFilter (optional) 
     * @param bBXFilter (optional) 
     * @param originalTreeFilter (optional) 
     * @param idPolenHarvestFilter (optional) 
     * @param speciesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxInitialStockFilter (optional) 
     * @param minInitialStockFilter (optional) 
     * @param maxCurrentStockFilter (optional) 
     * @param minCurrentStockFilter (optional) 
     * @param stockLocationFilter (optional) 
     * @param observationsFilter (optional) 
     * @param isMixtureFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param polenMixtures (optional) 
     * @param siteOriginFilter (optional) 
     * @param withStock (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, polenIdsFilter: (number | undefined)[] | undefined, maxPolenNumberFilter: number | undefined, minPolenNumberFilter: number | undefined, physicalBBSTreeIdFilter: string | undefined, bBSFilter: string | undefined, physicalBBXTreeIdFilter: string | undefined, bBXFilter: string | undefined, originalTreeFilter: string | undefined, idPolenHarvestFilter: string | undefined, speciesFilter: string | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxInitialStockFilter: number | undefined, minInitialStockFilter: number | undefined, maxCurrentStockFilter: number | undefined, minCurrentStockFilter: number | undefined, stockLocationFilter: string | undefined, observationsFilter: string | undefined, isMixtureFilter: number | undefined, supplierNameFilter: string | undefined, trialStandNameFilter: string | undefined, polenMixtures: _definitions_PolenMixtureDto[] | undefined, siteOriginFilter: string | undefined, withStock: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPolenForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (polenIdsFilter === null)
            throw new globalThis.Error("The parameter 'polenIdsFilter' cannot be null.");
        else if (polenIdsFilter !== undefined)
            polenIdsFilter && polenIdsFilter.forEach(item => { url_ += "PolenIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxPolenNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxPolenNumberFilter' cannot be null.");
        else if (maxPolenNumberFilter !== undefined)
            url_ += "MaxPolenNumberFilter=" + encodeURIComponent("" + maxPolenNumberFilter) + "&";
        if (minPolenNumberFilter === null)
            throw new globalThis.Error("The parameter 'minPolenNumberFilter' cannot be null.");
        else if (minPolenNumberFilter !== undefined)
            url_ += "MinPolenNumberFilter=" + encodeURIComponent("" + minPolenNumberFilter) + "&";
        if (physicalBBSTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'physicalBBSTreeIdFilter' cannot be null.");
        else if (physicalBBSTreeIdFilter !== undefined)
            url_ += "PhysicalBBSTreeIdFilter=" + encodeURIComponent("" + physicalBBSTreeIdFilter) + "&";
        if (bBSFilter === null)
            throw new globalThis.Error("The parameter 'bBSFilter' cannot be null.");
        else if (bBSFilter !== undefined)
            url_ += "BBSFilter=" + encodeURIComponent("" + bBSFilter) + "&";
        if (physicalBBXTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'physicalBBXTreeIdFilter' cannot be null.");
        else if (physicalBBXTreeIdFilter !== undefined)
            url_ += "PhysicalBBXTreeIdFilter=" + encodeURIComponent("" + physicalBBXTreeIdFilter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (originalTreeFilter === null)
            throw new globalThis.Error("The parameter 'originalTreeFilter' cannot be null.");
        else if (originalTreeFilter !== undefined)
            url_ += "OriginalTreeFilter=" + encodeURIComponent("" + originalTreeFilter) + "&";
        if (idPolenHarvestFilter === null)
            throw new globalThis.Error("The parameter 'idPolenHarvestFilter' cannot be null.");
        else if (idPolenHarvestFilter !== undefined)
            url_ += "IdPolenHarvestFilter=" + encodeURIComponent("" + idPolenHarvestFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            url_ += "SpeciesFilter=" + encodeURIComponent("" + speciesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'maxInitialStockFilter' cannot be null.");
        else if (maxInitialStockFilter !== undefined)
            url_ += "MaxInitialStockFilter=" + encodeURIComponent("" + maxInitialStockFilter) + "&";
        if (minInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'minInitialStockFilter' cannot be null.");
        else if (minInitialStockFilter !== undefined)
            url_ += "MinInitialStockFilter=" + encodeURIComponent("" + minInitialStockFilter) + "&";
        if (maxCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'maxCurrentStockFilter' cannot be null.");
        else if (maxCurrentStockFilter !== undefined)
            url_ += "MaxCurrentStockFilter=" + encodeURIComponent("" + maxCurrentStockFilter) + "&";
        if (minCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'minCurrentStockFilter' cannot be null.");
        else if (minCurrentStockFilter !== undefined)
            url_ += "MinCurrentStockFilter=" + encodeURIComponent("" + minCurrentStockFilter) + "&";
        if (stockLocationFilter === null)
            throw new globalThis.Error("The parameter 'stockLocationFilter' cannot be null.");
        else if (stockLocationFilter !== undefined)
            url_ += "StockLocationFilter=" + encodeURIComponent("" + stockLocationFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (isMixtureFilter === null)
            throw new globalThis.Error("The parameter 'isMixtureFilter' cannot be null.");
        else if (isMixtureFilter !== undefined)
            url_ += "IsMixtureFilter=" + encodeURIComponent("" + isMixtureFilter) + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (polenMixtures === null)
            throw new globalThis.Error("The parameter 'polenMixtures' cannot be null.");
        else if (polenMixtures !== undefined)
            polenMixtures && polenMixtures.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PolenMixtures[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (siteOriginFilter === null)
            throw new globalThis.Error("The parameter 'siteOriginFilter' cannot be null.");
        else if (siteOriginFilter !== undefined)
            url_ += "SiteOriginFilter=" + encodeURIComponent("" + siteOriginFilter) + "&";
        if (withStock === null)
            throw new globalThis.Error("The parameter 'withStock' cannot be null.");
        else if (withStock !== undefined)
            url_ += "withStock=" + encodeURIComponent("" + withStock) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPolenForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPolenForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPolenForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPolenForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param polenFilter (optional) 
     * @return OK
     */
    getAllDistinctPolenIds(polenFilter: string | undefined): Observable<PolenDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllDistinctPolenIds?";
        if (polenFilter === null)
            throw new globalThis.Error("The parameter 'polenFilter' cannot be null.");
        else if (polenFilter !== undefined)
            url_ += "polenFilter=" + encodeURIComponent("" + polenFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctPolenIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctPolenIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolenDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolenDto[]>;
        }));
    }

    protected processGetAllDistinctPolenIds(response: HttpResponseBase): Observable<PolenDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolenDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbsFilter (optional) 
     * @return OK
     */
    getAllDistinctBBS(bbsFilter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllDistinctBBS?";
        if (bbsFilter === null)
            throw new globalThis.Error("The parameter 'bbsFilter' cannot be null.");
        else if (bbsFilter !== undefined)
            url_ += "bbsFilter=" + encodeURIComponent("" + bbsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDistinctBBS(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbxFilter (optional) 
     * @return OK
     */
    getAllDistinctBBX(bbxFilter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllDistinctBBX?";
        if (bbxFilter === null)
            throw new globalThis.Error("The parameter 'bbxFilter' cannot be null.");
        else if (bbxFilter !== undefined)
            url_ += "bbxFilter=" + encodeURIComponent("" + bbxFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDistinctBBX(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenForView(id: number | undefined): Observable<GetPolenForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetPolenForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenForViewDto>;
        }));
    }

    protected processGetPolenForView(response: HttpResponseBase): Observable<GetPolenForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenForEdit(id: number | undefined): Observable<GetPolenForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetPolenForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenForEditOutput>;
        }));
    }

    protected processGetPolenForEdit(response: HttpResponseBase): Observable<GetPolenForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditPolenDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Polens/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Polens/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param polenIdsFilter (optional) 
     * @param maxLoteNumberFilter (optional) 
     * @param minLoteNumberFilter (optional) 
     * @param bBSTreeIdFilter (optional) 
     * @param bBSFilter (optional) 
     * @param bBXTreeIdFilter (optional) 
     * @param bBXFilter (optional) 
     * @param bBTFilter (optional) 
     * @param idPolenHarvestFilter (optional) 
     * @param speciesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxInitialStockFilter (optional) 
     * @param minInitialStockFilter (optional) 
     * @param maxCurrentStockFilter (optional) 
     * @param minCurrentStockFilter (optional) 
     * @param stockLocationFilter (optional) 
     * @param observationsFilter (optional) 
     * @param isMixtureFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param polenMixtures (optional) 
     * @param siteOriginFilter (optional) 
     * @param withStock (optional) 
     * @return OK
     */
    deleteMassivePolen(filter: string | undefined, polenIdsFilter: (number | undefined)[] | undefined, maxLoteNumberFilter: number | undefined, minLoteNumberFilter: number | undefined, bBSTreeIdFilter: string | undefined, bBSFilter: string | undefined, bBXTreeIdFilter: string | undefined, bBXFilter: string | undefined, bBTFilter: string | undefined, idPolenHarvestFilter: string | undefined, speciesFilter: string | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxInitialStockFilter: number | undefined, minInitialStockFilter: number | undefined, maxCurrentStockFilter: number | undefined, minCurrentStockFilter: number | undefined, stockLocationFilter: string | undefined, observationsFilter: string | undefined, isMixtureFilter: number | undefined, supplierNameFilter: string | undefined, trialStandNameFilter: string | undefined, polenMixtures: _definitions_PolenMixtureDto[] | undefined, siteOriginFilter: string | undefined, withStock: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Polens/DeleteMassivePolen?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (polenIdsFilter === null)
            throw new globalThis.Error("The parameter 'polenIdsFilter' cannot be null.");
        else if (polenIdsFilter !== undefined)
            polenIdsFilter && polenIdsFilter.forEach(item => { url_ += "PolenIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxLoteNumberFilter' cannot be null.");
        else if (maxLoteNumberFilter !== undefined)
            url_ += "MaxLoteNumberFilter=" + encodeURIComponent("" + maxLoteNumberFilter) + "&";
        if (minLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'minLoteNumberFilter' cannot be null.");
        else if (minLoteNumberFilter !== undefined)
            url_ += "MinLoteNumberFilter=" + encodeURIComponent("" + minLoteNumberFilter) + "&";
        if (bBSTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'bBSTreeIdFilter' cannot be null.");
        else if (bBSTreeIdFilter !== undefined)
            url_ += "BBSTreeIdFilter=" + encodeURIComponent("" + bBSTreeIdFilter) + "&";
        if (bBSFilter === null)
            throw new globalThis.Error("The parameter 'bBSFilter' cannot be null.");
        else if (bBSFilter !== undefined)
            url_ += "BBSFilter=" + encodeURIComponent("" + bBSFilter) + "&";
        if (bBXTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'bBXTreeIdFilter' cannot be null.");
        else if (bBXTreeIdFilter !== undefined)
            url_ += "BBXTreeIdFilter=" + encodeURIComponent("" + bBXTreeIdFilter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (bBTFilter === null)
            throw new globalThis.Error("The parameter 'bBTFilter' cannot be null.");
        else if (bBTFilter !== undefined)
            url_ += "BBTFilter=" + encodeURIComponent("" + bBTFilter) + "&";
        if (idPolenHarvestFilter === null)
            throw new globalThis.Error("The parameter 'idPolenHarvestFilter' cannot be null.");
        else if (idPolenHarvestFilter !== undefined)
            url_ += "IdPolenHarvestFilter=" + encodeURIComponent("" + idPolenHarvestFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            url_ += "SpeciesFilter=" + encodeURIComponent("" + speciesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'maxInitialStockFilter' cannot be null.");
        else if (maxInitialStockFilter !== undefined)
            url_ += "MaxInitialStockFilter=" + encodeURIComponent("" + maxInitialStockFilter) + "&";
        if (minInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'minInitialStockFilter' cannot be null.");
        else if (minInitialStockFilter !== undefined)
            url_ += "MinInitialStockFilter=" + encodeURIComponent("" + minInitialStockFilter) + "&";
        if (maxCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'maxCurrentStockFilter' cannot be null.");
        else if (maxCurrentStockFilter !== undefined)
            url_ += "MaxCurrentStockFilter=" + encodeURIComponent("" + maxCurrentStockFilter) + "&";
        if (minCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'minCurrentStockFilter' cannot be null.");
        else if (minCurrentStockFilter !== undefined)
            url_ += "MinCurrentStockFilter=" + encodeURIComponent("" + minCurrentStockFilter) + "&";
        if (stockLocationFilter === null)
            throw new globalThis.Error("The parameter 'stockLocationFilter' cannot be null.");
        else if (stockLocationFilter !== undefined)
            url_ += "StockLocationFilter=" + encodeURIComponent("" + stockLocationFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (isMixtureFilter === null)
            throw new globalThis.Error("The parameter 'isMixtureFilter' cannot be null.");
        else if (isMixtureFilter !== undefined)
            url_ += "IsMixtureFilter=" + encodeURIComponent("" + isMixtureFilter) + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (polenMixtures === null)
            throw new globalThis.Error("The parameter 'polenMixtures' cannot be null.");
        else if (polenMixtures !== undefined)
            polenMixtures && polenMixtures.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PolenMixtures[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (siteOriginFilter === null)
            throw new globalThis.Error("The parameter 'siteOriginFilter' cannot be null.");
        else if (siteOriginFilter !== undefined)
            url_ += "SiteOriginFilter=" + encodeURIComponent("" + siteOriginFilter) + "&";
        if (withStock === null)
            throw new globalThis.Error("The parameter 'withStock' cannot be null.");
        else if (withStock !== undefined)
            url_ += "withStock=" + encodeURIComponent("" + withStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassivePolen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassivePolen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassivePolen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param polenIdsFilter (optional) 
     * @param maxPolenNumberFilter (optional) 
     * @param minPolenNumberFilter (optional) 
     * @param physicalBBSTreeIdFilter (optional) 
     * @param bBSFilter (optional) 
     * @param physicalBBXTreeIdFilter (optional) 
     * @param bBXFilter (optional) 
     * @param originalTreeFilter (optional) 
     * @param idPolenHarvestFilter (optional) 
     * @param speciesFilter (optional) 
     * @param maxHarvestDateFilter (optional) 
     * @param minHarvestDateFilter (optional) 
     * @param maxInitialStockFilter (optional) 
     * @param minInitialStockFilter (optional) 
     * @param maxCurrentStockFilter (optional) 
     * @param minCurrentStockFilter (optional) 
     * @param stockLocationFilter (optional) 
     * @param observationsFilter (optional) 
     * @param isMixtureFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param polenMixtures (optional) 
     * @param siteOriginFilter (optional) 
     * @param withStock (optional) 
     * @return OK
     */
    getPolensToExcel(filter: string | undefined, polenIdsFilter: (number | undefined)[] | undefined, maxPolenNumberFilter: number | undefined, minPolenNumberFilter: number | undefined, physicalBBSTreeIdFilter: string | undefined, bBSFilter: string | undefined, physicalBBXTreeIdFilter: string | undefined, bBXFilter: string | undefined, originalTreeFilter: string | undefined, idPolenHarvestFilter: string | undefined, speciesFilter: string | undefined, maxHarvestDateFilter: DateTime | undefined, minHarvestDateFilter: DateTime | undefined, maxInitialStockFilter: number | undefined, minInitialStockFilter: number | undefined, maxCurrentStockFilter: number | undefined, minCurrentStockFilter: number | undefined, stockLocationFilter: string | undefined, observationsFilter: string | undefined, isMixtureFilter: number | undefined, supplierNameFilter: string | undefined, trialStandNameFilter: string | undefined, polenMixtures: _definitions_PolenMixtureDto[] | undefined, siteOriginFilter: string | undefined, withStock: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetPolensToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (polenIdsFilter === null)
            throw new globalThis.Error("The parameter 'polenIdsFilter' cannot be null.");
        else if (polenIdsFilter !== undefined)
            polenIdsFilter && polenIdsFilter.forEach(item => { url_ += "PolenIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxPolenNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxPolenNumberFilter' cannot be null.");
        else if (maxPolenNumberFilter !== undefined)
            url_ += "MaxPolenNumberFilter=" + encodeURIComponent("" + maxPolenNumberFilter) + "&";
        if (minPolenNumberFilter === null)
            throw new globalThis.Error("The parameter 'minPolenNumberFilter' cannot be null.");
        else if (minPolenNumberFilter !== undefined)
            url_ += "MinPolenNumberFilter=" + encodeURIComponent("" + minPolenNumberFilter) + "&";
        if (physicalBBSTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'physicalBBSTreeIdFilter' cannot be null.");
        else if (physicalBBSTreeIdFilter !== undefined)
            url_ += "PhysicalBBSTreeIdFilter=" + encodeURIComponent("" + physicalBBSTreeIdFilter) + "&";
        if (bBSFilter === null)
            throw new globalThis.Error("The parameter 'bBSFilter' cannot be null.");
        else if (bBSFilter !== undefined)
            url_ += "BBSFilter=" + encodeURIComponent("" + bBSFilter) + "&";
        if (physicalBBXTreeIdFilter === null)
            throw new globalThis.Error("The parameter 'physicalBBXTreeIdFilter' cannot be null.");
        else if (physicalBBXTreeIdFilter !== undefined)
            url_ += "PhysicalBBXTreeIdFilter=" + encodeURIComponent("" + physicalBBXTreeIdFilter) + "&";
        if (bBXFilter === null)
            throw new globalThis.Error("The parameter 'bBXFilter' cannot be null.");
        else if (bBXFilter !== undefined)
            url_ += "BBXFilter=" + encodeURIComponent("" + bBXFilter) + "&";
        if (originalTreeFilter === null)
            throw new globalThis.Error("The parameter 'originalTreeFilter' cannot be null.");
        else if (originalTreeFilter !== undefined)
            url_ += "OriginalTreeFilter=" + encodeURIComponent("" + originalTreeFilter) + "&";
        if (idPolenHarvestFilter === null)
            throw new globalThis.Error("The parameter 'idPolenHarvestFilter' cannot be null.");
        else if (idPolenHarvestFilter !== undefined)
            url_ += "IdPolenHarvestFilter=" + encodeURIComponent("" + idPolenHarvestFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            url_ += "SpeciesFilter=" + encodeURIComponent("" + speciesFilter) + "&";
        if (maxHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'maxHarvestDateFilter' cannot be null.");
        else if (maxHarvestDateFilter !== undefined)
            url_ += "MaxHarvestDateFilter=" + encodeURIComponent(maxHarvestDateFilter ? "" + maxHarvestDateFilter.toString() : "") + "&";
        if (minHarvestDateFilter === null)
            throw new globalThis.Error("The parameter 'minHarvestDateFilter' cannot be null.");
        else if (minHarvestDateFilter !== undefined)
            url_ += "MinHarvestDateFilter=" + encodeURIComponent(minHarvestDateFilter ? "" + minHarvestDateFilter.toString() : "") + "&";
        if (maxInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'maxInitialStockFilter' cannot be null.");
        else if (maxInitialStockFilter !== undefined)
            url_ += "MaxInitialStockFilter=" + encodeURIComponent("" + maxInitialStockFilter) + "&";
        if (minInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'minInitialStockFilter' cannot be null.");
        else if (minInitialStockFilter !== undefined)
            url_ += "MinInitialStockFilter=" + encodeURIComponent("" + minInitialStockFilter) + "&";
        if (maxCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'maxCurrentStockFilter' cannot be null.");
        else if (maxCurrentStockFilter !== undefined)
            url_ += "MaxCurrentStockFilter=" + encodeURIComponent("" + maxCurrentStockFilter) + "&";
        if (minCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'minCurrentStockFilter' cannot be null.");
        else if (minCurrentStockFilter !== undefined)
            url_ += "MinCurrentStockFilter=" + encodeURIComponent("" + minCurrentStockFilter) + "&";
        if (stockLocationFilter === null)
            throw new globalThis.Error("The parameter 'stockLocationFilter' cannot be null.");
        else if (stockLocationFilter !== undefined)
            url_ += "StockLocationFilter=" + encodeURIComponent("" + stockLocationFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (isMixtureFilter === null)
            throw new globalThis.Error("The parameter 'isMixtureFilter' cannot be null.");
        else if (isMixtureFilter !== undefined)
            url_ += "IsMixtureFilter=" + encodeURIComponent("" + isMixtureFilter) + "&";
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            url_ += "SupplierNameFilter=" + encodeURIComponent("" + supplierNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (polenMixtures === null)
            throw new globalThis.Error("The parameter 'polenMixtures' cannot be null.");
        else if (polenMixtures !== undefined)
            polenMixtures && polenMixtures.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PolenMixtures[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (siteOriginFilter === null)
            throw new globalThis.Error("The parameter 'siteOriginFilter' cannot be null.");
        else if (siteOriginFilter !== undefined)
            url_ += "SiteOriginFilter=" + encodeURIComponent("" + siteOriginFilter) + "&";
        if (withStock === null)
            throw new globalThis.Error("The parameter 'withStock' cannot be null.");
        else if (withStock !== undefined)
            url_ += "withStock=" + encodeURIComponent("" + withStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolensToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolensToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPolensToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSupplierForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolenSupplierLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllSupplierForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupplierForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupplierForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolenSupplierLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolenSupplierLookupTableDto>;
        }));
    }

    protected processGetAllSupplierForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPolenSupplierLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolenSupplierLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolenTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolenTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolenTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPolenTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolenTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolenTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolenTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolenTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPolenTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolenTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPolenForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolenLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Polens/GetAllPolenForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolenForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolenForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolenLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolenLookupTableDto>;
        }));
    }

    protected processGetAllPolenForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPolenLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolenLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPolensFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Polens/CreatePolensFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePolensFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePolensFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreatePolensFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditPolenDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Polens/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPolenDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPolenDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditPolenDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditPolenDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolenStockMovementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param bBPFilter (optional) 
     * @param polenSpecieFilter (optional) 
     * @param stockTypeFilter (optional) 
     * @param progeniesStatesStateFilter (optional) 
     * @param maxUpdateDateFilter (optional) 
     * @param minUpdateDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, bBPFilter: string | undefined, polenSpecieFilter: string | undefined, stockTypeFilter: string | undefined, progeniesStatesStateFilter: string | undefined, maxUpdateDateFilter: DateTime | undefined, minUpdateDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPolenStockMovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBPFilter === null)
            throw new globalThis.Error("The parameter 'bBPFilter' cannot be null.");
        else if (bBPFilter !== undefined)
            url_ += "BBPFilter=" + encodeURIComponent("" + bBPFilter) + "&";
        if (polenSpecieFilter === null)
            throw new globalThis.Error("The parameter 'polenSpecieFilter' cannot be null.");
        else if (polenSpecieFilter !== undefined)
            url_ += "PolenSpecieFilter=" + encodeURIComponent("" + polenSpecieFilter) + "&";
        if (stockTypeFilter === null)
            throw new globalThis.Error("The parameter 'stockTypeFilter' cannot be null.");
        else if (stockTypeFilter !== undefined)
            url_ += "StockTypeFilter=" + encodeURIComponent("" + stockTypeFilter) + "&";
        if (progeniesStatesStateFilter === null)
            throw new globalThis.Error("The parameter 'progeniesStatesStateFilter' cannot be null.");
        else if (progeniesStatesStateFilter !== undefined)
            url_ += "ProgeniesStatesStateFilter=" + encodeURIComponent("" + progeniesStatesStateFilter) + "&";
        if (maxUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'maxUpdateDateFilter' cannot be null.");
        else if (maxUpdateDateFilter !== undefined)
            url_ += "MaxUpdateDateFilter=" + encodeURIComponent(maxUpdateDateFilter ? "" + maxUpdateDateFilter.toString() : "") + "&";
        if (minUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'minUpdateDateFilter' cannot be null.");
        else if (minUpdateDateFilter !== undefined)
            url_ += "MinUpdateDateFilter=" + encodeURIComponent(minUpdateDateFilter ? "" + minUpdateDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPolenStockMovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPolenStockMovementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPolenStockMovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPolenStockMovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenStockMovementForView(id: number | undefined): Observable<GetPolenStockMovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetPolenStockMovementForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenStockMovementForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenStockMovementForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenStockMovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenStockMovementForViewDto>;
        }));
    }

    protected processGetPolenStockMovementForView(response: HttpResponseBase): Observable<GetPolenStockMovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenStockMovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPolenStockMovementForEdit(id: number | undefined): Observable<GetPolenStockMovementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetPolenStockMovementForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenStockMovementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenStockMovementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolenStockMovementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolenStockMovementForEditOutput>;
        }));
    }

    protected processGetPolenStockMovementForEdit(response: HttpResponseBase): Observable<GetPolenStockMovementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolenStockMovementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditPolenStockMovementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bBPFilter (optional) 
     * @param polenSpecieFilter (optional) 
     * @param stockTypeFilter (optional) 
     * @param progeniesStatesStateFilter (optional) 
     * @param maxUpdateDateFilter (optional) 
     * @param minUpdateDateFilter (optional) 
     * @return OK
     */
    deleteMassive(bBPFilter: string | undefined, polenSpecieFilter: string | undefined, stockTypeFilter: string | undefined, progeniesStatesStateFilter: string | undefined, maxUpdateDateFilter: DateTime | undefined, minUpdateDateFilter: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/DeleteMassive?";
        if (bBPFilter === null)
            throw new globalThis.Error("The parameter 'bBPFilter' cannot be null.");
        else if (bBPFilter !== undefined)
            url_ += "BBPFilter=" + encodeURIComponent("" + bBPFilter) + "&";
        if (polenSpecieFilter === null)
            throw new globalThis.Error("The parameter 'polenSpecieFilter' cannot be null.");
        else if (polenSpecieFilter !== undefined)
            url_ += "PolenSpecieFilter=" + encodeURIComponent("" + polenSpecieFilter) + "&";
        if (stockTypeFilter === null)
            throw new globalThis.Error("The parameter 'stockTypeFilter' cannot be null.");
        else if (stockTypeFilter !== undefined)
            url_ += "StockTypeFilter=" + encodeURIComponent("" + stockTypeFilter) + "&";
        if (progeniesStatesStateFilter === null)
            throw new globalThis.Error("The parameter 'progeniesStatesStateFilter' cannot be null.");
        else if (progeniesStatesStateFilter !== undefined)
            url_ += "ProgeniesStatesStateFilter=" + encodeURIComponent("" + progeniesStatesStateFilter) + "&";
        if (maxUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'maxUpdateDateFilter' cannot be null.");
        else if (maxUpdateDateFilter !== undefined)
            url_ += "MaxUpdateDateFilter=" + encodeURIComponent(maxUpdateDateFilter ? "" + maxUpdateDateFilter.toString() : "") + "&";
        if (minUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'minUpdateDateFilter' cannot be null.");
        else if (minUpdateDateFilter !== undefined)
            url_ += "MinUpdateDateFilter=" + encodeURIComponent(minUpdateDateFilter ? "" + minUpdateDateFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMassive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bBPFilter (optional) 
     * @param polenSpecieFilter (optional) 
     * @param stockTypeFilter (optional) 
     * @param progeniesStatesStateFilter (optional) 
     * @param maxUpdateDateFilter (optional) 
     * @param minUpdateDateFilter (optional) 
     * @return OK
     */
    getPolenStockMovementsToExcel(filter: string | undefined, bBPFilter: string | undefined, polenSpecieFilter: string | undefined, stockTypeFilter: string | undefined, progeniesStatesStateFilter: string | undefined, maxUpdateDateFilter: DateTime | undefined, minUpdateDateFilter: DateTime | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetPolenStockMovementsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bBPFilter === null)
            throw new globalThis.Error("The parameter 'bBPFilter' cannot be null.");
        else if (bBPFilter !== undefined)
            url_ += "BBPFilter=" + encodeURIComponent("" + bBPFilter) + "&";
        if (polenSpecieFilter === null)
            throw new globalThis.Error("The parameter 'polenSpecieFilter' cannot be null.");
        else if (polenSpecieFilter !== undefined)
            url_ += "PolenSpecieFilter=" + encodeURIComponent("" + polenSpecieFilter) + "&";
        if (stockTypeFilter === null)
            throw new globalThis.Error("The parameter 'stockTypeFilter' cannot be null.");
        else if (stockTypeFilter !== undefined)
            url_ += "StockTypeFilter=" + encodeURIComponent("" + stockTypeFilter) + "&";
        if (progeniesStatesStateFilter === null)
            throw new globalThis.Error("The parameter 'progeniesStatesStateFilter' cannot be null.");
        else if (progeniesStatesStateFilter !== undefined)
            url_ += "ProgeniesStatesStateFilter=" + encodeURIComponent("" + progeniesStatesStateFilter) + "&";
        if (maxUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'maxUpdateDateFilter' cannot be null.");
        else if (maxUpdateDateFilter !== undefined)
            url_ += "MaxUpdateDateFilter=" + encodeURIComponent(maxUpdateDateFilter ? "" + maxUpdateDateFilter.toString() : "") + "&";
        if (minUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'minUpdateDateFilter' cannot be null.");
        else if (minUpdateDateFilter !== undefined)
            url_ += "MinUpdateDateFilter=" + encodeURIComponent(minUpdateDateFilter ? "" + minUpdateDateFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenStockMovementsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenStockMovementsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPolenStockMovementsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPolenStockMovementsTemplateToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetPolenStockMovementsTemplateToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenStockMovementsTemplateToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenStockMovementsTemplateToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPolenStockMovementsTemplateToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPolenStockMovementsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/CreatePolenStockMovementsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePolenStockMovementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePolenStockMovementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreatePolenStockMovementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbpFilter (optional) 
     * @return OK
     */
    getBBPFilter(bbpFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetBBPFilter?";
        if (bbpFilter === null)
            throw new globalThis.Error("The parameter 'bbpFilter' cannot be null.");
        else if (bbpFilter !== undefined)
            url_ += "bbpFilter=" + encodeURIComponent("" + bbpFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBBPFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBBPFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetBBPFilter(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stateFilter (optional) 
     * @return OK
     */
    getStateFilter(stateFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetStateFilter?";
        if (stateFilter === null)
            throw new globalThis.Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "stateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetStateFilter(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param specieFilter (optional) 
     * @return OK
     */
    getSpecieFilter(specieFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetSpecieFilter?";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "specieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecieFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecieFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetSpecieFilter(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPolenStockMovementStockType(): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetPolenStockMovementStockType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolenStockMovementStockType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolenStockMovementStockType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetPolenStockMovementStockType(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPolenForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolenStockDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetAllPolenForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolenForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolenForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolenStockDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolenStockDto>;
        }));
    }

    protected processGetAllPolenForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPolenStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolenStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProgenieStateForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGeneticLookupTableResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetAllProgenieStateForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgenieStateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgenieStateForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGeneticLookupTableResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGeneticLookupTableResponseDto>;
        }));
    }

    protected processGetAllProgenieStateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGeneticLookupTableResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGeneticLookupTableResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProgenieStateTwoForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGeneticLookupTableResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/PolenStockMovements/GetAllProgenieStateTwoForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgenieStateTwoForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgenieStateTwoForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGeneticLookupTableResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGeneticLookupTableResponseDto>;
        }));
    }

    protected processGetAllProgenieStateTwoForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGeneticLookupTableResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGeneticLookupTableResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PorcentajeBBXsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param destineFilter (optional) 
     * @param maxpercentageFilter (optional) 
     * @param minpercentageFilter (optional) 
     * @param dateHarvest (optional) 
     * @param cloneBBXFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, id: number | undefined, statusFilter: string | undefined, destineFilter: string | undefined, maxpercentageFilter: number | undefined, minpercentageFilter: number | undefined, dateHarvest: DateTime | undefined, cloneBBXFilter: string | undefined, measurementSelectionNumberTFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPorcentajeBBXForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (maxpercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxpercentageFilter' cannot be null.");
        else if (maxpercentageFilter !== undefined)
            url_ += "MaxpercentageFilter=" + encodeURIComponent("" + maxpercentageFilter) + "&";
        if (minpercentageFilter === null)
            throw new globalThis.Error("The parameter 'minpercentageFilter' cannot be null.");
        else if (minpercentageFilter !== undefined)
            url_ += "MinpercentageFilter=" + encodeURIComponent("" + minpercentageFilter) + "&";
        if (dateHarvest === null)
            throw new globalThis.Error("The parameter 'dateHarvest' cannot be null.");
        else if (dateHarvest !== undefined)
            url_ += "DateHarvest=" + encodeURIComponent(dateHarvest ? "" + dateHarvest.toString() : "") + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPorcentajeBBXForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPorcentajeBBXForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPorcentajeBBXForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPorcentajeBBXForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPorcentajeBBXForView(id: number | undefined): Observable<GetPorcentajeBBXForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetPorcentajeBBXForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPorcentajeBBXForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPorcentajeBBXForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPorcentajeBBXForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPorcentajeBBXForViewDto>;
        }));
    }

    protected processGetPorcentajeBBXForView(response: HttpResponseBase): Observable<GetPorcentajeBBXForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPorcentajeBBXForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPorcentajeBBXForEdit(id: number | undefined): Observable<GetPorcentajeBBXForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetPorcentajeBBXForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPorcentajeBBXForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPorcentajeBBXForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPorcentajeBBXForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPorcentajeBBXForEditOutput>;
        }));
    }

    protected processGetPorcentajeBBXForEdit(response: HttpResponseBase): Observable<GetPorcentajeBBXForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPorcentajeBBXForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGetID(body: CreateOrEditPorcentajeBBXDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/CreateGetID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGetID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGetID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateGetID(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditPorcentajeBBXDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param id (optional) 
     * @param statusFilter (optional) 
     * @param dateHarvest (optional) 
     * @param destineFilter (optional) 
     * @param maxpercentageFilter (optional) 
     * @param minpercentageFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @return OK
     */
    getPorcentajeBBXsToExcel(filter: string | undefined, id: number | undefined, statusFilter: string | undefined, dateHarvest: DateTime | undefined, destineFilter: string | undefined, maxpercentageFilter: number | undefined, minpercentageFilter: number | undefined, cloneBBXFilter: string | undefined, measurementSelectionNumberTFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetPorcentajeBBXsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (dateHarvest === null)
            throw new globalThis.Error("The parameter 'dateHarvest' cannot be null.");
        else if (dateHarvest !== undefined)
            url_ += "DateHarvest=" + encodeURIComponent(dateHarvest ? "" + dateHarvest.toString() : "") + "&";
        if (destineFilter === null)
            throw new globalThis.Error("The parameter 'destineFilter' cannot be null.");
        else if (destineFilter !== undefined)
            url_ += "DestineFilter=" + encodeURIComponent("" + destineFilter) + "&";
        if (maxpercentageFilter === null)
            throw new globalThis.Error("The parameter 'maxpercentageFilter' cannot be null.");
        else if (maxpercentageFilter !== undefined)
            url_ += "MaxpercentageFilter=" + encodeURIComponent("" + maxpercentageFilter) + "&";
        if (minpercentageFilter === null)
            throw new globalThis.Error("The parameter 'minpercentageFilter' cannot be null.");
        else if (minpercentageFilter !== undefined)
            url_ += "MinpercentageFilter=" + encodeURIComponent("" + minpercentageFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPorcentajeBBXsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPorcentajeBBXsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPorcentajeBBXsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPorcentajeBBXCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPorcentajeBBXCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPorcentajeBBXCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPorcentajeBBXCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPorcentajeBBXCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementSelectionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PorcentajeBBXs/GetAllMeasurementSelectionForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementSelectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementSelectionForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementSelectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username === null)
            throw new globalThis.Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProgeniesStatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProgeniesStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProgeniesStateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProgeniesStateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgeniesStateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProgeniesStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProgeniesStateForView(id: number | undefined): Observable<GetProgeniesStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/GetProgeniesStateForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgeniesStateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgeniesStateForViewDto>;
        }));
    }

    protected processGetProgeniesStateForView(response: HttpResponseBase): Observable<GetProgeniesStateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgeniesStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProgeniesStateForEdit(id: number | undefined): Observable<GetProgeniesStateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/GetProgeniesStateForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgeniesStateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgeniesStateForEditOutput>;
        }));
    }

    protected processGetProgeniesStateForEdit(response: HttpResponseBase): Observable<GetProgeniesStateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgeniesStateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditProgeniesStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getProgeniesStatesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStates/GetProgeniesStatesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStatesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProgeniesStatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProgeniesStatesTwoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProgeniesStateTwoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProgeniesStateTwoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProgeniesStateTwoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgeniesStateTwoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProgeniesStateTwoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProgeniesStateTwoForView(id: number | undefined): Observable<GetProgeniesStateTwoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/GetProgeniesStateTwoForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStateTwoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStateTwoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgeniesStateTwoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgeniesStateTwoForViewDto>;
        }));
    }

    protected processGetProgeniesStateTwoForView(response: HttpResponseBase): Observable<GetProgeniesStateTwoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgeniesStateTwoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProgeniesStateTwoForEdit(id: number | undefined): Observable<GetProgeniesStateTwoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/GetProgeniesStateTwoForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStateTwoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStateTwoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgeniesStateTwoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgeniesStateTwoForEditOutput>;
        }));
    }

    protected processGetProgeniesStateTwoForEdit(response: HttpResponseBase): Observable<GetProgeniesStateTwoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgeniesStateTwoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditProgeniesStateTwoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getProgeniesStateTwosToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProgeniesStatesTwo/GetProgeniesStateTwosToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgeniesStateTwosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgeniesStateTwosToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProgeniesStateTwosToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectConfigurationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxProm_SobFilter (optional) 
     * @param minProm_SobFilter (optional) 
     * @param maxProm_gravesFilter (optional) 
     * @param minProm_gravesFilter (optional) 
     * @param maxProm_Zvol_HaFilter (optional) 
     * @param minProm_Zvol_HaFilter (optional) 
     * @param maxRank_Zvol_HaFilter (optional) 
     * @param minRank_Zvol_HaFilter (optional) 
     * @param verEnCampoFilter (optional) 
     * @param isDiscoSelectionFilter (optional) 
     * @param isChipSelectionFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param projectFilter (optional) 
     * @param trialFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxProm_SobFilter: number | undefined, minProm_SobFilter: number | undefined, maxProm_gravesFilter: number | undefined, minProm_gravesFilter: number | undefined, maxProm_Zvol_HaFilter: number | undefined, minProm_Zvol_HaFilter: number | undefined, maxRank_Zvol_HaFilter: number | undefined, minRank_Zvol_HaFilter: number | undefined, verEnCampoFilter: number | undefined, isDiscoSelectionFilter: number | undefined, isChipSelectionFilter: number | undefined, cloneBBXFilter: string | undefined, seedBBSFilter: string | undefined, projectFilter: string | undefined, trialFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProjectConfigurationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxProm_SobFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_SobFilter' cannot be null.");
        else if (maxProm_SobFilter !== undefined)
            url_ += "MaxProm_SobFilter=" + encodeURIComponent("" + maxProm_SobFilter) + "&";
        if (minProm_SobFilter === null)
            throw new globalThis.Error("The parameter 'minProm_SobFilter' cannot be null.");
        else if (minProm_SobFilter !== undefined)
            url_ += "MinProm_SobFilter=" + encodeURIComponent("" + minProm_SobFilter) + "&";
        if (maxProm_gravesFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_gravesFilter' cannot be null.");
        else if (maxProm_gravesFilter !== undefined)
            url_ += "MaxProm_gravesFilter=" + encodeURIComponent("" + maxProm_gravesFilter) + "&";
        if (minProm_gravesFilter === null)
            throw new globalThis.Error("The parameter 'minProm_gravesFilter' cannot be null.");
        else if (minProm_gravesFilter !== undefined)
            url_ += "MinProm_gravesFilter=" + encodeURIComponent("" + minProm_gravesFilter) + "&";
        if (maxProm_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_Zvol_HaFilter' cannot be null.");
        else if (maxProm_Zvol_HaFilter !== undefined)
            url_ += "MaxProm_Zvol_HaFilter=" + encodeURIComponent("" + maxProm_Zvol_HaFilter) + "&";
        if (minProm_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'minProm_Zvol_HaFilter' cannot be null.");
        else if (minProm_Zvol_HaFilter !== undefined)
            url_ += "MinProm_Zvol_HaFilter=" + encodeURIComponent("" + minProm_Zvol_HaFilter) + "&";
        if (maxRank_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'maxRank_Zvol_HaFilter' cannot be null.");
        else if (maxRank_Zvol_HaFilter !== undefined)
            url_ += "MaxRank_Zvol_HaFilter=" + encodeURIComponent("" + maxRank_Zvol_HaFilter) + "&";
        if (minRank_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'minRank_Zvol_HaFilter' cannot be null.");
        else if (minRank_Zvol_HaFilter !== undefined)
            url_ += "MinRank_Zvol_HaFilter=" + encodeURIComponent("" + minRank_Zvol_HaFilter) + "&";
        if (verEnCampoFilter === null)
            throw new globalThis.Error("The parameter 'verEnCampoFilter' cannot be null.");
        else if (verEnCampoFilter !== undefined)
            url_ += "VerEnCampoFilter=" + encodeURIComponent("" + verEnCampoFilter) + "&";
        if (isDiscoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'isDiscoSelectionFilter' cannot be null.");
        else if (isDiscoSelectionFilter !== undefined)
            url_ += "IsDiscoSelectionFilter=" + encodeURIComponent("" + isDiscoSelectionFilter) + "&";
        if (isChipSelectionFilter === null)
            throw new globalThis.Error("The parameter 'isChipSelectionFilter' cannot be null.");
        else if (isChipSelectionFilter !== undefined)
            url_ += "IsChipSelectionFilter=" + encodeURIComponent("" + isChipSelectionFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (projectFilter === null)
            throw new globalThis.Error("The parameter 'projectFilter' cannot be null.");
        else if (projectFilter !== undefined)
            url_ += "ProjectFilter=" + encodeURIComponent("" + projectFilter) + "&";
        if (trialFilter === null)
            throw new globalThis.Error("The parameter 'trialFilter' cannot be null.");
        else if (trialFilter !== undefined)
            url_ += "TrialFilter=" + encodeURIComponent("" + trialFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProjectConfigurationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProjectConfigurationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProjectConfigurationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProjectConfigurationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProjectConfigurationForView(id: number | undefined): Observable<GetProjectConfigurationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetProjectConfigurationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectConfigurationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectConfigurationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectConfigurationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectConfigurationForViewDto>;
        }));
    }

    protected processGetProjectConfigurationForView(response: HttpResponseBase): Observable<GetProjectConfigurationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectConfigurationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProjectConfigurationForEdit(id: number | undefined): Observable<GetProjectConfigurationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetProjectConfigurationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectConfigurationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectConfigurationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectConfigurationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectConfigurationForEditOutput>;
        }));
    }

    protected processGetProjectConfigurationForEdit(response: HttpResponseBase): Observable<GetProjectConfigurationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectConfigurationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditProjectConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteProjectTreatment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/DeleteProjectTreatment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectTreatment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectTreatment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxProm_SobFilter (optional) 
     * @param minProm_SobFilter (optional) 
     * @param maxProm_gravesFilter (optional) 
     * @param minProm_gravesFilter (optional) 
     * @param maxProm_Zvol_HaFilter (optional) 
     * @param minProm_Zvol_HaFilter (optional) 
     * @param maxRank_Zvol_HaFilter (optional) 
     * @param minRank_Zvol_HaFilter (optional) 
     * @param verEnCampoFilter (optional) 
     * @param isDiscoSelectionFilter (optional) 
     * @param isChipSelectionFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param projectFilter (optional) 
     * @param trialFilter (optional) 
     * @param getTemplate (optional) 
     * @return OK
     */
    getProjectConfigurationsToExcel(filter: string | undefined, maxProm_SobFilter: number | undefined, minProm_SobFilter: number | undefined, maxProm_gravesFilter: number | undefined, minProm_gravesFilter: number | undefined, maxProm_Zvol_HaFilter: number | undefined, minProm_Zvol_HaFilter: number | undefined, maxRank_Zvol_HaFilter: number | undefined, minRank_Zvol_HaFilter: number | undefined, verEnCampoFilter: number | undefined, isDiscoSelectionFilter: number | undefined, isChipSelectionFilter: number | undefined, cloneBBXFilter: string | undefined, seedBBSFilter: string | undefined, projectFilter: string | undefined, trialFilter: string | undefined, getTemplate: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetProjectConfigurationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxProm_SobFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_SobFilter' cannot be null.");
        else if (maxProm_SobFilter !== undefined)
            url_ += "MaxProm_SobFilter=" + encodeURIComponent("" + maxProm_SobFilter) + "&";
        if (minProm_SobFilter === null)
            throw new globalThis.Error("The parameter 'minProm_SobFilter' cannot be null.");
        else if (minProm_SobFilter !== undefined)
            url_ += "MinProm_SobFilter=" + encodeURIComponent("" + minProm_SobFilter) + "&";
        if (maxProm_gravesFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_gravesFilter' cannot be null.");
        else if (maxProm_gravesFilter !== undefined)
            url_ += "MaxProm_gravesFilter=" + encodeURIComponent("" + maxProm_gravesFilter) + "&";
        if (minProm_gravesFilter === null)
            throw new globalThis.Error("The parameter 'minProm_gravesFilter' cannot be null.");
        else if (minProm_gravesFilter !== undefined)
            url_ += "MinProm_gravesFilter=" + encodeURIComponent("" + minProm_gravesFilter) + "&";
        if (maxProm_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'maxProm_Zvol_HaFilter' cannot be null.");
        else if (maxProm_Zvol_HaFilter !== undefined)
            url_ += "MaxProm_Zvol_HaFilter=" + encodeURIComponent("" + maxProm_Zvol_HaFilter) + "&";
        if (minProm_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'minProm_Zvol_HaFilter' cannot be null.");
        else if (minProm_Zvol_HaFilter !== undefined)
            url_ += "MinProm_Zvol_HaFilter=" + encodeURIComponent("" + minProm_Zvol_HaFilter) + "&";
        if (maxRank_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'maxRank_Zvol_HaFilter' cannot be null.");
        else if (maxRank_Zvol_HaFilter !== undefined)
            url_ += "MaxRank_Zvol_HaFilter=" + encodeURIComponent("" + maxRank_Zvol_HaFilter) + "&";
        if (minRank_Zvol_HaFilter === null)
            throw new globalThis.Error("The parameter 'minRank_Zvol_HaFilter' cannot be null.");
        else if (minRank_Zvol_HaFilter !== undefined)
            url_ += "MinRank_Zvol_HaFilter=" + encodeURIComponent("" + minRank_Zvol_HaFilter) + "&";
        if (verEnCampoFilter === null)
            throw new globalThis.Error("The parameter 'verEnCampoFilter' cannot be null.");
        else if (verEnCampoFilter !== undefined)
            url_ += "VerEnCampoFilter=" + encodeURIComponent("" + verEnCampoFilter) + "&";
        if (isDiscoSelectionFilter === null)
            throw new globalThis.Error("The parameter 'isDiscoSelectionFilter' cannot be null.");
        else if (isDiscoSelectionFilter !== undefined)
            url_ += "IsDiscoSelectionFilter=" + encodeURIComponent("" + isDiscoSelectionFilter) + "&";
        if (isChipSelectionFilter === null)
            throw new globalThis.Error("The parameter 'isChipSelectionFilter' cannot be null.");
        else if (isChipSelectionFilter !== undefined)
            url_ += "IsChipSelectionFilter=" + encodeURIComponent("" + isChipSelectionFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (projectFilter === null)
            throw new globalThis.Error("The parameter 'projectFilter' cannot be null.");
        else if (projectFilter !== undefined)
            url_ += "ProjectFilter=" + encodeURIComponent("" + projectFilter) + "&";
        if (trialFilter === null)
            throw new globalThis.Error("The parameter 'trialFilter' cannot be null.");
        else if (trialFilter !== undefined)
            url_ += "TrialFilter=" + encodeURIComponent("" + trialFilter) + "&";
        if (getTemplate === null)
            throw new globalThis.Error("The parameter 'getTemplate' cannot be null.");
        else if (getTemplate !== undefined)
            url_ += "GetTemplate=" + encodeURIComponent("" + getTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectConfigurationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectConfigurationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProjectConfigurationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfProjectConfigurationSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProjectConfigurationSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProjectConfigurationSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfProjectConfigurationSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectConfigurationSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cloneBBXFilter (optional) 
     * @return OK
     */
    getAllCloneBBXByName(cloneBBXFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetAllCloneBBXByName?";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "cloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneBBXByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneBBXByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllCloneBBXByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedBBSFilter (optional) 
     * @return OK
     */
    getAllSeedBBSByName(seedBBSFilter: string | undefined): Observable<GetGeneticFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/GetAllSeedBBSByName?";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "seedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedBBSByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedBBSByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneticFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneticFilterDto[]>;
        }));
    }

    protected processGetAllSeedBBSByName(response: HttpResponseBase): Observable<GetGeneticFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGeneticFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importR3SheetFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/ImportR3SheetFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportR3SheetFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportR3SheetFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportR3SheetFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addBBXOrBBSToR3ProjectFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProjectConfigurations/AddBBXOrBBSToR3ProjectFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBBXOrBBSToR3ProjectFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBBXOrBBSToR3ProjectFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processAddBBXOrBBSToR3ProjectFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMeasurementSelectionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMeasurementSelectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectNameFilter (optional) 
     * @param laboratoryProjectStatusNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjects(filter: string | undefined, nameFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectNameFilter: string | undefined, laboratoryProjectStatusNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetAllProjects?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectNameFilter' cannot be null.");
        else if (laboratoryProjectNameFilter !== undefined)
            url_ += "LaboratoryProjectNameFilter=" + encodeURIComponent("" + laboratoryProjectNameFilter) + "&";
        if (laboratoryProjectStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusNameFilter' cannot be null.");
        else if (laboratoryProjectStatusNameFilter !== undefined)
            url_ += "LaboratoryProjectStatusNameFilter=" + encodeURIComponent("" + laboratoryProjectStatusNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProjectForViewDto>;
        }));
    }

    protected processGetAllProjects(response: HttpResponseBase): Observable<PagedResultDtoOfGetProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProjectForView(id: number | undefined): Observable<GetProjectForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetProjectForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectForViewDto>;
        }));
    }

    protected processGetProjectForView(response: HttpResponseBase): Observable<GetProjectForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getProjectForEdit(id: number | undefined): Observable<GetProjectForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetProjectForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectForEditOutput>;
        }));
    }

    protected processGetProjectForEdit(response: HttpResponseBase): Observable<GetProjectForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditProjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Projects/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Projects/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTreeFromR1Project(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Projects/DeleteTreeFromR1Project?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTreeFromR1Project(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTreeFromR1Project(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTreeFromR1Project(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTreeFromR2Project(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Projects/DeleteTreeFromR2Project?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTreeFromR2Project(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTreeFromR2Project(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTreeFromR2Project(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameIdsFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectTypesIdsFilter (optional) 
     * @param laboratoryProjectStatusIdsFilter (optional) 
     * @return OK
     */
    getProjectsToExcel(filter: string | undefined, projectNameIdsFilter: number[] | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectTypesIdsFilter: number[] | undefined, laboratoryProjectStatusIdsFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetProjectsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameIdsFilter === null)
            throw new globalThis.Error("The parameter 'projectNameIdsFilter' cannot be null.");
        else if (projectNameIdsFilter !== undefined)
            projectNameIdsFilter && projectNameIdsFilter.forEach(item => { url_ += "ProjectNameIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectTypesIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectTypesIdsFilter' cannot be null.");
        else if (laboratoryProjectTypesIdsFilter !== undefined)
            laboratoryProjectTypesIdsFilter && laboratoryProjectTypesIdsFilter.forEach(item => { url_ += "LaboratoryProjectTypesIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (laboratoryProjectStatusIdsFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusIdsFilter' cannot be null.");
        else if (laboratoryProjectStatusIdsFilter !== undefined)
            laboratoryProjectStatusIdsFilter && laboratoryProjectStatusIdsFilter.forEach(item => { url_ += "LaboratoryProjectStatusIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProjectsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param laboratoryProjectNameFilter (optional) 
     * @param laboratoryProjectStatusNameFilter (optional) 
     * @return OK
     */
    getOtherProjectsToExcel(filter: string | undefined, nameFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, laboratoryProjectNameFilter: string | undefined, laboratoryProjectStatusNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetOtherProjectsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (laboratoryProjectNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectNameFilter' cannot be null.");
        else if (laboratoryProjectNameFilter !== undefined)
            url_ += "LaboratoryProjectNameFilter=" + encodeURIComponent("" + laboratoryProjectNameFilter) + "&";
        if (laboratoryProjectStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'laboratoryProjectStatusNameFilter' cannot be null.");
        else if (laboratoryProjectStatusNameFilter !== undefined)
            url_ += "LaboratoryProjectStatusNameFilter=" + encodeURIComponent("" + laboratoryProjectStatusNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherProjectsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherProjectsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOtherProjectsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLaboratoryProjectForTableDropdown(): Observable<ProjectLaboratoryProjectLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetAllLaboratoryProjectForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLaboratoryProjectLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLaboratoryProjectLookupTableDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectForTableDropdown(response: HttpResponseBase): Observable<ProjectLaboratoryProjectLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectLaboratoryProjectLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLaboratoryProjectStatusForTableDropdown(): Observable<ProjectLaboratoryProjectStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Projects/GetAllLaboratoryProjectStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLaboratoryProjectStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLaboratoryProjectStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLaboratoryProjectStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLaboratoryProjectStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllLaboratoryProjectStatusForTableDropdown(response: HttpResponseBase): Observable<ProjectLaboratoryProjectStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectLaboratoryProjectStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/CreateProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateProjectsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOtherProjectsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/CreateOtherProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOtherProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOtherProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateOtherProjectsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportOtherProjectsFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportOtherProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportOtherProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportOtherProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto[]>;
        }));
    }

    protected processOnPostImportOtherProjectsFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importR2SheetFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/ImportR2SheetFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportR2SheetFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportR2SheetFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportR2SheetFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportR2FromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportR2FromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportR2FromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportR2FromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processOnPostImportR2FromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTreesToExistingR1ProjectsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/AddTreesToExistingR1ProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTreesToExistingR1ProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTreesToExistingR1ProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processAddTreesToExistingR1ProjectsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportR1TreesFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportR1TreesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportR1TreesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportR1TreesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processOnPostImportR1TreesFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTreesToExistingR2ProjectsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/AddTreesToExistingR2ProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTreesToExistingR2ProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTreesToExistingR2ProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processAddTreesToExistingR2ProjectsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportR2TreesFromExcel(body: string | undefined): Observable<CreateOrEditProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportR2TreesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportR2TreesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportR2TreesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto>;
        }));
    }

    protected processOnPostImportR2TreesFromExcel(response: HttpResponseBase): Observable<CreateOrEditProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGenomicProjectsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/CreateGenomicProjectsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGenomicProjectsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGenomicProjectsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateGenomicProjectsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcelGenomicSelection(body: string | undefined): Observable<CreateOrEditProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportFromExcelGenomicSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcelGenomicSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcelGenomicSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditProjectDto[]>;
        }));
    }

    protected processOnPostImportFromExcelGenomicSelection(response: HttpResponseBase): Observable<CreateOrEditProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGenomicMeasurementsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/CreateGenomicMeasurementsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGenomicMeasurementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGenomicMeasurementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateGenomicMeasurementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcelBbtGenomicSelection(body: string | undefined): Observable<MeasurementSelectionGenomicDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Projects/OnPostImportFromExcelBbtGenomicSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcelBbtGenomicSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcelBbtGenomicSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementSelectionGenomicDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementSelectionGenomicDto[]>;
        }));
    }

    protected processOnPostImportFromExcelBbtGenomicSelection(response: HttpResponseBase): Observable<MeasurementSelectionGenomicDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementSelectionGenomicDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importBBTGenomicMeasurementsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/ImportBBTGenomicMeasurementsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBBTGenomicMeasurementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBBTGenomicMeasurementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportBBTGenomicMeasurementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importBBXGenomicMeasurementsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Projects/ImportBBXGenomicMeasurementsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBBXGenomicMeasurementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBBXGenomicMeasurementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportBBXGenomicMeasurementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PromedioLabBbxesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxFechaCalculoFilter (optional) 
     * @param minFechaCalculoFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param maxDB_Lab_FRBFilter (optional) 
     * @param minDB_Lab_FRBFilter (optional) 
     * @param bloqueFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPromBBX(filter: string | undefined, maxFechaCalculoFilter: DateTime | undefined, minFechaCalculoFilter: DateTime | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, maxDB_Lab_FRBFilter: number | undefined, minDB_Lab_FRBFilter: number | undefined, bloqueFilter: string | undefined, cloneBBXFilter: string | undefined, projectNameFilter: string | undefined, trialStandNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PromedioLabBbxproyectoPage> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/GetAllPromBBX?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCalculoFilter' cannot be null.");
        else if (maxFechaCalculoFilter !== undefined)
            url_ += "MaxFechaCalculoFilter=" + encodeURIComponent(maxFechaCalculoFilter ? "" + maxFechaCalculoFilter.toString() : "") + "&";
        if (minFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCalculoFilter' cannot be null.");
        else if (minFechaCalculoFilter !== undefined)
            url_ += "MinFechaCalculoFilter=" + encodeURIComponent(minFechaCalculoFilter ? "" + minFechaCalculoFilter.toString() : "") + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (maxDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_FRBFilter' cannot be null.");
        else if (maxDB_Lab_FRBFilter !== undefined)
            url_ += "MaxDB_Lab_FRBFilter=" + encodeURIComponent("" + maxDB_Lab_FRBFilter) + "&";
        if (minDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_FRBFilter' cannot be null.");
        else if (minDB_Lab_FRBFilter !== undefined)
            url_ += "MinDB_Lab_FRBFilter=" + encodeURIComponent("" + minDB_Lab_FRBFilter) + "&";
        if (bloqueFilter === null)
            throw new globalThis.Error("The parameter 'bloqueFilter' cannot be null.");
        else if (bloqueFilter !== undefined)
            url_ += "BloqueFilter=" + encodeURIComponent("" + bloqueFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPromBBX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPromBBX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromedioLabBbxproyectoPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromedioLabBbxproyectoPage>;
        }));
    }

    protected processGetAllPromBBX(response: HttpResponseBase): Observable<PromedioLabBbxproyectoPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromedioLabBbxproyectoPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateOrEditPromedioLabBbxDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idclone (optional) 
     * @param project (optional) 
     * @param body (optional) 
     * @return OK
     */
    setBBXDestine(idclone: number | undefined, project: string | undefined, body: GetBBXDestinationForViewDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/SetBBXDestine?";
        if (idclone === null)
            throw new globalThis.Error("The parameter 'idclone' cannot be null.");
        else if (idclone !== undefined)
            url_ += "idclone=" + encodeURIComponent("" + idclone) + "&";
        if (project === null)
            throw new globalThis.Error("The parameter 'project' cannot be null.");
        else if (project !== undefined)
            url_ += "Project=" + encodeURIComponent("" + project) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBBXDestine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBBXDestine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBBXDestine(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxFechaCalculoFilter (optional) 
     * @param minFechaCalculoFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param maxDB_Lab_FRBFilter (optional) 
     * @param minDB_Lab_FRBFilter (optional) 
     * @param bloqueFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @return OK
     */
    getPromedioLabBbxesToExcel(filter: string | undefined, maxFechaCalculoFilter: DateTime | undefined, minFechaCalculoFilter: DateTime | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, maxDB_Lab_FRBFilter: number | undefined, minDB_Lab_FRBFilter: number | undefined, bloqueFilter: string | undefined, cloneBBXFilter: string | undefined, projectNameFilter: string | undefined, trialStandNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/GetPromedioLabBbxesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCalculoFilter' cannot be null.");
        else if (maxFechaCalculoFilter !== undefined)
            url_ += "MaxFechaCalculoFilter=" + encodeURIComponent(maxFechaCalculoFilter ? "" + maxFechaCalculoFilter.toString() : "") + "&";
        if (minFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCalculoFilter' cannot be null.");
        else if (minFechaCalculoFilter !== undefined)
            url_ += "MinFechaCalculoFilter=" + encodeURIComponent(minFechaCalculoFilter ? "" + minFechaCalculoFilter.toString() : "") + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (maxDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_FRBFilter' cannot be null.");
        else if (maxDB_Lab_FRBFilter !== undefined)
            url_ += "MaxDB_Lab_FRBFilter=" + encodeURIComponent("" + maxDB_Lab_FRBFilter) + "&";
        if (minDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_FRBFilter' cannot be null.");
        else if (minDB_Lab_FRBFilter !== undefined)
            url_ += "MinDB_Lab_FRBFilter=" + encodeURIComponent("" + minDB_Lab_FRBFilter) + "&";
        if (bloqueFilter === null)
            throw new globalThis.Error("The parameter 'bloqueFilter' cannot be null.");
        else if (bloqueFilter !== undefined)
            url_ += "BloqueFilter=" + encodeURIComponent("" + bloqueFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromedioLabBbxesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromedioLabBbxesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPromedioLabBbxesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxFechaCalculoFilter (optional) 
     * @param minFechaCalculoFilter (optional) 
     * @param maxDB_10Filter (optional) 
     * @param minDB_10Filter (optional) 
     * @param maxDB_Lab_FRBFilter (optional) 
     * @param minDB_Lab_FRBFilter (optional) 
     * @param bloqueFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxFechaCalculoFilter: DateTime | undefined, minFechaCalculoFilter: DateTime | undefined, maxDB_10Filter: number | undefined, minDB_10Filter: number | undefined, maxDB_Lab_FRBFilter: number | undefined, minDB_Lab_FRBFilter: number | undefined, bloqueFilter: string | undefined, cloneBBXFilter: string | undefined, projectNameFilter: string | undefined, trialStandNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPromedioLabBbxForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCalculoFilter' cannot be null.");
        else if (maxFechaCalculoFilter !== undefined)
            url_ += "MaxFechaCalculoFilter=" + encodeURIComponent(maxFechaCalculoFilter ? "" + maxFechaCalculoFilter.toString() : "") + "&";
        if (minFechaCalculoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCalculoFilter' cannot be null.");
        else if (minFechaCalculoFilter !== undefined)
            url_ += "MinFechaCalculoFilter=" + encodeURIComponent(minFechaCalculoFilter ? "" + minFechaCalculoFilter.toString() : "") + "&";
        if (maxDB_10Filter === null)
            throw new globalThis.Error("The parameter 'maxDB_10Filter' cannot be null.");
        else if (maxDB_10Filter !== undefined)
            url_ += "MaxDB_10Filter=" + encodeURIComponent("" + maxDB_10Filter) + "&";
        if (minDB_10Filter === null)
            throw new globalThis.Error("The parameter 'minDB_10Filter' cannot be null.");
        else if (minDB_10Filter !== undefined)
            url_ += "MinDB_10Filter=" + encodeURIComponent("" + minDB_10Filter) + "&";
        if (maxDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'maxDB_Lab_FRBFilter' cannot be null.");
        else if (maxDB_Lab_FRBFilter !== undefined)
            url_ += "MaxDB_Lab_FRBFilter=" + encodeURIComponent("" + maxDB_Lab_FRBFilter) + "&";
        if (minDB_Lab_FRBFilter === null)
            throw new globalThis.Error("The parameter 'minDB_Lab_FRBFilter' cannot be null.");
        else if (minDB_Lab_FRBFilter !== undefined)
            url_ += "MinDB_Lab_FRBFilter=" + encodeURIComponent("" + minDB_Lab_FRBFilter) + "&";
        if (bloqueFilter === null)
            throw new globalThis.Error("The parameter 'bloqueFilter' cannot be null.");
        else if (bloqueFilter !== undefined)
            url_ += "BloqueFilter=" + encodeURIComponent("" + bloqueFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPromedioLabBbxForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPromedioLabBbxForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPromedioLabBbxForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPromedioLabBbxForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDestinesFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/SetDestinesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDestinesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDestinesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processSetDestinesFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditPromedioLabBbxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PromedioLabBbxes/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPromedioLabBbxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPromedioLabBbxDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditPromedioLabBbxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditPromedioLabBbxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QualityClassificationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param classificationFilter (optional) 
     * @param qualityClassificationTypeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, classificationFilter: string | undefined, qualityClassificationTypeNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetQualityClassificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (classificationFilter === null)
            throw new globalThis.Error("The parameter 'classificationFilter' cannot be null.");
        else if (classificationFilter !== undefined)
            url_ += "ClassificationFilter=" + encodeURIComponent("" + classificationFilter) + "&";
        if (qualityClassificationTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'qualityClassificationTypeNameFilter' cannot be null.");
        else if (qualityClassificationTypeNameFilter !== undefined)
            url_ += "QualityClassificationTypeNameFilter=" + encodeURIComponent("" + qualityClassificationTypeNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetQualityClassificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetQualityClassificationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQualityClassificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetQualityClassificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityClassificationForView(id: number | undefined): Observable<GetQualityClassificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/GetQualityClassificationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityClassificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityClassificationForViewDto>;
        }));
    }

    protected processGetQualityClassificationForView(response: HttpResponseBase): Observable<GetQualityClassificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityClassificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityClassificationForEdit(id: number | undefined): Observable<GetQualityClassificationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/GetQualityClassificationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityClassificationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityClassificationForEditOutput>;
        }));
    }

    protected processGetQualityClassificationForEdit(response: HttpResponseBase): Observable<GetQualityClassificationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityClassificationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditQualityClassificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param classificationFilter (optional) 
     * @param qualityClassificationTypeNameFilter (optional) 
     * @return OK
     */
    getQualityClassificationsToExcel(filter: string | undefined, classificationFilter: string | undefined, qualityClassificationTypeNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/GetQualityClassificationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (classificationFilter === null)
            throw new globalThis.Error("The parameter 'classificationFilter' cannot be null.");
        else if (classificationFilter !== undefined)
            url_ += "ClassificationFilter=" + encodeURIComponent("" + classificationFilter) + "&";
        if (qualityClassificationTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'qualityClassificationTypeNameFilter' cannot be null.");
        else if (qualityClassificationTypeNameFilter !== undefined)
            url_ += "QualityClassificationTypeNameFilter=" + encodeURIComponent("" + qualityClassificationTypeNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetQualityClassificationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createQualityClassificationFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassifications/CreateQualityClassificationFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQualityClassificationFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQualityClassificationFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateQualityClassificationFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QualityClassificationTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, typeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetQualityClassificationTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter === null)
            throw new globalThis.Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetQualityClassificationTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetQualityClassificationTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQualityClassificationTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetQualityClassificationTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityClassificationTypeForView(id: number | undefined): Observable<GetQualityClassificationTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/GetQualityClassificationTypeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityClassificationTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityClassificationTypeForViewDto>;
        }));
    }

    protected processGetQualityClassificationTypeForView(response: HttpResponseBase): Observable<GetQualityClassificationTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityClassificationTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityClassificationTypeForEdit(id: number | undefined): Observable<GetQualityClassificationTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/GetQualityClassificationTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityClassificationTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityClassificationTypeForEditOutput>;
        }));
    }

    protected processGetQualityClassificationTypeForEdit(response: HttpResponseBase): Observable<GetQualityClassificationTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityClassificationTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditQualityClassificationTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @return OK
     */
    getQualityClassificationTypesToExcel(filter: string | undefined, typeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/GetQualityClassificationTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter === null)
            throw new globalThis.Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityClassificationTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityClassificationTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetQualityClassificationTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createQualityClassificationTypeFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityClassificationTypes/CreateQualityClassificationTypeFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQualityClassificationTypeFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQualityClassificationTypeFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateQualityClassificationTypeFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QualityControlsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param qualityCodeFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param maxControlDateFilter (optional) 
     * @param minControlDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, qualityCodeFilter: string | undefined, trialNumberFilter: string | undefined, maxControlDateFilter: DateTime | undefined, minControlDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetQualityControlForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (qualityCodeFilter === null)
            throw new globalThis.Error("The parameter 'qualityCodeFilter' cannot be null.");
        else if (qualityCodeFilter !== undefined)
            url_ += "QualityCodeFilter=" + encodeURIComponent("" + qualityCodeFilter) + "&";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        if (maxControlDateFilter === null)
            throw new globalThis.Error("The parameter 'maxControlDateFilter' cannot be null.");
        else if (maxControlDateFilter !== undefined)
            url_ += "MaxControlDateFilter=" + encodeURIComponent(maxControlDateFilter ? "" + maxControlDateFilter.toString() : "") + "&";
        if (minControlDateFilter === null)
            throw new globalThis.Error("The parameter 'minControlDateFilter' cannot be null.");
        else if (minControlDateFilter !== undefined)
            url_ += "MinControlDateFilter=" + encodeURIComponent(minControlDateFilter ? "" + minControlDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetQualityControlForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetQualityControlForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQualityControlForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetQualityControlForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityControlForView(id: number | undefined): Observable<GetQualityControlForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetQualityControlForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityControlForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityControlForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityControlForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityControlForViewDto>;
        }));
    }

    protected processGetQualityControlForView(response: HttpResponseBase): Observable<GetQualityControlForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityControlForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getQualityControlForEdit(id: number | undefined): Observable<GetQualityControlForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetQualityControlForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityControlForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityControlForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQualityControlForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQualityControlForEditOutput>;
        }));
    }

    protected processGetQualityControlForEdit(response: HttpResponseBase): Observable<GetQualityControlForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualityControlForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditQualityControlDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param qualityCodeFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param maxControlDateFilter (optional) 
     * @param minControlDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    deleteByFilters(filter: string | undefined, qualityCodeFilter: string | undefined, trialNumberFilter: string | undefined, maxControlDateFilter: DateTime | undefined, minControlDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/DeleteByFilters?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (qualityCodeFilter === null)
            throw new globalThis.Error("The parameter 'qualityCodeFilter' cannot be null.");
        else if (qualityCodeFilter !== undefined)
            url_ += "QualityCodeFilter=" + encodeURIComponent("" + qualityCodeFilter) + "&";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        if (maxControlDateFilter === null)
            throw new globalThis.Error("The parameter 'maxControlDateFilter' cannot be null.");
        else if (maxControlDateFilter !== undefined)
            url_ += "MaxControlDateFilter=" + encodeURIComponent(maxControlDateFilter ? "" + maxControlDateFilter.toString() : "") + "&";
        if (minControlDateFilter === null)
            throw new globalThis.Error("The parameter 'minControlDateFilter' cannot be null.");
        else if (minControlDateFilter !== undefined)
            url_ += "MinControlDateFilter=" + encodeURIComponent(minControlDateFilter ? "" + minControlDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteByFilters(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param qualityCodeFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param maxControlDateFilter (optional) 
     * @param minControlDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getQualityControlsToExcel(filter: string | undefined, qualityCodeFilter: string | undefined, trialNumberFilter: string | undefined, maxControlDateFilter: DateTime | undefined, minControlDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetQualityControlsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (qualityCodeFilter === null)
            throw new globalThis.Error("The parameter 'qualityCodeFilter' cannot be null.");
        else if (qualityCodeFilter !== undefined)
            url_ += "QualityCodeFilter=" + encodeURIComponent("" + qualityCodeFilter) + "&";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        if (maxControlDateFilter === null)
            throw new globalThis.Error("The parameter 'maxControlDateFilter' cannot be null.");
        else if (maxControlDateFilter !== undefined)
            url_ += "MaxControlDateFilter=" + encodeURIComponent(maxControlDateFilter ? "" + maxControlDateFilter.toString() : "") + "&";
        if (minControlDateFilter === null)
            throw new globalThis.Error("The parameter 'minControlDateFilter' cannot be null.");
        else if (minControlDateFilter !== undefined)
            url_ += "MinControlDateFilter=" + encodeURIComponent(minControlDateFilter ? "" + minControlDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityControlsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityControlsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetQualityControlsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllQualityCodesForLookup(filter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetAllQualityCodesForLookup?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualityCodesForLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualityCodesForLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllQualityCodesForLookup(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllTrialsForLookup(filter: string | undefined): Observable<TrialLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetAllTrialsForLookup?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialsForLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialsForLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrialLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrialLookupDto[]>;
        }));
    }

    protected processGetAllTrialsForLookup(response: HttpResponseBase): Observable<TrialLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialLookupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialId (optional) 
     * @param qualityCode (optional) 
     * @return OK
     */
    getGeneticMaterialByTrialAndQualityCode(trialId: number | undefined, qualityCode: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/GetGeneticMaterialByTrialAndQualityCode?";
        if (trialId === null)
            throw new globalThis.Error("The parameter 'trialId' cannot be null.");
        else if (trialId !== undefined)
            url_ += "trialId=" + encodeURIComponent("" + trialId) + "&";
        if (qualityCode === null)
            throw new globalThis.Error("The parameter 'qualityCode' cannot be null.");
        else if (qualityCode !== undefined)
            url_ += "qualityCode=" + encodeURIComponent("" + qualityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneticMaterialByTrialAndQualityCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneticMaterialByTrialAndQualityCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetGeneticMaterialByTrialAndQualityCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importQualityControlsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/QualityControls/ImportQualityControlsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportQualityControlsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQualityControlsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportQualityControlsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoatingporcentajeTraiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxIDBandejaFilter (optional) 
     * @param minIDBandejaFilter (optional) 
     * @param etiquetaBandejaFilter (optional) 
     * @param origenBandejaFilter (optional) 
     * @param maxFechaCosechaFilter (optional) 
     * @param minFechaCosechaFilter (optional) 
     * @param maxFechaConteoInicialFilter (optional) 
     * @param minFechaConteoInicialFilter (optional) 
     * @param maxCantidadPlantasInicialesFilter (optional) 
     * @param minCantidadPlantasInicialesFilter (optional) 
     * @param zonaCrecimientoFilter (optional) 
     * @param maxFechaEntradaCrecimientoFilter (optional) 
     * @param minFechaEntradaCrecimientoFilter (optional) 
     * @param maxFechaEntradaEnraizamientoFilter (optional) 
     * @param minFechaEntradaEnraizamientoFilter (optional) 
     * @param zonaEnraizamientoFilter (optional) 
     * @param maxCantidadConteoFinalFilter (optional) 
     * @param minCantidadConteoFinalFilter (optional) 
     * @param maxFechaPlantasFinalFilter (optional) 
     * @param minFechaPlantasFinalFilter (optional) 
     * @param observacionFilter (optional) 
     * @param maxFechaCensoFinalFilter (optional) 
     * @param minFechaCensoFinalFilter (optional) 
     * @param maxCensoFinalFilter (optional) 
     * @param minCensoFinalFilter (optional) 
     * @param maxPorcentajeEnraizamientoFilter (optional) 
     * @param minPorcentajeEnraizamientoFilter (optional) 
     * @param seedSpeciesFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param destinationFilter (optional) 
     * @param pendings (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxIDBandejaFilter: number | undefined, minIDBandejaFilter: number | undefined, etiquetaBandejaFilter: string | undefined, origenBandejaFilter: string | undefined, maxFechaCosechaFilter: DateTime | undefined, minFechaCosechaFilter: DateTime | undefined, maxFechaConteoInicialFilter: DateTime | undefined, minFechaConteoInicialFilter: DateTime | undefined, maxCantidadPlantasInicialesFilter: number | undefined, minCantidadPlantasInicialesFilter: number | undefined, zonaCrecimientoFilter: string | undefined, maxFechaEntradaCrecimientoFilter: DateTime | undefined, minFechaEntradaCrecimientoFilter: DateTime | undefined, maxFechaEntradaEnraizamientoFilter: DateTime | undefined, minFechaEntradaEnraizamientoFilter: DateTime | undefined, zonaEnraizamientoFilter: string | undefined, maxCantidadConteoFinalFilter: number | undefined, minCantidadConteoFinalFilter: number | undefined, maxFechaPlantasFinalFilter: DateTime | undefined, minFechaPlantasFinalFilter: DateTime | undefined, observacionFilter: string | undefined, maxFechaCensoFinalFilter: DateTime | undefined, minFechaCensoFinalFilter: DateTime | undefined, maxCensoFinalFilter: number | undefined, minCensoFinalFilter: number | undefined, maxPorcentajeEnraizamientoFilter: number | undefined, minPorcentajeEnraizamientoFilter: number | undefined, seedSpeciesFilter: string | undefined, projectNameFilter: string[] | undefined, measurementSelectionNumberTFilter: string[] | undefined, cloneBBXFilter: string[] | undefined, sourcePlantGroupNumberFilter: string[] | undefined, destinationFilter: string[] | undefined, pendings: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRoatingporcentajeTrayForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxIDBandejaFilter === null)
            throw new globalThis.Error("The parameter 'maxIDBandejaFilter' cannot be null.");
        else if (maxIDBandejaFilter !== undefined)
            url_ += "MaxIDBandejaFilter=" + encodeURIComponent("" + maxIDBandejaFilter) + "&";
        if (minIDBandejaFilter === null)
            throw new globalThis.Error("The parameter 'minIDBandejaFilter' cannot be null.");
        else if (minIDBandejaFilter !== undefined)
            url_ += "MinIDBandejaFilter=" + encodeURIComponent("" + minIDBandejaFilter) + "&";
        if (etiquetaBandejaFilter === null)
            throw new globalThis.Error("The parameter 'etiquetaBandejaFilter' cannot be null.");
        else if (etiquetaBandejaFilter !== undefined)
            url_ += "EtiquetaBandejaFilter=" + encodeURIComponent("" + etiquetaBandejaFilter) + "&";
        if (origenBandejaFilter === null)
            throw new globalThis.Error("The parameter 'origenBandejaFilter' cannot be null.");
        else if (origenBandejaFilter !== undefined)
            url_ += "OrigenBandejaFilter=" + encodeURIComponent("" + origenBandejaFilter) + "&";
        if (maxFechaCosechaFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCosechaFilter' cannot be null.");
        else if (maxFechaCosechaFilter !== undefined)
            url_ += "MaxFechaCosechaFilter=" + encodeURIComponent(maxFechaCosechaFilter ? "" + maxFechaCosechaFilter.toString() : "") + "&";
        if (minFechaCosechaFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCosechaFilter' cannot be null.");
        else if (minFechaCosechaFilter !== undefined)
            url_ += "MinFechaCosechaFilter=" + encodeURIComponent(minFechaCosechaFilter ? "" + minFechaCosechaFilter.toString() : "") + "&";
        if (maxFechaConteoInicialFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaConteoInicialFilter' cannot be null.");
        else if (maxFechaConteoInicialFilter !== undefined)
            url_ += "MaxFechaConteoInicialFilter=" + encodeURIComponent(maxFechaConteoInicialFilter ? "" + maxFechaConteoInicialFilter.toString() : "") + "&";
        if (minFechaConteoInicialFilter === null)
            throw new globalThis.Error("The parameter 'minFechaConteoInicialFilter' cannot be null.");
        else if (minFechaConteoInicialFilter !== undefined)
            url_ += "MinFechaConteoInicialFilter=" + encodeURIComponent(minFechaConteoInicialFilter ? "" + minFechaConteoInicialFilter.toString() : "") + "&";
        if (maxCantidadPlantasInicialesFilter === null)
            throw new globalThis.Error("The parameter 'maxCantidadPlantasInicialesFilter' cannot be null.");
        else if (maxCantidadPlantasInicialesFilter !== undefined)
            url_ += "MaxCantidadPlantasInicialesFilter=" + encodeURIComponent("" + maxCantidadPlantasInicialesFilter) + "&";
        if (minCantidadPlantasInicialesFilter === null)
            throw new globalThis.Error("The parameter 'minCantidadPlantasInicialesFilter' cannot be null.");
        else if (minCantidadPlantasInicialesFilter !== undefined)
            url_ += "MinCantidadPlantasInicialesFilter=" + encodeURIComponent("" + minCantidadPlantasInicialesFilter) + "&";
        if (zonaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'zonaCrecimientoFilter' cannot be null.");
        else if (zonaCrecimientoFilter !== undefined)
            url_ += "ZonaCrecimientoFilter=" + encodeURIComponent("" + zonaCrecimientoFilter) + "&";
        if (maxFechaEntradaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaEntradaCrecimientoFilter' cannot be null.");
        else if (maxFechaEntradaCrecimientoFilter !== undefined)
            url_ += "MaxFechaEntradaCrecimientoFilter=" + encodeURIComponent(maxFechaEntradaCrecimientoFilter ? "" + maxFechaEntradaCrecimientoFilter.toString() : "") + "&";
        if (minFechaEntradaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaEntradaCrecimientoFilter' cannot be null.");
        else if (minFechaEntradaCrecimientoFilter !== undefined)
            url_ += "MinFechaEntradaCrecimientoFilter=" + encodeURIComponent(minFechaEntradaCrecimientoFilter ? "" + minFechaEntradaCrecimientoFilter.toString() : "") + "&";
        if (maxFechaEntradaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaEntradaEnraizamientoFilter' cannot be null.");
        else if (maxFechaEntradaEnraizamientoFilter !== undefined)
            url_ += "MaxFechaEntradaEnraizamientoFilter=" + encodeURIComponent(maxFechaEntradaEnraizamientoFilter ? "" + maxFechaEntradaEnraizamientoFilter.toString() : "") + "&";
        if (minFechaEntradaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaEntradaEnraizamientoFilter' cannot be null.");
        else if (minFechaEntradaEnraizamientoFilter !== undefined)
            url_ += "MinFechaEntradaEnraizamientoFilter=" + encodeURIComponent(minFechaEntradaEnraizamientoFilter ? "" + minFechaEntradaEnraizamientoFilter.toString() : "") + "&";
        if (zonaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'zonaEnraizamientoFilter' cannot be null.");
        else if (zonaEnraizamientoFilter !== undefined)
            url_ += "ZonaEnraizamientoFilter=" + encodeURIComponent("" + zonaEnraizamientoFilter) + "&";
        if (maxCantidadConteoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxCantidadConteoFinalFilter' cannot be null.");
        else if (maxCantidadConteoFinalFilter !== undefined)
            url_ += "MaxCantidadConteoFinalFilter=" + encodeURIComponent("" + maxCantidadConteoFinalFilter) + "&";
        if (minCantidadConteoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minCantidadConteoFinalFilter' cannot be null.");
        else if (minCantidadConteoFinalFilter !== undefined)
            url_ += "MinCantidadConteoFinalFilter=" + encodeURIComponent("" + minCantidadConteoFinalFilter) + "&";
        if (maxFechaPlantasFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaPlantasFinalFilter' cannot be null.");
        else if (maxFechaPlantasFinalFilter !== undefined)
            url_ += "MaxFechaPlantasFinalFilter=" + encodeURIComponent(maxFechaPlantasFinalFilter ? "" + maxFechaPlantasFinalFilter.toString() : "") + "&";
        if (minFechaPlantasFinalFilter === null)
            throw new globalThis.Error("The parameter 'minFechaPlantasFinalFilter' cannot be null.");
        else if (minFechaPlantasFinalFilter !== undefined)
            url_ += "MinFechaPlantasFinalFilter=" + encodeURIComponent(minFechaPlantasFinalFilter ? "" + minFechaPlantasFinalFilter.toString() : "") + "&";
        if (observacionFilter === null)
            throw new globalThis.Error("The parameter 'observacionFilter' cannot be null.");
        else if (observacionFilter !== undefined)
            url_ += "ObservacionFilter=" + encodeURIComponent("" + observacionFilter) + "&";
        if (maxFechaCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCensoFinalFilter' cannot be null.");
        else if (maxFechaCensoFinalFilter !== undefined)
            url_ += "MaxFechaCensoFinalFilter=" + encodeURIComponent(maxFechaCensoFinalFilter ? "" + maxFechaCensoFinalFilter.toString() : "") + "&";
        if (minFechaCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCensoFinalFilter' cannot be null.");
        else if (minFechaCensoFinalFilter !== undefined)
            url_ += "MinFechaCensoFinalFilter=" + encodeURIComponent(minFechaCensoFinalFilter ? "" + minFechaCensoFinalFilter.toString() : "") + "&";
        if (maxCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxCensoFinalFilter' cannot be null.");
        else if (maxCensoFinalFilter !== undefined)
            url_ += "MaxCensoFinalFilter=" + encodeURIComponent("" + maxCensoFinalFilter) + "&";
        if (minCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minCensoFinalFilter' cannot be null.");
        else if (minCensoFinalFilter !== undefined)
            url_ += "MinCensoFinalFilter=" + encodeURIComponent("" + minCensoFinalFilter) + "&";
        if (maxPorcentajeEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentajeEnraizamientoFilter' cannot be null.");
        else if (maxPorcentajeEnraizamientoFilter !== undefined)
            url_ += "MaxPorcentajeEnraizamientoFilter=" + encodeURIComponent("" + maxPorcentajeEnraizamientoFilter) + "&";
        if (minPorcentajeEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentajeEnraizamientoFilter' cannot be null.");
        else if (minPorcentajeEnraizamientoFilter !== undefined)
            url_ += "MinPorcentajeEnraizamientoFilter=" + encodeURIComponent("" + minPorcentajeEnraizamientoFilter) + "&";
        if (seedSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'seedSpeciesFilter' cannot be null.");
        else if (seedSpeciesFilter !== undefined)
            url_ += "SeedSpeciesFilter=" + encodeURIComponent("" + seedSpeciesFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            projectNameFilter && projectNameFilter.forEach(item => { url_ += "ProjectNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            measurementSelectionNumberTFilter && measurementSelectionNumberTFilter.forEach(item => { url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + item) + "&"; });
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            cloneBBXFilter && cloneBBXFilter.forEach(item => { url_ += "CloneBBXFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            sourcePlantGroupNumberFilter && sourcePlantGroupNumberFilter.forEach(item => { url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            destinationFilter && destinationFilter.forEach(item => { url_ += "DestinationFilter=" + encodeURIComponent("" + item) + "&"; });
        if (pendings === null)
            throw new globalThis.Error("The parameter 'pendings' cannot be null.");
        else if (pendings !== undefined)
            url_ += "Pendings=" + encodeURIComponent("" + pendings) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRoatingporcentajeTrayForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRoatingporcentajeTrayForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRoatingporcentajeTrayForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRoatingporcentajeTrayForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoatingporcentajeTrayForView(id: number | undefined): Observable<GetRoatingporcentajeTrayForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetRoatingporcentajeTrayForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoatingporcentajeTrayForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoatingporcentajeTrayForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoatingporcentajeTrayForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoatingporcentajeTrayForViewDto>;
        }));
    }

    protected processGetRoatingporcentajeTrayForView(response: HttpResponseBase): Observable<GetRoatingporcentajeTrayForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoatingporcentajeTrayForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoatingporcentajeTrayForEdit(id: number | undefined): Observable<GetRoatingporcentajeTrayForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetRoatingporcentajeTrayForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoatingporcentajeTrayForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoatingporcentajeTrayForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoatingporcentajeTrayForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoatingporcentajeTrayForEditOutput>;
        }));
    }

    protected processGetRoatingporcentajeTrayForEdit(response: HttpResponseBase): Observable<GetRoatingporcentajeTrayForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoatingporcentajeTrayForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditRoatingporcentajeTrayDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteItem (optional) 
     * @return OK
     */
    deleteSelectedRoatingporcentajeTraies(deleteItem: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/DeleteSelectedRoatingporcentajeTraies?";
        if (deleteItem === null)
            throw new globalThis.Error("The parameter 'deleteItem' cannot be null.");
        else if (deleteItem !== undefined)
            deleteItem && deleteItem.forEach(item => { url_ += "deleteItem=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSelectedRoatingporcentajeTraies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSelectedRoatingporcentajeTraies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSelectedRoatingporcentajeTraies(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxIDBandejaFilter (optional) 
     * @param minIDBandejaFilter (optional) 
     * @param etiquetaBandejaFilter (optional) 
     * @param origenBandejaFilter (optional) 
     * @param maxFechaCosechaFilter (optional) 
     * @param minFechaCosechaFilter (optional) 
     * @param maxFechaConteoInicialFilter (optional) 
     * @param minFechaConteoInicialFilter (optional) 
     * @param maxCantidadPlantasInicialesFilter (optional) 
     * @param minCantidadPlantasInicialesFilter (optional) 
     * @param zonaCrecimientoFilter (optional) 
     * @param maxFechaEntradaCrecimientoFilter (optional) 
     * @param minFechaEntradaCrecimientoFilter (optional) 
     * @param maxFechaEntradaEnraizamientoFilter (optional) 
     * @param minFechaEntradaEnraizamientoFilter (optional) 
     * @param zonaEnraizamientoFilter (optional) 
     * @param maxCantidadConteoFinalFilter (optional) 
     * @param minCantidadConteoFinalFilter (optional) 
     * @param maxFechaPlantasFinalFilter (optional) 
     * @param minFechaPlantasFinalFilter (optional) 
     * @param observacionFilter (optional) 
     * @param maxFechaCensoFinalFilter (optional) 
     * @param minFechaCensoFinalFilter (optional) 
     * @param maxCensoFinalFilter (optional) 
     * @param minCensoFinalFilter (optional) 
     * @param maxPorcentajeEnraizamientoFilter (optional) 
     * @param minPorcentajeEnraizamientoFilter (optional) 
     * @param seedSpeciesFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param destinationFilter (optional) 
     * @param pendings (optional) 
     * @return OK
     */
    getRoatingporcentajeTraiesToExcel(filter: string | undefined, maxIDBandejaFilter: number | undefined, minIDBandejaFilter: number | undefined, etiquetaBandejaFilter: string | undefined, origenBandejaFilter: string | undefined, maxFechaCosechaFilter: DateTime | undefined, minFechaCosechaFilter: DateTime | undefined, maxFechaConteoInicialFilter: DateTime | undefined, minFechaConteoInicialFilter: DateTime | undefined, maxCantidadPlantasInicialesFilter: number | undefined, minCantidadPlantasInicialesFilter: number | undefined, zonaCrecimientoFilter: string | undefined, maxFechaEntradaCrecimientoFilter: DateTime | undefined, minFechaEntradaCrecimientoFilter: DateTime | undefined, maxFechaEntradaEnraizamientoFilter: DateTime | undefined, minFechaEntradaEnraizamientoFilter: DateTime | undefined, zonaEnraizamientoFilter: string | undefined, maxCantidadConteoFinalFilter: number | undefined, minCantidadConteoFinalFilter: number | undefined, maxFechaPlantasFinalFilter: DateTime | undefined, minFechaPlantasFinalFilter: DateTime | undefined, observacionFilter: string | undefined, maxFechaCensoFinalFilter: DateTime | undefined, minFechaCensoFinalFilter: DateTime | undefined, maxCensoFinalFilter: number | undefined, minCensoFinalFilter: number | undefined, maxPorcentajeEnraizamientoFilter: number | undefined, minPorcentajeEnraizamientoFilter: number | undefined, seedSpeciesFilter: string | undefined, projectNameFilter: string[] | undefined, measurementSelectionNumberTFilter: string[] | undefined, cloneBBXFilter: string[] | undefined, sourcePlantGroupNumberFilter: string[] | undefined, destinationFilter: string[] | undefined, pendings: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetRoatingporcentajeTraiesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxIDBandejaFilter === null)
            throw new globalThis.Error("The parameter 'maxIDBandejaFilter' cannot be null.");
        else if (maxIDBandejaFilter !== undefined)
            url_ += "MaxIDBandejaFilter=" + encodeURIComponent("" + maxIDBandejaFilter) + "&";
        if (minIDBandejaFilter === null)
            throw new globalThis.Error("The parameter 'minIDBandejaFilter' cannot be null.");
        else if (minIDBandejaFilter !== undefined)
            url_ += "MinIDBandejaFilter=" + encodeURIComponent("" + minIDBandejaFilter) + "&";
        if (etiquetaBandejaFilter === null)
            throw new globalThis.Error("The parameter 'etiquetaBandejaFilter' cannot be null.");
        else if (etiquetaBandejaFilter !== undefined)
            url_ += "EtiquetaBandejaFilter=" + encodeURIComponent("" + etiquetaBandejaFilter) + "&";
        if (origenBandejaFilter === null)
            throw new globalThis.Error("The parameter 'origenBandejaFilter' cannot be null.");
        else if (origenBandejaFilter !== undefined)
            url_ += "OrigenBandejaFilter=" + encodeURIComponent("" + origenBandejaFilter) + "&";
        if (maxFechaCosechaFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCosechaFilter' cannot be null.");
        else if (maxFechaCosechaFilter !== undefined)
            url_ += "MaxFechaCosechaFilter=" + encodeURIComponent(maxFechaCosechaFilter ? "" + maxFechaCosechaFilter.toString() : "") + "&";
        if (minFechaCosechaFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCosechaFilter' cannot be null.");
        else if (minFechaCosechaFilter !== undefined)
            url_ += "MinFechaCosechaFilter=" + encodeURIComponent(minFechaCosechaFilter ? "" + minFechaCosechaFilter.toString() : "") + "&";
        if (maxFechaConteoInicialFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaConteoInicialFilter' cannot be null.");
        else if (maxFechaConteoInicialFilter !== undefined)
            url_ += "MaxFechaConteoInicialFilter=" + encodeURIComponent(maxFechaConteoInicialFilter ? "" + maxFechaConteoInicialFilter.toString() : "") + "&";
        if (minFechaConteoInicialFilter === null)
            throw new globalThis.Error("The parameter 'minFechaConteoInicialFilter' cannot be null.");
        else if (minFechaConteoInicialFilter !== undefined)
            url_ += "MinFechaConteoInicialFilter=" + encodeURIComponent(minFechaConteoInicialFilter ? "" + minFechaConteoInicialFilter.toString() : "") + "&";
        if (maxCantidadPlantasInicialesFilter === null)
            throw new globalThis.Error("The parameter 'maxCantidadPlantasInicialesFilter' cannot be null.");
        else if (maxCantidadPlantasInicialesFilter !== undefined)
            url_ += "MaxCantidadPlantasInicialesFilter=" + encodeURIComponent("" + maxCantidadPlantasInicialesFilter) + "&";
        if (minCantidadPlantasInicialesFilter === null)
            throw new globalThis.Error("The parameter 'minCantidadPlantasInicialesFilter' cannot be null.");
        else if (minCantidadPlantasInicialesFilter !== undefined)
            url_ += "MinCantidadPlantasInicialesFilter=" + encodeURIComponent("" + minCantidadPlantasInicialesFilter) + "&";
        if (zonaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'zonaCrecimientoFilter' cannot be null.");
        else if (zonaCrecimientoFilter !== undefined)
            url_ += "ZonaCrecimientoFilter=" + encodeURIComponent("" + zonaCrecimientoFilter) + "&";
        if (maxFechaEntradaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaEntradaCrecimientoFilter' cannot be null.");
        else if (maxFechaEntradaCrecimientoFilter !== undefined)
            url_ += "MaxFechaEntradaCrecimientoFilter=" + encodeURIComponent(maxFechaEntradaCrecimientoFilter ? "" + maxFechaEntradaCrecimientoFilter.toString() : "") + "&";
        if (minFechaEntradaCrecimientoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaEntradaCrecimientoFilter' cannot be null.");
        else if (minFechaEntradaCrecimientoFilter !== undefined)
            url_ += "MinFechaEntradaCrecimientoFilter=" + encodeURIComponent(minFechaEntradaCrecimientoFilter ? "" + minFechaEntradaCrecimientoFilter.toString() : "") + "&";
        if (maxFechaEntradaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaEntradaEnraizamientoFilter' cannot be null.");
        else if (maxFechaEntradaEnraizamientoFilter !== undefined)
            url_ += "MaxFechaEntradaEnraizamientoFilter=" + encodeURIComponent(maxFechaEntradaEnraizamientoFilter ? "" + maxFechaEntradaEnraizamientoFilter.toString() : "") + "&";
        if (minFechaEntradaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'minFechaEntradaEnraizamientoFilter' cannot be null.");
        else if (minFechaEntradaEnraizamientoFilter !== undefined)
            url_ += "MinFechaEntradaEnraizamientoFilter=" + encodeURIComponent(minFechaEntradaEnraizamientoFilter ? "" + minFechaEntradaEnraizamientoFilter.toString() : "") + "&";
        if (zonaEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'zonaEnraizamientoFilter' cannot be null.");
        else if (zonaEnraizamientoFilter !== undefined)
            url_ += "ZonaEnraizamientoFilter=" + encodeURIComponent("" + zonaEnraizamientoFilter) + "&";
        if (maxCantidadConteoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxCantidadConteoFinalFilter' cannot be null.");
        else if (maxCantidadConteoFinalFilter !== undefined)
            url_ += "MaxCantidadConteoFinalFilter=" + encodeURIComponent("" + maxCantidadConteoFinalFilter) + "&";
        if (minCantidadConteoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minCantidadConteoFinalFilter' cannot be null.");
        else if (minCantidadConteoFinalFilter !== undefined)
            url_ += "MinCantidadConteoFinalFilter=" + encodeURIComponent("" + minCantidadConteoFinalFilter) + "&";
        if (maxFechaPlantasFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaPlantasFinalFilter' cannot be null.");
        else if (maxFechaPlantasFinalFilter !== undefined)
            url_ += "MaxFechaPlantasFinalFilter=" + encodeURIComponent(maxFechaPlantasFinalFilter ? "" + maxFechaPlantasFinalFilter.toString() : "") + "&";
        if (minFechaPlantasFinalFilter === null)
            throw new globalThis.Error("The parameter 'minFechaPlantasFinalFilter' cannot be null.");
        else if (minFechaPlantasFinalFilter !== undefined)
            url_ += "MinFechaPlantasFinalFilter=" + encodeURIComponent(minFechaPlantasFinalFilter ? "" + minFechaPlantasFinalFilter.toString() : "") + "&";
        if (observacionFilter === null)
            throw new globalThis.Error("The parameter 'observacionFilter' cannot be null.");
        else if (observacionFilter !== undefined)
            url_ += "ObservacionFilter=" + encodeURIComponent("" + observacionFilter) + "&";
        if (maxFechaCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxFechaCensoFinalFilter' cannot be null.");
        else if (maxFechaCensoFinalFilter !== undefined)
            url_ += "MaxFechaCensoFinalFilter=" + encodeURIComponent(maxFechaCensoFinalFilter ? "" + maxFechaCensoFinalFilter.toString() : "") + "&";
        if (minFechaCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minFechaCensoFinalFilter' cannot be null.");
        else if (minFechaCensoFinalFilter !== undefined)
            url_ += "MinFechaCensoFinalFilter=" + encodeURIComponent(minFechaCensoFinalFilter ? "" + minFechaCensoFinalFilter.toString() : "") + "&";
        if (maxCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'maxCensoFinalFilter' cannot be null.");
        else if (maxCensoFinalFilter !== undefined)
            url_ += "MaxCensoFinalFilter=" + encodeURIComponent("" + maxCensoFinalFilter) + "&";
        if (minCensoFinalFilter === null)
            throw new globalThis.Error("The parameter 'minCensoFinalFilter' cannot be null.");
        else if (minCensoFinalFilter !== undefined)
            url_ += "MinCensoFinalFilter=" + encodeURIComponent("" + minCensoFinalFilter) + "&";
        if (maxPorcentajeEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentajeEnraizamientoFilter' cannot be null.");
        else if (maxPorcentajeEnraizamientoFilter !== undefined)
            url_ += "MaxPorcentajeEnraizamientoFilter=" + encodeURIComponent("" + maxPorcentajeEnraizamientoFilter) + "&";
        if (minPorcentajeEnraizamientoFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentajeEnraizamientoFilter' cannot be null.");
        else if (minPorcentajeEnraizamientoFilter !== undefined)
            url_ += "MinPorcentajeEnraizamientoFilter=" + encodeURIComponent("" + minPorcentajeEnraizamientoFilter) + "&";
        if (seedSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'seedSpeciesFilter' cannot be null.");
        else if (seedSpeciesFilter !== undefined)
            url_ += "SeedSpeciesFilter=" + encodeURIComponent("" + seedSpeciesFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            projectNameFilter && projectNameFilter.forEach(item => { url_ += "ProjectNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            measurementSelectionNumberTFilter && measurementSelectionNumberTFilter.forEach(item => { url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + item) + "&"; });
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            cloneBBXFilter && cloneBBXFilter.forEach(item => { url_ += "CloneBBXFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            sourcePlantGroupNumberFilter && sourcePlantGroupNumberFilter.forEach(item => { url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            destinationFilter && destinationFilter.forEach(item => { url_ += "DestinationFilter=" + encodeURIComponent("" + item) + "&"; });
        if (pendings === null)
            throw new globalThis.Error("The parameter 'pendings' cannot be null.");
        else if (pendings !== undefined)
            url_ += "Pendings=" + encodeURIComponent("" + pendings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoatingporcentajeTraiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoatingporcentajeTraiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRoatingporcentajeTraiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMeasurementSelectionForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllMeasurementSelectionForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementSelectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementSelectionForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementSelectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSourcePlantForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllSourcePlantForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto>;
        }));
    }

    protected processGetAllSourcePlantForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createroatingporcentajeTraiesFromExcel(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/CreateroatingporcentajeTraiesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateroatingporcentajeTraiesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateroatingporcentajeTraiesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateroatingporcentajeTraiesFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createStakingGCFromExcel(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/CreateStakingGCFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStakingGCFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStakingGCFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStakingGCFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateConsolidationGCFromExcel(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/UpdateConsolidationGCFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsolidationGCFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsolidationGCFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsolidationGCFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createroatingporcentajeTraiesMasiveFromExcel(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/CreateroatingporcentajeTraiesMasiveFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateroatingporcentajeTraiesMasiveFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateroatingporcentajeTraiesMasiveFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateroatingporcentajeTraiesMasiveFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectFilter (optional) 
     * @return OK
     */
    getAllProjectsForLookupTable(projectFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllProjectsForLookupTable?";
        if (projectFilter === null)
            throw new globalThis.Error("The parameter 'projectFilter' cannot be null.");
        else if (projectFilter !== undefined)
            url_ += "projectFilter=" + encodeURIComponent("" + projectFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllProjectsForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantGroupNumbersFilter (optional) 
     * @return OK
     */
    getAllSourcePlantGroupNumbersForLookupTable(sourcePlantGroupNumbersFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllSourcePlantGroupNumbersForLookupTable?";
        if (sourcePlantGroupNumbersFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumbersFilter' cannot be null.");
        else if (sourcePlantGroupNumbersFilter !== undefined)
            url_ += "sourcePlantGroupNumbersFilter=" + encodeURIComponent("" + sourcePlantGroupNumbersFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantGroupNumbersForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantGroupNumbersForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantGroupNumbersForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbtFilter (optional) 
     * @return OK
     */
    getAllBBTForLookupTable(bbtFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllBBTForLookupTable?";
        if (bbtFilter === null)
            throw new globalThis.Error("The parameter 'bbtFilter' cannot be null.");
        else if (bbtFilter !== undefined)
            url_ += "bbtFilter=" + encodeURIComponent("" + bbtFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBTForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBTForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllBBTForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbxFilter (optional) 
     * @return OK
     */
    getAllBBXForLookupTable(bbxFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllBBXForLookupTable?";
        if (bbxFilter === null)
            throw new globalThis.Error("The parameter 'bbxFilter' cannot be null.");
        else if (bbxFilter !== undefined)
            url_ += "bbxFilter=" + encodeURIComponent("" + bbxFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBBXForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBBXForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllBBXForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinoFilter (optional) 
     * @return OK
     */
    getAllDestinoForLookupTable(destinoFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RoatingporcentajeTraies/GetAllDestinoForLookupTable?";
        if (destinoFilter === null)
            throw new globalThis.Error("The parameter 'destinoFilter' cannot be null.");
        else if (destinoFilter !== undefined)
            url_ += "destinoFilter=" + encodeURIComponent("" + destinoFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDestinoForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDestinoForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllDestinoForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RootingPendingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param projectTypeFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, projectNameFilter: string | undefined, sourcePlantGroupNumberFilter: number | undefined, projectTypeFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, withRootingFilter: EnumWhitRooting, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRootingPendingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        if (projectTypeFilter === null)
            throw new globalThis.Error("The parameter 'projectTypeFilter' cannot be null.");
        else if (projectTypeFilter !== undefined)
            url_ += "ProjectTypeFilter=" + encodeURIComponent("" + projectTypeFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (withRootingFilter === undefined || withRootingFilter === null)
            throw new globalThis.Error("The parameter 'withRootingFilter' must be defined and cannot be null.");
        else
            url_ += "WithRootingFilter=" + encodeURIComponent("" + withRootingFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRootingPendingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRootingPendingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRootingPendingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRootingPendingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param projectTypeFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllNo(filter: string | undefined, projectNameFilter: string | undefined, sourcePlantGroupNumberFilter: number | undefined, projectTypeFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, withRootingFilter: EnumWhitRooting, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetRootingPendingForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetAllNo?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        if (projectTypeFilter === null)
            throw new globalThis.Error("The parameter 'projectTypeFilter' cannot be null.");
        else if (projectTypeFilter !== undefined)
            url_ += "ProjectTypeFilter=" + encodeURIComponent("" + projectTypeFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (withRootingFilter === undefined || withRootingFilter === null)
            throw new globalThis.Error("The parameter 'withRootingFilter' must be defined and cannot be null.");
        else
            url_ += "WithRootingFilter=" + encodeURIComponent("" + withRootingFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRootingPendingForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRootingPendingForViewDto[]>;
        }));
    }

    protected processGetAllNo(response: HttpResponseBase): Observable<GetRootingPendingForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRootingPendingForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param projectTypeFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllYes(filter: string | undefined, projectNameFilter: string | undefined, sourcePlantGroupNumberFilter: number | undefined, projectTypeFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, withRootingFilter: EnumWhitRooting, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetRootingPendingForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetAllYes?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        if (projectTypeFilter === null)
            throw new globalThis.Error("The parameter 'projectTypeFilter' cannot be null.");
        else if (projectTypeFilter !== undefined)
            url_ += "ProjectTypeFilter=" + encodeURIComponent("" + projectTypeFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (withRootingFilter === undefined || withRootingFilter === null)
            throw new globalThis.Error("The parameter 'withRootingFilter' must be defined and cannot be null.");
        else
            url_ += "WithRootingFilter=" + encodeURIComponent("" + withRootingFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllYes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllYes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRootingPendingForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRootingPendingForViewDto[]>;
        }));
    }

    protected processGetAllYes(response: HttpResponseBase): Observable<GetRootingPendingForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRootingPendingForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param projectTypeFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllRootingPendings(filter: string | undefined, projectNameFilter: string | undefined, sourcePlantGroupNumberFilter: number | undefined, projectTypeFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, withRootingFilter: EnumWhitRooting, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetRootingPendingForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetAllRootingPendings?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        if (projectTypeFilter === null)
            throw new globalThis.Error("The parameter 'projectTypeFilter' cannot be null.");
        else if (projectTypeFilter !== undefined)
            url_ += "ProjectTypeFilter=" + encodeURIComponent("" + projectTypeFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (withRootingFilter === undefined || withRootingFilter === null)
            throw new globalThis.Error("The parameter 'withRootingFilter' must be defined and cannot be null.");
        else
            url_ += "WithRootingFilter=" + encodeURIComponent("" + withRootingFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRootingPendings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRootingPendings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRootingPendingForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRootingPendingForViewDto[]>;
        }));
    }

    protected processGetAllRootingPendings(response: HttpResponseBase): Observable<GetRootingPendingForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRootingPendingForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param projectNameFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param projectTypeFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getRootingPendingsToExcel(filter: string | undefined, projectNameFilter: string | undefined, sourcePlantGroupNumberFilter: number | undefined, projectTypeFilter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, withRootingFilter: EnumWhitRooting, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetRootingPendingsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            url_ += "ProjectNameFilter=" + encodeURIComponent("" + projectNameFilter) + "&";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        if (projectTypeFilter === null)
            throw new globalThis.Error("The parameter 'projectTypeFilter' cannot be null.");
        else if (projectTypeFilter !== undefined)
            url_ += "ProjectTypeFilter=" + encodeURIComponent("" + projectTypeFilter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (withRootingFilter === undefined || withRootingFilter === null)
            throw new globalThis.Error("The parameter 'withRootingFilter' must be defined and cannot be null.");
        else
            url_ += "WithRootingFilter=" + encodeURIComponent("" + withRootingFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRootingPendingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRootingPendingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRootingPendingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRootingPendingForView(id: number | undefined): Observable<GetRootingPendingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RootingPendings/GetRootingPendingForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRootingPendingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRootingPendingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRootingPendingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRootingPendingForViewDto>;
        }));
    }

    protected processGetRootingPendingForView(response: HttpResponseBase): Observable<GetRootingPendingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRootingPendingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedDestinationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedDestinationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedDestinationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedDestinationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedDestinationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedDestinationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedDestinationForView(id: number | undefined): Observable<GetSeedDestinationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/GetSeedDestinationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedDestinationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedDestinationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedDestinationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedDestinationForViewDto>;
        }));
    }

    protected processGetSeedDestinationForView(response: HttpResponseBase): Observable<GetSeedDestinationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedDestinationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedDestinationForEdit(id: number | undefined): Observable<GetSeedDestinationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/GetSeedDestinationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedDestinationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedDestinationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedDestinationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedDestinationForEditOutput>;
        }));
    }

    protected processGetSeedDestinationForEdit(response: HttpResponseBase): Observable<GetSeedDestinationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedDestinationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedDestinationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getSeedDestinationsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedDestinations/GetSeedDestinationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedDestinationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedDestinationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedDestinationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedlingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param seedBBSFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, seedBBSFilter: string | undefined, cloneBBXFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedlingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedlingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedlingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedlingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedlingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedlingForEdit(id: number | undefined): Observable<GetSeedlingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/GetSeedlingForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedlingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedlingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedlingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedlingForEditOutput>;
        }));
    }

    protected processGetSeedlingForEdit(response: HttpResponseBase): Observable<GetSeedlingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedlingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedlingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedlingSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedlingSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedlingSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedlingSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedlingSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedlingCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seedlings/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedlingCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedlingCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedlingCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedlingCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedMixturesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxPorcentajeFilter (optional) 
     * @param minPorcentajeFilter (optional) 
     * @param maxSeedCompositionIDFilter (optional) 
     * @param minSeedCompositionIDFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxPorcentajeFilter: number | undefined, minPorcentajeFilter: number | undefined, maxSeedCompositionIDFilter: number | undefined, minSeedCompositionIDFilter: number | undefined, seedBBSFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedMixtureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPorcentajeFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentajeFilter' cannot be null.");
        else if (maxPorcentajeFilter !== undefined)
            url_ += "MaxPorcentajeFilter=" + encodeURIComponent("" + maxPorcentajeFilter) + "&";
        if (minPorcentajeFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentajeFilter' cannot be null.");
        else if (minPorcentajeFilter !== undefined)
            url_ += "MinPorcentajeFilter=" + encodeURIComponent("" + minPorcentajeFilter) + "&";
        if (maxSeedCompositionIDFilter === null)
            throw new globalThis.Error("The parameter 'maxSeedCompositionIDFilter' cannot be null.");
        else if (maxSeedCompositionIDFilter !== undefined)
            url_ += "MaxSeedCompositionIDFilter=" + encodeURIComponent("" + maxSeedCompositionIDFilter) + "&";
        if (minSeedCompositionIDFilter === null)
            throw new globalThis.Error("The parameter 'minSeedCompositionIDFilter' cannot be null.");
        else if (minSeedCompositionIDFilter !== undefined)
            url_ += "MinSeedCompositionIDFilter=" + encodeURIComponent("" + minSeedCompositionIDFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedMixtureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedMixtureForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedMixtureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedMixtureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedMixtureForView(id: number | undefined): Observable<GetSeedMixtureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/GetSeedMixtureForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedMixtureForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedMixtureForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedMixtureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedMixtureForViewDto>;
        }));
    }

    protected processGetSeedMixtureForView(response: HttpResponseBase): Observable<GetSeedMixtureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedMixtureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedMixtureForEdit(id: number | undefined): Observable<GetSeedMixtureForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/GetSeedMixtureForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedMixtureForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedMixtureForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedMixtureForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedMixtureForEditOutput>;
        }));
    }

    protected processGetSeedMixtureForEdit(response: HttpResponseBase): Observable<GetSeedMixtureForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedMixtureForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedMixtureDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxPorcentajeFilter (optional) 
     * @param minPorcentajeFilter (optional) 
     * @param maxSeedCompositionIDFilter (optional) 
     * @param minSeedCompositionIDFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @return OK
     */
    getSeedMixturesToExcel(filter: string | undefined, maxPorcentajeFilter: number | undefined, minPorcentajeFilter: number | undefined, maxSeedCompositionIDFilter: number | undefined, minSeedCompositionIDFilter: number | undefined, seedBBSFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/GetSeedMixturesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPorcentajeFilter === null)
            throw new globalThis.Error("The parameter 'maxPorcentajeFilter' cannot be null.");
        else if (maxPorcentajeFilter !== undefined)
            url_ += "MaxPorcentajeFilter=" + encodeURIComponent("" + maxPorcentajeFilter) + "&";
        if (minPorcentajeFilter === null)
            throw new globalThis.Error("The parameter 'minPorcentajeFilter' cannot be null.");
        else if (minPorcentajeFilter !== undefined)
            url_ += "MinPorcentajeFilter=" + encodeURIComponent("" + minPorcentajeFilter) + "&";
        if (maxSeedCompositionIDFilter === null)
            throw new globalThis.Error("The parameter 'maxSeedCompositionIDFilter' cannot be null.");
        else if (maxSeedCompositionIDFilter !== undefined)
            url_ += "MaxSeedCompositionIDFilter=" + encodeURIComponent("" + maxSeedCompositionIDFilter) + "&";
        if (minSeedCompositionIDFilter === null)
            throw new globalThis.Error("The parameter 'minSeedCompositionIDFilter' cannot be null.");
        else if (minSeedCompositionIDFilter !== undefined)
            url_ += "MinSeedCompositionIDFilter=" + encodeURIComponent("" + minSeedCompositionIDFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedMixturesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedMixturesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedMixturesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedMixtureSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedMixtures/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedMixtureSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedMixtureSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedMixtureSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedMixtureSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param seedIdsFilter (optional) 
     * @param maxLoteNumberFilter (optional) 
     * @param minLoteNumberFilter (optional) 
     * @param speciesFilter (optional) 
     * @param speciesDisplayNameFilter (optional) 
     * @param maxReceivedDateFilter (optional) 
     * @param minReceivedDateFilter (optional) 
     * @param idMotherTreeFilter (optional) 
     * @param bBSMotherFilter (optional) 
     * @param maxBlockMotherFilter (optional) 
     * @param minBlockMotherFilter (optional) 
     * @param maxSubBlockMotherFilter (optional) 
     * @param minSubBlockMotherFilter (optional) 
     * @param maxTreeNumberMotherFilter (optional) 
     * @param minTreeNumberMotherFilter (optional) 
     * @param speciesMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idFatherTreeFilter (optional) 
     * @param maxIdTrialFatherFilter (optional) 
     * @param minIdTrialFatherFilter (optional) 
     * @param bBSFatherFilter (optional) 
     * @param maxBlockFatherFilter (optional) 
     * @param minBlockFatherFilter (optional) 
     * @param maxSubBlockFatherFilter (optional) 
     * @param minSubBlockFatherFilter (optional) 
     * @param maxIdPatherTreeFilter (optional) 
     * @param minIdPatherTreeFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param supplierCodeFilter (optional) 
     * @param isMixSeedFilter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param categorySeedOriginNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param seedDestinationNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, seedIdsFilter: (number | undefined)[] | undefined, maxLoteNumberFilter: number | undefined, minLoteNumberFilter: number | undefined, speciesFilter: string[] | undefined, speciesDisplayNameFilter: string | undefined, maxReceivedDateFilter: DateTime | undefined, minReceivedDateFilter: DateTime | undefined, idMotherTreeFilter: string[] | undefined, bBSMotherFilter: string[] | undefined, maxBlockMotherFilter: number | undefined, minBlockMotherFilter: number | undefined, maxSubBlockMotherFilter: number | undefined, minSubBlockMotherFilter: number | undefined, maxTreeNumberMotherFilter: number | undefined, minTreeNumberMotherFilter: number | undefined, speciesMotherFilter: string[] | undefined, bBPFatherFilter: string[] | undefined, idFatherTreeFilter: string[] | undefined, maxIdTrialFatherFilter: number | undefined, minIdTrialFatherFilter: number | undefined, bBSFatherFilter: string[] | undefined, maxBlockFatherFilter: number | undefined, minBlockFatherFilter: number | undefined, maxSubBlockFatherFilter: number | undefined, minSubBlockFatherFilter: number | undefined, maxIdPatherTreeFilter: number | undefined, minIdPatherTreeFilter: number | undefined, specieFatherFilter: string[] | undefined, supplierCodeFilter: string[] | undefined, isMixSeedFilter: number | undefined, typeSpecieNameFilter: string[] | undefined, categorySeedOriginNameFilter: string[] | undefined, crossingTechniqueNameFilter: string[] | undefined, trialStandNameFilter: string[] | undefined, supplierNameFilter: string[] | undefined, seedDestinationNameFilter: string[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedIdsFilter === null)
            throw new globalThis.Error("The parameter 'seedIdsFilter' cannot be null.");
        else if (seedIdsFilter !== undefined)
            seedIdsFilter && seedIdsFilter.forEach(item => { url_ += "SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxLoteNumberFilter' cannot be null.");
        else if (maxLoteNumberFilter !== undefined)
            url_ += "MaxLoteNumberFilter=" + encodeURIComponent("" + maxLoteNumberFilter) + "&";
        if (minLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'minLoteNumberFilter' cannot be null.");
        else if (minLoteNumberFilter !== undefined)
            url_ += "MinLoteNumberFilter=" + encodeURIComponent("" + minLoteNumberFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            speciesFilter && speciesFilter.forEach(item => { url_ += "SpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (speciesDisplayNameFilter === null)
            throw new globalThis.Error("The parameter 'speciesDisplayNameFilter' cannot be null.");
        else if (speciesDisplayNameFilter !== undefined)
            url_ += "SpeciesDisplayNameFilter=" + encodeURIComponent("" + speciesDisplayNameFilter) + "&";
        if (maxReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'maxReceivedDateFilter' cannot be null.");
        else if (maxReceivedDateFilter !== undefined)
            url_ += "MaxReceivedDateFilter=" + encodeURIComponent(maxReceivedDateFilter ? "" + maxReceivedDateFilter.toString() : "") + "&";
        if (minReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'minReceivedDateFilter' cannot be null.");
        else if (minReceivedDateFilter !== undefined)
            url_ += "MinReceivedDateFilter=" + encodeURIComponent(minReceivedDateFilter ? "" + minReceivedDateFilter.toString() : "") + "&";
        if (idMotherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idMotherTreeFilter' cannot be null.");
        else if (idMotherTreeFilter !== undefined)
            idMotherTreeFilter && idMotherTreeFilter.forEach(item => { url_ += "IdMotherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBSMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBSMotherFilter' cannot be null.");
        else if (bBSMotherFilter !== undefined)
            bBSMotherFilter && bBSMotherFilter.forEach(item => { url_ += "BBSMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockMotherFilter' cannot be null.");
        else if (maxBlockMotherFilter !== undefined)
            url_ += "MaxBlockMotherFilter=" + encodeURIComponent("" + maxBlockMotherFilter) + "&";
        if (minBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockMotherFilter' cannot be null.");
        else if (minBlockMotherFilter !== undefined)
            url_ += "MinBlockMotherFilter=" + encodeURIComponent("" + minBlockMotherFilter) + "&";
        if (maxSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockMotherFilter' cannot be null.");
        else if (maxSubBlockMotherFilter !== undefined)
            url_ += "MaxSubBlockMotherFilter=" + encodeURIComponent("" + maxSubBlockMotherFilter) + "&";
        if (minSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockMotherFilter' cannot be null.");
        else if (minSubBlockMotherFilter !== undefined)
            url_ += "MinSubBlockMotherFilter=" + encodeURIComponent("" + minSubBlockMotherFilter) + "&";
        if (maxTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberMotherFilter' cannot be null.");
        else if (maxTreeNumberMotherFilter !== undefined)
            url_ += "MaxTreeNumberMotherFilter=" + encodeURIComponent("" + maxTreeNumberMotherFilter) + "&";
        if (minTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberMotherFilter' cannot be null.");
        else if (minTreeNumberMotherFilter !== undefined)
            url_ += "MinTreeNumberMotherFilter=" + encodeURIComponent("" + minTreeNumberMotherFilter) + "&";
        if (speciesMotherFilter === null)
            throw new globalThis.Error("The parameter 'speciesMotherFilter' cannot be null.");
        else if (speciesMotherFilter !== undefined)
            speciesMotherFilter && speciesMotherFilter.forEach(item => { url_ += "SpeciesMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            bBPFatherFilter && bBPFatherFilter.forEach(item => { url_ += "BBPFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (idFatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idFatherTreeFilter' cannot be null.");
        else if (idFatherTreeFilter !== undefined)
            idFatherTreeFilter && idFatherTreeFilter.forEach(item => { url_ += "IdFatherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxIdTrialFatherFilter' cannot be null.");
        else if (maxIdTrialFatherFilter !== undefined)
            url_ += "MaxIdTrialFatherFilter=" + encodeURIComponent("" + maxIdTrialFatherFilter) + "&";
        if (minIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'minIdTrialFatherFilter' cannot be null.");
        else if (minIdTrialFatherFilter !== undefined)
            url_ += "MinIdTrialFatherFilter=" + encodeURIComponent("" + minIdTrialFatherFilter) + "&";
        if (bBSFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBSFatherFilter' cannot be null.");
        else if (bBSFatherFilter !== undefined)
            bBSFatherFilter && bBSFatherFilter.forEach(item => { url_ += "BBSFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFatherFilter' cannot be null.");
        else if (maxBlockFatherFilter !== undefined)
            url_ += "MaxBlockFatherFilter=" + encodeURIComponent("" + maxBlockFatherFilter) + "&";
        if (minBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFatherFilter' cannot be null.");
        else if (minBlockFatherFilter !== undefined)
            url_ += "MinBlockFatherFilter=" + encodeURIComponent("" + minBlockFatherFilter) + "&";
        if (maxSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockFatherFilter' cannot be null.");
        else if (maxSubBlockFatherFilter !== undefined)
            url_ += "MaxSubBlockFatherFilter=" + encodeURIComponent("" + maxSubBlockFatherFilter) + "&";
        if (minSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockFatherFilter' cannot be null.");
        else if (minSubBlockFatherFilter !== undefined)
            url_ += "MinSubBlockFatherFilter=" + encodeURIComponent("" + minSubBlockFatherFilter) + "&";
        if (maxIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'maxIdPatherTreeFilter' cannot be null.");
        else if (maxIdPatherTreeFilter !== undefined)
            url_ += "MaxIdPatherTreeFilter=" + encodeURIComponent("" + maxIdPatherTreeFilter) + "&";
        if (minIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'minIdPatherTreeFilter' cannot be null.");
        else if (minIdPatherTreeFilter !== undefined)
            url_ += "MinIdPatherTreeFilter=" + encodeURIComponent("" + minIdPatherTreeFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            specieFatherFilter && specieFatherFilter.forEach(item => { url_ += "SpecieFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierCodeFilter === null)
            throw new globalThis.Error("The parameter 'supplierCodeFilter' cannot be null.");
        else if (supplierCodeFilter !== undefined)
            supplierCodeFilter && supplierCodeFilter.forEach(item => { url_ += "SupplierCodeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (isMixSeedFilter === null)
            throw new globalThis.Error("The parameter 'isMixSeedFilter' cannot be null.");
        else if (isMixSeedFilter !== undefined)
            url_ += "IsMixSeedFilter=" + encodeURIComponent("" + isMixSeedFilter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            typeSpecieNameFilter && typeSpecieNameFilter.forEach(item => { url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (categorySeedOriginNameFilter === null)
            throw new globalThis.Error("The parameter 'categorySeedOriginNameFilter' cannot be null.");
        else if (categorySeedOriginNameFilter !== undefined)
            categorySeedOriginNameFilter && categorySeedOriginNameFilter.forEach(item => { url_ += "CategorySeedOriginNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            crossingTechniqueNameFilter && crossingTechniqueNameFilter.forEach(item => { url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            trialStandNameFilter && trialStandNameFilter.forEach(item => { url_ += "TrialStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            supplierNameFilter && supplierNameFilter.forEach(item => { url_ += "SupplierNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (seedDestinationNameFilter === null)
            throw new globalThis.Error("The parameter 'seedDestinationNameFilter' cannot be null.");
        else if (seedDestinationNameFilter !== undefined)
            seedDestinationNameFilter && seedDestinationNameFilter.forEach(item => { url_ += "SeedDestinationNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbsFilter (optional) 
     * @return OK
     */
    getAllDistinctSeedIds(bbsFilter: string | undefined): Observable<SeedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllDistinctSeedIds?";
        if (bbsFilter === null)
            throw new globalThis.Error("The parameter 'bbsFilter' cannot be null.");
        else if (bbsFilter !== undefined)
            url_ += "bbsFilter=" + encodeURIComponent("" + bbsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctSeedIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctSeedIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedDto[]>;
        }));
    }

    protected processGetAllDistinctSeedIds(response: HttpResponseBase): Observable<SeedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param siteorigen (optional) 
     * @return OK
     */
    isMixture(siteorigen: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/IsMixture?";
        if (siteorigen === null)
            throw new globalThis.Error("The parameter 'siteorigen' cannot be null.");
        else if (siteorigen !== undefined)
            url_ += "siteorigen=" + encodeURIComponent("" + siteorigen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMixture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMixture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsMixture(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedForView(id: number | undefined): Observable<GetSeedForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSeedForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedForViewDto>;
        }));
    }

    protected processGetSeedForView(response: HttpResponseBase): Observable<GetSeedForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedForEdit(id: number | undefined): Observable<GetSeedForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSeedForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedForEditOutput>;
        }));
    }

    protected processGetSeedForEdit(response: HttpResponseBase): Observable<GetSeedForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param seedIdsFilter (optional) 
     * @param maxLoteNumberFilter (optional) 
     * @param minLoteNumberFilter (optional) 
     * @param speciesFilter (optional) 
     * @param maxReceivedDateFilter (optional) 
     * @param minReceivedDateFilter (optional) 
     * @param idMotherTreeFilter (optional) 
     * @param bBSMotherFilter (optional) 
     * @param maxBlockMotherFilter (optional) 
     * @param minBlockMotherFilter (optional) 
     * @param maxSubBlockMotherFilter (optional) 
     * @param minSubBlockMotherFilter (optional) 
     * @param maxTreeNumberMotherFilter (optional) 
     * @param minTreeNumberMotherFilter (optional) 
     * @param speciesMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idFatherTreeFilter (optional) 
     * @param maxIdTrialFatherFilter (optional) 
     * @param minIdTrialFatherFilter (optional) 
     * @param bBSFatherFilter (optional) 
     * @param maxBlockFatherFilter (optional) 
     * @param minBlockFatherFilter (optional) 
     * @param maxSubBlockFatherFilter (optional) 
     * @param minSubBlockFatherFilter (optional) 
     * @param maxIdPatherTreeFilter (optional) 
     * @param minIdPatherTreeFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param supplierCodeFilter (optional) 
     * @param isMixSeedFilter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param categorySeedOriginNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param seedDestinationNameFilter (optional) 
     * @return OK
     */
    deleteMassiveSeed(filter: string | undefined, seedIdsFilter: (number | undefined)[] | undefined, maxLoteNumberFilter: number | undefined, minLoteNumberFilter: number | undefined, speciesFilter: string[] | undefined, maxReceivedDateFilter: DateTime | undefined, minReceivedDateFilter: DateTime | undefined, idMotherTreeFilter: string[] | undefined, bBSMotherFilter: string[] | undefined, maxBlockMotherFilter: number | undefined, minBlockMotherFilter: number | undefined, maxSubBlockMotherFilter: number | undefined, minSubBlockMotherFilter: number | undefined, maxTreeNumberMotherFilter: number | undefined, minTreeNumberMotherFilter: number | undefined, speciesMotherFilter: string[] | undefined, bBPFatherFilter: string[] | undefined, idFatherTreeFilter: string[] | undefined, maxIdTrialFatherFilter: number | undefined, minIdTrialFatherFilter: number | undefined, bBSFatherFilter: string[] | undefined, maxBlockFatherFilter: number | undefined, minBlockFatherFilter: number | undefined, maxSubBlockFatherFilter: number | undefined, minSubBlockFatherFilter: number | undefined, maxIdPatherTreeFilter: number | undefined, minIdPatherTreeFilter: number | undefined, specieFatherFilter: string[] | undefined, supplierCodeFilter: string[] | undefined, isMixSeedFilter: number | undefined, typeSpecieNameFilter: string[] | undefined, categorySeedOriginNameFilter: string[] | undefined, crossingTechniqueNameFilter: string[] | undefined, trialStandNameFilter: string[] | undefined, supplierNameFilter: string[] | undefined, seedDestinationNameFilter: string[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/DeleteMassiveSeed?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedIdsFilter === null)
            throw new globalThis.Error("The parameter 'seedIdsFilter' cannot be null.");
        else if (seedIdsFilter !== undefined)
            seedIdsFilter && seedIdsFilter.forEach(item => { url_ += "SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxLoteNumberFilter' cannot be null.");
        else if (maxLoteNumberFilter !== undefined)
            url_ += "MaxLoteNumberFilter=" + encodeURIComponent("" + maxLoteNumberFilter) + "&";
        if (minLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'minLoteNumberFilter' cannot be null.");
        else if (minLoteNumberFilter !== undefined)
            url_ += "MinLoteNumberFilter=" + encodeURIComponent("" + minLoteNumberFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            speciesFilter && speciesFilter.forEach(item => { url_ += "SpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'maxReceivedDateFilter' cannot be null.");
        else if (maxReceivedDateFilter !== undefined)
            url_ += "MaxReceivedDateFilter=" + encodeURIComponent(maxReceivedDateFilter ? "" + maxReceivedDateFilter.toString() : "") + "&";
        if (minReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'minReceivedDateFilter' cannot be null.");
        else if (minReceivedDateFilter !== undefined)
            url_ += "MinReceivedDateFilter=" + encodeURIComponent(minReceivedDateFilter ? "" + minReceivedDateFilter.toString() : "") + "&";
        if (idMotherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idMotherTreeFilter' cannot be null.");
        else if (idMotherTreeFilter !== undefined)
            idMotherTreeFilter && idMotherTreeFilter.forEach(item => { url_ += "IdMotherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBSMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBSMotherFilter' cannot be null.");
        else if (bBSMotherFilter !== undefined)
            bBSMotherFilter && bBSMotherFilter.forEach(item => { url_ += "BBSMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockMotherFilter' cannot be null.");
        else if (maxBlockMotherFilter !== undefined)
            url_ += "MaxBlockMotherFilter=" + encodeURIComponent("" + maxBlockMotherFilter) + "&";
        if (minBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockMotherFilter' cannot be null.");
        else if (minBlockMotherFilter !== undefined)
            url_ += "MinBlockMotherFilter=" + encodeURIComponent("" + minBlockMotherFilter) + "&";
        if (maxSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockMotherFilter' cannot be null.");
        else if (maxSubBlockMotherFilter !== undefined)
            url_ += "MaxSubBlockMotherFilter=" + encodeURIComponent("" + maxSubBlockMotherFilter) + "&";
        if (minSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockMotherFilter' cannot be null.");
        else if (minSubBlockMotherFilter !== undefined)
            url_ += "MinSubBlockMotherFilter=" + encodeURIComponent("" + minSubBlockMotherFilter) + "&";
        if (maxTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberMotherFilter' cannot be null.");
        else if (maxTreeNumberMotherFilter !== undefined)
            url_ += "MaxTreeNumberMotherFilter=" + encodeURIComponent("" + maxTreeNumberMotherFilter) + "&";
        if (minTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberMotherFilter' cannot be null.");
        else if (minTreeNumberMotherFilter !== undefined)
            url_ += "MinTreeNumberMotherFilter=" + encodeURIComponent("" + minTreeNumberMotherFilter) + "&";
        if (speciesMotherFilter === null)
            throw new globalThis.Error("The parameter 'speciesMotherFilter' cannot be null.");
        else if (speciesMotherFilter !== undefined)
            speciesMotherFilter && speciesMotherFilter.forEach(item => { url_ += "SpeciesMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            bBPFatherFilter && bBPFatherFilter.forEach(item => { url_ += "BBPFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (idFatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idFatherTreeFilter' cannot be null.");
        else if (idFatherTreeFilter !== undefined)
            idFatherTreeFilter && idFatherTreeFilter.forEach(item => { url_ += "IdFatherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxIdTrialFatherFilter' cannot be null.");
        else if (maxIdTrialFatherFilter !== undefined)
            url_ += "MaxIdTrialFatherFilter=" + encodeURIComponent("" + maxIdTrialFatherFilter) + "&";
        if (minIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'minIdTrialFatherFilter' cannot be null.");
        else if (minIdTrialFatherFilter !== undefined)
            url_ += "MinIdTrialFatherFilter=" + encodeURIComponent("" + minIdTrialFatherFilter) + "&";
        if (bBSFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBSFatherFilter' cannot be null.");
        else if (bBSFatherFilter !== undefined)
            bBSFatherFilter && bBSFatherFilter.forEach(item => { url_ += "BBSFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFatherFilter' cannot be null.");
        else if (maxBlockFatherFilter !== undefined)
            url_ += "MaxBlockFatherFilter=" + encodeURIComponent("" + maxBlockFatherFilter) + "&";
        if (minBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFatherFilter' cannot be null.");
        else if (minBlockFatherFilter !== undefined)
            url_ += "MinBlockFatherFilter=" + encodeURIComponent("" + minBlockFatherFilter) + "&";
        if (maxSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockFatherFilter' cannot be null.");
        else if (maxSubBlockFatherFilter !== undefined)
            url_ += "MaxSubBlockFatherFilter=" + encodeURIComponent("" + maxSubBlockFatherFilter) + "&";
        if (minSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockFatherFilter' cannot be null.");
        else if (minSubBlockFatherFilter !== undefined)
            url_ += "MinSubBlockFatherFilter=" + encodeURIComponent("" + minSubBlockFatherFilter) + "&";
        if (maxIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'maxIdPatherTreeFilter' cannot be null.");
        else if (maxIdPatherTreeFilter !== undefined)
            url_ += "MaxIdPatherTreeFilter=" + encodeURIComponent("" + maxIdPatherTreeFilter) + "&";
        if (minIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'minIdPatherTreeFilter' cannot be null.");
        else if (minIdPatherTreeFilter !== undefined)
            url_ += "MinIdPatherTreeFilter=" + encodeURIComponent("" + minIdPatherTreeFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            specieFatherFilter && specieFatherFilter.forEach(item => { url_ += "SpecieFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierCodeFilter === null)
            throw new globalThis.Error("The parameter 'supplierCodeFilter' cannot be null.");
        else if (supplierCodeFilter !== undefined)
            supplierCodeFilter && supplierCodeFilter.forEach(item => { url_ += "SupplierCodeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (isMixSeedFilter === null)
            throw new globalThis.Error("The parameter 'isMixSeedFilter' cannot be null.");
        else if (isMixSeedFilter !== undefined)
            url_ += "IsMixSeedFilter=" + encodeURIComponent("" + isMixSeedFilter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            typeSpecieNameFilter && typeSpecieNameFilter.forEach(item => { url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (categorySeedOriginNameFilter === null)
            throw new globalThis.Error("The parameter 'categorySeedOriginNameFilter' cannot be null.");
        else if (categorySeedOriginNameFilter !== undefined)
            categorySeedOriginNameFilter && categorySeedOriginNameFilter.forEach(item => { url_ += "CategorySeedOriginNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            crossingTechniqueNameFilter && crossingTechniqueNameFilter.forEach(item => { url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            trialStandNameFilter && trialStandNameFilter.forEach(item => { url_ += "TrialStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            supplierNameFilter && supplierNameFilter.forEach(item => { url_ += "SupplierNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (seedDestinationNameFilter === null)
            throw new globalThis.Error("The parameter 'seedDestinationNameFilter' cannot be null.");
        else if (seedDestinationNameFilter !== undefined)
            seedDestinationNameFilter && seedDestinationNameFilter.forEach(item => { url_ += "SeedDestinationNameFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveSeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveSeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveSeed(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param seedIdsFilter (optional) 
     * @param maxLoteNumberFilter (optional) 
     * @param minLoteNumberFilter (optional) 
     * @param speciesFilter (optional) 
     * @param maxReceivedDateFilter (optional) 
     * @param minReceivedDateFilter (optional) 
     * @param idMotherTreeFilter (optional) 
     * @param bBSMotherFilter (optional) 
     * @param maxBlockMotherFilter (optional) 
     * @param minBlockMotherFilter (optional) 
     * @param maxSubBlockMotherFilter (optional) 
     * @param minSubBlockMotherFilter (optional) 
     * @param maxTreeNumberMotherFilter (optional) 
     * @param minTreeNumberMotherFilter (optional) 
     * @param speciesMotherFilter (optional) 
     * @param bBPFatherFilter (optional) 
     * @param idFatherTreeFilter (optional) 
     * @param maxIdTrialFatherFilter (optional) 
     * @param minIdTrialFatherFilter (optional) 
     * @param bBSFatherFilter (optional) 
     * @param maxBlockFatherFilter (optional) 
     * @param minBlockFatherFilter (optional) 
     * @param maxSubBlockFatherFilter (optional) 
     * @param minSubBlockFatherFilter (optional) 
     * @param maxIdPatherTreeFilter (optional) 
     * @param minIdPatherTreeFilter (optional) 
     * @param specieFatherFilter (optional) 
     * @param supplierCodeFilter (optional) 
     * @param isMixSeedFilter (optional) 
     * @param typeSpecieNameFilter (optional) 
     * @param categorySeedOriginNameFilter (optional) 
     * @param crossingTechniqueNameFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param supplierNameFilter (optional) 
     * @param seedDestinationNameFilter (optional) 
     * @return OK
     */
    getSeedsToExcel(filter: string | undefined, seedIdsFilter: (number | undefined)[] | undefined, maxLoteNumberFilter: number | undefined, minLoteNumberFilter: number | undefined, speciesFilter: string[] | undefined, maxReceivedDateFilter: DateTime | undefined, minReceivedDateFilter: DateTime | undefined, idMotherTreeFilter: string[] | undefined, bBSMotherFilter: string[] | undefined, maxBlockMotherFilter: number | undefined, minBlockMotherFilter: number | undefined, maxSubBlockMotherFilter: number | undefined, minSubBlockMotherFilter: number | undefined, maxTreeNumberMotherFilter: number | undefined, minTreeNumberMotherFilter: number | undefined, speciesMotherFilter: string[] | undefined, bBPFatherFilter: string[] | undefined, idFatherTreeFilter: string[] | undefined, maxIdTrialFatherFilter: number | undefined, minIdTrialFatherFilter: number | undefined, bBSFatherFilter: string[] | undefined, maxBlockFatherFilter: number | undefined, minBlockFatherFilter: number | undefined, maxSubBlockFatherFilter: number | undefined, minSubBlockFatherFilter: number | undefined, maxIdPatherTreeFilter: number | undefined, minIdPatherTreeFilter: number | undefined, specieFatherFilter: string[] | undefined, supplierCodeFilter: string[] | undefined, isMixSeedFilter: number | undefined, typeSpecieNameFilter: string[] | undefined, categorySeedOriginNameFilter: string[] | undefined, crossingTechniqueNameFilter: string[] | undefined, trialStandNameFilter: string[] | undefined, supplierNameFilter: string[] | undefined, seedDestinationNameFilter: string[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSeedsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (seedIdsFilter === null)
            throw new globalThis.Error("The parameter 'seedIdsFilter' cannot be null.");
        else if (seedIdsFilter !== undefined)
            seedIdsFilter && seedIdsFilter.forEach(item => { url_ += "SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxLoteNumberFilter' cannot be null.");
        else if (maxLoteNumberFilter !== undefined)
            url_ += "MaxLoteNumberFilter=" + encodeURIComponent("" + maxLoteNumberFilter) + "&";
        if (minLoteNumberFilter === null)
            throw new globalThis.Error("The parameter 'minLoteNumberFilter' cannot be null.");
        else if (minLoteNumberFilter !== undefined)
            url_ += "MinLoteNumberFilter=" + encodeURIComponent("" + minLoteNumberFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            speciesFilter && speciesFilter.forEach(item => { url_ += "SpeciesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'maxReceivedDateFilter' cannot be null.");
        else if (maxReceivedDateFilter !== undefined)
            url_ += "MaxReceivedDateFilter=" + encodeURIComponent(maxReceivedDateFilter ? "" + maxReceivedDateFilter.toString() : "") + "&";
        if (minReceivedDateFilter === null)
            throw new globalThis.Error("The parameter 'minReceivedDateFilter' cannot be null.");
        else if (minReceivedDateFilter !== undefined)
            url_ += "MinReceivedDateFilter=" + encodeURIComponent(minReceivedDateFilter ? "" + minReceivedDateFilter.toString() : "") + "&";
        if (idMotherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idMotherTreeFilter' cannot be null.");
        else if (idMotherTreeFilter !== undefined)
            idMotherTreeFilter && idMotherTreeFilter.forEach(item => { url_ += "IdMotherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBSMotherFilter === null)
            throw new globalThis.Error("The parameter 'bBSMotherFilter' cannot be null.");
        else if (bBSMotherFilter !== undefined)
            bBSMotherFilter && bBSMotherFilter.forEach(item => { url_ += "BBSMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockMotherFilter' cannot be null.");
        else if (maxBlockMotherFilter !== undefined)
            url_ += "MaxBlockMotherFilter=" + encodeURIComponent("" + maxBlockMotherFilter) + "&";
        if (minBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockMotherFilter' cannot be null.");
        else if (minBlockMotherFilter !== undefined)
            url_ += "MinBlockMotherFilter=" + encodeURIComponent("" + minBlockMotherFilter) + "&";
        if (maxSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockMotherFilter' cannot be null.");
        else if (maxSubBlockMotherFilter !== undefined)
            url_ += "MaxSubBlockMotherFilter=" + encodeURIComponent("" + maxSubBlockMotherFilter) + "&";
        if (minSubBlockMotherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockMotherFilter' cannot be null.");
        else if (minSubBlockMotherFilter !== undefined)
            url_ += "MinSubBlockMotherFilter=" + encodeURIComponent("" + minSubBlockMotherFilter) + "&";
        if (maxTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'maxTreeNumberMotherFilter' cannot be null.");
        else if (maxTreeNumberMotherFilter !== undefined)
            url_ += "MaxTreeNumberMotherFilter=" + encodeURIComponent("" + maxTreeNumberMotherFilter) + "&";
        if (minTreeNumberMotherFilter === null)
            throw new globalThis.Error("The parameter 'minTreeNumberMotherFilter' cannot be null.");
        else if (minTreeNumberMotherFilter !== undefined)
            url_ += "MinTreeNumberMotherFilter=" + encodeURIComponent("" + minTreeNumberMotherFilter) + "&";
        if (speciesMotherFilter === null)
            throw new globalThis.Error("The parameter 'speciesMotherFilter' cannot be null.");
        else if (speciesMotherFilter !== undefined)
            speciesMotherFilter && speciesMotherFilter.forEach(item => { url_ += "SpeciesMotherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (bBPFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBPFatherFilter' cannot be null.");
        else if (bBPFatherFilter !== undefined)
            bBPFatherFilter && bBPFatherFilter.forEach(item => { url_ += "BBPFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (idFatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'idFatherTreeFilter' cannot be null.");
        else if (idFatherTreeFilter !== undefined)
            idFatherTreeFilter && idFatherTreeFilter.forEach(item => { url_ += "IdFatherTreeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxIdTrialFatherFilter' cannot be null.");
        else if (maxIdTrialFatherFilter !== undefined)
            url_ += "MaxIdTrialFatherFilter=" + encodeURIComponent("" + maxIdTrialFatherFilter) + "&";
        if (minIdTrialFatherFilter === null)
            throw new globalThis.Error("The parameter 'minIdTrialFatherFilter' cannot be null.");
        else if (minIdTrialFatherFilter !== undefined)
            url_ += "MinIdTrialFatherFilter=" + encodeURIComponent("" + minIdTrialFatherFilter) + "&";
        if (bBSFatherFilter === null)
            throw new globalThis.Error("The parameter 'bBSFatherFilter' cannot be null.");
        else if (bBSFatherFilter !== undefined)
            bBSFatherFilter && bBSFatherFilter.forEach(item => { url_ += "BBSFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFatherFilter' cannot be null.");
        else if (maxBlockFatherFilter !== undefined)
            url_ += "MaxBlockFatherFilter=" + encodeURIComponent("" + maxBlockFatherFilter) + "&";
        if (minBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFatherFilter' cannot be null.");
        else if (minBlockFatherFilter !== undefined)
            url_ += "MinBlockFatherFilter=" + encodeURIComponent("" + minBlockFatherFilter) + "&";
        if (maxSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'maxSubBlockFatherFilter' cannot be null.");
        else if (maxSubBlockFatherFilter !== undefined)
            url_ += "MaxSubBlockFatherFilter=" + encodeURIComponent("" + maxSubBlockFatherFilter) + "&";
        if (minSubBlockFatherFilter === null)
            throw new globalThis.Error("The parameter 'minSubBlockFatherFilter' cannot be null.");
        else if (minSubBlockFatherFilter !== undefined)
            url_ += "MinSubBlockFatherFilter=" + encodeURIComponent("" + minSubBlockFatherFilter) + "&";
        if (maxIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'maxIdPatherTreeFilter' cannot be null.");
        else if (maxIdPatherTreeFilter !== undefined)
            url_ += "MaxIdPatherTreeFilter=" + encodeURIComponent("" + maxIdPatherTreeFilter) + "&";
        if (minIdPatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'minIdPatherTreeFilter' cannot be null.");
        else if (minIdPatherTreeFilter !== undefined)
            url_ += "MinIdPatherTreeFilter=" + encodeURIComponent("" + minIdPatherTreeFilter) + "&";
        if (specieFatherFilter === null)
            throw new globalThis.Error("The parameter 'specieFatherFilter' cannot be null.");
        else if (specieFatherFilter !== undefined)
            specieFatherFilter && specieFatherFilter.forEach(item => { url_ += "SpecieFatherFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierCodeFilter === null)
            throw new globalThis.Error("The parameter 'supplierCodeFilter' cannot be null.");
        else if (supplierCodeFilter !== undefined)
            supplierCodeFilter && supplierCodeFilter.forEach(item => { url_ += "SupplierCodeFilter=" + encodeURIComponent("" + item) + "&"; });
        if (isMixSeedFilter === null)
            throw new globalThis.Error("The parameter 'isMixSeedFilter' cannot be null.");
        else if (isMixSeedFilter !== undefined)
            url_ += "IsMixSeedFilter=" + encodeURIComponent("" + isMixSeedFilter) + "&";
        if (typeSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'typeSpecieNameFilter' cannot be null.");
        else if (typeSpecieNameFilter !== undefined)
            typeSpecieNameFilter && typeSpecieNameFilter.forEach(item => { url_ += "TypeSpecieNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (categorySeedOriginNameFilter === null)
            throw new globalThis.Error("The parameter 'categorySeedOriginNameFilter' cannot be null.");
        else if (categorySeedOriginNameFilter !== undefined)
            categorySeedOriginNameFilter && categorySeedOriginNameFilter.forEach(item => { url_ += "CategorySeedOriginNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (crossingTechniqueNameFilter === null)
            throw new globalThis.Error("The parameter 'crossingTechniqueNameFilter' cannot be null.");
        else if (crossingTechniqueNameFilter !== undefined)
            crossingTechniqueNameFilter && crossingTechniqueNameFilter.forEach(item => { url_ += "CrossingTechniqueNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            trialStandNameFilter && trialStandNameFilter.forEach(item => { url_ += "TrialStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (supplierNameFilter === null)
            throw new globalThis.Error("The parameter 'supplierNameFilter' cannot be null.");
        else if (supplierNameFilter !== undefined)
            supplierNameFilter && supplierNameFilter.forEach(item => { url_ += "SupplierNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (seedDestinationNameFilter === null)
            throw new globalThis.Error("The parameter 'seedDestinationNameFilter' cannot be null.");
        else if (seedDestinationNameFilter !== undefined)
            seedDestinationNameFilter && seedDestinationNameFilter.forEach(item => { url_ += "SeedDestinationNameFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTypeSpecieForTableDropdown(): Observable<SeedTypeSpecieLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllTypeSpecieForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeSpecieForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeSpecieForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedTypeSpecieLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedTypeSpecieLookupTableDto[]>;
        }));
    }

    protected processGetAllTypeSpecieForTableDropdown(response: HttpResponseBase): Observable<SeedTypeSpecieLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedTypeSpecieLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCategorySeedOriginForTableDropdown(): Observable<SeedCategorySeedOriginLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllCategorySeedOriginForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategorySeedOriginForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategorySeedOriginForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedCategorySeedOriginLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedCategorySeedOriginLookupTableDto[]>;
        }));
    }

    protected processGetAllCategorySeedOriginForTableDropdown(response: HttpResponseBase): Observable<SeedCategorySeedOriginLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedCategorySeedOriginLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCrossingTechniqueForTableDropdown(): Observable<SeedCrossingTechniqueLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllCrossingTechniqueForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCrossingTechniqueForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCrossingTechniqueForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedCrossingTechniqueLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedCrossingTechniqueLookupTableDto[]>;
        }));
    }

    protected processGetAllCrossingTechniqueForTableDropdown(response: HttpResponseBase): Observable<SeedCrossingTechniqueLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedCrossingTechniqueLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSupplierForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedSupplierLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSupplierForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupplierForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupplierForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedSupplierLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedSupplierLookupTableDto>;
        }));
    }

    protected processGetAllSupplierForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedSupplierLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedSupplierLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSeedDestinationForTableDropdown(): Observable<SeedSeedDestinationLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedDestinationForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedDestinationForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedDestinationForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedSeedDestinationLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedSeedDestinationLookupTableDto[]>;
        }));
    }

    protected processGetAllSeedDestinationForTableDropdown(response: HttpResponseBase): Observable<SeedSeedDestinationLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedSeedDestinationLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllPolenForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllPolenForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolenForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolenForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto>;
        }));
    }

    protected processGetAllPolenForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfControlledCrossingPolenLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfControlledCrossingPolenLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSpeciesGroupNames(): Observable<SpeciesGroupLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSpeciesGroupNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpeciesGroupNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpeciesGroupNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesGroupLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesGroupLookupTableDto[]>;
        }));
    }

    protected processGetAllSpeciesGroupNames(response: HttpResponseBase): Observable<SpeciesGroupLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeciesGroupLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSeedsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/CreateSeedsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSeedsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSeedsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSeedsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditSeedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditSeedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditSeedDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditSeedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditSeedDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param specie (optional) 
     * @return OK
     */
    getSpeciesGroupForEdit(specie: string | undefined): Observable<CreateOrEditSeedDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSpeciesGroupForEdit?";
        if (specie === null)
            throw new globalThis.Error("The parameter 'specie' cannot be null.");
        else if (specie !== undefined)
            url_ += "specie=" + encodeURIComponent("" + specie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeciesGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeciesGroupForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditSeedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditSeedDto>;
        }));
    }

    protected processGetSpeciesGroupForEdit(response: HttpResponseBase): Observable<CreateOrEditSeedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditSeedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sangre (optional) 
     * @param especie (optional) 
     * @param body (optional) 
     * @return OK
     */
    analisis(sangre: number | undefined, especie: string | undefined, body: Nodosangre[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/Analisis?";
        if (sangre === null)
            throw new globalThis.Error("The parameter 'sangre' cannot be null.");
        else if (sangre !== undefined)
            url_ += "sangre=" + encodeURIComponent("" + sangre) + "&";
        if (especie === null)
            throw new globalThis.Error("The parameter 'especie' cannot be null.");
        else if (especie !== undefined)
            url_ += "especie=" + encodeURIComponent("" + especie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalisis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalisis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnalisis(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedIds (optional) 
     * @return OK
     */
    getSeedsCloneDetails(seedIds: number[] | undefined): Observable<SeedGeneratedClonesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSeedsCloneDetails?";
        if (seedIds === null)
            throw new globalThis.Error("The parameter 'seedIds' cannot be null.");
        else if (seedIds !== undefined)
            seedIds && seedIds.forEach(item => { url_ += "seedIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedsCloneDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedsCloneDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedGeneratedClonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedGeneratedClonesDto[]>;
        }));
    }

    protected processGetSeedsCloneDetails(response: HttpResponseBase): Observable<SeedGeneratedClonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedGeneratedClonesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedIds (optional) 
     * @return OK
     */
    getSeedsCloneDetailsToExcel(seedIds: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetSeedsCloneDetailsToExcel?";
        if (seedIds === null)
            throw new globalThis.Error("The parameter 'seedIds' cannot be null.");
        else if (seedIds !== undefined)
            seedIds && seedIds.forEach(item => { url_ += "seedIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedsCloneDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedsCloneDetailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedsCloneDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedSpeciesFilter (optional) 
     * @return OK
     */
    getAllSeedSpeciesForLookupTable(seedSpeciesFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedSpeciesForLookupTable?";
        if (seedSpeciesFilter === null)
            throw new globalThis.Error("The parameter 'seedSpeciesFilter' cannot be null.");
        else if (seedSpeciesFilter !== undefined)
            url_ += "seedSpeciesFilter=" + encodeURIComponent("" + seedSpeciesFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedSpeciesForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedSpeciesForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedSpeciesForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedIdMotherTreeFilter (optional) 
     * @return OK
     */
    getAllSeedMotherTreeForLookupTable(seedIdMotherTreeFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedMotherTreeForLookupTable?";
        if (seedIdMotherTreeFilter === null)
            throw new globalThis.Error("The parameter 'seedIdMotherTreeFilter' cannot be null.");
        else if (seedIdMotherTreeFilter !== undefined)
            url_ += "seedIdMotherTreeFilter=" + encodeURIComponent("" + seedIdMotherTreeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedMotherTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedMotherTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedMotherTreeForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedBBSMotherFilter (optional) 
     * @return OK
     */
    getAllSeedBBSMotherForLookupTable(seedBBSMotherFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedBBSMotherForLookupTable?";
        if (seedBBSMotherFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSMotherFilter' cannot be null.");
        else if (seedBBSMotherFilter !== undefined)
            url_ += "seedBBSMotherFilter=" + encodeURIComponent("" + seedBBSMotherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedBBSMotherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedBBSMotherForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedBBSMotherForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedSpeciesMotherFilter (optional) 
     * @return OK
     */
    getAllSeedSpeciesMotherForLookupTable(seedSpeciesMotherFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedSpeciesMotherForLookupTable?";
        if (seedSpeciesMotherFilter === null)
            throw new globalThis.Error("The parameter 'seedSpeciesMotherFilter' cannot be null.");
        else if (seedSpeciesMotherFilter !== undefined)
            url_ += "seedSpeciesMotherFilter=" + encodeURIComponent("" + seedSpeciesMotherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedSpeciesMotherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedSpeciesMotherForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedSpeciesMotherForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedBBPFathersFilter (optional) 
     * @return OK
     */
    getAllSeedBBPFatherForLookupTable(seedBBPFathersFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedBBPFatherForLookupTable?";
        if (seedBBPFathersFilter === null)
            throw new globalThis.Error("The parameter 'seedBBPFathersFilter' cannot be null.");
        else if (seedBBPFathersFilter !== undefined)
            url_ += "seedBBPFathersFilter=" + encodeURIComponent("" + seedBBPFathersFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedBBPFatherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedBBPFatherForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedBBPFatherForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedIdFatherTreeFilter (optional) 
     * @return OK
     */
    getAllSeedFatherTreeForLookupTable(seedIdFatherTreeFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedFatherTreeForLookupTable?";
        if (seedIdFatherTreeFilter === null)
            throw new globalThis.Error("The parameter 'seedIdFatherTreeFilter' cannot be null.");
        else if (seedIdFatherTreeFilter !== undefined)
            url_ += "seedIdFatherTreeFilter=" + encodeURIComponent("" + seedIdFatherTreeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedFatherTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedFatherTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedFatherTreeForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedBBSFatherFilter (optional) 
     * @return OK
     */
    getAllSeedBBSFatherForLookupTable(seedBBSFatherFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedBBSFatherForLookupTable?";
        if (seedBBSFatherFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFatherFilter' cannot be null.");
        else if (seedBBSFatherFilter !== undefined)
            url_ += "seedBBSFatherFilter=" + encodeURIComponent("" + seedBBSFatherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedBBSFatherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedBBSFatherForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedBBSFatherForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedSpecieFatherFilter (optional) 
     * @return OK
     */
    getAllSeedSpecieFatherForLookupTable(seedSpecieFatherFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedSpecieFatherForLookupTable?";
        if (seedSpecieFatherFilter === null)
            throw new globalThis.Error("The parameter 'seedSpecieFatherFilter' cannot be null.");
        else if (seedSpecieFatherFilter !== undefined)
            url_ += "seedSpecieFatherFilter=" + encodeURIComponent("" + seedSpecieFatherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedSpecieFatherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedSpecieFatherForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedSpecieFatherForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedSupplierCodeFilter (optional) 
     * @return OK
     */
    getAllSeedSupplierCodeForLookupTable(seedSupplierCodeFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedSupplierCodeForLookupTable?";
        if (seedSupplierCodeFilter === null)
            throw new globalThis.Error("The parameter 'seedSupplierCodeFilter' cannot be null.");
        else if (seedSupplierCodeFilter !== undefined)
            url_ += "seedSupplierCodeFilter=" + encodeURIComponent("" + seedSupplierCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedSupplierCodeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedSupplierCodeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedSupplierCodeForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedTypeSpecieFilter (optional) 
     * @return OK
     */
    getAllSeedTypeSpecieForLookupTable(seedTypeSpecieFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedTypeSpecieForLookupTable?";
        if (seedTypeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'seedTypeSpecieFilter' cannot be null.");
        else if (seedTypeSpecieFilter !== undefined)
            url_ += "seedTypeSpecieFilter=" + encodeURIComponent("" + seedTypeSpecieFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedTypeSpecieForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedTypeSpecieForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedTypeSpecieForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedCategorySeedOriginFilter (optional) 
     * @return OK
     */
    getAllSeedCategorySeedOriginForLookupTable(seedCategorySeedOriginFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedCategorySeedOriginForLookupTable?";
        if (seedCategorySeedOriginFilter === null)
            throw new globalThis.Error("The parameter 'seedCategorySeedOriginFilter' cannot be null.");
        else if (seedCategorySeedOriginFilter !== undefined)
            url_ += "seedCategorySeedOriginFilter=" + encodeURIComponent("" + seedCategorySeedOriginFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedCategorySeedOriginForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedCategorySeedOriginForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedCategorySeedOriginForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedCrossingTechniqueFilter (optional) 
     * @return OK
     */
    getAllSeedCrossingTechniqueForLookupTable(seedCrossingTechniqueFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedCrossingTechniqueForLookupTable?";
        if (seedCrossingTechniqueFilter === null)
            throw new globalThis.Error("The parameter 'seedCrossingTechniqueFilter' cannot be null.");
        else if (seedCrossingTechniqueFilter !== undefined)
            url_ += "seedCrossingTechniqueFilter=" + encodeURIComponent("" + seedCrossingTechniqueFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedCrossingTechniqueForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedCrossingTechniqueForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedCrossingTechniqueForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedTrialsStandNameFilter (optional) 
     * @return OK
     */
    getAllSeedOldTrialDenominationForLookupTable(seedTrialsStandNameFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedOldTrialDenominationForLookupTable?";
        if (seedTrialsStandNameFilter === null)
            throw new globalThis.Error("The parameter 'seedTrialsStandNameFilter' cannot be null.");
        else if (seedTrialsStandNameFilter !== undefined)
            url_ += "seedTrialsStandNameFilter=" + encodeURIComponent("" + seedTrialsStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedOldTrialDenominationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedOldTrialDenominationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedOldTrialDenominationForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedSupplierFilter (optional) 
     * @return OK
     */
    getAllSeedSupplierForLookupTable(seedSupplierFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedSupplierForLookupTable?";
        if (seedSupplierFilter === null)
            throw new globalThis.Error("The parameter 'seedSupplierFilter' cannot be null.");
        else if (seedSupplierFilter !== undefined)
            url_ += "seedSupplierFilter=" + encodeURIComponent("" + seedSupplierFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedSupplierForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedSupplierForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedSupplierForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seedDestinationFilter (optional) 
     * @return OK
     */
    getAllSeedDestinationForLookupTable(seedDestinationFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seeds/GetAllSeedDestinationForLookupTable?";
        if (seedDestinationFilter === null)
            throw new globalThis.Error("The parameter 'seedDestinationFilter' cannot be null.");
        else if (seedDestinationFilter !== undefined)
            url_ += "seedDestinationFilter=" + encodeURIComponent("" + seedDestinationFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedDestinationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedDestinationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSeedDestinationForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedStockMovementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxMovementDateFilter (optional) 
     * @param minMovementDateFilter (optional) 
     * @param movementTypeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param unitTypeFilter (optional) 
     * @param isCleanFilter (optional) 
     * @param destinationFilter (optional) 
     * @param destination2Filter (optional) 
     * @param shelfFilter (optional) 
     * @param quadrantFilter (optional) 
     * @param drawerLocationFilter (optional) 
     * @param bagDetailFilter (optional) 
     * @param commentsFilter (optional) 
     * @param maxCaliber059mmFilter (optional) 
     * @param minCaliber059mmFilter (optional) 
     * @param maxCaliber071mmFilter (optional) 
     * @param minCaliber071mmFilter (optional) 
     * @param maxCaliber084mmFilter (optional) 
     * @param minCaliber084mmFilter (optional) 
     * @param maxCaliber100mmFilter (optional) 
     * @param minCaliber100mmFilter (optional) 
     * @param calibrationObservationFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxMovementDateFilter: DateTime | undefined, minMovementDateFilter: DateTime | undefined, movementTypeFilter: string | undefined, maxQuantityFilter: number | undefined, minQuantityFilter: number | undefined, unitTypeFilter: string | undefined, isCleanFilter: number | undefined, destinationFilter: string | undefined, destination2Filter: string | undefined, shelfFilter: string | undefined, quadrantFilter: string | undefined, drawerLocationFilter: string | undefined, bagDetailFilter: string | undefined, commentsFilter: string | undefined, maxCaliber059mmFilter: number | undefined, minCaliber059mmFilter: number | undefined, maxCaliber071mmFilter: number | undefined, minCaliber071mmFilter: number | undefined, maxCaliber084mmFilter: number | undefined, minCaliber084mmFilter: number | undefined, maxCaliber100mmFilter: number | undefined, minCaliber100mmFilter: number | undefined, calibrationObservationFilter: string | undefined, seedBBSFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedStockMovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxMovementDateFilter === null)
            throw new globalThis.Error("The parameter 'maxMovementDateFilter' cannot be null.");
        else if (maxMovementDateFilter !== undefined)
            url_ += "MaxMovementDateFilter=" + encodeURIComponent(maxMovementDateFilter ? "" + maxMovementDateFilter.toString() : "") + "&";
        if (minMovementDateFilter === null)
            throw new globalThis.Error("The parameter 'minMovementDateFilter' cannot be null.");
        else if (minMovementDateFilter !== undefined)
            url_ += "MinMovementDateFilter=" + encodeURIComponent(minMovementDateFilter ? "" + minMovementDateFilter.toString() : "") + "&";
        if (movementTypeFilter === null)
            throw new globalThis.Error("The parameter 'movementTypeFilter' cannot be null.");
        else if (movementTypeFilter !== undefined)
            url_ += "MovementTypeFilter=" + encodeURIComponent("" + movementTypeFilter) + "&";
        if (maxQuantityFilter === null)
            throw new globalThis.Error("The parameter 'maxQuantityFilter' cannot be null.");
        else if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter === null)
            throw new globalThis.Error("The parameter 'minQuantityFilter' cannot be null.");
        else if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (unitTypeFilter === null)
            throw new globalThis.Error("The parameter 'unitTypeFilter' cannot be null.");
        else if (unitTypeFilter !== undefined)
            url_ += "UnitTypeFilter=" + encodeURIComponent("" + unitTypeFilter) + "&";
        if (isCleanFilter === null)
            throw new globalThis.Error("The parameter 'isCleanFilter' cannot be null.");
        else if (isCleanFilter !== undefined)
            url_ += "IsCleanFilter=" + encodeURIComponent("" + isCleanFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (destination2Filter === null)
            throw new globalThis.Error("The parameter 'destination2Filter' cannot be null.");
        else if (destination2Filter !== undefined)
            url_ += "Destination2Filter=" + encodeURIComponent("" + destination2Filter) + "&";
        if (shelfFilter === null)
            throw new globalThis.Error("The parameter 'shelfFilter' cannot be null.");
        else if (shelfFilter !== undefined)
            url_ += "ShelfFilter=" + encodeURIComponent("" + shelfFilter) + "&";
        if (quadrantFilter === null)
            throw new globalThis.Error("The parameter 'quadrantFilter' cannot be null.");
        else if (quadrantFilter !== undefined)
            url_ += "QuadrantFilter=" + encodeURIComponent("" + quadrantFilter) + "&";
        if (drawerLocationFilter === null)
            throw new globalThis.Error("The parameter 'drawerLocationFilter' cannot be null.");
        else if (drawerLocationFilter !== undefined)
            url_ += "DrawerLocationFilter=" + encodeURIComponent("" + drawerLocationFilter) + "&";
        if (bagDetailFilter === null)
            throw new globalThis.Error("The parameter 'bagDetailFilter' cannot be null.");
        else if (bagDetailFilter !== undefined)
            url_ += "BagDetailFilter=" + encodeURIComponent("" + bagDetailFilter) + "&";
        if (commentsFilter === null)
            throw new globalThis.Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&";
        if (maxCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber059mmFilter' cannot be null.");
        else if (maxCaliber059mmFilter !== undefined)
            url_ += "MaxCaliber059mmFilter=" + encodeURIComponent("" + maxCaliber059mmFilter) + "&";
        if (minCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber059mmFilter' cannot be null.");
        else if (minCaliber059mmFilter !== undefined)
            url_ += "MinCaliber059mmFilter=" + encodeURIComponent("" + minCaliber059mmFilter) + "&";
        if (maxCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber071mmFilter' cannot be null.");
        else if (maxCaliber071mmFilter !== undefined)
            url_ += "MaxCaliber071mmFilter=" + encodeURIComponent("" + maxCaliber071mmFilter) + "&";
        if (minCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber071mmFilter' cannot be null.");
        else if (minCaliber071mmFilter !== undefined)
            url_ += "MinCaliber071mmFilter=" + encodeURIComponent("" + minCaliber071mmFilter) + "&";
        if (maxCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber084mmFilter' cannot be null.");
        else if (maxCaliber084mmFilter !== undefined)
            url_ += "MaxCaliber084mmFilter=" + encodeURIComponent("" + maxCaliber084mmFilter) + "&";
        if (minCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber084mmFilter' cannot be null.");
        else if (minCaliber084mmFilter !== undefined)
            url_ += "MinCaliber084mmFilter=" + encodeURIComponent("" + minCaliber084mmFilter) + "&";
        if (maxCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber100mmFilter' cannot be null.");
        else if (maxCaliber100mmFilter !== undefined)
            url_ += "MaxCaliber100mmFilter=" + encodeURIComponent("" + maxCaliber100mmFilter) + "&";
        if (minCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber100mmFilter' cannot be null.");
        else if (minCaliber100mmFilter !== undefined)
            url_ += "MinCaliber100mmFilter=" + encodeURIComponent("" + minCaliber100mmFilter) + "&";
        if (calibrationObservationFilter === null)
            throw new globalThis.Error("The parameter 'calibrationObservationFilter' cannot be null.");
        else if (calibrationObservationFilter !== undefined)
            url_ += "CalibrationObservationFilter=" + encodeURIComponent("" + calibrationObservationFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedStockMovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedStockMovementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedStockMovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedStockMovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedStockMovementForView(id: number | undefined): Observable<GetSeedStockMovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetSeedStockMovementForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStockMovementForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStockMovementForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedStockMovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedStockMovementForViewDto>;
        }));
    }

    protected processGetSeedStockMovementForView(response: HttpResponseBase): Observable<GetSeedStockMovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedStockMovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedStockMovementForEdit(id: number | undefined): Observable<GetSeedStockMovementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetSeedStockMovementForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStockMovementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStockMovementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedStockMovementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedStockMovementForEditOutput>;
        }));
    }

    protected processGetSeedStockMovementForEdit(response: HttpResponseBase): Observable<GetSeedStockMovementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedStockMovementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedStockMovementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxMovementDateFilter (optional) 
     * @param minMovementDateFilter (optional) 
     * @param movementTypeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param unitTypeFilter (optional) 
     * @param isCleanFilter (optional) 
     * @param destinationFilter (optional) 
     * @param destination2Filter (optional) 
     * @param shelfFilter (optional) 
     * @param quadrantFilter (optional) 
     * @param drawerLocationFilter (optional) 
     * @param bagDetailFilter (optional) 
     * @param commentsFilter (optional) 
     * @param maxCaliber059mmFilter (optional) 
     * @param minCaliber059mmFilter (optional) 
     * @param maxCaliber071mmFilter (optional) 
     * @param minCaliber071mmFilter (optional) 
     * @param maxCaliber084mmFilter (optional) 
     * @param minCaliber084mmFilter (optional) 
     * @param maxCaliber100mmFilter (optional) 
     * @param minCaliber100mmFilter (optional) 
     * @param calibrationObservationFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param seedIdFilter (optional) 
     * @return OK
     */
    getSeedStockMovementsToExcel(filter: string | undefined, maxMovementDateFilter: DateTime | undefined, minMovementDateFilter: DateTime | undefined, movementTypeFilter: string | undefined, maxQuantityFilter: number | undefined, minQuantityFilter: number | undefined, unitTypeFilter: string | undefined, isCleanFilter: number | undefined, destinationFilter: string | undefined, destination2Filter: string | undefined, shelfFilter: string | undefined, quadrantFilter: string | undefined, drawerLocationFilter: string | undefined, bagDetailFilter: string | undefined, commentsFilter: string | undefined, maxCaliber059mmFilter: number | undefined, minCaliber059mmFilter: number | undefined, maxCaliber071mmFilter: number | undefined, minCaliber071mmFilter: number | undefined, maxCaliber084mmFilter: number | undefined, minCaliber084mmFilter: number | undefined, maxCaliber100mmFilter: number | undefined, minCaliber100mmFilter: number | undefined, calibrationObservationFilter: string | undefined, seedBBSFilter: string | undefined, seedIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetSeedStockMovementsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxMovementDateFilter === null)
            throw new globalThis.Error("The parameter 'maxMovementDateFilter' cannot be null.");
        else if (maxMovementDateFilter !== undefined)
            url_ += "MaxMovementDateFilter=" + encodeURIComponent(maxMovementDateFilter ? "" + maxMovementDateFilter.toString() : "") + "&";
        if (minMovementDateFilter === null)
            throw new globalThis.Error("The parameter 'minMovementDateFilter' cannot be null.");
        else if (minMovementDateFilter !== undefined)
            url_ += "MinMovementDateFilter=" + encodeURIComponent(minMovementDateFilter ? "" + minMovementDateFilter.toString() : "") + "&";
        if (movementTypeFilter === null)
            throw new globalThis.Error("The parameter 'movementTypeFilter' cannot be null.");
        else if (movementTypeFilter !== undefined)
            url_ += "MovementTypeFilter=" + encodeURIComponent("" + movementTypeFilter) + "&";
        if (maxQuantityFilter === null)
            throw new globalThis.Error("The parameter 'maxQuantityFilter' cannot be null.");
        else if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter === null)
            throw new globalThis.Error("The parameter 'minQuantityFilter' cannot be null.");
        else if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (unitTypeFilter === null)
            throw new globalThis.Error("The parameter 'unitTypeFilter' cannot be null.");
        else if (unitTypeFilter !== undefined)
            url_ += "UnitTypeFilter=" + encodeURIComponent("" + unitTypeFilter) + "&";
        if (isCleanFilter === null)
            throw new globalThis.Error("The parameter 'isCleanFilter' cannot be null.");
        else if (isCleanFilter !== undefined)
            url_ += "IsCleanFilter=" + encodeURIComponent("" + isCleanFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (destination2Filter === null)
            throw new globalThis.Error("The parameter 'destination2Filter' cannot be null.");
        else if (destination2Filter !== undefined)
            url_ += "Destination2Filter=" + encodeURIComponent("" + destination2Filter) + "&";
        if (shelfFilter === null)
            throw new globalThis.Error("The parameter 'shelfFilter' cannot be null.");
        else if (shelfFilter !== undefined)
            url_ += "ShelfFilter=" + encodeURIComponent("" + shelfFilter) + "&";
        if (quadrantFilter === null)
            throw new globalThis.Error("The parameter 'quadrantFilter' cannot be null.");
        else if (quadrantFilter !== undefined)
            url_ += "QuadrantFilter=" + encodeURIComponent("" + quadrantFilter) + "&";
        if (drawerLocationFilter === null)
            throw new globalThis.Error("The parameter 'drawerLocationFilter' cannot be null.");
        else if (drawerLocationFilter !== undefined)
            url_ += "DrawerLocationFilter=" + encodeURIComponent("" + drawerLocationFilter) + "&";
        if (bagDetailFilter === null)
            throw new globalThis.Error("The parameter 'bagDetailFilter' cannot be null.");
        else if (bagDetailFilter !== undefined)
            url_ += "BagDetailFilter=" + encodeURIComponent("" + bagDetailFilter) + "&";
        if (commentsFilter === null)
            throw new globalThis.Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&";
        if (maxCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber059mmFilter' cannot be null.");
        else if (maxCaliber059mmFilter !== undefined)
            url_ += "MaxCaliber059mmFilter=" + encodeURIComponent("" + maxCaliber059mmFilter) + "&";
        if (minCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber059mmFilter' cannot be null.");
        else if (minCaliber059mmFilter !== undefined)
            url_ += "MinCaliber059mmFilter=" + encodeURIComponent("" + minCaliber059mmFilter) + "&";
        if (maxCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber071mmFilter' cannot be null.");
        else if (maxCaliber071mmFilter !== undefined)
            url_ += "MaxCaliber071mmFilter=" + encodeURIComponent("" + maxCaliber071mmFilter) + "&";
        if (minCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber071mmFilter' cannot be null.");
        else if (minCaliber071mmFilter !== undefined)
            url_ += "MinCaliber071mmFilter=" + encodeURIComponent("" + minCaliber071mmFilter) + "&";
        if (maxCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber084mmFilter' cannot be null.");
        else if (maxCaliber084mmFilter !== undefined)
            url_ += "MaxCaliber084mmFilter=" + encodeURIComponent("" + maxCaliber084mmFilter) + "&";
        if (minCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber084mmFilter' cannot be null.");
        else if (minCaliber084mmFilter !== undefined)
            url_ += "MinCaliber084mmFilter=" + encodeURIComponent("" + minCaliber084mmFilter) + "&";
        if (maxCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber100mmFilter' cannot be null.");
        else if (maxCaliber100mmFilter !== undefined)
            url_ += "MaxCaliber100mmFilter=" + encodeURIComponent("" + maxCaliber100mmFilter) + "&";
        if (minCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber100mmFilter' cannot be null.");
        else if (minCaliber100mmFilter !== undefined)
            url_ += "MinCaliber100mmFilter=" + encodeURIComponent("" + minCaliber100mmFilter) + "&";
        if (calibrationObservationFilter === null)
            throw new globalThis.Error("The parameter 'calibrationObservationFilter' cannot be null.");
        else if (calibrationObservationFilter !== undefined)
            url_ += "CalibrationObservationFilter=" + encodeURIComponent("" + calibrationObservationFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (seedIdFilter === null)
            throw new globalThis.Error("The parameter 'seedIdFilter' cannot be null.");
        else if (seedIdFilter !== undefined)
            url_ += "SeedIdFilter=" + encodeURIComponent("" + seedIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStockMovementsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStockMovementsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedStockMovementsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedStockMovementSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedStockMovementSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedStockMovementSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedStockMovementSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedStockMovementSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importSeedStockMovementsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/ImportSeedStockMovementsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSeedStockMovementsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSeedStockMovementsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportSeedStockMovementsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSeedUnitTypes(): Observable<SeedUnitTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SeedStockMovements/GetSeedUnitTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedUnitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedUnitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeedUnitTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeedUnitTypeDto[]>;
        }));
    }

    protected processGetSeedUnitTypes(response: HttpResponseBase): Observable<SeedUnitTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedUnitTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeedStocksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param isCleanFilter (optional) 
     * @param unitTypeFilter (optional) 
     * @param maxInitialStockFilter (optional) 
     * @param minInitialStockFilter (optional) 
     * @param maxCurrentStockFilter (optional) 
     * @param minCurrentStockFilter (optional) 
     * @param maxLastUpdateDateFilter (optional) 
     * @param minLastUpdateDateFilter (optional) 
     * @param maxCaliber059mmFilter (optional) 
     * @param minCaliber059mmFilter (optional) 
     * @param maxCaliber071mmFilter (optional) 
     * @param minCaliber071mmFilter (optional) 
     * @param maxCaliber084mmFilter (optional) 
     * @param minCaliber084mmFilter (optional) 
     * @param maxCaliber100mmFilter (optional) 
     * @param minCaliber100mmFilter (optional) 
     * @param destinationFilter (optional) 
     * @param destination2Filter (optional) 
     * @param shelfFilter (optional) 
     * @param quadrantFilter (optional) 
     * @param drawerLocationFilter (optional) 
     * @param bagDetailFilter (optional) 
     * @param commentsFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, isCleanFilter: number | undefined, unitTypeFilter: string | undefined, maxInitialStockFilter: number | undefined, minInitialStockFilter: number | undefined, maxCurrentStockFilter: number | undefined, minCurrentStockFilter: number | undefined, maxLastUpdateDateFilter: DateTime | undefined, minLastUpdateDateFilter: DateTime | undefined, maxCaliber059mmFilter: number | undefined, minCaliber059mmFilter: number | undefined, maxCaliber071mmFilter: number | undefined, minCaliber071mmFilter: number | undefined, maxCaliber084mmFilter: number | undefined, minCaliber084mmFilter: number | undefined, maxCaliber100mmFilter: number | undefined, minCaliber100mmFilter: number | undefined, destinationFilter: string | undefined, destination2Filter: string | undefined, shelfFilter: string | undefined, quadrantFilter: string | undefined, drawerLocationFilter: string | undefined, bagDetailFilter: string | undefined, commentsFilter: string | undefined, seedBBSFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeedStockForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isCleanFilter === null)
            throw new globalThis.Error("The parameter 'isCleanFilter' cannot be null.");
        else if (isCleanFilter !== undefined)
            url_ += "IsCleanFilter=" + encodeURIComponent("" + isCleanFilter) + "&";
        if (unitTypeFilter === null)
            throw new globalThis.Error("The parameter 'unitTypeFilter' cannot be null.");
        else if (unitTypeFilter !== undefined)
            url_ += "UnitTypeFilter=" + encodeURIComponent("" + unitTypeFilter) + "&";
        if (maxInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'maxInitialStockFilter' cannot be null.");
        else if (maxInitialStockFilter !== undefined)
            url_ += "MaxInitialStockFilter=" + encodeURIComponent("" + maxInitialStockFilter) + "&";
        if (minInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'minInitialStockFilter' cannot be null.");
        else if (minInitialStockFilter !== undefined)
            url_ += "MinInitialStockFilter=" + encodeURIComponent("" + minInitialStockFilter) + "&";
        if (maxCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'maxCurrentStockFilter' cannot be null.");
        else if (maxCurrentStockFilter !== undefined)
            url_ += "MaxCurrentStockFilter=" + encodeURIComponent("" + maxCurrentStockFilter) + "&";
        if (minCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'minCurrentStockFilter' cannot be null.");
        else if (minCurrentStockFilter !== undefined)
            url_ += "MinCurrentStockFilter=" + encodeURIComponent("" + minCurrentStockFilter) + "&";
        if (maxLastUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'maxLastUpdateDateFilter' cannot be null.");
        else if (maxLastUpdateDateFilter !== undefined)
            url_ += "MaxLastUpdateDateFilter=" + encodeURIComponent(maxLastUpdateDateFilter ? "" + maxLastUpdateDateFilter.toString() : "") + "&";
        if (minLastUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'minLastUpdateDateFilter' cannot be null.");
        else if (minLastUpdateDateFilter !== undefined)
            url_ += "MinLastUpdateDateFilter=" + encodeURIComponent(minLastUpdateDateFilter ? "" + minLastUpdateDateFilter.toString() : "") + "&";
        if (maxCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber059mmFilter' cannot be null.");
        else if (maxCaliber059mmFilter !== undefined)
            url_ += "MaxCaliber059mmFilter=" + encodeURIComponent("" + maxCaliber059mmFilter) + "&";
        if (minCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber059mmFilter' cannot be null.");
        else if (minCaliber059mmFilter !== undefined)
            url_ += "MinCaliber059mmFilter=" + encodeURIComponent("" + minCaliber059mmFilter) + "&";
        if (maxCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber071mmFilter' cannot be null.");
        else if (maxCaliber071mmFilter !== undefined)
            url_ += "MaxCaliber071mmFilter=" + encodeURIComponent("" + maxCaliber071mmFilter) + "&";
        if (minCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber071mmFilter' cannot be null.");
        else if (minCaliber071mmFilter !== undefined)
            url_ += "MinCaliber071mmFilter=" + encodeURIComponent("" + minCaliber071mmFilter) + "&";
        if (maxCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber084mmFilter' cannot be null.");
        else if (maxCaliber084mmFilter !== undefined)
            url_ += "MaxCaliber084mmFilter=" + encodeURIComponent("" + maxCaliber084mmFilter) + "&";
        if (minCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber084mmFilter' cannot be null.");
        else if (minCaliber084mmFilter !== undefined)
            url_ += "MinCaliber084mmFilter=" + encodeURIComponent("" + minCaliber084mmFilter) + "&";
        if (maxCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber100mmFilter' cannot be null.");
        else if (maxCaliber100mmFilter !== undefined)
            url_ += "MaxCaliber100mmFilter=" + encodeURIComponent("" + maxCaliber100mmFilter) + "&";
        if (minCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber100mmFilter' cannot be null.");
        else if (minCaliber100mmFilter !== undefined)
            url_ += "MinCaliber100mmFilter=" + encodeURIComponent("" + minCaliber100mmFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (destination2Filter === null)
            throw new globalThis.Error("The parameter 'destination2Filter' cannot be null.");
        else if (destination2Filter !== undefined)
            url_ += "Destination2Filter=" + encodeURIComponent("" + destination2Filter) + "&";
        if (shelfFilter === null)
            throw new globalThis.Error("The parameter 'shelfFilter' cannot be null.");
        else if (shelfFilter !== undefined)
            url_ += "ShelfFilter=" + encodeURIComponent("" + shelfFilter) + "&";
        if (quadrantFilter === null)
            throw new globalThis.Error("The parameter 'quadrantFilter' cannot be null.");
        else if (quadrantFilter !== undefined)
            url_ += "QuadrantFilter=" + encodeURIComponent("" + quadrantFilter) + "&";
        if (drawerLocationFilter === null)
            throw new globalThis.Error("The parameter 'drawerLocationFilter' cannot be null.");
        else if (drawerLocationFilter !== undefined)
            url_ += "DrawerLocationFilter=" + encodeURIComponent("" + drawerLocationFilter) + "&";
        if (bagDetailFilter === null)
            throw new globalThis.Error("The parameter 'bagDetailFilter' cannot be null.");
        else if (bagDetailFilter !== undefined)
            url_ += "BagDetailFilter=" + encodeURIComponent("" + bagDetailFilter) + "&";
        if (commentsFilter === null)
            throw new globalThis.Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeedStockForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeedStockForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeedStockForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeedStockForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedStockForView(id: number | undefined): Observable<GetSeedStockForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/GetSeedStockForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStockForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStockForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedStockForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedStockForViewDto>;
        }));
    }

    protected processGetSeedStockForView(response: HttpResponseBase): Observable<GetSeedStockForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedStockForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSeedStockForEdit(id: number | undefined): Observable<GetSeedStockForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/GetSeedStockForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStockForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStockForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeedStockForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeedStockForEditOutput>;
        }));
    }

    protected processGetSeedStockForEdit(response: HttpResponseBase): Observable<GetSeedStockForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeedStockForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSeedStockDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isCleanFilter (optional) 
     * @param unitTypeFilter (optional) 
     * @param maxInitialStockFilter (optional) 
     * @param minInitialStockFilter (optional) 
     * @param maxCurrentStockFilter (optional) 
     * @param minCurrentStockFilter (optional) 
     * @param maxLastUpdateDateFilter (optional) 
     * @param minLastUpdateDateFilter (optional) 
     * @param maxCaliber059mmFilter (optional) 
     * @param minCaliber059mmFilter (optional) 
     * @param maxCaliber071mmFilter (optional) 
     * @param minCaliber071mmFilter (optional) 
     * @param maxCaliber084mmFilter (optional) 
     * @param minCaliber084mmFilter (optional) 
     * @param maxCaliber100mmFilter (optional) 
     * @param minCaliber100mmFilter (optional) 
     * @param destinationFilter (optional) 
     * @param destination2Filter (optional) 
     * @param shelfFilter (optional) 
     * @param quadrantFilter (optional) 
     * @param drawerLocationFilter (optional) 
     * @param bagDetailFilter (optional) 
     * @param commentsFilter (optional) 
     * @param seedBBSFilter (optional) 
     * @param seedIdFilter (optional) 
     * @return OK
     */
    getSeedStocksToExcel(filter: string | undefined, isCleanFilter: number | undefined, unitTypeFilter: string | undefined, maxInitialStockFilter: number | undefined, minInitialStockFilter: number | undefined, maxCurrentStockFilter: number | undefined, minCurrentStockFilter: number | undefined, maxLastUpdateDateFilter: DateTime | undefined, minLastUpdateDateFilter: DateTime | undefined, maxCaliber059mmFilter: number | undefined, minCaliber059mmFilter: number | undefined, maxCaliber071mmFilter: number | undefined, minCaliber071mmFilter: number | undefined, maxCaliber084mmFilter: number | undefined, minCaliber084mmFilter: number | undefined, maxCaliber100mmFilter: number | undefined, minCaliber100mmFilter: number | undefined, destinationFilter: string | undefined, destination2Filter: string | undefined, shelfFilter: string | undefined, quadrantFilter: string | undefined, drawerLocationFilter: string | undefined, bagDetailFilter: string | undefined, commentsFilter: string | undefined, seedBBSFilter: string | undefined, seedIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/GetSeedStocksToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isCleanFilter === null)
            throw new globalThis.Error("The parameter 'isCleanFilter' cannot be null.");
        else if (isCleanFilter !== undefined)
            url_ += "IsCleanFilter=" + encodeURIComponent("" + isCleanFilter) + "&";
        if (unitTypeFilter === null)
            throw new globalThis.Error("The parameter 'unitTypeFilter' cannot be null.");
        else if (unitTypeFilter !== undefined)
            url_ += "UnitTypeFilter=" + encodeURIComponent("" + unitTypeFilter) + "&";
        if (maxInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'maxInitialStockFilter' cannot be null.");
        else if (maxInitialStockFilter !== undefined)
            url_ += "MaxInitialStockFilter=" + encodeURIComponent("" + maxInitialStockFilter) + "&";
        if (minInitialStockFilter === null)
            throw new globalThis.Error("The parameter 'minInitialStockFilter' cannot be null.");
        else if (minInitialStockFilter !== undefined)
            url_ += "MinInitialStockFilter=" + encodeURIComponent("" + minInitialStockFilter) + "&";
        if (maxCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'maxCurrentStockFilter' cannot be null.");
        else if (maxCurrentStockFilter !== undefined)
            url_ += "MaxCurrentStockFilter=" + encodeURIComponent("" + maxCurrentStockFilter) + "&";
        if (minCurrentStockFilter === null)
            throw new globalThis.Error("The parameter 'minCurrentStockFilter' cannot be null.");
        else if (minCurrentStockFilter !== undefined)
            url_ += "MinCurrentStockFilter=" + encodeURIComponent("" + minCurrentStockFilter) + "&";
        if (maxLastUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'maxLastUpdateDateFilter' cannot be null.");
        else if (maxLastUpdateDateFilter !== undefined)
            url_ += "MaxLastUpdateDateFilter=" + encodeURIComponent(maxLastUpdateDateFilter ? "" + maxLastUpdateDateFilter.toString() : "") + "&";
        if (minLastUpdateDateFilter === null)
            throw new globalThis.Error("The parameter 'minLastUpdateDateFilter' cannot be null.");
        else if (minLastUpdateDateFilter !== undefined)
            url_ += "MinLastUpdateDateFilter=" + encodeURIComponent(minLastUpdateDateFilter ? "" + minLastUpdateDateFilter.toString() : "") + "&";
        if (maxCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber059mmFilter' cannot be null.");
        else if (maxCaliber059mmFilter !== undefined)
            url_ += "MaxCaliber059mmFilter=" + encodeURIComponent("" + maxCaliber059mmFilter) + "&";
        if (minCaliber059mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber059mmFilter' cannot be null.");
        else if (minCaliber059mmFilter !== undefined)
            url_ += "MinCaliber059mmFilter=" + encodeURIComponent("" + minCaliber059mmFilter) + "&";
        if (maxCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber071mmFilter' cannot be null.");
        else if (maxCaliber071mmFilter !== undefined)
            url_ += "MaxCaliber071mmFilter=" + encodeURIComponent("" + maxCaliber071mmFilter) + "&";
        if (minCaliber071mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber071mmFilter' cannot be null.");
        else if (minCaliber071mmFilter !== undefined)
            url_ += "MinCaliber071mmFilter=" + encodeURIComponent("" + minCaliber071mmFilter) + "&";
        if (maxCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber084mmFilter' cannot be null.");
        else if (maxCaliber084mmFilter !== undefined)
            url_ += "MaxCaliber084mmFilter=" + encodeURIComponent("" + maxCaliber084mmFilter) + "&";
        if (minCaliber084mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber084mmFilter' cannot be null.");
        else if (minCaliber084mmFilter !== undefined)
            url_ += "MinCaliber084mmFilter=" + encodeURIComponent("" + minCaliber084mmFilter) + "&";
        if (maxCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'maxCaliber100mmFilter' cannot be null.");
        else if (maxCaliber100mmFilter !== undefined)
            url_ += "MaxCaliber100mmFilter=" + encodeURIComponent("" + maxCaliber100mmFilter) + "&";
        if (minCaliber100mmFilter === null)
            throw new globalThis.Error("The parameter 'minCaliber100mmFilter' cannot be null.");
        else if (minCaliber100mmFilter !== undefined)
            url_ += "MinCaliber100mmFilter=" + encodeURIComponent("" + minCaliber100mmFilter) + "&";
        if (destinationFilter === null)
            throw new globalThis.Error("The parameter 'destinationFilter' cannot be null.");
        else if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (destination2Filter === null)
            throw new globalThis.Error("The parameter 'destination2Filter' cannot be null.");
        else if (destination2Filter !== undefined)
            url_ += "Destination2Filter=" + encodeURIComponent("" + destination2Filter) + "&";
        if (shelfFilter === null)
            throw new globalThis.Error("The parameter 'shelfFilter' cannot be null.");
        else if (shelfFilter !== undefined)
            url_ += "ShelfFilter=" + encodeURIComponent("" + shelfFilter) + "&";
        if (quadrantFilter === null)
            throw new globalThis.Error("The parameter 'quadrantFilter' cannot be null.");
        else if (quadrantFilter !== undefined)
            url_ += "QuadrantFilter=" + encodeURIComponent("" + quadrantFilter) + "&";
        if (drawerLocationFilter === null)
            throw new globalThis.Error("The parameter 'drawerLocationFilter' cannot be null.");
        else if (drawerLocationFilter !== undefined)
            url_ += "DrawerLocationFilter=" + encodeURIComponent("" + drawerLocationFilter) + "&";
        if (bagDetailFilter === null)
            throw new globalThis.Error("The parameter 'bagDetailFilter' cannot be null.");
        else if (bagDetailFilter !== undefined)
            url_ += "BagDetailFilter=" + encodeURIComponent("" + bagDetailFilter) + "&";
        if (commentsFilter === null)
            throw new globalThis.Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&";
        if (seedBBSFilter === null)
            throw new globalThis.Error("The parameter 'seedBBSFilter' cannot be null.");
        else if (seedBBSFilter !== undefined)
            url_ += "SeedBBSFilter=" + encodeURIComponent("" + seedBBSFilter) + "&";
        if (seedIdFilter === null)
            throw new globalThis.Error("The parameter 'seedIdFilter' cannot be null.");
        else if (seedIdFilter !== undefined)
            url_ += "SeedIdFilter=" + encodeURIComponent("" + seedIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeedStocksToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeedStocksToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeedStocksToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSeedStockSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSeedStockSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSeedStockSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSeedStockSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSeedStockSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importSeedStocksFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeedStocks/ImportSeedStocksFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSeedStocksFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSeedStocksFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processImportSeedStocksFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SilvicultureTreatmentNutritionalsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param silvicultureTrialIdFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treatmentNameFilter (optional) 
     * @param treatmentObjectiveFilter (optional) 
     * @param treatmentProductTypeFilter (optional) 
     * @param maxInterventionDateFilter (optional) 
     * @param minInterventionDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, silvicultureTrialIdFilter: number | undefined, cloneBBXFilter: string | undefined, treatmentNameFilter: string | undefined, treatmentObjectiveFilter: string | undefined, treatmentProductTypeFilter: string | undefined, maxInterventionDateFilter: DateTime | undefined, minInterventionDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (silvicultureTrialIdFilter === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialIdFilter' cannot be null.");
        else if (silvicultureTrialIdFilter !== undefined)
            url_ += "SilvicultureTrialIdFilter=" + encodeURIComponent("" + silvicultureTrialIdFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treatmentNameFilter === null)
            throw new globalThis.Error("The parameter 'treatmentNameFilter' cannot be null.");
        else if (treatmentNameFilter !== undefined)
            url_ += "TreatmentNameFilter=" + encodeURIComponent("" + treatmentNameFilter) + "&";
        if (treatmentObjectiveFilter === null)
            throw new globalThis.Error("The parameter 'treatmentObjectiveFilter' cannot be null.");
        else if (treatmentObjectiveFilter !== undefined)
            url_ += "TreatmentObjectiveFilter=" + encodeURIComponent("" + treatmentObjectiveFilter) + "&";
        if (treatmentProductTypeFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeFilter' cannot be null.");
        else if (treatmentProductTypeFilter !== undefined)
            url_ += "TreatmentProductTypeFilter=" + encodeURIComponent("" + treatmentProductTypeFilter) + "&";
        if (maxInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInterventionDateFilter' cannot be null.");
        else if (maxInterventionDateFilter !== undefined)
            url_ += "MaxInterventionDateFilter=" + encodeURIComponent(maxInterventionDateFilter ? "" + maxInterventionDateFilter.toString() : "") + "&";
        if (minInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'minInterventionDateFilter' cannot be null.");
        else if (minInterventionDateFilter !== undefined)
            url_ += "MinInterventionDateFilter=" + encodeURIComponent(minInterventionDateFilter ? "" + minInterventionDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSilvicultureTreatmentNutritionalForView(id: number | undefined): Observable<GetSilvicultureTreatmentNutritionalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetSilvicultureTreatmentNutritionalForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTreatmentNutritionalForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTreatmentNutritionalForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSilvicultureTreatmentNutritionalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSilvicultureTreatmentNutritionalForViewDto>;
        }));
    }

    protected processGetSilvicultureTreatmentNutritionalForView(response: HttpResponseBase): Observable<GetSilvicultureTreatmentNutritionalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSilvicultureTreatmentNutritionalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSilvicultureTreatmentNutritionalForEdit(id: number | undefined): Observable<GetSilvicultureTreatmentNutritionalForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetSilvicultureTreatmentNutritionalForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTreatmentNutritionalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTreatmentNutritionalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSilvicultureTreatmentNutritionalForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSilvicultureTreatmentNutritionalForEditOutput>;
        }));
    }

    protected processGetSilvicultureTreatmentNutritionalForEdit(response: HttpResponseBase): Observable<GetSilvicultureTreatmentNutritionalForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSilvicultureTreatmentNutritionalForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSilvicultureTreatmentNutritionalDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param silvicultureTrialIdFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treatmentNameFilter (optional) 
     * @param treatmentObjectiveFilter (optional) 
     * @param treatmentProductTypeFilter (optional) 
     * @param maxInterventionDateFilter (optional) 
     * @param minInterventionDateFilter (optional) 
     * @return OK
     */
    deleteMassive(filter: string | undefined, silvicultureTrialIdFilter: number | undefined, cloneBBXFilter: string | undefined, treatmentNameFilter: string | undefined, treatmentObjectiveFilter: string | undefined, treatmentProductTypeFilter: string | undefined, maxInterventionDateFilter: DateTime | undefined, minInterventionDateFilter: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/DeleteMassive?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (silvicultureTrialIdFilter === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialIdFilter' cannot be null.");
        else if (silvicultureTrialIdFilter !== undefined)
            url_ += "SilvicultureTrialIdFilter=" + encodeURIComponent("" + silvicultureTrialIdFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treatmentNameFilter === null)
            throw new globalThis.Error("The parameter 'treatmentNameFilter' cannot be null.");
        else if (treatmentNameFilter !== undefined)
            url_ += "TreatmentNameFilter=" + encodeURIComponent("" + treatmentNameFilter) + "&";
        if (treatmentObjectiveFilter === null)
            throw new globalThis.Error("The parameter 'treatmentObjectiveFilter' cannot be null.");
        else if (treatmentObjectiveFilter !== undefined)
            url_ += "TreatmentObjectiveFilter=" + encodeURIComponent("" + treatmentObjectiveFilter) + "&";
        if (treatmentProductTypeFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeFilter' cannot be null.");
        else if (treatmentProductTypeFilter !== undefined)
            url_ += "TreatmentProductTypeFilter=" + encodeURIComponent("" + treatmentProductTypeFilter) + "&";
        if (maxInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInterventionDateFilter' cannot be null.");
        else if (maxInterventionDateFilter !== undefined)
            url_ += "MaxInterventionDateFilter=" + encodeURIComponent(maxInterventionDateFilter ? "" + maxInterventionDateFilter.toString() : "") + "&";
        if (minInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'minInterventionDateFilter' cannot be null.");
        else if (minInterventionDateFilter !== undefined)
            url_ += "MinInterventionDateFilter=" + encodeURIComponent(minInterventionDateFilter ? "" + minInterventionDateFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassive(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param silvicultureTrialIdFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param treatmentNameFilter (optional) 
     * @param treatmentObjectiveFilter (optional) 
     * @param treatmentProductTypeFilter (optional) 
     * @param maxInterventionDateFilter (optional) 
     * @param minInterventionDateFilter (optional) 
     * @return OK
     */
    getSilvicultureTreatmentNutritionalsToExcel(filter: string | undefined, silvicultureTrialIdFilter: number | undefined, cloneBBXFilter: string | undefined, treatmentNameFilter: string | undefined, treatmentObjectiveFilter: string | undefined, treatmentProductTypeFilter: string | undefined, maxInterventionDateFilter: DateTime | undefined, minInterventionDateFilter: DateTime | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetSilvicultureTreatmentNutritionalsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (silvicultureTrialIdFilter === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialIdFilter' cannot be null.");
        else if (silvicultureTrialIdFilter !== undefined)
            url_ += "SilvicultureTrialIdFilter=" + encodeURIComponent("" + silvicultureTrialIdFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (treatmentNameFilter === null)
            throw new globalThis.Error("The parameter 'treatmentNameFilter' cannot be null.");
        else if (treatmentNameFilter !== undefined)
            url_ += "TreatmentNameFilter=" + encodeURIComponent("" + treatmentNameFilter) + "&";
        if (treatmentObjectiveFilter === null)
            throw new globalThis.Error("The parameter 'treatmentObjectiveFilter' cannot be null.");
        else if (treatmentObjectiveFilter !== undefined)
            url_ += "TreatmentObjectiveFilter=" + encodeURIComponent("" + treatmentObjectiveFilter) + "&";
        if (treatmentProductTypeFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeFilter' cannot be null.");
        else if (treatmentProductTypeFilter !== undefined)
            url_ += "TreatmentProductTypeFilter=" + encodeURIComponent("" + treatmentProductTypeFilter) + "&";
        if (maxInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInterventionDateFilter' cannot be null.");
        else if (maxInterventionDateFilter !== undefined)
            url_ += "MaxInterventionDateFilter=" + encodeURIComponent(maxInterventionDateFilter ? "" + maxInterventionDateFilter.toString() : "") + "&";
        if (minInterventionDateFilter === null)
            throw new globalThis.Error("The parameter 'minInterventionDateFilter' cannot be null.");
        else if (minInterventionDateFilter !== undefined)
            url_ += "MinInterventionDateFilter=" + encodeURIComponent(minInterventionDateFilter ? "" + minInterventionDateFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTreatmentNutritionalsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTreatmentNutritionalsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSilvicultureTreatmentNutritionalsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSilvicultureTreatmentNutritionalFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/CreateSilvicultureTreatmentNutritionalFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSilvicultureTreatmentNutritionalFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSilvicultureTreatmentNutritionalFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSilvicultureTreatmentNutritionalFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSilvicultureTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllSilvicultureTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSilvicultureTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSilvicultureTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto>;
        }));
    }

    protected processGetAllSilvicultureTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentObjectiveForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentObjectiveForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentObjectiveForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentObjectiveForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentObjectiveForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentParcelTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentParcelTypeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentParcelTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentParcelTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentParcelTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param silvicultureTrialId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(silvicultureTrialId: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllCloneForLookupTable?";
        if (silvicultureTrialId === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialId' cannot be null.");
        else if (silvicultureTrialId !== undefined)
            url_ += "SilvicultureTrialId=" + encodeURIComponent("" + silvicultureTrialId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentProductTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentProductTypeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentProductTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentProductTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentProductTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentProductForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentProductForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentProductForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentProductForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentProductForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentInterventionZoneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentInterventionZoneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentInterventionZoneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentInterventionZoneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentInterventionZoneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentInterventionMomentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentInterventionMomentForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentInterventionMomentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentInterventionMomentForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentInterventionMomentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentInterventionObjectiveForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentInterventionObjectiveForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentInterventionObjectiveForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentInterventionObjectiveForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentInterventionObjectiveForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentApplyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentApplyForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentApplyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentApplyForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentApplyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllInterventionFoundationsOneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllInterventionFoundationsOneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInterventionFoundationsOneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInterventionFoundationsOneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto>;
        }));
    }

    protected processGetAllInterventionFoundationsOneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllInterventionFoundationsTwoForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllInterventionFoundationsTwoForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInterventionFoundationsTwoForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInterventionFoundationsTwoForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto>;
        }));
    }

    protected processGetAllInterventionFoundationsTwoForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllInterventionFoundationsThreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllInterventionFoundationsThreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInterventionFoundationsThreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInterventionFoundationsThreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto>;
        }));
    }

    protected processGetAllInterventionFoundationsThreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentDoseTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentDoseTypeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentDoseTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentDoseTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentDoseTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllSilvicultureTrialIdFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllSilvicultureTrialIdFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSilvicultureTrialIdFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSilvicultureTrialIdFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllSilvicultureTrialIdFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllGeneticMaterialFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllGeneticMaterialFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGeneticMaterialFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGeneticMaterialFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllGeneticMaterialFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllTreatmentNameFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentNameFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentNameFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentNameFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllTreatmentNameFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllTreatmentObjectiveFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentObjectiveFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentObjectiveFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentObjectiveFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllTreatmentObjectiveFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllTreatmentProductTypeFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTreatmentNutritionals/GetAllTreatmentProductTypeFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentProductTypeFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentProductTypeFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllTreatmentProductTypeFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SilvicultureTrialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param propertyFilter (optional) 
     * @param regionFilter (optional) 
     * @param coneatFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param instalationYearFilter (optional) 
     * @param experimentIdFilter (optional) 
     * @param experimentTypeNameFilter (optional) 
     * @param experimentSpecieNameFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param experimentCategoryNameFilter (optional) 
     * @param experimentClassificationNameFilter (optional) 
     * @param experimentClasificationtwoNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, propertyFilter: string | undefined, regionFilter: string | undefined, coneatFilter: string | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, instalationYearFilter: string | undefined, experimentIdFilter: string | undefined, experimentTypeNameFilter: string | undefined, experimentSpecieNameFilter: string | undefined, cloneBBXFilter: string | undefined, experimentCategoryNameFilter: string | undefined, experimentClassificationNameFilter: string | undefined, experimentClasificationtwoNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSilvicultureTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (propertyFilter === null)
            throw new globalThis.Error("The parameter 'propertyFilter' cannot be null.");
        else if (propertyFilter !== undefined)
            url_ += "PropertyFilter=" + encodeURIComponent("" + propertyFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            url_ += "ConeatFilter=" + encodeURIComponent("" + coneatFilter) + "&";
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (instalationYearFilter === null)
            throw new globalThis.Error("The parameter 'instalationYearFilter' cannot be null.");
        else if (instalationYearFilter !== undefined)
            url_ += "InstalationYearFilter=" + encodeURIComponent("" + instalationYearFilter) + "&";
        if (experimentIdFilter === null)
            throw new globalThis.Error("The parameter 'experimentIdFilter' cannot be null.");
        else if (experimentIdFilter !== undefined)
            url_ += "ExperimentIdFilter=" + encodeURIComponent("" + experimentIdFilter) + "&";
        if (experimentTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentTypeNameFilter' cannot be null.");
        else if (experimentTypeNameFilter !== undefined)
            url_ += "ExperimentTypeNameFilter=" + encodeURIComponent("" + experimentTypeNameFilter) + "&";
        if (experimentSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentSpecieNameFilter' cannot be null.");
        else if (experimentSpecieNameFilter !== undefined)
            url_ += "ExperimentSpecieNameFilter=" + encodeURIComponent("" + experimentSpecieNameFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (experimentCategoryNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentCategoryNameFilter' cannot be null.");
        else if (experimentCategoryNameFilter !== undefined)
            url_ += "ExperimentCategoryNameFilter=" + encodeURIComponent("" + experimentCategoryNameFilter) + "&";
        if (experimentClassificationNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentClassificationNameFilter' cannot be null.");
        else if (experimentClassificationNameFilter !== undefined)
            url_ += "ExperimentClassificationNameFilter=" + encodeURIComponent("" + experimentClassificationNameFilter) + "&";
        if (experimentClasificationtwoNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentClasificationtwoNameFilter' cannot be null.");
        else if (experimentClasificationtwoNameFilter !== undefined)
            url_ += "ExperimentClasificationtwoNameFilter=" + encodeURIComponent("" + experimentClasificationtwoNameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSilvicultureTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSilvicultureTrialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSilvicultureTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSilvicultureTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSilvicultureTrialForView(id: number | undefined): Observable<GetSilvicultureTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetSilvicultureTrialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTrialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTrialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSilvicultureTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSilvicultureTrialForViewDto>;
        }));
    }

    protected processGetSilvicultureTrialForView(response: HttpResponseBase): Observable<GetSilvicultureTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSilvicultureTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSilvicultureTrialForEdit(id: number | undefined): Observable<GetSilvicultureTrialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetSilvicultureTrialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTrialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTrialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSilvicultureTrialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSilvicultureTrialForEditOutput>;
        }));
    }

    protected processGetSilvicultureTrialForEdit(response: HttpResponseBase): Observable<GetSilvicultureTrialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSilvicultureTrialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSilvicultureTrialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param regionFilter (optional) 
     * @param coneatFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param experimentIdFilter (optional) 
     * @param experimentTypeNameFilter (optional) 
     * @param experimentSpecieNameFilter (optional) 
     * @param experimentStigmaFilter (optional) 
     * @param experimentCategoryNameFilter (optional) 
     * @param experimentClassificationNameFilter (optional) 
     * @param experimentClasificationtwoNameFilter (optional) 
     * @param propertyFilter (optional) 
     * @param instalationYear (optional) 
     * @param getTemplate (optional) 
     * @return OK
     */
    getSilvicultureTrialsToExcel(filter: string | undefined, regionFilter: string | undefined, coneatFilter: string | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, experimentIdFilter: string | undefined, experimentTypeNameFilter: string | undefined, experimentSpecieNameFilter: string | undefined, experimentStigmaFilter: string | undefined, experimentCategoryNameFilter: string | undefined, experimentClassificationNameFilter: string | undefined, experimentClasificationtwoNameFilter: string | undefined, propertyFilter: string | undefined, instalationYear: string | undefined, getTemplate: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetSilvicultureTrialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            url_ += "ConeatFilter=" + encodeURIComponent("" + coneatFilter) + "&";
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (experimentIdFilter === null)
            throw new globalThis.Error("The parameter 'experimentIdFilter' cannot be null.");
        else if (experimentIdFilter !== undefined)
            url_ += "ExperimentIdFilter=" + encodeURIComponent("" + experimentIdFilter) + "&";
        if (experimentTypeNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentTypeNameFilter' cannot be null.");
        else if (experimentTypeNameFilter !== undefined)
            url_ += "ExperimentTypeNameFilter=" + encodeURIComponent("" + experimentTypeNameFilter) + "&";
        if (experimentSpecieNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentSpecieNameFilter' cannot be null.");
        else if (experimentSpecieNameFilter !== undefined)
            url_ += "ExperimentSpecieNameFilter=" + encodeURIComponent("" + experimentSpecieNameFilter) + "&";
        if (experimentStigmaFilter === null)
            throw new globalThis.Error("The parameter 'experimentStigmaFilter' cannot be null.");
        else if (experimentStigmaFilter !== undefined)
            url_ += "ExperimentStigmaFilter=" + encodeURIComponent("" + experimentStigmaFilter) + "&";
        if (experimentCategoryNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentCategoryNameFilter' cannot be null.");
        else if (experimentCategoryNameFilter !== undefined)
            url_ += "ExperimentCategoryNameFilter=" + encodeURIComponent("" + experimentCategoryNameFilter) + "&";
        if (experimentClassificationNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentClassificationNameFilter' cannot be null.");
        else if (experimentClassificationNameFilter !== undefined)
            url_ += "ExperimentClassificationNameFilter=" + encodeURIComponent("" + experimentClassificationNameFilter) + "&";
        if (experimentClasificationtwoNameFilter === null)
            throw new globalThis.Error("The parameter 'experimentClasificationtwoNameFilter' cannot be null.");
        else if (experimentClasificationtwoNameFilter !== undefined)
            url_ += "ExperimentClasificationtwoNameFilter=" + encodeURIComponent("" + experimentClasificationtwoNameFilter) + "&";
        if (propertyFilter === null)
            throw new globalThis.Error("The parameter 'propertyFilter' cannot be null.");
        else if (propertyFilter !== undefined)
            url_ += "PropertyFilter=" + encodeURIComponent("" + propertyFilter) + "&";
        if (instalationYear === null)
            throw new globalThis.Error("The parameter 'instalationYear' cannot be null.");
        else if (instalationYear !== undefined)
            url_ += "InstalationYear=" + encodeURIComponent("" + instalationYear) + "&";
        if (getTemplate === null)
            throw new globalThis.Error("The parameter 'getTemplate' cannot be null.");
        else if (getTemplate !== undefined)
            url_ += "GetTemplate=" + encodeURIComponent("" + getTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSilvicultureTrialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSilvicultureTrialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSilvicultureTrialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllGroupTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllGroupTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto>;
        }));
    }

    protected processGetAllGroupTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentTypeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto>;
        }));
    }

    protected processGetAllExperimentTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentSpecieQuantityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentSpecieQuantityForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentSpecieQuantityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentSpecieQuantityForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto>;
        }));
    }

    protected processGetAllExperimentSpecieQuantityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentSpecieForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentSpecieForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentSpecieForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentSpecieForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto>;
        }));
    }

    protected processGetAllExperimentSpecieForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentLocationForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentLocationForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentLocationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentLocationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto>;
        }));
    }

    protected processGetAllExperimentLocationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentCategoryForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentCategoryForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentCategoryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentCategoryForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto>;
        }));
    }

    protected processGetAllExperimentCategoryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param categoryId (optional) 
     * @return OK
     */
    getAllExperimentClassificationForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, categoryId: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentClassificationForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentClassificationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentClassificationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto>;
        }));
    }

    protected processGetAllExperimentClassificationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllExperimentClasificationtwoForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentClasificationtwoForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentClasificationtwoForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentClasificationtwoForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto>;
        }));
    }

    protected processGetAllExperimentClasificationtwoForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialDesignTypesForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllTrialDesignTypesForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialDesignTypesForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialDesignTypesForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto>;
        }));
    }

    protected processGetAllTrialDesignTypesForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialStatusForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllTrialStatusForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialStatusForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialStatusForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto>;
        }));
    }

    protected processGetAllTrialStatusForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSilvicultureTrialFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/CreateSilvicultureTrialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSilvicultureTrialFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSilvicultureTrialFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSilvicultureTrialFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllPropertyFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllPropertyFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPropertyFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPropertyFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllPropertyFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllConeatFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllConeatFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConeatFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConeatFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllConeatFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllInstalationYearFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllInstalationYearFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInstalationYearFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInstalationYearFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllInstalationYearFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllCategoryFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllCategoryFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategoryFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategoryFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllCategoryFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllClasificationFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllClasificationFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClasificationFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClasificationFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllClasificationFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllClasificationTwoFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllClasificationTwoFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClasificationTwoFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClasificationTwoFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllClasificationTwoFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllExperimentIdFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentIdFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentIdFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentIdFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllExperimentIdFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllExperimentTypeFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentTypeFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentTypeFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentTypeFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllExperimentTypeFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllSpecieFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllSpecieFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpecieFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpecieFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllSpecieFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllExperimentStigmaFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllExperimentStigmaFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExperimentStigmaFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExperimentStigmaFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllExperimentStigmaFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllRegionFilter(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrials/GetAllRegionFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegionFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegionFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllRegionFilter(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SilvicultureTrialsFilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param silvicultureTrialId (optional) 
     * @param filter (optional) 
     * @param fileTags (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(silvicultureTrialId: number | undefined, filter: string | undefined, fileTags: _definitions_FileTagsDto[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllSilvicultureTrialFilesDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/GetAll?";
        if (silvicultureTrialId === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialId' cannot be null.");
        else if (silvicultureTrialId !== undefined)
            url_ += "SilvicultureTrialId=" + encodeURIComponent("" + silvicultureTrialId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fileTags === null)
            throw new globalThis.Error("The parameter 'fileTags' cannot be null.");
        else if (fileTags !== undefined)
            fileTags && fileTags.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FileTags[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSilvicultureTrialFilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSilvicultureTrialFilesDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSilvicultureTrialFilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSilvicultureTrialFilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getAllTags(filter: string | undefined): Observable<GetGenericFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/GetAllTags?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGenericFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGenericFilterDto[]>;
        }));
    }

    protected processGetAllTags(response: HttpResponseBase): Observable<GetGenericFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGenericFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param silvicultureTrialFileId (optional) 
     * @param newTag (optional) 
     * @return OK
     */
    updateTag(silvicultureTrialFileId: number | undefined, newTag: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/UpdateTag?";
        if (silvicultureTrialFileId === null)
            throw new globalThis.Error("The parameter 'silvicultureTrialFileId' cannot be null.");
        else if (silvicultureTrialFileId !== undefined)
            url_ += "silvicultureTrialFileId=" + encodeURIComponent("" + silvicultureTrialFileId) + "&";
        if (newTag === null)
            throw new globalThis.Error("The parameter 'newTag' cannot be null.");
        else if (newTag !== undefined)
            url_ += "newTag=" + encodeURIComponent("" + newTag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param silvicultureTrialId (optional) 
     * @param tag (optional) 
     * @param oldFiles (optional) 
     * @param newFiles (optional) 
     * @param id (optional) 
     * @return OK
     */
    createOrEdit(silvicultureTrialId: number | undefined, tag: string | undefined, oldFiles: FileBlobDto[] | undefined, newFiles: FileParameter[] | undefined, id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (silvicultureTrialId === null || silvicultureTrialId === undefined)
            throw new globalThis.Error("The parameter 'silvicultureTrialId' cannot be null.");
        else
            content_.append("SilvicultureTrialId", silvicultureTrialId.toString());
        if (tag === null || tag === undefined)
            throw new globalThis.Error("The parameter 'tag' cannot be null.");
        else
            content_.append("Tag", tag.toString());
        if (oldFiles === null || oldFiles === undefined)
            throw new globalThis.Error("The parameter 'oldFiles' cannot be null.");
        else
            oldFiles.forEach(item_ => content_.append("OldFiles", item_.toString()));
        if (newFiles === null || newFiles === undefined)
            throw new globalThis.Error("The parameter 'newFiles' cannot be null.");
        else
            newFiles.forEach(item_ => content_.append("NewFiles", item_.data, item_.fileName ? item_.fileName : "NewFiles") );
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param isMassive (optional) 
     * @param id (optional) 
     * @param fileId (optional) 
     * @return OK
     */
    delete(fileName: string | undefined, isMassive: boolean | undefined, id: number | undefined, fileId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/Delete?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isMassive === null)
            throw new globalThis.Error("The parameter 'isMassive' cannot be null.");
        else if (isMassive !== undefined)
            url_ += "IsMassive=" + encodeURIComponent("" + isMassive) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadFile(body: DownloadDeleteFilesBlobStorageDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SilvicultureTrialsFiles/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SourcePlantPlantationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxCanaletonFilter (optional) 
     * @param minCanaletonFilter (optional) 
     * @param maxPositionFilter (optional) 
     * @param minPositionFilter (optional) 
     * @param observationsFilter (optional) 
     * @param groupNumberFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param minGroupNumberFilter (optional) 
     * @param maxGroupNumberFilter (optional) 
     * @param operativeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, maxQuantityFilter: number | undefined, minQuantityFilter: number | undefined, maxCanaletonFilter: number | undefined, minCanaletonFilter: number | undefined, maxPositionFilter: number | undefined, minPositionFilter: number | undefined, observationsFilter: string | undefined, groupNumberFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, cloneBBXFilter: string | undefined, minGroupNumberFilter: number | undefined, maxGroupNumberFilter: number | undefined, operativeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSourcePlantPlantationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (maxQuantityFilter === null)
            throw new globalThis.Error("The parameter 'maxQuantityFilter' cannot be null.");
        else if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter === null)
            throw new globalThis.Error("The parameter 'minQuantityFilter' cannot be null.");
        else if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxCanaletonFilter === null)
            throw new globalThis.Error("The parameter 'maxCanaletonFilter' cannot be null.");
        else if (maxCanaletonFilter !== undefined)
            url_ += "MaxCanaletonFilter=" + encodeURIComponent("" + maxCanaletonFilter) + "&";
        if (minCanaletonFilter === null)
            throw new globalThis.Error("The parameter 'minCanaletonFilter' cannot be null.");
        else if (minCanaletonFilter !== undefined)
            url_ += "MinCanaletonFilter=" + encodeURIComponent("" + minCanaletonFilter) + "&";
        if (maxPositionFilter === null)
            throw new globalThis.Error("The parameter 'maxPositionFilter' cannot be null.");
        else if (maxPositionFilter !== undefined)
            url_ += "MaxPositionFilter=" + encodeURIComponent("" + maxPositionFilter) + "&";
        if (minPositionFilter === null)
            throw new globalThis.Error("The parameter 'minPositionFilter' cannot be null.");
        else if (minPositionFilter !== undefined)
            url_ += "MinPositionFilter=" + encodeURIComponent("" + minPositionFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (groupNumberFilter === null)
            throw new globalThis.Error("The parameter 'groupNumberFilter' cannot be null.");
        else if (groupNumberFilter !== undefined)
            url_ += "GroupNumberFilter=" + encodeURIComponent("" + groupNumberFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (minGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'minGroupNumberFilter' cannot be null.");
        else if (minGroupNumberFilter !== undefined)
            url_ += "MinGroupNumberFilter=" + encodeURIComponent("" + minGroupNumberFilter) + "&";
        if (maxGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxGroupNumberFilter' cannot be null.");
        else if (maxGroupNumberFilter !== undefined)
            url_ += "MaxGroupNumberFilter=" + encodeURIComponent("" + maxGroupNumberFilter) + "&";
        if (operativeFilter === null)
            throw new globalThis.Error("The parameter 'operativeFilter' cannot be null.");
        else if (operativeFilter !== undefined)
            url_ += "OperativeFilter=" + encodeURIComponent("" + operativeFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSourcePlantPlantationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSourcePlantPlantationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSourcePlantPlantationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSourcePlantPlantationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSourcePlantPlantationForView(id: number | undefined): Observable<GetSourcePlantPlantationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetSourcePlantPlantationForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantPlantationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantPlantationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSourcePlantPlantationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSourcePlantPlantationForViewDto>;
        }));
    }

    protected processGetSourcePlantPlantationForView(response: HttpResponseBase): Observable<GetSourcePlantPlantationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourcePlantPlantationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSourcePlantPlantationForEdit(id: number | undefined): Observable<GetSourcePlantPlantationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetSourcePlantPlantationForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantPlantationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantPlantationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSourcePlantPlantationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSourcePlantPlantationForEditOutput>;
        }));
    }

    protected processGetSourcePlantPlantationForEdit(response: HttpResponseBase): Observable<GetSourcePlantPlantationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourcePlantPlantationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSourcePlantPlantationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSourcePlantForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetAllSourcePlantForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto>;
        }));
    }

    protected processGetAllSourcePlantForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    getSourcePlantGroupNumberById(input: number | undefined): Observable<SourcePlantPlantationSourcePlantLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetSourcePlantGroupNumberById?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantGroupNumberById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantGroupNumberById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourcePlantPlantationSourcePlantLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourcePlantPlantationSourcePlantLookupTableDto>;
        }));
    }

    protected processGetSourcePlantGroupNumberById(response: HttpResponseBase): Observable<SourcePlantPlantationSourcePlantLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourcePlantPlantationSourcePlantLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxCanaletonFilter (optional) 
     * @param minCanaletonFilter (optional) 
     * @param maxPositionFilter (optional) 
     * @param minPositionFilter (optional) 
     * @param observationsFilter (optional) 
     * @param groupNumberFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param minGroupNumberFilter (optional) 
     * @param maxGroupNumberFilter (optional) 
     * @param operativeFilter (optional) 
     * @return OK
     */
    getSourcePlantPlantationsToExcel(filter: string | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, maxQuantityFilter: number | undefined, minQuantityFilter: number | undefined, maxCanaletonFilter: number | undefined, minCanaletonFilter: number | undefined, maxPositionFilter: number | undefined, minPositionFilter: number | undefined, observationsFilter: string | undefined, groupNumberFilter: number | undefined, measurementSelectionNumberTFilter: string | undefined, cloneBBXFilter: string | undefined, minGroupNumberFilter: number | undefined, maxGroupNumberFilter: number | undefined, operativeFilter: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetSourcePlantPlantationsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (maxQuantityFilter === null)
            throw new globalThis.Error("The parameter 'maxQuantityFilter' cannot be null.");
        else if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter === null)
            throw new globalThis.Error("The parameter 'minQuantityFilter' cannot be null.");
        else if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxCanaletonFilter === null)
            throw new globalThis.Error("The parameter 'maxCanaletonFilter' cannot be null.");
        else if (maxCanaletonFilter !== undefined)
            url_ += "MaxCanaletonFilter=" + encodeURIComponent("" + maxCanaletonFilter) + "&";
        if (minCanaletonFilter === null)
            throw new globalThis.Error("The parameter 'minCanaletonFilter' cannot be null.");
        else if (minCanaletonFilter !== undefined)
            url_ += "MinCanaletonFilter=" + encodeURIComponent("" + minCanaletonFilter) + "&";
        if (maxPositionFilter === null)
            throw new globalThis.Error("The parameter 'maxPositionFilter' cannot be null.");
        else if (maxPositionFilter !== undefined)
            url_ += "MaxPositionFilter=" + encodeURIComponent("" + maxPositionFilter) + "&";
        if (minPositionFilter === null)
            throw new globalThis.Error("The parameter 'minPositionFilter' cannot be null.");
        else if (minPositionFilter !== undefined)
            url_ += "MinPositionFilter=" + encodeURIComponent("" + minPositionFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (groupNumberFilter === null)
            throw new globalThis.Error("The parameter 'groupNumberFilter' cannot be null.");
        else if (groupNumberFilter !== undefined)
            url_ += "GroupNumberFilter=" + encodeURIComponent("" + groupNumberFilter) + "&";
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + measurementSelectionNumberTFilter) + "&";
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            url_ += "CloneBBXFilter=" + encodeURIComponent("" + cloneBBXFilter) + "&";
        if (minGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'minGroupNumberFilter' cannot be null.");
        else if (minGroupNumberFilter !== undefined)
            url_ += "MinGroupNumberFilter=" + encodeURIComponent("" + minGroupNumberFilter) + "&";
        if (maxGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxGroupNumberFilter' cannot be null.");
        else if (maxGroupNumberFilter !== undefined)
            url_ += "MaxGroupNumberFilter=" + encodeURIComponent("" + maxGroupNumberFilter) + "&";
        if (operativeFilter === null)
            throw new globalThis.Error("The parameter 'operativeFilter' cannot be null.");
        else if (operativeFilter !== undefined)
            url_ += "OperativeFilter=" + encodeURIComponent("" + operativeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantPlantationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantPlantationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSourcePlantPlantationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSourcePlantPlantationsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/CreateSourcePlantPlantationsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSourcePlantPlantationsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSourcePlantPlantationsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSourcePlantPlantationsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMassDiscardDate(body: UpdateMassDiscardDateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/UpdateMassDiscardDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMassDiscardDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMassDiscardDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMassDiscardDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupNumberFilter (optional) 
     * @return OK
     */
    getAllDistinctGroupNumbers(groupNumberFilter: string | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetAllDistinctGroupNumbers?";
        if (groupNumberFilter === null)
            throw new globalThis.Error("The parameter 'groupNumberFilter' cannot be null.");
        else if (groupNumberFilter !== undefined)
            url_ += "groupNumberFilter=" + encodeURIComponent("" + groupNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctGroupNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctGroupNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllDistinctGroupNumbers(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbtFilter (optional) 
     * @return OK
     */
    getAllDistinctBBTs(bbtFilter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetAllDistinctBBTs?";
        if (bbtFilter === null)
            throw new globalThis.Error("The parameter 'bbtFilter' cannot be null.");
        else if (bbtFilter !== undefined)
            url_ += "bbtFilter=" + encodeURIComponent("" + bbtFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBTs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBTs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDistinctBBTs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bbxFilter (optional) 
     * @return OK
     */
    getAllDistinctBBXs(bbxFilter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlantPlantations/GetAllDistinctBBXs?";
        if (bbxFilter === null)
            throw new globalThis.Error("The parameter 'bbxFilter' cannot be null.");
        else if (bbxFilter !== undefined)
            url_ += "bbxFilter=" + encodeURIComponent("" + bbxFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctBBXs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctBBXs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDistinctBBXs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SourcePlantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param groupNumberFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param originSourcePlantFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param operativeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, groupNumberFilter: string[] | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, originSourcePlantFilter: number | undefined, projectNameFilter: string[] | undefined, measurementSelectionNumberTFilter: string[] | undefined, cloneBBXFilter: string[] | undefined, sourcePlantGroupNumberFilter: string[] | undefined, operativeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSourcePlantForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (groupNumberFilter === null)
            throw new globalThis.Error("The parameter 'groupNumberFilter' cannot be null.");
        else if (groupNumberFilter !== undefined)
            groupNumberFilter && groupNumberFilter.forEach(item => { url_ += "GroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxStartDateFilter === null)
            throw new globalThis.Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
        if (minStartDateFilter === null)
            throw new globalThis.Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
        if (originSourcePlantFilter === null)
            throw new globalThis.Error("The parameter 'originSourcePlantFilter' cannot be null.");
        else if (originSourcePlantFilter !== undefined)
            url_ += "OriginSourcePlantFilter=" + encodeURIComponent("" + originSourcePlantFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            projectNameFilter && projectNameFilter.forEach(item => { url_ += "ProjectNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            measurementSelectionNumberTFilter && measurementSelectionNumberTFilter.forEach(item => { url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + item) + "&"; });
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            cloneBBXFilter && cloneBBXFilter.forEach(item => { url_ += "CloneBBXFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            sourcePlantGroupNumberFilter && sourcePlantGroupNumberFilter.forEach(item => { url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (operativeFilter === null)
            throw new globalThis.Error("The parameter 'operativeFilter' cannot be null.");
        else if (operativeFilter !== undefined)
            url_ += "OperativeFilter=" + encodeURIComponent("" + operativeFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSourcePlantForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSourcePlantForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSourcePlantForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSourcePlantForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSourcePlantForView(id: number | undefined): Observable<GetSourcePlantForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetSourcePlantForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSourcePlantForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSourcePlantForViewDto>;
        }));
    }

    protected processGetSourcePlantForView(response: HttpResponseBase): Observable<GetSourcePlantForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourcePlantForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSourcePlantForEdit(id: number | undefined): Observable<GetSourcePlantForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetSourcePlantForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSourcePlantForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSourcePlantForEditOutput>;
        }));
    }

    protected processGetSourcePlantForEdit(response: HttpResponseBase): Observable<GetSourcePlantForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourcePlantForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNextSourcePlantNumber(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetNextSourcePlantNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextSourcePlantNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextSourcePlantNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNextSourcePlantNumber(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSourcePlantDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteItem (optional) 
     * @return OK
     */
    deleteSelectedSourcePlant(deleteItem: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/deleteSelectedSourcePlant?";
        if (deleteItem === null)
            throw new globalThis.Error("The parameter 'deleteItem' cannot be null.");
        else if (deleteItem !== undefined)
            deleteItem && deleteItem.forEach(item => { url_ += "deleteItem=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSelectedSourcePlant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSelectedSourcePlant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteSelectedSourcePlant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param groupNumberFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param originSourcePlantFilter (optional) 
     * @param projectNameFilter (optional) 
     * @param measurementSelectionNumberTFilter (optional) 
     * @param cloneBBXFilter (optional) 
     * @param sourcePlantGroupNumberFilter (optional) 
     * @param operativeFilter (optional) 
     * @return OK
     */
    getSourcePlantsToExcel(filter: string | undefined, groupNumberFilter: string[] | undefined, maxStartDateFilter: DateTime | undefined, minStartDateFilter: DateTime | undefined, originSourcePlantFilter: number | undefined, projectNameFilter: string[] | undefined, measurementSelectionNumberTFilter: string[] | undefined, cloneBBXFilter: string[] | undefined, sourcePlantGroupNumberFilter: string[] | undefined, operativeFilter: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetSourcePlantsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (groupNumberFilter === null)
            throw new globalThis.Error("The parameter 'groupNumberFilter' cannot be null.");
        else if (groupNumberFilter !== undefined)
            groupNumberFilter && groupNumberFilter.forEach(item => { url_ += "GroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxStartDateFilter === null)
            throw new globalThis.Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toString() : "") + "&";
        if (minStartDateFilter === null)
            throw new globalThis.Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toString() : "") + "&";
        if (originSourcePlantFilter === null)
            throw new globalThis.Error("The parameter 'originSourcePlantFilter' cannot be null.");
        else if (originSourcePlantFilter !== undefined)
            url_ += "OriginSourcePlantFilter=" + encodeURIComponent("" + originSourcePlantFilter) + "&";
        if (projectNameFilter === null)
            throw new globalThis.Error("The parameter 'projectNameFilter' cannot be null.");
        else if (projectNameFilter !== undefined)
            projectNameFilter && projectNameFilter.forEach(item => { url_ += "ProjectNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (measurementSelectionNumberTFilter === null)
            throw new globalThis.Error("The parameter 'measurementSelectionNumberTFilter' cannot be null.");
        else if (measurementSelectionNumberTFilter !== undefined)
            measurementSelectionNumberTFilter && measurementSelectionNumberTFilter.forEach(item => { url_ += "MeasurementSelectionNumberTFilter=" + encodeURIComponent("" + item) + "&"; });
        if (cloneBBXFilter === null)
            throw new globalThis.Error("The parameter 'cloneBBXFilter' cannot be null.");
        else if (cloneBBXFilter !== undefined)
            cloneBBXFilter && cloneBBXFilter.forEach(item => { url_ += "CloneBBXFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            sourcePlantGroupNumberFilter && sourcePlantGroupNumberFilter.forEach(item => { url_ += "SourcePlantGroupNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (operativeFilter === null)
            throw new globalThis.Error("The parameter 'operativeFilter' cannot be null.");
        else if (operativeFilter !== undefined)
            url_ += "OperativeFilter=" + encodeURIComponent("" + operativeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcePlantsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcePlantsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSourcePlantsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param cloneId (optional) 
     * @return OK
     */
    getAllProjectForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, cloneId: number | undefined): Observable<PagedResultDtoOfSourcePlantProjectLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllProjectForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (cloneId === null)
            throw new globalThis.Error("The parameter 'cloneId' cannot be null.");
        else if (cloneId !== undefined)
            url_ += "cloneId=" + encodeURIComponent("" + cloneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSourcePlantProjectLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSourcePlantProjectLookupTableDto>;
        }));
    }

    protected processGetAllProjectForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSourcePlantProjectLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSourcePlantProjectLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    getAllMeasurementSelectionForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, projectId: number | undefined): Observable<PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllMeasurementSelectionForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementSelectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementSelectionForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto>;
        }));
    }

    protected processGetAllMeasurementSelectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    getAllCloneForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, projectId: number | undefined): Observable<PagedResultDtoOfSourcePlantCloneLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllCloneForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCloneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCloneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSourcePlantCloneLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSourcePlantCloneLookupTableDto>;
        }));
    }

    protected processGetAllCloneForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSourcePlantCloneLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSourcePlantCloneLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param originSourcePlant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSourcePlantForLookupTable(filter: string | undefined, originSourcePlant: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSourcePlantSourcePlantLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (originSourcePlant === null)
            throw new globalThis.Error("The parameter 'originSourcePlant' cannot be null.");
        else if (originSourcePlant !== undefined)
            url_ += "OriginSourcePlant=" + encodeURIComponent("" + originSourcePlant) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSourcePlantSourcePlantLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSourcePlantSourcePlantLookupTableDto>;
        }));
    }

    protected processGetAllSourcePlantForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSourcePlantSourcePlantLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSourcePlantSourcePlantLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSourcePlantsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/CreateSourcePlantsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSourcePlantsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSourcePlantsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSourcePlantsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantGroupNumberFilter (optional) 
     * @return OK
     */
    getAllSourcePlantGroupNumbersForLookupTable(sourcePlantGroupNumberFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantGroupNumbersForLookupTable?";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "sourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantGroupNumbersForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantGroupNumbersForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantGroupNumbersForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantProjectsFilter (optional) 
     * @return OK
     */
    getAllSourcePlantProjectsForLookupTable(sourcePlantProjectsFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantProjectsForLookupTable?";
        if (sourcePlantProjectsFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantProjectsFilter' cannot be null.");
        else if (sourcePlantProjectsFilter !== undefined)
            url_ += "sourcePlantProjectsFilter=" + encodeURIComponent("" + sourcePlantProjectsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantProjectsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantProjectsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantProjectsForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantBBTsFilter (optional) 
     * @return OK
     */
    getAllSourcePlantBBTsForLookupTable(sourcePlantBBTsFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantBBTsForLookupTable?";
        if (sourcePlantBBTsFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantBBTsFilter' cannot be null.");
        else if (sourcePlantBBTsFilter !== undefined)
            url_ += "sourcePlantBBTsFilter=" + encodeURIComponent("" + sourcePlantBBTsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantBBTsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantBBTsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantBBTsForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantBBXsFilter (optional) 
     * @return OK
     */
    getAllSourcePlantBBXsForLookupTable(sourcePlantBBXsFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantBBXsForLookupTable?";
        if (sourcePlantBBXsFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantBBXsFilter' cannot be null.");
        else if (sourcePlantBBXsFilter !== undefined)
            url_ += "sourcePlantBBXsFilter=" + encodeURIComponent("" + sourcePlantBBXsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantBBXsForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantBBXsForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantBBXsForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sourcePlantGroupNumberFilter (optional) 
     * @return OK
     */
    getAllSourcePlantSourcePlantsGroupNumbersForLookupTable(sourcePlantGroupNumberFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SourcePlants/GetAllSourcePlantSourcePlantsGroupNumbersForLookupTable?";
        if (sourcePlantGroupNumberFilter === null)
            throw new globalThis.Error("The parameter 'sourcePlantGroupNumberFilter' cannot be null.");
        else if (sourcePlantGroupNumberFilter !== undefined)
            url_ += "sourcePlantGroupNumberFilter=" + encodeURIComponent("" + sourcePlantGroupNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourcePlantSourcePlantsGroupNumbersForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourcePlantSourcePlantsGroupNumbersForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllSourcePlantSourcePlantsGroupNumbersForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SpeciesGroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param speciesFilter (optional) 
     * @param siteClassificationFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, speciesFilter: string | undefined, siteClassificationFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSpeciesGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            url_ += "SpeciesFilter=" + encodeURIComponent("" + speciesFilter) + "&";
        if (siteClassificationFilter === null)
            throw new globalThis.Error("The parameter 'siteClassificationFilter' cannot be null.");
        else if (siteClassificationFilter !== undefined)
            url_ += "SiteClassificationFilter=" + encodeURIComponent("" + siteClassificationFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSpeciesGroupForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSpeciesGroupForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSpeciesGroupForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSpeciesGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSpeciesGroupForView(id: number | undefined): Observable<GetSpeciesGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/GetSpeciesGroupForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeciesGroupForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeciesGroupForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSpeciesGroupForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSpeciesGroupForViewDto>;
        }));
    }

    protected processGetSpeciesGroupForView(response: HttpResponseBase): Observable<GetSpeciesGroupForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSpeciesGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSpeciesGroupForEdit(id: number | undefined): Observable<GetSpeciesGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/GetSpeciesGroupForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeciesGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeciesGroupForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSpeciesGroupForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSpeciesGroupForEditOutput>;
        }));
    }

    protected processGetSpeciesGroupForEdit(response: HttpResponseBase): Observable<GetSpeciesGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSpeciesGroupForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSpeciesGroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param speciesFilter (optional) 
     * @param siteClassificationFilter (optional) 
     * @return OK
     */
    getSpeciesGroupsToExcel(filter: string | undefined, nameFilter: string | undefined, speciesFilter: string | undefined, siteClassificationFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroups/GetSpeciesGroupsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (speciesFilter === null)
            throw new globalThis.Error("The parameter 'speciesFilter' cannot be null.");
        else if (speciesFilter !== undefined)
            url_ += "SpeciesFilter=" + encodeURIComponent("" + speciesFilter) + "&";
        if (siteClassificationFilter === null)
            throw new globalThis.Error("The parameter 'siteClassificationFilter' cannot be null.");
        else if (siteClassificationFilter !== undefined)
            url_ += "SiteClassificationFilter=" + encodeURIComponent("" + siteClassificationFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeciesGroupsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeciesGroupsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSpeciesGroupsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SuppliersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSupplierForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSupplierForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSupplierForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSupplierForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSupplierForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSupplierForView(id: number | undefined): Observable<GetSupplierForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/GetSupplierForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSupplierForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSupplierForViewDto>;
        }));
    }

    protected processGetSupplierForView(response: HttpResponseBase): Observable<GetSupplierForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupplierForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSupplierForEdit(id: number | undefined): Observable<GetSupplierForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/GetSupplierForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSupplierForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSupplierForEditOutput>;
        }));
    }

    protected processGetSupplierForEdit(response: HttpResponseBase): Observable<GetSupplierForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupplierForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditSupplierDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getSuppliersToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/GetSuppliersToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSuppliersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSupplierFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/CreateSupplierFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplierFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplierFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateSupplierFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditSupplierDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Suppliers/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditSupplierDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditSupplierDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditSupplierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditSupplierDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new globalThis.Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new globalThis.Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new globalThis.Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new globalThis.Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new globalThis.Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param extension (optional) 
     * @return OK
     */
    getTenantLogo(skin: string, tenantId: number | undefined, extension: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}?";
        if (skin === undefined || skin === null)
            throw new globalThis.Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (extension === null)
            throw new globalThis.Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new globalThis.Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new globalThis.Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearDarkLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearDarkLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearDarkLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearDarkLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearDarkLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearDarkLogoMinimal(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearDarkLogoMinimal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearDarkLogoMinimal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearDarkLogoMinimal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearDarkLogoMinimal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearLightLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLightLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLightLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLightLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLightLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearLightLogoMinimal(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLightLogoMinimal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLightLogoMinimal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLightLogoMinimal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLightLogoMinimal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new globalThis.Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return OK
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new globalThis.Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return OK
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new globalThis.Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return OK
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new globalThis.Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return OK
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new globalThis.Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new globalThis.Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return OK
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new globalThis.Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return OK
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity === null)
            throw new globalThis.Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentAppliesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentApplyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentApplies/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentApplyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentApplyForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentApplyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentApplyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentApplyForEdit(id: number | undefined): Observable<GetTreatmentApplyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentApplies/GetTreatmentApplyForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentApplyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentApplyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentApplyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentApplyForEditOutput>;
        }));
    }

    protected processGetTreatmentApplyForEdit(response: HttpResponseBase): Observable<GetTreatmentApplyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentApplyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentApplyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentApplies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentApplies/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentAppliesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentApplies/GetTreatmentAppliesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentAppliesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentAppliesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentAppliesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentDoseTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentDoseTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentDoseTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentDoseTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentDoseTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentDoseTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentDoseTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentDoseTypeForEdit(id: number | undefined): Observable<GetTreatmentDoseTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentDoseTypes/GetTreatmentDoseTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentDoseTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentDoseTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentDoseTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentDoseTypeForEditOutput>;
        }));
    }

    protected processGetTreatmentDoseTypeForEdit(response: HttpResponseBase): Observable<GetTreatmentDoseTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentDoseTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentDoseTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentDoseTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentDoseTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentDoseTypesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentDoseTypes/GetTreatmentDoseTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentDoseTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentDoseTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentDoseTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentInterventionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentInterventionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentInterventions/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentInterventionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentInterventionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentInterventionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentInterventionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentInterventionForEdit(id: number | undefined): Observable<GetTreatmentInterventionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentInterventions/GetTreatmentInterventionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentInterventionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentInterventionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentInterventionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentInterventionForEditOutput>;
        }));
    }

    protected processGetTreatmentInterventionForEdit(response: HttpResponseBase): Observable<GetTreatmentInterventionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentInterventionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentInterventionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentInterventions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentInterventions/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentInterventionsToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentInterventions/GetTreatmentInterventionsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentInterventionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentInterventionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentInterventionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentObjectivesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentObjectiveForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentObjectives/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentObjectiveForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentObjectiveForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentObjectiveForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentObjectiveForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentObjectiveForEdit(id: number | undefined): Observable<GetTreatmentObjectiveForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentObjectives/GetTreatmentObjectiveForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentObjectiveForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentObjectiveForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentObjectiveForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentObjectiveForEditOutput>;
        }));
    }

    protected processGetTreatmentObjectiveForEdit(response: HttpResponseBase): Observable<GetTreatmentObjectiveForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentObjectiveForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentObjectiveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentObjectives/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentObjectives/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentObjectivesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentObjectives/GetTreatmentObjectivesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentObjectivesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentObjectivesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentObjectivesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentParcelTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentParcelTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentParcelTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentParcelTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentParcelTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentParcelTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentParcelTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentParcelTypeForEdit(id: number | undefined): Observable<GetTreatmentParcelTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentParcelTypes/GetTreatmentParcelTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentParcelTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentParcelTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentParcelTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentParcelTypeForEditOutput>;
        }));
    }

    protected processGetTreatmentParcelTypeForEdit(response: HttpResponseBase): Observable<GetTreatmentParcelTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentParcelTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentParcelTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentParcelTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentParcelTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentParcelTypesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentParcelTypes/GetTreatmentParcelTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentParcelTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentParcelTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentParcelTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param treatmentProductTypeProductTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, treatmentProductTypeProductTypeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treatmentProductTypeProductTypeFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeProductTypeFilter' cannot be null.");
        else if (treatmentProductTypeProductTypeFilter !== undefined)
            url_ += "TreatmentProductTypeProductTypeFilter=" + encodeURIComponent("" + treatmentProductTypeProductTypeFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentProductForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentProductForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentProductForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentProductForEdit(id: number | undefined): Observable<GetTreatmentProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/GetTreatmentProductForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProductForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentProductForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentProductForEditOutput>;
        }));
    }

    protected processGetTreatmentProductForEdit(response: HttpResponseBase): Observable<GetTreatmentProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentProductForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param treatmentProductTypeProductTypeFilter (optional) 
     * @param treatmentProductTypeIdFilter (optional) 
     * @return OK
     */
    getTreatmentProductsToExcel(filter: string | undefined, treatmentProductTypeProductTypeFilter: string | undefined, treatmentProductTypeIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/GetTreatmentProductsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treatmentProductTypeProductTypeFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeProductTypeFilter' cannot be null.");
        else if (treatmentProductTypeProductTypeFilter !== undefined)
            url_ += "TreatmentProductTypeProductTypeFilter=" + encodeURIComponent("" + treatmentProductTypeProductTypeFilter) + "&";
        if (treatmentProductTypeIdFilter === null)
            throw new globalThis.Error("The parameter 'treatmentProductTypeIdFilter' cannot be null.");
        else if (treatmentProductTypeIdFilter !== undefined)
            url_ += "TreatmentProductTypeIdFilter=" + encodeURIComponent("" + treatmentProductTypeIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProductsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentProductsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentProductTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProducts/GetAllTreatmentProductTypeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentProductTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentProductTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentProductTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentProductTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentProductTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProductTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentProductTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentProductTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentProductTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentProductTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentProductTypeForEdit(id: number | undefined): Observable<GetTreatmentProductTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProductTypes/GetTreatmentProductTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProductTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProductTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentProductTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentProductTypeForEditOutput>;
        }));
    }

    protected processGetTreatmentProductTypeForEdit(response: HttpResponseBase): Observable<GetTreatmentProductTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentProductTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentProductTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProductTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProductTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTreatmentProductTypesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProductTypes/GetTreatmentProductTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentProductTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentProductTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentProductTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxBlockFilter (optional) 
     * @param minBlockFilter (optional) 
     * @param subBlockFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_SeedIdsFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_CloneIdsFilter (optional) 
     * @param onlyHSCFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxBlockFilter: number | undefined, minBlockFilter: number | undefined, subBlockFilter: number | undefined, trialStandNameFilter: string | undefined, trialNumbersFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_SeedIdsFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_CloneIdsFilter: (number | undefined)[] | undefined, onlyHSCFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreatmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBlockFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFilter' cannot be null.");
        else if (maxBlockFilter !== undefined)
            url_ += "MaxBlockFilter=" + encodeURIComponent("" + maxBlockFilter) + "&";
        if (minBlockFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFilter' cannot be null.");
        else if (minBlockFilter !== undefined)
            url_ += "MinBlockFilter=" + encodeURIComponent("" + minBlockFilter) + "&";
        if (subBlockFilter === null)
            throw new globalThis.Error("The parameter 'subBlockFilter' cannot be null.");
        else if (subBlockFilter !== undefined)
            url_ += "SubBlockFilter=" + encodeURIComponent("" + subBlockFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            trialNumbersFilter && trialNumbersFilter.forEach(item => { url_ += "TrialNumbersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_SeedIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_SeedIdsFilter && getAllTreatmentGeneticMaterialIds_SeedIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_CloneIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_CloneIdsFilter && getAllTreatmentGeneticMaterialIds_CloneIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.CloneIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (onlyHSCFilter === null)
            throw new globalThis.Error("The parameter 'onlyHSCFilter' cannot be null.");
        else if (onlyHSCFilter !== undefined)
            url_ += "OnlyHSCFilter=" + encodeURIComponent("" + onlyHSCFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreatmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreatmentForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreatmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreatmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentForView(id: number | undefined): Observable<GetTreatmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetTreatmentForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentForViewDto>;
        }));
    }

    protected processGetTreatmentForView(response: HttpResponseBase): Observable<GetTreatmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreatmentForEdit(id: number | undefined): Observable<GetTreatmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetTreatmentForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreatmentForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreatmentForEditOutput>;
        }));
    }

    protected processGetTreatmentForEdit(response: HttpResponseBase): Observable<GetTreatmentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreatmentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeTreatmentForEdit(id: number | undefined): Observable<GetTreeTreatmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetTreeTreatmentForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeTreatmentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeTreatmentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeTreatmentForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeTreatmentForEditOutput>;
        }));
    }

    protected processGetTreeTreatmentForEdit(response: HttpResponseBase): Observable<GetTreeTreatmentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeTreatmentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTreeAndTreatment(body: CreateOrEditTreeTreatmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/UpdateTreeAndTreatment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTreeAndTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTreeAndTreatment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTreeAndTreatment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreatmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTree(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/DeleteTree?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTree(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBlockFilter (optional) 
     * @param minBlockFilter (optional) 
     * @param subBlockFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_SeedIdsFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_CloneIdsFilter (optional) 
     * @return OK
     */
    deleteMassiveTreatment(filter: string | undefined, maxBlockFilter: number | undefined, minBlockFilter: number | undefined, subBlockFilter: number | undefined, trialStandNameFilter: string | undefined, trialNumbersFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_SeedIdsFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_CloneIdsFilter: (number | undefined)[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/DeleteMassiveTreatment?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBlockFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFilter' cannot be null.");
        else if (maxBlockFilter !== undefined)
            url_ += "MaxBlockFilter=" + encodeURIComponent("" + maxBlockFilter) + "&";
        if (minBlockFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFilter' cannot be null.");
        else if (minBlockFilter !== undefined)
            url_ += "MinBlockFilter=" + encodeURIComponent("" + minBlockFilter) + "&";
        if (subBlockFilter === null)
            throw new globalThis.Error("The parameter 'subBlockFilter' cannot be null.");
        else if (subBlockFilter !== undefined)
            url_ += "SubBlockFilter=" + encodeURIComponent("" + subBlockFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            trialNumbersFilter && trialNumbersFilter.forEach(item => { url_ += "TrialNumbersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_SeedIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_SeedIdsFilter && getAllTreatmentGeneticMaterialIds_SeedIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_CloneIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_CloneIdsFilter && getAllTreatmentGeneticMaterialIds_CloneIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.CloneIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMassiveTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMassiveTreatment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteMassiveTreatment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxBlockFilter (optional) 
     * @param minBlockFilter (optional) 
     * @param subBlockFilter (optional) 
     * @param trialStandNameFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_SeedIdsFilter (optional) 
     * @param getAllTreatmentGeneticMaterialIds_CloneIdsFilter (optional) 
     * @param onlyHSCFilter (optional) 
     * @return OK
     */
    getTreatmentsToExcel(filter: string | undefined, maxBlockFilter: number | undefined, minBlockFilter: number | undefined, subBlockFilter: number | undefined, trialStandNameFilter: string | undefined, trialNumbersFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_SeedIdsFilter: (number | undefined)[] | undefined, getAllTreatmentGeneticMaterialIds_CloneIdsFilter: (number | undefined)[] | undefined, onlyHSCFilter: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetTreatmentsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBlockFilter === null)
            throw new globalThis.Error("The parameter 'maxBlockFilter' cannot be null.");
        else if (maxBlockFilter !== undefined)
            url_ += "MaxBlockFilter=" + encodeURIComponent("" + maxBlockFilter) + "&";
        if (minBlockFilter === null)
            throw new globalThis.Error("The parameter 'minBlockFilter' cannot be null.");
        else if (minBlockFilter !== undefined)
            url_ += "MinBlockFilter=" + encodeURIComponent("" + minBlockFilter) + "&";
        if (subBlockFilter === null)
            throw new globalThis.Error("The parameter 'subBlockFilter' cannot be null.");
        else if (subBlockFilter !== undefined)
            url_ += "SubBlockFilter=" + encodeURIComponent("" + subBlockFilter) + "&";
        if (trialStandNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStandNameFilter' cannot be null.");
        else if (trialStandNameFilter !== undefined)
            url_ += "TrialStandNameFilter=" + encodeURIComponent("" + trialStandNameFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            trialNumbersFilter && trialNumbersFilter.forEach(item => { url_ += "TrialNumbersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_SeedIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_SeedIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_SeedIdsFilter && getAllTreatmentGeneticMaterialIds_SeedIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.SeedIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter === null)
            throw new globalThis.Error("The parameter 'getAllTreatmentGeneticMaterialIds_CloneIdsFilter' cannot be null.");
        else if (getAllTreatmentGeneticMaterialIds_CloneIdsFilter !== undefined)
            getAllTreatmentGeneticMaterialIds_CloneIdsFilter && getAllTreatmentGeneticMaterialIds_CloneIdsFilter.forEach(item => { url_ += "getAllTreatmentGeneticMaterialIds.CloneIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (onlyHSCFilter === null)
            throw new globalThis.Error("The parameter 'onlyHSCFilter' cannot be null.");
        else if (onlyHSCFilter !== undefined)
            url_ += "OnlyHSCFilter=" + encodeURIComponent("" + onlyHSCFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreatmentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreatmentsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreatmentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTrialForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreatmentTrialLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetAllTrialForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreatmentTrialLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreatmentTrialLookupTableDto>;
        }));
    }

    protected processGetAllTrialForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreatmentTrialLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreatmentTrialLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreatmentSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreatmentSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreatmentSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreatmentSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreatmentSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreatmentTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreatmentTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreatmentTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreatmentTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreatmentTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDistinctTrialIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetAllDistinctTrialIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctTrialIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctTrialIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllDistinctTrialIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTreatmentFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/CreateTreatmentFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTreatmentFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTreatmentFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTreatmentFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isRenewal (optional) 
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(isRenewal: boolean | undefined, body: string | undefined): Observable<CreateOrEditTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/OnPostImportFromExcel?";
        if (isRenewal === null)
            throw new globalThis.Error("The parameter 'isRenewal' cannot be null.");
        else if (isRenewal !== undefined)
            url_ += "isRenewal=" + encodeURIComponent("" + isRenewal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTreeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTreeDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTreeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTreeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getIdTreeStatusEnPie(): Observable<number | null> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/GetIdTreeStatusEnPie";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdTreeStatusEnPie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdTreeStatusEnPie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetIdTreeStatusEnPie(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param treeId (optional) 
     * @return OK
     */
    validateDeletedTree(treeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/ValidateDeletedTree?";
        if (treeId === null)
            throw new globalThis.Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDeletedTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDeletedTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDeletedTree(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateDeletedTrees(body: Tree[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/ValidateDeletedTrees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDeletedTrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDeletedTrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDeletedTrees(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renewTreatmentFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Treatments/RenewTreatmentFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewTreatmentFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewTreatmentFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processRenewTreatmentFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreeManagementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param treeOldFilter (optional) 
     * @param maxdateModifiedFilter (optional) 
     * @param mindateModifiedFilter (optional) 
     * @param treeNSFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, treeOldFilter: string | undefined, maxdateModifiedFilter: DateTime | undefined, mindateModifiedFilter: DateTime | undefined, treeNSFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreeManagementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treeOldFilter === null)
            throw new globalThis.Error("The parameter 'treeOldFilter' cannot be null.");
        else if (treeOldFilter !== undefined)
            url_ += "TreeOldFilter=" + encodeURIComponent("" + treeOldFilter) + "&";
        if (maxdateModifiedFilter === null)
            throw new globalThis.Error("The parameter 'maxdateModifiedFilter' cannot be null.");
        else if (maxdateModifiedFilter !== undefined)
            url_ += "MaxdateModifiedFilter=" + encodeURIComponent(maxdateModifiedFilter ? "" + maxdateModifiedFilter.toString() : "") + "&";
        if (mindateModifiedFilter === null)
            throw new globalThis.Error("The parameter 'mindateModifiedFilter' cannot be null.");
        else if (mindateModifiedFilter !== undefined)
            url_ += "MindateModifiedFilter=" + encodeURIComponent(mindateModifiedFilter ? "" + mindateModifiedFilter.toString() : "") + "&";
        if (treeNSFilter === null)
            throw new globalThis.Error("The parameter 'treeNSFilter' cannot be null.");
        else if (treeNSFilter !== undefined)
            url_ += "TreeNSFilter=" + encodeURIComponent("" + treeNSFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreeManagementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreeManagementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreeManagementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreeManagementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeManagementForEdit(id: number | undefined): Observable<GetTreeManagementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetTreeManagementForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeManagementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeManagementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeManagementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeManagementForEditOutput>;
        }));
    }

    protected processGetTreeManagementForEdit(response: HttpResponseBase): Observable<GetTreeManagementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeManagementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreeManagementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreatmentSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetAllSeedForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreatmentSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreatmentSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreatmentSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreatmentSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param treeOldFilter (optional) 
     * @param maxdateModifiedFilter (optional) 
     * @param mindateModifiedFilter (optional) 
     * @param treeNSFilter (optional) 
     * @return OK
     */
    getTreeManagementsToExcel(filter: string | undefined, treeOldFilter: string | undefined, maxdateModifiedFilter: DateTime | undefined, mindateModifiedFilter: DateTime | undefined, treeNSFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetTreeManagementsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treeOldFilter === null)
            throw new globalThis.Error("The parameter 'treeOldFilter' cannot be null.");
        else if (treeOldFilter !== undefined)
            url_ += "TreeOldFilter=" + encodeURIComponent("" + treeOldFilter) + "&";
        if (maxdateModifiedFilter === null)
            throw new globalThis.Error("The parameter 'maxdateModifiedFilter' cannot be null.");
        else if (maxdateModifiedFilter !== undefined)
            url_ += "MaxdateModifiedFilter=" + encodeURIComponent(maxdateModifiedFilter ? "" + maxdateModifiedFilter.toString() : "") + "&";
        if (mindateModifiedFilter === null)
            throw new globalThis.Error("The parameter 'mindateModifiedFilter' cannot be null.");
        else if (mindateModifiedFilter !== undefined)
            url_ += "MindateModifiedFilter=" + encodeURIComponent(mindateModifiedFilter ? "" + mindateModifiedFilter.toString() : "") + "&";
        if (treeNSFilter === null)
            throw new globalThis.Error("The parameter 'treeNSFilter' cannot be null.");
        else if (treeNSFilter !== undefined)
            url_ += "TreeNSFilter=" + encodeURIComponent("" + treeNSFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeManagementsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeManagementsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreeManagementsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param specie (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSeedFilterSpecieForLookupTable(filterText: string | undefined, specie: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetAllSeedFilterSpecieForLookupTable?";
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (specie === null)
            throw new globalThis.Error("The parameter 'specie' cannot be null.");
        else if (specie !== undefined)
            url_ += "Specie=" + encodeURIComponent("" + specie) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeedFilterSpecieForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeedFilterSpecieForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
        }));
    }

    protected processGetAllSeedFilterSpecieForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelperSeedSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param specie (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllcloneFilterSpecieForLookupTable(filterText: string | undefined, specie: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetAllcloneFilterSpecieForLookupTable?";
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (specie === null)
            throw new globalThis.Error("The parameter 'specie' cannot be null.");
        else if (specie !== undefined)
            url_ += "Specie=" + encodeURIComponent("" + specie) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllcloneFilterSpecieForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllcloneFilterSpecieForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto>;
        }));
    }

    protected processGetAllcloneFilterSpecieForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfHelperSeedSeedLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfHelperSeedSeedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreeManagementTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeManagements/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreeManagementTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreeManagementTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreeManagementTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreeManagementTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreeMeasurementAlertsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param codeFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, codeFilter: number | undefined, trialNumbersFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreeMeasurementAlertForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (codeFilter === null)
            throw new globalThis.Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            url_ += "TrialNumbersFilter=" + encodeURIComponent("" + trialNumbersFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreeMeasurementAlertForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreeMeasurementAlertForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreeMeasurementAlertForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreeMeasurementAlertForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeMeasurementAlertForView(id: number | undefined): Observable<GetTreeMeasurementAlertForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/GetTreeMeasurementAlertForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementAlertForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementAlertForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeMeasurementAlertForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeMeasurementAlertForViewDto>;
        }));
    }

    protected processGetTreeMeasurementAlertForView(response: HttpResponseBase): Observable<GetTreeMeasurementAlertForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeMeasurementAlertForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeMeasurementAlertForEdit(id: number | undefined): Observable<GetTreeMeasurementAlertForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/GetTreeMeasurementAlertForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementAlertForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementAlertForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeMeasurementAlertForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeMeasurementAlertForEditOutput>;
        }));
    }

    protected processGetTreeMeasurementAlertForEdit(response: HttpResponseBase): Observable<GetTreeMeasurementAlertForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeMeasurementAlertForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreeMeasurementAlertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param codeFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @return OK
     */
    getTreeMeasurementAlertsToExcel(filter: string | undefined, maxDateFilter: DateTime | undefined, minDateFilter: DateTime | undefined, codeFilter: number | undefined, trialNumbersFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/GetTreeMeasurementAlertsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxDateFilter === null)
            throw new globalThis.Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toString() : "") + "&";
        if (minDateFilter === null)
            throw new globalThis.Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toString() : "") + "&";
        if (codeFilter === null)
            throw new globalThis.Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            url_ += "TrialNumbersFilter=" + encodeURIComponent("" + trialNumbersFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementAlertsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementAlertsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreeMeasurementAlertsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDistinctTrialIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurementAlerts/GetAllDistinctTrialIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctTrialIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctTrialIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllDistinctTrialIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreeMeasurementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxMeasurementDateFilter (optional) 
     * @param minMeasurementDateFilter (optional) 
     * @param maxDAPFilter (optional) 
     * @param minDAPFilter (optional) 
     * @param maxHeightFilter (optional) 
     * @param minHeightFilter (optional) 
     * @param maxVolumeFilter (optional) 
     * @param minVolumeFilter (optional) 
     * @param maxDefectHeightFilter (optional) 
     * @param minDefectHeightFilter (optional) 
     * @param maxSobreFilter (optional) 
     * @param minSobreFilter (optional) 
     * @param observationsFilter (optional) 
     * @param fliaFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param adultObservationCodeDetailFilter (optional) 
     * @param frostToleranceCodeFilter (optional) 
     * @param pestAndDiseaseCodeFilter (optional) 
     * @param typeTrialIdFilter (optional) 
     * @param maxTrialAgeDataFilter (optional) 
     * @param minTrialAgeDataFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxMeasurementDateFilter: DateTime | undefined, minMeasurementDateFilter: DateTime | undefined, maxDAPFilter: number | undefined, minDAPFilter: number | undefined, maxHeightFilter: number | undefined, minHeightFilter: number | undefined, maxVolumeFilter: number | undefined, minVolumeFilter: number | undefined, maxDefectHeightFilter: number | undefined, minDefectHeightFilter: number | undefined, maxSobreFilter: number | undefined, minSobreFilter: number | undefined, observationsFilter: string | undefined, fliaFilter: string | undefined, treeSpecieFilter: string | undefined, adultObservationCodeDetailFilter: string | undefined, frostToleranceCodeFilter: string | undefined, pestAndDiseaseCodeFilter: string | undefined, typeTrialIdFilter: number | undefined, maxTrialAgeDataFilter: number | undefined, minTrialAgeDataFilter: number | undefined, trialNumbersFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreeMeasurementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxMeasurementDateFilter === null)
            throw new globalThis.Error("The parameter 'maxMeasurementDateFilter' cannot be null.");
        else if (maxMeasurementDateFilter !== undefined)
            url_ += "MaxMeasurementDateFilter=" + encodeURIComponent(maxMeasurementDateFilter ? "" + maxMeasurementDateFilter.toString() : "") + "&";
        if (minMeasurementDateFilter === null)
            throw new globalThis.Error("The parameter 'minMeasurementDateFilter' cannot be null.");
        else if (minMeasurementDateFilter !== undefined)
            url_ += "MinMeasurementDateFilter=" + encodeURIComponent(minMeasurementDateFilter ? "" + minMeasurementDateFilter.toString() : "") + "&";
        if (maxDAPFilter === null)
            throw new globalThis.Error("The parameter 'maxDAPFilter' cannot be null.");
        else if (maxDAPFilter !== undefined)
            url_ += "MaxDAPFilter=" + encodeURIComponent("" + maxDAPFilter) + "&";
        if (minDAPFilter === null)
            throw new globalThis.Error("The parameter 'minDAPFilter' cannot be null.");
        else if (minDAPFilter !== undefined)
            url_ += "MinDAPFilter=" + encodeURIComponent("" + minDAPFilter) + "&";
        if (maxHeightFilter === null)
            throw new globalThis.Error("The parameter 'maxHeightFilter' cannot be null.");
        else if (maxHeightFilter !== undefined)
            url_ += "MaxHeightFilter=" + encodeURIComponent("" + maxHeightFilter) + "&";
        if (minHeightFilter === null)
            throw new globalThis.Error("The parameter 'minHeightFilter' cannot be null.");
        else if (minHeightFilter !== undefined)
            url_ += "MinHeightFilter=" + encodeURIComponent("" + minHeightFilter) + "&";
        if (maxVolumeFilter === null)
            throw new globalThis.Error("The parameter 'maxVolumeFilter' cannot be null.");
        else if (maxVolumeFilter !== undefined)
            url_ += "MaxVolumeFilter=" + encodeURIComponent("" + maxVolumeFilter) + "&";
        if (minVolumeFilter === null)
            throw new globalThis.Error("The parameter 'minVolumeFilter' cannot be null.");
        else if (minVolumeFilter !== undefined)
            url_ += "MinVolumeFilter=" + encodeURIComponent("" + minVolumeFilter) + "&";
        if (maxDefectHeightFilter === null)
            throw new globalThis.Error("The parameter 'maxDefectHeightFilter' cannot be null.");
        else if (maxDefectHeightFilter !== undefined)
            url_ += "MaxDefectHeightFilter=" + encodeURIComponent("" + maxDefectHeightFilter) + "&";
        if (minDefectHeightFilter === null)
            throw new globalThis.Error("The parameter 'minDefectHeightFilter' cannot be null.");
        else if (minDefectHeightFilter !== undefined)
            url_ += "MinDefectHeightFilter=" + encodeURIComponent("" + minDefectHeightFilter) + "&";
        if (maxSobreFilter === null)
            throw new globalThis.Error("The parameter 'maxSobreFilter' cannot be null.");
        else if (maxSobreFilter !== undefined)
            url_ += "MaxSobreFilter=" + encodeURIComponent("" + maxSobreFilter) + "&";
        if (minSobreFilter === null)
            throw new globalThis.Error("The parameter 'minSobreFilter' cannot be null.");
        else if (minSobreFilter !== undefined)
            url_ += "MinSobreFilter=" + encodeURIComponent("" + minSobreFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (fliaFilter === null)
            throw new globalThis.Error("The parameter 'fliaFilter' cannot be null.");
        else if (fliaFilter !== undefined)
            url_ += "FliaFilter=" + encodeURIComponent("" + fliaFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (adultObservationCodeDetailFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationCodeDetailFilter' cannot be null.");
        else if (adultObservationCodeDetailFilter !== undefined)
            url_ += "AdultObservationCodeDetailFilter=" + encodeURIComponent("" + adultObservationCodeDetailFilter) + "&";
        if (frostToleranceCodeFilter === null)
            throw new globalThis.Error("The parameter 'frostToleranceCodeFilter' cannot be null.");
        else if (frostToleranceCodeFilter !== undefined)
            url_ += "FrostToleranceCodeFilter=" + encodeURIComponent("" + frostToleranceCodeFilter) + "&";
        if (pestAndDiseaseCodeFilter === null)
            throw new globalThis.Error("The parameter 'pestAndDiseaseCodeFilter' cannot be null.");
        else if (pestAndDiseaseCodeFilter !== undefined)
            url_ += "PestAndDiseaseCodeFilter=" + encodeURIComponent("" + pestAndDiseaseCodeFilter) + "&";
        if (typeTrialIdFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialIdFilter' cannot be null.");
        else if (typeTrialIdFilter !== undefined)
            url_ += "TypeTrialIdFilter=" + encodeURIComponent("" + typeTrialIdFilter) + "&";
        if (maxTrialAgeDataFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAgeDataFilter' cannot be null.");
        else if (maxTrialAgeDataFilter !== undefined)
            url_ += "MaxTrialAgeDataFilter=" + encodeURIComponent("" + maxTrialAgeDataFilter) + "&";
        if (minTrialAgeDataFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAgeDataFilter' cannot be null.");
        else if (minTrialAgeDataFilter !== undefined)
            url_ += "MinTrialAgeDataFilter=" + encodeURIComponent("" + minTrialAgeDataFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            trialNumbersFilter && trialNumbersFilter.forEach(item => { url_ += "TrialNumbersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreeMeasurementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreeMeasurementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreeMeasurementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreeMeasurementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeMeasurementForView(id: number | undefined): Observable<GetTreeMeasurementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetTreeMeasurementForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeMeasurementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeMeasurementForViewDto>;
        }));
    }

    protected processGetTreeMeasurementForView(response: HttpResponseBase): Observable<GetTreeMeasurementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeMeasurementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeMeasurementForEdit(id: number | undefined): Observable<GetTreeMeasurementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetTreeMeasurementForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeMeasurementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeMeasurementForEditOutput>;
        }));
    }

    protected processGetTreeMeasurementForEdit(response: HttpResponseBase): Observable<GetTreeMeasurementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeMeasurementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreeMeasurementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @param trialNumber (optional) 
     * @return OK
     */
    deleteByDate(date: DateTime | undefined, trialNumber: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/DeleteByDate?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        if (trialNumber === null)
            throw new globalThis.Error("The parameter 'trialNumber' cannot be null.");
        else if (trialNumber !== undefined)
            url_ += "trialNumber=" + encodeURIComponent("" + trialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteByDate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxMeasurementDateFilter (optional) 
     * @param minMeasurementDateFilter (optional) 
     * @param maxDAPFilter (optional) 
     * @param minDAPFilter (optional) 
     * @param maxHeightFilter (optional) 
     * @param minHeightFilter (optional) 
     * @param maxVolumeFilter (optional) 
     * @param minVolumeFilter (optional) 
     * @param maxDefectHeightFilter (optional) 
     * @param minDefectHeightFilter (optional) 
     * @param maxSobreFilter (optional) 
     * @param minSobreFilter (optional) 
     * @param observationsFilter (optional) 
     * @param fliaFilter (optional) 
     * @param treeSpecieFilter (optional) 
     * @param adultObservationCodeDetailFilter (optional) 
     * @param frostToleranceCodeFilter (optional) 
     * @param pestAndDiseaseCodeFilter (optional) 
     * @param typeTrialIdFilter (optional) 
     * @param maxTrialAgeDataFilter (optional) 
     * @param minTrialAgeDataFilter (optional) 
     * @param trialNumbersFilter (optional) 
     * @return OK
     */
    getTreeMeasurementsToExcel(filter: string | undefined, maxMeasurementDateFilter: DateTime | undefined, minMeasurementDateFilter: DateTime | undefined, maxDAPFilter: number | undefined, minDAPFilter: number | undefined, maxHeightFilter: number | undefined, minHeightFilter: number | undefined, maxVolumeFilter: number | undefined, minVolumeFilter: number | undefined, maxDefectHeightFilter: number | undefined, minDefectHeightFilter: number | undefined, maxSobreFilter: number | undefined, minSobreFilter: number | undefined, observationsFilter: string | undefined, fliaFilter: string | undefined, treeSpecieFilter: string | undefined, adultObservationCodeDetailFilter: string | undefined, frostToleranceCodeFilter: string | undefined, pestAndDiseaseCodeFilter: string | undefined, typeTrialIdFilter: number | undefined, maxTrialAgeDataFilter: number | undefined, minTrialAgeDataFilter: number | undefined, trialNumbersFilter: (number | undefined)[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetTreeMeasurementsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxMeasurementDateFilter === null)
            throw new globalThis.Error("The parameter 'maxMeasurementDateFilter' cannot be null.");
        else if (maxMeasurementDateFilter !== undefined)
            url_ += "MaxMeasurementDateFilter=" + encodeURIComponent(maxMeasurementDateFilter ? "" + maxMeasurementDateFilter.toString() : "") + "&";
        if (minMeasurementDateFilter === null)
            throw new globalThis.Error("The parameter 'minMeasurementDateFilter' cannot be null.");
        else if (minMeasurementDateFilter !== undefined)
            url_ += "MinMeasurementDateFilter=" + encodeURIComponent(minMeasurementDateFilter ? "" + minMeasurementDateFilter.toString() : "") + "&";
        if (maxDAPFilter === null)
            throw new globalThis.Error("The parameter 'maxDAPFilter' cannot be null.");
        else if (maxDAPFilter !== undefined)
            url_ += "MaxDAPFilter=" + encodeURIComponent("" + maxDAPFilter) + "&";
        if (minDAPFilter === null)
            throw new globalThis.Error("The parameter 'minDAPFilter' cannot be null.");
        else if (minDAPFilter !== undefined)
            url_ += "MinDAPFilter=" + encodeURIComponent("" + minDAPFilter) + "&";
        if (maxHeightFilter === null)
            throw new globalThis.Error("The parameter 'maxHeightFilter' cannot be null.");
        else if (maxHeightFilter !== undefined)
            url_ += "MaxHeightFilter=" + encodeURIComponent("" + maxHeightFilter) + "&";
        if (minHeightFilter === null)
            throw new globalThis.Error("The parameter 'minHeightFilter' cannot be null.");
        else if (minHeightFilter !== undefined)
            url_ += "MinHeightFilter=" + encodeURIComponent("" + minHeightFilter) + "&";
        if (maxVolumeFilter === null)
            throw new globalThis.Error("The parameter 'maxVolumeFilter' cannot be null.");
        else if (maxVolumeFilter !== undefined)
            url_ += "MaxVolumeFilter=" + encodeURIComponent("" + maxVolumeFilter) + "&";
        if (minVolumeFilter === null)
            throw new globalThis.Error("The parameter 'minVolumeFilter' cannot be null.");
        else if (minVolumeFilter !== undefined)
            url_ += "MinVolumeFilter=" + encodeURIComponent("" + minVolumeFilter) + "&";
        if (maxDefectHeightFilter === null)
            throw new globalThis.Error("The parameter 'maxDefectHeightFilter' cannot be null.");
        else if (maxDefectHeightFilter !== undefined)
            url_ += "MaxDefectHeightFilter=" + encodeURIComponent("" + maxDefectHeightFilter) + "&";
        if (minDefectHeightFilter === null)
            throw new globalThis.Error("The parameter 'minDefectHeightFilter' cannot be null.");
        else if (minDefectHeightFilter !== undefined)
            url_ += "MinDefectHeightFilter=" + encodeURIComponent("" + minDefectHeightFilter) + "&";
        if (maxSobreFilter === null)
            throw new globalThis.Error("The parameter 'maxSobreFilter' cannot be null.");
        else if (maxSobreFilter !== undefined)
            url_ += "MaxSobreFilter=" + encodeURIComponent("" + maxSobreFilter) + "&";
        if (minSobreFilter === null)
            throw new globalThis.Error("The parameter 'minSobreFilter' cannot be null.");
        else if (minSobreFilter !== undefined)
            url_ += "MinSobreFilter=" + encodeURIComponent("" + minSobreFilter) + "&";
        if (observationsFilter === null)
            throw new globalThis.Error("The parameter 'observationsFilter' cannot be null.");
        else if (observationsFilter !== undefined)
            url_ += "ObservationsFilter=" + encodeURIComponent("" + observationsFilter) + "&";
        if (fliaFilter === null)
            throw new globalThis.Error("The parameter 'fliaFilter' cannot be null.");
        else if (fliaFilter !== undefined)
            url_ += "FliaFilter=" + encodeURIComponent("" + fliaFilter) + "&";
        if (treeSpecieFilter === null)
            throw new globalThis.Error("The parameter 'treeSpecieFilter' cannot be null.");
        else if (treeSpecieFilter !== undefined)
            url_ += "TreeSpecieFilter=" + encodeURIComponent("" + treeSpecieFilter) + "&";
        if (adultObservationCodeDetailFilter === null)
            throw new globalThis.Error("The parameter 'adultObservationCodeDetailFilter' cannot be null.");
        else if (adultObservationCodeDetailFilter !== undefined)
            url_ += "AdultObservationCodeDetailFilter=" + encodeURIComponent("" + adultObservationCodeDetailFilter) + "&";
        if (frostToleranceCodeFilter === null)
            throw new globalThis.Error("The parameter 'frostToleranceCodeFilter' cannot be null.");
        else if (frostToleranceCodeFilter !== undefined)
            url_ += "FrostToleranceCodeFilter=" + encodeURIComponent("" + frostToleranceCodeFilter) + "&";
        if (pestAndDiseaseCodeFilter === null)
            throw new globalThis.Error("The parameter 'pestAndDiseaseCodeFilter' cannot be null.");
        else if (pestAndDiseaseCodeFilter !== undefined)
            url_ += "PestAndDiseaseCodeFilter=" + encodeURIComponent("" + pestAndDiseaseCodeFilter) + "&";
        if (typeTrialIdFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialIdFilter' cannot be null.");
        else if (typeTrialIdFilter !== undefined)
            url_ += "TypeTrialIdFilter=" + encodeURIComponent("" + typeTrialIdFilter) + "&";
        if (maxTrialAgeDataFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAgeDataFilter' cannot be null.");
        else if (maxTrialAgeDataFilter !== undefined)
            url_ += "MaxTrialAgeDataFilter=" + encodeURIComponent("" + maxTrialAgeDataFilter) + "&";
        if (minTrialAgeDataFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAgeDataFilter' cannot be null.");
        else if (minTrialAgeDataFilter !== undefined)
            url_ += "MinTrialAgeDataFilter=" + encodeURIComponent("" + minTrialAgeDataFilter) + "&";
        if (trialNumbersFilter === null)
            throw new globalThis.Error("The parameter 'trialNumbersFilter' cannot be null.");
        else if (trialNumbersFilter !== undefined)
            trialNumbersFilter && trialNumbersFilter.forEach(item => { url_ += "TrialNumbersFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeMeasurementsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeMeasurementsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreeMeasurementsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreeMeasurementTreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllTreeForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreeMeasurementTreeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreeMeasurementTreeLookupTableDto>;
        }));
    }

    protected processGetAllTreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreeMeasurementTreeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreeMeasurementTreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTypeTrialForTableDropdown(): Observable<TrialTypeTrialLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllTypeTrialForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeTrialForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeTrialForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrialTypeTrialLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrialTypeTrialLookupTableDto[]>;
        }));
    }

    protected processGetAllTypeTrialForTableDropdown(response: HttpResponseBase): Observable<TrialTypeTrialLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialTypeTrialLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAdultObservationCodeForTableDropdown(): Observable<TreeMeasurementAdultObservationCodeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllAdultObservationCodeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdultObservationCodeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdultObservationCodeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeMeasurementAdultObservationCodeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeMeasurementAdultObservationCodeLookupTableDto[]>;
        }));
    }

    protected processGetAllAdultObservationCodeForTableDropdown(response: HttpResponseBase): Observable<TreeMeasurementAdultObservationCodeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeMeasurementAdultObservationCodeLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllFrostToleranceCodeForTableDropdown(): Observable<TreeMeasurementFrostToleranceCodeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllFrostToleranceCodeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFrostToleranceCodeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFrostToleranceCodeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeMeasurementFrostToleranceCodeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeMeasurementFrostToleranceCodeLookupTableDto[]>;
        }));
    }

    protected processGetAllFrostToleranceCodeForTableDropdown(response: HttpResponseBase): Observable<TreeMeasurementFrostToleranceCodeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeMeasurementFrostToleranceCodeLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllPestAndDiseaseCodeForTableDropdown(): Observable<TreeMeasurementPestAndDiseaseCodeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllPestAndDiseaseCodeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPestAndDiseaseCodeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPestAndDiseaseCodeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeMeasurementPestAndDiseaseCodeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeMeasurementPestAndDiseaseCodeLookupTableDto[]>;
        }));
    }

    protected processGetAllPestAndDiseaseCodeForTableDropdown(response: HttpResponseBase): Observable<TreeMeasurementPestAndDiseaseCodeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeMeasurementPestAndDiseaseCodeLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTreeMeasurementFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/CreateTreeMeasurementFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTreeMeasurementFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTreeMeasurementFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTreeMeasurementFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTreeMeasurementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTreeMeasurementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTreeMeasurementDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTreeMeasurementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTreeMeasurementDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDistinctTrialIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeMeasurements/GetAllDistinctTrialIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistinctTrialIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistinctTrialIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllDistinctTrialIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param treeNumberFilter (optional) 
     * @param specieFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param nSFilter (optional) 
     * @param nXFilter (optional) 
     * @param maxRowFilter (optional) 
     * @param minRowFilter (optional) 
     * @param plotFilter (optional) 
     * @param maxXFilter (optional) 
     * @param minXFilter (optional) 
     * @param maxYFilter (optional) 
     * @param minYFilter (optional) 
     * @param treatmentSubBlockFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, treeNumberFilter: number | undefined, specieFilter: string | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, nSFilter: string | undefined, nXFilter: string | undefined, maxRowFilter: number | undefined, minRowFilter: number | undefined, plotFilter: string | undefined, maxXFilter: number | undefined, minXFilter: number | undefined, maxYFilter: number | undefined, minYFilter: number | undefined, treatmentSubBlockFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treeNumberFilter === null)
            throw new globalThis.Error("The parameter 'treeNumberFilter' cannot be null.");
        else if (treeNumberFilter !== undefined)
            url_ += "TreeNumberFilter=" + encodeURIComponent("" + treeNumberFilter) + "&";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "SpecieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (nSFilter === null)
            throw new globalThis.Error("The parameter 'nSFilter' cannot be null.");
        else if (nSFilter !== undefined)
            url_ += "NSFilter=" + encodeURIComponent("" + nSFilter) + "&";
        if (nXFilter === null)
            throw new globalThis.Error("The parameter 'nXFilter' cannot be null.");
        else if (nXFilter !== undefined)
            url_ += "NXFilter=" + encodeURIComponent("" + nXFilter) + "&";
        if (maxRowFilter === null)
            throw new globalThis.Error("The parameter 'maxRowFilter' cannot be null.");
        else if (maxRowFilter !== undefined)
            url_ += "MaxRowFilter=" + encodeURIComponent("" + maxRowFilter) + "&";
        if (minRowFilter === null)
            throw new globalThis.Error("The parameter 'minRowFilter' cannot be null.");
        else if (minRowFilter !== undefined)
            url_ += "MinRowFilter=" + encodeURIComponent("" + minRowFilter) + "&";
        if (plotFilter === null)
            throw new globalThis.Error("The parameter 'plotFilter' cannot be null.");
        else if (plotFilter !== undefined)
            url_ += "PlotFilter=" + encodeURIComponent("" + plotFilter) + "&";
        if (maxXFilter === null)
            throw new globalThis.Error("The parameter 'maxXFilter' cannot be null.");
        else if (maxXFilter !== undefined)
            url_ += "MaxXFilter=" + encodeURIComponent("" + maxXFilter) + "&";
        if (minXFilter === null)
            throw new globalThis.Error("The parameter 'minXFilter' cannot be null.");
        else if (minXFilter !== undefined)
            url_ += "MinXFilter=" + encodeURIComponent("" + minXFilter) + "&";
        if (maxYFilter === null)
            throw new globalThis.Error("The parameter 'maxYFilter' cannot be null.");
        else if (maxYFilter !== undefined)
            url_ += "MaxYFilter=" + encodeURIComponent("" + maxYFilter) + "&";
        if (minYFilter === null)
            throw new globalThis.Error("The parameter 'minYFilter' cannot be null.");
        else if (minYFilter !== undefined)
            url_ += "MinYFilter=" + encodeURIComponent("" + minYFilter) + "&";
        if (treatmentSubBlockFilter === null)
            throw new globalThis.Error("The parameter 'treatmentSubBlockFilter' cannot be null.");
        else if (treatmentSubBlockFilter !== undefined)
            url_ += "TreatmentSubBlockFilter=" + encodeURIComponent("" + treatmentSubBlockFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeForView(id: number | undefined): Observable<GetTreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetTreeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeForViewDto>;
        }));
    }

    protected processGetTreeForView(response: HttpResponseBase): Observable<GetTreeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeForEdit(id: number | undefined): Observable<GetTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetTreeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeForEditOutput>;
        }));
    }

    protected processGetTreeForEdit(response: HttpResponseBase): Observable<GetTreeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trees/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param treeId (optional) 
     * @return OK
     */
    validateDeletedTree(treeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trees/ValidateDeletedTree?";
        if (treeId === null)
            throw new globalThis.Error("The parameter 'treeId' cannot be null.");
        else if (treeId !== undefined)
            url_ += "treeId=" + encodeURIComponent("" + treeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDeletedTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDeletedTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDeletedTree(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param treeNumberFilter (optional) 
     * @param specieFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param nSFilter (optional) 
     * @param nXFilter (optional) 
     * @param maxRowFilter (optional) 
     * @param minRowFilter (optional) 
     * @param plotFilter (optional) 
     * @param maxXFilter (optional) 
     * @param minXFilter (optional) 
     * @param maxYFilter (optional) 
     * @param minYFilter (optional) 
     * @param treatmentSubBlockFilter (optional) 
     * @return OK
     */
    getTreesToExcel(filter: string | undefined, treeNumberFilter: number | undefined, specieFilter: string | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, nSFilter: string | undefined, nXFilter: string | undefined, maxRowFilter: number | undefined, minRowFilter: number | undefined, plotFilter: string | undefined, maxXFilter: number | undefined, minXFilter: number | undefined, maxYFilter: number | undefined, minYFilter: number | undefined, treatmentSubBlockFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetTreesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (treeNumberFilter === null)
            throw new globalThis.Error("The parameter 'treeNumberFilter' cannot be null.");
        else if (treeNumberFilter !== undefined)
            url_ += "TreeNumberFilter=" + encodeURIComponent("" + treeNumberFilter) + "&";
        if (specieFilter === null)
            throw new globalThis.Error("The parameter 'specieFilter' cannot be null.");
        else if (specieFilter !== undefined)
            url_ += "SpecieFilter=" + encodeURIComponent("" + specieFilter) + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (nSFilter === null)
            throw new globalThis.Error("The parameter 'nSFilter' cannot be null.");
        else if (nSFilter !== undefined)
            url_ += "NSFilter=" + encodeURIComponent("" + nSFilter) + "&";
        if (nXFilter === null)
            throw new globalThis.Error("The parameter 'nXFilter' cannot be null.");
        else if (nXFilter !== undefined)
            url_ += "NXFilter=" + encodeURIComponent("" + nXFilter) + "&";
        if (maxRowFilter === null)
            throw new globalThis.Error("The parameter 'maxRowFilter' cannot be null.");
        else if (maxRowFilter !== undefined)
            url_ += "MaxRowFilter=" + encodeURIComponent("" + maxRowFilter) + "&";
        if (minRowFilter === null)
            throw new globalThis.Error("The parameter 'minRowFilter' cannot be null.");
        else if (minRowFilter !== undefined)
            url_ += "MinRowFilter=" + encodeURIComponent("" + minRowFilter) + "&";
        if (plotFilter === null)
            throw new globalThis.Error("The parameter 'plotFilter' cannot be null.");
        else if (plotFilter !== undefined)
            url_ += "PlotFilter=" + encodeURIComponent("" + plotFilter) + "&";
        if (maxXFilter === null)
            throw new globalThis.Error("The parameter 'maxXFilter' cannot be null.");
        else if (maxXFilter !== undefined)
            url_ += "MaxXFilter=" + encodeURIComponent("" + maxXFilter) + "&";
        if (minXFilter === null)
            throw new globalThis.Error("The parameter 'minXFilter' cannot be null.");
        else if (minXFilter !== undefined)
            url_ += "MinXFilter=" + encodeURIComponent("" + minXFilter) + "&";
        if (maxYFilter === null)
            throw new globalThis.Error("The parameter 'maxYFilter' cannot be null.");
        else if (maxYFilter !== undefined)
            url_ += "MaxYFilter=" + encodeURIComponent("" + maxYFilter) + "&";
        if (minYFilter === null)
            throw new globalThis.Error("The parameter 'minYFilter' cannot be null.");
        else if (minYFilter !== undefined)
            url_ += "MinYFilter=" + encodeURIComponent("" + minYFilter) + "&";
        if (treatmentSubBlockFilter === null)
            throw new globalThis.Error("The parameter 'treatmentSubBlockFilter' cannot be null.");
        else if (treatmentSubBlockFilter !== undefined)
            url_ += "TreatmentSubBlockFilter=" + encodeURIComponent("" + treatmentSubBlockFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTreatmentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTreeTreatmentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetAllTreatmentForLookupTable?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreatmentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreatmentForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTreeTreatmentLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTreeTreatmentLookupTableDto>;
        }));
    }

    protected processGetAllTreatmentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTreeTreatmentLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTreeTreatmentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getIdTreeStatusEnPie(): Observable<number | null> {
        let url_ = this.baseUrl + "/api/services/app/Trees/GetIdTreeStatusEnPie";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdTreeStatusEnPie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdTreeStatusEnPie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetIdTreeStatusEnPie(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreeStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTreeStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTreeStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTreeStatusForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTreeStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTreeStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeStatusForView(id: number | undefined): Observable<GetTreeStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/GetTreeStatusForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeStatusForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeStatusForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeStatusForViewDto>;
        }));
    }

    protected processGetTreeStatusForView(response: HttpResponseBase): Observable<GetTreeStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTreeStatusForEdit(id: number | undefined): Observable<GetTreeStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/GetTreeStatusForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeStatusForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTreeStatusForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTreeStatusForEditOutput>;
        }));
    }

    protected processGetTreeStatusForEdit(response: HttpResponseBase): Observable<GetTreeStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTreeStatusForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTreeStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isStandingFilter (optional) 
     * @return OK
     */
    getTreeStatusesToExcel(filter: string | undefined, nameFilter: string | undefined, isStandingFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/GetTreeStatusesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isStandingFilter === null)
            throw new globalThis.Error("The parameter 'isStandingFilter' cannot be null.");
        else if (isStandingFilter !== undefined)
            url_ += "IsStandingFilter=" + encodeURIComponent("" + isStandingFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeStatusesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTreeStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    treeStatusFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/TreeStatusFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTreeStatusFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTreeStatusFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processTreeStatusFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTreeStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreeStatuses/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTreeStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTreeStatusDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTreeStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTreeStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrialDesignTypesesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isDividedPlotsFilter (optional) 
     * @param isAlfaLaticeAsteriskFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, isDividedPlotsFilter: number | undefined, isAlfaLaticeAsteriskFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrialDesignTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isDividedPlotsFilter === null)
            throw new globalThis.Error("The parameter 'isDividedPlotsFilter' cannot be null.");
        else if (isDividedPlotsFilter !== undefined)
            url_ += "IsDividedPlotsFilter=" + encodeURIComponent("" + isDividedPlotsFilter) + "&";
        if (isAlfaLaticeAsteriskFilter === null)
            throw new globalThis.Error("The parameter 'isAlfaLaticeAsteriskFilter' cannot be null.");
        else if (isAlfaLaticeAsteriskFilter !== undefined)
            url_ += "IsAlfaLaticeAsteriskFilter=" + encodeURIComponent("" + isAlfaLaticeAsteriskFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrialDesignTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrialDesignTypesForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrialDesignTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrialDesignTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isDividedPlotsFilter (optional) 
     * @param isAlfaLaticeAsteriskFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, isDividedPlotsFilter: number | undefined, isAlfaLaticeAsteriskFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isDividedPlotsFilter === null)
            throw new globalThis.Error("The parameter 'isDividedPlotsFilter' cannot be null.");
        else if (isDividedPlotsFilter !== undefined)
            url_ += "IsDividedPlotsFilter=" + encodeURIComponent("" + isDividedPlotsFilter) + "&";
        if (isAlfaLaticeAsteriskFilter === null)
            throw new globalThis.Error("The parameter 'isAlfaLaticeAsteriskFilter' cannot be null.");
        else if (isAlfaLaticeAsteriskFilter !== undefined)
            url_ += "IsAlfaLaticeAsteriskFilter=" + encodeURIComponent("" + isAlfaLaticeAsteriskFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialDesignTypesForView(id: number | undefined): Observable<GetTrialDesignTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/GetTrialDesignTypesForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialDesignTypesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialDesignTypesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialDesignTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialDesignTypesForViewDto>;
        }));
    }

    protected processGetTrialDesignTypesForView(response: HttpResponseBase): Observable<GetTrialDesignTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialDesignTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialDesignTypesForEdit(id: number | undefined): Observable<GetTrialDesignTypesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/GetTrialDesignTypesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialDesignTypesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialDesignTypesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialDesignTypesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialDesignTypesForEditOutput>;
        }));
    }

    protected processGetTrialDesignTypesForEdit(response: HttpResponseBase): Observable<GetTrialDesignTypesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialDesignTypesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTrialDesignTypesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isDividedPlotsFilter (optional) 
     * @param isAlfaLaticeAsteriskFilter (optional) 
     * @return OK
     */
    getTrialDesignTypesesToExcel(filter: string | undefined, nameFilter: string | undefined, isDividedPlotsFilter: number | undefined, isAlfaLaticeAsteriskFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/GetTrialDesignTypesesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isDividedPlotsFilter === null)
            throw new globalThis.Error("The parameter 'isDividedPlotsFilter' cannot be null.");
        else if (isDividedPlotsFilter !== undefined)
            url_ += "IsDividedPlotsFilter=" + encodeURIComponent("" + isDividedPlotsFilter) + "&";
        if (isAlfaLaticeAsteriskFilter === null)
            throw new globalThis.Error("The parameter 'isAlfaLaticeAsteriskFilter' cannot be null.");
        else if (isAlfaLaticeAsteriskFilter !== undefined)
            url_ += "IsAlfaLaticeAsteriskFilter=" + encodeURIComponent("" + isAlfaLaticeAsteriskFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialDesignTypesesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialDesignTypesesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTrialDesignTypesesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTrialDesignTypesFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/CreateTrialDesignTypesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrialDesignTypesFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrialDesignTypesFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTrialDesignTypesFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTrialDesignTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrialDesignTypeses/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTrialDesignTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTrialDesignTypesDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTrialDesignTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTrialDesignTypesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrialRDsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxTrialNumberFilter (optional) 
     * @param minTrialNumberFilter (optional) 
     * @param maxTrialAreaFilter (optional) 
     * @param minTrialAreaFilter (optional) 
     * @param experimentTypeFilter (optional) 
     * @param trialTypeFilter (optional) 
     * @param regionFilter (optional) 
     * @param zoneFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxTrialNumberFilter: number | undefined, minTrialNumberFilter: number | undefined, maxTrialAreaFilter: number | undefined, minTrialAreaFilter: number | undefined, experimentTypeFilter: string | undefined, trialTypeFilter: string | undefined, regionFilter: string | undefined, zoneFilter: string | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrialRDForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialRDs/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialNumberFilter' cannot be null.");
        else if (maxTrialNumberFilter !== undefined)
            url_ += "MaxTrialNumberFilter=" + encodeURIComponent("" + maxTrialNumberFilter) + "&";
        if (minTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTrialNumberFilter' cannot be null.");
        else if (minTrialNumberFilter !== undefined)
            url_ += "MinTrialNumberFilter=" + encodeURIComponent("" + minTrialNumberFilter) + "&";
        if (maxTrialAreaFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAreaFilter' cannot be null.");
        else if (maxTrialAreaFilter !== undefined)
            url_ += "MaxTrialAreaFilter=" + encodeURIComponent("" + maxTrialAreaFilter) + "&";
        if (minTrialAreaFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAreaFilter' cannot be null.");
        else if (minTrialAreaFilter !== undefined)
            url_ += "MinTrialAreaFilter=" + encodeURIComponent("" + minTrialAreaFilter) + "&";
        if (experimentTypeFilter === null)
            throw new globalThis.Error("The parameter 'experimentTypeFilter' cannot be null.");
        else if (experimentTypeFilter !== undefined)
            url_ += "ExperimentTypeFilter=" + encodeURIComponent("" + experimentTypeFilter) + "&";
        if (trialTypeFilter === null)
            throw new globalThis.Error("The parameter 'trialTypeFilter' cannot be null.");
        else if (trialTypeFilter !== undefined)
            url_ += "TrialTypeFilter=" + encodeURIComponent("" + trialTypeFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            url_ += "ZoneFilter=" + encodeURIComponent("" + zoneFilter) + "&";
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrialRDForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrialRDForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrialRDForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrialRDForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxTrialNumberFilter (optional) 
     * @param minTrialNumberFilter (optional) 
     * @param maxTrialAreaFilter (optional) 
     * @param minTrialAreaFilter (optional) 
     * @param experimentTypeFilter (optional) 
     * @param trialTypeFilter (optional) 
     * @param regionFilter (optional) 
     * @param zoneFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @return OK
     */
    getTrialRDsToExcel(filter: string | undefined, maxTrialNumberFilter: number | undefined, minTrialNumberFilter: number | undefined, maxTrialAreaFilter: number | undefined, minTrialAreaFilter: number | undefined, experimentTypeFilter: string | undefined, trialTypeFilter: string | undefined, regionFilter: string | undefined, zoneFilter: string | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialRDs/GetTrialRDsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialNumberFilter' cannot be null.");
        else if (maxTrialNumberFilter !== undefined)
            url_ += "MaxTrialNumberFilter=" + encodeURIComponent("" + maxTrialNumberFilter) + "&";
        if (minTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTrialNumberFilter' cannot be null.");
        else if (minTrialNumberFilter !== undefined)
            url_ += "MinTrialNumberFilter=" + encodeURIComponent("" + minTrialNumberFilter) + "&";
        if (maxTrialAreaFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialAreaFilter' cannot be null.");
        else if (maxTrialAreaFilter !== undefined)
            url_ += "MaxTrialAreaFilter=" + encodeURIComponent("" + maxTrialAreaFilter) + "&";
        if (minTrialAreaFilter === null)
            throw new globalThis.Error("The parameter 'minTrialAreaFilter' cannot be null.");
        else if (minTrialAreaFilter !== undefined)
            url_ += "MinTrialAreaFilter=" + encodeURIComponent("" + minTrialAreaFilter) + "&";
        if (experimentTypeFilter === null)
            throw new globalThis.Error("The parameter 'experimentTypeFilter' cannot be null.");
        else if (experimentTypeFilter !== undefined)
            url_ += "ExperimentTypeFilter=" + encodeURIComponent("" + experimentTypeFilter) + "&";
        if (trialTypeFilter === null)
            throw new globalThis.Error("The parameter 'trialTypeFilter' cannot be null.");
        else if (trialTypeFilter !== undefined)
            url_ += "TrialTypeFilter=" + encodeURIComponent("" + trialTypeFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            url_ += "ZoneFilter=" + encodeURIComponent("" + zoneFilter) + "&";
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialRDsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialRDsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTrialRDsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxTrialNumberFilter (optional) 
     * @param minTrialNumberFilter (optional) 
     * @param regionFilter (optional) 
     * @param oldTrialDenominationFilter (optional) 
     * @param districtFilter (optional) 
     * @param zoneFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param maxAreaFilter (optional) 
     * @param minAreaFilter (optional) 
     * @param maxTreatmentsFilter (optional) 
     * @param minTreatmentsFilter (optional) 
     * @param maxTotalTreesFilter (optional) 
     * @param minTotalTreesFilter (optional) 
     * @param observationFilter (optional) 
     * @param maxDistanceBetweenPlantsFilter (optional) 
     * @param minDistanceBetweenPlantsFilter (optional) 
     * @param maxDistanceBetweenRowsFilter (optional) 
     * @param minDistanceBetweenRowsFilter (optional) 
     * @param maxDataFilter (optional) 
     * @param minDataFilter (optional) 
     * @param aPSServiceOrderFilter (optional) 
     * @param planningStatusFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param standNameFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param oldStandNameFilter (optional) 
     * @param coneatFilter (optional) 
     * @param typeTrialNameFilter (optional) 
     * @param trialDesignTypesNameFilter (optional) 
     * @param trialStatusNameFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param isGenomicSelection (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxTrialNumberFilter: number | undefined, minTrialNumberFilter: number | undefined, regionFilter: string[] | undefined, oldTrialDenominationFilter: string[] | undefined, districtFilter: string[] | undefined, zoneFilter: string[] | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, maxAreaFilter: number | undefined, minAreaFilter: number | undefined, maxTreatmentsFilter: number | undefined, minTreatmentsFilter: number | undefined, maxTotalTreesFilter: number | undefined, minTotalTreesFilter: number | undefined, observationFilter: string | undefined, maxDistanceBetweenPlantsFilter: number | undefined, minDistanceBetweenPlantsFilter: number | undefined, maxDistanceBetweenRowsFilter: number | undefined, minDistanceBetweenRowsFilter: number | undefined, maxDataFilter: number | undefined, minDataFilter: number | undefined, aPSServiceOrderFilter: number | undefined, planningStatusFilter: string[] | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, standNameFilter: string[] | undefined, farmNameFilter: string[] | undefined, oldStandNameFilter: string[] | undefined, coneatFilter: string[] | undefined, typeTrialNameFilter: string[] | undefined, trialDesignTypesNameFilter: string[] | undefined, trialStatusNameFilter: string[] | undefined, trialNumberFilter: string[] | undefined, isGenomicSelection: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialNumberFilter' cannot be null.");
        else if (maxTrialNumberFilter !== undefined)
            url_ += "MaxTrialNumberFilter=" + encodeURIComponent("" + maxTrialNumberFilter) + "&";
        if (minTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTrialNumberFilter' cannot be null.");
        else if (minTrialNumberFilter !== undefined)
            url_ += "MinTrialNumberFilter=" + encodeURIComponent("" + minTrialNumberFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            regionFilter && regionFilter.forEach(item => { url_ += "RegionFilter=" + encodeURIComponent("" + item) + "&"; });
        if (oldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'oldTrialDenominationFilter' cannot be null.");
        else if (oldTrialDenominationFilter !== undefined)
            oldTrialDenominationFilter && oldTrialDenominationFilter.forEach(item => { url_ += "OldTrialDenominationFilter=" + encodeURIComponent("" + item) + "&"; });
        if (districtFilter === null)
            throw new globalThis.Error("The parameter 'districtFilter' cannot be null.");
        else if (districtFilter !== undefined)
            districtFilter && districtFilter.forEach(item => { url_ += "DistrictFilter=" + encodeURIComponent("" + item) + "&"; });
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            zoneFilter && zoneFilter.forEach(item => { url_ += "ZoneFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (maxAreaFilter === null)
            throw new globalThis.Error("The parameter 'maxAreaFilter' cannot be null.");
        else if (maxAreaFilter !== undefined)
            url_ += "MaxAreaFilter=" + encodeURIComponent("" + maxAreaFilter) + "&";
        if (minAreaFilter === null)
            throw new globalThis.Error("The parameter 'minAreaFilter' cannot be null.");
        else if (minAreaFilter !== undefined)
            url_ += "MinAreaFilter=" + encodeURIComponent("" + minAreaFilter) + "&";
        if (maxTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'maxTreatmentsFilter' cannot be null.");
        else if (maxTreatmentsFilter !== undefined)
            url_ += "MaxTreatmentsFilter=" + encodeURIComponent("" + maxTreatmentsFilter) + "&";
        if (minTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'minTreatmentsFilter' cannot be null.");
        else if (minTreatmentsFilter !== undefined)
            url_ += "MinTreatmentsFilter=" + encodeURIComponent("" + minTreatmentsFilter) + "&";
        if (maxTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'maxTotalTreesFilter' cannot be null.");
        else if (maxTotalTreesFilter !== undefined)
            url_ += "MaxTotalTreesFilter=" + encodeURIComponent("" + maxTotalTreesFilter) + "&";
        if (minTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'minTotalTreesFilter' cannot be null.");
        else if (minTotalTreesFilter !== undefined)
            url_ += "MinTotalTreesFilter=" + encodeURIComponent("" + minTotalTreesFilter) + "&";
        if (observationFilter === null)
            throw new globalThis.Error("The parameter 'observationFilter' cannot be null.");
        else if (observationFilter !== undefined)
            url_ += "ObservationFilter=" + encodeURIComponent("" + observationFilter) + "&";
        if (maxDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenPlantsFilter' cannot be null.");
        else if (maxDistanceBetweenPlantsFilter !== undefined)
            url_ += "MaxDistanceBetweenPlantsFilter=" + encodeURIComponent("" + maxDistanceBetweenPlantsFilter) + "&";
        if (minDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenPlantsFilter' cannot be null.");
        else if (minDistanceBetweenPlantsFilter !== undefined)
            url_ += "MinDistanceBetweenPlantsFilter=" + encodeURIComponent("" + minDistanceBetweenPlantsFilter) + "&";
        if (maxDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenRowsFilter' cannot be null.");
        else if (maxDistanceBetweenRowsFilter !== undefined)
            url_ += "MaxDistanceBetweenRowsFilter=" + encodeURIComponent("" + maxDistanceBetweenRowsFilter) + "&";
        if (minDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenRowsFilter' cannot be null.");
        else if (minDistanceBetweenRowsFilter !== undefined)
            url_ += "MinDistanceBetweenRowsFilter=" + encodeURIComponent("" + minDistanceBetweenRowsFilter) + "&";
        if (maxDataFilter === null)
            throw new globalThis.Error("The parameter 'maxDataFilter' cannot be null.");
        else if (maxDataFilter !== undefined)
            url_ += "MaxDataFilter=" + encodeURIComponent("" + maxDataFilter) + "&";
        if (minDataFilter === null)
            throw new globalThis.Error("The parameter 'minDataFilter' cannot be null.");
        else if (minDataFilter !== undefined)
            url_ += "MinDataFilter=" + encodeURIComponent("" + minDataFilter) + "&";
        if (aPSServiceOrderFilter === null)
            throw new globalThis.Error("The parameter 'aPSServiceOrderFilter' cannot be null.");
        else if (aPSServiceOrderFilter !== undefined)
            url_ += "APSServiceOrderFilter=" + encodeURIComponent("" + aPSServiceOrderFilter) + "&";
        if (planningStatusFilter === null)
            throw new globalThis.Error("The parameter 'planningStatusFilter' cannot be null.");
        else if (planningStatusFilter !== undefined)
            planningStatusFilter && planningStatusFilter.forEach(item => { url_ += "PlanningStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            standNameFilter && standNameFilter.forEach(item => { url_ += "StandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            farmNameFilter && farmNameFilter.forEach(item => { url_ += "FarmNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (oldStandNameFilter === null)
            throw new globalThis.Error("The parameter 'oldStandNameFilter' cannot be null.");
        else if (oldStandNameFilter !== undefined)
            oldStandNameFilter && oldStandNameFilter.forEach(item => { url_ += "OldStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            coneatFilter && coneatFilter.forEach(item => { url_ += "ConeatFilter=" + encodeURIComponent("" + item) + "&"; });
        if (typeTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialNameFilter' cannot be null.");
        else if (typeTrialNameFilter !== undefined)
            typeTrialNameFilter && typeTrialNameFilter.forEach(item => { url_ += "TypeTrialNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialDesignTypesNameFilter === null)
            throw new globalThis.Error("The parameter 'trialDesignTypesNameFilter' cannot be null.");
        else if (trialDesignTypesNameFilter !== undefined)
            trialDesignTypesNameFilter && trialDesignTypesNameFilter.forEach(item => { url_ += "TrialDesignTypesNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStatusNameFilter' cannot be null.");
        else if (trialStatusNameFilter !== undefined)
            trialStatusNameFilter && trialStatusNameFilter.forEach(item => { url_ += "TrialStatusNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            trialNumberFilter && trialNumberFilter.forEach(item => { url_ += "TrialNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (isGenomicSelection === null)
            throw new globalThis.Error("The parameter 'isGenomicSelection' cannot be null.");
        else if (isGenomicSelection !== undefined)
            url_ += "IsGenomicSelection=" + encodeURIComponent("" + isGenomicSelection) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxTrialNumberFilter (optional) 
     * @param minTrialNumberFilter (optional) 
     * @param regionFilter (optional) 
     * @param oldTrialDenominationFilter (optional) 
     * @param districtFilter (optional) 
     * @param zoneFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param maxAreaFilter (optional) 
     * @param minAreaFilter (optional) 
     * @param maxTreatmentsFilter (optional) 
     * @param minTreatmentsFilter (optional) 
     * @param maxTotalTreesFilter (optional) 
     * @param minTotalTreesFilter (optional) 
     * @param observationFilter (optional) 
     * @param maxDistanceBetweenPlantsFilter (optional) 
     * @param minDistanceBetweenPlantsFilter (optional) 
     * @param maxDistanceBetweenRowsFilter (optional) 
     * @param minDistanceBetweenRowsFilter (optional) 
     * @param maxDataFilter (optional) 
     * @param minDataFilter (optional) 
     * @param aPSServiceOrderFilter (optional) 
     * @param planningStatusFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param standNameFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param oldStandNameFilter (optional) 
     * @param coneatFilter (optional) 
     * @param typeTrialNameFilter (optional) 
     * @param trialDesignTypesNameFilter (optional) 
     * @param trialStatusNameFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @param isGenomicSelection (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, maxTrialNumberFilter: number | undefined, minTrialNumberFilter: number | undefined, regionFilter: string[] | undefined, oldTrialDenominationFilter: string[] | undefined, districtFilter: string[] | undefined, zoneFilter: string[] | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, maxAreaFilter: number | undefined, minAreaFilter: number | undefined, maxTreatmentsFilter: number | undefined, minTreatmentsFilter: number | undefined, maxTotalTreesFilter: number | undefined, minTotalTreesFilter: number | undefined, observationFilter: string | undefined, maxDistanceBetweenPlantsFilter: number | undefined, minDistanceBetweenPlantsFilter: number | undefined, maxDistanceBetweenRowsFilter: number | undefined, minDistanceBetweenRowsFilter: number | undefined, maxDataFilter: number | undefined, minDataFilter: number | undefined, aPSServiceOrderFilter: number | undefined, planningStatusFilter: string[] | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, standNameFilter: string[] | undefined, farmNameFilter: string[] | undefined, oldStandNameFilter: string[] | undefined, coneatFilter: string[] | undefined, typeTrialNameFilter: string[] | undefined, trialDesignTypesNameFilter: string[] | undefined, trialStatusNameFilter: string[] | undefined, trialNumberFilter: string[] | undefined, isGenomicSelection: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialNumberFilter' cannot be null.");
        else if (maxTrialNumberFilter !== undefined)
            url_ += "MaxTrialNumberFilter=" + encodeURIComponent("" + maxTrialNumberFilter) + "&";
        if (minTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTrialNumberFilter' cannot be null.");
        else if (minTrialNumberFilter !== undefined)
            url_ += "MinTrialNumberFilter=" + encodeURIComponent("" + minTrialNumberFilter) + "&";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            regionFilter && regionFilter.forEach(item => { url_ += "RegionFilter=" + encodeURIComponent("" + item) + "&"; });
        if (oldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'oldTrialDenominationFilter' cannot be null.");
        else if (oldTrialDenominationFilter !== undefined)
            oldTrialDenominationFilter && oldTrialDenominationFilter.forEach(item => { url_ += "OldTrialDenominationFilter=" + encodeURIComponent("" + item) + "&"; });
        if (districtFilter === null)
            throw new globalThis.Error("The parameter 'districtFilter' cannot be null.");
        else if (districtFilter !== undefined)
            districtFilter && districtFilter.forEach(item => { url_ += "DistrictFilter=" + encodeURIComponent("" + item) + "&"; });
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            zoneFilter && zoneFilter.forEach(item => { url_ += "ZoneFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (maxAreaFilter === null)
            throw new globalThis.Error("The parameter 'maxAreaFilter' cannot be null.");
        else if (maxAreaFilter !== undefined)
            url_ += "MaxAreaFilter=" + encodeURIComponent("" + maxAreaFilter) + "&";
        if (minAreaFilter === null)
            throw new globalThis.Error("The parameter 'minAreaFilter' cannot be null.");
        else if (minAreaFilter !== undefined)
            url_ += "MinAreaFilter=" + encodeURIComponent("" + minAreaFilter) + "&";
        if (maxTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'maxTreatmentsFilter' cannot be null.");
        else if (maxTreatmentsFilter !== undefined)
            url_ += "MaxTreatmentsFilter=" + encodeURIComponent("" + maxTreatmentsFilter) + "&";
        if (minTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'minTreatmentsFilter' cannot be null.");
        else if (minTreatmentsFilter !== undefined)
            url_ += "MinTreatmentsFilter=" + encodeURIComponent("" + minTreatmentsFilter) + "&";
        if (maxTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'maxTotalTreesFilter' cannot be null.");
        else if (maxTotalTreesFilter !== undefined)
            url_ += "MaxTotalTreesFilter=" + encodeURIComponent("" + maxTotalTreesFilter) + "&";
        if (minTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'minTotalTreesFilter' cannot be null.");
        else if (minTotalTreesFilter !== undefined)
            url_ += "MinTotalTreesFilter=" + encodeURIComponent("" + minTotalTreesFilter) + "&";
        if (observationFilter === null)
            throw new globalThis.Error("The parameter 'observationFilter' cannot be null.");
        else if (observationFilter !== undefined)
            url_ += "ObservationFilter=" + encodeURIComponent("" + observationFilter) + "&";
        if (maxDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenPlantsFilter' cannot be null.");
        else if (maxDistanceBetweenPlantsFilter !== undefined)
            url_ += "MaxDistanceBetweenPlantsFilter=" + encodeURIComponent("" + maxDistanceBetweenPlantsFilter) + "&";
        if (minDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenPlantsFilter' cannot be null.");
        else if (minDistanceBetweenPlantsFilter !== undefined)
            url_ += "MinDistanceBetweenPlantsFilter=" + encodeURIComponent("" + minDistanceBetweenPlantsFilter) + "&";
        if (maxDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenRowsFilter' cannot be null.");
        else if (maxDistanceBetweenRowsFilter !== undefined)
            url_ += "MaxDistanceBetweenRowsFilter=" + encodeURIComponent("" + maxDistanceBetweenRowsFilter) + "&";
        if (minDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenRowsFilter' cannot be null.");
        else if (minDistanceBetweenRowsFilter !== undefined)
            url_ += "MinDistanceBetweenRowsFilter=" + encodeURIComponent("" + minDistanceBetweenRowsFilter) + "&";
        if (maxDataFilter === null)
            throw new globalThis.Error("The parameter 'maxDataFilter' cannot be null.");
        else if (maxDataFilter !== undefined)
            url_ += "MaxDataFilter=" + encodeURIComponent("" + maxDataFilter) + "&";
        if (minDataFilter === null)
            throw new globalThis.Error("The parameter 'minDataFilter' cannot be null.");
        else if (minDataFilter !== undefined)
            url_ += "MinDataFilter=" + encodeURIComponent("" + minDataFilter) + "&";
        if (aPSServiceOrderFilter === null)
            throw new globalThis.Error("The parameter 'aPSServiceOrderFilter' cannot be null.");
        else if (aPSServiceOrderFilter !== undefined)
            url_ += "APSServiceOrderFilter=" + encodeURIComponent("" + aPSServiceOrderFilter) + "&";
        if (planningStatusFilter === null)
            throw new globalThis.Error("The parameter 'planningStatusFilter' cannot be null.");
        else if (planningStatusFilter !== undefined)
            planningStatusFilter && planningStatusFilter.forEach(item => { url_ += "PlanningStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            standNameFilter && standNameFilter.forEach(item => { url_ += "StandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            farmNameFilter && farmNameFilter.forEach(item => { url_ += "FarmNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (oldStandNameFilter === null)
            throw new globalThis.Error("The parameter 'oldStandNameFilter' cannot be null.");
        else if (oldStandNameFilter !== undefined)
            oldStandNameFilter && oldStandNameFilter.forEach(item => { url_ += "OldStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            coneatFilter && coneatFilter.forEach(item => { url_ += "ConeatFilter=" + encodeURIComponent("" + item) + "&"; });
        if (typeTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialNameFilter' cannot be null.");
        else if (typeTrialNameFilter !== undefined)
            typeTrialNameFilter && typeTrialNameFilter.forEach(item => { url_ += "TypeTrialNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialDesignTypesNameFilter === null)
            throw new globalThis.Error("The parameter 'trialDesignTypesNameFilter' cannot be null.");
        else if (trialDesignTypesNameFilter !== undefined)
            trialDesignTypesNameFilter && trialDesignTypesNameFilter.forEach(item => { url_ += "TrialDesignTypesNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStatusNameFilter' cannot be null.");
        else if (trialStatusNameFilter !== undefined)
            trialStatusNameFilter && trialStatusNameFilter.forEach(item => { url_ += "TrialStatusNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            trialNumberFilter && trialNumberFilter.forEach(item => { url_ += "TrialNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        if (isGenomicSelection === null)
            throw new globalThis.Error("The parameter 'isGenomicSelection' cannot be null.");
        else if (isGenomicSelection !== undefined)
            url_ += "IsGenomicSelection=" + encodeURIComponent("" + isGenomicSelection) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrialForViewDto>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialForView(id: number | undefined): Observable<GetTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetTrialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialForViewDto>;
        }));
    }

    protected processGetTrialForView(response: HttpResponseBase): Observable<GetTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialForEdit(id: number | undefined): Observable<GetTrialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetTrialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialForEditOutput>;
        }));
    }

    protected processGetTrialForEdit(response: HttpResponseBase): Observable<GetTrialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTrialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxTrialNumberFilter (optional) 
     * @param minTrialNumberFilter (optional) 
     * @param oldTrialDenominationFilter (optional) 
     * @param districtFilter (optional) 
     * @param zoneFilter (optional) 
     * @param maxPlantationDateFilter (optional) 
     * @param minPlantationDateFilter (optional) 
     * @param maxAreaFilter (optional) 
     * @param minAreaFilter (optional) 
     * @param maxTreatmentsFilter (optional) 
     * @param minTreatmentsFilter (optional) 
     * @param maxTotalTreesFilter (optional) 
     * @param minTotalTreesFilter (optional) 
     * @param observationFilter (optional) 
     * @param maxDistanceBetweenPlantsFilter (optional) 
     * @param minDistanceBetweenPlantsFilter (optional) 
     * @param maxDistanceBetweenRowsFilter (optional) 
     * @param minDistanceBetweenRowsFilter (optional) 
     * @param maxDataFilter (optional) 
     * @param minDataFilter (optional) 
     * @param aPSServiceOrderFilter (optional) 
     * @param planningStatusFilter (optional) 
     * @param regionFilter (optional) 
     * @param maxInstalationDateFilter (optional) 
     * @param minInstalationDateFilter (optional) 
     * @param standNameFilter (optional) 
     * @param farmNameFilter (optional) 
     * @param oldStandNameFilter (optional) 
     * @param coneatFilter (optional) 
     * @param typeTrialNameFilter (optional) 
     * @param trialDesignTypesNameFilter (optional) 
     * @param trialStatusNameFilter (optional) 
     * @param trialNumberFilter (optional) 
     * @return OK
     */
    getTrialsToExcel(filter: string | undefined, maxTrialNumberFilter: number | undefined, minTrialNumberFilter: number | undefined, oldTrialDenominationFilter: string[] | undefined, districtFilter: string[] | undefined, zoneFilter: string[] | undefined, maxPlantationDateFilter: DateTime | undefined, minPlantationDateFilter: DateTime | undefined, maxAreaFilter: number | undefined, minAreaFilter: number | undefined, maxTreatmentsFilter: number | undefined, minTreatmentsFilter: number | undefined, maxTotalTreesFilter: number | undefined, minTotalTreesFilter: number | undefined, observationFilter: string | undefined, maxDistanceBetweenPlantsFilter: number | undefined, minDistanceBetweenPlantsFilter: number | undefined, maxDistanceBetweenRowsFilter: number | undefined, minDistanceBetweenRowsFilter: number | undefined, maxDataFilter: number | undefined, minDataFilter: number | undefined, aPSServiceOrderFilter: number | undefined, planningStatusFilter: string[] | undefined, regionFilter: string[] | undefined, maxInstalationDateFilter: DateTime | undefined, minInstalationDateFilter: DateTime | undefined, standNameFilter: string[] | undefined, farmNameFilter: string[] | undefined, oldStandNameFilter: string[] | undefined, coneatFilter: string[] | undefined, typeTrialNameFilter: string[] | undefined, trialDesignTypesNameFilter: string[] | undefined, trialStatusNameFilter: string[] | undefined, trialNumberFilter: string[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetTrialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'maxTrialNumberFilter' cannot be null.");
        else if (maxTrialNumberFilter !== undefined)
            url_ += "MaxTrialNumberFilter=" + encodeURIComponent("" + maxTrialNumberFilter) + "&";
        if (minTrialNumberFilter === null)
            throw new globalThis.Error("The parameter 'minTrialNumberFilter' cannot be null.");
        else if (minTrialNumberFilter !== undefined)
            url_ += "MinTrialNumberFilter=" + encodeURIComponent("" + minTrialNumberFilter) + "&";
        if (oldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'oldTrialDenominationFilter' cannot be null.");
        else if (oldTrialDenominationFilter !== undefined)
            oldTrialDenominationFilter && oldTrialDenominationFilter.forEach(item => { url_ += "OldTrialDenominationFilter=" + encodeURIComponent("" + item) + "&"; });
        if (districtFilter === null)
            throw new globalThis.Error("The parameter 'districtFilter' cannot be null.");
        else if (districtFilter !== undefined)
            districtFilter && districtFilter.forEach(item => { url_ += "DistrictFilter=" + encodeURIComponent("" + item) + "&"; });
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            zoneFilter && zoneFilter.forEach(item => { url_ += "ZoneFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxPlantationDateFilter' cannot be null.");
        else if (maxPlantationDateFilter !== undefined)
            url_ += "MaxPlantationDateFilter=" + encodeURIComponent(maxPlantationDateFilter ? "" + maxPlantationDateFilter.toString() : "") + "&";
        if (minPlantationDateFilter === null)
            throw new globalThis.Error("The parameter 'minPlantationDateFilter' cannot be null.");
        else if (minPlantationDateFilter !== undefined)
            url_ += "MinPlantationDateFilter=" + encodeURIComponent(minPlantationDateFilter ? "" + minPlantationDateFilter.toString() : "") + "&";
        if (maxAreaFilter === null)
            throw new globalThis.Error("The parameter 'maxAreaFilter' cannot be null.");
        else if (maxAreaFilter !== undefined)
            url_ += "MaxAreaFilter=" + encodeURIComponent("" + maxAreaFilter) + "&";
        if (minAreaFilter === null)
            throw new globalThis.Error("The parameter 'minAreaFilter' cannot be null.");
        else if (minAreaFilter !== undefined)
            url_ += "MinAreaFilter=" + encodeURIComponent("" + minAreaFilter) + "&";
        if (maxTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'maxTreatmentsFilter' cannot be null.");
        else if (maxTreatmentsFilter !== undefined)
            url_ += "MaxTreatmentsFilter=" + encodeURIComponent("" + maxTreatmentsFilter) + "&";
        if (minTreatmentsFilter === null)
            throw new globalThis.Error("The parameter 'minTreatmentsFilter' cannot be null.");
        else if (minTreatmentsFilter !== undefined)
            url_ += "MinTreatmentsFilter=" + encodeURIComponent("" + minTreatmentsFilter) + "&";
        if (maxTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'maxTotalTreesFilter' cannot be null.");
        else if (maxTotalTreesFilter !== undefined)
            url_ += "MaxTotalTreesFilter=" + encodeURIComponent("" + maxTotalTreesFilter) + "&";
        if (minTotalTreesFilter === null)
            throw new globalThis.Error("The parameter 'minTotalTreesFilter' cannot be null.");
        else if (minTotalTreesFilter !== undefined)
            url_ += "MinTotalTreesFilter=" + encodeURIComponent("" + minTotalTreesFilter) + "&";
        if (observationFilter === null)
            throw new globalThis.Error("The parameter 'observationFilter' cannot be null.");
        else if (observationFilter !== undefined)
            url_ += "ObservationFilter=" + encodeURIComponent("" + observationFilter) + "&";
        if (maxDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenPlantsFilter' cannot be null.");
        else if (maxDistanceBetweenPlantsFilter !== undefined)
            url_ += "MaxDistanceBetweenPlantsFilter=" + encodeURIComponent("" + maxDistanceBetweenPlantsFilter) + "&";
        if (minDistanceBetweenPlantsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenPlantsFilter' cannot be null.");
        else if (minDistanceBetweenPlantsFilter !== undefined)
            url_ += "MinDistanceBetweenPlantsFilter=" + encodeURIComponent("" + minDistanceBetweenPlantsFilter) + "&";
        if (maxDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'maxDistanceBetweenRowsFilter' cannot be null.");
        else if (maxDistanceBetweenRowsFilter !== undefined)
            url_ += "MaxDistanceBetweenRowsFilter=" + encodeURIComponent("" + maxDistanceBetweenRowsFilter) + "&";
        if (minDistanceBetweenRowsFilter === null)
            throw new globalThis.Error("The parameter 'minDistanceBetweenRowsFilter' cannot be null.");
        else if (minDistanceBetweenRowsFilter !== undefined)
            url_ += "MinDistanceBetweenRowsFilter=" + encodeURIComponent("" + minDistanceBetweenRowsFilter) + "&";
        if (maxDataFilter === null)
            throw new globalThis.Error("The parameter 'maxDataFilter' cannot be null.");
        else if (maxDataFilter !== undefined)
            url_ += "MaxDataFilter=" + encodeURIComponent("" + maxDataFilter) + "&";
        if (minDataFilter === null)
            throw new globalThis.Error("The parameter 'minDataFilter' cannot be null.");
        else if (minDataFilter !== undefined)
            url_ += "MinDataFilter=" + encodeURIComponent("" + minDataFilter) + "&";
        if (aPSServiceOrderFilter === null)
            throw new globalThis.Error("The parameter 'aPSServiceOrderFilter' cannot be null.");
        else if (aPSServiceOrderFilter !== undefined)
            url_ += "APSServiceOrderFilter=" + encodeURIComponent("" + aPSServiceOrderFilter) + "&";
        if (planningStatusFilter === null)
            throw new globalThis.Error("The parameter 'planningStatusFilter' cannot be null.");
        else if (planningStatusFilter !== undefined)
            planningStatusFilter && planningStatusFilter.forEach(item => { url_ += "PlanningStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            regionFilter && regionFilter.forEach(item => { url_ += "RegionFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'maxInstalationDateFilter' cannot be null.");
        else if (maxInstalationDateFilter !== undefined)
            url_ += "MaxInstalationDateFilter=" + encodeURIComponent(maxInstalationDateFilter ? "" + maxInstalationDateFilter.toString() : "") + "&";
        if (minInstalationDateFilter === null)
            throw new globalThis.Error("The parameter 'minInstalationDateFilter' cannot be null.");
        else if (minInstalationDateFilter !== undefined)
            url_ += "MinInstalationDateFilter=" + encodeURIComponent(minInstalationDateFilter ? "" + minInstalationDateFilter.toString() : "") + "&";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            standNameFilter && standNameFilter.forEach(item => { url_ += "StandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            farmNameFilter && farmNameFilter.forEach(item => { url_ += "FarmNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (oldStandNameFilter === null)
            throw new globalThis.Error("The parameter 'oldStandNameFilter' cannot be null.");
        else if (oldStandNameFilter !== undefined)
            oldStandNameFilter && oldStandNameFilter.forEach(item => { url_ += "OldStandNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            coneatFilter && coneatFilter.forEach(item => { url_ += "ConeatFilter=" + encodeURIComponent("" + item) + "&"; });
        if (typeTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialNameFilter' cannot be null.");
        else if (typeTrialNameFilter !== undefined)
            typeTrialNameFilter && typeTrialNameFilter.forEach(item => { url_ += "TypeTrialNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialDesignTypesNameFilter === null)
            throw new globalThis.Error("The parameter 'trialDesignTypesNameFilter' cannot be null.");
        else if (trialDesignTypesNameFilter !== undefined)
            trialDesignTypesNameFilter && trialDesignTypesNameFilter.forEach(item => { url_ += "TrialDesignTypesNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialStatusNameFilter === null)
            throw new globalThis.Error("The parameter 'trialStatusNameFilter' cannot be null.");
        else if (trialStatusNameFilter !== undefined)
            trialStatusNameFilter && trialStatusNameFilter.forEach(item => { url_ += "TrialStatusNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            trialNumberFilter && trialNumberFilter.forEach(item => { url_ += "TrialNumberFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTrialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTypeTrialForTableDropdown(): Observable<TrialTypeTrialLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTypeTrialForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeTrialForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeTrialForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrialTypeTrialLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrialTypeTrialLookupTableDto[]>;
        }));
    }

    protected processGetAllTypeTrialForTableDropdown(response: HttpResponseBase): Observable<TrialTypeTrialLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialTypeTrialLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTrialDesignTypesForTableDropdown(): Observable<TrialTrialDesignTypesLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTrialDesignTypesForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialDesignTypesForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialDesignTypesForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrialTrialDesignTypesLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrialTrialDesignTypesLookupTableDto[]>;
        }));
    }

    protected processGetAllTrialDesignTypesForTableDropdown(response: HttpResponseBase): Observable<TrialTrialDesignTypesLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialTrialDesignTypesLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTrialStatusForTableDropdown(): Observable<TrialTrialStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTrialStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrialTrialStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrialTrialStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllTrialStatusForTableDropdown(response: HttpResponseBase): Observable<TrialTrialStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialTrialStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTrialsFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Trials/CreateTrialsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrialsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrialsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTrialsFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filename (optional) 
     * @param trial (optional) 
     * @param body (optional) 
     * @return OK
     */
    uploadFile(filename: string | undefined, trial: string | undefined, body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trials/UploadFile?";
        if (filename === null)
            throw new globalThis.Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (trial === null)
            throw new globalThis.Error("The parameter 'trial' cannot be null.");
        else if (trial !== undefined)
            url_ += "trial=" + encodeURIComponent("" + trial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directoryFold (optional) 
     * @return OK
     */
    download(directoryFold: string | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/Download?";
        if (directoryFold === null)
            throw new globalThis.Error("The parameter 'directoryFold' cannot be null.");
        else if (directoryFold !== undefined)
            url_ += "directoryFold=" + encodeURIComponent("" + directoryFold) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trial (optional) 
     * @return OK
     */
    deleteFile(trial: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trials/DeleteFile?";
        if (trial === null)
            throw new globalThis.Error("The parameter 'trial' cannot be null.");
        else if (trial !== undefined)
            url_ += "trial=" + encodeURIComponent("" + trial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trial (optional) 
     * @return OK
     */
    downloadFile(trial: string | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/downloadFile?";
        if (trial === null)
            throw new globalThis.Error("The parameter 'trial' cannot be null.");
        else if (trial !== undefined)
            url_ += "trial=" + encodeURIComponent("" + trial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTrialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTrialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTrialDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTrialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTrialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeTrialId (optional) 
     * @return OK
     */
    getGroupTrialByTypeTrialId(typeTrialId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetGroupTrialByTypeTrialId?";
        if (typeTrialId === null)
            throw new globalThis.Error("The parameter 'typeTrialId' cannot be null.");
        else if (typeTrialId !== undefined)
            url_ += "typeTrialId=" + encodeURIComponent("" + typeTrialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupTrialByTypeTrialId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupTrialByTypeTrialId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetGroupTrialByTypeTrialId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeTrialId (optional) 
     * @return OK
     */
    getLastAvailableIdByGroupName(typeTrialId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetLastAvailableIdByGroupName?";
        if (typeTrialId === null)
            throw new globalThis.Error("The parameter 'typeTrialId' cannot be null.");
        else if (typeTrialId !== undefined)
            url_ += "typeTrialId=" + encodeURIComponent("" + typeTrialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastAvailableIdByGroupName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastAvailableIdByGroupName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLastAvailableIdByGroupName(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialNumberFilter (optional) 
     * @return OK
     */
    getAllTrialNumberForLookupTable(trialNumberFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTrialNumberForLookupTable?";
        if (trialNumberFilter === null)
            throw new globalThis.Error("The parameter 'trialNumberFilter' cannot be null.");
        else if (trialNumberFilter !== undefined)
            url_ += "TrialNumberFilter=" + encodeURIComponent("" + trialNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialNumberForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialNumberForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllTrialNumberForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param regionFilter (optional) 
     * @return OK
     */
    getAllRegionForLookupTable(regionFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllRegionForLookupTable?";
        if (regionFilter === null)
            throw new globalThis.Error("The parameter 'regionFilter' cannot be null.");
        else if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegionForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllRegionForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldTrialDenominationFilter (optional) 
     * @return OK
     */
    getAllOldTrialDenominationForLookupTable(oldTrialDenominationFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllOldTrialDenominationForLookupTable?";
        if (oldTrialDenominationFilter === null)
            throw new globalThis.Error("The parameter 'oldTrialDenominationFilter' cannot be null.");
        else if (oldTrialDenominationFilter !== undefined)
            url_ += "OldTrialDenominationFilter=" + encodeURIComponent("" + oldTrialDenominationFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOldTrialDenominationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOldTrialDenominationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllOldTrialDenominationForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtFilter (optional) 
     * @return OK
     */
    getAllDistrictForLookupTable(districtFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllDistrictForLookupTable?";
        if (districtFilter === null)
            throw new globalThis.Error("The parameter 'districtFilter' cannot be null.");
        else if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistrictForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistrictForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllDistrictForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoneFilter (optional) 
     * @return OK
     */
    getAllZoneForLookupTable(zoneFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllZoneForLookupTable?";
        if (zoneFilter === null)
            throw new globalThis.Error("The parameter 'zoneFilter' cannot be null.");
        else if (zoneFilter !== undefined)
            url_ += "ZoneFilter=" + encodeURIComponent("" + zoneFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZoneForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZoneForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllZoneForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param planningStatusFilter (optional) 
     * @return OK
     */
    getAllPlanningStatusForLookupTable(planningStatusFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllPlanningStatusForLookupTable?";
        if (planningStatusFilter === null)
            throw new globalThis.Error("The parameter 'planningStatusFilter' cannot be null.");
        else if (planningStatusFilter !== undefined)
            url_ += "PlanningStatusFilter=" + encodeURIComponent("" + planningStatusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanningStatusForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanningStatusForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllPlanningStatusForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param standNameFilter (optional) 
     * @return OK
     */
    getAllStandNameForLookupTable(standNameFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllStandNameForLookupTable?";
        if (standNameFilter === null)
            throw new globalThis.Error("The parameter 'standNameFilter' cannot be null.");
        else if (standNameFilter !== undefined)
            url_ += "StandNameFilter=" + encodeURIComponent("" + standNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStandNameForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStandNameForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllStandNameForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param farmNameFilter (optional) 
     * @return OK
     */
    getAllFarmNameForLookupTable(farmNameFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllFarmNameForLookupTable?";
        if (farmNameFilter === null)
            throw new globalThis.Error("The parameter 'farmNameFilter' cannot be null.");
        else if (farmNameFilter !== undefined)
            url_ += "FarmNameFilter=" + encodeURIComponent("" + farmNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFarmNameForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFarmNameForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllFarmNameForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldStandNameFilter (optional) 
     * @return OK
     */
    getAllOldStandNameForLookupTable(oldStandNameFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllOldStandNameForLookupTable?";
        if (oldStandNameFilter === null)
            throw new globalThis.Error("The parameter 'oldStandNameFilter' cannot be null.");
        else if (oldStandNameFilter !== undefined)
            url_ += "OldStandNameFilter=" + encodeURIComponent("" + oldStandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOldStandNameForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOldStandNameForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllOldStandNameForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param coneatFilter (optional) 
     * @return OK
     */
    getAllConeatForLookupTable(coneatFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllConeatForLookupTable?";
        if (coneatFilter === null)
            throw new globalThis.Error("The parameter 'coneatFilter' cannot be null.");
        else if (coneatFilter !== undefined)
            url_ += "ConeatFilter=" + encodeURIComponent("" + coneatFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConeatForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConeatForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllConeatForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeTrialFilter (optional) 
     * @return OK
     */
    getAllTypeTrialForLookupTable(typeTrialFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTypeTrialForLookupTable?";
        if (typeTrialFilter === null)
            throw new globalThis.Error("The parameter 'typeTrialFilter' cannot be null.");
        else if (typeTrialFilter !== undefined)
            url_ += "TypeTrialFilter=" + encodeURIComponent("" + typeTrialFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypeTrialForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypeTrialForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllTypeTrialForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialDesignTypesFilter (optional) 
     * @return OK
     */
    getAllTrialDesignTypesForLookupTable(trialDesignTypesFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTrialDesignTypesForLookupTable?";
        if (trialDesignTypesFilter === null)
            throw new globalThis.Error("The parameter 'trialDesignTypesFilter' cannot be null.");
        else if (trialDesignTypesFilter !== undefined)
            url_ += "TrialDesignTypesFilter=" + encodeURIComponent("" + trialDesignTypesFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialDesignTypesForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialDesignTypesForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllTrialDesignTypesForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trialStatusFilter (optional) 
     * @return OK
     */
    getAllTrialStatusForLookupTable(trialStatusFilter: string | undefined): Observable<LookupTableResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trials/GetAllTrialStatusForLookupTable?";
        if (trialStatusFilter === null)
            throw new globalThis.Error("The parameter 'trialStatusFilter' cannot be null.");
        else if (trialStatusFilter !== undefined)
            url_ += "TrialStatusFilter=" + encodeURIComponent("" + trialStatusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrialStatusForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrialStatusForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableResponseDto[]>;
        }));
    }

    protected processGetAllTrialStatusForLookupTable(response: HttpResponseBase): Observable<LookupTableResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrialStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isPlannedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, isPlannedFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrialStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isPlannedFilter === null)
            throw new globalThis.Error("The parameter 'isPlannedFilter' cannot be null.");
        else if (isPlannedFilter !== undefined)
            url_ += "IsPlannedFilter=" + encodeURIComponent("" + isPlannedFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrialStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrialStatusForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrialStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrialStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isPlannedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, isPlannedFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isPlannedFilter === null)
            throw new globalThis.Error("The parameter 'isPlannedFilter' cannot be null.");
        else if (isPlannedFilter !== undefined)
            url_ += "IsPlannedFilter=" + encodeURIComponent("" + isPlannedFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialStatusForView(id: number | undefined): Observable<GetTrialStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/GetTrialStatusForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialStatusForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialStatusForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialStatusForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialStatusForViewDto>;
        }));
    }

    protected processGetTrialStatusForView(response: HttpResponseBase): Observable<GetTrialStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTrialStatusForEdit(id: number | undefined): Observable<GetTrialStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/GetTrialStatusForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialStatusForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrialStatusForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrialStatusForEditOutput>;
        }));
    }

    protected processGetTrialStatusForEdit(response: HttpResponseBase): Observable<GetTrialStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrialStatusForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTrialStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isPlannedFilter (optional) 
     * @return OK
     */
    getTrialStatusesToExcel(filter: string | undefined, nameFilter: string | undefined, isPlannedFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/GetTrialStatusesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isPlannedFilter === null)
            throw new globalThis.Error("The parameter 'isPlannedFilter' cannot be null.");
        else if (isPlannedFilter !== undefined)
            url_ += "IsPlannedFilter=" + encodeURIComponent("" + isPlannedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrialStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrialStatusesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTrialStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTrialStatusFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/CreateTrialStatusFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrialStatusFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrialStatusFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTrialStatusFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTrialStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrialStatuses/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTrialStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTrialStatusDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTrialStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTrialStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return OK
     */
    getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier === null)
            throw new globalThis.Error("The parameter 'verifier' cannot be null.");
        else if (verifier !== undefined)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TypeGeneticMaterialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTypeGeneticMaterialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTypeGeneticMaterialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTypeGeneticMaterialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTypeGeneticMaterialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTypeGeneticMaterialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeGeneticMaterialForView(id: number | undefined): Observable<GetTypeGeneticMaterialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/GetTypeGeneticMaterialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeGeneticMaterialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeGeneticMaterialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeGeneticMaterialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeGeneticMaterialForViewDto>;
        }));
    }

    protected processGetTypeGeneticMaterialForView(response: HttpResponseBase): Observable<GetTypeGeneticMaterialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeGeneticMaterialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeGeneticMaterialForEdit(id: number | undefined): Observable<GetTypeGeneticMaterialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/GetTypeGeneticMaterialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeGeneticMaterialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeGeneticMaterialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeGeneticMaterialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeGeneticMaterialForEditOutput>;
        }));
    }

    protected processGetTypeGeneticMaterialForEdit(response: HttpResponseBase): Observable<GetTypeGeneticMaterialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeGeneticMaterialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTypeGeneticMaterialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getTypeGeneticMaterialsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/GetTypeGeneticMaterialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeGeneticMaterialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeGeneticMaterialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTypeGeneticMaterialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTypeGeneticMaterialFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/CreateTypeGeneticMaterialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTypeGeneticMaterialFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTypeGeneticMaterialFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTypeGeneticMaterialFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTypeGeneticMaterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TypeGeneticMaterials/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTypeGeneticMaterialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTypeGeneticMaterialDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTypeGeneticMaterialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTypeGeneticMaterialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TypeSpeciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTypeSpecieForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTypeSpecieForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTypeSpecieForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTypeSpecieForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTypeSpecieForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeSpecieForView(id: number | undefined): Observable<GetTypeSpecieForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/GetTypeSpecieForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeSpecieForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeSpecieForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeSpecieForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeSpecieForViewDto>;
        }));
    }

    protected processGetTypeSpecieForView(response: HttpResponseBase): Observable<GetTypeSpecieForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeSpecieForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeSpecieForEdit(id: number | undefined): Observable<GetTypeSpecieForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/GetTypeSpecieForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeSpecieForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeSpecieForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeSpecieForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeSpecieForEditOutput>;
        }));
    }

    protected processGetTypeSpecieForEdit(response: HttpResponseBase): Observable<GetTypeSpecieForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeSpecieForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTypeSpecieDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return OK
     */
    getTypeSpeciesToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeSpecies/GetTypeSpeciesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeSpeciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeSpeciesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTypeSpeciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TypeTrialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param categoryFilter (optional) 
     * @param groupTrialNameFilter (optional) 
     * @param isClonalSeedOrchardFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, categoryFilter: string | undefined, groupTrialNameFilter: string | undefined, isClonalSeedOrchardFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTypeTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (categoryFilter === null)
            throw new globalThis.Error("The parameter 'categoryFilter' cannot be null.");
        else if (categoryFilter !== undefined)
            url_ += "CategoryFilter=" + encodeURIComponent("" + categoryFilter) + "&";
        if (groupTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'groupTrialNameFilter' cannot be null.");
        else if (groupTrialNameFilter !== undefined)
            url_ += "GroupTrialNameFilter=" + encodeURIComponent("" + groupTrialNameFilter) + "&";
        if (isClonalSeedOrchardFilter === null)
            throw new globalThis.Error("The parameter 'isClonalSeedOrchardFilter' cannot be null.");
        else if (isClonalSeedOrchardFilter !== undefined)
            url_ += "IsClonalSeedOrchardFilter=" + encodeURIComponent("" + isClonalSeedOrchardFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTypeTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTypeTrialForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTypeTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTypeTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param categoryFilter (optional) 
     * @param groupTrialNameFilter (optional) 
     * @param isClonalSeedOrchardFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, categoryFilter: string | undefined, groupTrialNameFilter: string | undefined, isClonalSeedOrchardFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (categoryFilter === null)
            throw new globalThis.Error("The parameter 'categoryFilter' cannot be null.");
        else if (categoryFilter !== undefined)
            url_ += "CategoryFilter=" + encodeURIComponent("" + categoryFilter) + "&";
        if (groupTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'groupTrialNameFilter' cannot be null.");
        else if (groupTrialNameFilter !== undefined)
            url_ += "GroupTrialNameFilter=" + encodeURIComponent("" + groupTrialNameFilter) + "&";
        if (isClonalSeedOrchardFilter === null)
            throw new globalThis.Error("The parameter 'isClonalSeedOrchardFilter' cannot be null.");
        else if (isClonalSeedOrchardFilter !== undefined)
            url_ += "IsClonalSeedOrchardFilter=" + encodeURIComponent("" + isClonalSeedOrchardFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeTrialForView(id: number | undefined): Observable<GetTypeTrialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetTypeTrialForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeTrialForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeTrialForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeTrialForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeTrialForViewDto>;
        }));
    }

    protected processGetTypeTrialForView(response: HttpResponseBase): Observable<GetTypeTrialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeTrialForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTypeTrialForEdit(id: number | undefined): Observable<GetTypeTrialForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetTypeTrialForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeTrialForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeTrialForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypeTrialForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypeTrialForEditOutput>;
        }));
    }

    protected processGetTypeTrialForEdit(response: HttpResponseBase): Observable<GetTypeTrialForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeTrialForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditTypeTrialDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param categoryFilter (optional) 
     * @param groupTrialNameFilter (optional) 
     * @param isClonalSeedOrchardFilter (optional) 
     * @return OK
     */
    getTypeTrialsToExcel(filter: string | undefined, nameFilter: string | undefined, categoryFilter: string | undefined, groupTrialNameFilter: string | undefined, isClonalSeedOrchardFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetTypeTrialsToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (categoryFilter === null)
            throw new globalThis.Error("The parameter 'categoryFilter' cannot be null.");
        else if (categoryFilter !== undefined)
            url_ += "CategoryFilter=" + encodeURIComponent("" + categoryFilter) + "&";
        if (groupTrialNameFilter === null)
            throw new globalThis.Error("The parameter 'groupTrialNameFilter' cannot be null.");
        else if (groupTrialNameFilter !== undefined)
            url_ += "GroupTrialNameFilter=" + encodeURIComponent("" + groupTrialNameFilter) + "&";
        if (isClonalSeedOrchardFilter === null)
            throw new globalThis.Error("The parameter 'isClonalSeedOrchardFilter' cannot be null.");
        else if (isClonalSeedOrchardFilter !== undefined)
            url_ += "IsClonalSeedOrchardFilter=" + encodeURIComponent("" + isClonalSeedOrchardFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeTrialsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeTrialsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTypeTrialsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllGroupTrialForTableDropdown(): Observable<TypeTrialGroupTrialLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/GetAllGroupTrialForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupTrialForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupTrialForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeTrialGroupTrialLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeTrialGroupTrialLookupTableDto[]>;
        }));
    }

    protected processGetAllGroupTrialForTableDropdown(response: HttpResponseBase): Observable<TypeTrialGroupTrialLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TypeTrialGroupTrialLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTypeTrialFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/CreateTypeTrialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTypeTrialFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTypeTrialFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateTypeTrialFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditTypeTrialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TypeTrials/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTypeTrialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTypeTrialDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditTypeTrialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTypeTrialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return OK
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new globalThis.Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new globalThis.Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: string | undefined): Observable<WebhookEvent> {
        let url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookEvent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookEvent>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param subscriptionId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllSendAttempts(subscriptionId: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
        }));
    }

    protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllSendAttemptsOfWebhookEvent(id: string | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttemptsOfWebhookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttemptsOfWebhookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
        }));
    }

    protected processGetAllSendAttemptsOfWebhookEvent(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sendAttemptId (optional) 
     * @return OK
     */
    resend(sendAttemptId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
        if (sendAttemptId === null)
            throw new globalThis.Error("The parameter 'sendAttemptId' cannot be null.");
        else if (sendAttemptId !== undefined)
            url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    publishTestWebhook(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishTestWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPublishTestWebhook(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriptionId (optional) 
     * @return OK
     */
    getSubscription(subscriptionId: string | undefined): Observable<WebhookSubscription> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookSubscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookSubscription>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookSubscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateWebhookSubscription(body: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateWebhookSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateWebhookSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    isSubscribed(webhookName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
        if (webhookName === null)
            throw new globalThis.Error("The parameter 'webhookName' cannot be null.");
        else if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubscribed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubscribed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    getAllSubscriptionsIfFeaturesGranted(webhookName: string | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
        if (webhookName === null)
            throw new globalThis.Error("The parameter 'webhookName' cannot be null.");
        else if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionsIfFeaturesGranted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
        }));
    }

    protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodSampleTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTreeCutFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, isTreeCutFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWoodSampleTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTreeCutFilter === null)
            throw new globalThis.Error("The parameter 'isTreeCutFilter' cannot be null.");
        else if (isTreeCutFilter !== undefined)
            url_ += "IsTreeCutFilter=" + encodeURIComponent("" + isTreeCutFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWoodSampleTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWoodSampleTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetWoodSampleTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWoodSampleTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTreeCutFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, nameFilter: string | undefined, isTreeCutFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTreeCutFilter === null)
            throw new globalThis.Error("The parameter 'isTreeCutFilter' cannot be null.");
        else if (isTreeCutFilter !== undefined)
            url_ += "IsTreeCutFilter=" + encodeURIComponent("" + isTreeCutFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getWoodSampleTypeForView(id: number | undefined): Observable<GetWoodSampleTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/GetWoodSampleTypeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodSampleTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodSampleTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWoodSampleTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWoodSampleTypeForViewDto>;
        }));
    }

    protected processGetWoodSampleTypeForView(response: HttpResponseBase): Observable<GetWoodSampleTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWoodSampleTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getWoodSampleTypeForEdit(id: number | undefined): Observable<GetWoodSampleTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/GetWoodSampleTypeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodSampleTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodSampleTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWoodSampleTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWoodSampleTypeForEditOutput>;
        }));
    }

    protected processGetWoodSampleTypeForEdit(response: HttpResponseBase): Observable<GetWoodSampleTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWoodSampleTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditWoodSampleTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param isTreeCutFilter (optional) 
     * @return OK
     */
    getWoodSampleTypesToExcel(filter: string | undefined, nameFilter: string | undefined, isTreeCutFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/GetWoodSampleTypesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new globalThis.Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isTreeCutFilter === null)
            throw new globalThis.Error("The parameter 'isTreeCutFilter' cannot be null.");
        else if (isTreeCutFilter !== undefined)
            url_ += "IsTreeCutFilter=" + encodeURIComponent("" + isTreeCutFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodSampleTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodSampleTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetWoodSampleTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createWoodSampleTypeFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/CreateWoodSampleTypeFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodSampleTypeFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodSampleTypeFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateWoodSampleTypeFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditWoodSampleTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodSampleTypes/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditWoodSampleTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditWoodSampleTypeDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditWoodSampleTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditWoodSampleTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class YoungObservationCodesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetYoungObservationCodeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetYoungObservationCodeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetYoungObservationCodeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetYoungObservationCodeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetYoungObservationCodeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllFromDatabase(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetAllFromDatabase?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllFromDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getYoungObservationCodeForView(id: number | undefined): Observable<GetYoungObservationCodeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetYoungObservationCodeForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYoungObservationCodeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYoungObservationCodeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetYoungObservationCodeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetYoungObservationCodeForViewDto>;
        }));
    }

    protected processGetYoungObservationCodeForView(response: HttpResponseBase): Observable<GetYoungObservationCodeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetYoungObservationCodeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getYoungObservationCodeForEdit(id: number | undefined): Observable<GetYoungObservationCodeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetYoungObservationCodeForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYoungObservationCodeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYoungObservationCodeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetYoungObservationCodeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetYoungObservationCodeForEditOutput>;
        }));
    }

    protected processGetYoungObservationCodeForEdit(response: HttpResponseBase): Observable<GetYoungObservationCodeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetYoungObservationCodeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CreateOrEditYoungObservationCodeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTreeStatusForTableDropdown(): Observable<TreeStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetAllTreeStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTreeStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTreeStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllTreeStatusForTableDropdown(response: HttpResponseBase): Observable<TreeStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxCodeFilter (optional) 
     * @param minCodeFilter (optional) 
     * @param detailFilter (optional) 
     * @return OK
     */
    getYoungObservationCodesToExcel(filter: string | undefined, maxCodeFilter: number | undefined, minCodeFilter: number | undefined, detailFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/GetYoungObservationCodesToExcel?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCodeFilter === null)
            throw new globalThis.Error("The parameter 'maxCodeFilter' cannot be null.");
        else if (maxCodeFilter !== undefined)
            url_ += "MaxCodeFilter=" + encodeURIComponent("" + maxCodeFilter) + "&";
        if (minCodeFilter === null)
            throw new globalThis.Error("The parameter 'minCodeFilter' cannot be null.");
        else if (minCodeFilter !== undefined)
            url_ += "MinCodeFilter=" + encodeURIComponent("" + minCodeFilter) + "&";
        if (detailFilter === null)
            throw new globalThis.Error("The parameter 'detailFilter' cannot be null.");
        else if (detailFilter !== undefined)
            url_ += "DetailFilter=" + encodeURIComponent("" + detailFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYoungObservationCodesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYoungObservationCodesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetYoungObservationCodesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createYoungObservationCodeFromExcel(body: string | undefined): Observable<FileUploadOutput> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/CreateYoungObservationCodeFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateYoungObservationCodeFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateYoungObservationCodeFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadOutput>;
        }));
    }

    protected processCreateYoungObservationCodeFromExcel(response: HttpResponseBase): Observable<FileUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onPostImportFromExcel(body: string | undefined): Observable<CreateOrEditYoungObservationCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/YoungObservationCodes/OnPostImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnPostImportFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnPostImportFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditYoungObservationCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditYoungObservationCodeDto[]>;
        }));
    }

    protected processOnPostImportFromExcel(response: HttpResponseBase): Observable<CreateOrEditYoungObservationCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditYoungObservationCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class _definitions_FileTagsDto implements I_definitions_FileTagsDto {
    name!: string | undefined;

    constructor(data?: I_definitions_FileTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): _definitions_FileTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new _definitions_FileTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface I_definitions_FileTagsDto {
    name: string | undefined;
}

export class _definitions_PolenMixtureDto implements I_definitions_PolenMixtureDto {
    bbpCompositionName!: string | undefined;
    porcentage!: number;
    polenCompositionId!: number;
    id!: number;

    constructor(data?: I_definitions_PolenMixtureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbpCompositionName = _data["bbpCompositionName"];
            this.porcentage = _data["porcentage"];
            this.polenCompositionId = _data["polenCompositionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): _definitions_PolenMixtureDto {
        data = typeof data === 'object' ? data : {};
        let result = new _definitions_PolenMixtureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbpCompositionName"] = this.bbpCompositionName;
        data["porcentage"] = this.porcentage;
        data["polenCompositionId"] = this.polenCompositionId;
        data["id"] = this.id;
        return data;
    }
}

export interface I_definitions_PolenMixtureDto {
    bbpCompositionName: string | undefined;
    porcentage: number;
    polenCompositionId: number;
    id: number;
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
    subscriptionId!: string;
    isActive!: boolean;

    constructor(data?: IActivateWebhookSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivateWebhookSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateWebhookSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivateWebhookSubscriptionInput {
    subscriptionId: string;
    isActive: boolean;
}

export class AdultObservationCodeDto implements IAdultObservationCodeDto {
    code!: number;
    detail!: string | undefined;
    treeStatusId!: number;
    id!: number;

    constructor(data?: IAdultObservationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdultObservationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdultObservationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdultObservationCodeDto {
    code: number;
    detail: string | undefined;
    treeStatusId: number;
    id: number;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : undefined as any;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Assembly implements IAssembly {
    readonly definedTypes!: string[] | undefined;
    readonly exportedTypes!: string[] | undefined;
    readonly codeBase!: string | undefined;
    entryPoint!: MethodInfo;
    readonly fullName!: string | undefined;
    readonly imageRuntimeVersion!: string | undefined;
    readonly isDynamic!: boolean;
    readonly location!: string | undefined;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly escapedCodeBase!: string | undefined;
    manifestModule!: Module;
    readonly modules!: Module[] | undefined;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (this as any).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (this as any).definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (this as any).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (this as any).exportedTypes!.push(item);
            }
            (this as any).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : undefined as any;
            (this as any).fullName = _data["fullName"];
            (this as any).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (this as any).isDynamic = _data["isDynamic"];
            (this as any).location = _data["location"];
            (this as any).reflectionOnly = _data["reflectionOnly"];
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                (this as any).modules = [] as any;
                for (let item of _data["modules"])
                    (this as any).modules!.push(Module.fromJS(item));
            }
            (this as any).globalAssemblyCache = _data["globalAssemblyCache"];
            (this as any).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined as any;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: string[] | undefined;
    exportedTypes: string[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : undefined as any;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : undefined as any;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class BBXDestinationDto implements IBBXDestinationDto {
    name!: string | undefined;
    order!: number | undefined;
    isFT!: boolean;
    isMj!: boolean;
    id!: number;

    constructor(data?: IBBXDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.isFT = _data["isFT"];
            this.isMj = _data["isMj"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BBXDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BBXDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["isFT"] = this.isFT;
        data["isMj"] = this.isMj;
        data["id"] = this.id;
        return data;
    }
}

export interface IBBXDestinationDto {
    name: string | undefined;
    order: number | undefined;
    isFT: boolean;
    isMj: boolean;
    id: number;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class CanaletonMapDto implements ICanaletonMapDto {
    canaletonNumber!: number;
    positions!: PlantPositionDto[] | undefined;
    totalQuantity!: number;

    constructor(data?: ICanaletonMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canaletonNumber = _data["canaletonNumber"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(PlantPositionDto.fromJS(item));
            }
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): CanaletonMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CanaletonMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canaletonNumber"] = this.canaletonNumber;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface ICanaletonMapDto {
    canaletonNumber: number;
    positions: PlantPositionDto[] | undefined;
    totalQuantity: number;
}

export class CanaletonPlantationDto implements ICanaletonPlantationDto {
    canaleton!: number;
    position!: number;
    groupPlMadre!: string | undefined;
    origin!: string | undefined;
    bbx!: string | undefined;
    plantationDate!: DateTime;
    quantityPlanted!: string | undefined;
    positionInCanaleton!: number;
    observations!: string | undefined;
    discardDate!: DateTime | undefined;
    id!: number;

    constructor(data?: ICanaletonPlantationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canaleton = _data["canaleton"];
            this.position = _data["position"];
            this.groupPlMadre = _data["groupPlMadre"];
            this.origin = _data["origin"];
            this.bbx = _data["bbx"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.quantityPlanted = _data["quantityPlanted"];
            this.positionInCanaleton = _data["positionInCanaleton"];
            this.observations = _data["observations"];
            this.discardDate = _data["discardDate"] ? DateTime.fromISO(_data["discardDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CanaletonPlantationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CanaletonPlantationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canaleton"] = this.canaleton;
        data["position"] = this.position;
        data["groupPlMadre"] = this.groupPlMadre;
        data["origin"] = this.origin;
        data["bbx"] = this.bbx;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["quantityPlanted"] = this.quantityPlanted;
        data["positionInCanaleton"] = this.positionInCanaleton;
        data["observations"] = this.observations;
        data["discardDate"] = this.discardDate ? this.discardDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICanaletonPlantationDto {
    canaleton: number;
    position: number;
    groupPlMadre: string | undefined;
    origin: string | undefined;
    bbx: string | undefined;
    plantationDate: DateTime;
    quantityPlanted: string | undefined;
    positionInCanaleton: number;
    observations: string | undefined;
    discardDate: DateTime | undefined;
    id: number;
}

export class CanaletonViewsDto implements ICanaletonViewsDto {
    all!: string | undefined;
    left!: string | undefined;
    right!: string | undefined;

    constructor(data?: ICanaletonViewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.all = _data["all"];
            this.left = _data["left"];
            this.right = _data["right"];
        }
    }

    static fromJS(data: any): CanaletonViewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CanaletonViewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        data["left"] = this.left;
        data["right"] = this.right;
        return data;
    }
}

export interface ICanaletonViewsDto {
    all: string | undefined;
    left: string | undefined;
    right: string | undefined;
}

export class CategorySeedOrigin implements ICategorySeedOrigin {
    tenantId!: number | undefined;
    name!: string;
    denomination!: string;
    isBulk!: boolean;
    isControlledCrossing!: boolean;
    isOpenPollination!: boolean;
    isImported!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICategorySeedOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.denomination = _data["denomination"];
            this.isBulk = _data["isBulk"];
            this.isControlledCrossing = _data["isControlledCrossing"];
            this.isOpenPollination = _data["isOpenPollination"];
            this.isImported = _data["isImported"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategorySeedOrigin {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySeedOrigin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["denomination"] = this.denomination;
        data["isBulk"] = this.isBulk;
        data["isControlledCrossing"] = this.isControlledCrossing;
        data["isOpenPollination"] = this.isOpenPollination;
        data["isImported"] = this.isImported;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICategorySeedOrigin {
    tenantId: number | undefined;
    name: string;
    denomination: string;
    isBulk: boolean;
    isControlledCrossing: boolean;
    isOpenPollination: boolean;
    isImported: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CategorySeedOriginDto implements ICategorySeedOriginDto {
    name!: string | undefined;
    denomination!: string | undefined;
    isBulk!: boolean;
    isControlledCrossing!: boolean;
    isOpenPollination!: boolean;
    isImported!: boolean;
    id!: number;

    constructor(data?: ICategorySeedOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.denomination = _data["denomination"];
            this.isBulk = _data["isBulk"];
            this.isControlledCrossing = _data["isControlledCrossing"];
            this.isOpenPollination = _data["isOpenPollination"];
            this.isImported = _data["isImported"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategorySeedOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySeedOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["denomination"] = this.denomination;
        data["isBulk"] = this.isBulk;
        data["isControlledCrossing"] = this.isControlledCrossing;
        data["isOpenPollination"] = this.isOpenPollination;
        data["isImported"] = this.isImported;
        data["id"] = this.id;
        return data;
    }
}

export interface ICategorySeedOriginDto {
    name: string | undefined;
    denomination: string | undefined;
    isBulk: boolean;
    isControlledCrossing: boolean;
    isOpenPollination: boolean;
    isImported: boolean;
    id: number;
}

export class CategoryTrialDto implements ICategoryTrialDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ICategoryTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategoryTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICategoryTrialDto {
    name: string | undefined;
    id: number;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
    id: number;
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class CleanValuesInput implements ICleanValuesInput {
    dynamicEntityPropertyId!: number;
    entityId!: string | undefined;

    constructor(data?: ICleanValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CleanValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CleanValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICleanValuesInput {
    dynamicEntityPropertyId: number;
    entityId: string | undefined;
}

export class Clone implements IClone {
    tenantId!: number | undefined;
    bbx!: string;
    bbxNumber!: number;
    cloneOrigin!: EnumCloneOrigin;
    measurementSelectionId!: number | undefined;
    measurementSelectionFk!: MeasurementSelection;
    measurementGenomicSelectionId!: number | undefined;
    measurementSelectionGenomicFk!: MeasurementSelectionGenomic;
    treeId!: number | undefined;
    treeFk!: Tree;
    seedId!: number | undefined;
    seedFk!: Seed;
    specie!: string | undefined;
    supplierId!: number | undefined;
    supplierFk!: Supplier;
    dB_10!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    speciesGroupId!: number | undefined;
    speciesGroupFk!: SpeciesGroup;
    typeSpecieId!: number | undefined;
    typeSpecieFk!: TypeSpecie;
    creationDate!: DateTime;
    clone_Base!: string | undefined;
    material!: string | undefined;
    observations!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IClone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bbx = _data["bbx"];
            this.bbxNumber = _data["bbxNumber"];
            this.cloneOrigin = _data["cloneOrigin"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.measurementSelectionFk = _data["measurementSelectionFk"] ? MeasurementSelection.fromJS(_data["measurementSelectionFk"]) : undefined as any;
            this.measurementGenomicSelectionId = _data["measurementGenomicSelectionId"];
            this.measurementSelectionGenomicFk = _data["measurementSelectionGenomicFk"] ? MeasurementSelectionGenomic.fromJS(_data["measurementSelectionGenomicFk"]) : undefined as any;
            this.treeId = _data["treeId"];
            this.treeFk = _data["treeFk"] ? Tree.fromJS(_data["treeFk"]) : undefined as any;
            this.seedId = _data["seedId"];
            this.seedFk = _data["seedFk"] ? Seed.fromJS(_data["seedFk"]) : undefined as any;
            this.specie = _data["specie"];
            this.supplierId = _data["supplierId"];
            this.supplierFk = _data["supplierFk"] ? Supplier.fromJS(_data["supplierFk"]) : undefined as any;
            this.dB_10 = _data["dB_10"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.speciesGroupId = _data["speciesGroupId"];
            this.speciesGroupFk = _data["speciesGroupFk"] ? SpeciesGroup.fromJS(_data["speciesGroupFk"]) : undefined as any;
            this.typeSpecieId = _data["typeSpecieId"];
            this.typeSpecieFk = _data["typeSpecieFk"] ? TypeSpecie.fromJS(_data["typeSpecieFk"]) : undefined as any;
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
            this.clone_Base = _data["clone_Base"];
            this.material = _data["material"];
            this.observations = _data["observations"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Clone {
        data = typeof data === 'object' ? data : {};
        let result = new Clone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bbx"] = this.bbx;
        data["bbxNumber"] = this.bbxNumber;
        data["cloneOrigin"] = this.cloneOrigin;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["measurementSelectionFk"] = this.measurementSelectionFk ? this.measurementSelectionFk.toJSON() : undefined as any;
        data["measurementGenomicSelectionId"] = this.measurementGenomicSelectionId;
        data["measurementSelectionGenomicFk"] = this.measurementSelectionGenomicFk ? this.measurementSelectionGenomicFk.toJSON() : undefined as any;
        data["treeId"] = this.treeId;
        data["treeFk"] = this.treeFk ? this.treeFk.toJSON() : undefined as any;
        data["seedId"] = this.seedId;
        data["seedFk"] = this.seedFk ? this.seedFk.toJSON() : undefined as any;
        data["specie"] = this.specie;
        data["supplierId"] = this.supplierId;
        data["supplierFk"] = this.supplierFk ? this.supplierFk.toJSON() : undefined as any;
        data["dB_10"] = this.dB_10;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["speciesGroupId"] = this.speciesGroupId;
        data["speciesGroupFk"] = this.speciesGroupFk ? this.speciesGroupFk.toJSON() : undefined as any;
        data["typeSpecieId"] = this.typeSpecieId;
        data["typeSpecieFk"] = this.typeSpecieFk ? this.typeSpecieFk.toJSON() : undefined as any;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
        data["clone_Base"] = this.clone_Base;
        data["material"] = this.material;
        data["observations"] = this.observations;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClone {
    tenantId: number | undefined;
    bbx: string;
    bbxNumber: number;
    cloneOrigin: EnumCloneOrigin;
    measurementSelectionId: number | undefined;
    measurementSelectionFk: MeasurementSelection;
    measurementGenomicSelectionId: number | undefined;
    measurementSelectionGenomicFk: MeasurementSelectionGenomic;
    treeId: number | undefined;
    treeFk: Tree;
    seedId: number | undefined;
    seedFk: Seed;
    specie: string | undefined;
    supplierId: number | undefined;
    supplierFk: Supplier;
    dB_10: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    rP_Lab_FRB: number | undefined;
    speciesGroupId: number | undefined;
    speciesGroupFk: SpeciesGroup;
    typeSpecieId: number | undefined;
    typeSpecieFk: TypeSpecie;
    creationDate: DateTime;
    clone_Base: string | undefined;
    material: string | undefined;
    observations: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CloneDto implements ICloneDto {
    bbx!: string | undefined;
    cloneOrigin!: EnumCloneOrigin;
    measurementSelectionId!: number | undefined;
    treeId!: number | undefined;
    seedId!: number | undefined;
    specie!: string | undefined;
    supplierId!: number | undefined;
    dB_10!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    speciesGroupId!: number | undefined;
    typeSpecieId!: number | undefined;
    creationDate!: DateTime;
    clone_Base!: string | undefined;
    material!: string | undefined;
    observations!: string | undefined;
    id!: number;

    constructor(data?: ICloneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbx = _data["bbx"];
            this.cloneOrigin = _data["cloneOrigin"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.treeId = _data["treeId"];
            this.seedId = _data["seedId"];
            this.specie = _data["specie"];
            this.supplierId = _data["supplierId"];
            this.dB_10 = _data["dB_10"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.speciesGroupId = _data["speciesGroupId"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
            this.clone_Base = _data["clone_Base"];
            this.material = _data["material"];
            this.observations = _data["observations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CloneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbx"] = this.bbx;
        data["cloneOrigin"] = this.cloneOrigin;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["treeId"] = this.treeId;
        data["seedId"] = this.seedId;
        data["specie"] = this.specie;
        data["supplierId"] = this.supplierId;
        data["dB_10"] = this.dB_10;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["speciesGroupId"] = this.speciesGroupId;
        data["typeSpecieId"] = this.typeSpecieId;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
        data["clone_Base"] = this.clone_Base;
        data["material"] = this.material;
        data["observations"] = this.observations;
        data["id"] = this.id;
        return data;
    }
}

export interface ICloneDto {
    bbx: string | undefined;
    cloneOrigin: EnumCloneOrigin;
    measurementSelectionId: number | undefined;
    treeId: number | undefined;
    seedId: number | undefined;
    specie: string | undefined;
    supplierId: number | undefined;
    dB_10: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    rP_Lab_FRB: number | undefined;
    speciesGroupId: number | undefined;
    typeSpecieId: number | undefined;
    creationDate: DateTime;
    clone_Base: string | undefined;
    material: string | undefined;
    observations: string | undefined;
    id: number;
}

export class CloneLookupTableDto implements ICloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    trialNumber!: number;
    displayNameBBS!: string | undefined;

    constructor(data?: ICloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.trialNumber = _data["trialNumber"];
            this.displayNameBBS = _data["displayNameBBS"];
        }
    }

    static fromJS(data: any): CloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["trialNumber"] = this.trialNumber;
        data["displayNameBBS"] = this.displayNameBBS;
        return data;
    }
}

export interface ICloneLookupTableDto {
    id: number;
    displayName: string | undefined;
    trialNumber: number;
    displayNameBBS: string | undefined;
}

export class CloneMeasurementSelectionKPIDto implements ICloneMeasurementSelectionKPIDto {
    specie!: string | undefined;
    specieCategory!: string | undefined;
    specieType!: string | undefined;
    proyectName!: string | undefined;
    year!: string | undefined;
    bbs!: string | undefined;
    idBBS!: string | undefined;
    trialIdBBS!: string | undefined;
    bbt!: string | undefined;
    bbx!: string | undefined;
    countTrials!: number;
    trialIds!: string | undefined;

    constructor(data?: ICloneMeasurementSelectionKPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specie = _data["specie"];
            this.specieCategory = _data["specieCategory"];
            this.specieType = _data["specieType"];
            this.proyectName = _data["proyectName"];
            this.year = _data["year"];
            this.bbs = _data["bbs"];
            this.idBBS = _data["idBBS"];
            this.trialIdBBS = _data["trialIdBBS"];
            this.bbt = _data["bbt"];
            this.bbx = _data["bbx"];
            this.countTrials = _data["countTrials"];
            this.trialIds = _data["trialIds"];
        }
    }

    static fromJS(data: any): CloneMeasurementSelectionKPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneMeasurementSelectionKPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specie"] = this.specie;
        data["specieCategory"] = this.specieCategory;
        data["specieType"] = this.specieType;
        data["proyectName"] = this.proyectName;
        data["year"] = this.year;
        data["bbs"] = this.bbs;
        data["idBBS"] = this.idBBS;
        data["trialIdBBS"] = this.trialIdBBS;
        data["bbt"] = this.bbt;
        data["bbx"] = this.bbx;
        data["countTrials"] = this.countTrials;
        data["trialIds"] = this.trialIds;
        return data;
    }
}

export interface ICloneMeasurementSelectionKPIDto {
    specie: string | undefined;
    specieCategory: string | undefined;
    specieType: string | undefined;
    proyectName: string | undefined;
    year: string | undefined;
    bbs: string | undefined;
    idBBS: string | undefined;
    trialIdBBS: string | undefined;
    bbt: string | undefined;
    bbx: string | undefined;
    countTrials: number;
    trialIds: string | undefined;
}

export class CloneMeasurementSelectionLookupTableDto implements ICloneMeasurementSelectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICloneMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CloneMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICloneMeasurementSelectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CloneStatusDto implements ICloneStatusDto {
    name!: string | undefined;
    isTrial!: boolean;
    id!: number;

    constructor(data?: ICloneStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isTrial = _data["isTrial"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CloneStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isTrial"] = this.isTrial;
        data["id"] = this.id;
        return data;
    }
}

export interface ICloneStatusDto {
    name: string | undefined;
    isTrial: boolean;
    id: number;
}

export class CloneTreeLookupTableDto implements ICloneTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICloneTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CloneTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICloneTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ConstructorInfo implements IConstructorInfo {
    memberType!: MemberTypes;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isConstructor = _data["isConstructor"];
            (this as any).isFinal = _data["isFinal"];
            (this as any).isHideBySig = _data["isHideBySig"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isVirtual = _data["isVirtual"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (this as any).isGenericMethod = _data["isGenericMethod"];
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            (this as any).name = _data["name"];
            (this as any).declaringType = _data["declaringType"];
            (this as any).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined as any;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IConstructorInfo {
    memberType: MemberTypes;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class ControlledCrossingCrossingTechniqueLookupTableDto implements IControlledCrossingCrossingTechniqueLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IControlledCrossingCrossingTechniqueLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ControlledCrossingCrossingTechniqueLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingCrossingTechniqueLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IControlledCrossingCrossingTechniqueLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ControlledCrossingDto implements IControlledCrossingDto {
    bagNumber!: number;
    farmName!: string | undefined;
    standName!: string | undefined;
    site!: string | undefined;
    crossingYear!: number;
    bbtMother!: string | undefined;
    specieMother!: string | undefined;
    bbxMother!: string | undefined;
    idBBXMother!: string | undefined;
    idTreeMother!: string | undefined;
    bbpFather!: string | undefined;
    idTreeFather!: string | undefined;
    bbxFather!: string | undefined;
    idBBXFather!: string | undefined;
    bbtFather!: string | undefined;
    specieFather!: string | undefined;
    specie!: string | undefined;
    emasculationDate!: DateTime;
    numberOfMaskedBuds!: number;
    pollinationDate!: DateTime;
    numberPollinationBuds!: number;
    bagWithdrawalDate!: DateTime;
    numberCapsules!: number;
    harvestDate!: DateTime;
    numberHarvested!: number;
    percentageHarvestRetention!: number;
    numberOfSeeds!: number;
    operator!: string | undefined;
    bbc!: string | undefined;
    observations!: string | undefined;
    percentageRetentionBagWithdrawal!: number;
    trialId!: number | undefined;
    seedIdBBS!: number | undefined;
    polenIdBBP!: number | undefined;
    seedIdBBP!: number | undefined;
    typeSpecieId!: number | undefined;
    crossingTechniqueId!: number | undefined;
    seedIdBBC!: number | undefined;
    treeMotherId!: number | undefined;
    seedBBS!: string | undefined;
    seedBBS2!: string | undefined;
    id!: number;

    constructor(data?: IControlledCrossingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bagNumber = _data["bagNumber"];
            this.farmName = _data["farmName"];
            this.standName = _data["standName"];
            this.site = _data["site"];
            this.crossingYear = _data["crossingYear"];
            this.bbtMother = _data["bbtMother"];
            this.specieMother = _data["specieMother"];
            this.bbxMother = _data["bbxMother"];
            this.idBBXMother = _data["idBBXMother"];
            this.idTreeMother = _data["idTreeMother"];
            this.bbpFather = _data["bbpFather"];
            this.idTreeFather = _data["idTreeFather"];
            this.bbxFather = _data["bbxFather"];
            this.idBBXFather = _data["idBBXFather"];
            this.bbtFather = _data["bbtFather"];
            this.specieFather = _data["specieFather"];
            this.specie = _data["specie"];
            this.emasculationDate = _data["emasculationDate"] ? DateTime.fromISO(_data["emasculationDate"].toString()) : undefined as any;
            this.numberOfMaskedBuds = _data["numberOfMaskedBuds"];
            this.pollinationDate = _data["pollinationDate"] ? DateTime.fromISO(_data["pollinationDate"].toString()) : undefined as any;
            this.numberPollinationBuds = _data["numberPollinationBuds"];
            this.bagWithdrawalDate = _data["bagWithdrawalDate"] ? DateTime.fromISO(_data["bagWithdrawalDate"].toString()) : undefined as any;
            this.numberCapsules = _data["numberCapsules"];
            this.harvestDate = _data["harvestDate"] ? DateTime.fromISO(_data["harvestDate"].toString()) : undefined as any;
            this.numberHarvested = _data["numberHarvested"];
            this.percentageHarvestRetention = _data["percentageHarvestRetention"];
            this.numberOfSeeds = _data["numberOfSeeds"];
            this.operator = _data["operator"];
            this.bbc = _data["bbc"];
            this.observations = _data["observations"];
            this.percentageRetentionBagWithdrawal = _data["percentageRetentionBagWithdrawal"];
            this.trialId = _data["trialId"];
            this.seedIdBBS = _data["seedIdBBS"];
            this.polenIdBBP = _data["polenIdBBP"];
            this.seedIdBBP = _data["seedIdBBP"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.crossingTechniqueId = _data["crossingTechniqueId"];
            this.seedIdBBC = _data["seedIdBBC"];
            this.treeMotherId = _data["treeMotherId"];
            this.seedBBS = _data["seedBBS"];
            this.seedBBS2 = _data["seedBBS2"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlledCrossingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bagNumber"] = this.bagNumber;
        data["farmName"] = this.farmName;
        data["standName"] = this.standName;
        data["site"] = this.site;
        data["crossingYear"] = this.crossingYear;
        data["bbtMother"] = this.bbtMother;
        data["specieMother"] = this.specieMother;
        data["bbxMother"] = this.bbxMother;
        data["idBBXMother"] = this.idBBXMother;
        data["idTreeMother"] = this.idTreeMother;
        data["bbpFather"] = this.bbpFather;
        data["idTreeFather"] = this.idTreeFather;
        data["bbxFather"] = this.bbxFather;
        data["idBBXFather"] = this.idBBXFather;
        data["bbtFather"] = this.bbtFather;
        data["specieFather"] = this.specieFather;
        data["specie"] = this.specie;
        data["emasculationDate"] = this.emasculationDate ? this.emasculationDate.toString() : undefined as any;
        data["numberOfMaskedBuds"] = this.numberOfMaskedBuds;
        data["pollinationDate"] = this.pollinationDate ? this.pollinationDate.toString() : undefined as any;
        data["numberPollinationBuds"] = this.numberPollinationBuds;
        data["bagWithdrawalDate"] = this.bagWithdrawalDate ? this.bagWithdrawalDate.toString() : undefined as any;
        data["numberCapsules"] = this.numberCapsules;
        data["harvestDate"] = this.harvestDate ? this.harvestDate.toString() : undefined as any;
        data["numberHarvested"] = this.numberHarvested;
        data["percentageHarvestRetention"] = this.percentageHarvestRetention;
        data["numberOfSeeds"] = this.numberOfSeeds;
        data["operator"] = this.operator;
        data["bbc"] = this.bbc;
        data["observations"] = this.observations;
        data["percentageRetentionBagWithdrawal"] = this.percentageRetentionBagWithdrawal;
        data["trialId"] = this.trialId;
        data["seedIdBBS"] = this.seedIdBBS;
        data["polenIdBBP"] = this.polenIdBBP;
        data["seedIdBBP"] = this.seedIdBBP;
        data["typeSpecieId"] = this.typeSpecieId;
        data["crossingTechniqueId"] = this.crossingTechniqueId;
        data["seedIdBBC"] = this.seedIdBBC;
        data["treeMotherId"] = this.treeMotherId;
        data["seedBBS"] = this.seedBBS;
        data["seedBBS2"] = this.seedBBS2;
        data["id"] = this.id;
        return data;
    }
}

export interface IControlledCrossingDto {
    bagNumber: number;
    farmName: string | undefined;
    standName: string | undefined;
    site: string | undefined;
    crossingYear: number;
    bbtMother: string | undefined;
    specieMother: string | undefined;
    bbxMother: string | undefined;
    idBBXMother: string | undefined;
    idTreeMother: string | undefined;
    bbpFather: string | undefined;
    idTreeFather: string | undefined;
    bbxFather: string | undefined;
    idBBXFather: string | undefined;
    bbtFather: string | undefined;
    specieFather: string | undefined;
    specie: string | undefined;
    emasculationDate: DateTime;
    numberOfMaskedBuds: number;
    pollinationDate: DateTime;
    numberPollinationBuds: number;
    bagWithdrawalDate: DateTime;
    numberCapsules: number;
    harvestDate: DateTime;
    numberHarvested: number;
    percentageHarvestRetention: number;
    numberOfSeeds: number;
    operator: string | undefined;
    bbc: string | undefined;
    observations: string | undefined;
    percentageRetentionBagWithdrawal: number;
    trialId: number | undefined;
    seedIdBBS: number | undefined;
    polenIdBBP: number | undefined;
    seedIdBBP: number | undefined;
    typeSpecieId: number | undefined;
    crossingTechniqueId: number | undefined;
    seedIdBBC: number | undefined;
    treeMotherId: number | undefined;
    seedBBS: string | undefined;
    seedBBS2: string | undefined;
    id: number;
}

export class ControlledCrossingPolenLookupTableDto implements IControlledCrossingPolenLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayIdTree!: string | undefined;
    displayTreeNumber!: number | undefined;
    displayBBSTree!: string | undefined;
    displayBBXTree!: string | undefined;
    displayBlockTree!: number | undefined;
    displaySubBlockTree!: number | undefined;
    displaySpecie!: string | undefined;
    displayTrialNumber!: number | undefined;
    displayBBXTreeName!: string | undefined;
    dataBBT!: string | undefined;
    dataBBTId!: number | undefined;
    dataBBS!: string | undefined;
    dataBBX!: string | undefined;

    constructor(data?: IControlledCrossingPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayIdTree = _data["displayIdTree"];
            this.displayTreeNumber = _data["displayTreeNumber"];
            this.displayBBSTree = _data["displayBBSTree"];
            this.displayBBXTree = _data["displayBBXTree"];
            this.displayBlockTree = _data["displayBlockTree"];
            this.displaySubBlockTree = _data["displaySubBlockTree"];
            this.displaySpecie = _data["displaySpecie"];
            this.displayTrialNumber = _data["displayTrialNumber"];
            this.displayBBXTreeName = _data["displayBBXTreeName"];
            this.dataBBT = _data["dataBBT"];
            this.dataBBTId = _data["dataBBTId"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBX = _data["dataBBX"];
        }
    }

    static fromJS(data: any): ControlledCrossingPolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingPolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayIdTree"] = this.displayIdTree;
        data["displayTreeNumber"] = this.displayTreeNumber;
        data["displayBBSTree"] = this.displayBBSTree;
        data["displayBBXTree"] = this.displayBBXTree;
        data["displayBlockTree"] = this.displayBlockTree;
        data["displaySubBlockTree"] = this.displaySubBlockTree;
        data["displaySpecie"] = this.displaySpecie;
        data["displayTrialNumber"] = this.displayTrialNumber;
        data["displayBBXTreeName"] = this.displayBBXTreeName;
        data["dataBBT"] = this.dataBBT;
        data["dataBBTId"] = this.dataBBTId;
        data["dataBBS"] = this.dataBBS;
        data["dataBBX"] = this.dataBBX;
        return data;
    }
}

export interface IControlledCrossingPolenLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayIdTree: string | undefined;
    displayTreeNumber: number | undefined;
    displayBBSTree: string | undefined;
    displayBBXTree: string | undefined;
    displayBlockTree: number | undefined;
    displaySubBlockTree: number | undefined;
    displaySpecie: string | undefined;
    displayTrialNumber: number | undefined;
    displayBBXTreeName: string | undefined;
    dataBBT: string | undefined;
    dataBBTId: number | undefined;
    dataBBS: string | undefined;
    dataBBX: string | undefined;
}

export class ControlledCrossingSeedLookupTableDto implements IControlledCrossingSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displaySpeciesName!: string | undefined;
    displayIdTree!: string | undefined;
    dataBBT!: string | undefined;
    dataBBX!: string | undefined;
    dataBBXId!: string | undefined;

    constructor(data?: IControlledCrossingSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displaySpeciesName = _data["displaySpeciesName"];
            this.displayIdTree = _data["displayIdTree"];
            this.dataBBT = _data["dataBBT"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBXId = _data["dataBBXId"];
        }
    }

    static fromJS(data: any): ControlledCrossingSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displaySpeciesName"] = this.displaySpeciesName;
        data["displayIdTree"] = this.displayIdTree;
        data["dataBBT"] = this.dataBBT;
        data["dataBBX"] = this.dataBBX;
        data["dataBBXId"] = this.dataBBXId;
        return data;
    }
}

export interface IControlledCrossingSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
    displaySpeciesName: string | undefined;
    displayIdTree: string | undefined;
    dataBBT: string | undefined;
    dataBBX: string | undefined;
    dataBBXId: string | undefined;
}

export class ControlledCrossingTreeLookupTableDto implements IControlledCrossingTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayTreeSpecie!: string | undefined;
    displayTreeName!: string | undefined;
    dataTreeBlock!: number | undefined;
    dataTreeSubBlock!: number | undefined;
    dataTreeNumber!: number;
    dataBBS!: string | undefined;
    dataBBSId!: number | undefined;
    dataBBX!: string | undefined;
    dataBBXId!: number | undefined;
    dataBBT!: string | undefined;
    dataBBTId!: number | undefined;
    dataTrial!: number;
    dataTrialId!: number;
    dataOriginSite!: string | undefined;
    dataSpecie!: string | undefined;
    dataBBXName!: string | undefined;
    dataStandName!: string | undefined;

    constructor(data?: IControlledCrossingTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeSpecie = _data["displayTreeSpecie"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataTreeBlock = _data["dataTreeBlock"];
            this.dataTreeSubBlock = _data["dataTreeSubBlock"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBSId = _data["dataBBSId"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBXId = _data["dataBBXId"];
            this.dataBBT = _data["dataBBT"];
            this.dataBBTId = _data["dataBBTId"];
            this.dataTrial = _data["dataTrial"];
            this.dataTrialId = _data["dataTrialId"];
            this.dataOriginSite = _data["dataOriginSite"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBBXName = _data["dataBBXName"];
            this.dataStandName = _data["dataStandName"];
        }
    }

    static fromJS(data: any): ControlledCrossingTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeSpecie"] = this.displayTreeSpecie;
        data["displayTreeName"] = this.displayTreeName;
        data["dataTreeBlock"] = this.dataTreeBlock;
        data["dataTreeSubBlock"] = this.dataTreeSubBlock;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["dataBBS"] = this.dataBBS;
        data["dataBBSId"] = this.dataBBSId;
        data["dataBBX"] = this.dataBBX;
        data["dataBBXId"] = this.dataBBXId;
        data["dataBBT"] = this.dataBBT;
        data["dataBBTId"] = this.dataBBTId;
        data["dataTrial"] = this.dataTrial;
        data["dataTrialId"] = this.dataTrialId;
        data["dataOriginSite"] = this.dataOriginSite;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBBXName"] = this.dataBBXName;
        data["dataStandName"] = this.dataStandName;
        return data;
    }
}

export interface IControlledCrossingTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayTreeSpecie: string | undefined;
    displayTreeName: string | undefined;
    dataTreeBlock: number | undefined;
    dataTreeSubBlock: number | undefined;
    dataTreeNumber: number;
    dataBBS: string | undefined;
    dataBBSId: number | undefined;
    dataBBX: string | undefined;
    dataBBXId: number | undefined;
    dataBBT: string | undefined;
    dataBBTId: number | undefined;
    dataTrial: number;
    dataTrialId: number;
    dataOriginSite: string | undefined;
    dataSpecie: string | undefined;
    dataBBXName: string | undefined;
    dataStandName: string | undefined;
}

export class ControlledCrossingTrialLookupTableDto implements IControlledCrossingTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayTrialNumber!: number;
    displayFarmName!: string | undefined;

    constructor(data?: IControlledCrossingTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTrialNumber = _data["displayTrialNumber"];
            this.displayFarmName = _data["displayFarmName"];
        }
    }

    static fromJS(data: any): ControlledCrossingTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTrialNumber"] = this.displayTrialNumber;
        data["displayFarmName"] = this.displayFarmName;
        return data;
    }
}

export interface IControlledCrossingTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayTrialNumber: number;
    displayFarmName: string | undefined;
}

export class ControlledCrossingTypeSpecieLookupTableDto implements IControlledCrossingTypeSpecieLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IControlledCrossingTypeSpecieLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ControlledCrossingTypeSpecieLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlledCrossingTypeSpecieLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IControlledCrossingTypeSpecieLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateOrEditAdultObservationCodeDto implements ICreateOrEditAdultObservationCodeDto {
    code!: number;
    detail!: string;
    treeStatusId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdultObservationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdultObservationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdultObservationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdultObservationCodeDto {
    code: number;
    detail: string;
    treeStatusId: number;
    id: number | undefined;
}

export class CreateOrEditAnthillDto implements ICreateOrEditAnthillDto {
    species!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAnthillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.species = _data["species"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnthillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAnthillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["species"] = this.species;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAnthillDto {
    species: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditBBXDestinationDto implements ICreateOrEditBBXDestinationDto {
    name!: string;
    order!: number | undefined;
    isFT!: boolean;
    isMj!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBBXDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.isFT = _data["isFT"];
            this.isMj = _data["isMj"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBBXDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBBXDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["isFT"] = this.isFT;
        data["isMj"] = this.isMj;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBBXDestinationDto {
    name: string;
    order: number | undefined;
    isFT: boolean;
    isMj: boolean;
    id: number | undefined;
}

export class CreateOrEditCategorySeedOriginDto implements ICreateOrEditCategorySeedOriginDto {
    name!: string;
    denomination!: string;
    isBulk!: boolean;
    isControlledCrossing!: boolean;
    isOpenPollination!: boolean;
    isImported!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCategorySeedOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.denomination = _data["denomination"];
            this.isBulk = _data["isBulk"];
            this.isControlledCrossing = _data["isControlledCrossing"];
            this.isOpenPollination = _data["isOpenPollination"];
            this.isImported = _data["isImported"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCategorySeedOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCategorySeedOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["denomination"] = this.denomination;
        data["isBulk"] = this.isBulk;
        data["isControlledCrossing"] = this.isControlledCrossing;
        data["isOpenPollination"] = this.isOpenPollination;
        data["isImported"] = this.isImported;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCategorySeedOriginDto {
    name: string;
    denomination: string;
    isBulk: boolean;
    isControlledCrossing: boolean;
    isOpenPollination: boolean;
    isImported: boolean;
    id: number | undefined;
}

export class CreateOrEditCategoryTrialDto implements ICreateOrEditCategoryTrialDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCategoryTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCategoryTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCategoryTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCategoryTrialDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditCloneDto implements ICreateOrEditCloneDto {
    bbx!: string;
    cloneOrigin!: EnumCloneOrigin;
    measurementSelectionId!: number | undefined;
    treeId!: number | undefined;
    bbxNumber!: number;
    seedId!: number | undefined;
    specie!: string | undefined;
    supplierId!: number | undefined;
    supplierName!: string | undefined;
    dB_10!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    creationTime!: DateTime;
    speciesGroupId!: number | undefined;
    speciesGroupName!: string | undefined;
    typeSpecieId!: number | undefined;
    typeSpecieName!: string | undefined;
    maxRootingPercentage!: number | undefined;
    statusDate!: DateTime;
    creationDate!: DateTime;
    destineList!: GetBBXDestinationForViewDto[] | undefined;
    clone_Base!: string | undefined;
    material!: string | undefined;
    observations!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCloneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbx = _data["bbx"];
            this.cloneOrigin = _data["cloneOrigin"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.treeId = _data["treeId"];
            this.bbxNumber = _data["bbxNumber"];
            this.seedId = _data["seedId"];
            this.specie = _data["specie"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.dB_10 = _data["dB_10"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.speciesGroupId = _data["speciesGroupId"];
            this.speciesGroupName = _data["speciesGroupName"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.typeSpecieName = _data["typeSpecieName"];
            this.maxRootingPercentage = _data["maxRootingPercentage"];
            this.statusDate = _data["statusDate"] ? DateTime.fromISO(_data["statusDate"].toString()) : undefined as any;
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["destineList"])) {
                this.destineList = [] as any;
                for (let item of _data["destineList"])
                    this.destineList!.push(GetBBXDestinationForViewDto.fromJS(item));
            }
            this.clone_Base = _data["clone_Base"];
            this.material = _data["material"];
            this.observations = _data["observations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCloneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCloneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbx"] = this.bbx;
        data["cloneOrigin"] = this.cloneOrigin;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["treeId"] = this.treeId;
        data["bbxNumber"] = this.bbxNumber;
        data["seedId"] = this.seedId;
        data["specie"] = this.specie;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["dB_10"] = this.dB_10;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["speciesGroupId"] = this.speciesGroupId;
        data["speciesGroupName"] = this.speciesGroupName;
        data["typeSpecieId"] = this.typeSpecieId;
        data["typeSpecieName"] = this.typeSpecieName;
        data["maxRootingPercentage"] = this.maxRootingPercentage;
        data["statusDate"] = this.statusDate ? this.statusDate.toString() : undefined as any;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
        if (Array.isArray(this.destineList)) {
            data["destineList"] = [];
            for (let item of this.destineList)
                data["destineList"].push(item ? item.toJSON() : undefined as any);
        }
        data["clone_Base"] = this.clone_Base;
        data["material"] = this.material;
        data["observations"] = this.observations;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCloneDto {
    bbx: string;
    cloneOrigin: EnumCloneOrigin;
    measurementSelectionId: number | undefined;
    treeId: number | undefined;
    bbxNumber: number;
    seedId: number | undefined;
    specie: string | undefined;
    supplierId: number | undefined;
    supplierName: string | undefined;
    dB_10: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    rP_Lab_FRB: number | undefined;
    creationTime: DateTime;
    speciesGroupId: number | undefined;
    speciesGroupName: string | undefined;
    typeSpecieId: number | undefined;
    typeSpecieName: string | undefined;
    maxRootingPercentage: number | undefined;
    statusDate: DateTime;
    creationDate: DateTime;
    destineList: GetBBXDestinationForViewDto[] | undefined;
    clone_Base: string | undefined;
    material: string | undefined;
    observations: string | undefined;
    id: number | undefined;
}

export class CreateOrEditCloneStatusDto implements ICreateOrEditCloneStatusDto {
    name!: string;
    isTrial!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCloneStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isTrial = _data["isTrial"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCloneStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCloneStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isTrial"] = this.isTrial;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCloneStatusDto {
    name: string;
    isTrial: boolean;
    id: number | undefined;
}

export class CreateOrEditControlledCrossingDto implements ICreateOrEditControlledCrossingDto {
    bagNumber!: number;
    farmName!: string | undefined;
    standName!: string | undefined;
    site!: string | undefined;
    crossingYear!: number;
    bbtMother!: string | undefined;
    specieMother!: string;
    idTreeMother!: string;
    bbxMother!: string | undefined;
    idBBXMother!: string | undefined;
    bbpFather!: string | undefined;
    idTreeFather!: string;
    bbtFather!: string | undefined;
    bbxFather!: string | undefined;
    idBBXFather!: string | undefined;
    specieFather!: string;
    specie!: string;
    emasculationDate!: DateTime;
    numberOfMaskedBuds!: number;
    pollinationDate!: DateTime;
    numberPollinationBuds!: number;
    bagWithdrawalDate!: DateTime;
    numberCapsules!: number;
    harvestDate!: DateTime;
    numberHarvested!: number;
    percentageHarvestRetention!: number;
    numberOfSeeds!: number;
    operator!: string | undefined;
    bbc!: string;
    observations!: string | undefined;
    percentageRetentionBagWithdrawal!: number;
    trialId!: number | undefined;
    seedIdBBS!: number | undefined;
    polenIdBBP!: number | undefined;
    seedIdBBP!: number | undefined;
    typeSpecieId!: number | undefined;
    crossingTechniqueId!: number | undefined;
    seedIdBBC!: number | undefined;
    treeMotherId!: number | undefined;
    typeSpecieName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditControlledCrossingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bagNumber = _data["bagNumber"];
            this.farmName = _data["farmName"];
            this.standName = _data["standName"];
            this.site = _data["site"];
            this.crossingYear = _data["crossingYear"];
            this.bbtMother = _data["bbtMother"];
            this.specieMother = _data["specieMother"];
            this.idTreeMother = _data["idTreeMother"];
            this.bbxMother = _data["bbxMother"];
            this.idBBXMother = _data["idBBXMother"];
            this.bbpFather = _data["bbpFather"];
            this.idTreeFather = _data["idTreeFather"];
            this.bbtFather = _data["bbtFather"];
            this.bbxFather = _data["bbxFather"];
            this.idBBXFather = _data["idBBXFather"];
            this.specieFather = _data["specieFather"];
            this.specie = _data["specie"];
            this.emasculationDate = _data["emasculationDate"] ? DateTime.fromISO(_data["emasculationDate"].toString()) : undefined as any;
            this.numberOfMaskedBuds = _data["numberOfMaskedBuds"];
            this.pollinationDate = _data["pollinationDate"] ? DateTime.fromISO(_data["pollinationDate"].toString()) : undefined as any;
            this.numberPollinationBuds = _data["numberPollinationBuds"];
            this.bagWithdrawalDate = _data["bagWithdrawalDate"] ? DateTime.fromISO(_data["bagWithdrawalDate"].toString()) : undefined as any;
            this.numberCapsules = _data["numberCapsules"];
            this.harvestDate = _data["harvestDate"] ? DateTime.fromISO(_data["harvestDate"].toString()) : undefined as any;
            this.numberHarvested = _data["numberHarvested"];
            this.percentageHarvestRetention = _data["percentageHarvestRetention"];
            this.numberOfSeeds = _data["numberOfSeeds"];
            this.operator = _data["operator"];
            this.bbc = _data["bbc"];
            this.observations = _data["observations"];
            this.percentageRetentionBagWithdrawal = _data["percentageRetentionBagWithdrawal"];
            this.trialId = _data["trialId"];
            this.seedIdBBS = _data["seedIdBBS"];
            this.polenIdBBP = _data["polenIdBBP"];
            this.seedIdBBP = _data["seedIdBBP"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.crossingTechniqueId = _data["crossingTechniqueId"];
            this.seedIdBBC = _data["seedIdBBC"];
            this.treeMotherId = _data["treeMotherId"];
            this.typeSpecieName = _data["typeSpecieName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditControlledCrossingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditControlledCrossingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bagNumber"] = this.bagNumber;
        data["farmName"] = this.farmName;
        data["standName"] = this.standName;
        data["site"] = this.site;
        data["crossingYear"] = this.crossingYear;
        data["bbtMother"] = this.bbtMother;
        data["specieMother"] = this.specieMother;
        data["idTreeMother"] = this.idTreeMother;
        data["bbxMother"] = this.bbxMother;
        data["idBBXMother"] = this.idBBXMother;
        data["bbpFather"] = this.bbpFather;
        data["idTreeFather"] = this.idTreeFather;
        data["bbtFather"] = this.bbtFather;
        data["bbxFather"] = this.bbxFather;
        data["idBBXFather"] = this.idBBXFather;
        data["specieFather"] = this.specieFather;
        data["specie"] = this.specie;
        data["emasculationDate"] = this.emasculationDate ? this.emasculationDate.toString() : undefined as any;
        data["numberOfMaskedBuds"] = this.numberOfMaskedBuds;
        data["pollinationDate"] = this.pollinationDate ? this.pollinationDate.toString() : undefined as any;
        data["numberPollinationBuds"] = this.numberPollinationBuds;
        data["bagWithdrawalDate"] = this.bagWithdrawalDate ? this.bagWithdrawalDate.toString() : undefined as any;
        data["numberCapsules"] = this.numberCapsules;
        data["harvestDate"] = this.harvestDate ? this.harvestDate.toString() : undefined as any;
        data["numberHarvested"] = this.numberHarvested;
        data["percentageHarvestRetention"] = this.percentageHarvestRetention;
        data["numberOfSeeds"] = this.numberOfSeeds;
        data["operator"] = this.operator;
        data["bbc"] = this.bbc;
        data["observations"] = this.observations;
        data["percentageRetentionBagWithdrawal"] = this.percentageRetentionBagWithdrawal;
        data["trialId"] = this.trialId;
        data["seedIdBBS"] = this.seedIdBBS;
        data["polenIdBBP"] = this.polenIdBBP;
        data["seedIdBBP"] = this.seedIdBBP;
        data["typeSpecieId"] = this.typeSpecieId;
        data["crossingTechniqueId"] = this.crossingTechniqueId;
        data["seedIdBBC"] = this.seedIdBBC;
        data["treeMotherId"] = this.treeMotherId;
        data["typeSpecieName"] = this.typeSpecieName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditControlledCrossingDto {
    bagNumber: number;
    farmName: string | undefined;
    standName: string | undefined;
    site: string | undefined;
    crossingYear: number;
    bbtMother: string | undefined;
    specieMother: string;
    idTreeMother: string;
    bbxMother: string | undefined;
    idBBXMother: string | undefined;
    bbpFather: string | undefined;
    idTreeFather: string;
    bbtFather: string | undefined;
    bbxFather: string | undefined;
    idBBXFather: string | undefined;
    specieFather: string;
    specie: string;
    emasculationDate: DateTime;
    numberOfMaskedBuds: number;
    pollinationDate: DateTime;
    numberPollinationBuds: number;
    bagWithdrawalDate: DateTime;
    numberCapsules: number;
    harvestDate: DateTime;
    numberHarvested: number;
    percentageHarvestRetention: number;
    numberOfSeeds: number;
    operator: string | undefined;
    bbc: string;
    observations: string | undefined;
    percentageRetentionBagWithdrawal: number;
    trialId: number | undefined;
    seedIdBBS: number | undefined;
    polenIdBBP: number | undefined;
    seedIdBBP: number | undefined;
    typeSpecieId: number | undefined;
    crossingTechniqueId: number | undefined;
    seedIdBBC: number | undefined;
    treeMotherId: number | undefined;
    typeSpecieName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditCrossingTechniqueDto implements ICreateOrEditCrossingTechniqueDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCrossingTechniqueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCrossingTechniqueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCrossingTechniqueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCrossingTechniqueDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditDestinoBBXDto implements ICreateOrEditDestinoBBXDto {
    plantMother!: string | undefined;
    statusid!: number | undefined;
    fecha!: DateTime;
    destine!: number;
    bbXid!: number | undefined;
    projectId!: number | undefined;
    bbtId!: number | undefined;
    sourcePlantId!: number | undefined;
    bbt!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDestinoBBXDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantMother = _data["plantMother"];
            this.statusid = _data["statusid"];
            this.fecha = _data["fecha"] ? DateTime.fromISO(_data["fecha"].toString()) : undefined as any;
            this.destine = _data["destine"];
            this.bbXid = _data["bbXid"];
            this.projectId = _data["projectId"];
            this.bbtId = _data["bbtId"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.bbt = _data["bbt"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDestinoBBXDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDestinoBBXDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantMother"] = this.plantMother;
        data["statusid"] = this.statusid;
        data["fecha"] = this.fecha ? this.fecha.toString() : undefined as any;
        data["destine"] = this.destine;
        data["bbXid"] = this.bbXid;
        data["projectId"] = this.projectId;
        data["bbtId"] = this.bbtId;
        data["sourcePlantId"] = this.sourcePlantId;
        data["bbt"] = this.bbt;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDestinoBBXDto {
    plantMother: string | undefined;
    statusid: number | undefined;
    fecha: DateTime;
    destine: number;
    bbXid: number | undefined;
    projectId: number | undefined;
    bbtId: number | undefined;
    sourcePlantId: number | undefined;
    bbt: number | undefined;
    id: number | undefined;
}

export class CreateOrEditEnviromentConditionDto implements ICreateOrEditEnviromentConditionDto {
    condition!: string;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEnviromentConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.condition = _data["condition"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEnviromentConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEnviromentConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEnviromentConditionDto {
    condition: string;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditExperimentCategoryDto implements ICreateOrEditExperimentCategoryDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentCategoryDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditExperimentClasificationtwoDto implements ICreateOrEditExperimentClasificationtwoDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentClasificationtwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentClasificationtwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentClasificationtwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentClasificationtwoDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditExperimentClassificationDto implements ICreateOrEditExperimentClassificationDto {
    name!: string;
    experimentCategoryId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.experimentCategoryId = _data["experimentCategoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["experimentCategoryId"] = this.experimentCategoryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentClassificationDto {
    name: string;
    experimentCategoryId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditExperimentLocationDto implements ICreateOrEditExperimentLocationDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentLocationDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditExperimentSpecieDto implements ICreateOrEditExperimentSpecieDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentSpecieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentSpecieDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentSpecieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentSpecieDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditExperimentSpecieQuantityDto implements ICreateOrEditExperimentSpecieQuantityDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentSpecieQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentSpecieQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentSpecieQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentSpecieQuantityDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditExperimentTypeDto implements ICreateOrEditExperimentTypeDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExperimentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExperimentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExperimentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExperimentTypeDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditFileDto implements ICreateOrEditFileDto {
    id!: number | undefined;

    constructor(data?: ICreateOrEditFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFileDto {
    id: number | undefined;
}

export class CreateOrEditFrostToleranceDto implements ICreateOrEditFrostToleranceDto {
    name!: string;
    code!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFrostToleranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFrostToleranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFrostToleranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFrostToleranceDto {
    name: string;
    code: number;
    id: number | undefined;
}

export class CreateOrEditGenomicSeleccionDto implements ICreateOrEditGenomicSeleccionDto {
    projectId!: number | undefined;
    seedlingId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGenomicSeleccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.seedlingId = _data["seedlingId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGenomicSeleccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGenomicSeleccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["seedlingId"] = this.seedlingId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGenomicSeleccionDto {
    projectId: number | undefined;
    seedlingId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditGroupTrialDto implements ICreateOrEditGroupTrialDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGroupTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGroupTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGroupTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGroupTrialDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditHealthDoseDto implements ICreateOrEditHealthDoseDto {
    zoneStack!: boolean;
    transectId!: number | undefined;
    healthcareProductsDoseId!: number;
    healthcareTechnologyId!: number;
    healthcareMomentId!: number;
    levelInfestationId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneStack = _data["zoneStack"];
            this.transectId = _data["transectId"];
            this.healthcareProductsDoseId = _data["healthcareProductsDoseId"];
            this.healthcareTechnologyId = _data["healthcareTechnologyId"];
            this.healthcareMomentId = _data["healthcareMomentId"];
            this.levelInfestationId = _data["levelInfestationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneStack"] = this.zoneStack;
        data["transectId"] = this.transectId;
        data["healthcareProductsDoseId"] = this.healthcareProductsDoseId;
        data["healthcareTechnologyId"] = this.healthcareTechnologyId;
        data["healthcareMomentId"] = this.healthcareMomentId;
        data["levelInfestationId"] = this.levelInfestationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthDoseDto {
    zoneStack: boolean;
    transectId: number | undefined;
    healthcareProductsDoseId: number;
    healthcareTechnologyId: number;
    healthcareMomentId: number;
    levelInfestationId: number;
    id: number | undefined;
}

export class CreateOrEditHealthcareFormulaDto implements ICreateOrEditHealthcareFormulaDto {
    name!: string;
    isActive!: boolean;
    scales!: CreateOrEditHealthcareFormulaScaleDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["scales"])) {
                this.scales = [] as any;
                for (let item of _data["scales"])
                    this.scales!.push(CreateOrEditHealthcareFormulaScaleDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.scales)) {
            data["scales"] = [];
            for (let item of this.scales)
                data["scales"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareFormulaDto {
    name: string;
    isActive: boolean;
    scales: CreateOrEditHealthcareFormulaScaleDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditHealthcareFormulaScaleDto implements ICreateOrEditHealthcareFormulaScaleDto {
    healthcareFormulaId!: number;
    minScale!: number;
    maxScale!: number;
    color!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareFormulaScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthcareFormulaId = _data["healthcareFormulaId"];
            this.minScale = _data["minScale"];
            this.maxScale = _data["maxScale"];
            this.color = _data["color"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareFormulaScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareFormulaScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthcareFormulaId"] = this.healthcareFormulaId;
        data["minScale"] = this.minScale;
        data["maxScale"] = this.maxScale;
        data["color"] = this.color;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareFormulaScaleDto {
    healthcareFormulaId: number;
    minScale: number;
    maxScale: number;
    color: string | undefined;
    id: number | undefined;
}

export class CreateOrEditHealthcareMomentDto implements ICreateOrEditHealthcareMomentDto {
    moment!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareMomentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moment = _data["moment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareMomentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareMomentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moment"] = this.moment;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareMomentDto {
    moment: string;
    id: number | undefined;
}

export class CreateOrEditHealthcareProductDto implements ICreateOrEditHealthcareProductDto {
    name!: string;
    active!: boolean;
    doses!: CreateOrEditHealthcareProductsDoseDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.active = _data["active"];
            if (Array.isArray(_data["doses"])) {
                this.doses = [] as any;
                for (let item of _data["doses"])
                    this.doses!.push(CreateOrEditHealthcareProductsDoseDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["active"] = this.active;
        if (Array.isArray(this.doses)) {
            data["doses"] = [];
            for (let item of this.doses)
                data["doses"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareProductDto {
    name: string;
    active: boolean;
    doses: CreateOrEditHealthcareProductsDoseDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditHealthcareProductsDoseDto implements ICreateOrEditHealthcareProductsDoseDto {
    healthProductId!: number;
    dose!: number;
    minClassificationDose!: number;
    maxClassificationDose!: number;
    healthcareProductFk!: CreateOrEditHealthcareProductDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareProductsDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProductId = _data["healthProductId"];
            this.dose = _data["dose"];
            this.minClassificationDose = _data["minClassificationDose"];
            this.maxClassificationDose = _data["maxClassificationDose"];
            this.healthcareProductFk = _data["healthcareProductFk"] ? CreateOrEditHealthcareProductDto.fromJS(_data["healthcareProductFk"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareProductsDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareProductsDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProductId"] = this.healthProductId;
        data["dose"] = this.dose;
        data["minClassificationDose"] = this.minClassificationDose;
        data["maxClassificationDose"] = this.maxClassificationDose;
        data["healthcareProductFk"] = this.healthcareProductFk ? this.healthcareProductFk.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareProductsDoseDto {
    healthProductId: number;
    dose: number;
    minClassificationDose: number;
    maxClassificationDose: number;
    healthcareProductFk: CreateOrEditHealthcareProductDto;
    id: number | undefined;
}

export class CreateOrEditHealthcareTechnologyDto implements ICreateOrEditHealthcareTechnologyDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthcareTechnologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthcareTechnologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthcareTechnologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHealthcareTechnologyDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditInterventionFoundationsOneDto implements ICreateOrEditInterventionFoundationsOneDto {
    interventionFoundations!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditInterventionFoundationsOneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInterventionFoundationsOneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditInterventionFoundationsOneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditInterventionFoundationsOneDto {
    interventionFoundations: string;
    id: number | undefined;
}

export class CreateOrEditInterventionFoundationsThreeDto implements ICreateOrEditInterventionFoundationsThreeDto {
    interventionFoundations!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditInterventionFoundationsThreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInterventionFoundationsThreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditInterventionFoundationsThreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditInterventionFoundationsThreeDto {
    interventionFoundations: string;
    id: number | undefined;
}

export class CreateOrEditInterventionFoundationsTwoDto implements ICreateOrEditInterventionFoundationsTwoDto {
    interventionFoundations!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditInterventionFoundationsTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInterventionFoundationsTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditInterventionFoundationsTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditInterventionFoundationsTwoDto {
    interventionFoundations: string;
    id: number | undefined;
}

export class CreateOrEditLaboratoryProjectDto implements ICreateOrEditLaboratoryProjectDto {
    name!: string;
    laboratoryProjectTypeId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLaboratoryProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLaboratoryProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLaboratoryProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLaboratoryProjectDto {
    name: string;
    laboratoryProjectTypeId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditLaboratoryProjectStatusDto implements ICreateOrEditLaboratoryProjectStatusDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLaboratoryProjectStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLaboratoryProjectStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLaboratoryProjectStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLaboratoryProjectStatusDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationDto implements ICreateOrEditLevelInfestationDto {
    year!: number;
    periodId!: number;
    periodName!: string;
    regionId!: number;
    regionName!: string;
    zoneId!: number;
    zoneName!: string;
    propertyId!: number;
    propertyName!: string;
    standStatusId!: number;
    standStatusName!: string;
    area!: number;
    levelInfestationNewFieldId!: number | undefined;
    levelInfestationForestationId!: number | undefined;
    levelInfestationReforestationId!: number | undefined;
    levelInfestationTypeStubbleId!: number | undefined;
    levelInfestationPreviousForestDensityId!: number | undefined;
    levelInfestationTupDurationId!: number | undefined;
    levelInfestationTypeSoilId!: number;
    observations!: string | undefined;
    relieve!: boolean;
    vegetationUnderIds!: number[] | undefined;
    enviromentConditionIds!: number[] | undefined;
    anthillIds!: number[] | undefined;
    neighborsIds!: number[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.zoneId = _data["zoneId"];
            this.zoneName = _data["zoneName"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.standStatusId = _data["standStatusId"];
            this.standStatusName = _data["standStatusName"];
            this.area = _data["area"];
            this.levelInfestationNewFieldId = _data["levelInfestationNewFieldId"];
            this.levelInfestationForestationId = _data["levelInfestationForestationId"];
            this.levelInfestationReforestationId = _data["levelInfestationReforestationId"];
            this.levelInfestationTypeStubbleId = _data["levelInfestationTypeStubbleId"];
            this.levelInfestationPreviousForestDensityId = _data["levelInfestationPreviousForestDensityId"];
            this.levelInfestationTupDurationId = _data["levelInfestationTupDurationId"];
            this.levelInfestationTypeSoilId = _data["levelInfestationTypeSoilId"];
            this.observations = _data["observations"];
            this.relieve = _data["relieve"];
            if (Array.isArray(_data["vegetationUnderIds"])) {
                this.vegetationUnderIds = [] as any;
                for (let item of _data["vegetationUnderIds"])
                    this.vegetationUnderIds!.push(item);
            }
            if (Array.isArray(_data["enviromentConditionIds"])) {
                this.enviromentConditionIds = [] as any;
                for (let item of _data["enviromentConditionIds"])
                    this.enviromentConditionIds!.push(item);
            }
            if (Array.isArray(_data["anthillIds"])) {
                this.anthillIds = [] as any;
                for (let item of _data["anthillIds"])
                    this.anthillIds!.push(item);
            }
            if (Array.isArray(_data["neighborsIds"])) {
                this.neighborsIds = [] as any;
                for (let item of _data["neighborsIds"])
                    this.neighborsIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["zoneId"] = this.zoneId;
        data["zoneName"] = this.zoneName;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["standStatusId"] = this.standStatusId;
        data["standStatusName"] = this.standStatusName;
        data["area"] = this.area;
        data["levelInfestationNewFieldId"] = this.levelInfestationNewFieldId;
        data["levelInfestationForestationId"] = this.levelInfestationForestationId;
        data["levelInfestationReforestationId"] = this.levelInfestationReforestationId;
        data["levelInfestationTypeStubbleId"] = this.levelInfestationTypeStubbleId;
        data["levelInfestationPreviousForestDensityId"] = this.levelInfestationPreviousForestDensityId;
        data["levelInfestationTupDurationId"] = this.levelInfestationTupDurationId;
        data["levelInfestationTypeSoilId"] = this.levelInfestationTypeSoilId;
        data["observations"] = this.observations;
        data["relieve"] = this.relieve;
        if (Array.isArray(this.vegetationUnderIds)) {
            data["vegetationUnderIds"] = [];
            for (let item of this.vegetationUnderIds)
                data["vegetationUnderIds"].push(item);
        }
        if (Array.isArray(this.enviromentConditionIds)) {
            data["enviromentConditionIds"] = [];
            for (let item of this.enviromentConditionIds)
                data["enviromentConditionIds"].push(item);
        }
        if (Array.isArray(this.anthillIds)) {
            data["anthillIds"] = [];
            for (let item of this.anthillIds)
                data["anthillIds"].push(item);
        }
        if (Array.isArray(this.neighborsIds)) {
            data["neighborsIds"] = [];
            for (let item of this.neighborsIds)
                data["neighborsIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationDto {
    year: number;
    periodId: number;
    periodName: string;
    regionId: number;
    regionName: string;
    zoneId: number;
    zoneName: string;
    propertyId: number;
    propertyName: string;
    standStatusId: number;
    standStatusName: string;
    area: number;
    levelInfestationNewFieldId: number | undefined;
    levelInfestationForestationId: number | undefined;
    levelInfestationReforestationId: number | undefined;
    levelInfestationTypeStubbleId: number | undefined;
    levelInfestationPreviousForestDensityId: number | undefined;
    levelInfestationTupDurationId: number | undefined;
    levelInfestationTypeSoilId: number;
    observations: string | undefined;
    relieve: boolean;
    vegetationUnderIds: number[] | undefined;
    enviromentConditionIds: number[] | undefined;
    anthillIds: number[] | undefined;
    neighborsIds: number[] | undefined;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationForestationDto implements ICreateOrEditLevelInfestationForestationDto {
    forestation!: string;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationForestationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forestation = _data["forestation"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationForestationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationForestationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forestation"] = this.forestation;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationForestationDto {
    forestation: string;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationNewFieldDto implements ICreateOrEditLevelInfestationNewFieldDto {
    field!: string;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationNewFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationNewFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationNewFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationNewFieldDto {
    field: string;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationPreviousForestDensityDto implements ICreateOrEditLevelInfestationPreviousForestDensityDto {
    optionDensity!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationPreviousForestDensityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionDensity = _data["optionDensity"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationPreviousForestDensityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationPreviousForestDensityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionDensity"] = this.optionDensity;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationPreviousForestDensityDto {
    optionDensity: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationReforestationDto implements ICreateOrEditLevelInfestationReforestationDto {
    reforestation!: string;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationReforestationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reforestation = _data["reforestation"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationReforestationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationReforestationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reforestation"] = this.reforestation;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationReforestationDto {
    reforestation: string;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationTupDurationDto implements ICreateOrEditLevelInfestationTupDurationDto {
    tup!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationTupDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tup = _data["tup"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationTupDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationTupDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tup"] = this.tup;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationTupDurationDto {
    tup: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationTypeSoilDto implements ICreateOrEditLevelInfestationTypeSoilDto {
    type!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationTypeSoilDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationTypeSoilDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationTypeSoilDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationTypeSoilDto {
    type: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationTypeStubbleDto implements ICreateOrEditLevelInfestationTypeStubbleDto {
    type!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationTypeStubbleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationTypeStubbleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationTypeStubbleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationTypeStubbleDto {
    type: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditLevelInfestationVegetationUnderDto implements ICreateOrEditLevelInfestationVegetationUnderDto {
    vegetation!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLevelInfestationVegetationUnderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vegetation = _data["vegetation"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLevelInfestationVegetationUnderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLevelInfestationVegetationUnderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vegetation"] = this.vegetation;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLevelInfestationVegetationUnderDto {
    vegetation: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditMeasurementPlaningDto implements ICreateOrEditMeasurementPlaningDto {
    assignmentName!: string;
    status!: EnumMeasurementPlaningStatus;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementPlaningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentName = _data["assignmentName"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementPlaningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementPlaningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentName"] = this.assignmentName;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementPlaningDto {
    assignmentName: string;
    status: EnumMeasurementPlaningStatus;
    id: number | undefined;
}

export class CreateOrEditMeasurementPlaningOptionsDto implements ICreateOrEditMeasurementPlaningOptionsDto {
    dapRequired!: boolean;
    heightRequired!: boolean;
    adultObservationCodeRequired!: boolean;
    adultObservationHeightRequired!: boolean;
    frostToleranceCodeRequired!: boolean;
    pestsAndDiseasesCodeRequired!: boolean;
    partialMeasurement!: boolean;
    partialHeight!: boolean;
    standName!: string | undefined;
    trialNumber!: string | undefined;
    trialAge!: number;
    region!: string | undefined;
    trialType!: string | undefined;
    farmName!: string | undefined;
    status!: EnumMeasurementPlaningStatus;
    assignmentName!: string;
    measurementPlaningId!: number | undefined;
    trialId!: number | undefined;
    treatmentList!: GetAllMeasurementPlaningOptionsTreatmentDto[] | undefined;
    partialTreeList!: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;
    partialHeihtTreeList!: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementPlaningOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dapRequired = _data["dapRequired"];
            this.heightRequired = _data["heightRequired"];
            this.adultObservationCodeRequired = _data["adultObservationCodeRequired"];
            this.adultObservationHeightRequired = _data["adultObservationHeightRequired"];
            this.frostToleranceCodeRequired = _data["frostToleranceCodeRequired"];
            this.pestsAndDiseasesCodeRequired = _data["pestsAndDiseasesCodeRequired"];
            this.partialMeasurement = _data["partialMeasurement"];
            this.partialHeight = _data["partialHeight"];
            this.standName = _data["standName"];
            this.trialNumber = _data["trialNumber"];
            this.trialAge = _data["trialAge"];
            this.region = _data["region"];
            this.trialType = _data["trialType"];
            this.farmName = _data["farmName"];
            this.status = _data["status"];
            this.assignmentName = _data["assignmentName"];
            this.measurementPlaningId = _data["measurementPlaningId"];
            this.trialId = _data["trialId"];
            if (Array.isArray(_data["treatmentList"])) {
                this.treatmentList = [] as any;
                for (let item of _data["treatmentList"])
                    this.treatmentList!.push(GetAllMeasurementPlaningOptionsTreatmentDto.fromJS(item));
            }
            if (Array.isArray(_data["partialTreeList"])) {
                this.partialTreeList = [] as any;
                for (let item of _data["partialTreeList"])
                    this.partialTreeList!.push(GetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["partialHeihtTreeList"])) {
                this.partialHeihtTreeList = [] as any;
                for (let item of _data["partialHeihtTreeList"])
                    this.partialHeihtTreeList!.push(GetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementPlaningOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementPlaningOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dapRequired"] = this.dapRequired;
        data["heightRequired"] = this.heightRequired;
        data["adultObservationCodeRequired"] = this.adultObservationCodeRequired;
        data["adultObservationHeightRequired"] = this.adultObservationHeightRequired;
        data["frostToleranceCodeRequired"] = this.frostToleranceCodeRequired;
        data["pestsAndDiseasesCodeRequired"] = this.pestsAndDiseasesCodeRequired;
        data["partialMeasurement"] = this.partialMeasurement;
        data["partialHeight"] = this.partialHeight;
        data["standName"] = this.standName;
        data["trialNumber"] = this.trialNumber;
        data["trialAge"] = this.trialAge;
        data["region"] = this.region;
        data["trialType"] = this.trialType;
        data["farmName"] = this.farmName;
        data["status"] = this.status;
        data["assignmentName"] = this.assignmentName;
        data["measurementPlaningId"] = this.measurementPlaningId;
        data["trialId"] = this.trialId;
        if (Array.isArray(this.treatmentList)) {
            data["treatmentList"] = [];
            for (let item of this.treatmentList)
                data["treatmentList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partialTreeList)) {
            data["partialTreeList"] = [];
            for (let item of this.partialTreeList)
                data["partialTreeList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partialHeihtTreeList)) {
            data["partialHeihtTreeList"] = [];
            for (let item of this.partialHeihtTreeList)
                data["partialHeihtTreeList"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementPlaningOptionsDto {
    dapRequired: boolean;
    heightRequired: boolean;
    adultObservationCodeRequired: boolean;
    adultObservationHeightRequired: boolean;
    frostToleranceCodeRequired: boolean;
    pestsAndDiseasesCodeRequired: boolean;
    partialMeasurement: boolean;
    partialHeight: boolean;
    standName: string | undefined;
    trialNumber: string | undefined;
    trialAge: number;
    region: string | undefined;
    trialType: string | undefined;
    farmName: string | undefined;
    status: EnumMeasurementPlaningStatus;
    assignmentName: string;
    measurementPlaningId: number | undefined;
    trialId: number | undefined;
    treatmentList: GetAllMeasurementPlaningOptionsTreatmentDto[] | undefined;
    partialTreeList: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;
    partialHeihtTreeList: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementPlaningTreatmentDto implements ICreateOrEditMeasurementPlaningTreatmentDto {
    treatmentId!: number | undefined;
    measurementPlaningOptionsId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementPlaningTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentId = _data["treatmentId"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementPlaningTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementPlaningTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentId"] = this.treatmentId;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementPlaningTreatmentDto {
    treatmentId: number | undefined;
    measurementPlaningOptionsId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementPlaningTreeHeightNumberDto implements ICreateOrEditMeasurementPlaningTreeHeightNumberDto {
    treeNumber!: number;
    measurementPlaningOptionsId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementPlaningTreeHeightNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementPlaningTreeHeightNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementPlaningTreeHeightNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementPlaningTreeHeightNumberDto {
    treeNumber: number;
    measurementPlaningOptionsId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementPlaningTreeNumberDto implements ICreateOrEditMeasurementPlaningTreeNumberDto {
    treeNumber!: number;
    measurementPlaningOptionsId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementPlaningTreeNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementPlaningTreeNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementPlaningTreeNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementPlaningTreeNumberDto {
    treeNumber: number;
    measurementPlaningOptionsId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementSelectionDto implements ICreateOrEditMeasurementSelectionDto {
    bV_Vol!: number | undefined;
    stageOneSelection!: boolean;
    stageTwoSelection!: boolean;
    treeIdName!: string;
    nirCode!: string | undefined;
    dB_Model_Kg_m3!: number | undefined;
    pilodyn!: number | undefined;
    rP_Model_Percentage!: number | undefined;
    rP_Model_Disco_Percentage!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    dB_10!: number | undefined;
    observations!: string | undefined;
    destination!: string | undefined;
    numberT!: string | undefined;
    maxRootingPercentage!: number | undefined;
    numberX!: string | undefined;
    treeId!: number;
    woodSampleStageOneTypeId!: number | undefined;
    woodSampleStageTwoTypeId!: number | undefined;
    projectId!: number;
    laboratoryId!: string | undefined;
    subProyecto!: string | undefined;
    year!: number | undefined;
    samplingDate!: DateTime | undefined;
    treeAgeSamplingDate!: number | undefined;
    bV_DB_model!: number | undefined;
    bV_RP_model!: number | undefined;
    nirCodeSawdust!: string | undefined;
    observationsDisco!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bV_Vol = _data["bV_Vol"];
            this.stageOneSelection = _data["stageOneSelection"];
            this.stageTwoSelection = _data["stageTwoSelection"];
            this.treeIdName = _data["treeIdName"];
            this.nirCode = _data["nirCode"];
            this.dB_Model_Kg_m3 = _data["dB_Model_Kg_m3"];
            this.pilodyn = _data["pilodyn"];
            this.rP_Model_Percentage = _data["rP_Model_Percentage"];
            this.rP_Model_Disco_Percentage = _data["rP_Model_Disco_Percentage"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.dB_10 = _data["dB_10"];
            this.observations = _data["observations"];
            this.destination = _data["destination"];
            this.numberT = _data["numberT"];
            this.maxRootingPercentage = _data["maxRootingPercentage"];
            this.numberX = _data["numberX"];
            this.treeId = _data["treeId"];
            this.woodSampleStageOneTypeId = _data["woodSampleStageOneTypeId"];
            this.woodSampleStageTwoTypeId = _data["woodSampleStageTwoTypeId"];
            this.projectId = _data["projectId"];
            this.laboratoryId = _data["laboratoryId"];
            this.subProyecto = _data["subProyecto"];
            this.year = _data["year"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.treeAgeSamplingDate = _data["treeAgeSamplingDate"];
            this.bV_DB_model = _data["bV_DB_model"];
            this.bV_RP_model = _data["bV_RP_model"];
            this.nirCodeSawdust = _data["nirCodeSawdust"];
            this.observationsDisco = _data["observationsDisco"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bV_Vol"] = this.bV_Vol;
        data["stageOneSelection"] = this.stageOneSelection;
        data["stageTwoSelection"] = this.stageTwoSelection;
        data["treeIdName"] = this.treeIdName;
        data["nirCode"] = this.nirCode;
        data["dB_Model_Kg_m3"] = this.dB_Model_Kg_m3;
        data["pilodyn"] = this.pilodyn;
        data["rP_Model_Percentage"] = this.rP_Model_Percentage;
        data["rP_Model_Disco_Percentage"] = this.rP_Model_Disco_Percentage;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["dB_10"] = this.dB_10;
        data["observations"] = this.observations;
        data["destination"] = this.destination;
        data["numberT"] = this.numberT;
        data["maxRootingPercentage"] = this.maxRootingPercentage;
        data["numberX"] = this.numberX;
        data["treeId"] = this.treeId;
        data["woodSampleStageOneTypeId"] = this.woodSampleStageOneTypeId;
        data["woodSampleStageTwoTypeId"] = this.woodSampleStageTwoTypeId;
        data["projectId"] = this.projectId;
        data["laboratoryId"] = this.laboratoryId;
        data["subProyecto"] = this.subProyecto;
        data["year"] = this.year;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["treeAgeSamplingDate"] = this.treeAgeSamplingDate;
        data["bV_DB_model"] = this.bV_DB_model;
        data["bV_RP_model"] = this.bV_RP_model;
        data["nirCodeSawdust"] = this.nirCodeSawdust;
        data["observationsDisco"] = this.observationsDisco;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementSelectionDto {
    bV_Vol: number | undefined;
    stageOneSelection: boolean;
    stageTwoSelection: boolean;
    treeIdName: string;
    nirCode: string | undefined;
    dB_Model_Kg_m3: number | undefined;
    pilodyn: number | undefined;
    rP_Model_Percentage: number | undefined;
    rP_Model_Disco_Percentage: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    dB_10: number | undefined;
    observations: string | undefined;
    destination: string | undefined;
    numberT: string | undefined;
    maxRootingPercentage: number | undefined;
    numberX: string | undefined;
    treeId: number;
    woodSampleStageOneTypeId: number | undefined;
    woodSampleStageTwoTypeId: number | undefined;
    projectId: number;
    laboratoryId: string | undefined;
    subProyecto: string | undefined;
    year: number | undefined;
    samplingDate: DateTime | undefined;
    treeAgeSamplingDate: number | undefined;
    bV_DB_model: number | undefined;
    bV_RP_model: number | undefined;
    nirCodeSawdust: string | undefined;
    observationsDisco: string | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementSelectionGenomicDto implements ICreateOrEditMeasurementSelectionGenomicDto {
    bbt!: string | undefined;
    rootingPercentage!: number | undefined;
    bbx!: string | undefined;
    observations!: string | undefined;
    bbT_Destination!: string | undefined;
    bbX_Destination!: string | undefined;
    bluP_Vol!: number;
    err_Blup_Vol!: number;
    acc_Blup_Vol!: number;
    model_Blup_Vol!: number;
    gblup_Vol!: number;
    err_Gblup_VOL!: number;
    acc_Gblup_Vol!: number;
    model_Gblup_Vol!: number;
    hblup_Vol!: number;
    err_Hblup_Vol!: number;
    acc_Hblup_Vol!: number;
    model_Hblup_Vol!: number;
    blup_Rp!: number;
    err_Blup_Rp!: number;
    acc_Blup_Rp!: number;
    model_Blup_Rp!: number;
    gblup_Rp!: number;
    err_Gblup_Rp!: number;
    acc_Gblup_Rp!: number;
    model_Gblup_Rp!: number;
    hblup_Rp!: number;
    err_Hblup_Rp!: number;
    acc_Hblup_Rp!: number;
    model_Hblup_Rp!: number;
    blup_Db!: number;
    err_Blup_Db!: number;
    acc_Blup_Db!: number;
    model_Blup_Db!: number;
    gblup_Db!: number;
    err_Gblup_Db!: number;
    acc_Gblup_Db!: number;
    model_Gblup_Db!: number;
    hblup_Db!: number;
    err_Hblup_Db!: number;
    acc_Hblup_Db!: number;
    model_Hblup_Db!: number;
    seedlingId!: number | undefined;
    projectId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementSelectionGenomicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbt = _data["bbt"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.bbx = _data["bbx"];
            this.observations = _data["observations"];
            this.bbT_Destination = _data["bbT_Destination"];
            this.bbX_Destination = _data["bbX_Destination"];
            this.bluP_Vol = _data["bluP_Vol"];
            this.err_Blup_Vol = _data["err_Blup_Vol"];
            this.acc_Blup_Vol = _data["acc_Blup_Vol"];
            this.model_Blup_Vol = _data["model_Blup_Vol"];
            this.gblup_Vol = _data["gblup_Vol"];
            this.err_Gblup_VOL = _data["err_Gblup_VOL"];
            this.acc_Gblup_Vol = _data["acc_Gblup_Vol"];
            this.model_Gblup_Vol = _data["model_Gblup_Vol"];
            this.hblup_Vol = _data["hblup_Vol"];
            this.err_Hblup_Vol = _data["err_Hblup_Vol"];
            this.acc_Hblup_Vol = _data["acc_Hblup_Vol"];
            this.model_Hblup_Vol = _data["model_Hblup_Vol"];
            this.blup_Rp = _data["blup_Rp"];
            this.err_Blup_Rp = _data["err_Blup_Rp"];
            this.acc_Blup_Rp = _data["acc_Blup_Rp"];
            this.model_Blup_Rp = _data["model_Blup_Rp"];
            this.gblup_Rp = _data["gblup_Rp"];
            this.err_Gblup_Rp = _data["err_Gblup_Rp"];
            this.acc_Gblup_Rp = _data["acc_Gblup_Rp"];
            this.model_Gblup_Rp = _data["model_Gblup_Rp"];
            this.hblup_Rp = _data["hblup_Rp"];
            this.err_Hblup_Rp = _data["err_Hblup_Rp"];
            this.acc_Hblup_Rp = _data["acc_Hblup_Rp"];
            this.model_Hblup_Rp = _data["model_Hblup_Rp"];
            this.blup_Db = _data["blup_Db"];
            this.err_Blup_Db = _data["err_Blup_Db"];
            this.acc_Blup_Db = _data["acc_Blup_Db"];
            this.model_Blup_Db = _data["model_Blup_Db"];
            this.gblup_Db = _data["gblup_Db"];
            this.err_Gblup_Db = _data["err_Gblup_Db"];
            this.acc_Gblup_Db = _data["acc_Gblup_Db"];
            this.model_Gblup_Db = _data["model_Gblup_Db"];
            this.hblup_Db = _data["hblup_Db"];
            this.err_Hblup_Db = _data["err_Hblup_Db"];
            this.acc_Hblup_Db = _data["acc_Hblup_Db"];
            this.model_Hblup_Db = _data["model_Hblup_Db"];
            this.seedlingId = _data["seedlingId"];
            this.projectId = _data["projectId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementSelectionGenomicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementSelectionGenomicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbt"] = this.bbt;
        data["rootingPercentage"] = this.rootingPercentage;
        data["bbx"] = this.bbx;
        data["observations"] = this.observations;
        data["bbT_Destination"] = this.bbT_Destination;
        data["bbX_Destination"] = this.bbX_Destination;
        data["bluP_Vol"] = this.bluP_Vol;
        data["err_Blup_Vol"] = this.err_Blup_Vol;
        data["acc_Blup_Vol"] = this.acc_Blup_Vol;
        data["model_Blup_Vol"] = this.model_Blup_Vol;
        data["gblup_Vol"] = this.gblup_Vol;
        data["err_Gblup_VOL"] = this.err_Gblup_VOL;
        data["acc_Gblup_Vol"] = this.acc_Gblup_Vol;
        data["model_Gblup_Vol"] = this.model_Gblup_Vol;
        data["hblup_Vol"] = this.hblup_Vol;
        data["err_Hblup_Vol"] = this.err_Hblup_Vol;
        data["acc_Hblup_Vol"] = this.acc_Hblup_Vol;
        data["model_Hblup_Vol"] = this.model_Hblup_Vol;
        data["blup_Rp"] = this.blup_Rp;
        data["err_Blup_Rp"] = this.err_Blup_Rp;
        data["acc_Blup_Rp"] = this.acc_Blup_Rp;
        data["model_Blup_Rp"] = this.model_Blup_Rp;
        data["gblup_Rp"] = this.gblup_Rp;
        data["err_Gblup_Rp"] = this.err_Gblup_Rp;
        data["acc_Gblup_Rp"] = this.acc_Gblup_Rp;
        data["model_Gblup_Rp"] = this.model_Gblup_Rp;
        data["hblup_Rp"] = this.hblup_Rp;
        data["err_Hblup_Rp"] = this.err_Hblup_Rp;
        data["acc_Hblup_Rp"] = this.acc_Hblup_Rp;
        data["model_Hblup_Rp"] = this.model_Hblup_Rp;
        data["blup_Db"] = this.blup_Db;
        data["err_Blup_Db"] = this.err_Blup_Db;
        data["acc_Blup_Db"] = this.acc_Blup_Db;
        data["model_Blup_Db"] = this.model_Blup_Db;
        data["gblup_Db"] = this.gblup_Db;
        data["err_Gblup_Db"] = this.err_Gblup_Db;
        data["acc_Gblup_Db"] = this.acc_Gblup_Db;
        data["model_Gblup_Db"] = this.model_Gblup_Db;
        data["hblup_Db"] = this.hblup_Db;
        data["err_Hblup_Db"] = this.err_Hblup_Db;
        data["acc_Hblup_Db"] = this.acc_Hblup_Db;
        data["model_Hblup_Db"] = this.model_Hblup_Db;
        data["seedlingId"] = this.seedlingId;
        data["projectId"] = this.projectId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementSelectionGenomicDto {
    bbt: string | undefined;
    rootingPercentage: number | undefined;
    bbx: string | undefined;
    observations: string | undefined;
    bbT_Destination: string | undefined;
    bbX_Destination: string | undefined;
    bluP_Vol: number;
    err_Blup_Vol: number;
    acc_Blup_Vol: number;
    model_Blup_Vol: number;
    gblup_Vol: number;
    err_Gblup_VOL: number;
    acc_Gblup_Vol: number;
    model_Gblup_Vol: number;
    hblup_Vol: number;
    err_Hblup_Vol: number;
    acc_Hblup_Vol: number;
    model_Hblup_Vol: number;
    blup_Rp: number;
    err_Blup_Rp: number;
    acc_Blup_Rp: number;
    model_Blup_Rp: number;
    gblup_Rp: number;
    err_Gblup_Rp: number;
    acc_Gblup_Rp: number;
    model_Gblup_Rp: number;
    hblup_Rp: number;
    err_Hblup_Rp: number;
    acc_Hblup_Rp: number;
    model_Hblup_Rp: number;
    blup_Db: number;
    err_Blup_Db: number;
    acc_Blup_Db: number;
    model_Blup_Db: number;
    gblup_Db: number;
    err_Gblup_Db: number;
    acc_Gblup_Db: number;
    model_Gblup_Db: number;
    hblup_Db: number;
    err_Hblup_Db: number;
    acc_Hblup_Db: number;
    model_Hblup_Db: number;
    seedlingId: number | undefined;
    projectId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditMeasurementSelectionOtherProjectDto implements ICreateOrEditMeasurementSelectionOtherProjectDto {
    proyecto!: string;
    subProyecto!: string;
    ano!: string | undefined;
    iD_Muestra!: string | undefined;
    n_muestra!: string | undefined;
    codigo_NIR!: string | undefined;
    material!: string | undefined;
    tipo_material!: string | undefined;
    zona_muestra!: string | undefined;
    mezcla!: string | undefined;
    calidad_muestra!: string | undefined;
    material_genetico!: string | undefined;
    nLote!: string | undefined;
    nx!: string | undefined;
    especie!: string | undefined;
    fecha_plantacion!: string | undefined;
    fecha_muestreo!: string | undefined;
    fecha_ingreso_lab!: string | undefined;
    fecha_egreso_lab!: string | undefined;
    edad!: string | undefined;
    altura_muestreo!: string | undefined;
    diametro!: string | undefined;
    altura_comercial!: string | undefined;
    altura_total!: string | undefined;
    region!: string | undefined;
    zona!: string | undefined;
    establecimiento!: string | undefined;
    cuadro!: string | undefined;
    coneat!: string | undefined;
    es_de_esnayo!: string | undefined;
    grupo_de_ensayo!: string | undefined;
    ensayo!: string | undefined;
    posicion!: string | undefined;
    bloque!: string | undefined;
    sub_bloque!: string | undefined;
    y!: string | undefined;
    arbol!: string | undefined;
    row!: string | undefined;
    col!: string | undefined;
    id_arbol!: string | undefined;
    id_Campo!: string | undefined;
    idfosa!: string | undefined;
    iD_Laboratorio_Externo!: string | undefined;
    destino!: string | undefined;
    observaciones_1!: string | undefined;
    observaciones_2!: string | undefined;
    observaciones_3!: string | undefined;
    laboratorio!: string | undefined;
    iD_Archivo!: string | undefined;
    deposito_Muestra_1_Caja_Archivo!: string | undefined;
    cajA_VIAL!: string | undefined;
    posicion_dentro_de_la_caja_de_vial!: string | undefined;
    deposito_Contramuestra!: string | undefined;
    rP_Lab!: string | undefined;
    dB_Lab_Kg_m3!: string | undefined;
    pilodyn_prom_cm!: string | undefined;
    alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood!: string | undefined;
    consumo_madera_m3_Adt!: string | undefined;
    productividad_Adt_ha_anio!: string | undefined;
    ashes!: string | undefined;
    acetone_extractives!: string | undefined;
    asl!: string | undefined;
    ail!: string | undefined;
    total_lignin!: string | undefined;
    arabinose!: string | undefined;
    galactose!: string | undefined;
    glucose!: string | undefined;
    xylose!: string | undefined;
    mannose!: string | undefined;
    cellulose!: string | undefined;
    xylan!: string | undefined;
    glucomannan!: string | undefined;
    others_pollysaccharide!: string | undefined;
    total_pollysaccharide!: string | undefined;
    al_mg_Kg_BS!: string | undefined;
    ba_mg_Kg_BS!: string | undefined;
    ca_mg_Kg_BS!: string | undefined;
    cu_mg_Kg_BS!: string | undefined;
    fe_mg_Kg_BS!: string | undefined;
    k_mg_Kg_BS!: string | undefined;
    mg_mg_Kg_BS!: string | undefined;
    mn_mg_Kg_BS!: string | undefined;
    na_mg_Kg_BS!: string | undefined;
    p_mg_Kg_BS!: string | undefined;
    s_mg_Kg_BS!: string | undefined;
    si_mg_Kg_BS!: string | undefined;
    dmc!: string | undefined;
    quimica_1!: string | undefined;
    quimica_2!: string | undefined;
    quimica_3!: string | undefined;
    quimica_4!: string | undefined;
    clorofila_CCL!: string | undefined;
    clorofila_mg_dm2!: string | undefined;
    clorofila_umd_m2!: string | undefined;
    materia_seca!: string | undefined;
    n_total!: string | undefined;
    p!: string | undefined;
    k!: string | undefined;
    ca!: string | undefined;
    mg!: string | undefined;
    s!: string | undefined;
    cl!: string | undefined;
    na_ppm!: string | undefined;
    he_ppm!: string | undefined;
    mn_ppm!: string | undefined;
    zn_ppm!: string | undefined;
    b_ppm!: string | undefined;
    cu_ppm!: string | undefined;
    al_ppm!: string | undefined;
    mo_ppm!: string | undefined;
    macronutriente_1!: string | undefined;
    macronutriente_2!: string | undefined;
    macronutriente_3!: string | undefined;
    micronutriente_1!: string | undefined;
    micronutriente_2!: string | undefined;
    micronutriente_3!: string | undefined;
    masa_g!: string | undefined;
    pbray_1_ppm_P!: string | undefined;
    m_Organica_pct!: string | undefined;
    c_Organico_pct!: string | undefined;
    gravilla_pct!: string | undefined;
    arcilla_pct!: string | undefined;
    limo_pct!: string | undefined;
    arena_pct!: string | undefined;
    pH_H2O!: string | undefined;
    pH_KCl!: string | undefined;
    cE_mmhos_cm!: string | undefined;
    n_pct!: string | undefined;
    n_NO3_ug_N_g!: string | undefined;
    s_SO4_ppm_S!: string | undefined;
    k_meqK_100g!: string | undefined;
    na_meqNa_100g!: string | undefined;
    mg_meqMg_100g!: string | undefined;
    ca_meqCa_100g!: string | undefined;
    a_tit_meq_100g!: string | undefined;
    ciC_meq_100g!: string | undefined;
    al_Interc_meqAl_100g!: string | undefined;
    fe_mg_kg!: string | undefined;
    cu_mg_kg!: string | undefined;
    mn_mg_kg!: string | undefined;
    zn_mg_kg!: string | undefined;
    pH_KCl_2!: string | undefined;
    boro_mg_kg!: string | undefined;
    citrico_ug_P_g!: string | undefined;
    sat_Bases_pct!: string | undefined;
    datoSuelo_1!: string | undefined;
    datoSuelo_2!: string | undefined;
    datoSuelo_3!: string | undefined;
    projectId!: number | undefined;
    cloneId!: number | undefined;
    seedId!: number | undefined;
    woodSampleTypeId!: number | undefined;
    id_Registro!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeasurementSelectionOtherProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proyecto = _data["proyecto"];
            this.subProyecto = _data["subProyecto"];
            this.ano = _data["ano"];
            this.iD_Muestra = _data["iD_Muestra"];
            this.n_muestra = _data["n_muestra"];
            this.codigo_NIR = _data["codigo_NIR"];
            this.material = _data["material"];
            this.tipo_material = _data["tipo_material"];
            this.zona_muestra = _data["zona_muestra"];
            this.mezcla = _data["mezcla"];
            this.calidad_muestra = _data["calidad_muestra"];
            this.material_genetico = _data["material_genetico"];
            this.nLote = _data["nLote"];
            this.nx = _data["nx"];
            this.especie = _data["especie"];
            this.fecha_plantacion = _data["fecha_plantacion"];
            this.fecha_muestreo = _data["fecha_muestreo"];
            this.fecha_ingreso_lab = _data["fecha_ingreso_lab"];
            this.fecha_egreso_lab = _data["fecha_egreso_lab"];
            this.edad = _data["edad"];
            this.altura_muestreo = _data["altura_muestreo"];
            this.diametro = _data["diametro"];
            this.altura_comercial = _data["altura_comercial"];
            this.altura_total = _data["altura_total"];
            this.region = _data["region"];
            this.zona = _data["zona"];
            this.establecimiento = _data["establecimiento"];
            this.cuadro = _data["cuadro"];
            this.coneat = _data["coneat"];
            this.es_de_esnayo = _data["es_de_esnayo"];
            this.grupo_de_ensayo = _data["grupo_de_ensayo"];
            this.ensayo = _data["ensayo"];
            this.posicion = _data["posicion"];
            this.bloque = _data["bloque"];
            this.sub_bloque = _data["sub_bloque"];
            this.y = _data["y"];
            this.arbol = _data["arbol"];
            this.row = _data["row"];
            this.col = _data["col"];
            this.id_arbol = _data["id_arbol"];
            this.id_Campo = _data["id_Campo"];
            this.idfosa = _data["idfosa"];
            this.iD_Laboratorio_Externo = _data["iD_Laboratorio_Externo"];
            this.destino = _data["destino"];
            this.observaciones_1 = _data["observaciones_1"];
            this.observaciones_2 = _data["observaciones_2"];
            this.observaciones_3 = _data["observaciones_3"];
            this.laboratorio = _data["laboratorio"];
            this.iD_Archivo = _data["iD_Archivo"];
            this.deposito_Muestra_1_Caja_Archivo = _data["deposito_Muestra_1_Caja_Archivo"];
            this.cajA_VIAL = _data["cajA_VIAL"];
            this.posicion_dentro_de_la_caja_de_vial = _data["posicion_dentro_de_la_caja_de_vial"];
            this.deposito_Contramuestra = _data["deposito_Contramuestra"];
            this.rP_Lab = _data["rP_Lab"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.pilodyn_prom_cm = _data["pilodyn_prom_cm"];
            this.alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood = _data["alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood"];
            this.consumo_madera_m3_Adt = _data["consumo_madera_m3_Adt"];
            this.productividad_Adt_ha_anio = _data["productividad_Adt_ha_anio"];
            this.ashes = _data["ashes"];
            this.acetone_extractives = _data["acetone_extractives"];
            this.asl = _data["asl"];
            this.ail = _data["ail"];
            this.total_lignin = _data["total_lignin"];
            this.arabinose = _data["arabinose"];
            this.galactose = _data["galactose"];
            this.glucose = _data["glucose"];
            this.xylose = _data["xylose"];
            this.mannose = _data["mannose"];
            this.cellulose = _data["cellulose"];
            this.xylan = _data["xylan"];
            this.glucomannan = _data["glucomannan"];
            this.others_pollysaccharide = _data["others_pollysaccharide"];
            this.total_pollysaccharide = _data["total_pollysaccharide"];
            this.al_mg_Kg_BS = _data["al_mg_Kg_BS"];
            this.ba_mg_Kg_BS = _data["ba_mg_Kg_BS"];
            this.ca_mg_Kg_BS = _data["ca_mg_Kg_BS"];
            this.cu_mg_Kg_BS = _data["cu_mg_Kg_BS"];
            this.fe_mg_Kg_BS = _data["fe_mg_Kg_BS"];
            this.k_mg_Kg_BS = _data["k_mg_Kg_BS"];
            this.mg_mg_Kg_BS = _data["mg_mg_Kg_BS"];
            this.mn_mg_Kg_BS = _data["mn_mg_Kg_BS"];
            this.na_mg_Kg_BS = _data["na_mg_Kg_BS"];
            this.p_mg_Kg_BS = _data["p_mg_Kg_BS"];
            this.s_mg_Kg_BS = _data["s_mg_Kg_BS"];
            this.si_mg_Kg_BS = _data["si_mg_Kg_BS"];
            this.dmc = _data["dmc"];
            this.quimica_1 = _data["quimica_1"];
            this.quimica_2 = _data["quimica_2"];
            this.quimica_3 = _data["quimica_3"];
            this.quimica_4 = _data["quimica_4"];
            this.clorofila_CCL = _data["clorofila_CCL"];
            this.clorofila_mg_dm2 = _data["clorofila_mg_dm2"];
            this.clorofila_umd_m2 = _data["clorofila_umd_m2"];
            this.materia_seca = _data["materia_seca"];
            this.n_total = _data["n_total"];
            this.p = _data["p"];
            this.k = _data["k"];
            this.ca = _data["ca"];
            this.mg = _data["mg"];
            this.s = _data["s"];
            this.cl = _data["cl"];
            this.na_ppm = _data["na_ppm"];
            this.he_ppm = _data["he_ppm"];
            this.mn_ppm = _data["mn_ppm"];
            this.zn_ppm = _data["zn_ppm"];
            this.b_ppm = _data["b_ppm"];
            this.cu_ppm = _data["cu_ppm"];
            this.al_ppm = _data["al_ppm"];
            this.mo_ppm = _data["mo_ppm"];
            this.macronutriente_1 = _data["macronutriente_1"];
            this.macronutriente_2 = _data["macronutriente_2"];
            this.macronutriente_3 = _data["macronutriente_3"];
            this.micronutriente_1 = _data["micronutriente_1"];
            this.micronutriente_2 = _data["micronutriente_2"];
            this.micronutriente_3 = _data["micronutriente_3"];
            this.masa_g = _data["masa_g"];
            this.pbray_1_ppm_P = _data["pbray_1_ppm_P"];
            this.m_Organica_pct = _data["m_Organica_pct"];
            this.c_Organico_pct = _data["c_Organico_pct"];
            this.gravilla_pct = _data["gravilla_pct"];
            this.arcilla_pct = _data["arcilla_pct"];
            this.limo_pct = _data["limo_pct"];
            this.arena_pct = _data["arena_pct"];
            this.pH_H2O = _data["pH_H2O"];
            this.pH_KCl = _data["pH_KCl"];
            this.cE_mmhos_cm = _data["cE_mmhos_cm"];
            this.n_pct = _data["n_pct"];
            this.n_NO3_ug_N_g = _data["n_NO3_ug_N_g"];
            this.s_SO4_ppm_S = _data["s_SO4_ppm_S"];
            this.k_meqK_100g = _data["k_meqK_100g"];
            this.na_meqNa_100g = _data["na_meqNa_100g"];
            this.mg_meqMg_100g = _data["mg_meqMg_100g"];
            this.ca_meqCa_100g = _data["ca_meqCa_100g"];
            this.a_tit_meq_100g = _data["a_tit_meq_100g"];
            this.ciC_meq_100g = _data["ciC_meq_100g"];
            this.al_Interc_meqAl_100g = _data["al_Interc_meqAl_100g"];
            this.fe_mg_kg = _data["fe_mg_kg"];
            this.cu_mg_kg = _data["cu_mg_kg"];
            this.mn_mg_kg = _data["mn_mg_kg"];
            this.zn_mg_kg = _data["zn_mg_kg"];
            this.pH_KCl_2 = _data["pH_KCl_2"];
            this.boro_mg_kg = _data["boro_mg_kg"];
            this.citrico_ug_P_g = _data["citrico_ug_P_g"];
            this.sat_Bases_pct = _data["sat_Bases_pct"];
            this.datoSuelo_1 = _data["datoSuelo_1"];
            this.datoSuelo_2 = _data["datoSuelo_2"];
            this.datoSuelo_3 = _data["datoSuelo_3"];
            this.projectId = _data["projectId"];
            this.cloneId = _data["cloneId"];
            this.seedId = _data["seedId"];
            this.woodSampleTypeId = _data["woodSampleTypeId"];
            this.id_Registro = _data["id_Registro"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeasurementSelectionOtherProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeasurementSelectionOtherProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proyecto"] = this.proyecto;
        data["subProyecto"] = this.subProyecto;
        data["ano"] = this.ano;
        data["iD_Muestra"] = this.iD_Muestra;
        data["n_muestra"] = this.n_muestra;
        data["codigo_NIR"] = this.codigo_NIR;
        data["material"] = this.material;
        data["tipo_material"] = this.tipo_material;
        data["zona_muestra"] = this.zona_muestra;
        data["mezcla"] = this.mezcla;
        data["calidad_muestra"] = this.calidad_muestra;
        data["material_genetico"] = this.material_genetico;
        data["nLote"] = this.nLote;
        data["nx"] = this.nx;
        data["especie"] = this.especie;
        data["fecha_plantacion"] = this.fecha_plantacion;
        data["fecha_muestreo"] = this.fecha_muestreo;
        data["fecha_ingreso_lab"] = this.fecha_ingreso_lab;
        data["fecha_egreso_lab"] = this.fecha_egreso_lab;
        data["edad"] = this.edad;
        data["altura_muestreo"] = this.altura_muestreo;
        data["diametro"] = this.diametro;
        data["altura_comercial"] = this.altura_comercial;
        data["altura_total"] = this.altura_total;
        data["region"] = this.region;
        data["zona"] = this.zona;
        data["establecimiento"] = this.establecimiento;
        data["cuadro"] = this.cuadro;
        data["coneat"] = this.coneat;
        data["es_de_esnayo"] = this.es_de_esnayo;
        data["grupo_de_ensayo"] = this.grupo_de_ensayo;
        data["ensayo"] = this.ensayo;
        data["posicion"] = this.posicion;
        data["bloque"] = this.bloque;
        data["sub_bloque"] = this.sub_bloque;
        data["y"] = this.y;
        data["arbol"] = this.arbol;
        data["row"] = this.row;
        data["col"] = this.col;
        data["id_arbol"] = this.id_arbol;
        data["id_Campo"] = this.id_Campo;
        data["idfosa"] = this.idfosa;
        data["iD_Laboratorio_Externo"] = this.iD_Laboratorio_Externo;
        data["destino"] = this.destino;
        data["observaciones_1"] = this.observaciones_1;
        data["observaciones_2"] = this.observaciones_2;
        data["observaciones_3"] = this.observaciones_3;
        data["laboratorio"] = this.laboratorio;
        data["iD_Archivo"] = this.iD_Archivo;
        data["deposito_Muestra_1_Caja_Archivo"] = this.deposito_Muestra_1_Caja_Archivo;
        data["cajA_VIAL"] = this.cajA_VIAL;
        data["posicion_dentro_de_la_caja_de_vial"] = this.posicion_dentro_de_la_caja_de_vial;
        data["deposito_Contramuestra"] = this.deposito_Contramuestra;
        data["rP_Lab"] = this.rP_Lab;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["pilodyn_prom_cm"] = this.pilodyn_prom_cm;
        data["alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood"] = this.alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood;
        data["consumo_madera_m3_Adt"] = this.consumo_madera_m3_Adt;
        data["productividad_Adt_ha_anio"] = this.productividad_Adt_ha_anio;
        data["ashes"] = this.ashes;
        data["acetone_extractives"] = this.acetone_extractives;
        data["asl"] = this.asl;
        data["ail"] = this.ail;
        data["total_lignin"] = this.total_lignin;
        data["arabinose"] = this.arabinose;
        data["galactose"] = this.galactose;
        data["glucose"] = this.glucose;
        data["xylose"] = this.xylose;
        data["mannose"] = this.mannose;
        data["cellulose"] = this.cellulose;
        data["xylan"] = this.xylan;
        data["glucomannan"] = this.glucomannan;
        data["others_pollysaccharide"] = this.others_pollysaccharide;
        data["total_pollysaccharide"] = this.total_pollysaccharide;
        data["al_mg_Kg_BS"] = this.al_mg_Kg_BS;
        data["ba_mg_Kg_BS"] = this.ba_mg_Kg_BS;
        data["ca_mg_Kg_BS"] = this.ca_mg_Kg_BS;
        data["cu_mg_Kg_BS"] = this.cu_mg_Kg_BS;
        data["fe_mg_Kg_BS"] = this.fe_mg_Kg_BS;
        data["k_mg_Kg_BS"] = this.k_mg_Kg_BS;
        data["mg_mg_Kg_BS"] = this.mg_mg_Kg_BS;
        data["mn_mg_Kg_BS"] = this.mn_mg_Kg_BS;
        data["na_mg_Kg_BS"] = this.na_mg_Kg_BS;
        data["p_mg_Kg_BS"] = this.p_mg_Kg_BS;
        data["s_mg_Kg_BS"] = this.s_mg_Kg_BS;
        data["si_mg_Kg_BS"] = this.si_mg_Kg_BS;
        data["dmc"] = this.dmc;
        data["quimica_1"] = this.quimica_1;
        data["quimica_2"] = this.quimica_2;
        data["quimica_3"] = this.quimica_3;
        data["quimica_4"] = this.quimica_4;
        data["clorofila_CCL"] = this.clorofila_CCL;
        data["clorofila_mg_dm2"] = this.clorofila_mg_dm2;
        data["clorofila_umd_m2"] = this.clorofila_umd_m2;
        data["materia_seca"] = this.materia_seca;
        data["n_total"] = this.n_total;
        data["p"] = this.p;
        data["k"] = this.k;
        data["ca"] = this.ca;
        data["mg"] = this.mg;
        data["s"] = this.s;
        data["cl"] = this.cl;
        data["na_ppm"] = this.na_ppm;
        data["he_ppm"] = this.he_ppm;
        data["mn_ppm"] = this.mn_ppm;
        data["zn_ppm"] = this.zn_ppm;
        data["b_ppm"] = this.b_ppm;
        data["cu_ppm"] = this.cu_ppm;
        data["al_ppm"] = this.al_ppm;
        data["mo_ppm"] = this.mo_ppm;
        data["macronutriente_1"] = this.macronutriente_1;
        data["macronutriente_2"] = this.macronutriente_2;
        data["macronutriente_3"] = this.macronutriente_3;
        data["micronutriente_1"] = this.micronutriente_1;
        data["micronutriente_2"] = this.micronutriente_2;
        data["micronutriente_3"] = this.micronutriente_3;
        data["masa_g"] = this.masa_g;
        data["pbray_1_ppm_P"] = this.pbray_1_ppm_P;
        data["m_Organica_pct"] = this.m_Organica_pct;
        data["c_Organico_pct"] = this.c_Organico_pct;
        data["gravilla_pct"] = this.gravilla_pct;
        data["arcilla_pct"] = this.arcilla_pct;
        data["limo_pct"] = this.limo_pct;
        data["arena_pct"] = this.arena_pct;
        data["pH_H2O"] = this.pH_H2O;
        data["pH_KCl"] = this.pH_KCl;
        data["cE_mmhos_cm"] = this.cE_mmhos_cm;
        data["n_pct"] = this.n_pct;
        data["n_NO3_ug_N_g"] = this.n_NO3_ug_N_g;
        data["s_SO4_ppm_S"] = this.s_SO4_ppm_S;
        data["k_meqK_100g"] = this.k_meqK_100g;
        data["na_meqNa_100g"] = this.na_meqNa_100g;
        data["mg_meqMg_100g"] = this.mg_meqMg_100g;
        data["ca_meqCa_100g"] = this.ca_meqCa_100g;
        data["a_tit_meq_100g"] = this.a_tit_meq_100g;
        data["ciC_meq_100g"] = this.ciC_meq_100g;
        data["al_Interc_meqAl_100g"] = this.al_Interc_meqAl_100g;
        data["fe_mg_kg"] = this.fe_mg_kg;
        data["cu_mg_kg"] = this.cu_mg_kg;
        data["mn_mg_kg"] = this.mn_mg_kg;
        data["zn_mg_kg"] = this.zn_mg_kg;
        data["pH_KCl_2"] = this.pH_KCl_2;
        data["boro_mg_kg"] = this.boro_mg_kg;
        data["citrico_ug_P_g"] = this.citrico_ug_P_g;
        data["sat_Bases_pct"] = this.sat_Bases_pct;
        data["datoSuelo_1"] = this.datoSuelo_1;
        data["datoSuelo_2"] = this.datoSuelo_2;
        data["datoSuelo_3"] = this.datoSuelo_3;
        data["projectId"] = this.projectId;
        data["cloneId"] = this.cloneId;
        data["seedId"] = this.seedId;
        data["woodSampleTypeId"] = this.woodSampleTypeId;
        data["id_Registro"] = this.id_Registro;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeasurementSelectionOtherProjectDto {
    proyecto: string;
    subProyecto: string;
    ano: string | undefined;
    iD_Muestra: string | undefined;
    n_muestra: string | undefined;
    codigo_NIR: string | undefined;
    material: string | undefined;
    tipo_material: string | undefined;
    zona_muestra: string | undefined;
    mezcla: string | undefined;
    calidad_muestra: string | undefined;
    material_genetico: string | undefined;
    nLote: string | undefined;
    nx: string | undefined;
    especie: string | undefined;
    fecha_plantacion: string | undefined;
    fecha_muestreo: string | undefined;
    fecha_ingreso_lab: string | undefined;
    fecha_egreso_lab: string | undefined;
    edad: string | undefined;
    altura_muestreo: string | undefined;
    diametro: string | undefined;
    altura_comercial: string | undefined;
    altura_total: string | undefined;
    region: string | undefined;
    zona: string | undefined;
    establecimiento: string | undefined;
    cuadro: string | undefined;
    coneat: string | undefined;
    es_de_esnayo: string | undefined;
    grupo_de_ensayo: string | undefined;
    ensayo: string | undefined;
    posicion: string | undefined;
    bloque: string | undefined;
    sub_bloque: string | undefined;
    y: string | undefined;
    arbol: string | undefined;
    row: string | undefined;
    col: string | undefined;
    id_arbol: string | undefined;
    id_Campo: string | undefined;
    idfosa: string | undefined;
    iD_Laboratorio_Externo: string | undefined;
    destino: string | undefined;
    observaciones_1: string | undefined;
    observaciones_2: string | undefined;
    observaciones_3: string | undefined;
    laboratorio: string | undefined;
    iD_Archivo: string | undefined;
    deposito_Muestra_1_Caja_Archivo: string | undefined;
    cajA_VIAL: string | undefined;
    posicion_dentro_de_la_caja_de_vial: string | undefined;
    deposito_Contramuestra: string | undefined;
    rP_Lab: string | undefined;
    dB_Lab_Kg_m3: string | undefined;
    pilodyn_prom_cm: string | undefined;
    alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood: string | undefined;
    consumo_madera_m3_Adt: string | undefined;
    productividad_Adt_ha_anio: string | undefined;
    ashes: string | undefined;
    acetone_extractives: string | undefined;
    asl: string | undefined;
    ail: string | undefined;
    total_lignin: string | undefined;
    arabinose: string | undefined;
    galactose: string | undefined;
    glucose: string | undefined;
    xylose: string | undefined;
    mannose: string | undefined;
    cellulose: string | undefined;
    xylan: string | undefined;
    glucomannan: string | undefined;
    others_pollysaccharide: string | undefined;
    total_pollysaccharide: string | undefined;
    al_mg_Kg_BS: string | undefined;
    ba_mg_Kg_BS: string | undefined;
    ca_mg_Kg_BS: string | undefined;
    cu_mg_Kg_BS: string | undefined;
    fe_mg_Kg_BS: string | undefined;
    k_mg_Kg_BS: string | undefined;
    mg_mg_Kg_BS: string | undefined;
    mn_mg_Kg_BS: string | undefined;
    na_mg_Kg_BS: string | undefined;
    p_mg_Kg_BS: string | undefined;
    s_mg_Kg_BS: string | undefined;
    si_mg_Kg_BS: string | undefined;
    dmc: string | undefined;
    quimica_1: string | undefined;
    quimica_2: string | undefined;
    quimica_3: string | undefined;
    quimica_4: string | undefined;
    clorofila_CCL: string | undefined;
    clorofila_mg_dm2: string | undefined;
    clorofila_umd_m2: string | undefined;
    materia_seca: string | undefined;
    n_total: string | undefined;
    p: string | undefined;
    k: string | undefined;
    ca: string | undefined;
    mg: string | undefined;
    s: string | undefined;
    cl: string | undefined;
    na_ppm: string | undefined;
    he_ppm: string | undefined;
    mn_ppm: string | undefined;
    zn_ppm: string | undefined;
    b_ppm: string | undefined;
    cu_ppm: string | undefined;
    al_ppm: string | undefined;
    mo_ppm: string | undefined;
    macronutriente_1: string | undefined;
    macronutriente_2: string | undefined;
    macronutriente_3: string | undefined;
    micronutriente_1: string | undefined;
    micronutriente_2: string | undefined;
    micronutriente_3: string | undefined;
    masa_g: string | undefined;
    pbray_1_ppm_P: string | undefined;
    m_Organica_pct: string | undefined;
    c_Organico_pct: string | undefined;
    gravilla_pct: string | undefined;
    arcilla_pct: string | undefined;
    limo_pct: string | undefined;
    arena_pct: string | undefined;
    pH_H2O: string | undefined;
    pH_KCl: string | undefined;
    cE_mmhos_cm: string | undefined;
    n_pct: string | undefined;
    n_NO3_ug_N_g: string | undefined;
    s_SO4_ppm_S: string | undefined;
    k_meqK_100g: string | undefined;
    na_meqNa_100g: string | undefined;
    mg_meqMg_100g: string | undefined;
    ca_meqCa_100g: string | undefined;
    a_tit_meq_100g: string | undefined;
    ciC_meq_100g: string | undefined;
    al_Interc_meqAl_100g: string | undefined;
    fe_mg_kg: string | undefined;
    cu_mg_kg: string | undefined;
    mn_mg_kg: string | undefined;
    zn_mg_kg: string | undefined;
    pH_KCl_2: string | undefined;
    boro_mg_kg: string | undefined;
    citrico_ug_P_g: string | undefined;
    sat_Bases_pct: string | undefined;
    datoSuelo_1: string | undefined;
    datoSuelo_2: string | undefined;
    datoSuelo_3: string | undefined;
    projectId: number | undefined;
    cloneId: number | undefined;
    seedId: number | undefined;
    woodSampleTypeId: number | undefined;
    id_Registro: number;
    id: number | undefined;
}

export class CreateOrEditMesurementCloneEvaluationDto implements ICreateOrEditMesurementCloneEvaluationDto {
    bloque!: number | undefined;
    subbloque!: number | undefined;
    year!: number;
    fechaMuestreo!: DateTime;
    fechaPlantacion!: DateTime | undefined;
    edad!: number;
    dB_lab!: number | undefined;
    dB_10!: number | undefined;
    observacion!: string;
    idLab!: string;
    codigo_Nir!: string | undefined;
    dB_Modelo!: number | undefined;
    rP_Modelo!: number | undefined;
    pyrodin!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    lignina_FRB!: number | undefined;
    celulosa_FRB!: number | undefined;
    exT_AC_FRB!: number | undefined;
    consumo_AE!: number | undefined;
    ash!: number | undefined;
    extractives!: number | undefined;
    total_Lignin!: number | undefined;
    celullose!: number | undefined;
    glucomanan!: number | undefined;
    others!: number | undefined;
    ai!: number | undefined;
    ba!: number | undefined;
    ca!: number | undefined;
    cu!: number | undefined;
    fe!: number | undefined;
    k!: number | undefined;
    mg!: number | undefined;
    mn!: number | undefined;
    na!: number | undefined;
    p!: number | undefined;
    s!: number | undefined;
    si!: number | undefined;
    xylan!: number | undefined;
    sub_Proyecto!: string | undefined;
    typeMaterial!: string;
    projectId!: number;
    trialId!: number | undefined;
    treeId!: number | undefined;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    treeStatusId!: number | undefined;
    woodSampleTypeId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMesurementCloneEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bloque = _data["bloque"];
            this.subbloque = _data["subbloque"];
            this.year = _data["year"];
            this.fechaMuestreo = _data["fechaMuestreo"] ? DateTime.fromISO(_data["fechaMuestreo"].toString()) : undefined as any;
            this.fechaPlantacion = _data["fechaPlantacion"] ? DateTime.fromISO(_data["fechaPlantacion"].toString()) : undefined as any;
            this.edad = _data["edad"];
            this.dB_lab = _data["dB_lab"];
            this.dB_10 = _data["dB_10"];
            this.observacion = _data["observacion"];
            this.idLab = _data["idLab"];
            this.codigo_Nir = _data["codigo_Nir"];
            this.dB_Modelo = _data["dB_Modelo"];
            this.rP_Modelo = _data["rP_Modelo"];
            this.pyrodin = _data["pyrodin"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.lignina_FRB = _data["lignina_FRB"];
            this.celulosa_FRB = _data["celulosa_FRB"];
            this.exT_AC_FRB = _data["exT_AC_FRB"];
            this.consumo_AE = _data["consumo_AE"];
            this.ash = _data["ash"];
            this.extractives = _data["extractives"];
            this.total_Lignin = _data["total_Lignin"];
            this.celullose = _data["celullose"];
            this.glucomanan = _data["glucomanan"];
            this.others = _data["others"];
            this.ai = _data["ai"];
            this.ba = _data["ba"];
            this.ca = _data["ca"];
            this.cu = _data["cu"];
            this.fe = _data["fe"];
            this.k = _data["k"];
            this.mg = _data["mg"];
            this.mn = _data["mn"];
            this.na = _data["na"];
            this.p = _data["p"];
            this.s = _data["s"];
            this.si = _data["si"];
            this.xylan = _data["xylan"];
            this.sub_Proyecto = _data["sub_Proyecto"];
            this.typeMaterial = _data["typeMaterial"];
            this.projectId = _data["projectId"];
            this.trialId = _data["trialId"];
            this.treeId = _data["treeId"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.treeStatusId = _data["treeStatusId"];
            this.woodSampleTypeId = _data["woodSampleTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMesurementCloneEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMesurementCloneEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloque"] = this.bloque;
        data["subbloque"] = this.subbloque;
        data["year"] = this.year;
        data["fechaMuestreo"] = this.fechaMuestreo ? this.fechaMuestreo.toString() : undefined as any;
        data["fechaPlantacion"] = this.fechaPlantacion ? this.fechaPlantacion.toString() : undefined as any;
        data["edad"] = this.edad;
        data["dB_lab"] = this.dB_lab;
        data["dB_10"] = this.dB_10;
        data["observacion"] = this.observacion;
        data["idLab"] = this.idLab;
        data["codigo_Nir"] = this.codigo_Nir;
        data["dB_Modelo"] = this.dB_Modelo;
        data["rP_Modelo"] = this.rP_Modelo;
        data["pyrodin"] = this.pyrodin;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["lignina_FRB"] = this.lignina_FRB;
        data["celulosa_FRB"] = this.celulosa_FRB;
        data["exT_AC_FRB"] = this.exT_AC_FRB;
        data["consumo_AE"] = this.consumo_AE;
        data["ash"] = this.ash;
        data["extractives"] = this.extractives;
        data["total_Lignin"] = this.total_Lignin;
        data["celullose"] = this.celullose;
        data["glucomanan"] = this.glucomanan;
        data["others"] = this.others;
        data["ai"] = this.ai;
        data["ba"] = this.ba;
        data["ca"] = this.ca;
        data["cu"] = this.cu;
        data["fe"] = this.fe;
        data["k"] = this.k;
        data["mg"] = this.mg;
        data["mn"] = this.mn;
        data["na"] = this.na;
        data["p"] = this.p;
        data["s"] = this.s;
        data["si"] = this.si;
        data["xylan"] = this.xylan;
        data["sub_Proyecto"] = this.sub_Proyecto;
        data["typeMaterial"] = this.typeMaterial;
        data["projectId"] = this.projectId;
        data["trialId"] = this.trialId;
        data["treeId"] = this.treeId;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["treeStatusId"] = this.treeStatusId;
        data["woodSampleTypeId"] = this.woodSampleTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMesurementCloneEvaluationDto {
    bloque: number | undefined;
    subbloque: number | undefined;
    year: number;
    fechaMuestreo: DateTime;
    fechaPlantacion: DateTime | undefined;
    edad: number;
    dB_lab: number | undefined;
    dB_10: number | undefined;
    observacion: string;
    idLab: string;
    codigo_Nir: string | undefined;
    dB_Modelo: number | undefined;
    rP_Modelo: number | undefined;
    pyrodin: number | undefined;
    rP_Lab_FRB: number | undefined;
    lignina_FRB: number | undefined;
    celulosa_FRB: number | undefined;
    exT_AC_FRB: number | undefined;
    consumo_AE: number | undefined;
    ash: number | undefined;
    extractives: number | undefined;
    total_Lignin: number | undefined;
    celullose: number | undefined;
    glucomanan: number | undefined;
    others: number | undefined;
    ai: number | undefined;
    ba: number | undefined;
    ca: number | undefined;
    cu: number | undefined;
    fe: number | undefined;
    k: number | undefined;
    mg: number | undefined;
    mn: number | undefined;
    na: number | undefined;
    p: number | undefined;
    s: number | undefined;
    si: number | undefined;
    xylan: number | undefined;
    sub_Proyecto: string | undefined;
    typeMaterial: string;
    projectId: number;
    trialId: number | undefined;
    treeId: number | undefined;
    seedId: number | undefined;
    cloneId: number | undefined;
    treeStatusId: number | undefined;
    woodSampleTypeId: number;
    id: number | undefined;
}

export class CreateOrEditNeighborDto implements ICreateOrEditNeighborDto {
    neighbors!: string;
    description!: string | undefined;
    levelClassification!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNeighborDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neighbors = _data["neighbors"];
            this.description = _data["description"];
            this.levelClassification = _data["levelClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNeighborDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNeighborDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neighbors"] = this.neighbors;
        data["description"] = this.description;
        data["levelClassification"] = this.levelClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditNeighborDto {
    neighbors: string;
    description: string | undefined;
    levelClassification: number;
    id: number | undefined;
}

export class CreateOrEditParameterDto implements ICreateOrEditParameterDto {
    name!: string;
    value!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditParameterDto {
    name: string;
    value: number | undefined;
    id: number | undefined;
}

export class CreateOrEditPestAndDiseaseDto implements ICreateOrEditPestAndDiseaseDto {
    name!: string;
    code!: number;
    detail!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPestAndDiseaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPestAndDiseaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPestAndDiseaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPestAndDiseaseDto {
    name: string;
    code: number;
    detail: string;
    id: number | undefined;
}

export class CreateOrEditPolenDto implements ICreateOrEditPolenDto {
    bbp!: string;
    polenNumber!: number;
    physicalBBSTreeId!: string | undefined;
    bbs!: string | undefined;
    physicalBBXTreeId!: string | undefined;
    bbx!: string | undefined;
    generation!: string | undefined;
    originalTree!: string | undefined;
    idPolenHarvest!: string | undefined;
    species!: string;
    species2!: string | undefined;
    harvestDate!: DateTime;
    initialStock!: number;
    currentStock!: number;
    updateDate!: DateTime | undefined;
    stockLocation!: string | undefined;
    observations!: string | undefined;
    isMixture!: boolean;
    supplierId!: number;
    trialId!: number | undefined;
    polenMixtures!: _definitions_PolenMixtureDto[] | undefined;
    siteOrigin!: string | undefined;
    treeId!: number | undefined;
    typeHarvest!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPolenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbp = _data["bbp"];
            this.polenNumber = _data["polenNumber"];
            this.physicalBBSTreeId = _data["physicalBBSTreeId"];
            this.bbs = _data["bbs"];
            this.physicalBBXTreeId = _data["physicalBBXTreeId"];
            this.bbx = _data["bbx"];
            this.generation = _data["generation"];
            this.originalTree = _data["originalTree"];
            this.idPolenHarvest = _data["idPolenHarvest"];
            this.species = _data["species"];
            this.species2 = _data["species2"];
            this.harvestDate = _data["harvestDate"] ? DateTime.fromISO(_data["harvestDate"].toString()) : undefined as any;
            this.initialStock = _data["initialStock"];
            this.currentStock = _data["currentStock"];
            this.updateDate = _data["updateDate"] ? DateTime.fromISO(_data["updateDate"].toString()) : undefined as any;
            this.stockLocation = _data["stockLocation"];
            this.observations = _data["observations"];
            this.isMixture = _data["isMixture"];
            this.supplierId = _data["supplierId"];
            this.trialId = _data["trialId"];
            if (Array.isArray(_data["polenMixtures"])) {
                this.polenMixtures = [] as any;
                for (let item of _data["polenMixtures"])
                    this.polenMixtures!.push(_definitions_PolenMixtureDto.fromJS(item));
            }
            this.siteOrigin = _data["siteOrigin"];
            this.treeId = _data["treeId"];
            this.typeHarvest = _data["typeHarvest"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPolenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPolenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbp"] = this.bbp;
        data["polenNumber"] = this.polenNumber;
        data["physicalBBSTreeId"] = this.physicalBBSTreeId;
        data["bbs"] = this.bbs;
        data["physicalBBXTreeId"] = this.physicalBBXTreeId;
        data["bbx"] = this.bbx;
        data["generation"] = this.generation;
        data["originalTree"] = this.originalTree;
        data["idPolenHarvest"] = this.idPolenHarvest;
        data["species"] = this.species;
        data["species2"] = this.species2;
        data["harvestDate"] = this.harvestDate ? this.harvestDate.toString() : undefined as any;
        data["initialStock"] = this.initialStock;
        data["currentStock"] = this.currentStock;
        data["updateDate"] = this.updateDate ? this.updateDate.toString() : undefined as any;
        data["stockLocation"] = this.stockLocation;
        data["observations"] = this.observations;
        data["isMixture"] = this.isMixture;
        data["supplierId"] = this.supplierId;
        data["trialId"] = this.trialId;
        if (Array.isArray(this.polenMixtures)) {
            data["polenMixtures"] = [];
            for (let item of this.polenMixtures)
                data["polenMixtures"].push(item ? item.toJSON() : undefined as any);
        }
        data["siteOrigin"] = this.siteOrigin;
        data["treeId"] = this.treeId;
        data["typeHarvest"] = this.typeHarvest;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPolenDto {
    bbp: string;
    polenNumber: number;
    physicalBBSTreeId: string | undefined;
    bbs: string | undefined;
    physicalBBXTreeId: string | undefined;
    bbx: string | undefined;
    generation: string | undefined;
    originalTree: string | undefined;
    idPolenHarvest: string | undefined;
    species: string;
    species2: string | undefined;
    harvestDate: DateTime;
    initialStock: number;
    currentStock: number;
    updateDate: DateTime | undefined;
    stockLocation: string | undefined;
    observations: string | undefined;
    isMixture: boolean;
    supplierId: number;
    trialId: number | undefined;
    polenMixtures: _definitions_PolenMixtureDto[] | undefined;
    siteOrigin: string | undefined;
    treeId: number | undefined;
    typeHarvest: number;
    id: number | undefined;
}

export class CreateOrEditPolenMixtureDto implements ICreateOrEditPolenMixtureDto {
    bbpCompositionName!: string;
    porcentage!: number;
    polenCompositionId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPolenMixtureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbpCompositionName = _data["bbpCompositionName"];
            this.porcentage = _data["porcentage"];
            this.polenCompositionId = _data["polenCompositionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPolenMixtureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPolenMixtureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbpCompositionName"] = this.bbpCompositionName;
        data["porcentage"] = this.porcentage;
        data["polenCompositionId"] = this.polenCompositionId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPolenMixtureDto {
    bbpCompositionName: string;
    porcentage: number;
    polenCompositionId: number;
    id: number | undefined;
}

export class CreateOrEditPolenStockMovementDto implements ICreateOrEditPolenStockMovementDto {
    stockType!: string;
    quantityStock!: number;
    updateDate!: DateTime;
    stockLocation!: string | undefined;
    observation!: string | undefined;
    polenId!: number;
    progeniesStatesId!: number;
    progeniesStatesTwoId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPolenStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockType = _data["stockType"];
            this.quantityStock = _data["quantityStock"];
            this.updateDate = _data["updateDate"] ? DateTime.fromISO(_data["updateDate"].toString()) : undefined as any;
            this.stockLocation = _data["stockLocation"];
            this.observation = _data["observation"];
            this.polenId = _data["polenId"];
            this.progeniesStatesId = _data["progeniesStatesId"];
            this.progeniesStatesTwoId = _data["progeniesStatesTwoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPolenStockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPolenStockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockType"] = this.stockType;
        data["quantityStock"] = this.quantityStock;
        data["updateDate"] = this.updateDate ? this.updateDate.toString() : undefined as any;
        data["stockLocation"] = this.stockLocation;
        data["observation"] = this.observation;
        data["polenId"] = this.polenId;
        data["progeniesStatesId"] = this.progeniesStatesId;
        data["progeniesStatesTwoId"] = this.progeniesStatesTwoId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPolenStockMovementDto {
    stockType: string;
    quantityStock: number;
    updateDate: DateTime;
    stockLocation: string | undefined;
    observation: string | undefined;
    polenId: number;
    progeniesStatesId: number;
    progeniesStatesTwoId: number;
    id: number | undefined;
}

export class CreateOrEditPorcentajeBBXDto implements ICreateOrEditPorcentajeBBXDto {
    percentage!: number | undefined;
    cloneId!: number | undefined;
    dateHarvest!: DateTime;
    measurementSelectionId!: number | undefined;
    projectID!: number | undefined;
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPorcentajeBBXDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.cloneId = _data["cloneId"];
            this.dateHarvest = _data["dateHarvest"] ? DateTime.fromISO(_data["dateHarvest"].toString()) : undefined as any;
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.projectID = _data["projectID"];
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPorcentajeBBXDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPorcentajeBBXDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["cloneId"] = this.cloneId;
        data["dateHarvest"] = this.dateHarvest ? this.dateHarvest.toString() : undefined as any;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["projectID"] = this.projectID;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPorcentajeBBXDto {
    percentage: number | undefined;
    cloneId: number | undefined;
    dateHarvest: DateTime;
    measurementSelectionId: number | undefined;
    projectID: number | undefined;
    type: string | undefined;
    id: number | undefined;
}

export class CreateOrEditProgeniesStateDto implements ICreateOrEditProgeniesStateDto {
    state!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProgeniesStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgeniesStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProgeniesStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProgeniesStateDto {
    state: string;
    id: number | undefined;
}

export class CreateOrEditProgeniesStateTwoDto implements ICreateOrEditProgeniesStateTwoDto {
    state!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProgeniesStateTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgeniesStateTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProgeniesStateTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProgeniesStateTwoDto {
    state: string;
    id: number | undefined;
}

export class CreateOrEditProjectConfigurationDto implements ICreateOrEditProjectConfigurationDto {
    prom_Sob!: number | undefined;
    prom_graves!: number | undefined;
    prom_Zvol_Ha!: number | undefined;
    rank_Zvol_Ha!: number | undefined;
    verEnCampo!: boolean;
    isDiscoSelection!: boolean;
    isChipSelection!: boolean;
    cloneId!: number | undefined;
    seedId!: number | undefined;
    projectId!: number;
    project!: ProjectDto;
    trialsList!: TrialDto[] | undefined;
    trialNumbers!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProjectConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prom_Sob = _data["prom_Sob"];
            this.prom_graves = _data["prom_graves"];
            this.prom_Zvol_Ha = _data["prom_Zvol_Ha"];
            this.rank_Zvol_Ha = _data["rank_Zvol_Ha"];
            this.verEnCampo = _data["verEnCampo"];
            this.isDiscoSelection = _data["isDiscoSelection"];
            this.isChipSelection = _data["isChipSelection"];
            this.cloneId = _data["cloneId"];
            this.seedId = _data["seedId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["trialsList"])) {
                this.trialsList = [] as any;
                for (let item of _data["trialsList"])
                    this.trialsList!.push(TrialDto.fromJS(item));
            }
            this.trialNumbers = _data["trialNumbers"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProjectConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProjectConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prom_Sob"] = this.prom_Sob;
        data["prom_graves"] = this.prom_graves;
        data["prom_Zvol_Ha"] = this.prom_Zvol_Ha;
        data["rank_Zvol_Ha"] = this.rank_Zvol_Ha;
        data["verEnCampo"] = this.verEnCampo;
        data["isDiscoSelection"] = this.isDiscoSelection;
        data["isChipSelection"] = this.isChipSelection;
        data["cloneId"] = this.cloneId;
        data["seedId"] = this.seedId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.trialsList)) {
            data["trialsList"] = [];
            for (let item of this.trialsList)
                data["trialsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["trialNumbers"] = this.trialNumbers;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProjectConfigurationDto {
    prom_Sob: number | undefined;
    prom_graves: number | undefined;
    prom_Zvol_Ha: number | undefined;
    rank_Zvol_Ha: number | undefined;
    verEnCampo: boolean;
    isDiscoSelection: boolean;
    isChipSelection: boolean;
    cloneId: number | undefined;
    seedId: number | undefined;
    projectId: number;
    project: ProjectDto;
    trialsList: TrialDto[] | undefined;
    trialNumbers: string | undefined;
    id: number | undefined;
}

export class CreateOrEditProjectDto implements ICreateOrEditProjectDto {
    name!: string;
    date!: DateTime;
    laboratoryProjectTypeId!: number;
    laboratoryProjectStatusId!: number | undefined;
    isOtherProject!: boolean;
    measurementSelections!: MeasurementSelectionDto[] | undefined;
    measurementSelectionsGenomic!: MeasurementSelectionGenomicDto[] | undefined;
    measurementSelectionsOtherProject!: MeasurementSelectionOtherProjectDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.laboratoryProjectStatusId = _data["laboratoryProjectStatusId"];
            this.isOtherProject = _data["isOtherProject"];
            if (Array.isArray(_data["measurementSelections"])) {
                this.measurementSelections = [] as any;
                for (let item of _data["measurementSelections"])
                    this.measurementSelections!.push(MeasurementSelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["measurementSelectionsGenomic"])) {
                this.measurementSelectionsGenomic = [] as any;
                for (let item of _data["measurementSelectionsGenomic"])
                    this.measurementSelectionsGenomic!.push(MeasurementSelectionGenomicDto.fromJS(item));
            }
            if (Array.isArray(_data["measurementSelectionsOtherProject"])) {
                this.measurementSelectionsOtherProject = [] as any;
                for (let item of _data["measurementSelectionsOtherProject"])
                    this.measurementSelectionsOtherProject!.push(MeasurementSelectionOtherProjectDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["laboratoryProjectStatusId"] = this.laboratoryProjectStatusId;
        data["isOtherProject"] = this.isOtherProject;
        if (Array.isArray(this.measurementSelections)) {
            data["measurementSelections"] = [];
            for (let item of this.measurementSelections)
                data["measurementSelections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementSelectionsGenomic)) {
            data["measurementSelectionsGenomic"] = [];
            for (let item of this.measurementSelectionsGenomic)
                data["measurementSelectionsGenomic"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementSelectionsOtherProject)) {
            data["measurementSelectionsOtherProject"] = [];
            for (let item of this.measurementSelectionsOtherProject)
                data["measurementSelectionsOtherProject"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProjectDto {
    name: string;
    date: DateTime;
    laboratoryProjectTypeId: number;
    laboratoryProjectStatusId: number | undefined;
    isOtherProject: boolean;
    measurementSelections: MeasurementSelectionDto[] | undefined;
    measurementSelectionsGenomic: MeasurementSelectionGenomicDto[] | undefined;
    measurementSelectionsOtherProject: MeasurementSelectionOtherProjectDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditPromedioLabBbxDto implements ICreateOrEditPromedioLabBbxDto {
    cloneId!: number;
    projectName!: string | undefined;
    destineList!: GetBBXDestinationForViewDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPromedioLabBbxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloneId = _data["cloneId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["destineList"])) {
                this.destineList = [] as any;
                for (let item of _data["destineList"])
                    this.destineList!.push(GetBBXDestinationForViewDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPromedioLabBbxDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPromedioLabBbxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloneId"] = this.cloneId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.destineList)) {
            data["destineList"] = [];
            for (let item of this.destineList)
                data["destineList"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPromedioLabBbxDto {
    cloneId: number;
    projectName: string | undefined;
    destineList: GetBBXDestinationForViewDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditQualityClassificationDto implements ICreateOrEditQualityClassificationDto {
    qualityClassificationTypeId!: number;
    classification!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQualityClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassificationTypeId = _data["qualityClassificationTypeId"];
            this.classification = _data["classification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQualityClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQualityClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassificationTypeId"] = this.qualityClassificationTypeId;
        data["classification"] = this.classification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQualityClassificationDto {
    qualityClassificationTypeId: number;
    classification: string;
    id: number | undefined;
}

export class CreateOrEditQualityClassificationTypeDto implements ICreateOrEditQualityClassificationTypeDto {
    type!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQualityClassificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQualityClassificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQualityClassificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQualityClassificationTypeDto {
    type: string;
    id: number | undefined;
}

export class CreateOrEditQualityControlDto implements ICreateOrEditQualityControlDto {
    qualityCode!: string;
    trialId!: number;
    controlDate!: DateTime;
    height!: number | undefined;
    dac!: number | undefined;
    qualityAppearanceClassificationId!: number | undefined;
    qualityPanClassificationId!: number | undefined;
    qualityResultClassificationId!: number | undefined;
    qualityAverageClassificationId!: number | undefined;
    qualityFieldObsClassificationId!: number | undefined;
    qualityFieldClassificationId!: number | undefined;
    qualityReplantingReasonClassificationId!: number | undefined;
    qualityReasonClassificationId!: number | undefined;
    qualityObservationClassificationId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQualityControlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityCode = _data["qualityCode"];
            this.trialId = _data["trialId"];
            this.controlDate = _data["controlDate"] ? DateTime.fromISO(_data["controlDate"].toString()) : undefined as any;
            this.height = _data["height"];
            this.dac = _data["dac"];
            this.qualityAppearanceClassificationId = _data["qualityAppearanceClassificationId"];
            this.qualityPanClassificationId = _data["qualityPanClassificationId"];
            this.qualityResultClassificationId = _data["qualityResultClassificationId"];
            this.qualityAverageClassificationId = _data["qualityAverageClassificationId"];
            this.qualityFieldObsClassificationId = _data["qualityFieldObsClassificationId"];
            this.qualityFieldClassificationId = _data["qualityFieldClassificationId"];
            this.qualityReplantingReasonClassificationId = _data["qualityReplantingReasonClassificationId"];
            this.qualityReasonClassificationId = _data["qualityReasonClassificationId"];
            this.qualityObservationClassificationId = _data["qualityObservationClassificationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQualityControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQualityControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityCode"] = this.qualityCode;
        data["trialId"] = this.trialId;
        data["controlDate"] = this.controlDate ? this.controlDate.toString() : undefined as any;
        data["height"] = this.height;
        data["dac"] = this.dac;
        data["qualityAppearanceClassificationId"] = this.qualityAppearanceClassificationId;
        data["qualityPanClassificationId"] = this.qualityPanClassificationId;
        data["qualityResultClassificationId"] = this.qualityResultClassificationId;
        data["qualityAverageClassificationId"] = this.qualityAverageClassificationId;
        data["qualityFieldObsClassificationId"] = this.qualityFieldObsClassificationId;
        data["qualityFieldClassificationId"] = this.qualityFieldClassificationId;
        data["qualityReplantingReasonClassificationId"] = this.qualityReplantingReasonClassificationId;
        data["qualityReasonClassificationId"] = this.qualityReasonClassificationId;
        data["qualityObservationClassificationId"] = this.qualityObservationClassificationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQualityControlDto {
    qualityCode: string;
    trialId: number;
    controlDate: DateTime;
    height: number | undefined;
    dac: number | undefined;
    qualityAppearanceClassificationId: number | undefined;
    qualityPanClassificationId: number | undefined;
    qualityResultClassificationId: number | undefined;
    qualityAverageClassificationId: number | undefined;
    qualityFieldObsClassificationId: number | undefined;
    qualityFieldClassificationId: number | undefined;
    qualityReplantingReasonClassificationId: number | undefined;
    qualityReasonClassificationId: number | undefined;
    qualityObservationClassificationId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditRoatingporcentajeTrayDto implements ICreateOrEditRoatingporcentajeTrayDto {
    idBandeja!: number;
    etiquetaBandeja!: string;
    origenBandeja!: string;
    fechaCosecha!: DateTime | undefined;
    fechaConteoInicial!: DateTime;
    cantidadPlantasIniciales!: number;
    zonaCrecimiento!: string;
    fechaEntradaCrecimiento!: DateTime | undefined;
    fechaEntradaEnraizamiento!: DateTime;
    zonaEnraizamiento!: string;
    cantidadConteoFinal!: number | undefined;
    fechaPlantasFinal!: DateTime | undefined;
    observacion!: string | undefined;
    fechaCensoFinal!: DateTime | undefined;
    censoFinal!: number | undefined;
    porcentajeEnraizamiento!: number | undefined;
    seedId!: number | undefined;
    rootingPercentageId!: number | undefined;
    projectId!: number | undefined;
    measurementSelectionId!: number | undefined;
    destinos!: string | undefined;
    cloneId!: number | undefined;
    sourcePlantId!: number | undefined;
    trials!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRoatingporcentajeTrayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idBandeja = _data["idBandeja"];
            this.etiquetaBandeja = _data["etiquetaBandeja"];
            this.origenBandeja = _data["origenBandeja"];
            this.fechaCosecha = _data["fechaCosecha"] ? DateTime.fromISO(_data["fechaCosecha"].toString()) : undefined as any;
            this.fechaConteoInicial = _data["fechaConteoInicial"] ? DateTime.fromISO(_data["fechaConteoInicial"].toString()) : undefined as any;
            this.cantidadPlantasIniciales = _data["cantidadPlantasIniciales"];
            this.zonaCrecimiento = _data["zonaCrecimiento"];
            this.fechaEntradaCrecimiento = _data["fechaEntradaCrecimiento"] ? DateTime.fromISO(_data["fechaEntradaCrecimiento"].toString()) : undefined as any;
            this.fechaEntradaEnraizamiento = _data["fechaEntradaEnraizamiento"] ? DateTime.fromISO(_data["fechaEntradaEnraizamiento"].toString()) : undefined as any;
            this.zonaEnraizamiento = _data["zonaEnraizamiento"];
            this.cantidadConteoFinal = _data["cantidadConteoFinal"];
            this.fechaPlantasFinal = _data["fechaPlantasFinal"] ? DateTime.fromISO(_data["fechaPlantasFinal"].toString()) : undefined as any;
            this.observacion = _data["observacion"];
            this.fechaCensoFinal = _data["fechaCensoFinal"] ? DateTime.fromISO(_data["fechaCensoFinal"].toString()) : undefined as any;
            this.censoFinal = _data["censoFinal"];
            this.porcentajeEnraizamiento = _data["porcentajeEnraizamiento"];
            this.seedId = _data["seedId"];
            this.rootingPercentageId = _data["rootingPercentageId"];
            this.projectId = _data["projectId"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.destinos = _data["destinos"];
            this.cloneId = _data["cloneId"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.trials = _data["trials"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRoatingporcentajeTrayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRoatingporcentajeTrayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idBandeja"] = this.idBandeja;
        data["etiquetaBandeja"] = this.etiquetaBandeja;
        data["origenBandeja"] = this.origenBandeja;
        data["fechaCosecha"] = this.fechaCosecha ? this.fechaCosecha.toString() : undefined as any;
        data["fechaConteoInicial"] = this.fechaConteoInicial ? this.fechaConteoInicial.toString() : undefined as any;
        data["cantidadPlantasIniciales"] = this.cantidadPlantasIniciales;
        data["zonaCrecimiento"] = this.zonaCrecimiento;
        data["fechaEntradaCrecimiento"] = this.fechaEntradaCrecimiento ? this.fechaEntradaCrecimiento.toString() : undefined as any;
        data["fechaEntradaEnraizamiento"] = this.fechaEntradaEnraizamiento ? this.fechaEntradaEnraizamiento.toString() : undefined as any;
        data["zonaEnraizamiento"] = this.zonaEnraizamiento;
        data["cantidadConteoFinal"] = this.cantidadConteoFinal;
        data["fechaPlantasFinal"] = this.fechaPlantasFinal ? this.fechaPlantasFinal.toString() : undefined as any;
        data["observacion"] = this.observacion;
        data["fechaCensoFinal"] = this.fechaCensoFinal ? this.fechaCensoFinal.toString() : undefined as any;
        data["censoFinal"] = this.censoFinal;
        data["porcentajeEnraizamiento"] = this.porcentajeEnraizamiento;
        data["seedId"] = this.seedId;
        data["rootingPercentageId"] = this.rootingPercentageId;
        data["projectId"] = this.projectId;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["destinos"] = this.destinos;
        data["cloneId"] = this.cloneId;
        data["sourcePlantId"] = this.sourcePlantId;
        data["trials"] = this.trials;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRoatingporcentajeTrayDto {
    idBandeja: number;
    etiquetaBandeja: string;
    origenBandeja: string;
    fechaCosecha: DateTime | undefined;
    fechaConteoInicial: DateTime;
    cantidadPlantasIniciales: number;
    zonaCrecimiento: string;
    fechaEntradaCrecimiento: DateTime | undefined;
    fechaEntradaEnraizamiento: DateTime;
    zonaEnraizamiento: string;
    cantidadConteoFinal: number | undefined;
    fechaPlantasFinal: DateTime | undefined;
    observacion: string | undefined;
    fechaCensoFinal: DateTime | undefined;
    censoFinal: number | undefined;
    porcentajeEnraizamiento: number | undefined;
    seedId: number | undefined;
    rootingPercentageId: number | undefined;
    projectId: number | undefined;
    measurementSelectionId: number | undefined;
    destinos: string | undefined;
    cloneId: number | undefined;
    sourcePlantId: number | undefined;
    trials: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSeedDestinationDto implements ICreateOrEditSeedDestinationDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedDestinationDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditSeedDto implements ICreateOrEditSeedDto {
    bbs!: string;
    loteNumber!: number | undefined;
    species!: string | undefined;
    speciesNameId!: number | undefined;
    receivedDate!: DateTime;
    idMotherTree!: string | undefined;
    bbsMother!: string | undefined;
    blockMother!: number | undefined;
    subBlockMother!: number | undefined;
    treeNumberMother!: number | undefined;
    speciesMother!: string | undefined;
    bbpFather!: string | undefined;
    idFatherTree!: string | undefined;
    idTrialFather!: number | undefined;
    bbsFather!: string | undefined;
    blockFather!: number;
    subBlockFather!: number;
    treeNumberFather!: number;
    specieFather!: string | undefined;
    supplierCode!: string | undefined;
    isMixSeed!: boolean;
    typeSpecieId!: number | undefined;
    categorySeedOriginId!: number;
    crossingTechniqueId!: number | undefined;
    trialId!: number | undefined;
    standName!: string | undefined;
    farmName!: string | undefined;
    supplierId!: number;
    seedDestinationId!: number | undefined;
    siteOrigin!: string | undefined;
    classification!: EnumSiteClassification;
    idTrialMothre!: number | undefined;
    bbxMother!: string | undefined;
    bbxidTreeMother!: string | undefined;
    bbxFather!: string | undefined;
    bbxidTreeFather!: string | undefined;
    seedMixture!: SeedMixtureDto[] | undefined;
    treeMotherId!: number | undefined;
    polenFatherId!: number | undefined;
    typeSpecieName!: string | undefined;
    speciesName!: string | undefined;
    originalTreeMother!: string | undefined;
    originalTreeFather!: string | undefined;
    observation!: string | undefined;
    observationSpecie!: string | undefined;
    generation!: string | undefined;
    specie2Calculated!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbs = _data["bbs"];
            this.loteNumber = _data["loteNumber"];
            this.species = _data["species"];
            this.speciesNameId = _data["speciesNameId"];
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : undefined as any;
            this.idMotherTree = _data["idMotherTree"];
            this.bbsMother = _data["bbsMother"];
            this.blockMother = _data["blockMother"];
            this.subBlockMother = _data["subBlockMother"];
            this.treeNumberMother = _data["treeNumberMother"];
            this.speciesMother = _data["speciesMother"];
            this.bbpFather = _data["bbpFather"];
            this.idFatherTree = _data["idFatherTree"];
            this.idTrialFather = _data["idTrialFather"];
            this.bbsFather = _data["bbsFather"];
            this.blockFather = _data["blockFather"];
            this.subBlockFather = _data["subBlockFather"];
            this.treeNumberFather = _data["treeNumberFather"];
            this.specieFather = _data["specieFather"];
            this.supplierCode = _data["supplierCode"];
            this.isMixSeed = _data["isMixSeed"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.categorySeedOriginId = _data["categorySeedOriginId"];
            this.crossingTechniqueId = _data["crossingTechniqueId"];
            this.trialId = _data["trialId"];
            this.standName = _data["standName"];
            this.farmName = _data["farmName"];
            this.supplierId = _data["supplierId"];
            this.seedDestinationId = _data["seedDestinationId"];
            this.siteOrigin = _data["siteOrigin"];
            this.classification = _data["classification"];
            this.idTrialMothre = _data["idTrialMothre"];
            this.bbxMother = _data["bbxMother"];
            this.bbxidTreeMother = _data["bbxidTreeMother"];
            this.bbxFather = _data["bbxFather"];
            this.bbxidTreeFather = _data["bbxidTreeFather"];
            if (Array.isArray(_data["seedMixture"])) {
                this.seedMixture = [] as any;
                for (let item of _data["seedMixture"])
                    this.seedMixture!.push(SeedMixtureDto.fromJS(item));
            }
            this.treeMotherId = _data["treeMotherId"];
            this.polenFatherId = _data["polenFatherId"];
            this.typeSpecieName = _data["typeSpecieName"];
            this.speciesName = _data["speciesName"];
            this.originalTreeMother = _data["originalTreeMother"];
            this.originalTreeFather = _data["originalTreeFather"];
            this.observation = _data["observation"];
            this.observationSpecie = _data["observationSpecie"];
            this.generation = _data["generation"];
            this.specie2Calculated = _data["specie2Calculated"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbs"] = this.bbs;
        data["loteNumber"] = this.loteNumber;
        data["species"] = this.species;
        data["speciesNameId"] = this.speciesNameId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : undefined as any;
        data["idMotherTree"] = this.idMotherTree;
        data["bbsMother"] = this.bbsMother;
        data["blockMother"] = this.blockMother;
        data["subBlockMother"] = this.subBlockMother;
        data["treeNumberMother"] = this.treeNumberMother;
        data["speciesMother"] = this.speciesMother;
        data["bbpFather"] = this.bbpFather;
        data["idFatherTree"] = this.idFatherTree;
        data["idTrialFather"] = this.idTrialFather;
        data["bbsFather"] = this.bbsFather;
        data["blockFather"] = this.blockFather;
        data["subBlockFather"] = this.subBlockFather;
        data["treeNumberFather"] = this.treeNumberFather;
        data["specieFather"] = this.specieFather;
        data["supplierCode"] = this.supplierCode;
        data["isMixSeed"] = this.isMixSeed;
        data["typeSpecieId"] = this.typeSpecieId;
        data["categorySeedOriginId"] = this.categorySeedOriginId;
        data["crossingTechniqueId"] = this.crossingTechniqueId;
        data["trialId"] = this.trialId;
        data["standName"] = this.standName;
        data["farmName"] = this.farmName;
        data["supplierId"] = this.supplierId;
        data["seedDestinationId"] = this.seedDestinationId;
        data["siteOrigin"] = this.siteOrigin;
        data["classification"] = this.classification;
        data["idTrialMothre"] = this.idTrialMothre;
        data["bbxMother"] = this.bbxMother;
        data["bbxidTreeMother"] = this.bbxidTreeMother;
        data["bbxFather"] = this.bbxFather;
        data["bbxidTreeFather"] = this.bbxidTreeFather;
        if (Array.isArray(this.seedMixture)) {
            data["seedMixture"] = [];
            for (let item of this.seedMixture)
                data["seedMixture"].push(item ? item.toJSON() : undefined as any);
        }
        data["treeMotherId"] = this.treeMotherId;
        data["polenFatherId"] = this.polenFatherId;
        data["typeSpecieName"] = this.typeSpecieName;
        data["speciesName"] = this.speciesName;
        data["originalTreeMother"] = this.originalTreeMother;
        data["originalTreeFather"] = this.originalTreeFather;
        data["observation"] = this.observation;
        data["observationSpecie"] = this.observationSpecie;
        data["generation"] = this.generation;
        data["specie2Calculated"] = this.specie2Calculated;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedDto {
    bbs: string;
    loteNumber: number | undefined;
    species: string | undefined;
    speciesNameId: number | undefined;
    receivedDate: DateTime;
    idMotherTree: string | undefined;
    bbsMother: string | undefined;
    blockMother: number | undefined;
    subBlockMother: number | undefined;
    treeNumberMother: number | undefined;
    speciesMother: string | undefined;
    bbpFather: string | undefined;
    idFatherTree: string | undefined;
    idTrialFather: number | undefined;
    bbsFather: string | undefined;
    blockFather: number;
    subBlockFather: number;
    treeNumberFather: number;
    specieFather: string | undefined;
    supplierCode: string | undefined;
    isMixSeed: boolean;
    typeSpecieId: number | undefined;
    categorySeedOriginId: number;
    crossingTechniqueId: number | undefined;
    trialId: number | undefined;
    standName: string | undefined;
    farmName: string | undefined;
    supplierId: number;
    seedDestinationId: number | undefined;
    siteOrigin: string | undefined;
    classification: EnumSiteClassification;
    idTrialMothre: number | undefined;
    bbxMother: string | undefined;
    bbxidTreeMother: string | undefined;
    bbxFather: string | undefined;
    bbxidTreeFather: string | undefined;
    seedMixture: SeedMixtureDto[] | undefined;
    treeMotherId: number | undefined;
    polenFatherId: number | undefined;
    typeSpecieName: string | undefined;
    speciesName: string | undefined;
    originalTreeMother: string | undefined;
    originalTreeFather: string | undefined;
    observation: string | undefined;
    observationSpecie: string | undefined;
    generation: string | undefined;
    specie2Calculated: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSeedMixtureDto implements ICreateOrEditSeedMixtureDto {
    porcentaje!: number;
    seedCompositionID!: number;
    seedCompisitonId!: number;
    seedCompositionName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedMixtureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porcentaje = _data["porcentaje"];
            this.seedCompositionID = _data["seedCompositionID"];
            this.seedCompisitonId = _data["seedCompisitonId"];
            this.seedCompositionName = _data["seedCompositionName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedMixtureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedMixtureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porcentaje"] = this.porcentaje;
        data["seedCompositionID"] = this.seedCompositionID;
        data["seedCompisitonId"] = this.seedCompisitonId;
        data["seedCompositionName"] = this.seedCompositionName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedMixtureDto {
    porcentaje: number;
    seedCompositionID: number;
    seedCompisitonId: number;
    seedCompositionName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSeedStockDto implements ICreateOrEditSeedStockDto {
    isClean!: boolean;
    unitType!: string;
    initialStock!: number | undefined;
    currentStock!: number | undefined;
    stockMinimo!: number | undefined;
    lastUpdateDate!: DateTime | undefined;
    caliber059mm!: number | undefined;
    caliber071mm!: number | undefined;
    caliber084mm!: number | undefined;
    caliber100mm!: number | undefined;
    destination!: string | undefined;
    destination2!: string | undefined;
    shelf!: string | undefined;
    quadrant!: string | undefined;
    drawerLocation!: string | undefined;
    bagDetail!: string | undefined;
    comments!: string | undefined;
    seedId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isClean = _data["isClean"];
            this.unitType = _data["unitType"];
            this.initialStock = _data["initialStock"];
            this.currentStock = _data["currentStock"];
            this.stockMinimo = _data["stockMinimo"];
            this.lastUpdateDate = _data["lastUpdateDate"] ? DateTime.fromISO(_data["lastUpdateDate"].toString()) : undefined as any;
            this.caliber059mm = _data["caliber059mm"];
            this.caliber071mm = _data["caliber071mm"];
            this.caliber084mm = _data["caliber084mm"];
            this.caliber100mm = _data["caliber100mm"];
            this.destination = _data["destination"];
            this.destination2 = _data["destination2"];
            this.shelf = _data["shelf"];
            this.quadrant = _data["quadrant"];
            this.drawerLocation = _data["drawerLocation"];
            this.bagDetail = _data["bagDetail"];
            this.comments = _data["comments"];
            this.seedId = _data["seedId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClean"] = this.isClean;
        data["unitType"] = this.unitType;
        data["initialStock"] = this.initialStock;
        data["currentStock"] = this.currentStock;
        data["stockMinimo"] = this.stockMinimo;
        data["lastUpdateDate"] = this.lastUpdateDate ? this.lastUpdateDate.toString() : undefined as any;
        data["caliber059mm"] = this.caliber059mm;
        data["caliber071mm"] = this.caliber071mm;
        data["caliber084mm"] = this.caliber084mm;
        data["caliber100mm"] = this.caliber100mm;
        data["destination"] = this.destination;
        data["destination2"] = this.destination2;
        data["shelf"] = this.shelf;
        data["quadrant"] = this.quadrant;
        data["drawerLocation"] = this.drawerLocation;
        data["bagDetail"] = this.bagDetail;
        data["comments"] = this.comments;
        data["seedId"] = this.seedId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedStockDto {
    isClean: boolean;
    unitType: string;
    initialStock: number | undefined;
    currentStock: number | undefined;
    stockMinimo: number | undefined;
    lastUpdateDate: DateTime | undefined;
    caliber059mm: number | undefined;
    caliber071mm: number | undefined;
    caliber084mm: number | undefined;
    caliber100mm: number | undefined;
    destination: string | undefined;
    destination2: string | undefined;
    shelf: string | undefined;
    quadrant: string | undefined;
    drawerLocation: string | undefined;
    bagDetail: string | undefined;
    comments: string | undefined;
    seedId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSeedStockMovementDto implements ICreateOrEditSeedStockMovementDto {
    movementDate!: DateTime;
    movementType!: string | undefined;
    quantity!: number;
    unitType!: string | undefined;
    isClean!: boolean;
    destination!: string | undefined;
    destination2!: string | undefined;
    shelf!: string | undefined;
    quadrant!: string | undefined;
    drawerLocation!: string | undefined;
    bagDetail!: string | undefined;
    comments!: string | undefined;
    caliber059mm!: number;
    caliber071mm!: number;
    caliber084mm!: number;
    caliber100mm!: number;
    calibrationObservation!: string | undefined;
    stockMovementQuantity!: number | undefined;
    seedId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementDate = _data["movementDate"] ? DateTime.fromISO(_data["movementDate"].toString()) : undefined as any;
            this.movementType = _data["movementType"];
            this.quantity = _data["quantity"];
            this.unitType = _data["unitType"];
            this.isClean = _data["isClean"];
            this.destination = _data["destination"];
            this.destination2 = _data["destination2"];
            this.shelf = _data["shelf"];
            this.quadrant = _data["quadrant"];
            this.drawerLocation = _data["drawerLocation"];
            this.bagDetail = _data["bagDetail"];
            this.comments = _data["comments"];
            this.caliber059mm = _data["caliber059mm"];
            this.caliber071mm = _data["caliber071mm"];
            this.caliber084mm = _data["caliber084mm"];
            this.caliber100mm = _data["caliber100mm"];
            this.calibrationObservation = _data["calibrationObservation"];
            this.stockMovementQuantity = _data["stockMovementQuantity"];
            this.seedId = _data["seedId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedStockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedStockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementDate"] = this.movementDate ? this.movementDate.toString() : undefined as any;
        data["movementType"] = this.movementType;
        data["quantity"] = this.quantity;
        data["unitType"] = this.unitType;
        data["isClean"] = this.isClean;
        data["destination"] = this.destination;
        data["destination2"] = this.destination2;
        data["shelf"] = this.shelf;
        data["quadrant"] = this.quadrant;
        data["drawerLocation"] = this.drawerLocation;
        data["bagDetail"] = this.bagDetail;
        data["comments"] = this.comments;
        data["caliber059mm"] = this.caliber059mm;
        data["caliber071mm"] = this.caliber071mm;
        data["caliber084mm"] = this.caliber084mm;
        data["caliber100mm"] = this.caliber100mm;
        data["calibrationObservation"] = this.calibrationObservation;
        data["stockMovementQuantity"] = this.stockMovementQuantity;
        data["seedId"] = this.seedId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedStockMovementDto {
    movementDate: DateTime;
    movementType: string | undefined;
    quantity: number;
    unitType: string | undefined;
    isClean: boolean;
    destination: string | undefined;
    destination2: string | undefined;
    shelf: string | undefined;
    quadrant: string | undefined;
    drawerLocation: string | undefined;
    bagDetail: string | undefined;
    comments: string | undefined;
    caliber059mm: number;
    caliber071mm: number;
    caliber084mm: number;
    caliber100mm: number;
    calibrationObservation: string | undefined;
    stockMovementQuantity: number | undefined;
    seedId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSeedlingDto implements ICreateOrEditSeedlingDto {
    seedId!: number | undefined;
    cloneId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeedlingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeedlingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeedlingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeedlingDto {
    seedId: number | undefined;
    cloneId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSilvicultureTreatmentNutritionalDto implements ICreateOrEditSilvicultureTreatmentNutritionalDto {
    treatment!: number;
    treatmentStartDate!: DateTime;
    treatmentTag!: string;
    interventionDate!: DateTime;
    interventionWidth!: number | undefined;
    dose_Gr_Pl!: number | undefined;
    dose_Kg_Ha_Total!: number | undefined;
    dose_L_Ha_Total!: number | undefined;
    dose_Kg_Ha_Concentrated!: number | undefined;
    dilution!: number | undefined;
    largeTrickle!: number | undefined;
    depth!: number | undefined;
    longitudinalFertilizerBleed!: number | undefined;
    observation!: string | undefined;
    observationOne!: string | undefined;
    silvicultureTrialId!: number;
    treatmentObjectiveId!: number;
    treatmentParcelTypeId!: number;
    cloneId!: number;
    treatmentProductTypeId!: number;
    treatmentProductId!: number;
    treatmentInterventionZoneId!: number;
    treatmentInterventionMomentId!: number;
    treatmentInterventionObjectiveId!: number;
    treatmentApplyOneId!: number | undefined;
    treatmentApplyTwoId!: number | undefined;
    treatmentApplyThreeId!: number | undefined;
    treatmentApplyFourId!: number | undefined;
    treatmentApplyFiveId!: number | undefined;
    interventionFoundationsOneId!: number;
    interventionFoundationsTwoId!: number | undefined;
    interventionFoundationsThreeId!: number | undefined;
    treatmentDoseTypeId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSilvicultureTreatmentNutritionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatment = _data["treatment"];
            this.treatmentStartDate = _data["treatmentStartDate"] ? DateTime.fromISO(_data["treatmentStartDate"].toString()) : undefined as any;
            this.treatmentTag = _data["treatmentTag"];
            this.interventionDate = _data["interventionDate"] ? DateTime.fromISO(_data["interventionDate"].toString()) : undefined as any;
            this.interventionWidth = _data["interventionWidth"];
            this.dose_Gr_Pl = _data["dose_Gr_Pl"];
            this.dose_Kg_Ha_Total = _data["dose_Kg_Ha_Total"];
            this.dose_L_Ha_Total = _data["dose_L_Ha_Total"];
            this.dose_Kg_Ha_Concentrated = _data["dose_Kg_Ha_Concentrated"];
            this.dilution = _data["dilution"];
            this.largeTrickle = _data["largeTrickle"];
            this.depth = _data["depth"];
            this.longitudinalFertilizerBleed = _data["longitudinalFertilizerBleed"];
            this.observation = _data["observation"];
            this.observationOne = _data["observationOne"];
            this.silvicultureTrialId = _data["silvicultureTrialId"];
            this.treatmentObjectiveId = _data["treatmentObjectiveId"];
            this.treatmentParcelTypeId = _data["treatmentParcelTypeId"];
            this.cloneId = _data["cloneId"];
            this.treatmentProductTypeId = _data["treatmentProductTypeId"];
            this.treatmentProductId = _data["treatmentProductId"];
            this.treatmentInterventionZoneId = _data["treatmentInterventionZoneId"];
            this.treatmentInterventionMomentId = _data["treatmentInterventionMomentId"];
            this.treatmentInterventionObjectiveId = _data["treatmentInterventionObjectiveId"];
            this.treatmentApplyOneId = _data["treatmentApplyOneId"];
            this.treatmentApplyTwoId = _data["treatmentApplyTwoId"];
            this.treatmentApplyThreeId = _data["treatmentApplyThreeId"];
            this.treatmentApplyFourId = _data["treatmentApplyFourId"];
            this.treatmentApplyFiveId = _data["treatmentApplyFiveId"];
            this.interventionFoundationsOneId = _data["interventionFoundationsOneId"];
            this.interventionFoundationsTwoId = _data["interventionFoundationsTwoId"];
            this.interventionFoundationsThreeId = _data["interventionFoundationsThreeId"];
            this.treatmentDoseTypeId = _data["treatmentDoseTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSilvicultureTreatmentNutritionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSilvicultureTreatmentNutritionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment;
        data["treatmentStartDate"] = this.treatmentStartDate ? this.treatmentStartDate.toString() : undefined as any;
        data["treatmentTag"] = this.treatmentTag;
        data["interventionDate"] = this.interventionDate ? this.interventionDate.toString() : undefined as any;
        data["interventionWidth"] = this.interventionWidth;
        data["dose_Gr_Pl"] = this.dose_Gr_Pl;
        data["dose_Kg_Ha_Total"] = this.dose_Kg_Ha_Total;
        data["dose_L_Ha_Total"] = this.dose_L_Ha_Total;
        data["dose_Kg_Ha_Concentrated"] = this.dose_Kg_Ha_Concentrated;
        data["dilution"] = this.dilution;
        data["largeTrickle"] = this.largeTrickle;
        data["depth"] = this.depth;
        data["longitudinalFertilizerBleed"] = this.longitudinalFertilizerBleed;
        data["observation"] = this.observation;
        data["observationOne"] = this.observationOne;
        data["silvicultureTrialId"] = this.silvicultureTrialId;
        data["treatmentObjectiveId"] = this.treatmentObjectiveId;
        data["treatmentParcelTypeId"] = this.treatmentParcelTypeId;
        data["cloneId"] = this.cloneId;
        data["treatmentProductTypeId"] = this.treatmentProductTypeId;
        data["treatmentProductId"] = this.treatmentProductId;
        data["treatmentInterventionZoneId"] = this.treatmentInterventionZoneId;
        data["treatmentInterventionMomentId"] = this.treatmentInterventionMomentId;
        data["treatmentInterventionObjectiveId"] = this.treatmentInterventionObjectiveId;
        data["treatmentApplyOneId"] = this.treatmentApplyOneId;
        data["treatmentApplyTwoId"] = this.treatmentApplyTwoId;
        data["treatmentApplyThreeId"] = this.treatmentApplyThreeId;
        data["treatmentApplyFourId"] = this.treatmentApplyFourId;
        data["treatmentApplyFiveId"] = this.treatmentApplyFiveId;
        data["interventionFoundationsOneId"] = this.interventionFoundationsOneId;
        data["interventionFoundationsTwoId"] = this.interventionFoundationsTwoId;
        data["interventionFoundationsThreeId"] = this.interventionFoundationsThreeId;
        data["treatmentDoseTypeId"] = this.treatmentDoseTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSilvicultureTreatmentNutritionalDto {
    treatment: number;
    treatmentStartDate: DateTime;
    treatmentTag: string;
    interventionDate: DateTime;
    interventionWidth: number | undefined;
    dose_Gr_Pl: number | undefined;
    dose_Kg_Ha_Total: number | undefined;
    dose_L_Ha_Total: number | undefined;
    dose_Kg_Ha_Concentrated: number | undefined;
    dilution: number | undefined;
    largeTrickle: number | undefined;
    depth: number | undefined;
    longitudinalFertilizerBleed: number | undefined;
    observation: string | undefined;
    observationOne: string | undefined;
    silvicultureTrialId: number;
    treatmentObjectiveId: number;
    treatmentParcelTypeId: number;
    cloneId: number;
    treatmentProductTypeId: number;
    treatmentProductId: number;
    treatmentInterventionZoneId: number;
    treatmentInterventionMomentId: number;
    treatmentInterventionObjectiveId: number;
    treatmentApplyOneId: number | undefined;
    treatmentApplyTwoId: number | undefined;
    treatmentApplyThreeId: number | undefined;
    treatmentApplyFourId: number | undefined;
    treatmentApplyFiveId: number | undefined;
    interventionFoundationsOneId: number;
    interventionFoundationsTwoId: number | undefined;
    interventionFoundationsThreeId: number | undefined;
    treatmentDoseTypeId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSilvicultureTrialDto implements ICreateOrEditSilvicultureTrialDto {
    experimentStigma!: string | undefined;
    region!: string;
    zone!: string;
    property!: string;
    stand!: string;
    standArea!: number | undefined;
    cycle!: number | undefined;
    rotation!: number | undefined;
    coneat!: string;
    geology!: string;
    soilUnit!: string;
    specialWords!: string | undefined;
    instalationDate!: DateTime;
    plantationDate!: DateTime | undefined;
    treeDistance!: number | undefined;
    rowDistance!: number | undefined;
    treatmentNumber!: number;
    repeats!: number | undefined;
    treeByParcel!: number | undefined;
    observation!: string | undefined;
    observation2!: string | undefined;
    data!: string | undefined;
    standLatitude!: number | undefined;
    standLength!: number | undefined;
    planningRegime!: string | undefined;
    experimentId!: string;
    groupTrialId!: number;
    experimentTypeId!: number;
    experimentSpecieQuantityId!: number;
    experimentSpecieId!: number;
    stigmaCloneId!: number | undefined;
    experimentLocationId!: number;
    experimentCategoryId!: number;
    experimentClassificationId!: number;
    experimentClasificationtwoId!: number;
    trialDesignTypesId!: number;
    trialStatusId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSilvicultureTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentStigma = _data["experimentStigma"];
            this.region = _data["region"];
            this.zone = _data["zone"];
            this.property = _data["property"];
            this.stand = _data["stand"];
            this.standArea = _data["standArea"];
            this.cycle = _data["cycle"];
            this.rotation = _data["rotation"];
            this.coneat = _data["coneat"];
            this.geology = _data["geology"];
            this.soilUnit = _data["soilUnit"];
            this.specialWords = _data["specialWords"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.treeDistance = _data["treeDistance"];
            this.rowDistance = _data["rowDistance"];
            this.treatmentNumber = _data["treatmentNumber"];
            this.repeats = _data["repeats"];
            this.treeByParcel = _data["treeByParcel"];
            this.observation = _data["observation"];
            this.observation2 = _data["observation2"];
            this.data = _data["data"];
            this.standLatitude = _data["standLatitude"];
            this.standLength = _data["standLength"];
            this.planningRegime = _data["planningRegime"];
            this.experimentId = _data["experimentId"];
            this.groupTrialId = _data["groupTrialId"];
            this.experimentTypeId = _data["experimentTypeId"];
            this.experimentSpecieQuantityId = _data["experimentSpecieQuantityId"];
            this.experimentSpecieId = _data["experimentSpecieId"];
            this.stigmaCloneId = _data["stigmaCloneId"];
            this.experimentLocationId = _data["experimentLocationId"];
            this.experimentCategoryId = _data["experimentCategoryId"];
            this.experimentClassificationId = _data["experimentClassificationId"];
            this.experimentClasificationtwoId = _data["experimentClasificationtwoId"];
            this.trialDesignTypesId = _data["trialDesignTypesId"];
            this.trialStatusId = _data["trialStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSilvicultureTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSilvicultureTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentStigma"] = this.experimentStigma;
        data["region"] = this.region;
        data["zone"] = this.zone;
        data["property"] = this.property;
        data["stand"] = this.stand;
        data["standArea"] = this.standArea;
        data["cycle"] = this.cycle;
        data["rotation"] = this.rotation;
        data["coneat"] = this.coneat;
        data["geology"] = this.geology;
        data["soilUnit"] = this.soilUnit;
        data["specialWords"] = this.specialWords;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["treeDistance"] = this.treeDistance;
        data["rowDistance"] = this.rowDistance;
        data["treatmentNumber"] = this.treatmentNumber;
        data["repeats"] = this.repeats;
        data["treeByParcel"] = this.treeByParcel;
        data["observation"] = this.observation;
        data["observation2"] = this.observation2;
        data["data"] = this.data;
        data["standLatitude"] = this.standLatitude;
        data["standLength"] = this.standLength;
        data["planningRegime"] = this.planningRegime;
        data["experimentId"] = this.experimentId;
        data["groupTrialId"] = this.groupTrialId;
        data["experimentTypeId"] = this.experimentTypeId;
        data["experimentSpecieQuantityId"] = this.experimentSpecieQuantityId;
        data["experimentSpecieId"] = this.experimentSpecieId;
        data["stigmaCloneId"] = this.stigmaCloneId;
        data["experimentLocationId"] = this.experimentLocationId;
        data["experimentCategoryId"] = this.experimentCategoryId;
        data["experimentClassificationId"] = this.experimentClassificationId;
        data["experimentClasificationtwoId"] = this.experimentClasificationtwoId;
        data["trialDesignTypesId"] = this.trialDesignTypesId;
        data["trialStatusId"] = this.trialStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSilvicultureTrialDto {
    experimentStigma: string | undefined;
    region: string;
    zone: string;
    property: string;
    stand: string;
    standArea: number | undefined;
    cycle: number | undefined;
    rotation: number | undefined;
    coneat: string;
    geology: string;
    soilUnit: string;
    specialWords: string | undefined;
    instalationDate: DateTime;
    plantationDate: DateTime | undefined;
    treeDistance: number | undefined;
    rowDistance: number | undefined;
    treatmentNumber: number;
    repeats: number | undefined;
    treeByParcel: number | undefined;
    observation: string | undefined;
    observation2: string | undefined;
    data: string | undefined;
    standLatitude: number | undefined;
    standLength: number | undefined;
    planningRegime: string | undefined;
    experimentId: string;
    groupTrialId: number;
    experimentTypeId: number;
    experimentSpecieQuantityId: number;
    experimentSpecieId: number;
    stigmaCloneId: number | undefined;
    experimentLocationId: number;
    experimentCategoryId: number;
    experimentClassificationId: number;
    experimentClasificationtwoId: number;
    trialDesignTypesId: number;
    trialStatusId: number;
    id: number | undefined;
}

export class CreateOrEditSourcePlantDto implements ICreateOrEditSourcePlantDto {
    groupNumber!: number;
    startDate!: DateTime;
    originSourcePlant!: EnumOriginSourcePlant;
    projectId!: number | undefined;
    measurementSelectionId!: number | undefined;
    measurementSelectionGenomicId!: number | undefined;
    cloneId!: number | undefined;
    sourcePlantId!: number | undefined;
    destineList!: GetBBXDestinationForViewDto[] | undefined;
    initialPlantation!: CreateOrEditSourcePlantPlantationDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSourcePlantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupNumber = _data["groupNumber"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.originSourcePlant = _data["originSourcePlant"];
            this.projectId = _data["projectId"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.measurementSelectionGenomicId = _data["measurementSelectionGenomicId"];
            this.cloneId = _data["cloneId"];
            this.sourcePlantId = _data["sourcePlantId"];
            if (Array.isArray(_data["destineList"])) {
                this.destineList = [] as any;
                for (let item of _data["destineList"])
                    this.destineList!.push(GetBBXDestinationForViewDto.fromJS(item));
            }
            this.initialPlantation = _data["initialPlantation"] ? CreateOrEditSourcePlantPlantationDto.fromJS(_data["initialPlantation"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSourcePlantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSourcePlantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupNumber"] = this.groupNumber;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["originSourcePlant"] = this.originSourcePlant;
        data["projectId"] = this.projectId;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["measurementSelectionGenomicId"] = this.measurementSelectionGenomicId;
        data["cloneId"] = this.cloneId;
        data["sourcePlantId"] = this.sourcePlantId;
        if (Array.isArray(this.destineList)) {
            data["destineList"] = [];
            for (let item of this.destineList)
                data["destineList"].push(item ? item.toJSON() : undefined as any);
        }
        data["initialPlantation"] = this.initialPlantation ? this.initialPlantation.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSourcePlantDto {
    groupNumber: number;
    startDate: DateTime;
    originSourcePlant: EnumOriginSourcePlant;
    projectId: number | undefined;
    measurementSelectionId: number | undefined;
    measurementSelectionGenomicId: number | undefined;
    cloneId: number | undefined;
    sourcePlantId: number | undefined;
    destineList: GetBBXDestinationForViewDto[] | undefined;
    initialPlantation: CreateOrEditSourcePlantPlantationDto;
    id: number | undefined;
}

export class CreateOrEditSourcePlantPlantationDto implements ICreateOrEditSourcePlantPlantationDto {
    plantationDate!: DateTime;
    quantity!: number;
    canaleton!: number;
    position!: number;
    observations!: string | undefined;
    sourcePlantId!: number;
    plantationNumber!: number | undefined;
    discardDate!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSourcePlantPlantationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.quantity = _data["quantity"];
            this.canaleton = _data["canaleton"];
            this.position = _data["position"];
            this.observations = _data["observations"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.plantationNumber = _data["plantationNumber"];
            this.discardDate = _data["discardDate"] ? DateTime.fromISO(_data["discardDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSourcePlantPlantationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSourcePlantPlantationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["quantity"] = this.quantity;
        data["canaleton"] = this.canaleton;
        data["position"] = this.position;
        data["observations"] = this.observations;
        data["sourcePlantId"] = this.sourcePlantId;
        data["plantationNumber"] = this.plantationNumber;
        data["discardDate"] = this.discardDate ? this.discardDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSourcePlantPlantationDto {
    plantationDate: DateTime;
    quantity: number;
    canaleton: number;
    position: number;
    observations: string | undefined;
    sourcePlantId: number;
    plantationNumber: number | undefined;
    discardDate: DateTime | undefined;
    id: number | undefined;
}

export class CreateOrEditSpeciesGroupDto implements ICreateOrEditSpeciesGroupDto {
    name!: string;
    species!: string | undefined;
    formula!: string | undefined;
    siteClassification!: EnumSiteClassification;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.species = _data["species"];
            this.formula = _data["formula"];
            this.siteClassification = _data["siteClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["species"] = this.species;
        data["formula"] = this.formula;
        data["siteClassification"] = this.siteClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSpeciesGroupDto {
    name: string;
    species: string | undefined;
    formula: string | undefined;
    siteClassification: EnumSiteClassification;
    id: number | undefined;
}

export class CreateOrEditSupplierDto implements ICreateOrEditSupplierDto {
    name!: string;
    isFOSA!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFOSA = _data["isFOSA"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFOSA"] = this.isFOSA;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSupplierDto {
    name: string;
    isFOSA: boolean;
    id: number | undefined;
}

export class CreateOrEditTreatmentApplyDto implements ICreateOrEditTreatmentApplyDto {
    apply!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentApplyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apply = _data["apply"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentApplyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentApplyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apply"] = this.apply;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentApplyDto {
    apply: string;
    id: number | undefined;
}

export class CreateOrEditTreatmentDoseTypeDto implements ICreateOrEditTreatmentDoseTypeDto {
    doseType!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentDoseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseType = _data["doseType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentDoseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentDoseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseType"] = this.doseType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentDoseTypeDto {
    doseType: string;
    id: number | undefined;
}

export class CreateOrEditTreatmentDto implements ICreateOrEditTreatmentDto {
    block!: number | undefined;
    subBlock!: number | undefined;
    trialId!: number;
    number!: number;
    treatmentName!: string | undefined;
    bulk!: boolean | undefined;
    trialNumber!: number;
    y!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.trialId = _data["trialId"];
            this.number = _data["number"];
            this.treatmentName = _data["treatmentName"];
            this.bulk = _data["bulk"];
            this.trialNumber = _data["trialNumber"];
            this.y = _data["y"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["trialId"] = this.trialId;
        data["number"] = this.number;
        data["treatmentName"] = this.treatmentName;
        data["bulk"] = this.bulk;
        data["trialNumber"] = this.trialNumber;
        data["y"] = this.y;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentDto {
    block: number | undefined;
    subBlock: number | undefined;
    trialId: number;
    number: number;
    treatmentName: string | undefined;
    bulk: boolean | undefined;
    trialNumber: number;
    y: number;
    id: number | undefined;
}

export class CreateOrEditTreatmentInterventionDto implements ICreateOrEditTreatmentInterventionDto {
    zone!: string | undefined;
    moment!: string | undefined;
    objective!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentInterventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zone = _data["zone"];
            this.moment = _data["moment"];
            this.objective = _data["objective"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentInterventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentInterventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["moment"] = this.moment;
        data["objective"] = this.objective;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentInterventionDto {
    zone: string | undefined;
    moment: string | undefined;
    objective: string | undefined;
    id: number | undefined;
}

export class CreateOrEditTreatmentObjectiveDto implements ICreateOrEditTreatmentObjectiveDto {
    objective!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objective = _data["objective"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objective"] = this.objective;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentObjectiveDto {
    objective: string;
    id: number | undefined;
}

export class CreateOrEditTreatmentParcelTypeDto implements ICreateOrEditTreatmentParcelTypeDto {
    parcelType!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentParcelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parcelType = _data["parcelType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentParcelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentParcelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parcelType"] = this.parcelType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentParcelTypeDto {
    parcelType: string;
    id: number | undefined;
}

export class CreateOrEditTreatmentProductDto implements ICreateOrEditTreatmentProductDto {
    name!: string;
    abbreviation!: string;
    manufacturer!: string | undefined;
    composition!: string;
    tdl!: string;
    fertilizerType!: string;
    formulation!: string | undefined;
    observation!: string | undefined;
    bioforestCode!: string | undefined;
    treatmentProductName!: string | undefined;
    treatmentProductTypeId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.manufacturer = _data["manufacturer"];
            this.composition = _data["composition"];
            this.tdl = _data["tdl"];
            this.fertilizerType = _data["fertilizerType"];
            this.formulation = _data["formulation"];
            this.observation = _data["observation"];
            this.bioforestCode = _data["bioforestCode"];
            this.treatmentProductName = _data["treatmentProductName"];
            this.treatmentProductTypeId = _data["treatmentProductTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["manufacturer"] = this.manufacturer;
        data["composition"] = this.composition;
        data["tdl"] = this.tdl;
        data["fertilizerType"] = this.fertilizerType;
        data["formulation"] = this.formulation;
        data["observation"] = this.observation;
        data["bioforestCode"] = this.bioforestCode;
        data["treatmentProductName"] = this.treatmentProductName;
        data["treatmentProductTypeId"] = this.treatmentProductTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentProductDto {
    name: string;
    abbreviation: string;
    manufacturer: string | undefined;
    composition: string;
    tdl: string;
    fertilizerType: string;
    formulation: string | undefined;
    observation: string | undefined;
    bioforestCode: string | undefined;
    treatmentProductName: string | undefined;
    treatmentProductTypeId: number;
    id: number | undefined;
}

export class CreateOrEditTreatmentProductTypeDto implements ICreateOrEditTreatmentProductTypeDto {
    productType!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreatmentProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productType = _data["productType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreatmentProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreatmentProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreatmentProductTypeDto {
    productType: string;
    id: number | undefined;
}

export class CreateOrEditTreeDto implements ICreateOrEditTreeDto {
    treeNumber!: number;
    specie!: string | undefined;
    plantationDate!: DateTime | undefined;
    ns!: string | undefined;
    nx!: string | undefined;
    row!: number | undefined;
    plot!: string | undefined;
    x!: number | undefined;
    y!: number | undefined;
    originalTreeId!: number | undefined;
    treatmentId!: number;
    order!: number;
    treeStatusId!: number | undefined;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    seedlingId!: number | undefined;
    originTrayId!: EnumOriginSourcePlant;
    qualityCode!: string | undefined;
    renewalDate!: DateTime | undefined;
    trialNumber!: number | undefined;
    block!: number | undefined;
    subBlock!: number | undefined;
    isHSCRenewal!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.specie = _data["specie"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.ns = _data["ns"];
            this.nx = _data["nx"];
            this.row = _data["row"];
            this.plot = _data["plot"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.originalTreeId = _data["originalTreeId"];
            this.treatmentId = _data["treatmentId"];
            this.order = _data["order"];
            this.treeStatusId = _data["treeStatusId"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.seedlingId = _data["seedlingId"];
            this.originTrayId = _data["originTrayId"];
            this.qualityCode = _data["qualityCode"];
            this.renewalDate = _data["renewalDate"] ? DateTime.fromISO(_data["renewalDate"].toString()) : undefined as any;
            this.trialNumber = _data["trialNumber"];
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.isHSCRenewal = _data["isHSCRenewal"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["specie"] = this.specie;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["ns"] = this.ns;
        data["nx"] = this.nx;
        data["row"] = this.row;
        data["plot"] = this.plot;
        data["x"] = this.x;
        data["y"] = this.y;
        data["originalTreeId"] = this.originalTreeId;
        data["treatmentId"] = this.treatmentId;
        data["order"] = this.order;
        data["treeStatusId"] = this.treeStatusId;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["seedlingId"] = this.seedlingId;
        data["originTrayId"] = this.originTrayId;
        data["qualityCode"] = this.qualityCode;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toString() : undefined as any;
        data["trialNumber"] = this.trialNumber;
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["isHSCRenewal"] = this.isHSCRenewal;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeDto {
    treeNumber: number;
    specie: string | undefined;
    plantationDate: DateTime | undefined;
    ns: string | undefined;
    nx: string | undefined;
    row: number | undefined;
    plot: string | undefined;
    x: number | undefined;
    y: number | undefined;
    originalTreeId: number | undefined;
    treatmentId: number;
    order: number;
    treeStatusId: number | undefined;
    seedId: number | undefined;
    cloneId: number | undefined;
    seedlingId: number | undefined;
    originTrayId: EnumOriginSourcePlant;
    qualityCode: string | undefined;
    renewalDate: DateTime | undefined;
    trialNumber: number | undefined;
    block: number | undefined;
    subBlock: number | undefined;
    isHSCRenewal: boolean;
    id: number | undefined;
}

export class CreateOrEditTreeManagementDto implements ICreateOrEditTreeManagementDto {
    treeOld!: string;
    dateModified!: DateTime;
    treeNew!: string | undefined;
    treeId!: number;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeOld = _data["treeOld"];
            this.dateModified = _data["dateModified"] ? DateTime.fromISO(_data["dateModified"].toString()) : undefined as any;
            this.treeNew = _data["treeNew"];
            this.treeId = _data["treeId"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeOld"] = this.treeOld;
        data["dateModified"] = this.dateModified ? this.dateModified.toString() : undefined as any;
        data["treeNew"] = this.treeNew;
        data["treeId"] = this.treeId;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeManagementDto {
    treeOld: string;
    dateModified: DateTime;
    treeNew: string | undefined;
    treeId: number;
    seedId: number | undefined;
    cloneId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditTreeMeasurementAlertDto implements ICreateOrEditTreeMeasurementAlertDto {
    date!: DateTime;
    code!: EnumTreeMeasurementAlert;
    height!: number | undefined;
    dap!: number | undefined;
    trialId!: number;
    treeName!: string | undefined;
    previousHeight!: number | undefined;
    previousDap!: number | undefined;
    defectHeight!: number | undefined;
    observations!: string | undefined;
    adultObservationCodeId!: number | undefined;
    measurementPlaningOptionsId!: number;
    treeStatusId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeMeasurementAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.code = _data["code"];
            this.height = _data["height"];
            this.dap = _data["dap"];
            this.trialId = _data["trialId"];
            this.treeName = _data["treeName"];
            this.previousHeight = _data["previousHeight"];
            this.previousDap = _data["previousDap"];
            this.defectHeight = _data["defectHeight"];
            this.observations = _data["observations"];
            this.adultObservationCodeId = _data["adultObservationCodeId"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeMeasurementAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeMeasurementAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["code"] = this.code;
        data["height"] = this.height;
        data["dap"] = this.dap;
        data["trialId"] = this.trialId;
        data["treeName"] = this.treeName;
        data["previousHeight"] = this.previousHeight;
        data["previousDap"] = this.previousDap;
        data["defectHeight"] = this.defectHeight;
        data["observations"] = this.observations;
        data["adultObservationCodeId"] = this.adultObservationCodeId;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeMeasurementAlertDto {
    date: DateTime;
    code: EnumTreeMeasurementAlert;
    height: number | undefined;
    dap: number | undefined;
    trialId: number;
    treeName: string | undefined;
    previousHeight: number | undefined;
    previousDap: number | undefined;
    defectHeight: number | undefined;
    observations: string | undefined;
    adultObservationCodeId: number | undefined;
    measurementPlaningOptionsId: number;
    treeStatusId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditTreeMeasurementDto implements ICreateOrEditTreeMeasurementDto {
    measurementDate!: DateTime;
    dap!: number | undefined;
    height!: number | undefined;
    volume!: number | undefined;
    defectHeight!: number | undefined;
    sobre!: number | undefined;
    observations!: string | undefined;
    flia!: string | undefined;
    treeId!: number;
    adultObservationCodeId!: number | undefined;
    frostToleranceCodeId!: number | undefined;
    pestAndDiseaseCodeId!: number | undefined;
    pestAndDiseaseCodeSeverity!: number | undefined;
    pestAndDiseaseCodeIntensity!: number | undefined;
    measurementPlaningOptionsId!: number | undefined;
    trialId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementDate = _data["measurementDate"] ? DateTime.fromISO(_data["measurementDate"].toString()) : undefined as any;
            this.dap = _data["dap"];
            this.height = _data["height"];
            this.volume = _data["volume"];
            this.defectHeight = _data["defectHeight"];
            this.sobre = _data["sobre"];
            this.observations = _data["observations"];
            this.flia = _data["flia"];
            this.treeId = _data["treeId"];
            this.adultObservationCodeId = _data["adultObservationCodeId"];
            this.frostToleranceCodeId = _data["frostToleranceCodeId"];
            this.pestAndDiseaseCodeId = _data["pestAndDiseaseCodeId"];
            this.pestAndDiseaseCodeSeverity = _data["pestAndDiseaseCodeSeverity"];
            this.pestAndDiseaseCodeIntensity = _data["pestAndDiseaseCodeIntensity"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.trialId = _data["trialId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toString() : undefined as any;
        data["dap"] = this.dap;
        data["height"] = this.height;
        data["volume"] = this.volume;
        data["defectHeight"] = this.defectHeight;
        data["sobre"] = this.sobre;
        data["observations"] = this.observations;
        data["flia"] = this.flia;
        data["treeId"] = this.treeId;
        data["adultObservationCodeId"] = this.adultObservationCodeId;
        data["frostToleranceCodeId"] = this.frostToleranceCodeId;
        data["pestAndDiseaseCodeId"] = this.pestAndDiseaseCodeId;
        data["pestAndDiseaseCodeSeverity"] = this.pestAndDiseaseCodeSeverity;
        data["pestAndDiseaseCodeIntensity"] = this.pestAndDiseaseCodeIntensity;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["trialId"] = this.trialId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeMeasurementDto {
    measurementDate: DateTime;
    dap: number | undefined;
    height: number | undefined;
    volume: number | undefined;
    defectHeight: number | undefined;
    sobre: number | undefined;
    observations: string | undefined;
    flia: string | undefined;
    treeId: number;
    adultObservationCodeId: number | undefined;
    frostToleranceCodeId: number | undefined;
    pestAndDiseaseCodeId: number | undefined;
    pestAndDiseaseCodeSeverity: number | undefined;
    pestAndDiseaseCodeIntensity: number | undefined;
    measurementPlaningOptionsId: number | undefined;
    trialId: number;
    id: number | undefined;
}

export class CreateOrEditTreeStatusDto implements ICreateOrEditTreeStatusDto {
    name!: string;
    code!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeStatusDto {
    name: string;
    code: number;
    id: number | undefined;
}

export class CreateOrEditTreeTreatmentDto implements ICreateOrEditTreeTreatmentDto {
    tree!: CreateOrEditTreeDto;
    treatment!: CreateOrEditTreatmentDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTreeTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tree = _data["tree"] ? CreateOrEditTreeDto.fromJS(_data["tree"]) : undefined as any;
            this.treatment = _data["treatment"] ? CreateOrEditTreatmentDto.fromJS(_data["treatment"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTreeTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTreeTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["treatment"] = this.treatment ? this.treatment.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTreeTreatmentDto {
    tree: CreateOrEditTreeDto;
    treatment: CreateOrEditTreatmentDto;
    id: number | undefined;
}

export class CreateOrEditTrialDesignTypesDto implements ICreateOrEditTrialDesignTypesDto {
    name!: string;
    isDividedPlots!: boolean;
    isAlfaLaticeAsterisk!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrialDesignTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDividedPlots = _data["isDividedPlots"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrialDesignTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrialDesignTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDividedPlots"] = this.isDividedPlots;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrialDesignTypesDto {
    name: string;
    isDividedPlots: boolean;
    isAlfaLaticeAsterisk: boolean;
    id: number | undefined;
}

export class CreateOrEditTrialDto implements ICreateOrEditTrialDto {
    trialNumber!: number;
    region!: string;
    oldTrialDenomination!: string | undefined;
    district!: string | undefined;
    zone!: string;
    plantationDate!: DateTime;
    area!: number | undefined;
    treatments!: number | undefined;
    totalTrees!: number | undefined;
    observation!: string | undefined;
    distanceBetweenPlants!: number;
    distanceBetweenRows!: number;
    data!: number | undefined;
    apsServiceOrder!: boolean;
    planningStatus!: string | undefined;
    instalationDate!: DateTime | undefined;
    standName!: string;
    farmName!: string;
    oldStandName!: string | undefined;
    coneat!: string;
    typeTrialId!: number;
    trialDesignTypesId!: number;
    trialStatusId!: number;
    density!: number;
    isGenomicSelection!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialNumber = _data["trialNumber"];
            this.region = _data["region"];
            this.oldTrialDenomination = _data["oldTrialDenomination"];
            this.district = _data["district"];
            this.zone = _data["zone"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.area = _data["area"];
            this.treatments = _data["treatments"];
            this.totalTrees = _data["totalTrees"];
            this.observation = _data["observation"];
            this.distanceBetweenPlants = _data["distanceBetweenPlants"];
            this.distanceBetweenRows = _data["distanceBetweenRows"];
            this.data = _data["data"];
            this.apsServiceOrder = _data["apsServiceOrder"];
            this.planningStatus = _data["planningStatus"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.standName = _data["standName"];
            this.farmName = _data["farmName"];
            this.oldStandName = _data["oldStandName"];
            this.coneat = _data["coneat"];
            this.typeTrialId = _data["typeTrialId"];
            this.trialDesignTypesId = _data["trialDesignTypesId"];
            this.trialStatusId = _data["trialStatusId"];
            this.density = _data["density"];
            this.isGenomicSelection = _data["isGenomicSelection"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialNumber"] = this.trialNumber;
        data["region"] = this.region;
        data["oldTrialDenomination"] = this.oldTrialDenomination;
        data["district"] = this.district;
        data["zone"] = this.zone;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["area"] = this.area;
        data["treatments"] = this.treatments;
        data["totalTrees"] = this.totalTrees;
        data["observation"] = this.observation;
        data["distanceBetweenPlants"] = this.distanceBetweenPlants;
        data["distanceBetweenRows"] = this.distanceBetweenRows;
        data["data"] = this.data;
        data["apsServiceOrder"] = this.apsServiceOrder;
        data["planningStatus"] = this.planningStatus;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["standName"] = this.standName;
        data["farmName"] = this.farmName;
        data["oldStandName"] = this.oldStandName;
        data["coneat"] = this.coneat;
        data["typeTrialId"] = this.typeTrialId;
        data["trialDesignTypesId"] = this.trialDesignTypesId;
        data["trialStatusId"] = this.trialStatusId;
        data["density"] = this.density;
        data["isGenomicSelection"] = this.isGenomicSelection;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrialDto {
    trialNumber: number;
    region: string;
    oldTrialDenomination: string | undefined;
    district: string | undefined;
    zone: string;
    plantationDate: DateTime;
    area: number | undefined;
    treatments: number | undefined;
    totalTrees: number | undefined;
    observation: string | undefined;
    distanceBetweenPlants: number;
    distanceBetweenRows: number;
    data: number | undefined;
    apsServiceOrder: boolean;
    planningStatus: string | undefined;
    instalationDate: DateTime | undefined;
    standName: string;
    farmName: string;
    oldStandName: string | undefined;
    coneat: string;
    typeTrialId: number;
    trialDesignTypesId: number;
    trialStatusId: number;
    density: number;
    isGenomicSelection: boolean;
    id: number | undefined;
}

export class CreateOrEditTrialStatusDto implements ICreateOrEditTrialStatusDto {
    name!: string;
    isPlanned!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrialStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPlanned = _data["isPlanned"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrialStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrialStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPlanned"] = this.isPlanned;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrialStatusDto {
    name: string;
    isPlanned: boolean;
    id: number | undefined;
}

export class CreateOrEditTypeGeneticMaterialDto implements ICreateOrEditTypeGeneticMaterialDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTypeGeneticMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTypeGeneticMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTypeGeneticMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTypeGeneticMaterialDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditTypeSpecieDto implements ICreateOrEditTypeSpecieDto {
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTypeSpecieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTypeSpecieDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTypeSpecieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTypeSpecieDto {
    name: string;
    id: number | undefined;
}

export class CreateOrEditTypeTrialDto implements ICreateOrEditTypeTrialDto {
    name!: string;
    category!: string;
    groupTrialId!: number;
    isClonalSeedOrchard!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTypeTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.groupTrialId = _data["groupTrialId"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTypeTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTypeTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["groupTrialId"] = this.groupTrialId;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTypeTrialDto {
    name: string;
    category: string;
    groupTrialId: number;
    isClonalSeedOrchard: boolean;
    id: number | undefined;
}

export class CreateOrEditWoodSampleTypeDto implements ICreateOrEditWoodSampleTypeDto {
    name!: string;
    isTreeCut!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditWoodSampleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isTreeCut = _data["isTreeCut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWoodSampleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditWoodSampleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isTreeCut"] = this.isTreeCut;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditWoodSampleTypeDto {
    name: string;
    isTreeCut: boolean;
    id: number | undefined;
}

export class CreateOrEditYoungObservationCodeDto implements ICreateOrEditYoungObservationCodeDto {
    code!: number;
    detail!: string;
    treeStatusId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditYoungObservationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditYoungObservationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditYoungObservationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditYoungObservationCodeDto {
    code: number;
    detail: string;
    treeStatusId: number;
    id: number | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class CrossingTechnique implements ICrossingTechnique {
    tenantId!: number | undefined;
    name!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICrossingTechnique) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CrossingTechnique {
        data = typeof data === 'object' ? data : {};
        let result = new CrossingTechnique();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICrossingTechnique {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CrossingTechniqueDto implements ICrossingTechniqueDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ICrossingTechniqueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CrossingTechniqueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossingTechniqueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICrossingTechniqueDto {
    name: string | undefined;
    id: number;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class CustomAttributeData implements ICustomAttributeData {
    readonly attributeType!: string | undefined;
    constructor_!: ConstructorInfo;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments!: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : undefined as any;
            if (Array.isArray(_data["constructorArguments"])) {
                (this as any).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (this as any).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (this as any).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (this as any).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined as any;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: string | undefined;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | undefined;
    readonly isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : undefined as any;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : undefined as any;
            (this as any).memberName = _data["memberName"];
            (this as any).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined as any;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined as any;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: string | undefined;
    value!: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: string | undefined;
    value: any | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class DestinoBBXDto implements IDestinoBBXDto {
    plantMother!: number | undefined;
    statusid!: number | undefined;
    fecha!: DateTime;
    destine!: number;
    bbXid!: number | undefined;
    projectId!: number | undefined;
    bbtId!: number | undefined;
    isTrial!: boolean;
    sourcePlantId!: number | undefined;
    origin!: string | undefined;
    originId!: string | undefined;
    measurementGenomicSelectionId!: number | undefined;
    id!: number;

    constructor(data?: IDestinoBBXDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantMother = _data["plantMother"];
            this.statusid = _data["statusid"];
            this.fecha = _data["fecha"] ? DateTime.fromISO(_data["fecha"].toString()) : undefined as any;
            this.destine = _data["destine"];
            this.bbXid = _data["bbXid"];
            this.projectId = _data["projectId"];
            this.bbtId = _data["bbtId"];
            this.isTrial = _data["isTrial"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.origin = _data["origin"];
            this.originId = _data["originId"];
            this.measurementGenomicSelectionId = _data["measurementGenomicSelectionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DestinoBBXDto {
        data = typeof data === 'object' ? data : {};
        let result = new DestinoBBXDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantMother"] = this.plantMother;
        data["statusid"] = this.statusid;
        data["fecha"] = this.fecha ? this.fecha.toString() : undefined as any;
        data["destine"] = this.destine;
        data["bbXid"] = this.bbXid;
        data["projectId"] = this.projectId;
        data["bbtId"] = this.bbtId;
        data["isTrial"] = this.isTrial;
        data["sourcePlantId"] = this.sourcePlantId;
        data["origin"] = this.origin;
        data["originId"] = this.originId;
        data["measurementGenomicSelectionId"] = this.measurementGenomicSelectionId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDestinoBBXDto {
    plantMother: number | undefined;
    statusid: number | undefined;
    fecha: DateTime;
    destine: number;
    bbXid: number | undefined;
    projectId: number | undefined;
    bbtId: number | undefined;
    isTrial: boolean;
    sourcePlantId: number | undefined;
    origin: string | undefined;
    originId: string | undefined;
    measurementGenomicSelectionId: number | undefined;
    id: number;
}

export class DownloadDeleteFilesBlobStorageDto implements IDownloadDeleteFilesBlobStorageDto {
    fileName!: string | undefined;
    isMassive!: boolean;
    id!: number;

    constructor(data?: IDownloadDeleteFilesBlobStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.isMassive = _data["isMassive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadDeleteFilesBlobStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDeleteFilesBlobStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["isMassive"] = this.isMassive;
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadDeleteFilesBlobStorageDto {
    fileName: string | undefined;
    isMassive: boolean;
    id: number;
}

export class DynamicEntityPropertyDto implements IDynamicEntityPropertyDto {
    entityFullName!: string | undefined;
    dynamicPropertyName!: string | undefined;
    dynamicPropertyId!: number;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
            this.dynamicPropertyName = _data["dynamicPropertyName"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        data["dynamicPropertyName"] = this.dynamicPropertyName;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyDto {
    entityFullName: string | undefined;
    dynamicPropertyName: string | undefined;
    dynamicPropertyId: number;
    tenantId: number | undefined;
    id: number;
}

export class DynamicEntityPropertyValueDto implements IDynamicEntityPropertyValueDto {
    value!: string | undefined;
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyValueDto {
    value: string | undefined;
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    id: number;
}

export class DynamicPropertyDto implements IDynamicPropertyDto {
    propertyName!: string | undefined;
    displayName!: string | undefined;
    inputType!: string | undefined;
    permission!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.displayName = _data["displayName"];
            this.inputType = _data["inputType"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["displayName"] = this.displayName;
        data["inputType"] = this.inputType;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyDto {
    propertyName: string | undefined;
    displayName: string | undefined;
    inputType: string | undefined;
    permission: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class DynamicPropertyValueDto implements IDynamicPropertyValueDto {
    value!: string | undefined;
    tenantId!: number | undefined;
    dynamicPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyValueDto {
    value: string | undefined;
    tenantId: number | undefined;
    dynamicPropertyId: number;
    id: number;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : undefined as any;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : undefined as any;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : undefined as any;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (this as any).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : undefined as any;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export enum EnumCloneOrigin {
    Genetics = 0,
    Imported = 1,
    EvaluationClone = 2,
    SourcePlant = 3,
}

export enum EnumMeasurementPlaningStatus {
    Design = 0,
    Planing = 1,
    InMeasurement = 2,
    Measured = 3,
    Synchronized = 4,
}

export enum EnumOriginSourcePlant {
    None = 0,
    Origen_MJ = 1,
    Captura = 2,
    Micropropagación = 3,
    SeleccionGenomica = 4,
    Importado = 5,
    Clonal = 6,
}

export enum EnumSiteClassification {
    None = 0,
    Alto = 1,
    Bajo = 2,
}

export enum EnumTreeMeasurementAlert {
    LowerDap = 0,
    LowerHeight = 1,
    InconsistentStatus = 2,
}

export enum EnumTypeHarvest {
    Indefinido = 0,
    Semilla = 1,
    Clon = 2,
}

export enum EnumWhitRooting {
    All = 0,
    Yes = 1,
    No = 2,
}

export class ExperimentCategoryDto implements IExperimentCategoryDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentCategoryDto {
    name: string | undefined;
    id: number;
}

export class ExperimentClasificationtwoDto implements IExperimentClasificationtwoDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentClasificationtwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentClasificationtwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentClasificationtwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentClasificationtwoDto {
    name: string | undefined;
    id: number;
}

export class ExperimentClassificationDto implements IExperimentClassificationDto {
    name!: string | undefined;
    experimentCategoryId!: number | undefined;
    id!: number;

    constructor(data?: IExperimentClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.experimentCategoryId = _data["experimentCategoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["experimentCategoryId"] = this.experimentCategoryId;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentClassificationDto {
    name: string | undefined;
    experimentCategoryId: number | undefined;
    id: number;
}

export class ExperimentClassificationExperimentCategoryLookupTableDto implements IExperimentClassificationExperimentCategoryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IExperimentClassificationExperimentCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ExperimentClassificationExperimentCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentClassificationExperimentCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IExperimentClassificationExperimentCategoryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ExperimentLocationDto implements IExperimentLocationDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentLocationDto {
    name: string | undefined;
    id: number;
}

export class ExperimentSpecieDto implements IExperimentSpecieDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentSpecieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentSpecieDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentSpecieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentSpecieDto {
    name: string | undefined;
    id: number;
}

export class ExperimentSpecieQuantityDto implements IExperimentSpecieQuantityDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentSpecieQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentSpecieQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentSpecieQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentSpecieQuantityDto {
    name: string | undefined;
    id: number;
}

export class ExperimentStigmaDto implements IExperimentStigmaDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentStigmaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentStigmaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStigmaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentStigmaDto {
    name: string | undefined;
    id: number;
}

export class ExperimentTypeDto implements IExperimentTypeDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExperimentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentTypeDto {
    name: string | undefined;
    id: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class ExportTypesDto implements IExportTypesDto {
    image!: string | undefined;
    pdf!: string | undefined;

    constructor(data?: IExportTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.pdf = _data["pdf"];
        }
    }

    static fromJS(data: any): ExportTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["pdf"] = this.pdf;
        return data;
    }
}

export interface IExportTypesDto {
    image: string | undefined;
    pdf: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    userId!: number | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    userId: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (this.additionalParams as any)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (data["additionalParams"] as any)[key] = (this.additionalParams as any)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : undefined as any;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : undefined as any;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : undefined as any;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : undefined as any;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : undefined as any;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : undefined as any;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : undefined as any;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : undefined as any;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : undefined as any;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : undefined as any;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : undefined as any;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item ? item.toJSON() : undefined as any);
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : undefined as any;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : undefined as any;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : undefined as any;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined as any;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FileBlobDto implements IFileBlobDto {
    fileName!: string | undefined;
    fileFormat!: string | undefined;
    fileUploadDate!: DateTime;
    storageLocation!: string | undefined;
    fileTag!: string | undefined;
    fileSize!: number;
    id!: number | undefined;

    constructor(data?: IFileBlobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileFormat = _data["fileFormat"];
            this.fileUploadDate = _data["fileUploadDate"] ? DateTime.fromISO(_data["fileUploadDate"].toString()) : undefined as any;
            this.storageLocation = _data["storageLocation"];
            this.fileTag = _data["fileTag"];
            this.fileSize = _data["fileSize"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileBlobDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileBlobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileFormat"] = this.fileFormat;
        data["fileUploadDate"] = this.fileUploadDate ? this.fileUploadDate.toString() : undefined as any;
        data["storageLocation"] = this.storageLocation;
        data["fileTag"] = this.fileTag;
        data["fileSize"] = this.fileSize;
        data["id"] = this.id;
        return data;
    }
}

export interface IFileBlobDto {
    fileName: string | undefined;
    fileFormat: string | undefined;
    fileUploadDate: DateTime;
    storageLocation: string | undefined;
    fileTag: string | undefined;
    fileSize: number;
    id: number | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;
    data!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["data"] = this.data;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
    data: string | undefined;
}

export class FileUploadOutput implements IFileUploadOutput {
    error!: boolean;
    fileName!: string | undefined;
    fileType!: string | undefined;
    code!: number;
    message!: string | undefined;
    details!: string | undefined;
    validationErrors!: ValidationErrorInfo[] | undefined;

    constructor(data?: IFileUploadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileUploadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileUploadOutput {
    error: boolean;
    fileName: string | undefined;
    fileType: string | undefined;
    code: number;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class FilterTypesDto implements IFilterTypesDto {
    species!: string | undefined;
    clonalEvaluation!: string | undefined;
    rootingPercentage!: string | undefined;
    production!: string | undefined;

    constructor(data?: IFilterTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.species = _data["species"];
            this.clonalEvaluation = _data["clonalEvaluation"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.production = _data["production"];
        }
    }

    static fromJS(data: any): FilterTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["species"] = this.species;
        data["clonalEvaluation"] = this.clonalEvaluation;
        data["rootingPercentage"] = this.rootingPercentage;
        data["production"] = this.production;
        return data;
    }
}

export interface IFilterTypesDto {
    species: string | undefined;
    clonalEvaluation: string | undefined;
    rootingPercentage: string | undefined;
    production: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : undefined as any;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : undefined as any;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class FrostToleranceDto implements IFrostToleranceDto {
    name!: string | undefined;
    code!: number;
    id!: number;

    constructor(data?: IFrostToleranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FrostToleranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrostToleranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IFrostToleranceDto {
    name: string | undefined;
    code: number;
    id: number;
}

export class FuncOfIServiceProviderIHealthCheck implements IFuncOfIServiceProviderIHealthCheck {
    readonly hasSingleTarget!: boolean;
    readonly target!: any | undefined;
    method!: MethodInfo;

    constructor(data?: IFuncOfIServiceProviderIHealthCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).hasSingleTarget = _data["hasSingleTarget"];
            (this as any).target = _data["target"];
            this.method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : undefined as any;
        }
    }

    static fromJS(data: any): FuncOfIServiceProviderIHealthCheck {
        data = typeof data === 'object' ? data : {};
        let result = new FuncOfIServiceProviderIHealthCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSingleTarget"] = this.hasSingleTarget;
        data["target"] = this.target;
        data["method"] = this.method ? this.method.toJSON() : undefined as any;
        return data;
    }
}

export interface IFuncOfIServiceProviderIHealthCheck {
    hasSingleTarget: boolean;
    target: any | undefined;
    method: MethodInfo;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GeneticLookupTableResponseDto implements IGeneticLookupTableResponseDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneticLookupTableResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GeneticLookupTableResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneticLookupTableResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGeneticLookupTableResponseDto {
    id: number;
    displayName: string | undefined;
}

export class GenomicSeleccionDto implements IGenomicSeleccionDto {
    projectType!: string | undefined;
    projectStatus!: string | undefined;
    projectName!: string | undefined;
    subProject!: string | undefined;
    year!: number;
    specie!: string | undefined;
    specieName!: string | undefined;
    specieType!: string | undefined;
    treatmentType!: string | undefined;
    geneticMeterial!: string | undefined;
    motherId!: string | undefined;
    fatherId!: string | undefined;
    sampleType!: string | undefined;
    sampleDate!: DateTime;
    seedling!: number;
    seedlingName!: string | undefined;
    seedling_GS!: string | undefined;
    projectId!: number | undefined;
    seedlingId!: number | undefined;
    tag!: string | undefined;
    id!: number;

    constructor(data?: IGenomicSeleccionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectType = _data["projectType"];
            this.projectStatus = _data["projectStatus"];
            this.projectName = _data["projectName"];
            this.subProject = _data["subProject"];
            this.year = _data["year"];
            this.specie = _data["specie"];
            this.specieName = _data["specieName"];
            this.specieType = _data["specieType"];
            this.treatmentType = _data["treatmentType"];
            this.geneticMeterial = _data["geneticMeterial"];
            this.motherId = _data["motherId"];
            this.fatherId = _data["fatherId"];
            this.sampleType = _data["sampleType"];
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : undefined as any;
            this.seedling = _data["seedling"];
            this.seedlingName = _data["seedlingName"];
            this.seedling_GS = _data["seedling_GS"];
            this.projectId = _data["projectId"];
            this.seedlingId = _data["seedlingId"];
            this.tag = _data["tag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GenomicSeleccionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenomicSeleccionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectType"] = this.projectType;
        data["projectStatus"] = this.projectStatus;
        data["projectName"] = this.projectName;
        data["subProject"] = this.subProject;
        data["year"] = this.year;
        data["specie"] = this.specie;
        data["specieName"] = this.specieName;
        data["specieType"] = this.specieType;
        data["treatmentType"] = this.treatmentType;
        data["geneticMeterial"] = this.geneticMeterial;
        data["motherId"] = this.motherId;
        data["fatherId"] = this.fatherId;
        data["sampleType"] = this.sampleType;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : undefined as any;
        data["seedling"] = this.seedling;
        data["seedlingName"] = this.seedlingName;
        data["seedling_GS"] = this.seedling_GS;
        data["projectId"] = this.projectId;
        data["seedlingId"] = this.seedlingId;
        data["tag"] = this.tag;
        data["id"] = this.id;
        return data;
    }
}

export interface IGenomicSeleccionDto {
    projectType: string | undefined;
    projectStatus: string | undefined;
    projectName: string | undefined;
    subProject: string | undefined;
    year: number;
    specie: string | undefined;
    specieName: string | undefined;
    specieType: string | undefined;
    treatmentType: string | undefined;
    geneticMeterial: string | undefined;
    motherId: string | undefined;
    fatherId: string | undefined;
    sampleType: string | undefined;
    sampleDate: DateTime;
    seedling: number;
    seedlingName: string | undefined;
    seedling_GS: string | undefined;
    projectId: number | undefined;
    seedlingId: number | undefined;
    tag: string | undefined;
    id: number;
}

export class GenomicSeleccionProjectLookupTableDto implements IGenomicSeleccionProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGenomicSeleccionProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GenomicSeleccionProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenomicSeleccionProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGenomicSeleccionProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GenomicSeleccionSeedlingLookupTableDto implements IGenomicSeleccionSeedlingLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGenomicSeleccionSeedlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GenomicSeleccionSeedlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenomicSeleccionSeedlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGenomicSeleccionSeedlingLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetAdultObservationCodeForEditOutput implements IGetAdultObservationCodeForEditOutput {
    adultObservationCode!: CreateOrEditAdultObservationCodeDto;
    treeStatusName!: string | undefined;

    constructor(data?: IGetAdultObservationCodeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adultObservationCode = _data["adultObservationCode"] ? CreateOrEditAdultObservationCodeDto.fromJS(_data["adultObservationCode"]) : undefined as any;
            this.treeStatusName = _data["treeStatusName"];
        }
    }

    static fromJS(data: any): GetAdultObservationCodeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdultObservationCodeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adultObservationCode"] = this.adultObservationCode ? this.adultObservationCode.toJSON() : undefined as any;
        data["treeStatusName"] = this.treeStatusName;
        return data;
    }
}

export interface IGetAdultObservationCodeForEditOutput {
    adultObservationCode: CreateOrEditAdultObservationCodeDto;
    treeStatusName: string | undefined;
}

export class GetAdultObservationCodeForViewDto implements IGetAdultObservationCodeForViewDto {
    adultObservationCode!: AdultObservationCodeDto;
    treeStatusName!: string | undefined;

    constructor(data?: IGetAdultObservationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adultObservationCode = _data["adultObservationCode"] ? AdultObservationCodeDto.fromJS(_data["adultObservationCode"]) : undefined as any;
            this.treeStatusName = _data["treeStatusName"];
        }
    }

    static fromJS(data: any): GetAdultObservationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdultObservationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adultObservationCode"] = this.adultObservationCode ? this.adultObservationCode.toJSON() : undefined as any;
        data["treeStatusName"] = this.treeStatusName;
        return data;
    }
}

export interface IGetAdultObservationCodeForViewDto {
    adultObservationCode: AdultObservationCodeDto;
    treeStatusName: string | undefined;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetAllAvailableWebhooksOutput {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutput implements IGetAllDynamicEntityPropertyValuesOutput {
    items!: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllDynamicEntityPropertyValuesOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutput {
    items: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutputItem implements IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId!: number;
    propertyName!: string | undefined;
    inputType!: IInputType;
    selectedValues!: string[] | undefined;
    allValuesInputTypeHas!: string[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.propertyName = _data["propertyName"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : undefined as any;
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(item);
            }
            if (Array.isArray(_data["allValuesInputTypeHas"])) {
                this.allValuesInputTypeHas = [] as any;
                for (let item of _data["allValuesInputTypeHas"])
                    this.allValuesInputTypeHas!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["propertyName"] = this.propertyName;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item);
        }
        if (Array.isArray(this.allValuesInputTypeHas)) {
            data["allValuesInputTypeHas"] = [];
            for (let item of this.allValuesInputTypeHas)
                data["allValuesInputTypeHas"].push(item);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId: number;
    propertyName: string | undefined;
    inputType: IInputType;
    selectedValues: string[] | undefined;
    allValuesInputTypeHas: string[] | undefined;
}

export class GetAllEntitiesHasDynamicPropertyOutput implements IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName!: string | undefined;

    constructor(data?: IGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
        }
    }

    static fromJS(data: any): GetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        return data;
    }
}

export interface IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName: string | undefined;
}

export class GetAllLevelInfestationResponseDto implements IGetAllLevelInfestationResponseDto {
    userCreation!: string | undefined;
    creationTime!: DateTime;
    year!: number;
    periodName!: string | undefined;
    regionName!: string | undefined;
    zoneName!: string | undefined;
    propertyName!: string | undefined;
    standStatusName!: string | undefined;
    area!: number;
    id!: number;

    constructor(data?: IGetAllLevelInfestationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCreation = _data["userCreation"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.year = _data["year"];
            this.periodName = _data["periodName"];
            this.regionName = _data["regionName"];
            this.zoneName = _data["zoneName"];
            this.propertyName = _data["propertyName"];
            this.standStatusName = _data["standStatusName"];
            this.area = _data["area"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllLevelInfestationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLevelInfestationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCreation"] = this.userCreation;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["year"] = this.year;
        data["periodName"] = this.periodName;
        data["regionName"] = this.regionName;
        data["zoneName"] = this.zoneName;
        data["propertyName"] = this.propertyName;
        data["standStatusName"] = this.standStatusName;
        data["area"] = this.area;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllLevelInfestationResponseDto {
    userCreation: string | undefined;
    creationTime: DateTime;
    year: number;
    periodName: string | undefined;
    regionName: string | undefined;
    zoneName: string | undefined;
    propertyName: string | undefined;
    standStatusName: string | undefined;
    area: number;
    id: number;
}

export class GetAllMeasurementPlaningOptionsTreatmentDto implements IGetAllMeasurementPlaningOptionsTreatmentDto {
    id!: number;
    displayName!: string | undefined;
    displayNumber!: number;
    displayIsBulk!: boolean | undefined;
    displayBlock!: number | undefined;
    displayTrialId!: number;
    displaSubBlock!: number | undefined;
    displayTreatmentName!: string | undefined;

    constructor(data?: IGetAllMeasurementPlaningOptionsTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayNumber = _data["displayNumber"];
            this.displayIsBulk = _data["displayIsBulk"];
            this.displayBlock = _data["displayBlock"];
            this.displayTrialId = _data["displayTrialId"];
            this.displaSubBlock = _data["displaSubBlock"];
            this.displayTreatmentName = _data["displayTreatmentName"];
        }
    }

    static fromJS(data: any): GetAllMeasurementPlaningOptionsTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMeasurementPlaningOptionsTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayNumber"] = this.displayNumber;
        data["displayIsBulk"] = this.displayIsBulk;
        data["displayBlock"] = this.displayBlock;
        data["displayTrialId"] = this.displayTrialId;
        data["displaSubBlock"] = this.displaSubBlock;
        data["displayTreatmentName"] = this.displayTreatmentName;
        return data;
    }
}

export interface IGetAllMeasurementPlaningOptionsTreatmentDto {
    id: number;
    displayName: string | undefined;
    displayNumber: number;
    displayIsBulk: boolean | undefined;
    displayBlock: number | undefined;
    displayTrialId: number;
    displaSubBlock: number | undefined;
    displayTreatmentName: string | undefined;
}

export class GetAllMeasurementPlaningOptionsTreeNumberDto implements IGetAllMeasurementPlaningOptionsTreeNumberDto {
    displayNumber!: number | undefined;
    id!: number;

    constructor(data?: IGetAllMeasurementPlaningOptionsTreeNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayNumber = _data["displayNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllMeasurementPlaningOptionsTreeNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMeasurementPlaningOptionsTreeNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayNumber"] = this.displayNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllMeasurementPlaningOptionsTreeNumberDto {
    displayNumber: number | undefined;
    id: number;
}

export class GetAllMeasurementSelectionGenomicsForExcelInput implements IGetAllMeasurementSelectionGenomicsForExcelInput {
    filter!: string | undefined;
    seedlingSubProjectFilter!: string | undefined;
    projectNameFilter!: string | undefined;
    destination!: string | undefined;

    constructor(data?: IGetAllMeasurementSelectionGenomicsForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.seedlingSubProjectFilter = _data["seedlingSubProjectFilter"];
            this.projectNameFilter = _data["projectNameFilter"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): GetAllMeasurementSelectionGenomicsForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMeasurementSelectionGenomicsForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["seedlingSubProjectFilter"] = this.seedlingSubProjectFilter;
        data["projectNameFilter"] = this.projectNameFilter;
        data["destination"] = this.destination;
        return data;
    }
}

export interface IGetAllMeasurementSelectionGenomicsForExcelInput {
    filter: string | undefined;
    seedlingSubProjectFilter: string | undefined;
    projectNameFilter: string | undefined;
    destination: string | undefined;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
    id!: string;
    webhookUri!: string | undefined;
    webhookSubscriptionId!: string;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookUri = _data["webhookUri"];
            this.webhookSubscriptionId = _data["webhookSubscriptionId"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookUri"] = this.webhookUri;
        data["webhookSubscriptionId"] = this.webhookSubscriptionId;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
    id: string;
    webhookUri: string | undefined;
    webhookSubscriptionId: string;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
    id!: string;
    webhookEventId!: string;
    webhookName!: string | undefined;
    data!: string | undefined;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;

    constructor(data?: IGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookEventId = _data["webhookEventId"];
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookEventId"] = this.webhookEventId;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetAllSendAttemptsOutput {
    id: string;
    webhookEventId: string;
    webhookName: string | undefined;
    data: string | undefined;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
}

export class GetAllSilvicultureTrialFilesDto implements IGetAllSilvicultureTrialFilesDto {
    silvicultureTrialId!: number;
    fileId!: number;
    fileName!: string | undefined;
    fileFormat!: string | undefined;
    fileTag!: string | undefined;
    fileSize!: number;
    fileUploadDate!: DateTime;
    storageLocation!: string | undefined;
    id!: number;

    constructor(data?: IGetAllSilvicultureTrialFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.silvicultureTrialId = _data["silvicultureTrialId"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileFormat = _data["fileFormat"];
            this.fileTag = _data["fileTag"];
            this.fileSize = _data["fileSize"];
            this.fileUploadDate = _data["fileUploadDate"] ? DateTime.fromISO(_data["fileUploadDate"].toString()) : undefined as any;
            this.storageLocation = _data["storageLocation"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllSilvicultureTrialFilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSilvicultureTrialFilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["silvicultureTrialId"] = this.silvicultureTrialId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileFormat"] = this.fileFormat;
        data["fileTag"] = this.fileTag;
        data["fileSize"] = this.fileSize;
        data["fileUploadDate"] = this.fileUploadDate ? this.fileUploadDate.toString() : undefined as any;
        data["storageLocation"] = this.storageLocation;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllSilvicultureTrialFilesDto {
    silvicultureTrialId: number;
    fileId: number;
    fileName: string | undefined;
    fileFormat: string | undefined;
    fileTag: string | undefined;
    fileSize: number;
    fileUploadDate: DateTime;
    storageLocation: string | undefined;
    id: number;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
    webhookUri!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    id!: string;

    constructor(data?: IGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookUri = _data["webhookUri"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookUri"] = this.webhookUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllSubscriptionsOutput {
    webhookUri: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    id: string;
}

export class GetBBXDestinationForEditOutput implements IGetBBXDestinationForEditOutput {
    bbxDestination!: CreateOrEditBBXDestinationDto;

    constructor(data?: IGetBBXDestinationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbxDestination = _data["bbxDestination"] ? CreateOrEditBBXDestinationDto.fromJS(_data["bbxDestination"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetBBXDestinationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBBXDestinationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbxDestination"] = this.bbxDestination ? this.bbxDestination.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetBBXDestinationForEditOutput {
    bbxDestination: CreateOrEditBBXDestinationDto;
}

export class GetBBXDestinationForViewDto implements IGetBBXDestinationForViewDto {
    bbxDestination!: BBXDestinationDto;

    constructor(data?: IGetBBXDestinationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbxDestination = _data["bbxDestination"] ? BBXDestinationDto.fromJS(_data["bbxDestination"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetBBXDestinationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBBXDestinationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbxDestination"] = this.bbxDestination ? this.bbxDestination.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetBBXDestinationForViewDto {
    bbxDestination: BBXDestinationDto;
}

export class GetBBXDestinationForViewForManyDto implements IGetBBXDestinationForViewForManyDto {
    destineList!: GetBBXDestinationForViewDto[] | undefined;
    measurementIds!: number[] | undefined;

    constructor(data?: IGetBBXDestinationForViewForManyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["destineList"])) {
                this.destineList = [] as any;
                for (let item of _data["destineList"])
                    this.destineList!.push(GetBBXDestinationForViewDto.fromJS(item));
            }
            if (Array.isArray(_data["measurementIds"])) {
                this.measurementIds = [] as any;
                for (let item of _data["measurementIds"])
                    this.measurementIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetBBXDestinationForViewForManyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBBXDestinationForViewForManyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destineList)) {
            data["destineList"] = [];
            for (let item of this.destineList)
                data["destineList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementIds)) {
            data["measurementIds"] = [];
            for (let item of this.measurementIds)
                data["measurementIds"].push(item);
        }
        return data;
    }
}

export interface IGetBBXDestinationForViewForManyDto {
    destineList: GetBBXDestinationForViewDto[] | undefined;
    measurementIds: number[] | undefined;
}

export class GetBBXManagementForViewDto implements IGetBBXManagementForViewDto {
    bbxDestination!: GetDestinoBBXForViewDto;
    fastTrack!: boolean;
    bbx!: string | undefined;
    percentage!: number | undefined;
    fecha!: DateTime;
    bbxId!: number | undefined;
    status!: number | undefined;
    statusView!: GetCloneStatusForViewDto;
    bbt!: string | undefined;

    constructor(data?: IGetBBXManagementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbxDestination = _data["bbxDestination"] ? GetDestinoBBXForViewDto.fromJS(_data["bbxDestination"]) : undefined as any;
            this.fastTrack = _data["fastTrack"];
            this.bbx = _data["bbx"];
            this.percentage = _data["percentage"];
            this.fecha = _data["fecha"] ? DateTime.fromISO(_data["fecha"].toString()) : undefined as any;
            this.bbxId = _data["bbxId"];
            this.status = _data["status"];
            this.statusView = _data["statusView"] ? GetCloneStatusForViewDto.fromJS(_data["statusView"]) : undefined as any;
            this.bbt = _data["bbt"];
        }
    }

    static fromJS(data: any): GetBBXManagementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBBXManagementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbxDestination"] = this.bbxDestination ? this.bbxDestination.toJSON() : undefined as any;
        data["fastTrack"] = this.fastTrack;
        data["bbx"] = this.bbx;
        data["percentage"] = this.percentage;
        data["fecha"] = this.fecha ? this.fecha.toString() : undefined as any;
        data["bbxId"] = this.bbxId;
        data["status"] = this.status;
        data["statusView"] = this.statusView ? this.statusView.toJSON() : undefined as any;
        data["bbt"] = this.bbt;
        return data;
    }
}

export interface IGetBBXManagementForViewDto {
    bbxDestination: GetDestinoBBXForViewDto;
    fastTrack: boolean;
    bbx: string | undefined;
    percentage: number | undefined;
    fecha: DateTime;
    bbxId: number | undefined;
    status: number | undefined;
    statusView: GetCloneStatusForViewDto;
    bbt: string | undefined;
}

export class GetBBXManagementForViewEditDto implements IGetBBXManagementForViewEditDto {
    bbxDestination!: GetDestinoBBXForViewDto;
    fastTrack!: boolean;
    bbx!: string | undefined;
    percentage!: number | undefined;
    fecha!: DateTime;
    bbxId!: number | undefined;
    status!: number | undefined;
    type!: string | undefined;
    valor!: string | undefined;
    statusView!: GetCloneStatusForViewDto;
    bbt!: string | undefined;
    isBBT!: boolean;

    constructor(data?: IGetBBXManagementForViewEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbxDestination = _data["bbxDestination"] ? GetDestinoBBXForViewDto.fromJS(_data["bbxDestination"]) : undefined as any;
            this.fastTrack = _data["fastTrack"];
            this.bbx = _data["bbx"];
            this.percentage = _data["percentage"];
            this.fecha = _data["fecha"] ? DateTime.fromISO(_data["fecha"].toString()) : undefined as any;
            this.bbxId = _data["bbxId"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.valor = _data["valor"];
            this.statusView = _data["statusView"] ? GetCloneStatusForViewDto.fromJS(_data["statusView"]) : undefined as any;
            this.bbt = _data["bbt"];
            this.isBBT = _data["isBBT"];
        }
    }

    static fromJS(data: any): GetBBXManagementForViewEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBBXManagementForViewEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbxDestination"] = this.bbxDestination ? this.bbxDestination.toJSON() : undefined as any;
        data["fastTrack"] = this.fastTrack;
        data["bbx"] = this.bbx;
        data["percentage"] = this.percentage;
        data["fecha"] = this.fecha ? this.fecha.toString() : undefined as any;
        data["bbxId"] = this.bbxId;
        data["status"] = this.status;
        data["type"] = this.type;
        data["valor"] = this.valor;
        data["statusView"] = this.statusView ? this.statusView.toJSON() : undefined as any;
        data["bbt"] = this.bbt;
        data["isBBT"] = this.isBBT;
        return data;
    }
}

export interface IGetBBXManagementForViewEditDto {
    bbxDestination: GetDestinoBBXForViewDto;
    fastTrack: boolean;
    bbx: string | undefined;
    percentage: number | undefined;
    fecha: DateTime;
    bbxId: number | undefined;
    status: number | undefined;
    type: string | undefined;
    valor: string | undefined;
    statusView: GetCloneStatusForViewDto;
    bbt: string | undefined;
    isBBT: boolean;
}

export class GetCanaletonPlantationForViewDto implements IGetCanaletonPlantationForViewDto {
    canaletonPlantation!: CanaletonPlantationDto;

    constructor(data?: IGetCanaletonPlantationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canaletonPlantation = _data["canaletonPlantation"] ? CanaletonPlantationDto.fromJS(_data["canaletonPlantation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCanaletonPlantationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCanaletonPlantationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canaletonPlantation"] = this.canaletonPlantation ? this.canaletonPlantation.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCanaletonPlantationForViewDto {
    canaletonPlantation: CanaletonPlantationDto;
}

export class GetCategorySeedOriginForEditOutput implements IGetCategorySeedOriginForEditOutput {
    categorySeedOrigin!: CreateOrEditCategorySeedOriginDto;

    constructor(data?: IGetCategorySeedOriginForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySeedOrigin = _data["categorySeedOrigin"] ? CreateOrEditCategorySeedOriginDto.fromJS(_data["categorySeedOrigin"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCategorySeedOriginForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategorySeedOriginForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySeedOrigin"] = this.categorySeedOrigin ? this.categorySeedOrigin.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCategorySeedOriginForEditOutput {
    categorySeedOrigin: CreateOrEditCategorySeedOriginDto;
}

export class GetCategorySeedOriginForViewDto implements IGetCategorySeedOriginForViewDto {
    categorySeedOrigin!: CategorySeedOriginDto;

    constructor(data?: IGetCategorySeedOriginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySeedOrigin = _data["categorySeedOrigin"] ? CategorySeedOriginDto.fromJS(_data["categorySeedOrigin"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCategorySeedOriginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategorySeedOriginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySeedOrigin"] = this.categorySeedOrigin ? this.categorySeedOrigin.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCategorySeedOriginForViewDto {
    categorySeedOrigin: CategorySeedOriginDto;
}

export class GetCategoryTrialForEditOutput implements IGetCategoryTrialForEditOutput {
    categoryTrial!: CreateOrEditCategoryTrialDto;

    constructor(data?: IGetCategoryTrialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryTrial = _data["categoryTrial"] ? CreateOrEditCategoryTrialDto.fromJS(_data["categoryTrial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCategoryTrialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryTrialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryTrial"] = this.categoryTrial ? this.categoryTrial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCategoryTrialForEditOutput {
    categoryTrial: CreateOrEditCategoryTrialDto;
}

export class GetCategoryTrialForViewDto implements IGetCategoryTrialForViewDto {
    categoryTrial!: CategoryTrialDto;

    constructor(data?: IGetCategoryTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryTrial = _data["categoryTrial"] ? CategoryTrialDto.fromJS(_data["categoryTrial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCategoryTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryTrial"] = this.categoryTrial ? this.categoryTrial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCategoryTrialForViewDto {
    categoryTrial: CategoryTrialDto;
}

export class GetCloneForEditOutput implements IGetCloneForEditOutput {
    clone!: CreateOrEditCloneDto;
    measurementSelectionNumberT!: string | undefined;
    treeSpecie!: string | undefined;
    creationDate!: DateTime;

    constructor(data?: IGetCloneForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clone = _data["clone"] ? CreateOrEditCloneDto.fromJS(_data["clone"]) : undefined as any;
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.treeSpecie = _data["treeSpecie"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetCloneForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloneForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clone"] = this.clone ? this.clone.toJSON() : undefined as any;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["treeSpecie"] = this.treeSpecie;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
        return data;
    }
}

export interface IGetCloneForEditOutput {
    clone: CreateOrEditCloneDto;
    measurementSelectionNumberT: string | undefined;
    treeSpecie: string | undefined;
    creationDate: DateTime;
}

export class GetCloneForViewDto implements IGetCloneForViewDto {
    clone!: CloneDto;
    measurementSelectionNumberT!: string | undefined;
    treeSpecie!: string | undefined;
    supplier!: string | undefined;
    supplierName!: string | undefined;
    speciesName!: string | undefined;
    typeSpecie!: string | undefined;
    creationDate!: DateTime;
    maxRootinPercentage!: number | undefined;
    statusDate!: DateTime;
    status!: string | undefined;
    destinations!: string | undefined;

    constructor(data?: IGetCloneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clone = _data["clone"] ? CloneDto.fromJS(_data["clone"]) : undefined as any;
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.treeSpecie = _data["treeSpecie"];
            this.supplier = _data["supplier"];
            this.supplierName = _data["supplierName"];
            this.speciesName = _data["speciesName"];
            this.typeSpecie = _data["typeSpecie"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
            this.maxRootinPercentage = _data["maxRootinPercentage"];
            this.statusDate = _data["statusDate"] ? DateTime.fromISO(_data["statusDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.destinations = _data["destinations"];
        }
    }

    static fromJS(data: any): GetCloneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clone"] = this.clone ? this.clone.toJSON() : undefined as any;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["treeSpecie"] = this.treeSpecie;
        data["supplier"] = this.supplier;
        data["supplierName"] = this.supplierName;
        data["speciesName"] = this.speciesName;
        data["typeSpecie"] = this.typeSpecie;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
        data["maxRootinPercentage"] = this.maxRootinPercentage;
        data["statusDate"] = this.statusDate ? this.statusDate.toString() : undefined as any;
        data["status"] = this.status;
        data["destinations"] = this.destinations;
        return data;
    }
}

export interface IGetCloneForViewDto {
    clone: CloneDto;
    measurementSelectionNumberT: string | undefined;
    treeSpecie: string | undefined;
    supplier: string | undefined;
    supplierName: string | undefined;
    speciesName: string | undefined;
    typeSpecie: string | undefined;
    creationDate: DateTime;
    maxRootinPercentage: number | undefined;
    statusDate: DateTime;
    status: string | undefined;
    destinations: string | undefined;
}

export class GetClonePedigreeForViewDto implements IGetClonePedigreeForViewDto {
    clone!: CloneDto;
    cloneSeed!: SeedDto;
    fatherSeed!: SeedDto;
    motherSeed!: SeedDto;
    fatherGrandFatherSeed!: SeedDto;
    fatherGrandMotherSeed!: SeedDto;
    motherGrandFatherSeed!: SeedDto;
    motherGrandMotherSeed!: SeedDto;

    constructor(data?: IGetClonePedigreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clone = _data["clone"] ? CloneDto.fromJS(_data["clone"]) : undefined as any;
            this.cloneSeed = _data["cloneSeed"] ? SeedDto.fromJS(_data["cloneSeed"]) : undefined as any;
            this.fatherSeed = _data["fatherSeed"] ? SeedDto.fromJS(_data["fatherSeed"]) : undefined as any;
            this.motherSeed = _data["motherSeed"] ? SeedDto.fromJS(_data["motherSeed"]) : undefined as any;
            this.fatherGrandFatherSeed = _data["fatherGrandFatherSeed"] ? SeedDto.fromJS(_data["fatherGrandFatherSeed"]) : undefined as any;
            this.fatherGrandMotherSeed = _data["fatherGrandMotherSeed"] ? SeedDto.fromJS(_data["fatherGrandMotherSeed"]) : undefined as any;
            this.motherGrandFatherSeed = _data["motherGrandFatherSeed"] ? SeedDto.fromJS(_data["motherGrandFatherSeed"]) : undefined as any;
            this.motherGrandMotherSeed = _data["motherGrandMotherSeed"] ? SeedDto.fromJS(_data["motherGrandMotherSeed"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetClonePedigreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClonePedigreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clone"] = this.clone ? this.clone.toJSON() : undefined as any;
        data["cloneSeed"] = this.cloneSeed ? this.cloneSeed.toJSON() : undefined as any;
        data["fatherSeed"] = this.fatherSeed ? this.fatherSeed.toJSON() : undefined as any;
        data["motherSeed"] = this.motherSeed ? this.motherSeed.toJSON() : undefined as any;
        data["fatherGrandFatherSeed"] = this.fatherGrandFatherSeed ? this.fatherGrandFatherSeed.toJSON() : undefined as any;
        data["fatherGrandMotherSeed"] = this.fatherGrandMotherSeed ? this.fatherGrandMotherSeed.toJSON() : undefined as any;
        data["motherGrandFatherSeed"] = this.motherGrandFatherSeed ? this.motherGrandFatherSeed.toJSON() : undefined as any;
        data["motherGrandMotherSeed"] = this.motherGrandMotherSeed ? this.motherGrandMotherSeed.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetClonePedigreeForViewDto {
    clone: CloneDto;
    cloneSeed: SeedDto;
    fatherSeed: SeedDto;
    motherSeed: SeedDto;
    fatherGrandFatherSeed: SeedDto;
    fatherGrandMotherSeed: SeedDto;
    motherGrandFatherSeed: SeedDto;
    motherGrandMotherSeed: SeedDto;
}

export class GetCloneStatusForEditOutput implements IGetCloneStatusForEditOutput {
    cloneStatus!: CreateOrEditCloneStatusDto;

    constructor(data?: IGetCloneStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloneStatus = _data["cloneStatus"] ? CreateOrEditCloneStatusDto.fromJS(_data["cloneStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCloneStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloneStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloneStatus"] = this.cloneStatus ? this.cloneStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCloneStatusForEditOutput {
    cloneStatus: CreateOrEditCloneStatusDto;
}

export class GetCloneStatusForViewDto implements IGetCloneStatusForViewDto {
    cloneStatus!: CloneStatusDto;

    constructor(data?: IGetCloneStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloneStatus = _data["cloneStatus"] ? CloneStatusDto.fromJS(_data["cloneStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCloneStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloneStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloneStatus"] = this.cloneStatus ? this.cloneStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCloneStatusForViewDto {
    cloneStatus: CloneStatusDto;
}

export class GetControlledCrossingForEditOutput implements IGetControlledCrossingForEditOutput {
    controlledCrossing!: CreateOrEditControlledCrossingDto;
    trialStandName!: string | undefined;
    trialNumber!: number | undefined;
    seedBBS!: string | undefined;
    polenBBP!: string | undefined;
    seedBBS2!: string | undefined;
    typeSpecieName!: string | undefined;
    crossingTechniqueName!: string | undefined;
    seedBBS3!: string | undefined;

    constructor(data?: IGetControlledCrossingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlledCrossing = _data["controlledCrossing"] ? CreateOrEditControlledCrossingDto.fromJS(_data["controlledCrossing"]) : undefined as any;
            this.trialStandName = _data["trialStandName"];
            this.trialNumber = _data["trialNumber"];
            this.seedBBS = _data["seedBBS"];
            this.polenBBP = _data["polenBBP"];
            this.seedBBS2 = _data["seedBBS2"];
            this.typeSpecieName = _data["typeSpecieName"];
            this.crossingTechniqueName = _data["crossingTechniqueName"];
            this.seedBBS3 = _data["seedBBS3"];
        }
    }

    static fromJS(data: any): GetControlledCrossingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetControlledCrossingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlledCrossing"] = this.controlledCrossing ? this.controlledCrossing.toJSON() : undefined as any;
        data["trialStandName"] = this.trialStandName;
        data["trialNumber"] = this.trialNumber;
        data["seedBBS"] = this.seedBBS;
        data["polenBBP"] = this.polenBBP;
        data["seedBBS2"] = this.seedBBS2;
        data["typeSpecieName"] = this.typeSpecieName;
        data["crossingTechniqueName"] = this.crossingTechniqueName;
        data["seedBBS3"] = this.seedBBS3;
        return data;
    }
}

export interface IGetControlledCrossingForEditOutput {
    controlledCrossing: CreateOrEditControlledCrossingDto;
    trialStandName: string | undefined;
    trialNumber: number | undefined;
    seedBBS: string | undefined;
    polenBBP: string | undefined;
    seedBBS2: string | undefined;
    typeSpecieName: string | undefined;
    crossingTechniqueName: string | undefined;
    seedBBS3: string | undefined;
}

export class GetControlledCrossingForViewDto implements IGetControlledCrossingForViewDto {
    controlledCrossing!: ControlledCrossingDto;
    trialStandName!: string | undefined;
    seedBBS!: string | undefined;
    polenBBP!: string | undefined;
    seedBBS2!: string | undefined;
    typeSpecieName!: string | undefined;
    crossingTechniqueName!: string | undefined;
    seedBBS3!: string | undefined;
    trialNumber!: number;

    constructor(data?: IGetControlledCrossingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlledCrossing = _data["controlledCrossing"] ? ControlledCrossingDto.fromJS(_data["controlledCrossing"]) : undefined as any;
            this.trialStandName = _data["trialStandName"];
            this.seedBBS = _data["seedBBS"];
            this.polenBBP = _data["polenBBP"];
            this.seedBBS2 = _data["seedBBS2"];
            this.typeSpecieName = _data["typeSpecieName"];
            this.crossingTechniqueName = _data["crossingTechniqueName"];
            this.seedBBS3 = _data["seedBBS3"];
            this.trialNumber = _data["trialNumber"];
        }
    }

    static fromJS(data: any): GetControlledCrossingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetControlledCrossingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlledCrossing"] = this.controlledCrossing ? this.controlledCrossing.toJSON() : undefined as any;
        data["trialStandName"] = this.trialStandName;
        data["seedBBS"] = this.seedBBS;
        data["polenBBP"] = this.polenBBP;
        data["seedBBS2"] = this.seedBBS2;
        data["typeSpecieName"] = this.typeSpecieName;
        data["crossingTechniqueName"] = this.crossingTechniqueName;
        data["seedBBS3"] = this.seedBBS3;
        data["trialNumber"] = this.trialNumber;
        return data;
    }
}

export interface IGetControlledCrossingForViewDto {
    controlledCrossing: ControlledCrossingDto;
    trialStandName: string | undefined;
    seedBBS: string | undefined;
    polenBBP: string | undefined;
    seedBBS2: string | undefined;
    typeSpecieName: string | undefined;
    crossingTechniqueName: string | undefined;
    seedBBS3: string | undefined;
    trialNumber: number;
}

export class GetCrossingTechniqueForEditOutput implements IGetCrossingTechniqueForEditOutput {
    crossingTechnique!: CreateOrEditCrossingTechniqueDto;

    constructor(data?: IGetCrossingTechniqueForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crossingTechnique = _data["crossingTechnique"] ? CreateOrEditCrossingTechniqueDto.fromJS(_data["crossingTechnique"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCrossingTechniqueForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCrossingTechniqueForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crossingTechnique"] = this.crossingTechnique ? this.crossingTechnique.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCrossingTechniqueForEditOutput {
    crossingTechnique: CreateOrEditCrossingTechniqueDto;
}

export class GetCrossingTechniqueForViewDto implements IGetCrossingTechniqueForViewDto {
    crossingTechnique!: CrossingTechniqueDto;

    constructor(data?: IGetCrossingTechniqueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crossingTechnique = _data["crossingTechnique"] ? CrossingTechniqueDto.fromJS(_data["crossingTechnique"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCrossingTechniqueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCrossingTechniqueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crossingTechnique"] = this.crossingTechnique ? this.crossingTechnique.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCrossingTechniqueForViewDto {
    crossingTechnique: CrossingTechniqueDto;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : undefined as any;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : undefined as any;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetDestinoBBXForEditOutput implements IGetDestinoBBXForEditOutput {
    destinoBBX!: CreateOrEditDestinoBBXDto;
    cloneBBX!: string | undefined;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;

    constructor(data?: IGetDestinoBBXForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinoBBX = _data["destinoBBX"] ? CreateOrEditDestinoBBXDto.fromJS(_data["destinoBBX"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
        }
    }

    static fromJS(data: any): GetDestinoBBXForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinoBBXForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinoBBX"] = this.destinoBBX ? this.destinoBBX.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        return data;
    }
}

export interface IGetDestinoBBXForEditOutput {
    destinoBBX: CreateOrEditDestinoBBXDto;
    cloneBBX: string | undefined;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
}

export class GetDestinoBBXForViewDto implements IGetDestinoBBXForViewDto {
    id!: number;
    destinoBBX!: DestinoBBXDto;
    cloneBBX!: string | undefined;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    destineName!: string | undefined;
    plantMother!: string | undefined;
    type!: string | undefined;
    valor!: string | undefined;

    constructor(data?: IGetDestinoBBXForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.destinoBBX = _data["destinoBBX"] ? DestinoBBXDto.fromJS(_data["destinoBBX"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.destineName = _data["destineName"];
            this.plantMother = _data["plantMother"];
            this.type = _data["type"];
            this.valor = _data["valor"];
        }
    }

    static fromJS(data: any): GetDestinoBBXForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinoBBXForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["destinoBBX"] = this.destinoBBX ? this.destinoBBX.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["destineName"] = this.destineName;
        data["plantMother"] = this.plantMother;
        data["type"] = this.type;
        data["valor"] = this.valor;
        return data;
    }
}

export interface IGetDestinoBBXForViewDto {
    id: number;
    destinoBBX: DestinoBBXDto;
    cloneBBX: string | undefined;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    destineName: string | undefined;
    plantMother: string | undefined;
    type: string | undefined;
    valor: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetExperimentCategoryForEditOutput implements IGetExperimentCategoryForEditOutput {
    experimentCategory!: CreateOrEditExperimentCategoryDto;

    constructor(data?: IGetExperimentCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentCategory = _data["experimentCategory"] ? CreateOrEditExperimentCategoryDto.fromJS(_data["experimentCategory"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentCategory"] = this.experimentCategory ? this.experimentCategory.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentCategoryForEditOutput {
    experimentCategory: CreateOrEditExperimentCategoryDto;
}

export class GetExperimentCategoryForViewDto implements IGetExperimentCategoryForViewDto {
    experimentCategory!: ExperimentCategoryDto;

    constructor(data?: IGetExperimentCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentCategory = _data["experimentCategory"] ? ExperimentCategoryDto.fromJS(_data["experimentCategory"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentCategory"] = this.experimentCategory ? this.experimentCategory.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentCategoryForViewDto {
    experimentCategory: ExperimentCategoryDto;
}

export class GetExperimentClasificationtwoForEditOutput implements IGetExperimentClasificationtwoForEditOutput {
    experimentClasificationtwo!: CreateOrEditExperimentClasificationtwoDto;

    constructor(data?: IGetExperimentClasificationtwoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentClasificationtwo = _data["experimentClasificationtwo"] ? CreateOrEditExperimentClasificationtwoDto.fromJS(_data["experimentClasificationtwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentClasificationtwoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentClasificationtwoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentClasificationtwo"] = this.experimentClasificationtwo ? this.experimentClasificationtwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentClasificationtwoForEditOutput {
    experimentClasificationtwo: CreateOrEditExperimentClasificationtwoDto;
}

export class GetExperimentClasificationtwoForViewDto implements IGetExperimentClasificationtwoForViewDto {
    experimentClasificationtwo!: ExperimentClasificationtwoDto;

    constructor(data?: IGetExperimentClasificationtwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentClasificationtwo = _data["experimentClasificationtwo"] ? ExperimentClasificationtwoDto.fromJS(_data["experimentClasificationtwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentClasificationtwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentClasificationtwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentClasificationtwo"] = this.experimentClasificationtwo ? this.experimentClasificationtwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentClasificationtwoForViewDto {
    experimentClasificationtwo: ExperimentClasificationtwoDto;
}

export class GetExperimentClassificationForEditOutput implements IGetExperimentClassificationForEditOutput {
    experimentClassification!: CreateOrEditExperimentClassificationDto;
    experimentCategoryName!: string | undefined;

    constructor(data?: IGetExperimentClassificationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentClassification = _data["experimentClassification"] ? CreateOrEditExperimentClassificationDto.fromJS(_data["experimentClassification"]) : undefined as any;
            this.experimentCategoryName = _data["experimentCategoryName"];
        }
    }

    static fromJS(data: any): GetExperimentClassificationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentClassificationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentClassification"] = this.experimentClassification ? this.experimentClassification.toJSON() : undefined as any;
        data["experimentCategoryName"] = this.experimentCategoryName;
        return data;
    }
}

export interface IGetExperimentClassificationForEditOutput {
    experimentClassification: CreateOrEditExperimentClassificationDto;
    experimentCategoryName: string | undefined;
}

export class GetExperimentClassificationForViewDto implements IGetExperimentClassificationForViewDto {
    experimentClassification!: ExperimentClassificationDto;
    experimentCategoryName!: string | undefined;

    constructor(data?: IGetExperimentClassificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentClassification = _data["experimentClassification"] ? ExperimentClassificationDto.fromJS(_data["experimentClassification"]) : undefined as any;
            this.experimentCategoryName = _data["experimentCategoryName"];
        }
    }

    static fromJS(data: any): GetExperimentClassificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentClassificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentClassification"] = this.experimentClassification ? this.experimentClassification.toJSON() : undefined as any;
        data["experimentCategoryName"] = this.experimentCategoryName;
        return data;
    }
}

export interface IGetExperimentClassificationForViewDto {
    experimentClassification: ExperimentClassificationDto;
    experimentCategoryName: string | undefined;
}

export class GetExperimentLocationForEditOutput implements IGetExperimentLocationForEditOutput {
    experimentLocation!: CreateOrEditExperimentLocationDto;

    constructor(data?: IGetExperimentLocationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentLocation = _data["experimentLocation"] ? CreateOrEditExperimentLocationDto.fromJS(_data["experimentLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentLocationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentLocationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentLocation"] = this.experimentLocation ? this.experimentLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentLocationForEditOutput {
    experimentLocation: CreateOrEditExperimentLocationDto;
}

export class GetExperimentLocationForViewDto implements IGetExperimentLocationForViewDto {
    experimentLocation!: ExperimentLocationDto;

    constructor(data?: IGetExperimentLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentLocation = _data["experimentLocation"] ? ExperimentLocationDto.fromJS(_data["experimentLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentLocation"] = this.experimentLocation ? this.experimentLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentLocationForViewDto {
    experimentLocation: ExperimentLocationDto;
}

export class GetExperimentSpecieForEditOutput implements IGetExperimentSpecieForEditOutput {
    experimentSpecie!: CreateOrEditExperimentSpecieDto;

    constructor(data?: IGetExperimentSpecieForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentSpecie = _data["experimentSpecie"] ? CreateOrEditExperimentSpecieDto.fromJS(_data["experimentSpecie"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentSpecieForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentSpecieForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentSpecie"] = this.experimentSpecie ? this.experimentSpecie.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentSpecieForEditOutput {
    experimentSpecie: CreateOrEditExperimentSpecieDto;
}

export class GetExperimentSpecieForViewDto implements IGetExperimentSpecieForViewDto {
    experimentSpecie!: ExperimentSpecieDto;

    constructor(data?: IGetExperimentSpecieForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentSpecie = _data["experimentSpecie"] ? ExperimentSpecieDto.fromJS(_data["experimentSpecie"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentSpecieForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentSpecieForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentSpecie"] = this.experimentSpecie ? this.experimentSpecie.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentSpecieForViewDto {
    experimentSpecie: ExperimentSpecieDto;
}

export class GetExperimentSpecieQuantityForEditOutput implements IGetExperimentSpecieQuantityForEditOutput {
    experimentSpecieQuantity!: CreateOrEditExperimentSpecieQuantityDto;

    constructor(data?: IGetExperimentSpecieQuantityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentSpecieQuantity = _data["experimentSpecieQuantity"] ? CreateOrEditExperimentSpecieQuantityDto.fromJS(_data["experimentSpecieQuantity"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentSpecieQuantityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentSpecieQuantityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentSpecieQuantity"] = this.experimentSpecieQuantity ? this.experimentSpecieQuantity.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentSpecieQuantityForEditOutput {
    experimentSpecieQuantity: CreateOrEditExperimentSpecieQuantityDto;
}

export class GetExperimentSpecieQuantityForViewDto implements IGetExperimentSpecieQuantityForViewDto {
    experimentSpecieQuantity!: ExperimentSpecieQuantityDto;

    constructor(data?: IGetExperimentSpecieQuantityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentSpecieQuantity = _data["experimentSpecieQuantity"] ? ExperimentSpecieQuantityDto.fromJS(_data["experimentSpecieQuantity"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentSpecieQuantityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentSpecieQuantityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentSpecieQuantity"] = this.experimentSpecieQuantity ? this.experimentSpecieQuantity.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentSpecieQuantityForViewDto {
    experimentSpecieQuantity: ExperimentSpecieQuantityDto;
}

export class GetExperimentStigmaForViewDto implements IGetExperimentStigmaForViewDto {
    experimentStigma!: ExperimentStigmaDto;

    constructor(data?: IGetExperimentStigmaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentStigma = _data["experimentStigma"] ? ExperimentStigmaDto.fromJS(_data["experimentStigma"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentStigmaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentStigmaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentStigma"] = this.experimentStigma ? this.experimentStigma.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentStigmaForViewDto {
    experimentStigma: ExperimentStigmaDto;
}

export class GetExperimentTypeForEditOutput implements IGetExperimentTypeForEditOutput {
    experimentType!: CreateOrEditExperimentTypeDto;

    constructor(data?: IGetExperimentTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentType = _data["experimentType"] ? CreateOrEditExperimentTypeDto.fromJS(_data["experimentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentType"] = this.experimentType ? this.experimentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentTypeForEditOutput {
    experimentType: CreateOrEditExperimentTypeDto;
}

export class GetExperimentTypeForViewDto implements IGetExperimentTypeForViewDto {
    experimentType!: ExperimentTypeDto;

    constructor(data?: IGetExperimentTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentType = _data["experimentType"] ? ExperimentTypeDto.fromJS(_data["experimentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetExperimentTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExperimentTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentType"] = this.experimentType ? this.experimentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetExperimentTypeForViewDto {
    experimentType: ExperimentTypeDto;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : undefined as any;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : undefined as any;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : undefined as any;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetFileForEditOutput implements IGetFileForEditOutput {
    file!: CreateOrEditFileDto;

    constructor(data?: IGetFileForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? CreateOrEditFileDto.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFileForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFileForEditOutput {
    file: CreateOrEditFileDto;
}

export class GetFileForViewDto implements IGetFileForViewDto {
    file!: FileBlobDto;

    constructor(data?: IGetFileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileBlobDto.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFileForViewDto {
    file: FileBlobDto;
}

export class GetFrostToleranceForEditOutput implements IGetFrostToleranceForEditOutput {
    frostTolerance!: CreateOrEditFrostToleranceDto;

    constructor(data?: IGetFrostToleranceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frostTolerance = _data["frostTolerance"] ? CreateOrEditFrostToleranceDto.fromJS(_data["frostTolerance"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFrostToleranceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFrostToleranceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frostTolerance"] = this.frostTolerance ? this.frostTolerance.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFrostToleranceForEditOutput {
    frostTolerance: CreateOrEditFrostToleranceDto;
}

export class GetFrostToleranceForViewDto implements IGetFrostToleranceForViewDto {
    frostTolerance!: FrostToleranceDto;

    constructor(data?: IGetFrostToleranceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frostTolerance = _data["frostTolerance"] ? FrostToleranceDto.fromJS(_data["frostTolerance"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFrostToleranceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFrostToleranceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frostTolerance"] = this.frostTolerance ? this.frostTolerance.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFrostToleranceForViewDto {
    frostTolerance: FrostToleranceDto;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetGenericFilterDto implements IGetGenericFilterDto {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: IGetGenericFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGenericFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGenericFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGenericFilterDto {
    id: number | undefined;
    name: string | undefined;
}

export class GetGeneticFilterDto implements IGetGeneticFilterDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IGetGeneticFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetGeneticFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneticFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetGeneticFilterDto {
    id: number;
    name: string | undefined;
}

export class GetGenomicSeleccionForEditOutput implements IGetGenomicSeleccionForEditOutput {
    genomicSeleccion!: CreateOrEditGenomicSeleccionDto;
    projectName!: string | undefined;
    seedlingSubProject!: string | undefined;

    constructor(data?: IGetGenomicSeleccionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genomicSeleccion = _data["genomicSeleccion"] ? CreateOrEditGenomicSeleccionDto.fromJS(_data["genomicSeleccion"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.seedlingSubProject = _data["seedlingSubProject"];
        }
    }

    static fromJS(data: any): GetGenomicSeleccionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGenomicSeleccionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genomicSeleccion"] = this.genomicSeleccion ? this.genomicSeleccion.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["seedlingSubProject"] = this.seedlingSubProject;
        return data;
    }
}

export interface IGetGenomicSeleccionForEditOutput {
    genomicSeleccion: CreateOrEditGenomicSeleccionDto;
    projectName: string | undefined;
    seedlingSubProject: string | undefined;
}

export class GetGenomicSeleccionForViewDto implements IGetGenomicSeleccionForViewDto {
    genomicSeleccion!: GenomicSeleccionDto;
    projectName!: string | undefined;
    seedlingSubProject!: string | undefined;
    measurementSelectionGenomicId!: number;

    constructor(data?: IGetGenomicSeleccionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genomicSeleccion = _data["genomicSeleccion"] ? GenomicSeleccionDto.fromJS(_data["genomicSeleccion"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.seedlingSubProject = _data["seedlingSubProject"];
            this.measurementSelectionGenomicId = _data["measurementSelectionGenomicId"];
        }
    }

    static fromJS(data: any): GetGenomicSeleccionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGenomicSeleccionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genomicSeleccion"] = this.genomicSeleccion ? this.genomicSeleccion.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["seedlingSubProject"] = this.seedlingSubProject;
        data["measurementSelectionGenomicId"] = this.measurementSelectionGenomicId;
        return data;
    }
}

export interface IGetGenomicSeleccionForViewDto {
    genomicSeleccion: GenomicSeleccionDto;
    projectName: string | undefined;
    seedlingSubProject: string | undefined;
    measurementSelectionGenomicId: number;
}

export class GetGroupTrialForEditOutput implements IGetGroupTrialForEditOutput {
    groupTrial!: CreateOrEditGroupTrialDto;

    constructor(data?: IGetGroupTrialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupTrial = _data["groupTrial"] ? CreateOrEditGroupTrialDto.fromJS(_data["groupTrial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetGroupTrialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupTrialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupTrial"] = this.groupTrial ? this.groupTrial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetGroupTrialForEditOutput {
    groupTrial: CreateOrEditGroupTrialDto;
}

export class GetGroupTrialForViewDto implements IGetGroupTrialForViewDto {
    groupTrial!: GroupTrialDto;

    constructor(data?: IGetGroupTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupTrial = _data["groupTrial"] ? GroupTrialDto.fromJS(_data["groupTrial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetGroupTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupTrial"] = this.groupTrial ? this.groupTrial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetGroupTrialForViewDto {
    groupTrial: GroupTrialDto;
}

export class GetHealthDoseForEditOutput implements IGetHealthDoseForEditOutput {
    healthDose!: CreateOrEditHealthDoseDto;
    healthcareProductName!: string | undefined;
    healthcareProductId!: number | undefined;
    healthcareTechnologyName!: string | undefined;
    healthcareMomentMoment!: string | undefined;

    constructor(data?: IGetHealthDoseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthDose = _data["healthDose"] ? CreateOrEditHealthDoseDto.fromJS(_data["healthDose"]) : undefined as any;
            this.healthcareProductName = _data["healthcareProductName"];
            this.healthcareProductId = _data["healthcareProductId"];
            this.healthcareTechnologyName = _data["healthcareTechnologyName"];
            this.healthcareMomentMoment = _data["healthcareMomentMoment"];
        }
    }

    static fromJS(data: any): GetHealthDoseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthDoseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthDose"] = this.healthDose ? this.healthDose.toJSON() : undefined as any;
        data["healthcareProductName"] = this.healthcareProductName;
        data["healthcareProductId"] = this.healthcareProductId;
        data["healthcareTechnologyName"] = this.healthcareTechnologyName;
        data["healthcareMomentMoment"] = this.healthcareMomentMoment;
        return data;
    }
}

export interface IGetHealthDoseForEditOutput {
    healthDose: CreateOrEditHealthDoseDto;
    healthcareProductName: string | undefined;
    healthcareProductId: number | undefined;
    healthcareTechnologyName: string | undefined;
    healthcareMomentMoment: string | undefined;
}

export class GetHealthDoseForViewDto implements IGetHealthDoseForViewDto {
    healthDose!: HealthDoseDto;
    year!: number;
    periodName!: string | undefined;
    region!: string | undefined;
    zone!: string | undefined;
    propertyName!: string | undefined;
    totalArea!: number;
    classification!: number;
    classificationColor!: string | undefined;
    dose!: number;
    observations!: string | undefined;
    relieve!: boolean;
    standStatusName!: string | undefined;
    healthcareProductName!: string | undefined;
    healthcareTechnologyName!: string | undefined;
    healthcareMomentMoment!: string | undefined;

    constructor(data?: IGetHealthDoseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthDose = _data["healthDose"] ? HealthDoseDto.fromJS(_data["healthDose"]) : undefined as any;
            this.year = _data["year"];
            this.periodName = _data["periodName"];
            this.region = _data["region"];
            this.zone = _data["zone"];
            this.propertyName = _data["propertyName"];
            this.totalArea = _data["totalArea"];
            this.classification = _data["classification"];
            this.classificationColor = _data["classificationColor"];
            this.dose = _data["dose"];
            this.observations = _data["observations"];
            this.relieve = _data["relieve"];
            this.standStatusName = _data["standStatusName"];
            this.healthcareProductName = _data["healthcareProductName"];
            this.healthcareTechnologyName = _data["healthcareTechnologyName"];
            this.healthcareMomentMoment = _data["healthcareMomentMoment"];
        }
    }

    static fromJS(data: any): GetHealthDoseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthDoseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthDose"] = this.healthDose ? this.healthDose.toJSON() : undefined as any;
        data["year"] = this.year;
        data["periodName"] = this.periodName;
        data["region"] = this.region;
        data["zone"] = this.zone;
        data["propertyName"] = this.propertyName;
        data["totalArea"] = this.totalArea;
        data["classification"] = this.classification;
        data["classificationColor"] = this.classificationColor;
        data["dose"] = this.dose;
        data["observations"] = this.observations;
        data["relieve"] = this.relieve;
        data["standStatusName"] = this.standStatusName;
        data["healthcareProductName"] = this.healthcareProductName;
        data["healthcareTechnologyName"] = this.healthcareTechnologyName;
        data["healthcareMomentMoment"] = this.healthcareMomentMoment;
        return data;
    }
}

export interface IGetHealthDoseForViewDto {
    healthDose: HealthDoseDto;
    year: number;
    periodName: string | undefined;
    region: string | undefined;
    zone: string | undefined;
    propertyName: string | undefined;
    totalArea: number;
    classification: number;
    classificationColor: string | undefined;
    dose: number;
    observations: string | undefined;
    relieve: boolean;
    standStatusName: string | undefined;
    healthcareProductName: string | undefined;
    healthcareTechnologyName: string | undefined;
    healthcareMomentMoment: string | undefined;
}

export class GetHealthcareFormulaDto implements IGetHealthcareFormulaDto {
    healthcareFormula!: HealthcareFormulaDto;

    constructor(data?: IGetHealthcareFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthcareFormula = _data["healthcareFormula"] ? HealthcareFormulaDto.fromJS(_data["healthcareFormula"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetHealthcareFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthcareFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthcareFormula"] = this.healthcareFormula ? this.healthcareFormula.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetHealthcareFormulaDto {
    healthcareFormula: HealthcareFormulaDto;
}

export class GetHealthcareMastersDto implements IGetHealthcareMastersDto {
    master!: HealthcareMastersDto;

    constructor(data?: IGetHealthcareMastersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.master = _data["master"] ? HealthcareMastersDto.fromJS(_data["master"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetHealthcareMastersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthcareMastersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["master"] = this.master ? this.master.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetHealthcareMastersDto {
    master: HealthcareMastersDto;
}

export class GetHealthcareProductDto implements IGetHealthcareProductDto {
    healthcareProduct!: HealthcareProductDto;

    constructor(data?: IGetHealthcareProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthcareProduct = _data["healthcareProduct"] ? HealthcareProductDto.fromJS(_data["healthcareProduct"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetHealthcareProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthcareProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthcareProduct"] = this.healthcareProduct ? this.healthcareProduct.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetHealthcareProductDto {
    healthcareProduct: HealthcareProductDto;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetInterventionFoundationsOneForEditOutput implements IGetInterventionFoundationsOneForEditOutput {
    interventionFoundationsOne!: CreateOrEditInterventionFoundationsOneDto;

    constructor(data?: IGetInterventionFoundationsOneForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsOne = _data["interventionFoundationsOne"] ? CreateOrEditInterventionFoundationsOneDto.fromJS(_data["interventionFoundationsOne"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsOneForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsOneForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsOne"] = this.interventionFoundationsOne ? this.interventionFoundationsOne.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsOneForEditOutput {
    interventionFoundationsOne: CreateOrEditInterventionFoundationsOneDto;
}

export class GetInterventionFoundationsOneForViewDto implements IGetInterventionFoundationsOneForViewDto {
    interventionFoundationsOne!: InterventionFoundationsOneDto;

    constructor(data?: IGetInterventionFoundationsOneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsOne = _data["interventionFoundationsOne"] ? InterventionFoundationsOneDto.fromJS(_data["interventionFoundationsOne"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsOneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsOneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsOne"] = this.interventionFoundationsOne ? this.interventionFoundationsOne.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsOneForViewDto {
    interventionFoundationsOne: InterventionFoundationsOneDto;
}

export class GetInterventionFoundationsThreeForEditOutput implements IGetInterventionFoundationsThreeForEditOutput {
    interventionFoundationsThree!: CreateOrEditInterventionFoundationsThreeDto;

    constructor(data?: IGetInterventionFoundationsThreeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsThree = _data["interventionFoundationsThree"] ? CreateOrEditInterventionFoundationsThreeDto.fromJS(_data["interventionFoundationsThree"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsThreeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsThreeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsThree"] = this.interventionFoundationsThree ? this.interventionFoundationsThree.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsThreeForEditOutput {
    interventionFoundationsThree: CreateOrEditInterventionFoundationsThreeDto;
}

export class GetInterventionFoundationsThreeForViewDto implements IGetInterventionFoundationsThreeForViewDto {
    interventionFoundationsThree!: InterventionFoundationsThreeDto;

    constructor(data?: IGetInterventionFoundationsThreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsThree = _data["interventionFoundationsThree"] ? InterventionFoundationsThreeDto.fromJS(_data["interventionFoundationsThree"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsThreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsThreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsThree"] = this.interventionFoundationsThree ? this.interventionFoundationsThree.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsThreeForViewDto {
    interventionFoundationsThree: InterventionFoundationsThreeDto;
}

export class GetInterventionFoundationsTwoForEditOutput implements IGetInterventionFoundationsTwoForEditOutput {
    interventionFoundationsTwo!: CreateOrEditInterventionFoundationsTwoDto;

    constructor(data?: IGetInterventionFoundationsTwoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsTwo = _data["interventionFoundationsTwo"] ? CreateOrEditInterventionFoundationsTwoDto.fromJS(_data["interventionFoundationsTwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsTwoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsTwoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsTwo"] = this.interventionFoundationsTwo ? this.interventionFoundationsTwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsTwoForEditOutput {
    interventionFoundationsTwo: CreateOrEditInterventionFoundationsTwoDto;
}

export class GetInterventionFoundationsTwoForViewDto implements IGetInterventionFoundationsTwoForViewDto {
    interventionFoundationsTwo!: InterventionFoundationsTwoDto;

    constructor(data?: IGetInterventionFoundationsTwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundationsTwo = _data["interventionFoundationsTwo"] ? InterventionFoundationsTwoDto.fromJS(_data["interventionFoundationsTwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetInterventionFoundationsTwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionFoundationsTwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundationsTwo"] = this.interventionFoundationsTwo ? this.interventionFoundationsTwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetInterventionFoundationsTwoForViewDto {
    interventionFoundationsTwo: InterventionFoundationsTwoDto;
}

export class GetLaboratoryProjectForEditOutput implements IGetLaboratoryProjectForEditOutput {
    laboratoryProject!: CreateOrEditLaboratoryProjectDto;

    constructor(data?: IGetLaboratoryProjectForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratoryProject = _data["laboratoryProject"] ? CreateOrEditLaboratoryProjectDto.fromJS(_data["laboratoryProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLaboratoryProjectForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryProjectForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratoryProject"] = this.laboratoryProject ? this.laboratoryProject.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLaboratoryProjectForEditOutput {
    laboratoryProject: CreateOrEditLaboratoryProjectDto;
}

export class GetLaboratoryProjectForViewDto implements IGetLaboratoryProjectForViewDto {
    laboratoryProject!: LaboratoryProjectDto;

    constructor(data?: IGetLaboratoryProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratoryProject = _data["laboratoryProject"] ? LaboratoryProjectDto.fromJS(_data["laboratoryProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLaboratoryProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratoryProject"] = this.laboratoryProject ? this.laboratoryProject.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLaboratoryProjectForViewDto {
    laboratoryProject: LaboratoryProjectDto;
}

export class GetLaboratoryProjectStatusForEditOutput implements IGetLaboratoryProjectStatusForEditOutput {
    laboratoryProjectStatus!: CreateOrEditLaboratoryProjectStatusDto;

    constructor(data?: IGetLaboratoryProjectStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratoryProjectStatus = _data["laboratoryProjectStatus"] ? CreateOrEditLaboratoryProjectStatusDto.fromJS(_data["laboratoryProjectStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLaboratoryProjectStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryProjectStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratoryProjectStatus"] = this.laboratoryProjectStatus ? this.laboratoryProjectStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLaboratoryProjectStatusForEditOutput {
    laboratoryProjectStatus: CreateOrEditLaboratoryProjectStatusDto;
}

export class GetLaboratoryProjectStatusForViewDto implements IGetLaboratoryProjectStatusForViewDto {
    laboratoryProjectStatus!: LaboratoryProjectStatusDto;

    constructor(data?: IGetLaboratoryProjectStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratoryProjectStatus = _data["laboratoryProjectStatus"] ? LaboratoryProjectStatusDto.fromJS(_data["laboratoryProjectStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLaboratoryProjectStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryProjectStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratoryProjectStatus"] = this.laboratoryProjectStatus ? this.laboratoryProjectStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLaboratoryProjectStatusForViewDto {
    laboratoryProjectStatus: LaboratoryProjectStatusDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : undefined as any;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetMeasurementPlaningForEditOutput implements IGetMeasurementPlaningForEditOutput {
    measurementPlaning!: CreateOrEditMeasurementPlaningDto;

    constructor(data?: IGetMeasurementPlaningForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaning = _data["measurementPlaning"] ? CreateOrEditMeasurementPlaningDto.fromJS(_data["measurementPlaning"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMeasurementPlaningForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaning"] = this.measurementPlaning ? this.measurementPlaning.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMeasurementPlaningForEditOutput {
    measurementPlaning: CreateOrEditMeasurementPlaningDto;
}

export class GetMeasurementPlaningForViewDto implements IGetMeasurementPlaningForViewDto {
    measurementPlaning!: MeasurementPlaningDto;

    constructor(data?: IGetMeasurementPlaningForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaning = _data["measurementPlaning"] ? MeasurementPlaningDto.fromJS(_data["measurementPlaning"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMeasurementPlaningForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaning"] = this.measurementPlaning ? this.measurementPlaning.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMeasurementPlaningForViewDto {
    measurementPlaning: MeasurementPlaningDto;
}

export class GetMeasurementPlaningOptionsForEditOutput implements IGetMeasurementPlaningOptionsForEditOutput {
    measurementPlaningOptions!: CreateOrEditMeasurementPlaningOptionsDto;
    measurementPlaningAssignmentName!: string | undefined;
    trialStandName!: string | undefined;

    constructor(data?: IGetMeasurementPlaningOptionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningOptions = _data["measurementPlaningOptions"] ? CreateOrEditMeasurementPlaningOptionsDto.fromJS(_data["measurementPlaningOptions"]) : undefined as any;
            this.measurementPlaningAssignmentName = _data["measurementPlaningAssignmentName"];
            this.trialStandName = _data["trialStandName"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningOptionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningOptionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningOptions"] = this.measurementPlaningOptions ? this.measurementPlaningOptions.toJSON() : undefined as any;
        data["measurementPlaningAssignmentName"] = this.measurementPlaningAssignmentName;
        data["trialStandName"] = this.trialStandName;
        return data;
    }
}

export interface IGetMeasurementPlaningOptionsForEditOutput {
    measurementPlaningOptions: CreateOrEditMeasurementPlaningOptionsDto;
    measurementPlaningAssignmentName: string | undefined;
    trialStandName: string | undefined;
}

export class GetMeasurementPlaningOptionsForViewDto implements IGetMeasurementPlaningOptionsForViewDto {
    measurementPlaningOptions!: MeasurementPlaningOptionsDto;
    measurementPlaningAssignmentName!: string | undefined;
    trialStandName!: string | undefined;
    measurementPlaningOptionTreatment!: GetAllMeasurementPlaningOptionsTreatmentDto;
    measurementPlaningOptionTreeNumber!: GetAllMeasurementPlaningOptionsTreeNumberDto;
    measurementPlaningOptionPartialTreeHeightNumber!: GetAllMeasurementPlaningOptionsTreeNumberDto;
    trial!: GetTrialForViewDto;
    id!: number;

    constructor(data?: IGetMeasurementPlaningOptionsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningOptions = _data["measurementPlaningOptions"] ? MeasurementPlaningOptionsDto.fromJS(_data["measurementPlaningOptions"]) : undefined as any;
            this.measurementPlaningAssignmentName = _data["measurementPlaningAssignmentName"];
            this.trialStandName = _data["trialStandName"];
            this.measurementPlaningOptionTreatment = _data["measurementPlaningOptionTreatment"] ? GetAllMeasurementPlaningOptionsTreatmentDto.fromJS(_data["measurementPlaningOptionTreatment"]) : undefined as any;
            this.measurementPlaningOptionTreeNumber = _data["measurementPlaningOptionTreeNumber"] ? GetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(_data["measurementPlaningOptionTreeNumber"]) : undefined as any;
            this.measurementPlaningOptionPartialTreeHeightNumber = _data["measurementPlaningOptionPartialTreeHeightNumber"] ? GetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(_data["measurementPlaningOptionPartialTreeHeightNumber"]) : undefined as any;
            this.trial = _data["trial"] ? GetTrialForViewDto.fromJS(_data["trial"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningOptionsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningOptionsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningOptions"] = this.measurementPlaningOptions ? this.measurementPlaningOptions.toJSON() : undefined as any;
        data["measurementPlaningAssignmentName"] = this.measurementPlaningAssignmentName;
        data["trialStandName"] = this.trialStandName;
        data["measurementPlaningOptionTreatment"] = this.measurementPlaningOptionTreatment ? this.measurementPlaningOptionTreatment.toJSON() : undefined as any;
        data["measurementPlaningOptionTreeNumber"] = this.measurementPlaningOptionTreeNumber ? this.measurementPlaningOptionTreeNumber.toJSON() : undefined as any;
        data["measurementPlaningOptionPartialTreeHeightNumber"] = this.measurementPlaningOptionPartialTreeHeightNumber ? this.measurementPlaningOptionPartialTreeHeightNumber.toJSON() : undefined as any;
        data["trial"] = this.trial ? this.trial.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetMeasurementPlaningOptionsForViewDto {
    measurementPlaningOptions: MeasurementPlaningOptionsDto;
    measurementPlaningAssignmentName: string | undefined;
    trialStandName: string | undefined;
    measurementPlaningOptionTreatment: GetAllMeasurementPlaningOptionsTreatmentDto;
    measurementPlaningOptionTreeNumber: GetAllMeasurementPlaningOptionsTreeNumberDto;
    measurementPlaningOptionPartialTreeHeightNumber: GetAllMeasurementPlaningOptionsTreeNumberDto;
    trial: GetTrialForViewDto;
    id: number;
}

export class GetMeasurementPlaningTreatmentForEditOutput implements IGetMeasurementPlaningTreatmentForEditOutput {
    measurementPlaningTreatment!: CreateOrEditMeasurementPlaningTreatmentDto;
    treatmentNameTratament!: string | undefined;
    measurementPlaningOptionsStandName!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreatmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreatment = _data["measurementPlaningTreatment"] ? CreateOrEditMeasurementPlaningTreatmentDto.fromJS(_data["measurementPlaningTreatment"]) : undefined as any;
            this.treatmentNameTratament = _data["treatmentNameTratament"];
            this.measurementPlaningOptionsStandName = _data["measurementPlaningOptionsStandName"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreatmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreatmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreatment"] = this.measurementPlaningTreatment ? this.measurementPlaningTreatment.toJSON() : undefined as any;
        data["treatmentNameTratament"] = this.treatmentNameTratament;
        data["measurementPlaningOptionsStandName"] = this.measurementPlaningOptionsStandName;
        return data;
    }
}

export interface IGetMeasurementPlaningTreatmentForEditOutput {
    measurementPlaningTreatment: CreateOrEditMeasurementPlaningTreatmentDto;
    treatmentNameTratament: string | undefined;
    measurementPlaningOptionsStandName: string | undefined;
}

export class GetMeasurementPlaningTreatmentForViewDto implements IGetMeasurementPlaningTreatmentForViewDto {
    measurementPlaningTreatment!: MeasurementPlaningTreatmentDto;
    treatmentNameTratament!: string | undefined;
    measurementPlaningOptionsStandName!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreatmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreatment = _data["measurementPlaningTreatment"] ? MeasurementPlaningTreatmentDto.fromJS(_data["measurementPlaningTreatment"]) : undefined as any;
            this.treatmentNameTratament = _data["treatmentNameTratament"];
            this.measurementPlaningOptionsStandName = _data["measurementPlaningOptionsStandName"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreatmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreatmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreatment"] = this.measurementPlaningTreatment ? this.measurementPlaningTreatment.toJSON() : undefined as any;
        data["treatmentNameTratament"] = this.treatmentNameTratament;
        data["measurementPlaningOptionsStandName"] = this.measurementPlaningOptionsStandName;
        return data;
    }
}

export interface IGetMeasurementPlaningTreatmentForViewDto {
    measurementPlaningTreatment: MeasurementPlaningTreatmentDto;
    treatmentNameTratament: string | undefined;
    measurementPlaningOptionsStandName: string | undefined;
}

export class GetMeasurementPlaningTreeHeightNumberForEditOutput implements IGetMeasurementPlaningTreeHeightNumberForEditOutput {
    measurementPlaningTreeHeightNumber!: CreateOrEditMeasurementPlaningTreeHeightNumberDto;
    measurementPlaningOptionsStandName!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreeHeightNumberForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreeHeightNumber = _data["measurementPlaningTreeHeightNumber"] ? CreateOrEditMeasurementPlaningTreeHeightNumberDto.fromJS(_data["measurementPlaningTreeHeightNumber"]) : undefined as any;
            this.measurementPlaningOptionsStandName = _data["measurementPlaningOptionsStandName"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreeHeightNumberForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreeHeightNumberForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreeHeightNumber"] = this.measurementPlaningTreeHeightNumber ? this.measurementPlaningTreeHeightNumber.toJSON() : undefined as any;
        data["measurementPlaningOptionsStandName"] = this.measurementPlaningOptionsStandName;
        return data;
    }
}

export interface IGetMeasurementPlaningTreeHeightNumberForEditOutput {
    measurementPlaningTreeHeightNumber: CreateOrEditMeasurementPlaningTreeHeightNumberDto;
    measurementPlaningOptionsStandName: string | undefined;
}

export class GetMeasurementPlaningTreeHeightNumberForViewDto implements IGetMeasurementPlaningTreeHeightNumberForViewDto {
    measurementPlaningTreeHeightNumber!: MeasurementPlaningTreeHeightNumberDto;
    measurementPlaningOptionsStandName!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreeHeightNumberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreeHeightNumber = _data["measurementPlaningTreeHeightNumber"] ? MeasurementPlaningTreeHeightNumberDto.fromJS(_data["measurementPlaningTreeHeightNumber"]) : undefined as any;
            this.measurementPlaningOptionsStandName = _data["measurementPlaningOptionsStandName"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreeHeightNumberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreeHeightNumberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreeHeightNumber"] = this.measurementPlaningTreeHeightNumber ? this.measurementPlaningTreeHeightNumber.toJSON() : undefined as any;
        data["measurementPlaningOptionsStandName"] = this.measurementPlaningOptionsStandName;
        return data;
    }
}

export interface IGetMeasurementPlaningTreeHeightNumberForViewDto {
    measurementPlaningTreeHeightNumber: MeasurementPlaningTreeHeightNumberDto;
    measurementPlaningOptionsStandName: string | undefined;
}

export class GetMeasurementPlaningTreeNumberForEditOutput implements IGetMeasurementPlaningTreeNumberForEditOutput {
    measurementPlaningTreeNumber!: CreateOrEditMeasurementPlaningTreeNumberDto;
    measurementPlaningOptionsTrialNumber!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreeNumberForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreeNumber = _data["measurementPlaningTreeNumber"] ? CreateOrEditMeasurementPlaningTreeNumberDto.fromJS(_data["measurementPlaningTreeNumber"]) : undefined as any;
            this.measurementPlaningOptionsTrialNumber = _data["measurementPlaningOptionsTrialNumber"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreeNumberForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreeNumberForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreeNumber"] = this.measurementPlaningTreeNumber ? this.measurementPlaningTreeNumber.toJSON() : undefined as any;
        data["measurementPlaningOptionsTrialNumber"] = this.measurementPlaningOptionsTrialNumber;
        return data;
    }
}

export interface IGetMeasurementPlaningTreeNumberForEditOutput {
    measurementPlaningTreeNumber: CreateOrEditMeasurementPlaningTreeNumberDto;
    measurementPlaningOptionsTrialNumber: string | undefined;
}

export class GetMeasurementPlaningTreeNumberForViewDto implements IGetMeasurementPlaningTreeNumberForViewDto {
    measurementPlaningTreeNumber!: MeasurementPlaningTreeNumberDto;
    measurementPlaningOptionsTrialNumber!: string | undefined;

    constructor(data?: IGetMeasurementPlaningTreeNumberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementPlaningTreeNumber = _data["measurementPlaningTreeNumber"] ? MeasurementPlaningTreeNumberDto.fromJS(_data["measurementPlaningTreeNumber"]) : undefined as any;
            this.measurementPlaningOptionsTrialNumber = _data["measurementPlaningOptionsTrialNumber"];
        }
    }

    static fromJS(data: any): GetMeasurementPlaningTreeNumberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementPlaningTreeNumberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementPlaningTreeNumber"] = this.measurementPlaningTreeNumber ? this.measurementPlaningTreeNumber.toJSON() : undefined as any;
        data["measurementPlaningOptionsTrialNumber"] = this.measurementPlaningOptionsTrialNumber;
        return data;
    }
}

export interface IGetMeasurementPlaningTreeNumberForViewDto {
    measurementPlaningTreeNumber: MeasurementPlaningTreeNumberDto;
    measurementPlaningOptionsTrialNumber: string | undefined;
}

export class GetMeasurementSelectionForEditOutput implements IGetMeasurementSelectionForEditOutput {
    measurementSelection!: CreateOrEditMeasurementSelectionDto;
    treeSpecie!: string | undefined;
    woodSampleTypeName!: string | undefined;
    woodSampleTypeName2!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IGetMeasurementSelectionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSelection = _data["measurementSelection"] ? CreateOrEditMeasurementSelectionDto.fromJS(_data["measurementSelection"]) : undefined as any;
            this.treeSpecie = _data["treeSpecie"];
            this.woodSampleTypeName = _data["woodSampleTypeName"];
            this.woodSampleTypeName2 = _data["woodSampleTypeName2"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSelection"] = this.measurementSelection ? this.measurementSelection.toJSON() : undefined as any;
        data["treeSpecie"] = this.treeSpecie;
        data["woodSampleTypeName"] = this.woodSampleTypeName;
        data["woodSampleTypeName2"] = this.woodSampleTypeName2;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IGetMeasurementSelectionForEditOutput {
    measurementSelection: CreateOrEditMeasurementSelectionDto;
    treeSpecie: string | undefined;
    woodSampleTypeName: string | undefined;
    woodSampleTypeName2: string | undefined;
    projectName: string | undefined;
}

export class GetMeasurementSelectionForViewDto implements IGetMeasurementSelectionForViewDto {
    measurementSelection!: MeasurementSelectionDto;
    treeSpecie!: string | undefined;
    woodSampleTypeName!: string | undefined;
    woodSampleTypeName2!: string | undefined;
    projectName!: string | undefined;
    date!: DateTime | undefined;
    laboratoryProjectTypeName!: string | undefined;
    laboratoryProjectStatusName!: string | undefined;
    treeName!: string | undefined;
    specie!: string | undefined;
    specieType!: string | undefined;
    treatmentType!: string | undefined;
    trial!: number;
    treatment!: string | undefined;
    block!: number | undefined;
    treeStatus!: string | undefined;
    subBlock!: number | undefined;
    treeNumber!: number;
    materialType!: string | undefined;
    plantationDate!: DateTime | undefined;
    laboratoryId!: string | undefined;
    subProyecto!: string | undefined;
    year!: number | undefined;
    samplingDate!: DateTime | undefined;
    treeAgeSamplingDate!: number | undefined;
    treeStatusId!: number;
    treeStatusName!: string | undefined;
    speciesName!: string | undefined;
    projectId!: number;
    finalNumberOfPlants!: number | undefined;
    roatingPercentageTrayOriginPlant!: string | undefined;

    constructor(data?: IGetMeasurementSelectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSelection = _data["measurementSelection"] ? MeasurementSelectionDto.fromJS(_data["measurementSelection"]) : undefined as any;
            this.treeSpecie = _data["treeSpecie"];
            this.woodSampleTypeName = _data["woodSampleTypeName"];
            this.woodSampleTypeName2 = _data["woodSampleTypeName2"];
            this.projectName = _data["projectName"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.laboratoryProjectTypeName = _data["laboratoryProjectTypeName"];
            this.laboratoryProjectStatusName = _data["laboratoryProjectStatusName"];
            this.treeName = _data["treeName"];
            this.specie = _data["specie"];
            this.specieType = _data["specieType"];
            this.treatmentType = _data["treatmentType"];
            this.trial = _data["trial"];
            this.treatment = _data["treatment"];
            this.block = _data["block"];
            this.treeStatus = _data["treeStatus"];
            this.subBlock = _data["subBlock"];
            this.treeNumber = _data["treeNumber"];
            this.materialType = _data["materialType"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.laboratoryId = _data["laboratoryId"];
            this.subProyecto = _data["subProyecto"];
            this.year = _data["year"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.treeAgeSamplingDate = _data["treeAgeSamplingDate"];
            this.treeStatusId = _data["treeStatusId"];
            this.treeStatusName = _data["treeStatusName"];
            this.speciesName = _data["speciesName"];
            this.projectId = _data["projectId"];
            this.finalNumberOfPlants = _data["finalNumberOfPlants"];
            this.roatingPercentageTrayOriginPlant = _data["roatingPercentageTrayOriginPlant"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSelection"] = this.measurementSelection ? this.measurementSelection.toJSON() : undefined as any;
        data["treeSpecie"] = this.treeSpecie;
        data["woodSampleTypeName"] = this.woodSampleTypeName;
        data["woodSampleTypeName2"] = this.woodSampleTypeName2;
        data["projectName"] = this.projectName;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["laboratoryProjectTypeName"] = this.laboratoryProjectTypeName;
        data["laboratoryProjectStatusName"] = this.laboratoryProjectStatusName;
        data["treeName"] = this.treeName;
        data["specie"] = this.specie;
        data["specieType"] = this.specieType;
        data["treatmentType"] = this.treatmentType;
        data["trial"] = this.trial;
        data["treatment"] = this.treatment;
        data["block"] = this.block;
        data["treeStatus"] = this.treeStatus;
        data["subBlock"] = this.subBlock;
        data["treeNumber"] = this.treeNumber;
        data["materialType"] = this.materialType;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["laboratoryId"] = this.laboratoryId;
        data["subProyecto"] = this.subProyecto;
        data["year"] = this.year;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["treeAgeSamplingDate"] = this.treeAgeSamplingDate;
        data["treeStatusId"] = this.treeStatusId;
        data["treeStatusName"] = this.treeStatusName;
        data["speciesName"] = this.speciesName;
        data["projectId"] = this.projectId;
        data["finalNumberOfPlants"] = this.finalNumberOfPlants;
        data["roatingPercentageTrayOriginPlant"] = this.roatingPercentageTrayOriginPlant;
        return data;
    }
}

export interface IGetMeasurementSelectionForViewDto {
    measurementSelection: MeasurementSelectionDto;
    treeSpecie: string | undefined;
    woodSampleTypeName: string | undefined;
    woodSampleTypeName2: string | undefined;
    projectName: string | undefined;
    date: DateTime | undefined;
    laboratoryProjectTypeName: string | undefined;
    laboratoryProjectStatusName: string | undefined;
    treeName: string | undefined;
    specie: string | undefined;
    specieType: string | undefined;
    treatmentType: string | undefined;
    trial: number;
    treatment: string | undefined;
    block: number | undefined;
    treeStatus: string | undefined;
    subBlock: number | undefined;
    treeNumber: number;
    materialType: string | undefined;
    plantationDate: DateTime | undefined;
    laboratoryId: string | undefined;
    subProyecto: string | undefined;
    year: number | undefined;
    samplingDate: DateTime | undefined;
    treeAgeSamplingDate: number | undefined;
    treeStatusId: number;
    treeStatusName: string | undefined;
    speciesName: string | undefined;
    projectId: number;
    finalNumberOfPlants: number | undefined;
    roatingPercentageTrayOriginPlant: string | undefined;
}

export class GetMeasurementSelectionGenomicForEditOutput implements IGetMeasurementSelectionGenomicForEditOutput {
    measurementSelectionGenomic!: CreateOrEditMeasurementSelectionGenomicDto;
    seedlingSubProject!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IGetMeasurementSelectionGenomicForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSelectionGenomic = _data["measurementSelectionGenomic"] ? CreateOrEditMeasurementSelectionGenomicDto.fromJS(_data["measurementSelectionGenomic"]) : undefined as any;
            this.seedlingSubProject = _data["seedlingSubProject"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionGenomicForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionGenomicForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSelectionGenomic"] = this.measurementSelectionGenomic ? this.measurementSelectionGenomic.toJSON() : undefined as any;
        data["seedlingSubProject"] = this.seedlingSubProject;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IGetMeasurementSelectionGenomicForEditOutput {
    measurementSelectionGenomic: CreateOrEditMeasurementSelectionGenomicDto;
    seedlingSubProject: string | undefined;
    projectName: string | undefined;
}

export class GetMeasurementSelectionGenomicForViewDto implements IGetMeasurementSelectionGenomicForViewDto {
    specie!: string | undefined;
    treatmentType!: string | undefined;
    seedlingName!: string | undefined;
    projectType!: string | undefined;
    projectName!: string | undefined;
    subProject!: string | undefined;
    anio!: number;
    geneticMaterial!: string | undefined;
    sampleType!: string | undefined;
    plantin!: number;
    seedlingSubProject!: string | undefined;
    measurementSelectionGenomic!: MeasurementSelectionGenomicDto;
    projectStatus!: string | undefined;
    specieName!: any | undefined;
    specieType!: any | undefined;
    motherId!: string | undefined;
    fatherId!: string | undefined;
    samplingDate!: DateTime;
    tag!: string | undefined;

    constructor(data?: IGetMeasurementSelectionGenomicForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specie = _data["specie"];
            this.treatmentType = _data["treatmentType"];
            this.seedlingName = _data["seedlingName"];
            this.projectType = _data["projectType"];
            this.projectName = _data["projectName"];
            this.subProject = _data["subProject"];
            this.anio = _data["anio"];
            this.geneticMaterial = _data["geneticMaterial"];
            this.sampleType = _data["sampleType"];
            this.plantin = _data["plantin"];
            this.seedlingSubProject = _data["seedlingSubProject"];
            this.measurementSelectionGenomic = _data["measurementSelectionGenomic"] ? MeasurementSelectionGenomicDto.fromJS(_data["measurementSelectionGenomic"]) : undefined as any;
            this.projectStatus = _data["projectStatus"];
            this.specieName = _data["specieName"];
            this.specieType = _data["specieType"];
            this.motherId = _data["motherId"];
            this.fatherId = _data["fatherId"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionGenomicForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionGenomicForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specie"] = this.specie;
        data["treatmentType"] = this.treatmentType;
        data["seedlingName"] = this.seedlingName;
        data["projectType"] = this.projectType;
        data["projectName"] = this.projectName;
        data["subProject"] = this.subProject;
        data["anio"] = this.anio;
        data["geneticMaterial"] = this.geneticMaterial;
        data["sampleType"] = this.sampleType;
        data["plantin"] = this.plantin;
        data["seedlingSubProject"] = this.seedlingSubProject;
        data["measurementSelectionGenomic"] = this.measurementSelectionGenomic ? this.measurementSelectionGenomic.toJSON() : undefined as any;
        data["projectStatus"] = this.projectStatus;
        data["specieName"] = this.specieName;
        data["specieType"] = this.specieType;
        data["motherId"] = this.motherId;
        data["fatherId"] = this.fatherId;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IGetMeasurementSelectionGenomicForViewDto {
    specie: string | undefined;
    treatmentType: string | undefined;
    seedlingName: string | undefined;
    projectType: string | undefined;
    projectName: string | undefined;
    subProject: string | undefined;
    anio: number;
    geneticMaterial: string | undefined;
    sampleType: string | undefined;
    plantin: number;
    seedlingSubProject: string | undefined;
    measurementSelectionGenomic: MeasurementSelectionGenomicDto;
    projectStatus: string | undefined;
    specieName: any | undefined;
    specieType: any | undefined;
    motherId: string | undefined;
    fatherId: string | undefined;
    samplingDate: DateTime;
    tag: string | undefined;
}

export class GetMeasurementSelectionOtherProjectForEditOutput implements IGetMeasurementSelectionOtherProjectForEditOutput {
    measurementSelectionOtherProject!: CreateOrEditMeasurementSelectionOtherProjectDto;
    projectName!: string | undefined;
    projectLabTypeName!: string | undefined;
    bbxName!: string | undefined;
    bbsName!: string | undefined;
    woodSampleTypeName!: string | undefined;

    constructor(data?: IGetMeasurementSelectionOtherProjectForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSelectionOtherProject = _data["measurementSelectionOtherProject"] ? CreateOrEditMeasurementSelectionOtherProjectDto.fromJS(_data["measurementSelectionOtherProject"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.projectLabTypeName = _data["projectLabTypeName"];
            this.bbxName = _data["bbxName"];
            this.bbsName = _data["bbsName"];
            this.woodSampleTypeName = _data["woodSampleTypeName"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionOtherProjectForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionOtherProjectForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSelectionOtherProject"] = this.measurementSelectionOtherProject ? this.measurementSelectionOtherProject.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["projectLabTypeName"] = this.projectLabTypeName;
        data["bbxName"] = this.bbxName;
        data["bbsName"] = this.bbsName;
        data["woodSampleTypeName"] = this.woodSampleTypeName;
        return data;
    }
}

export interface IGetMeasurementSelectionOtherProjectForEditOutput {
    measurementSelectionOtherProject: CreateOrEditMeasurementSelectionOtherProjectDto;
    projectName: string | undefined;
    projectLabTypeName: string | undefined;
    bbxName: string | undefined;
    bbsName: string | undefined;
    woodSampleTypeName: string | undefined;
}

export class GetMeasurementSelectionOtherProjectForViewDto implements IGetMeasurementSelectionOtherProjectForViewDto {
    measurementSelectionOtherProject!: MeasurementSelectionOtherProjectDto;
    projectName!: string | undefined;
    bbxName!: string | undefined;
    bbsName!: string | undefined;
    woodSampleTypeName!: string | undefined;
    laboratoryProjectName!: string | undefined;

    constructor(data?: IGetMeasurementSelectionOtherProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSelectionOtherProject = _data["measurementSelectionOtherProject"] ? MeasurementSelectionOtherProjectDto.fromJS(_data["measurementSelectionOtherProject"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.bbxName = _data["bbxName"];
            this.bbsName = _data["bbsName"];
            this.woodSampleTypeName = _data["woodSampleTypeName"];
            this.laboratoryProjectName = _data["laboratoryProjectName"];
        }
    }

    static fromJS(data: any): GetMeasurementSelectionOtherProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementSelectionOtherProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSelectionOtherProject"] = this.measurementSelectionOtherProject ? this.measurementSelectionOtherProject.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["bbxName"] = this.bbxName;
        data["bbsName"] = this.bbsName;
        data["woodSampleTypeName"] = this.woodSampleTypeName;
        data["laboratoryProjectName"] = this.laboratoryProjectName;
        return data;
    }
}

export interface IGetMeasurementSelectionOtherProjectForViewDto {
    measurementSelectionOtherProject: MeasurementSelectionOtherProjectDto;
    projectName: string | undefined;
    bbxName: string | undefined;
    bbsName: string | undefined;
    woodSampleTypeName: string | undefined;
    laboratoryProjectName: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetMesurementCloneEvaluationForEditOutput implements IGetMesurementCloneEvaluationForEditOutput {
    mesurementCloneEvaluation!: CreateOrEditMesurementCloneEvaluationDto;
    projectName!: string | undefined;
    trialOldTrialDenomination!: string | undefined;
    treeName!: string | undefined;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;
    treeStatusName!: string | undefined;

    constructor(data?: IGetMesurementCloneEvaluationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mesurementCloneEvaluation = _data["mesurementCloneEvaluation"] ? CreateOrEditMesurementCloneEvaluationDto.fromJS(_data["mesurementCloneEvaluation"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.trialOldTrialDenomination = _data["trialOldTrialDenomination"];
            this.treeName = _data["treeName"];
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
            this.treeStatusName = _data["treeStatusName"];
        }
    }

    static fromJS(data: any): GetMesurementCloneEvaluationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMesurementCloneEvaluationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mesurementCloneEvaluation"] = this.mesurementCloneEvaluation ? this.mesurementCloneEvaluation.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["trialOldTrialDenomination"] = this.trialOldTrialDenomination;
        data["treeName"] = this.treeName;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        data["treeStatusName"] = this.treeStatusName;
        return data;
    }
}

export interface IGetMesurementCloneEvaluationForEditOutput {
    mesurementCloneEvaluation: CreateOrEditMesurementCloneEvaluationDto;
    projectName: string | undefined;
    trialOldTrialDenomination: string | undefined;
    treeName: string | undefined;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
    treeStatusName: string | undefined;
}

export class GetMesurementCloneEvaluationForViewDto implements IGetMesurementCloneEvaluationForViewDto {
    mesurementCloneEvaluation!: MesurementCloneEvaluationDto;
    projectName!: string | undefined;
    trialOldTrialDenomination!: string | undefined;
    treeSpecie!: string | undefined;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;
    treeStatusName!: string | undefined;
    typeProjectName!: string | undefined;
    treeNumber!: string | undefined;
    treeName!: string | undefined;
    bbt!: string | undefined;
    projectStatus!: string | undefined;
    typeSpecie!: string | undefined;
    groupSpecie!: string | undefined;
    rootingPercentage!: number | undefined;
    destination!: string | undefined;
    typeTreatment!: string | undefined;
    finalNumberOfPlants!: number | undefined;
    roatingPercentageTrayOriginPlant!: string | undefined;

    constructor(data?: IGetMesurementCloneEvaluationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mesurementCloneEvaluation = _data["mesurementCloneEvaluation"] ? MesurementCloneEvaluationDto.fromJS(_data["mesurementCloneEvaluation"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.trialOldTrialDenomination = _data["trialOldTrialDenomination"];
            this.treeSpecie = _data["treeSpecie"];
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
            this.treeStatusName = _data["treeStatusName"];
            this.typeProjectName = _data["typeProjectName"];
            this.treeNumber = _data["treeNumber"];
            this.treeName = _data["treeName"];
            this.bbt = _data["bbt"];
            this.projectStatus = _data["projectStatus"];
            this.typeSpecie = _data["typeSpecie"];
            this.groupSpecie = _data["groupSpecie"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.destination = _data["destination"];
            this.typeTreatment = _data["typeTreatment"];
            this.finalNumberOfPlants = _data["finalNumberOfPlants"];
            this.roatingPercentageTrayOriginPlant = _data["roatingPercentageTrayOriginPlant"];
        }
    }

    static fromJS(data: any): GetMesurementCloneEvaluationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMesurementCloneEvaluationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mesurementCloneEvaluation"] = this.mesurementCloneEvaluation ? this.mesurementCloneEvaluation.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["trialOldTrialDenomination"] = this.trialOldTrialDenomination;
        data["treeSpecie"] = this.treeSpecie;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        data["treeStatusName"] = this.treeStatusName;
        data["typeProjectName"] = this.typeProjectName;
        data["treeNumber"] = this.treeNumber;
        data["treeName"] = this.treeName;
        data["bbt"] = this.bbt;
        data["projectStatus"] = this.projectStatus;
        data["typeSpecie"] = this.typeSpecie;
        data["groupSpecie"] = this.groupSpecie;
        data["rootingPercentage"] = this.rootingPercentage;
        data["destination"] = this.destination;
        data["typeTreatment"] = this.typeTreatment;
        data["finalNumberOfPlants"] = this.finalNumberOfPlants;
        data["roatingPercentageTrayOriginPlant"] = this.roatingPercentageTrayOriginPlant;
        return data;
    }
}

export interface IGetMesurementCloneEvaluationForViewDto {
    mesurementCloneEvaluation: MesurementCloneEvaluationDto;
    projectName: string | undefined;
    trialOldTrialDenomination: string | undefined;
    treeSpecie: string | undefined;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
    treeStatusName: string | undefined;
    typeProjectName: string | undefined;
    treeNumber: string | undefined;
    treeName: string | undefined;
    bbt: string | undefined;
    projectStatus: string | undefined;
    typeSpecie: string | undefined;
    groupSpecie: string | undefined;
    rootingPercentage: number | undefined;
    destination: string | undefined;
    typeTreatment: string | undefined;
    finalNumberOfPlants: number | undefined;
    roatingPercentageTrayOriginPlant: string | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class GetParameterForEditOutput implements IGetParameterForEditOutput {
    parameter!: CreateOrEditParameterDto;

    constructor(data?: IGetParameterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"] ? CreateOrEditParameterDto.fromJS(_data["parameter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetParameterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetParameterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetParameterForEditOutput {
    parameter: CreateOrEditParameterDto;
}

export class GetParameterForViewDto implements IGetParameterForViewDto {
    parameter!: ParameterDto;

    constructor(data?: IGetParameterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetParameterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetParameterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetParameterForViewDto {
    parameter: ParameterDto;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetPestAndDiseaseForEditOutput implements IGetPestAndDiseaseForEditOutput {
    pestAndDisease!: CreateOrEditPestAndDiseaseDto;

    constructor(data?: IGetPestAndDiseaseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pestAndDisease = _data["pestAndDisease"] ? CreateOrEditPestAndDiseaseDto.fromJS(_data["pestAndDisease"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPestAndDiseaseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPestAndDiseaseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pestAndDisease"] = this.pestAndDisease ? this.pestAndDisease.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPestAndDiseaseForEditOutput {
    pestAndDisease: CreateOrEditPestAndDiseaseDto;
}

export class GetPestAndDiseaseForViewDto implements IGetPestAndDiseaseForViewDto {
    pestAndDisease!: PestAndDiseaseDto;

    constructor(data?: IGetPestAndDiseaseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pestAndDisease = _data["pestAndDisease"] ? PestAndDiseaseDto.fromJS(_data["pestAndDisease"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPestAndDiseaseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPestAndDiseaseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pestAndDisease"] = this.pestAndDisease ? this.pestAndDisease.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPestAndDiseaseForViewDto {
    pestAndDisease: PestAndDiseaseDto;
}

export class GetPolenForEditOutput implements IGetPolenForEditOutput {
    polen!: CreateOrEditPolenDto;
    supplierName!: string | undefined;
    trialStandName!: string | undefined;
    trialFarmName!: string | undefined;
    treeName!: string | undefined;
    trialNumber!: number | undefined;

    constructor(data?: IGetPolenForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polen = _data["polen"] ? CreateOrEditPolenDto.fromJS(_data["polen"]) : undefined as any;
            this.supplierName = _data["supplierName"];
            this.trialStandName = _data["trialStandName"];
            this.trialFarmName = _data["trialFarmName"];
            this.treeName = _data["treeName"];
            this.trialNumber = _data["trialNumber"];
        }
    }

    static fromJS(data: any): GetPolenForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polen"] = this.polen ? this.polen.toJSON() : undefined as any;
        data["supplierName"] = this.supplierName;
        data["trialStandName"] = this.trialStandName;
        data["trialFarmName"] = this.trialFarmName;
        data["treeName"] = this.treeName;
        data["trialNumber"] = this.trialNumber;
        return data;
    }
}

export interface IGetPolenForEditOutput {
    polen: CreateOrEditPolenDto;
    supplierName: string | undefined;
    trialStandName: string | undefined;
    trialFarmName: string | undefined;
    treeName: string | undefined;
    trialNumber: number | undefined;
}

export class GetPolenForViewDto implements IGetPolenForViewDto {
    polen!: PolenDto;
    supplierName!: string | undefined;
    trialStandName!: string | undefined;
    trialFarmName!: any | undefined;
    trialNumber!: number;
    readonly polenMixture!: any | undefined;

    constructor(data?: IGetPolenForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polen = _data["polen"] ? PolenDto.fromJS(_data["polen"]) : undefined as any;
            this.supplierName = _data["supplierName"];
            this.trialStandName = _data["trialStandName"];
            this.trialFarmName = _data["trialFarmName"];
            this.trialNumber = _data["trialNumber"];
            (this as any).polenMixture = _data["polenMixture"];
        }
    }

    static fromJS(data: any): GetPolenForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polen"] = this.polen ? this.polen.toJSON() : undefined as any;
        data["supplierName"] = this.supplierName;
        data["trialStandName"] = this.trialStandName;
        data["trialFarmName"] = this.trialFarmName;
        data["trialNumber"] = this.trialNumber;
        data["polenMixture"] = this.polenMixture;
        return data;
    }
}

export interface IGetPolenForViewDto {
    polen: PolenDto;
    supplierName: string | undefined;
    trialStandName: string | undefined;
    trialFarmName: any | undefined;
    trialNumber: number;
    polenMixture: any | undefined;
}

export class GetPolenMixtureForEditOutput implements IGetPolenMixtureForEditOutput {
    polenMixture!: CreateOrEditPolenMixtureDto;
    polenCompositionId!: number;

    constructor(data?: IGetPolenMixtureForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polenMixture = _data["polenMixture"] ? CreateOrEditPolenMixtureDto.fromJS(_data["polenMixture"]) : undefined as any;
            this.polenCompositionId = _data["polenCompositionId"];
        }
    }

    static fromJS(data: any): GetPolenMixtureForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenMixtureForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polenMixture"] = this.polenMixture ? this.polenMixture.toJSON() : undefined as any;
        data["polenCompositionId"] = this.polenCompositionId;
        return data;
    }
}

export interface IGetPolenMixtureForEditOutput {
    polenMixture: CreateOrEditPolenMixtureDto;
    polenCompositionId: number;
}

export class GetPolenMixtureForViewDto implements IGetPolenMixtureForViewDto {
    polenMixture!: _definitions_PolenMixtureDto;
    polenCompositionId!: number;

    constructor(data?: IGetPolenMixtureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polenMixture = _data["polenMixture"] ? _definitions_PolenMixtureDto.fromJS(_data["polenMixture"]) : undefined as any;
            this.polenCompositionId = _data["polenCompositionId"];
        }
    }

    static fromJS(data: any): GetPolenMixtureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenMixtureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polenMixture"] = this.polenMixture ? this.polenMixture.toJSON() : undefined as any;
        data["polenCompositionId"] = this.polenCompositionId;
        return data;
    }
}

export interface IGetPolenMixtureForViewDto {
    polenMixture: _definitions_PolenMixtureDto;
    polenCompositionId: number;
}

export class GetPolenStockMovementForEditOutput implements IGetPolenStockMovementForEditOutput {
    polenStockMovement!: CreateOrEditPolenStockMovementDto;
    bbp!: string | undefined;
    polenNumber!: number;
    polenSpecie!: string | undefined;
    polenCurrentStock!: number;
    progenieStateName!: string | undefined;
    progenieStateTwoName!: string | undefined;
    polenHarvestDate!: DateTime;

    constructor(data?: IGetPolenStockMovementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polenStockMovement = _data["polenStockMovement"] ? CreateOrEditPolenStockMovementDto.fromJS(_data["polenStockMovement"]) : undefined as any;
            this.bbp = _data["bbp"];
            this.polenNumber = _data["polenNumber"];
            this.polenSpecie = _data["polenSpecie"];
            this.polenCurrentStock = _data["polenCurrentStock"];
            this.progenieStateName = _data["progenieStateName"];
            this.progenieStateTwoName = _data["progenieStateTwoName"];
            this.polenHarvestDate = _data["polenHarvestDate"] ? DateTime.fromISO(_data["polenHarvestDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetPolenStockMovementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenStockMovementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polenStockMovement"] = this.polenStockMovement ? this.polenStockMovement.toJSON() : undefined as any;
        data["bbp"] = this.bbp;
        data["polenNumber"] = this.polenNumber;
        data["polenSpecie"] = this.polenSpecie;
        data["polenCurrentStock"] = this.polenCurrentStock;
        data["progenieStateName"] = this.progenieStateName;
        data["progenieStateTwoName"] = this.progenieStateTwoName;
        data["polenHarvestDate"] = this.polenHarvestDate ? this.polenHarvestDate.toString() : undefined as any;
        return data;
    }
}

export interface IGetPolenStockMovementForEditOutput {
    polenStockMovement: CreateOrEditPolenStockMovementDto;
    bbp: string | undefined;
    polenNumber: number;
    polenSpecie: string | undefined;
    polenCurrentStock: number;
    progenieStateName: string | undefined;
    progenieStateTwoName: string | undefined;
    polenHarvestDate: DateTime;
}

export class GetPolenStockMovementForViewDto implements IGetPolenStockMovementForViewDto {
    polenStockMovement!: PolenStockMovementDto;
    polenStock!: PolenStockDto;
    progeniesStatesState!: string | undefined;
    progeniesStatesTwoState!: string | undefined;

    constructor(data?: IGetPolenStockMovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polenStockMovement = _data["polenStockMovement"] ? PolenStockMovementDto.fromJS(_data["polenStockMovement"]) : undefined as any;
            this.polenStock = _data["polenStock"] ? PolenStockDto.fromJS(_data["polenStock"]) : undefined as any;
            this.progeniesStatesState = _data["progeniesStatesState"];
            this.progeniesStatesTwoState = _data["progeniesStatesTwoState"];
        }
    }

    static fromJS(data: any): GetPolenStockMovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolenStockMovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polenStockMovement"] = this.polenStockMovement ? this.polenStockMovement.toJSON() : undefined as any;
        data["polenStock"] = this.polenStock ? this.polenStock.toJSON() : undefined as any;
        data["progeniesStatesState"] = this.progeniesStatesState;
        data["progeniesStatesTwoState"] = this.progeniesStatesTwoState;
        return data;
    }
}

export interface IGetPolenStockMovementForViewDto {
    polenStockMovement: PolenStockMovementDto;
    polenStock: PolenStockDto;
    progeniesStatesState: string | undefined;
    progeniesStatesTwoState: string | undefined;
}

export class GetPorcentajeBBXForEditOutput implements IGetPorcentajeBBXForEditOutput {
    porcentajeBBX!: CreateOrEditPorcentajeBBXDto;
    cloneBBX!: string | undefined;
    projectName!: string | undefined;
    destineName!: string | undefined;
    type!: string | undefined;
    measurementSelectionNumberT!: string | undefined;

    constructor(data?: IGetPorcentajeBBXForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porcentajeBBX = _data["porcentajeBBX"] ? CreateOrEditPorcentajeBBXDto.fromJS(_data["porcentajeBBX"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.projectName = _data["projectName"];
            this.destineName = _data["destineName"];
            this.type = _data["type"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
        }
    }

    static fromJS(data: any): GetPorcentajeBBXForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorcentajeBBXForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porcentajeBBX"] = this.porcentajeBBX ? this.porcentajeBBX.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["projectName"] = this.projectName;
        data["destineName"] = this.destineName;
        data["type"] = this.type;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        return data;
    }
}

export interface IGetPorcentajeBBXForEditOutput {
    porcentajeBBX: CreateOrEditPorcentajeBBXDto;
    cloneBBX: string | undefined;
    projectName: string | undefined;
    destineName: string | undefined;
    type: string | undefined;
    measurementSelectionNumberT: string | undefined;
}

export class GetPorcentajeBBXForViewDto implements IGetPorcentajeBBXForViewDto {
    porcentajeBBX!: PorcentajeBBXDto;
    dateHarvest!: DateTime;
    cloneBBX!: string | undefined;
    projectName!: string | undefined;
    destineName!: string | undefined;
    type!: string | undefined;
    measurementSelectionNumberT!: string | undefined;

    constructor(data?: IGetPorcentajeBBXForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porcentajeBBX = _data["porcentajeBBX"] ? PorcentajeBBXDto.fromJS(_data["porcentajeBBX"]) : undefined as any;
            this.dateHarvest = _data["dateHarvest"] ? DateTime.fromISO(_data["dateHarvest"].toString()) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.projectName = _data["projectName"];
            this.destineName = _data["destineName"];
            this.type = _data["type"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
        }
    }

    static fromJS(data: any): GetPorcentajeBBXForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorcentajeBBXForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porcentajeBBX"] = this.porcentajeBBX ? this.porcentajeBBX.toJSON() : undefined as any;
        data["dateHarvest"] = this.dateHarvest ? this.dateHarvest.toString() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["projectName"] = this.projectName;
        data["destineName"] = this.destineName;
        data["type"] = this.type;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        return data;
    }
}

export interface IGetPorcentajeBBXForViewDto {
    porcentajeBBX: PorcentajeBBXDto;
    dateHarvest: DateTime;
    cloneBBX: string | undefined;
    projectName: string | undefined;
    destineName: string | undefined;
    type: string | undefined;
    measurementSelectionNumberT: string | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetProgeniesStateForEditOutput implements IGetProgeniesStateForEditOutput {
    progeniesState!: CreateOrEditProgeniesStateDto;

    constructor(data?: IGetProgeniesStateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progeniesState = _data["progeniesState"] ? CreateOrEditProgeniesStateDto.fromJS(_data["progeniesState"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetProgeniesStateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgeniesStateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progeniesState"] = this.progeniesState ? this.progeniesState.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetProgeniesStateForEditOutput {
    progeniesState: CreateOrEditProgeniesStateDto;
}

export class GetProgeniesStateForViewDto implements IGetProgeniesStateForViewDto {
    progeniesState!: ProgeniesStateDto;

    constructor(data?: IGetProgeniesStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progeniesState = _data["progeniesState"] ? ProgeniesStateDto.fromJS(_data["progeniesState"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetProgeniesStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgeniesStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progeniesState"] = this.progeniesState ? this.progeniesState.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetProgeniesStateForViewDto {
    progeniesState: ProgeniesStateDto;
}

export class GetProgeniesStateTwoForEditOutput implements IGetProgeniesStateTwoForEditOutput {
    progeniesStateTwo!: CreateOrEditProgeniesStateTwoDto;

    constructor(data?: IGetProgeniesStateTwoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progeniesStateTwo = _data["progeniesStateTwo"] ? CreateOrEditProgeniesStateTwoDto.fromJS(_data["progeniesStateTwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetProgeniesStateTwoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgeniesStateTwoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progeniesStateTwo"] = this.progeniesStateTwo ? this.progeniesStateTwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetProgeniesStateTwoForEditOutput {
    progeniesStateTwo: CreateOrEditProgeniesStateTwoDto;
}

export class GetProgeniesStateTwoForViewDto implements IGetProgeniesStateTwoForViewDto {
    progeniesStateTwo!: ProgeniesStateTwoDto;

    constructor(data?: IGetProgeniesStateTwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progeniesStateTwo = _data["progeniesStateTwo"] ? ProgeniesStateTwoDto.fromJS(_data["progeniesStateTwo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetProgeniesStateTwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgeniesStateTwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progeniesStateTwo"] = this.progeniesStateTwo ? this.progeniesStateTwo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetProgeniesStateTwoForViewDto {
    progeniesStateTwo: ProgeniesStateTwoDto;
}

export class GetProjectConfigurationForEditOutput implements IGetProjectConfigurationForEditOutput {
    projectConfiguration!: CreateOrEditProjectConfigurationDto;
    cloneBBX!: string | undefined;
    seedBBS!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IGetProjectConfigurationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectConfiguration = _data["projectConfiguration"] ? CreateOrEditProjectConfigurationDto.fromJS(_data["projectConfiguration"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.seedBBS = _data["seedBBS"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectConfigurationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectConfigurationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectConfiguration"] = this.projectConfiguration ? this.projectConfiguration.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["seedBBS"] = this.seedBBS;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IGetProjectConfigurationForEditOutput {
    projectConfiguration: CreateOrEditProjectConfigurationDto;
    cloneBBX: string | undefined;
    seedBBS: string | undefined;
    projectName: string | undefined;
}

export class GetProjectConfigurationForViewDto implements IGetProjectConfigurationForViewDto {
    projectConfiguration!: ProjectConfigurationDto;
    cloneBBX!: string | undefined;
    seedBBS!: string | undefined;
    projectName!: string | undefined;
    trialNames!: string | undefined;
    projectType!: string | undefined;
    projectDate!: string | undefined;
    trialNumbers!: string | undefined;

    constructor(data?: IGetProjectConfigurationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectConfiguration = _data["projectConfiguration"] ? ProjectConfigurationDto.fromJS(_data["projectConfiguration"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.seedBBS = _data["seedBBS"];
            this.projectName = _data["projectName"];
            this.trialNames = _data["trialNames"];
            this.projectType = _data["projectType"];
            this.projectDate = _data["projectDate"];
            this.trialNumbers = _data["trialNumbers"];
        }
    }

    static fromJS(data: any): GetProjectConfigurationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectConfigurationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectConfiguration"] = this.projectConfiguration ? this.projectConfiguration.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["seedBBS"] = this.seedBBS;
        data["projectName"] = this.projectName;
        data["trialNames"] = this.trialNames;
        data["projectType"] = this.projectType;
        data["projectDate"] = this.projectDate;
        data["trialNumbers"] = this.trialNumbers;
        return data;
    }
}

export interface IGetProjectConfigurationForViewDto {
    projectConfiguration: ProjectConfigurationDto;
    cloneBBX: string | undefined;
    seedBBS: string | undefined;
    projectName: string | undefined;
    trialNames: string | undefined;
    projectType: string | undefined;
    projectDate: string | undefined;
    trialNumbers: string | undefined;
}

export class GetProjectForEditOutput implements IGetProjectForEditOutput {
    project!: CreateOrEditProjectDto;
    laboratoryProjectName!: string | undefined;
    laboratoryProjectStatusName!: string | undefined;

    constructor(data?: IGetProjectForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? CreateOrEditProjectDto.fromJS(_data["project"]) : undefined as any;
            this.laboratoryProjectName = _data["laboratoryProjectName"];
            this.laboratoryProjectStatusName = _data["laboratoryProjectStatusName"];
        }
    }

    static fromJS(data: any): GetProjectForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["laboratoryProjectName"] = this.laboratoryProjectName;
        data["laboratoryProjectStatusName"] = this.laboratoryProjectStatusName;
        return data;
    }
}

export interface IGetProjectForEditOutput {
    project: CreateOrEditProjectDto;
    laboratoryProjectName: string | undefined;
    laboratoryProjectStatusName: string | undefined;
}

export class GetProjectForViewDto implements IGetProjectForViewDto {
    project!: ProjectDto;
    laboratoryProjectName!: string | undefined;
    laboratoryProjectStatusName!: string | undefined;

    constructor(data?: IGetProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined as any;
            this.laboratoryProjectName = _data["laboratoryProjectName"];
            this.laboratoryProjectStatusName = _data["laboratoryProjectStatusName"];
        }
    }

    static fromJS(data: any): GetProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["laboratoryProjectName"] = this.laboratoryProjectName;
        data["laboratoryProjectStatusName"] = this.laboratoryProjectStatusName;
        return data;
    }
}

export interface IGetProjectForViewDto {
    project: ProjectDto;
    laboratoryProjectName: string | undefined;
    laboratoryProjectStatusName: string | undefined;
}

export class GetPromedioLabBbxForViewDto implements IGetPromedioLabBbxForViewDto {
    promedioLabBbx!: PromedioLabBbxDto;
    cloneName!: string | undefined;
    typeMaterial!: string | undefined;
    projectName!: string | undefined;
    age!: number;
    trialStandName!: string | undefined;

    constructor(data?: IGetPromedioLabBbxForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promedioLabBbx = _data["promedioLabBbx"] ? PromedioLabBbxDto.fromJS(_data["promedioLabBbx"]) : undefined as any;
            this.cloneName = _data["cloneName"];
            this.typeMaterial = _data["typeMaterial"];
            this.projectName = _data["projectName"];
            this.age = _data["age"];
            this.trialStandName = _data["trialStandName"];
        }
    }

    static fromJS(data: any): GetPromedioLabBbxForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPromedioLabBbxForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promedioLabBbx"] = this.promedioLabBbx ? this.promedioLabBbx.toJSON() : undefined as any;
        data["cloneName"] = this.cloneName;
        data["typeMaterial"] = this.typeMaterial;
        data["projectName"] = this.projectName;
        data["age"] = this.age;
        data["trialStandName"] = this.trialStandName;
        return data;
    }
}

export interface IGetPromedioLabBbxForViewDto {
    promedioLabBbx: PromedioLabBbxDto;
    cloneName: string | undefined;
    typeMaterial: string | undefined;
    projectName: string | undefined;
    age: number;
    trialStandName: string | undefined;
}

export class GetQualityClassificationForEditOutput implements IGetQualityClassificationForEditOutput {
    qualityClassification!: CreateOrEditQualityClassificationDto;
    qualityClassificationTypeName!: string | undefined;

    constructor(data?: IGetQualityClassificationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassification = _data["qualityClassification"] ? CreateOrEditQualityClassificationDto.fromJS(_data["qualityClassification"]) : undefined as any;
            this.qualityClassificationTypeName = _data["qualityClassificationTypeName"];
        }
    }

    static fromJS(data: any): GetQualityClassificationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityClassificationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassification"] = this.qualityClassification ? this.qualityClassification.toJSON() : undefined as any;
        data["qualityClassificationTypeName"] = this.qualityClassificationTypeName;
        return data;
    }
}

export interface IGetQualityClassificationForEditOutput {
    qualityClassification: CreateOrEditQualityClassificationDto;
    qualityClassificationTypeName: string | undefined;
}

export class GetQualityClassificationForViewDto implements IGetQualityClassificationForViewDto {
    qualityClassification!: QualityClassificationDto;
    qualityClassificationTypeName!: string | undefined;

    constructor(data?: IGetQualityClassificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassification = _data["qualityClassification"] ? QualityClassificationDto.fromJS(_data["qualityClassification"]) : undefined as any;
            this.qualityClassificationTypeName = _data["qualityClassificationTypeName"];
        }
    }

    static fromJS(data: any): GetQualityClassificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityClassificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassification"] = this.qualityClassification ? this.qualityClassification.toJSON() : undefined as any;
        data["qualityClassificationTypeName"] = this.qualityClassificationTypeName;
        return data;
    }
}

export interface IGetQualityClassificationForViewDto {
    qualityClassification: QualityClassificationDto;
    qualityClassificationTypeName: string | undefined;
}

export class GetQualityClassificationTypeForEditOutput implements IGetQualityClassificationTypeForEditOutput {
    qualityClassificationType!: CreateOrEditQualityClassificationTypeDto;

    constructor(data?: IGetQualityClassificationTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassificationType = _data["qualityClassificationType"] ? CreateOrEditQualityClassificationTypeDto.fromJS(_data["qualityClassificationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetQualityClassificationTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityClassificationTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassificationType"] = this.qualityClassificationType ? this.qualityClassificationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetQualityClassificationTypeForEditOutput {
    qualityClassificationType: CreateOrEditQualityClassificationTypeDto;
}

export class GetQualityClassificationTypeForViewDto implements IGetQualityClassificationTypeForViewDto {
    qualityClassificationType!: QualityClassificationTypeDto;

    constructor(data?: IGetQualityClassificationTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassificationType = _data["qualityClassificationType"] ? QualityClassificationTypeDto.fromJS(_data["qualityClassificationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetQualityClassificationTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityClassificationTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassificationType"] = this.qualityClassificationType ? this.qualityClassificationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetQualityClassificationTypeForViewDto {
    qualityClassificationType: QualityClassificationTypeDto;
}

export class GetQualityControlForEditOutput implements IGetQualityControlForEditOutput {
    qualityControl!: CreateOrEditQualityControlDto;
    trialTrialNumber!: string | undefined;
    geneticMaterial!: string | undefined;
    qualityAppearanceClassificationName!: string | undefined;
    qualityPanClassificationName!: string | undefined;
    qualityResultClassificationName!: string | undefined;
    qualityAverageClassificationName!: string | undefined;
    qualityFieldObsClassificationName!: string | undefined;
    qualityFieldClassificationName!: string | undefined;
    qualityReplantingReasonClassificationName!: string | undefined;
    qualityReasonClassificationName!: string | undefined;
    qualityObservationClassificationName!: string | undefined;

    constructor(data?: IGetQualityControlForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityControl = _data["qualityControl"] ? CreateOrEditQualityControlDto.fromJS(_data["qualityControl"]) : undefined as any;
            this.trialTrialNumber = _data["trialTrialNumber"];
            this.geneticMaterial = _data["geneticMaterial"];
            this.qualityAppearanceClassificationName = _data["qualityAppearanceClassificationName"];
            this.qualityPanClassificationName = _data["qualityPanClassificationName"];
            this.qualityResultClassificationName = _data["qualityResultClassificationName"];
            this.qualityAverageClassificationName = _data["qualityAverageClassificationName"];
            this.qualityFieldObsClassificationName = _data["qualityFieldObsClassificationName"];
            this.qualityFieldClassificationName = _data["qualityFieldClassificationName"];
            this.qualityReplantingReasonClassificationName = _data["qualityReplantingReasonClassificationName"];
            this.qualityReasonClassificationName = _data["qualityReasonClassificationName"];
            this.qualityObservationClassificationName = _data["qualityObservationClassificationName"];
        }
    }

    static fromJS(data: any): GetQualityControlForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityControlForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityControl"] = this.qualityControl ? this.qualityControl.toJSON() : undefined as any;
        data["trialTrialNumber"] = this.trialTrialNumber;
        data["geneticMaterial"] = this.geneticMaterial;
        data["qualityAppearanceClassificationName"] = this.qualityAppearanceClassificationName;
        data["qualityPanClassificationName"] = this.qualityPanClassificationName;
        data["qualityResultClassificationName"] = this.qualityResultClassificationName;
        data["qualityAverageClassificationName"] = this.qualityAverageClassificationName;
        data["qualityFieldObsClassificationName"] = this.qualityFieldObsClassificationName;
        data["qualityFieldClassificationName"] = this.qualityFieldClassificationName;
        data["qualityReplantingReasonClassificationName"] = this.qualityReplantingReasonClassificationName;
        data["qualityReasonClassificationName"] = this.qualityReasonClassificationName;
        data["qualityObservationClassificationName"] = this.qualityObservationClassificationName;
        return data;
    }
}

export interface IGetQualityControlForEditOutput {
    qualityControl: CreateOrEditQualityControlDto;
    trialTrialNumber: string | undefined;
    geneticMaterial: string | undefined;
    qualityAppearanceClassificationName: string | undefined;
    qualityPanClassificationName: string | undefined;
    qualityResultClassificationName: string | undefined;
    qualityAverageClassificationName: string | undefined;
    qualityFieldObsClassificationName: string | undefined;
    qualityFieldClassificationName: string | undefined;
    qualityReplantingReasonClassificationName: string | undefined;
    qualityReasonClassificationName: string | undefined;
    qualityObservationClassificationName: string | undefined;
}

export class GetQualityControlForViewDto implements IGetQualityControlForViewDto {
    qualityControl!: QualityControlDto;
    trialTrialNumber!: string | undefined;
    geneticMaterial!: string | undefined;
    qualityAppearanceClassificationName!: string | undefined;
    qualityPanClassificationName!: string | undefined;
    qualityResultClassificationName!: string | undefined;
    qualityAverageClassificationName!: string | undefined;
    qualityFieldObsClassificationName!: string | undefined;
    qualityFieldClassificationName!: string | undefined;
    qualityReplantingReasonClassificationName!: string | undefined;
    qualityReasonClassificationName!: string | undefined;
    qualityObservationClassificationName!: string | undefined;

    constructor(data?: IGetQualityControlForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityControl = _data["qualityControl"] ? QualityControlDto.fromJS(_data["qualityControl"]) : undefined as any;
            this.trialTrialNumber = _data["trialTrialNumber"];
            this.geneticMaterial = _data["geneticMaterial"];
            this.qualityAppearanceClassificationName = _data["qualityAppearanceClassificationName"];
            this.qualityPanClassificationName = _data["qualityPanClassificationName"];
            this.qualityResultClassificationName = _data["qualityResultClassificationName"];
            this.qualityAverageClassificationName = _data["qualityAverageClassificationName"];
            this.qualityFieldObsClassificationName = _data["qualityFieldObsClassificationName"];
            this.qualityFieldClassificationName = _data["qualityFieldClassificationName"];
            this.qualityReplantingReasonClassificationName = _data["qualityReplantingReasonClassificationName"];
            this.qualityReasonClassificationName = _data["qualityReasonClassificationName"];
            this.qualityObservationClassificationName = _data["qualityObservationClassificationName"];
        }
    }

    static fromJS(data: any): GetQualityControlForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualityControlForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityControl"] = this.qualityControl ? this.qualityControl.toJSON() : undefined as any;
        data["trialTrialNumber"] = this.trialTrialNumber;
        data["geneticMaterial"] = this.geneticMaterial;
        data["qualityAppearanceClassificationName"] = this.qualityAppearanceClassificationName;
        data["qualityPanClassificationName"] = this.qualityPanClassificationName;
        data["qualityResultClassificationName"] = this.qualityResultClassificationName;
        data["qualityAverageClassificationName"] = this.qualityAverageClassificationName;
        data["qualityFieldObsClassificationName"] = this.qualityFieldObsClassificationName;
        data["qualityFieldClassificationName"] = this.qualityFieldClassificationName;
        data["qualityReplantingReasonClassificationName"] = this.qualityReplantingReasonClassificationName;
        data["qualityReasonClassificationName"] = this.qualityReasonClassificationName;
        data["qualityObservationClassificationName"] = this.qualityObservationClassificationName;
        return data;
    }
}

export interface IGetQualityControlForViewDto {
    qualityControl: QualityControlDto;
    trialTrialNumber: string | undefined;
    geneticMaterial: string | undefined;
    qualityAppearanceClassificationName: string | undefined;
    qualityPanClassificationName: string | undefined;
    qualityResultClassificationName: string | undefined;
    qualityAverageClassificationName: string | undefined;
    qualityFieldObsClassificationName: string | undefined;
    qualityFieldClassificationName: string | undefined;
    qualityReplantingReasonClassificationName: string | undefined;
    qualityReasonClassificationName: string | undefined;
    qualityObservationClassificationName: string | undefined;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : undefined as any;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : undefined as any;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetRoatingporcentajeTrayForEditOutput implements IGetRoatingporcentajeTrayForEditOutput {
    roatingporcentajeTray!: CreateOrEditRoatingporcentajeTrayDto;
    seedSpecies!: string | undefined;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    cloneBBX!: string | undefined;
    sourcePlantGroupNumber!: number | undefined;

    constructor(data?: IGetRoatingporcentajeTrayForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roatingporcentajeTray = _data["roatingporcentajeTray"] ? CreateOrEditRoatingporcentajeTrayDto.fromJS(_data["roatingporcentajeTray"]) : undefined as any;
            this.seedSpecies = _data["seedSpecies"];
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.cloneBBX = _data["cloneBBX"];
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
        }
    }

    static fromJS(data: any): GetRoatingporcentajeTrayForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoatingporcentajeTrayForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roatingporcentajeTray"] = this.roatingporcentajeTray ? this.roatingporcentajeTray.toJSON() : undefined as any;
        data["seedSpecies"] = this.seedSpecies;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["cloneBBX"] = this.cloneBBX;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        return data;
    }
}

export interface IGetRoatingporcentajeTrayForEditOutput {
    roatingporcentajeTray: CreateOrEditRoatingporcentajeTrayDto;
    seedSpecies: string | undefined;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    cloneBBX: string | undefined;
    sourcePlantGroupNumber: number | undefined;
}

export class GetRoatingporcentajeTrayForViewDto implements IGetRoatingporcentajeTrayForViewDto {
    roatingporcentajeTray!: RoatingporcentajeTrayDto;
    dateHarvest!: DateTime;
    seedSpecies!: string | undefined;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    cloneBBX!: string | undefined;
    sourcePlantGroupNumber!: string | undefined;

    constructor(data?: IGetRoatingporcentajeTrayForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roatingporcentajeTray = _data["roatingporcentajeTray"] ? RoatingporcentajeTrayDto.fromJS(_data["roatingporcentajeTray"]) : undefined as any;
            this.dateHarvest = _data["dateHarvest"] ? DateTime.fromISO(_data["dateHarvest"].toString()) : undefined as any;
            this.seedSpecies = _data["seedSpecies"];
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.cloneBBX = _data["cloneBBX"];
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
        }
    }

    static fromJS(data: any): GetRoatingporcentajeTrayForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoatingporcentajeTrayForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roatingporcentajeTray"] = this.roatingporcentajeTray ? this.roatingporcentajeTray.toJSON() : undefined as any;
        data["dateHarvest"] = this.dateHarvest ? this.dateHarvest.toString() : undefined as any;
        data["seedSpecies"] = this.seedSpecies;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["cloneBBX"] = this.cloneBBX;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        return data;
    }
}

export interface IGetRoatingporcentajeTrayForViewDto {
    roatingporcentajeTray: RoatingporcentajeTrayDto;
    dateHarvest: DateTime;
    seedSpecies: string | undefined;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    cloneBBX: string | undefined;
    sourcePlantGroupNumber: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
}

export class GetRootingPendingForViewDto implements IGetRootingPendingForViewDto {
    porcentajeBBX!: PorcentajeBBXDto;
    cloneBBX!: string | undefined;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    projectType!: string | undefined;
    specie!: string | undefined;
    percentage!: number | undefined;
    destination!: string | undefined;
    bbxId!: number | undefined;
    bbtId!: number | undefined;
    sourcePlantGroupNumber!: number | undefined;
    origin!: string | undefined;

    constructor(data?: IGetRootingPendingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porcentajeBBX = _data["porcentajeBBX"] ? PorcentajeBBXDto.fromJS(_data["porcentajeBBX"]) : undefined as any;
            this.cloneBBX = _data["cloneBBX"];
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.projectType = _data["projectType"];
            this.specie = _data["specie"];
            this.percentage = _data["percentage"];
            this.destination = _data["destination"];
            this.bbxId = _data["bbxId"];
            this.bbtId = _data["bbtId"];
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): GetRootingPendingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRootingPendingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porcentajeBBX"] = this.porcentajeBBX ? this.porcentajeBBX.toJSON() : undefined as any;
        data["cloneBBX"] = this.cloneBBX;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["projectType"] = this.projectType;
        data["specie"] = this.specie;
        data["percentage"] = this.percentage;
        data["destination"] = this.destination;
        data["bbxId"] = this.bbxId;
        data["bbtId"] = this.bbtId;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IGetRootingPendingForViewDto {
    porcentajeBBX: PorcentajeBBXDto;
    cloneBBX: string | undefined;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    projectType: string | undefined;
    specie: string | undefined;
    percentage: number | undefined;
    destination: string | undefined;
    bbxId: number | undefined;
    bbtId: number | undefined;
    sourcePlantGroupNumber: number | undefined;
    origin: string | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetSeedDestinationForEditOutput implements IGetSeedDestinationForEditOutput {
    seedDestination!: CreateOrEditSeedDestinationDto;

    constructor(data?: IGetSeedDestinationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedDestination = _data["seedDestination"] ? CreateOrEditSeedDestinationDto.fromJS(_data["seedDestination"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSeedDestinationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedDestinationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedDestination"] = this.seedDestination ? this.seedDestination.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSeedDestinationForEditOutput {
    seedDestination: CreateOrEditSeedDestinationDto;
}

export class GetSeedDestinationForViewDto implements IGetSeedDestinationForViewDto {
    seedDestination!: SeedDestinationDto;

    constructor(data?: IGetSeedDestinationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedDestination = _data["seedDestination"] ? SeedDestinationDto.fromJS(_data["seedDestination"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSeedDestinationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedDestinationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedDestination"] = this.seedDestination ? this.seedDestination.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSeedDestinationForViewDto {
    seedDestination: SeedDestinationDto;
}

export class GetSeedForEditOutput implements IGetSeedForEditOutput {
    seed!: CreateOrEditSeedDto;
    typeSpecieName!: string | undefined;
    speciesDisplayName!: string | undefined;
    categorySeedOriginName!: string | undefined;
    crossingTechniqueName!: string | undefined;
    trialStandName!: string | undefined;
    supplierName!: string | undefined;
    seedDestinationName!: string | undefined;
    farmName!: string | undefined;
    standName!: string | undefined;
    originalTreeMother!: string | undefined;
    originalTreeFather!: string | undefined;
    observation!: string | undefined;
    observationSpecie!: string | undefined;
    generation!: string | undefined;
    specie2Calculated!: string | undefined;

    constructor(data?: IGetSeedForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seed = _data["seed"] ? CreateOrEditSeedDto.fromJS(_data["seed"]) : undefined as any;
            this.typeSpecieName = _data["typeSpecieName"];
            this.speciesDisplayName = _data["speciesDisplayName"];
            this.categorySeedOriginName = _data["categorySeedOriginName"];
            this.crossingTechniqueName = _data["crossingTechniqueName"];
            this.trialStandName = _data["trialStandName"];
            this.supplierName = _data["supplierName"];
            this.seedDestinationName = _data["seedDestinationName"];
            this.farmName = _data["farmName"];
            this.standName = _data["standName"];
            this.originalTreeMother = _data["originalTreeMother"];
            this.originalTreeFather = _data["originalTreeFather"];
            this.observation = _data["observation"];
            this.observationSpecie = _data["observationSpecie"];
            this.generation = _data["generation"];
            this.specie2Calculated = _data["specie2Calculated"];
        }
    }

    static fromJS(data: any): GetSeedForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["typeSpecieName"] = this.typeSpecieName;
        data["speciesDisplayName"] = this.speciesDisplayName;
        data["categorySeedOriginName"] = this.categorySeedOriginName;
        data["crossingTechniqueName"] = this.crossingTechniqueName;
        data["trialStandName"] = this.trialStandName;
        data["supplierName"] = this.supplierName;
        data["seedDestinationName"] = this.seedDestinationName;
        data["farmName"] = this.farmName;
        data["standName"] = this.standName;
        data["originalTreeMother"] = this.originalTreeMother;
        data["originalTreeFather"] = this.originalTreeFather;
        data["observation"] = this.observation;
        data["observationSpecie"] = this.observationSpecie;
        data["generation"] = this.generation;
        data["specie2Calculated"] = this.specie2Calculated;
        return data;
    }
}

export interface IGetSeedForEditOutput {
    seed: CreateOrEditSeedDto;
    typeSpecieName: string | undefined;
    speciesDisplayName: string | undefined;
    categorySeedOriginName: string | undefined;
    crossingTechniqueName: string | undefined;
    trialStandName: string | undefined;
    supplierName: string | undefined;
    seedDestinationName: string | undefined;
    farmName: string | undefined;
    standName: string | undefined;
    originalTreeMother: string | undefined;
    originalTreeFather: string | undefined;
    observation: string | undefined;
    observationSpecie: string | undefined;
    generation: string | undefined;
    specie2Calculated: string | undefined;
}

export class GetSeedForViewDto implements IGetSeedForViewDto {
    seed!: SeedDto;
    typeSpecieName!: string | undefined;
    speciesDisplayName!: string | undefined;
    graSpeciesName!: string | undefined;
    clasificacionSpecie!: string | undefined;
    categorySeedOriginName!: string | undefined;
    crossingTechniqueName!: string | undefined;
    trialStandName!: string | undefined;
    farmName!: string | undefined;
    supplierName!: string | undefined;
    trialId!: number;
    seedDestinationName!: string | undefined;
    idTrialMothre!: number;
    bbxMother!: string | undefined;
    bbxidTreeMother!: string | undefined;
    bbxFather!: string | undefined;
    bbxidTreeFather!: string | undefined;
    siteOrigin!: string | undefined;
    trialNumber!: string | undefined;
    trialMotherNumber!: string | undefined;
    seedMixture!: string | undefined;

    constructor(data?: IGetSeedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seed = _data["seed"] ? SeedDto.fromJS(_data["seed"]) : undefined as any;
            this.typeSpecieName = _data["typeSpecieName"];
            this.speciesDisplayName = _data["speciesDisplayName"];
            this.graSpeciesName = _data["graSpeciesName"];
            this.clasificacionSpecie = _data["clasificacionSpecie"];
            this.categorySeedOriginName = _data["categorySeedOriginName"];
            this.crossingTechniqueName = _data["crossingTechniqueName"];
            this.trialStandName = _data["trialStandName"];
            this.farmName = _data["farmName"];
            this.supplierName = _data["supplierName"];
            this.trialId = _data["trialId"];
            this.seedDestinationName = _data["seedDestinationName"];
            this.idTrialMothre = _data["idTrialMothre"];
            this.bbxMother = _data["bbxMother"];
            this.bbxidTreeMother = _data["bbxidTreeMother"];
            this.bbxFather = _data["bbxFather"];
            this.bbxidTreeFather = _data["bbxidTreeFather"];
            this.siteOrigin = _data["siteOrigin"];
            this.trialNumber = _data["trialNumber"];
            this.trialMotherNumber = _data["trialMotherNumber"];
            this.seedMixture = _data["seedMixture"];
        }
    }

    static fromJS(data: any): GetSeedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["typeSpecieName"] = this.typeSpecieName;
        data["speciesDisplayName"] = this.speciesDisplayName;
        data["graSpeciesName"] = this.graSpeciesName;
        data["clasificacionSpecie"] = this.clasificacionSpecie;
        data["categorySeedOriginName"] = this.categorySeedOriginName;
        data["crossingTechniqueName"] = this.crossingTechniqueName;
        data["trialStandName"] = this.trialStandName;
        data["farmName"] = this.farmName;
        data["supplierName"] = this.supplierName;
        data["trialId"] = this.trialId;
        data["seedDestinationName"] = this.seedDestinationName;
        data["idTrialMothre"] = this.idTrialMothre;
        data["bbxMother"] = this.bbxMother;
        data["bbxidTreeMother"] = this.bbxidTreeMother;
        data["bbxFather"] = this.bbxFather;
        data["bbxidTreeFather"] = this.bbxidTreeFather;
        data["siteOrigin"] = this.siteOrigin;
        data["trialNumber"] = this.trialNumber;
        data["trialMotherNumber"] = this.trialMotherNumber;
        data["seedMixture"] = this.seedMixture;
        return data;
    }
}

export interface IGetSeedForViewDto {
    seed: SeedDto;
    typeSpecieName: string | undefined;
    speciesDisplayName: string | undefined;
    graSpeciesName: string | undefined;
    clasificacionSpecie: string | undefined;
    categorySeedOriginName: string | undefined;
    crossingTechniqueName: string | undefined;
    trialStandName: string | undefined;
    farmName: string | undefined;
    supplierName: string | undefined;
    trialId: number;
    seedDestinationName: string | undefined;
    idTrialMothre: number;
    bbxMother: string | undefined;
    bbxidTreeMother: string | undefined;
    bbxFather: string | undefined;
    bbxidTreeFather: string | undefined;
    siteOrigin: string | undefined;
    trialNumber: string | undefined;
    trialMotherNumber: string | undefined;
    seedMixture: string | undefined;
}

export class GetSeedMixtureForEditOutput implements IGetSeedMixtureForEditOutput {
    seedMixture!: CreateOrEditSeedMixtureDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedMixtureForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedMixture = _data["seedMixture"] ? CreateOrEditSeedMixtureDto.fromJS(_data["seedMixture"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedMixtureForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedMixtureForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedMixture"] = this.seedMixture ? this.seedMixture.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedMixtureForEditOutput {
    seedMixture: CreateOrEditSeedMixtureDto;
    seedBBS: string | undefined;
}

export class GetSeedMixtureForViewDto implements IGetSeedMixtureForViewDto {
    seedMixture!: SeedMixtureDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedMixtureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedMixture = _data["seedMixture"] ? SeedMixtureDto.fromJS(_data["seedMixture"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedMixtureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedMixtureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedMixture"] = this.seedMixture ? this.seedMixture.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedMixtureForViewDto {
    seedMixture: SeedMixtureDto;
    seedBBS: string | undefined;
}

export class GetSeedPedigreeForViewDto implements IGetSeedPedigreeForViewDto {
    seed!: SeedDto;
    fatherSeed!: SeedDto;
    motherSeed!: SeedDto;
    fatherGrandFatherSeed!: SeedDto;
    fatherGrandMotherSeed!: SeedDto;
    motherGrandFatherSeed!: SeedDto;
    motherGrandMotherSeed!: SeedDto;
    bbc!: string | undefined;

    constructor(data?: IGetSeedPedigreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seed = _data["seed"] ? SeedDto.fromJS(_data["seed"]) : undefined as any;
            this.fatherSeed = _data["fatherSeed"] ? SeedDto.fromJS(_data["fatherSeed"]) : undefined as any;
            this.motherSeed = _data["motherSeed"] ? SeedDto.fromJS(_data["motherSeed"]) : undefined as any;
            this.fatherGrandFatherSeed = _data["fatherGrandFatherSeed"] ? SeedDto.fromJS(_data["fatherGrandFatherSeed"]) : undefined as any;
            this.fatherGrandMotherSeed = _data["fatherGrandMotherSeed"] ? SeedDto.fromJS(_data["fatherGrandMotherSeed"]) : undefined as any;
            this.motherGrandFatherSeed = _data["motherGrandFatherSeed"] ? SeedDto.fromJS(_data["motherGrandFatherSeed"]) : undefined as any;
            this.motherGrandMotherSeed = _data["motherGrandMotherSeed"] ? SeedDto.fromJS(_data["motherGrandMotherSeed"]) : undefined as any;
            this.bbc = _data["bbc"];
        }
    }

    static fromJS(data: any): GetSeedPedigreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedPedigreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["fatherSeed"] = this.fatherSeed ? this.fatherSeed.toJSON() : undefined as any;
        data["motherSeed"] = this.motherSeed ? this.motherSeed.toJSON() : undefined as any;
        data["fatherGrandFatherSeed"] = this.fatherGrandFatherSeed ? this.fatherGrandFatherSeed.toJSON() : undefined as any;
        data["fatherGrandMotherSeed"] = this.fatherGrandMotherSeed ? this.fatherGrandMotherSeed.toJSON() : undefined as any;
        data["motherGrandFatherSeed"] = this.motherGrandFatherSeed ? this.motherGrandFatherSeed.toJSON() : undefined as any;
        data["motherGrandMotherSeed"] = this.motherGrandMotherSeed ? this.motherGrandMotherSeed.toJSON() : undefined as any;
        data["bbc"] = this.bbc;
        return data;
    }
}

export interface IGetSeedPedigreeForViewDto {
    seed: SeedDto;
    fatherSeed: SeedDto;
    motherSeed: SeedDto;
    fatherGrandFatherSeed: SeedDto;
    fatherGrandMotherSeed: SeedDto;
    motherGrandFatherSeed: SeedDto;
    motherGrandMotherSeed: SeedDto;
    bbc: string | undefined;
}

export class GetSeedStockForEditOutput implements IGetSeedStockForEditOutput {
    seedStock!: CreateOrEditSeedStockDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedStockForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedStock = _data["seedStock"] ? CreateOrEditSeedStockDto.fromJS(_data["seedStock"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedStockForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedStockForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedStock"] = this.seedStock ? this.seedStock.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedStockForEditOutput {
    seedStock: CreateOrEditSeedStockDto;
    seedBBS: string | undefined;
}

export class GetSeedStockForViewDto implements IGetSeedStockForViewDto {
    seedStock!: SeedStockDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedStockForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedStock = _data["seedStock"] ? SeedStockDto.fromJS(_data["seedStock"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedStockForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedStockForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedStock"] = this.seedStock ? this.seedStock.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedStockForViewDto {
    seedStock: SeedStockDto;
    seedBBS: string | undefined;
}

export class GetSeedStockMovementForEditOutput implements IGetSeedStockMovementForEditOutput {
    seedStockMovement!: CreateOrEditSeedStockMovementDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedStockMovementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedStockMovement = _data["seedStockMovement"] ? CreateOrEditSeedStockMovementDto.fromJS(_data["seedStockMovement"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedStockMovementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedStockMovementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedStockMovement"] = this.seedStockMovement ? this.seedStockMovement.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedStockMovementForEditOutput {
    seedStockMovement: CreateOrEditSeedStockMovementDto;
    seedBBS: string | undefined;
}

export class GetSeedStockMovementForViewDto implements IGetSeedStockMovementForViewDto {
    seedStockMovement!: SeedStockMovementDto;
    seedBBS!: string | undefined;

    constructor(data?: IGetSeedStockMovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedStockMovement = _data["seedStockMovement"] ? SeedStockMovementDto.fromJS(_data["seedStockMovement"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
        }
    }

    static fromJS(data: any): GetSeedStockMovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedStockMovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedStockMovement"] = this.seedStockMovement ? this.seedStockMovement.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        return data;
    }
}

export interface IGetSeedStockMovementForViewDto {
    seedStockMovement: SeedStockMovementDto;
    seedBBS: string | undefined;
}

export class GetSeedlingForEditOutput implements IGetSeedlingForEditOutput {
    seedling!: CreateOrEditSeedlingDto;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;

    constructor(data?: IGetSeedlingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedling = _data["seedling"] ? CreateOrEditSeedlingDto.fromJS(_data["seedling"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
        }
    }

    static fromJS(data: any): GetSeedlingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedlingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedling"] = this.seedling ? this.seedling.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        return data;
    }
}

export interface IGetSeedlingForEditOutput {
    seedling: CreateOrEditSeedlingDto;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
}

export class GetSeedlingForViewDto implements IGetSeedlingForViewDto {
    seedling!: SeedlingDto;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;

    constructor(data?: IGetSeedlingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedling = _data["seedling"] ? SeedlingDto.fromJS(_data["seedling"]) : undefined as any;
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
        }
    }

    static fromJS(data: any): GetSeedlingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeedlingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedling"] = this.seedling ? this.seedling.toJSON() : undefined as any;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        return data;
    }
}

export interface IGetSeedlingForViewDto {
    seedling: SeedlingDto;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
}

export class GetSilvicultureTreatmentNutritionalForEditOutput implements IGetSilvicultureTreatmentNutritionalForEditOutput {
    silvicultureTreatmentNutritional!: CreateOrEditSilvicultureTreatmentNutritionalDto;
    silvicultureTrialId!: string | undefined;
    treatmentObjective!: string | undefined;
    treatmentParcelType!: string | undefined;
    cloneBBX!: string | undefined;
    treatmentProductType!: string | undefined;
    treatmentProductName!: string | undefined;
    treatmentInterventionZone!: string | undefined;
    treatmentInterventionMoment!: string | undefined;
    treatmentInterventionObjective!: string | undefined;
    treatmentApply!: string | undefined;
    treatmentApply2!: string | undefined;
    treatmentApply3!: string | undefined;
    treatmentApply4!: string | undefined;
    treatmentApply5!: string | undefined;
    interventionFoundationsOne!: string | undefined;
    interventionFoundationsTwo!: string | undefined;
    interventionFoundationsThree!: string | undefined;
    treatmentDoseType!: string | undefined;

    constructor(data?: IGetSilvicultureTreatmentNutritionalForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.silvicultureTreatmentNutritional = _data["silvicultureTreatmentNutritional"] ? CreateOrEditSilvicultureTreatmentNutritionalDto.fromJS(_data["silvicultureTreatmentNutritional"]) : undefined as any;
            this.silvicultureTrialId = _data["silvicultureTrialId"];
            this.treatmentObjective = _data["treatmentObjective"];
            this.treatmentParcelType = _data["treatmentParcelType"];
            this.cloneBBX = _data["cloneBBX"];
            this.treatmentProductType = _data["treatmentProductType"];
            this.treatmentProductName = _data["treatmentProductName"];
            this.treatmentInterventionZone = _data["treatmentInterventionZone"];
            this.treatmentInterventionMoment = _data["treatmentInterventionMoment"];
            this.treatmentInterventionObjective = _data["treatmentInterventionObjective"];
            this.treatmentApply = _data["treatmentApply"];
            this.treatmentApply2 = _data["treatmentApply2"];
            this.treatmentApply3 = _data["treatmentApply3"];
            this.treatmentApply4 = _data["treatmentApply4"];
            this.treatmentApply5 = _data["treatmentApply5"];
            this.interventionFoundationsOne = _data["interventionFoundationsOne"];
            this.interventionFoundationsTwo = _data["interventionFoundationsTwo"];
            this.interventionFoundationsThree = _data["interventionFoundationsThree"];
            this.treatmentDoseType = _data["treatmentDoseType"];
        }
    }

    static fromJS(data: any): GetSilvicultureTreatmentNutritionalForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSilvicultureTreatmentNutritionalForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["silvicultureTreatmentNutritional"] = this.silvicultureTreatmentNutritional ? this.silvicultureTreatmentNutritional.toJSON() : undefined as any;
        data["silvicultureTrialId"] = this.silvicultureTrialId;
        data["treatmentObjective"] = this.treatmentObjective;
        data["treatmentParcelType"] = this.treatmentParcelType;
        data["cloneBBX"] = this.cloneBBX;
        data["treatmentProductType"] = this.treatmentProductType;
        data["treatmentProductName"] = this.treatmentProductName;
        data["treatmentInterventionZone"] = this.treatmentInterventionZone;
        data["treatmentInterventionMoment"] = this.treatmentInterventionMoment;
        data["treatmentInterventionObjective"] = this.treatmentInterventionObjective;
        data["treatmentApply"] = this.treatmentApply;
        data["treatmentApply2"] = this.treatmentApply2;
        data["treatmentApply3"] = this.treatmentApply3;
        data["treatmentApply4"] = this.treatmentApply4;
        data["treatmentApply5"] = this.treatmentApply5;
        data["interventionFoundationsOne"] = this.interventionFoundationsOne;
        data["interventionFoundationsTwo"] = this.interventionFoundationsTwo;
        data["interventionFoundationsThree"] = this.interventionFoundationsThree;
        data["treatmentDoseType"] = this.treatmentDoseType;
        return data;
    }
}

export interface IGetSilvicultureTreatmentNutritionalForEditOutput {
    silvicultureTreatmentNutritional: CreateOrEditSilvicultureTreatmentNutritionalDto;
    silvicultureTrialId: string | undefined;
    treatmentObjective: string | undefined;
    treatmentParcelType: string | undefined;
    cloneBBX: string | undefined;
    treatmentProductType: string | undefined;
    treatmentProductName: string | undefined;
    treatmentInterventionZone: string | undefined;
    treatmentInterventionMoment: string | undefined;
    treatmentInterventionObjective: string | undefined;
    treatmentApply: string | undefined;
    treatmentApply2: string | undefined;
    treatmentApply3: string | undefined;
    treatmentApply4: string | undefined;
    treatmentApply5: string | undefined;
    interventionFoundationsOne: string | undefined;
    interventionFoundationsTwo: string | undefined;
    interventionFoundationsThree: string | undefined;
    treatmentDoseType: string | undefined;
}

export class GetSilvicultureTreatmentNutritionalForViewDto implements IGetSilvicultureTreatmentNutritionalForViewDto {
    silvicultureTreatmentNutritional!: SilvicultureTreatmentNutritionalDto;
    silvicultureTrialId!: string | undefined;
    treatmentObjective!: string | undefined;
    treatmentParcelType!: string | undefined;
    cloneBBX!: string | undefined;
    treatmentProductType!: string | undefined;
    treatmentProductName!: string | undefined;
    treatmentInterventionZone!: string | undefined;
    treatmentInterventionMoment!: string | undefined;
    treatmentInterventionObjective!: string | undefined;
    treatmentApply!: string | undefined;
    treatmentApply2!: string | undefined;
    treatmentApply3!: string | undefined;
    treatmentApply4!: string | undefined;
    treatmentApply5!: string | undefined;
    interventionFoundationsOne!: string | undefined;
    interventionFoundationsTwo!: string | undefined;
    interventionFoundationsThree!: string | undefined;
    treatmentDoseType!: string | undefined;

    constructor(data?: IGetSilvicultureTreatmentNutritionalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.silvicultureTreatmentNutritional = _data["silvicultureTreatmentNutritional"] ? SilvicultureTreatmentNutritionalDto.fromJS(_data["silvicultureTreatmentNutritional"]) : undefined as any;
            this.silvicultureTrialId = _data["silvicultureTrialId"];
            this.treatmentObjective = _data["treatmentObjective"];
            this.treatmentParcelType = _data["treatmentParcelType"];
            this.cloneBBX = _data["cloneBBX"];
            this.treatmentProductType = _data["treatmentProductType"];
            this.treatmentProductName = _data["treatmentProductName"];
            this.treatmentInterventionZone = _data["treatmentInterventionZone"];
            this.treatmentInterventionMoment = _data["treatmentInterventionMoment"];
            this.treatmentInterventionObjective = _data["treatmentInterventionObjective"];
            this.treatmentApply = _data["treatmentApply"];
            this.treatmentApply2 = _data["treatmentApply2"];
            this.treatmentApply3 = _data["treatmentApply3"];
            this.treatmentApply4 = _data["treatmentApply4"];
            this.treatmentApply5 = _data["treatmentApply5"];
            this.interventionFoundationsOne = _data["interventionFoundationsOne"];
            this.interventionFoundationsTwo = _data["interventionFoundationsTwo"];
            this.interventionFoundationsThree = _data["interventionFoundationsThree"];
            this.treatmentDoseType = _data["treatmentDoseType"];
        }
    }

    static fromJS(data: any): GetSilvicultureTreatmentNutritionalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSilvicultureTreatmentNutritionalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["silvicultureTreatmentNutritional"] = this.silvicultureTreatmentNutritional ? this.silvicultureTreatmentNutritional.toJSON() : undefined as any;
        data["silvicultureTrialId"] = this.silvicultureTrialId;
        data["treatmentObjective"] = this.treatmentObjective;
        data["treatmentParcelType"] = this.treatmentParcelType;
        data["cloneBBX"] = this.cloneBBX;
        data["treatmentProductType"] = this.treatmentProductType;
        data["treatmentProductName"] = this.treatmentProductName;
        data["treatmentInterventionZone"] = this.treatmentInterventionZone;
        data["treatmentInterventionMoment"] = this.treatmentInterventionMoment;
        data["treatmentInterventionObjective"] = this.treatmentInterventionObjective;
        data["treatmentApply"] = this.treatmentApply;
        data["treatmentApply2"] = this.treatmentApply2;
        data["treatmentApply3"] = this.treatmentApply3;
        data["treatmentApply4"] = this.treatmentApply4;
        data["treatmentApply5"] = this.treatmentApply5;
        data["interventionFoundationsOne"] = this.interventionFoundationsOne;
        data["interventionFoundationsTwo"] = this.interventionFoundationsTwo;
        data["interventionFoundationsThree"] = this.interventionFoundationsThree;
        data["treatmentDoseType"] = this.treatmentDoseType;
        return data;
    }
}

export interface IGetSilvicultureTreatmentNutritionalForViewDto {
    silvicultureTreatmentNutritional: SilvicultureTreatmentNutritionalDto;
    silvicultureTrialId: string | undefined;
    treatmentObjective: string | undefined;
    treatmentParcelType: string | undefined;
    cloneBBX: string | undefined;
    treatmentProductType: string | undefined;
    treatmentProductName: string | undefined;
    treatmentInterventionZone: string | undefined;
    treatmentInterventionMoment: string | undefined;
    treatmentInterventionObjective: string | undefined;
    treatmentApply: string | undefined;
    treatmentApply2: string | undefined;
    treatmentApply3: string | undefined;
    treatmentApply4: string | undefined;
    treatmentApply5: string | undefined;
    interventionFoundationsOne: string | undefined;
    interventionFoundationsTwo: string | undefined;
    interventionFoundationsThree: string | undefined;
    treatmentDoseType: string | undefined;
}

export class GetSilvicultureTrialForEditOutput implements IGetSilvicultureTrialForEditOutput {
    silvicultureTrial!: CreateOrEditSilvicultureTrialDto;
    groupTrialName!: string | undefined;
    experimentTypeName!: string | undefined;
    experimentSpecieQuantityName!: string | undefined;
    experimentSpecieName!: string | undefined;
    cloneBBX!: string | undefined;
    experimentLocationName!: string | undefined;
    experimentCategoryName!: string | undefined;
    experimentClassificationName!: string | undefined;
    experimentClasificationtwoName!: string | undefined;
    trialDesignTypesName!: string | undefined;
    trialStatusName!: string | undefined;

    constructor(data?: IGetSilvicultureTrialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.silvicultureTrial = _data["silvicultureTrial"] ? CreateOrEditSilvicultureTrialDto.fromJS(_data["silvicultureTrial"]) : undefined as any;
            this.groupTrialName = _data["groupTrialName"];
            this.experimentTypeName = _data["experimentTypeName"];
            this.experimentSpecieQuantityName = _data["experimentSpecieQuantityName"];
            this.experimentSpecieName = _data["experimentSpecieName"];
            this.cloneBBX = _data["cloneBBX"];
            this.experimentLocationName = _data["experimentLocationName"];
            this.experimentCategoryName = _data["experimentCategoryName"];
            this.experimentClassificationName = _data["experimentClassificationName"];
            this.experimentClasificationtwoName = _data["experimentClasificationtwoName"];
            this.trialDesignTypesName = _data["trialDesignTypesName"];
            this.trialStatusName = _data["trialStatusName"];
        }
    }

    static fromJS(data: any): GetSilvicultureTrialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSilvicultureTrialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["silvicultureTrial"] = this.silvicultureTrial ? this.silvicultureTrial.toJSON() : undefined as any;
        data["groupTrialName"] = this.groupTrialName;
        data["experimentTypeName"] = this.experimentTypeName;
        data["experimentSpecieQuantityName"] = this.experimentSpecieQuantityName;
        data["experimentSpecieName"] = this.experimentSpecieName;
        data["cloneBBX"] = this.cloneBBX;
        data["experimentLocationName"] = this.experimentLocationName;
        data["experimentCategoryName"] = this.experimentCategoryName;
        data["experimentClassificationName"] = this.experimentClassificationName;
        data["experimentClasificationtwoName"] = this.experimentClasificationtwoName;
        data["trialDesignTypesName"] = this.trialDesignTypesName;
        data["trialStatusName"] = this.trialStatusName;
        return data;
    }
}

export interface IGetSilvicultureTrialForEditOutput {
    silvicultureTrial: CreateOrEditSilvicultureTrialDto;
    groupTrialName: string | undefined;
    experimentTypeName: string | undefined;
    experimentSpecieQuantityName: string | undefined;
    experimentSpecieName: string | undefined;
    cloneBBX: string | undefined;
    experimentLocationName: string | undefined;
    experimentCategoryName: string | undefined;
    experimentClassificationName: string | undefined;
    experimentClasificationtwoName: string | undefined;
    trialDesignTypesName: string | undefined;
    trialStatusName: string | undefined;
}

export class GetSilvicultureTrialForViewDto implements IGetSilvicultureTrialForViewDto {
    silvicultureTrial!: SilvicultureTrialDto;
    groupTrialName!: string | undefined;
    experimentTypeName!: string | undefined;
    experimentSpecieQuantityName!: string | undefined;
    experimentSpecieName!: string | undefined;
    stigma!: string | undefined;
    experimentLocationName!: string | undefined;
    experimentCategoryName!: string | undefined;
    experimentClassificationName!: string | undefined;
    experimentClasificationtwoName!: string | undefined;
    trialDesignTypesName!: string | undefined;
    trialStatusName!: string | undefined;

    constructor(data?: IGetSilvicultureTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.silvicultureTrial = _data["silvicultureTrial"] ? SilvicultureTrialDto.fromJS(_data["silvicultureTrial"]) : undefined as any;
            this.groupTrialName = _data["groupTrialName"];
            this.experimentTypeName = _data["experimentTypeName"];
            this.experimentSpecieQuantityName = _data["experimentSpecieQuantityName"];
            this.experimentSpecieName = _data["experimentSpecieName"];
            this.stigma = _data["stigma"];
            this.experimentLocationName = _data["experimentLocationName"];
            this.experimentCategoryName = _data["experimentCategoryName"];
            this.experimentClassificationName = _data["experimentClassificationName"];
            this.experimentClasificationtwoName = _data["experimentClasificationtwoName"];
            this.trialDesignTypesName = _data["trialDesignTypesName"];
            this.trialStatusName = _data["trialStatusName"];
        }
    }

    static fromJS(data: any): GetSilvicultureTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSilvicultureTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["silvicultureTrial"] = this.silvicultureTrial ? this.silvicultureTrial.toJSON() : undefined as any;
        data["groupTrialName"] = this.groupTrialName;
        data["experimentTypeName"] = this.experimentTypeName;
        data["experimentSpecieQuantityName"] = this.experimentSpecieQuantityName;
        data["experimentSpecieName"] = this.experimentSpecieName;
        data["stigma"] = this.stigma;
        data["experimentLocationName"] = this.experimentLocationName;
        data["experimentCategoryName"] = this.experimentCategoryName;
        data["experimentClassificationName"] = this.experimentClassificationName;
        data["experimentClasificationtwoName"] = this.experimentClasificationtwoName;
        data["trialDesignTypesName"] = this.trialDesignTypesName;
        data["trialStatusName"] = this.trialStatusName;
        return data;
    }
}

export interface IGetSilvicultureTrialForViewDto {
    silvicultureTrial: SilvicultureTrialDto;
    groupTrialName: string | undefined;
    experimentTypeName: string | undefined;
    experimentSpecieQuantityName: string | undefined;
    experimentSpecieName: string | undefined;
    stigma: string | undefined;
    experimentLocationName: string | undefined;
    experimentCategoryName: string | undefined;
    experimentClassificationName: string | undefined;
    experimentClasificationtwoName: string | undefined;
    trialDesignTypesName: string | undefined;
    trialStatusName: string | undefined;
}

export class GetSourcePlantForEditOutput implements IGetSourcePlantForEditOutput {
    sourcePlant!: CreateOrEditSourcePlantDto;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    cloneBBX!: string | undefined;
    sourcePlantGroupNumber!: number | undefined;
    species!: string | undefined;

    constructor(data?: IGetSourcePlantForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePlant = _data["sourcePlant"] ? CreateOrEditSourcePlantDto.fromJS(_data["sourcePlant"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.cloneBBX = _data["cloneBBX"];
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
            this.species = _data["species"];
        }
    }

    static fromJS(data: any): GetSourcePlantForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourcePlantForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePlant"] = this.sourcePlant ? this.sourcePlant.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["cloneBBX"] = this.cloneBBX;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        data["species"] = this.species;
        return data;
    }
}

export interface IGetSourcePlantForEditOutput {
    sourcePlant: CreateOrEditSourcePlantDto;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    cloneBBX: string | undefined;
    sourcePlantGroupNumber: number | undefined;
    species: string | undefined;
}

export class GetSourcePlantForViewDto implements IGetSourcePlantForViewDto {
    sourcePlant!: SourcePlantDto;
    projectName!: string | undefined;
    measurementSelectionNumberT!: string | undefined;
    cloneBBX!: string | undefined;
    sourcePlantGroupNumber!: number | undefined;
    species!: string | undefined;
    destinationsToShow!: string | undefined;
    discardDate!: DateTime | undefined;
    totalPlantation!: number;
    initialPlantation!: SourcePlantPlantationDto;

    constructor(data?: IGetSourcePlantForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePlant = _data["sourcePlant"] ? SourcePlantDto.fromJS(_data["sourcePlant"]) : undefined as any;
            this.projectName = _data["projectName"];
            this.measurementSelectionNumberT = _data["measurementSelectionNumberT"];
            this.cloneBBX = _data["cloneBBX"];
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
            this.species = _data["species"];
            this.destinationsToShow = _data["destinationsToShow"];
            this.discardDate = _data["discardDate"] ? DateTime.fromISO(_data["discardDate"].toString()) : undefined as any;
            this.totalPlantation = _data["totalPlantation"];
            this.initialPlantation = _data["initialPlantation"] ? SourcePlantPlantationDto.fromJS(_data["initialPlantation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSourcePlantForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourcePlantForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePlant"] = this.sourcePlant ? this.sourcePlant.toJSON() : undefined as any;
        data["projectName"] = this.projectName;
        data["measurementSelectionNumberT"] = this.measurementSelectionNumberT;
        data["cloneBBX"] = this.cloneBBX;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        data["species"] = this.species;
        data["destinationsToShow"] = this.destinationsToShow;
        data["discardDate"] = this.discardDate ? this.discardDate.toString() : undefined as any;
        data["totalPlantation"] = this.totalPlantation;
        data["initialPlantation"] = this.initialPlantation ? this.initialPlantation.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSourcePlantForViewDto {
    sourcePlant: SourcePlantDto;
    projectName: string | undefined;
    measurementSelectionNumberT: string | undefined;
    cloneBBX: string | undefined;
    sourcePlantGroupNumber: number | undefined;
    species: string | undefined;
    destinationsToShow: string | undefined;
    discardDate: DateTime | undefined;
    totalPlantation: number;
    initialPlantation: SourcePlantPlantationDto;
}

export class GetSourcePlantPlantationForEditOutput implements IGetSourcePlantPlantationForEditOutput {
    sourcePlantPlantation!: CreateOrEditSourcePlantPlantationDto;

    constructor(data?: IGetSourcePlantPlantationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePlantPlantation = _data["sourcePlantPlantation"] ? CreateOrEditSourcePlantPlantationDto.fromJS(_data["sourcePlantPlantation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSourcePlantPlantationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourcePlantPlantationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePlantPlantation"] = this.sourcePlantPlantation ? this.sourcePlantPlantation.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSourcePlantPlantationForEditOutput {
    sourcePlantPlantation: CreateOrEditSourcePlantPlantationDto;
}

export class GetSourcePlantPlantationForViewDto implements IGetSourcePlantPlantationForViewDto {
    sourcePlantPlantation!: SourcePlantPlantationDto;
    sourcePlantGroupNumber!: number;

    constructor(data?: IGetSourcePlantPlantationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePlantPlantation = _data["sourcePlantPlantation"] ? SourcePlantPlantationDto.fromJS(_data["sourcePlantPlantation"]) : undefined as any;
            this.sourcePlantGroupNumber = _data["sourcePlantGroupNumber"];
        }
    }

    static fromJS(data: any): GetSourcePlantPlantationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourcePlantPlantationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePlantPlantation"] = this.sourcePlantPlantation ? this.sourcePlantPlantation.toJSON() : undefined as any;
        data["sourcePlantGroupNumber"] = this.sourcePlantGroupNumber;
        return data;
    }
}

export interface IGetSourcePlantPlantationForViewDto {
    sourcePlantPlantation: SourcePlantPlantationDto;
    sourcePlantGroupNumber: number;
}

export class GetSpeciesGroupForEditOutput implements IGetSpeciesGroupForEditOutput {
    speciesGroup!: CreateOrEditSpeciesGroupDto;

    constructor(data?: IGetSpeciesGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speciesGroup = _data["speciesGroup"] ? CreateOrEditSpeciesGroupDto.fromJS(_data["speciesGroup"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSpeciesGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpeciesGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciesGroup"] = this.speciesGroup ? this.speciesGroup.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSpeciesGroupForEditOutput {
    speciesGroup: CreateOrEditSpeciesGroupDto;
}

export class GetSpeciesGroupForViewDto implements IGetSpeciesGroupForViewDto {
    speciesGroup!: SpeciesGroupDto;

    constructor(data?: IGetSpeciesGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speciesGroup = _data["speciesGroup"] ? SpeciesGroupDto.fromJS(_data["speciesGroup"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSpeciesGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpeciesGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciesGroup"] = this.speciesGroup ? this.speciesGroup.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSpeciesGroupForViewDto {
    speciesGroup: SpeciesGroupDto;
}

export class GetSupplierForEditOutput implements IGetSupplierForEditOutput {
    supplier!: CreateOrEditSupplierDto;

    constructor(data?: IGetSupplierForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] ? CreateOrEditSupplierDto.fromJS(_data["supplier"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSupplierForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSupplierForEditOutput {
    supplier: CreateOrEditSupplierDto;
}

export class GetSupplierForViewDto implements IGetSupplierForViewDto {
    supplier!: SupplierDto;

    constructor(data?: IGetSupplierForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] ? SupplierDto.fromJS(_data["supplier"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSupplierForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSupplierForViewDto {
    supplier: SupplierDto;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetTreatmentApplyForEditOutput implements IGetTreatmentApplyForEditOutput {
    treatmentApply!: CreateOrEditTreatmentApplyDto;

    constructor(data?: IGetTreatmentApplyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentApply = _data["treatmentApply"] ? CreateOrEditTreatmentApplyDto.fromJS(_data["treatmentApply"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentApplyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentApplyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentApply"] = this.treatmentApply ? this.treatmentApply.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentApplyForEditOutput {
    treatmentApply: CreateOrEditTreatmentApplyDto;
}

export class GetTreatmentApplyForViewDto implements IGetTreatmentApplyForViewDto {
    treatmentApply!: TreatmentApplyDto;

    constructor(data?: IGetTreatmentApplyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentApply = _data["treatmentApply"] ? TreatmentApplyDto.fromJS(_data["treatmentApply"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentApplyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentApplyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentApply"] = this.treatmentApply ? this.treatmentApply.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentApplyForViewDto {
    treatmentApply: TreatmentApplyDto;
}

export class GetTreatmentDoseTypeForEditOutput implements IGetTreatmentDoseTypeForEditOutput {
    treatmentDoseType!: CreateOrEditTreatmentDoseTypeDto;

    constructor(data?: IGetTreatmentDoseTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentDoseType = _data["treatmentDoseType"] ? CreateOrEditTreatmentDoseTypeDto.fromJS(_data["treatmentDoseType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentDoseTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentDoseTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentDoseType"] = this.treatmentDoseType ? this.treatmentDoseType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentDoseTypeForEditOutput {
    treatmentDoseType: CreateOrEditTreatmentDoseTypeDto;
}

export class GetTreatmentDoseTypeForViewDto implements IGetTreatmentDoseTypeForViewDto {
    treatmentDoseType!: TreatmentDoseTypeDto;

    constructor(data?: IGetTreatmentDoseTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentDoseType = _data["treatmentDoseType"] ? TreatmentDoseTypeDto.fromJS(_data["treatmentDoseType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentDoseTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentDoseTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentDoseType"] = this.treatmentDoseType ? this.treatmentDoseType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentDoseTypeForViewDto {
    treatmentDoseType: TreatmentDoseTypeDto;
}

export class GetTreatmentForEditOutput implements IGetTreatmentForEditOutput {
    treatment!: CreateOrEditTreatmentDto;
    trialStandName!: string | undefined;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;
    isAlfaLaticeAsterisk!: boolean;
    isClonalSeedOrchard!: boolean;
    originalTreeName!: string | undefined;

    constructor(data?: IGetTreatmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatment = _data["treatment"] ? CreateOrEditTreatmentDto.fromJS(_data["treatment"]) : undefined as any;
            this.trialStandName = _data["trialStandName"];
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.originalTreeName = _data["originalTreeName"];
        }
    }

    static fromJS(data: any): GetTreatmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment ? this.treatment.toJSON() : undefined as any;
        data["trialStandName"] = this.trialStandName;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["originalTreeName"] = this.originalTreeName;
        return data;
    }
}

export interface IGetTreatmentForEditOutput {
    treatment: CreateOrEditTreatmentDto;
    trialStandName: string | undefined;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
    isAlfaLaticeAsterisk: boolean;
    isClonalSeedOrchard: boolean;
    originalTreeName: string | undefined;
}

export class GetTreatmentForPWAViewDto implements IGetTreatmentForPWAViewDto {
    treatmentName!: string | undefined;
    measurementPlaningOptionId!: number;
    block!: number | undefined;
    subBlock!: number | undefined;
    id!: number;

    constructor(data?: IGetTreatmentForPWAViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentName = _data["treatmentName"];
            this.measurementPlaningOptionId = _data["measurementPlaningOptionId"];
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTreatmentForPWAViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentForPWAViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentName"] = this.treatmentName;
        data["measurementPlaningOptionId"] = this.measurementPlaningOptionId;
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetTreatmentForPWAViewDto {
    treatmentName: string | undefined;
    measurementPlaningOptionId: number;
    block: number | undefined;
    subBlock: number | undefined;
    id: number;
}

export class GetTreatmentForViewDto implements IGetTreatmentForViewDto {
    treatment!: TreatmentDto;
    trialStandName!: string | undefined;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;
    plantationDate!: DateTime | undefined;
    originalTreeName!: string | undefined;
    isAlfaLaticeAsterisk!: boolean;
    isClonalSeedOrchard!: boolean;
    tree!: TreeDto;
    seedlingId!: number | undefined;
    seedlingName!: string | undefined;

    constructor(data?: IGetTreatmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatment = _data["treatment"] ? TreatmentDto.fromJS(_data["treatment"]) : undefined as any;
            this.trialStandName = _data["trialStandName"];
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.originalTreeName = _data["originalTreeName"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.tree = _data["tree"] ? TreeDto.fromJS(_data["tree"]) : undefined as any;
            this.seedlingId = _data["seedlingId"];
            this.seedlingName = _data["seedlingName"];
        }
    }

    static fromJS(data: any): GetTreatmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment ? this.treatment.toJSON() : undefined as any;
        data["trialStandName"] = this.trialStandName;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["originalTreeName"] = this.originalTreeName;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["seedlingId"] = this.seedlingId;
        data["seedlingName"] = this.seedlingName;
        return data;
    }
}

export interface IGetTreatmentForViewDto {
    treatment: TreatmentDto;
    trialStandName: string | undefined;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
    plantationDate: DateTime | undefined;
    originalTreeName: string | undefined;
    isAlfaLaticeAsterisk: boolean;
    isClonalSeedOrchard: boolean;
    tree: TreeDto;
    seedlingId: number | undefined;
    seedlingName: string | undefined;
}

export class GetTreatmentInterventionForEditOutput implements IGetTreatmentInterventionForEditOutput {
    treatmentIntervention!: CreateOrEditTreatmentInterventionDto;

    constructor(data?: IGetTreatmentInterventionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentIntervention = _data["treatmentIntervention"] ? CreateOrEditTreatmentInterventionDto.fromJS(_data["treatmentIntervention"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentInterventionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentInterventionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentIntervention"] = this.treatmentIntervention ? this.treatmentIntervention.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentInterventionForEditOutput {
    treatmentIntervention: CreateOrEditTreatmentInterventionDto;
}

export class GetTreatmentInterventionForViewDto implements IGetTreatmentInterventionForViewDto {
    treatmentIntervention!: TreatmentInterventionDto;

    constructor(data?: IGetTreatmentInterventionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentIntervention = _data["treatmentIntervention"] ? TreatmentInterventionDto.fromJS(_data["treatmentIntervention"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentInterventionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentInterventionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentIntervention"] = this.treatmentIntervention ? this.treatmentIntervention.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentInterventionForViewDto {
    treatmentIntervention: TreatmentInterventionDto;
}

export class GetTreatmentObjectiveForEditOutput implements IGetTreatmentObjectiveForEditOutput {
    treatmentObjective!: CreateOrEditTreatmentObjectiveDto;

    constructor(data?: IGetTreatmentObjectiveForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentObjective = _data["treatmentObjective"] ? CreateOrEditTreatmentObjectiveDto.fromJS(_data["treatmentObjective"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentObjectiveForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentObjectiveForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentObjective"] = this.treatmentObjective ? this.treatmentObjective.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentObjectiveForEditOutput {
    treatmentObjective: CreateOrEditTreatmentObjectiveDto;
}

export class GetTreatmentObjectiveForViewDto implements IGetTreatmentObjectiveForViewDto {
    treatmentObjective!: TreatmentObjectiveDto;

    constructor(data?: IGetTreatmentObjectiveForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentObjective = _data["treatmentObjective"] ? TreatmentObjectiveDto.fromJS(_data["treatmentObjective"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentObjectiveForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentObjectiveForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentObjective"] = this.treatmentObjective ? this.treatmentObjective.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentObjectiveForViewDto {
    treatmentObjective: TreatmentObjectiveDto;
}

export class GetTreatmentParcelTypeForEditOutput implements IGetTreatmentParcelTypeForEditOutput {
    treatmentParcelType!: CreateOrEditTreatmentParcelTypeDto;

    constructor(data?: IGetTreatmentParcelTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentParcelType = _data["treatmentParcelType"] ? CreateOrEditTreatmentParcelTypeDto.fromJS(_data["treatmentParcelType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentParcelTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentParcelTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentParcelType"] = this.treatmentParcelType ? this.treatmentParcelType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentParcelTypeForEditOutput {
    treatmentParcelType: CreateOrEditTreatmentParcelTypeDto;
}

export class GetTreatmentParcelTypeForViewDto implements IGetTreatmentParcelTypeForViewDto {
    treatmentParcelType!: TreatmentParcelTypeDto;

    constructor(data?: IGetTreatmentParcelTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentParcelType = _data["treatmentParcelType"] ? TreatmentParcelTypeDto.fromJS(_data["treatmentParcelType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentParcelTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentParcelTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentParcelType"] = this.treatmentParcelType ? this.treatmentParcelType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentParcelTypeForViewDto {
    treatmentParcelType: TreatmentParcelTypeDto;
}

export class GetTreatmentProductForEditOutput implements IGetTreatmentProductForEditOutput {
    treatmentProduct!: CreateOrEditTreatmentProductDto;
    treatmentProductTypeProductType!: string | undefined;

    constructor(data?: IGetTreatmentProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProduct = _data["treatmentProduct"] ? CreateOrEditTreatmentProductDto.fromJS(_data["treatmentProduct"]) : undefined as any;
            this.treatmentProductTypeProductType = _data["treatmentProductTypeProductType"];
        }
    }

    static fromJS(data: any): GetTreatmentProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentProduct"] = this.treatmentProduct ? this.treatmentProduct.toJSON() : undefined as any;
        data["treatmentProductTypeProductType"] = this.treatmentProductTypeProductType;
        return data;
    }
}

export interface IGetTreatmentProductForEditOutput {
    treatmentProduct: CreateOrEditTreatmentProductDto;
    treatmentProductTypeProductType: string | undefined;
}

export class GetTreatmentProductForViewDto implements IGetTreatmentProductForViewDto {
    treatmentProduct!: TreatmentProductDto;
    treatmentProductTypeProductType!: string | undefined;

    constructor(data?: IGetTreatmentProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProduct = _data["treatmentProduct"] ? TreatmentProductDto.fromJS(_data["treatmentProduct"]) : undefined as any;
            this.treatmentProductTypeProductType = _data["treatmentProductTypeProductType"];
        }
    }

    static fromJS(data: any): GetTreatmentProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentProduct"] = this.treatmentProduct ? this.treatmentProduct.toJSON() : undefined as any;
        data["treatmentProductTypeProductType"] = this.treatmentProductTypeProductType;
        return data;
    }
}

export interface IGetTreatmentProductForViewDto {
    treatmentProduct: TreatmentProductDto;
    treatmentProductTypeProductType: string | undefined;
}

export class GetTreatmentProductTypeForEditOutput implements IGetTreatmentProductTypeForEditOutput {
    treatmentProductType!: CreateOrEditTreatmentProductTypeDto;

    constructor(data?: IGetTreatmentProductTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProductType = _data["treatmentProductType"] ? CreateOrEditTreatmentProductTypeDto.fromJS(_data["treatmentProductType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentProductTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentProductTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentProductType"] = this.treatmentProductType ? this.treatmentProductType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentProductTypeForEditOutput {
    treatmentProductType: CreateOrEditTreatmentProductTypeDto;
}

export class GetTreatmentProductTypeForViewDto implements IGetTreatmentProductTypeForViewDto {
    treatmentProductType!: TreatmentProductTypeDto;

    constructor(data?: IGetTreatmentProductTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentProductType = _data["treatmentProductType"] ? TreatmentProductTypeDto.fromJS(_data["treatmentProductType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreatmentProductTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreatmentProductTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentProductType"] = this.treatmentProductType ? this.treatmentProductType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreatmentProductTypeForViewDto {
    treatmentProductType: TreatmentProductTypeDto;
}

export class GetTreeForEditOutput implements IGetTreeForEditOutput {
    tree!: CreateOrEditTreeDto;
    treatmentSubBlock!: string | undefined;

    constructor(data?: IGetTreeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tree = _data["tree"] ? CreateOrEditTreeDto.fromJS(_data["tree"]) : undefined as any;
            this.treatmentSubBlock = _data["treatmentSubBlock"];
        }
    }

    static fromJS(data: any): GetTreeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["treatmentSubBlock"] = this.treatmentSubBlock;
        return data;
    }
}

export interface IGetTreeForEditOutput {
    tree: CreateOrEditTreeDto;
    treatmentSubBlock: string | undefined;
}

export class GetTreeForViewDto implements IGetTreeForViewDto {
    tree!: TreeDto;
    treatmentSubBlock!: string | undefined;

    constructor(data?: IGetTreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tree = _data["tree"] ? TreeDto.fromJS(_data["tree"]) : undefined as any;
            this.treatmentSubBlock = _data["treatmentSubBlock"];
        }
    }

    static fromJS(data: any): GetTreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["treatmentSubBlock"] = this.treatmentSubBlock;
        return data;
    }
}

export interface IGetTreeForViewDto {
    tree: TreeDto;
    treatmentSubBlock: string | undefined;
}

export class GetTreeManagementForEditOutput implements IGetTreeManagementForEditOutput {
    treeManagement!: CreateOrEditTreeManagementDto;
    treeNS!: string | undefined;

    constructor(data?: IGetTreeManagementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeManagement = _data["treeManagement"] ? CreateOrEditTreeManagementDto.fromJS(_data["treeManagement"]) : undefined as any;
            this.treeNS = _data["treeNS"];
        }
    }

    static fromJS(data: any): GetTreeManagementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeManagementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeManagement"] = this.treeManagement ? this.treeManagement.toJSON() : undefined as any;
        data["treeNS"] = this.treeNS;
        return data;
    }
}

export interface IGetTreeManagementForEditOutput {
    treeManagement: CreateOrEditTreeManagementDto;
    treeNS: string | undefined;
}

export class GetTreeManagementForViewDto implements IGetTreeManagementForViewDto {
    treeManagement!: TreeManagementDto;
    treecurrent!: string | undefined;
    treatament!: string | undefined;
    trial!: number;
    treeStatus!: string | undefined;

    constructor(data?: IGetTreeManagementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeManagement = _data["treeManagement"] ? TreeManagementDto.fromJS(_data["treeManagement"]) : undefined as any;
            this.treecurrent = _data["treecurrent"];
            this.treatament = _data["treatament"];
            this.trial = _data["trial"];
            this.treeStatus = _data["treeStatus"];
        }
    }

    static fromJS(data: any): GetTreeManagementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeManagementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeManagement"] = this.treeManagement ? this.treeManagement.toJSON() : undefined as any;
        data["treecurrent"] = this.treecurrent;
        data["treatament"] = this.treatament;
        data["trial"] = this.trial;
        data["treeStatus"] = this.treeStatus;
        return data;
    }
}

export interface IGetTreeManagementForViewDto {
    treeManagement: TreeManagementDto;
    treecurrent: string | undefined;
    treatament: string | undefined;
    trial: number;
    treeStatus: string | undefined;
}

export class GetTreeMeasurementAlertForEditOutput implements IGetTreeMeasurementAlertForEditOutput {
    treeMeasurementAlert!: CreateOrEditTreeMeasurementAlertDto;

    constructor(data?: IGetTreeMeasurementAlertForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeMeasurementAlert = _data["treeMeasurementAlert"] ? CreateOrEditTreeMeasurementAlertDto.fromJS(_data["treeMeasurementAlert"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreeMeasurementAlertForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeMeasurementAlertForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeMeasurementAlert"] = this.treeMeasurementAlert ? this.treeMeasurementAlert.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreeMeasurementAlertForEditOutput {
    treeMeasurementAlert: CreateOrEditTreeMeasurementAlertDto;
}

export class GetTreeMeasurementAlertForViewDto implements IGetTreeMeasurementAlertForViewDto {
    treeMeasurementAlert!: TreeMeasurementAlertDto;
    adultObservationCodeDetail!: string | undefined;
    measurementPlanningOptionsName!: string | undefined;
    measurementPlanningOptionsAssignmentName!: string | undefined;

    constructor(data?: IGetTreeMeasurementAlertForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeMeasurementAlert = _data["treeMeasurementAlert"] ? TreeMeasurementAlertDto.fromJS(_data["treeMeasurementAlert"]) : undefined as any;
            this.adultObservationCodeDetail = _data["adultObservationCodeDetail"];
            this.measurementPlanningOptionsName = _data["measurementPlanningOptionsName"];
            this.measurementPlanningOptionsAssignmentName = _data["measurementPlanningOptionsAssignmentName"];
        }
    }

    static fromJS(data: any): GetTreeMeasurementAlertForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeMeasurementAlertForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeMeasurementAlert"] = this.treeMeasurementAlert ? this.treeMeasurementAlert.toJSON() : undefined as any;
        data["adultObservationCodeDetail"] = this.adultObservationCodeDetail;
        data["measurementPlanningOptionsName"] = this.measurementPlanningOptionsName;
        data["measurementPlanningOptionsAssignmentName"] = this.measurementPlanningOptionsAssignmentName;
        return data;
    }
}

export interface IGetTreeMeasurementAlertForViewDto {
    treeMeasurementAlert: TreeMeasurementAlertDto;
    adultObservationCodeDetail: string | undefined;
    measurementPlanningOptionsName: string | undefined;
    measurementPlanningOptionsAssignmentName: string | undefined;
}

export class GetTreeMeasurementForEditOutput implements IGetTreeMeasurementForEditOutput {
    treeMeasurement!: CreateOrEditTreeMeasurementDto;
    treeSpecie!: string | undefined;
    adultObservationCodeDetail!: string | undefined;
    frostToleranceCode!: string | undefined;
    pestAndDiseaseCode!: string | undefined;
    treeName!: string | undefined;
    trailNumber!: number;
    trialId!: number;
    treatment!: string | undefined;
    dataBBS!: string | undefined;
    dataBBX!: string | undefined;
    dataTrialStandName!: string | undefined;
    dataSpecie!: string | undefined;
    dataBlock!: number | undefined;
    dataSubBlock!: number | undefined;
    dataY!: number | undefined;
    dataTreeNumber!: number;
    plantationDate!: DateTime;
    dataNS!: string | undefined;
    dataNX!: string | undefined;
    dataPlot!: number | undefined;
    dataNameTreatment!: string | undefined;

    constructor(data?: IGetTreeMeasurementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeMeasurement = _data["treeMeasurement"] ? CreateOrEditTreeMeasurementDto.fromJS(_data["treeMeasurement"]) : undefined as any;
            this.treeSpecie = _data["treeSpecie"];
            this.adultObservationCodeDetail = _data["adultObservationCodeDetail"];
            this.frostToleranceCode = _data["frostToleranceCode"];
            this.pestAndDiseaseCode = _data["pestAndDiseaseCode"];
            this.treeName = _data["treeName"];
            this.trailNumber = _data["trailNumber"];
            this.trialId = _data["trialId"];
            this.treatment = _data["treatment"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBX = _data["dataBBX"];
            this.dataTrialStandName = _data["dataTrialStandName"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBlock = _data["dataBlock"];
            this.dataSubBlock = _data["dataSubBlock"];
            this.dataY = _data["dataY"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.dataNS = _data["dataNS"];
            this.dataNX = _data["dataNX"];
            this.dataPlot = _data["dataPlot"];
            this.dataNameTreatment = _data["dataNameTreatment"];
        }
    }

    static fromJS(data: any): GetTreeMeasurementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeMeasurementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeMeasurement"] = this.treeMeasurement ? this.treeMeasurement.toJSON() : undefined as any;
        data["treeSpecie"] = this.treeSpecie;
        data["adultObservationCodeDetail"] = this.adultObservationCodeDetail;
        data["frostToleranceCode"] = this.frostToleranceCode;
        data["pestAndDiseaseCode"] = this.pestAndDiseaseCode;
        data["treeName"] = this.treeName;
        data["trailNumber"] = this.trailNumber;
        data["trialId"] = this.trialId;
        data["treatment"] = this.treatment;
        data["dataBBS"] = this.dataBBS;
        data["dataBBX"] = this.dataBBX;
        data["dataTrialStandName"] = this.dataTrialStandName;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBlock"] = this.dataBlock;
        data["dataSubBlock"] = this.dataSubBlock;
        data["dataY"] = this.dataY;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["dataNS"] = this.dataNS;
        data["dataNX"] = this.dataNX;
        data["dataPlot"] = this.dataPlot;
        data["dataNameTreatment"] = this.dataNameTreatment;
        return data;
    }
}

export interface IGetTreeMeasurementForEditOutput {
    treeMeasurement: CreateOrEditTreeMeasurementDto;
    treeSpecie: string | undefined;
    adultObservationCodeDetail: string | undefined;
    frostToleranceCode: string | undefined;
    pestAndDiseaseCode: string | undefined;
    treeName: string | undefined;
    trailNumber: number;
    trialId: number;
    treatment: string | undefined;
    dataBBS: string | undefined;
    dataBBX: string | undefined;
    dataTrialStandName: string | undefined;
    dataSpecie: string | undefined;
    dataBlock: number | undefined;
    dataSubBlock: number | undefined;
    dataY: number | undefined;
    dataTreeNumber: number;
    plantationDate: DateTime;
    dataNS: string | undefined;
    dataNX: string | undefined;
    dataPlot: number | undefined;
    dataNameTreatment: string | undefined;
}

export class GetTreeMeasurementForViewDto implements IGetTreeMeasurementForViewDto {
    treeMeasurement!: TreeMeasurementDto;
    treeSpecie!: string | undefined;
    adultObservationCodeDetail!: string | undefined;
    frostToleranceCode!: string | undefined;
    pestAndDiseaseCode!: string | undefined;
    tree!: GetTreeForViewDto;
    treatment!: GetTreatmentForViewDto;
    typeTrialDto!: TypeTrialDto;
    groupTrialDto!: GroupTrialDto;
    trialAge!: number;
    trailNumber!: number;
    dataBBS!: string | undefined;
    dataBBX!: string | undefined;
    dataSpecie!: string | undefined;
    dataBlock!: number | undefined;
    dataY!: number | undefined;
    dataSubBlock!: number | undefined;
    dataTreeNumber!: number;
    plantationDate!: DateTime;
    dataNS!: string | undefined;
    dataTrialStandName!: string | undefined;
    dataNX!: string | undefined;
    treeName!: string | undefined;
    dataPlot!: number | undefined;
    dataNameTreatment!: string | undefined;

    constructor(data?: IGetTreeMeasurementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeMeasurement = _data["treeMeasurement"] ? TreeMeasurementDto.fromJS(_data["treeMeasurement"]) : undefined as any;
            this.treeSpecie = _data["treeSpecie"];
            this.adultObservationCodeDetail = _data["adultObservationCodeDetail"];
            this.frostToleranceCode = _data["frostToleranceCode"];
            this.pestAndDiseaseCode = _data["pestAndDiseaseCode"];
            this.tree = _data["tree"] ? GetTreeForViewDto.fromJS(_data["tree"]) : undefined as any;
            this.treatment = _data["treatment"] ? GetTreatmentForViewDto.fromJS(_data["treatment"]) : undefined as any;
            this.typeTrialDto = _data["typeTrialDto"] ? TypeTrialDto.fromJS(_data["typeTrialDto"]) : undefined as any;
            this.groupTrialDto = _data["groupTrialDto"] ? GroupTrialDto.fromJS(_data["groupTrialDto"]) : undefined as any;
            this.trialAge = _data["trialAge"];
            this.trailNumber = _data["trailNumber"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBX = _data["dataBBX"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBlock = _data["dataBlock"];
            this.dataY = _data["dataY"];
            this.dataSubBlock = _data["dataSubBlock"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.dataNS = _data["dataNS"];
            this.dataTrialStandName = _data["dataTrialStandName"];
            this.dataNX = _data["dataNX"];
            this.treeName = _data["treeName"];
            this.dataPlot = _data["dataPlot"];
            this.dataNameTreatment = _data["dataNameTreatment"];
        }
    }

    static fromJS(data: any): GetTreeMeasurementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeMeasurementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeMeasurement"] = this.treeMeasurement ? this.treeMeasurement.toJSON() : undefined as any;
        data["treeSpecie"] = this.treeSpecie;
        data["adultObservationCodeDetail"] = this.adultObservationCodeDetail;
        data["frostToleranceCode"] = this.frostToleranceCode;
        data["pestAndDiseaseCode"] = this.pestAndDiseaseCode;
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["treatment"] = this.treatment ? this.treatment.toJSON() : undefined as any;
        data["typeTrialDto"] = this.typeTrialDto ? this.typeTrialDto.toJSON() : undefined as any;
        data["groupTrialDto"] = this.groupTrialDto ? this.groupTrialDto.toJSON() : undefined as any;
        data["trialAge"] = this.trialAge;
        data["trailNumber"] = this.trailNumber;
        data["dataBBS"] = this.dataBBS;
        data["dataBBX"] = this.dataBBX;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBlock"] = this.dataBlock;
        data["dataY"] = this.dataY;
        data["dataSubBlock"] = this.dataSubBlock;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["dataNS"] = this.dataNS;
        data["dataTrialStandName"] = this.dataTrialStandName;
        data["dataNX"] = this.dataNX;
        data["treeName"] = this.treeName;
        data["dataPlot"] = this.dataPlot;
        data["dataNameTreatment"] = this.dataNameTreatment;
        return data;
    }
}

export interface IGetTreeMeasurementForViewDto {
    treeMeasurement: TreeMeasurementDto;
    treeSpecie: string | undefined;
    adultObservationCodeDetail: string | undefined;
    frostToleranceCode: string | undefined;
    pestAndDiseaseCode: string | undefined;
    tree: GetTreeForViewDto;
    treatment: GetTreatmentForViewDto;
    typeTrialDto: TypeTrialDto;
    groupTrialDto: GroupTrialDto;
    trialAge: number;
    trailNumber: number;
    dataBBS: string | undefined;
    dataBBX: string | undefined;
    dataSpecie: string | undefined;
    dataBlock: number | undefined;
    dataY: number | undefined;
    dataSubBlock: number | undefined;
    dataTreeNumber: number;
    plantationDate: DateTime;
    dataNS: string | undefined;
    dataTrialStandName: string | undefined;
    dataNX: string | undefined;
    treeName: string | undefined;
    dataPlot: number | undefined;
    dataNameTreatment: string | undefined;
}

export class GetTreeStatusForEditOutput implements IGetTreeStatusForEditOutput {
    treeStatus!: CreateOrEditTreeStatusDto;

    constructor(data?: IGetTreeStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeStatus = _data["treeStatus"] ? CreateOrEditTreeStatusDto.fromJS(_data["treeStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreeStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeStatus"] = this.treeStatus ? this.treeStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreeStatusForEditOutput {
    treeStatus: CreateOrEditTreeStatusDto;
}

export class GetTreeStatusForViewDto implements IGetTreeStatusForViewDto {
    treeStatus!: TreeStatusDto;

    constructor(data?: IGetTreeStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeStatus = _data["treeStatus"] ? TreeStatusDto.fromJS(_data["treeStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTreeStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeStatus"] = this.treeStatus ? this.treeStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTreeStatusForViewDto {
    treeStatus: TreeStatusDto;
}

export class GetTreeTreatmentForEditOutput implements IGetTreeTreatmentForEditOutput {
    treatment!: CreateOrEditTreatmentDto;
    tree!: CreateOrEditTreeDto;
    trialStandName!: string | undefined;
    seedBBS!: string | undefined;
    cloneBBX!: string | undefined;
    isAlfaLaticeAsterisk!: boolean;
    isClonalSeedOrchard!: boolean;
    originalTreeName!: string | undefined;

    constructor(data?: IGetTreeTreatmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatment = _data["treatment"] ? CreateOrEditTreatmentDto.fromJS(_data["treatment"]) : undefined as any;
            this.tree = _data["tree"] ? CreateOrEditTreeDto.fromJS(_data["tree"]) : undefined as any;
            this.trialStandName = _data["trialStandName"];
            this.seedBBS = _data["seedBBS"];
            this.cloneBBX = _data["cloneBBX"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.originalTreeName = _data["originalTreeName"];
        }
    }

    static fromJS(data: any): GetTreeTreatmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeTreatmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment ? this.treatment.toJSON() : undefined as any;
        data["tree"] = this.tree ? this.tree.toJSON() : undefined as any;
        data["trialStandName"] = this.trialStandName;
        data["seedBBS"] = this.seedBBS;
        data["cloneBBX"] = this.cloneBBX;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["originalTreeName"] = this.originalTreeName;
        return data;
    }
}

export interface IGetTreeTreatmentForEditOutput {
    treatment: CreateOrEditTreatmentDto;
    tree: CreateOrEditTreeDto;
    trialStandName: string | undefined;
    seedBBS: string | undefined;
    cloneBBX: string | undefined;
    isAlfaLaticeAsterisk: boolean;
    isClonalSeedOrchard: boolean;
    originalTreeName: string | undefined;
}

export class GetTrialDesignTypesForEditOutput implements IGetTrialDesignTypesForEditOutput {
    trialDesignTypes!: CreateOrEditTrialDesignTypesDto;

    constructor(data?: IGetTrialDesignTypesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialDesignTypes = _data["trialDesignTypes"] ? CreateOrEditTrialDesignTypesDto.fromJS(_data["trialDesignTypes"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTrialDesignTypesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialDesignTypesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialDesignTypes"] = this.trialDesignTypes ? this.trialDesignTypes.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTrialDesignTypesForEditOutput {
    trialDesignTypes: CreateOrEditTrialDesignTypesDto;
}

export class GetTrialDesignTypesForViewDto implements IGetTrialDesignTypesForViewDto {
    trialDesignTypes!: TrialDesignTypesDto;

    constructor(data?: IGetTrialDesignTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialDesignTypes = _data["trialDesignTypes"] ? TrialDesignTypesDto.fromJS(_data["trialDesignTypes"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTrialDesignTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialDesignTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialDesignTypes"] = this.trialDesignTypes ? this.trialDesignTypes.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTrialDesignTypesForViewDto {
    trialDesignTypes: TrialDesignTypesDto;
}

export class GetTrialForEditOutput implements IGetTrialForEditOutput {
    trial!: CreateOrEditTrialDto;
    typeTrialName!: string | undefined;
    trialDesignTypesName!: string | undefined;
    trialStatusName!: string | undefined;
    groupTrialName!: string | undefined;

    constructor(data?: IGetTrialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trial = _data["trial"] ? CreateOrEditTrialDto.fromJS(_data["trial"]) : undefined as any;
            this.typeTrialName = _data["typeTrialName"];
            this.trialDesignTypesName = _data["trialDesignTypesName"];
            this.trialStatusName = _data["trialStatusName"];
            this.groupTrialName = _data["groupTrialName"];
        }
    }

    static fromJS(data: any): GetTrialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trial"] = this.trial ? this.trial.toJSON() : undefined as any;
        data["typeTrialName"] = this.typeTrialName;
        data["trialDesignTypesName"] = this.trialDesignTypesName;
        data["trialStatusName"] = this.trialStatusName;
        data["groupTrialName"] = this.groupTrialName;
        return data;
    }
}

export interface IGetTrialForEditOutput {
    trial: CreateOrEditTrialDto;
    typeTrialName: string | undefined;
    trialDesignTypesName: string | undefined;
    trialStatusName: string | undefined;
    groupTrialName: string | undefined;
}

export class GetTrialForViewDto implements IGetTrialForViewDto {
    trial!: TrialDto;
    typeTrialName!: string | undefined;
    trialDesignTypesName!: string | undefined;
    trialStatusName!: string | undefined;
    groupTrialName!: string | undefined;
    age!: number;
    newObservation!: string | undefined;

    constructor(data?: IGetTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trial = _data["trial"] ? TrialDto.fromJS(_data["trial"]) : undefined as any;
            this.typeTrialName = _data["typeTrialName"];
            this.trialDesignTypesName = _data["trialDesignTypesName"];
            this.trialStatusName = _data["trialStatusName"];
            this.groupTrialName = _data["groupTrialName"];
            this.age = _data["age"];
            this.newObservation = _data["newObservation"];
        }
    }

    static fromJS(data: any): GetTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trial"] = this.trial ? this.trial.toJSON() : undefined as any;
        data["typeTrialName"] = this.typeTrialName;
        data["trialDesignTypesName"] = this.trialDesignTypesName;
        data["trialStatusName"] = this.trialStatusName;
        data["groupTrialName"] = this.groupTrialName;
        data["age"] = this.age;
        data["newObservation"] = this.newObservation;
        return data;
    }
}

export interface IGetTrialForViewDto {
    trial: TrialDto;
    typeTrialName: string | undefined;
    trialDesignTypesName: string | undefined;
    trialStatusName: string | undefined;
    groupTrialName: string | undefined;
    age: number;
    newObservation: string | undefined;
}

export class GetTrialRDForViewDto implements IGetTrialRDForViewDto {
    trialRD!: TrialRDDto;

    constructor(data?: IGetTrialRDForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialRD = _data["trialRD"] ? TrialRDDto.fromJS(_data["trialRD"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTrialRDForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialRDForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialRD"] = this.trialRD ? this.trialRD.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTrialRDForViewDto {
    trialRD: TrialRDDto;
}

export class GetTrialStatusForEditOutput implements IGetTrialStatusForEditOutput {
    trialStatus!: CreateOrEditTrialStatusDto;

    constructor(data?: IGetTrialStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialStatus = _data["trialStatus"] ? CreateOrEditTrialStatusDto.fromJS(_data["trialStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTrialStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialStatus"] = this.trialStatus ? this.trialStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTrialStatusForEditOutput {
    trialStatus: CreateOrEditTrialStatusDto;
}

export class GetTrialStatusForViewDto implements IGetTrialStatusForViewDto {
    trialStatus!: TrialStatusDto;

    constructor(data?: IGetTrialStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialStatus = _data["trialStatus"] ? TrialStatusDto.fromJS(_data["trialStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTrialStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrialStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialStatus"] = this.trialStatus ? this.trialStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTrialStatusForViewDto {
    trialStatus: TrialStatusDto;
}

export class GetTypeGeneticMaterialForEditOutput implements IGetTypeGeneticMaterialForEditOutput {
    typeGeneticMaterial!: CreateOrEditTypeGeneticMaterialDto;

    constructor(data?: IGetTypeGeneticMaterialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeGeneticMaterial = _data["typeGeneticMaterial"] ? CreateOrEditTypeGeneticMaterialDto.fromJS(_data["typeGeneticMaterial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTypeGeneticMaterialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeGeneticMaterialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeGeneticMaterial"] = this.typeGeneticMaterial ? this.typeGeneticMaterial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTypeGeneticMaterialForEditOutput {
    typeGeneticMaterial: CreateOrEditTypeGeneticMaterialDto;
}

export class GetTypeGeneticMaterialForViewDto implements IGetTypeGeneticMaterialForViewDto {
    typeGeneticMaterial!: TypeGeneticMaterialDto;

    constructor(data?: IGetTypeGeneticMaterialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeGeneticMaterial = _data["typeGeneticMaterial"] ? TypeGeneticMaterialDto.fromJS(_data["typeGeneticMaterial"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTypeGeneticMaterialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeGeneticMaterialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeGeneticMaterial"] = this.typeGeneticMaterial ? this.typeGeneticMaterial.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTypeGeneticMaterialForViewDto {
    typeGeneticMaterial: TypeGeneticMaterialDto;
}

export class GetTypeSpecieForEditOutput implements IGetTypeSpecieForEditOutput {
    typeSpecie!: CreateOrEditTypeSpecieDto;

    constructor(data?: IGetTypeSpecieForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeSpecie = _data["typeSpecie"] ? CreateOrEditTypeSpecieDto.fromJS(_data["typeSpecie"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTypeSpecieForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeSpecieForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeSpecie"] = this.typeSpecie ? this.typeSpecie.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTypeSpecieForEditOutput {
    typeSpecie: CreateOrEditTypeSpecieDto;
}

export class GetTypeSpecieForViewDto implements IGetTypeSpecieForViewDto {
    typeSpecie!: TypeSpecieDto;

    constructor(data?: IGetTypeSpecieForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeSpecie = _data["typeSpecie"] ? TypeSpecieDto.fromJS(_data["typeSpecie"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTypeSpecieForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeSpecieForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeSpecie"] = this.typeSpecie ? this.typeSpecie.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTypeSpecieForViewDto {
    typeSpecie: TypeSpecieDto;
}

export class GetTypeTrialForEditOutput implements IGetTypeTrialForEditOutput {
    typeTrial!: CreateOrEditTypeTrialDto;
    groupTrialName!: string | undefined;

    constructor(data?: IGetTypeTrialForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeTrial = _data["typeTrial"] ? CreateOrEditTypeTrialDto.fromJS(_data["typeTrial"]) : undefined as any;
            this.groupTrialName = _data["groupTrialName"];
        }
    }

    static fromJS(data: any): GetTypeTrialForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeTrialForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeTrial"] = this.typeTrial ? this.typeTrial.toJSON() : undefined as any;
        data["groupTrialName"] = this.groupTrialName;
        return data;
    }
}

export interface IGetTypeTrialForEditOutput {
    typeTrial: CreateOrEditTypeTrialDto;
    groupTrialName: string | undefined;
}

export class GetTypeTrialForViewDto implements IGetTypeTrialForViewDto {
    typeTrial!: TypeTrialDto;
    groupTrialName!: string | undefined;

    constructor(data?: IGetTypeTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeTrial = _data["typeTrial"] ? TypeTrialDto.fromJS(_data["typeTrial"]) : undefined as any;
            this.groupTrialName = _data["groupTrialName"];
        }
    }

    static fromJS(data: any): GetTypeTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeTrial"] = this.typeTrial ? this.typeTrial.toJSON() : undefined as any;
        data["groupTrialName"] = this.groupTrialName;
        return data;
    }
}

export interface IGetTypeTrialForViewDto {
    typeTrial: TypeTrialDto;
    groupTrialName: string | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : undefined as any;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : undefined as any;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUsersInput implements IGetUsersInput {
    filter!: string | undefined;
    permissions!: string[] | undefined;
    role!: number | undefined;
    onlyLockedUsers!: boolean;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.role = _data["role"];
            this.onlyLockedUsers = _data["onlyLockedUsers"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["role"] = this.role;
        data["onlyLockedUsers"] = this.onlyLockedUsers;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetUsersInput {
    filter: string | undefined;
    permissions: string[] | undefined;
    role: number | undefined;
    onlyLockedUsers: boolean;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetWoodSampleTypeForEditOutput implements IGetWoodSampleTypeForEditOutput {
    woodSampleType!: CreateOrEditWoodSampleTypeDto;

    constructor(data?: IGetWoodSampleTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodSampleType = _data["woodSampleType"] ? CreateOrEditWoodSampleTypeDto.fromJS(_data["woodSampleType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetWoodSampleTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWoodSampleTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodSampleType"] = this.woodSampleType ? this.woodSampleType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetWoodSampleTypeForEditOutput {
    woodSampleType: CreateOrEditWoodSampleTypeDto;
}

export class GetWoodSampleTypeForViewDto implements IGetWoodSampleTypeForViewDto {
    woodSampleType!: WoodSampleTypeDto;

    constructor(data?: IGetWoodSampleTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodSampleType = _data["woodSampleType"] ? WoodSampleTypeDto.fromJS(_data["woodSampleType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetWoodSampleTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWoodSampleTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodSampleType"] = this.woodSampleType ? this.woodSampleType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetWoodSampleTypeForViewDto {
    woodSampleType: WoodSampleTypeDto;
}

export class GetYoungObservationCodeForEditOutput implements IGetYoungObservationCodeForEditOutput {
    youngObservationCode!: CreateOrEditYoungObservationCodeDto;
    treeStatusName!: string | undefined;

    constructor(data?: IGetYoungObservationCodeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.youngObservationCode = _data["youngObservationCode"] ? CreateOrEditYoungObservationCodeDto.fromJS(_data["youngObservationCode"]) : undefined as any;
            this.treeStatusName = _data["treeStatusName"];
        }
    }

    static fromJS(data: any): GetYoungObservationCodeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetYoungObservationCodeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["youngObservationCode"] = this.youngObservationCode ? this.youngObservationCode.toJSON() : undefined as any;
        data["treeStatusName"] = this.treeStatusName;
        return data;
    }
}

export interface IGetYoungObservationCodeForEditOutput {
    youngObservationCode: CreateOrEditYoungObservationCodeDto;
    treeStatusName: string | undefined;
}

export class GetYoungObservationCodeForViewDto implements IGetYoungObservationCodeForViewDto {
    youngObservationCode!: YoungObservationCodeDto;
    treeStatusName!: string | undefined;

    constructor(data?: IGetYoungObservationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.youngObservationCode = _data["youngObservationCode"] ? YoungObservationCodeDto.fromJS(_data["youngObservationCode"]) : undefined as any;
            this.treeStatusName = _data["treeStatusName"];
        }
    }

    static fromJS(data: any): GetYoungObservationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetYoungObservationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["youngObservationCode"] = this.youngObservationCode ? this.youngObservationCode.toJSON() : undefined as any;
        data["treeStatusName"] = this.treeStatusName;
        return data;
    }
}

export interface IGetYoungObservationCodeForViewDto {
    youngObservationCode: YoungObservationCodeDto;
    treeStatusName: string | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class GroupTrial implements IGroupTrial {
    tenantId!: number | undefined;
    name!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IGroupTrial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GroupTrial {
        data = typeof data === 'object' ? data : {};
        let result = new GroupTrial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGroupTrial {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GroupTrialDto implements IGroupTrialDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IGroupTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GroupTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IGroupTrialDto {
    name: string | undefined;
    id: number;
}

export class HealthCheckContext implements IHealthCheckContext {
    registration!: HealthCheckRegistration;

    constructor(data?: IHealthCheckContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registration = _data["registration"] ? HealthCheckRegistration.fromJS(_data["registration"]) : undefined as any;
        }
    }

    static fromJS(data: any): HealthCheckContext {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : undefined as any;
        return data;
    }
}

export interface IHealthCheckContext {
    registration: HealthCheckRegistration;
}

export class HealthCheckItemDto implements IHealthCheckItemDto {
    name!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;
    duration!: string;

    constructor(data?: IHealthCheckItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): HealthCheckItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["description"] = this.description;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IHealthCheckItemDto {
    name: string | undefined;
    status: string | undefined;
    description: string | undefined;
    duration: string;
}

export class HealthCheckRegistration implements IHealthCheckRegistration {
    factory!: FuncOfIServiceProviderIHealthCheck;
    failureStatus!: HealthStatus;
    timeout!: string;
    delay!: string | undefined;
    period!: string | undefined;
    name!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IHealthCheckRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? FuncOfIServiceProviderIHealthCheck.fromJS(_data["factory"]) : undefined as any;
            this.failureStatus = _data["failureStatus"];
            this.timeout = _data["timeout"];
            this.delay = _data["delay"];
            this.period = _data["period"];
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): HealthCheckRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : undefined as any;
        data["failureStatus"] = this.failureStatus;
        data["timeout"] = this.timeout;
        data["delay"] = this.delay;
        data["period"] = this.period;
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IHealthCheckRegistration {
    factory: FuncOfIServiceProviderIHealthCheck;
    failureStatus: HealthStatus;
    timeout: string;
    delay: string | undefined;
    period: string | undefined;
    name: string | undefined;
    tags: string[] | undefined;
}

export class HealthCheckResult implements IHealthCheckResult {
    data!: { [key: string]: any; } | undefined;
    description!: string | undefined;
    exception!: any | undefined;
    status!: HealthStatus;

    constructor(data?: IHealthCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.exception = _data["exception"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HealthCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        data["description"] = this.description;
        data["exception"] = this.exception;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResult {
    data: { [key: string]: any; } | undefined;
    description: string | undefined;
    exception: any | undefined;
    status: HealthStatus;
}

export class HealthDoseDto implements IHealthDoseDto {
    zoneStack!: boolean;
    transectId!: number | undefined;
    healthcareProductsDoseId!: number;
    healthcareTechnologyId!: number;
    healthcareMomentId!: number;
    levelInfestationId!: number;
    id!: number;

    constructor(data?: IHealthDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneStack = _data["zoneStack"];
            this.transectId = _data["transectId"];
            this.healthcareProductsDoseId = _data["healthcareProductsDoseId"];
            this.healthcareTechnologyId = _data["healthcareTechnologyId"];
            this.healthcareMomentId = _data["healthcareMomentId"];
            this.levelInfestationId = _data["levelInfestationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneStack"] = this.zoneStack;
        data["transectId"] = this.transectId;
        data["healthcareProductsDoseId"] = this.healthcareProductsDoseId;
        data["healthcareTechnologyId"] = this.healthcareTechnologyId;
        data["healthcareMomentId"] = this.healthcareMomentId;
        data["levelInfestationId"] = this.levelInfestationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthDoseDto {
    zoneStack: boolean;
    transectId: number | undefined;
    healthcareProductsDoseId: number;
    healthcareTechnologyId: number;
    healthcareMomentId: number;
    levelInfestationId: number;
    id: number;
}

export class HealthDoseHealthcareMomentLookupTableDto implements IHealthDoseHealthcareMomentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IHealthDoseHealthcareMomentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HealthDoseHealthcareMomentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthDoseHealthcareMomentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHealthDoseHealthcareMomentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class HealthDoseHealthcareProductLookupTableDto implements IHealthDoseHealthcareProductLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IHealthDoseHealthcareProductLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HealthDoseHealthcareProductLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthDoseHealthcareProductLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHealthDoseHealthcareProductLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class HealthDoseHealthcareTechnologyLookupTableDto implements IHealthDoseHealthcareTechnologyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IHealthDoseHealthcareTechnologyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HealthDoseHealthcareTechnologyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthDoseHealthcareTechnologyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHealthDoseHealthcareTechnologyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum HealthStatus {
    Unhealthy = 0,
    Degraded = 1,
    Healthy = 2,
}

export class HealthcareFormulaDto implements IHealthcareFormulaDto {
    name!: string | undefined;
    isActive!: boolean;
    scales!: HealthcareFormulaScaleDto[] | undefined;
    id!: number;

    constructor(data?: IHealthcareFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["scales"])) {
                this.scales = [] as any;
                for (let item of _data["scales"])
                    this.scales!.push(HealthcareFormulaScaleDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthcareFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.scales)) {
            data["scales"] = [];
            for (let item of this.scales)
                data["scales"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthcareFormulaDto {
    name: string | undefined;
    isActive: boolean;
    scales: HealthcareFormulaScaleDto[] | undefined;
    id: number;
}

export class HealthcareFormulaScaleDto implements IHealthcareFormulaScaleDto {
    minScale!: number;
    maxScale!: number;
    color!: string | undefined;
    id!: number;

    constructor(data?: IHealthcareFormulaScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minScale = _data["minScale"];
            this.maxScale = _data["maxScale"];
            this.color = _data["color"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthcareFormulaScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareFormulaScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minScale"] = this.minScale;
        data["maxScale"] = this.maxScale;
        data["color"] = this.color;
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthcareFormulaScaleDto {
    minScale: number;
    maxScale: number;
    color: string | undefined;
    id: number;
}

export class HealthcareMastersDto implements IHealthcareMastersDto {
    master!: string | undefined;
    descriptions!: string | undefined;
    levelClasifications!: number | undefined;
    id!: number;

    constructor(data?: IHealthcareMastersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.master = _data["master"];
            this.descriptions = _data["descriptions"];
            this.levelClasifications = _data["levelClasifications"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthcareMastersDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareMastersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["master"] = this.master;
        data["descriptions"] = this.descriptions;
        data["levelClasifications"] = this.levelClasifications;
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthcareMastersDto {
    master: string | undefined;
    descriptions: string | undefined;
    levelClasifications: number | undefined;
    id: number;
}

export class HealthcareProductDoseDto implements IHealthcareProductDoseDto {
    dose!: number;
    minClassificationDose!: number;
    maxClassificationDose!: number;
    id!: number;

    constructor(data?: IHealthcareProductDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dose = _data["dose"];
            this.minClassificationDose = _data["minClassificationDose"];
            this.maxClassificationDose = _data["maxClassificationDose"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthcareProductDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareProductDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dose"] = this.dose;
        data["minClassificationDose"] = this.minClassificationDose;
        data["maxClassificationDose"] = this.maxClassificationDose;
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthcareProductDoseDto {
    dose: number;
    minClassificationDose: number;
    maxClassificationDose: number;
    id: number;
}

export class HealthcareProductDto implements IHealthcareProductDto {
    name!: string | undefined;
    active!: boolean;
    doses!: HealthcareProductDoseDto[] | undefined;
    id!: number;

    constructor(data?: IHealthcareProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.active = _data["active"];
            if (Array.isArray(_data["doses"])) {
                this.doses = [] as any;
                for (let item of _data["doses"])
                    this.doses!.push(HealthcareProductDoseDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthcareProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthcareProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["active"] = this.active;
        if (Array.isArray(this.doses)) {
            data["doses"] = [];
            for (let item of this.doses)
                data["doses"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthcareProductDto {
    name: string | undefined;
    active: boolean;
    doses: HealthcareProductDoseDto[] | undefined;
    id: number;
}

export class HelperPolenPolenLookupTableDto implements IHelperPolenPolenLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IHelperPolenPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HelperPolenPolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelperPolenPolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHelperPolenPolenLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class HelperSeedSeedLookupTableDto implements IHelperSeedSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IHelperSeedSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HelperSeedSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelperSeedSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHelperSeedSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class HelperTreeNameAnalizerDto implements IHelperTreeNameAnalizerDto {
    trialNumber!: string | undefined;
    y!: string | undefined;
    block!: string | undefined;
    subBlock!: string | undefined;
    treeNumber!: string | undefined;
    geneticMaterial!: string | undefined;

    constructor(data?: IHelperTreeNameAnalizerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialNumber = _data["trialNumber"];
            this.y = _data["y"];
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.treeNumber = _data["treeNumber"];
            this.geneticMaterial = _data["geneticMaterial"];
        }
    }

    static fromJS(data: any): HelperTreeNameAnalizerDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelperTreeNameAnalizerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialNumber"] = this.trialNumber;
        data["y"] = this.y;
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["treeNumber"] = this.treeNumber;
        data["geneticMaterial"] = this.geneticMaterial;
        return data;
    }
}

export interface IHelperTreeNameAnalizerDto {
    trialNumber: string | undefined;
    y: string | undefined;
    block: string | undefined;
    subBlock: string | undefined;
    treeNumber: string | undefined;
    geneticMaterial: string | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : undefined as any;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : undefined as any;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined as any;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    UnprocessableContent = 431,
    Locked = 451,
    FailedDependency = 500,
    UpgradeRequired = 501,
    PreconditionRequired = 502,
    TooManyRequests = 503,
    RequestHeaderFieldsTooLarge = 504,
    UnavailableForLegalReasons = 505,
    InternalServerError = 506,
    NotImplemented = 507,
    BadGateway = 508,
    ServiceUnavailable = 510,
    GatewayTimeout = 511,
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : undefined as any;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class InsertOrUpdateAllValuesInput implements IInsertOrUpdateAllValuesInput {
    items!: InsertOrUpdateAllValuesInputItem[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InsertOrUpdateAllValuesInputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInput {
    items: InsertOrUpdateAllValuesInputItem[] | undefined;
}

export class InsertOrUpdateAllValuesInputItem implements IInsertOrUpdateAllValuesInputItem {
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    values!: string[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInputItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInputItem {
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    values: string[] | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : undefined as any;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : undefined as any;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class InterventionFoundationsOneDto implements IInterventionFoundationsOneDto {
    interventionFoundations!: string | undefined;
    id!: number;

    constructor(data?: IInterventionFoundationsOneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InterventionFoundationsOneDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionFoundationsOneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface IInterventionFoundationsOneDto {
    interventionFoundations: string | undefined;
    id: number;
}

export class InterventionFoundationsThreeDto implements IInterventionFoundationsThreeDto {
    interventionFoundations!: string | undefined;
    id!: number;

    constructor(data?: IInterventionFoundationsThreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InterventionFoundationsThreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionFoundationsThreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface IInterventionFoundationsThreeDto {
    interventionFoundations: string | undefined;
    id: number;
}

export class InterventionFoundationsTwoDto implements IInterventionFoundationsTwoDto {
    interventionFoundations!: string | undefined;
    id!: number;

    constructor(data?: IInterventionFoundationsTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionFoundations = _data["interventionFoundations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InterventionFoundationsTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionFoundationsTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionFoundations"] = this.interventionFoundations;
        data["id"] = this.id;
        return data;
    }
}

export interface IInterventionFoundationsTwoDto {
    interventionFoundations: string | undefined;
    id: number;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : undefined as any;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : undefined as any;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class LaboratoryProject implements ILaboratoryProject {
    tenantId!: number | undefined;
    name!: string;
    laboratoryProjectTypeId!: number | undefined;
    laboratoryProjectTypeFk!: LaboratoryProjectType;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILaboratoryProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.laboratoryProjectTypeFk = _data["laboratoryProjectTypeFk"] ? LaboratoryProjectType.fromJS(_data["laboratoryProjectTypeFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProject {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["laboratoryProjectTypeFk"] = this.laboratoryProjectTypeFk ? this.laboratoryProjectTypeFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProject {
    tenantId: number | undefined;
    name: string;
    laboratoryProjectTypeId: number | undefined;
    laboratoryProjectTypeFk: LaboratoryProjectType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LaboratoryProjectDto implements ILaboratoryProjectDto {
    name!: string | undefined;
    laboratoryProjectTypeId!: number | undefined;
    laboratoryProjectTypeName!: string | undefined;
    id!: number;

    constructor(data?: ILaboratoryProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.laboratoryProjectTypeName = _data["laboratoryProjectTypeName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["laboratoryProjectTypeName"] = this.laboratoryProjectTypeName;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProjectDto {
    name: string | undefined;
    laboratoryProjectTypeId: number | undefined;
    laboratoryProjectTypeName: string | undefined;
    id: number;
}

export class LaboratoryProjectStatus implements ILaboratoryProjectStatus {
    tenantId!: number | undefined;
    name!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILaboratoryProjectStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProjectStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProjectStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProjectStatus {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LaboratoryProjectStatusDto implements ILaboratoryProjectStatusDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ILaboratoryProjectStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProjectStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProjectStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProjectStatusDto {
    name: string | undefined;
    id: number;
}

export class LaboratoryProjectType implements ILaboratoryProjectType {
    tenantId!: number | undefined;
    name!: string;
    description!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILaboratoryProjectType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProjectType {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProjectType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProjectType {
    tenantId: number | undefined;
    name: string;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LaboratoryProjectTypeDto implements ILaboratoryProjectTypeDto {
    name!: string | undefined;
    description!: string | undefined;
    id!: number;

    constructor(data?: ILaboratoryProjectTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaboratoryProjectTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryProjectTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ILaboratoryProjectTypeDto {
    name: string | undefined;
    description: string | undefined;
    id: number;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyDto implements IListResultDtoOfDynamicEntityPropertyDto {
    items!: DynamicEntityPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyDto {
    items: DynamicEntityPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyValueDto implements IListResultDtoOfDynamicEntityPropertyValueDto {
    items!: DynamicEntityPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyValueDto {
    items: DynamicEntityPropertyValueDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyDto implements IListResultDtoOfDynamicPropertyDto {
    items!: DynamicPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyDto {
    items: DynamicPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyValueDto implements IListResultDtoOfDynamicPropertyValueDto {
    items!: DynamicPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyValueDto {
    items: DynamicPropertyValueDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
    items!: GetAllAvailableWebhooksOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
    items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput implements IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items!: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllEntitiesHasDynamicPropertyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
    items!: GetAllSubscriptionsOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
    items: GetAllSubscriptionsOutput[] | undefined;
}

export class ListResultDtoOfHealthCheckItemDto implements IListResultDtoOfHealthCheckItemDto {
    items!: HealthCheckItemDto[] | undefined;

    constructor(data?: IListResultDtoOfHealthCheckItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HealthCheckItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHealthCheckItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfHealthCheckItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfHealthCheckItemDto {
    items: HealthCheckItemDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LookupTableResponseDto implements ILookupTableResponseDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ILookupTableResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LookupTableResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupTableResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ILookupTableResponseDto {
    id: number;
    displayName: string | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class MeasurementCloneEvaluationWoodSampleTypeLookupTableDto implements IMeasurementCloneEvaluationWoodSampleTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementCloneEvaluationWoodSampleTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementCloneEvaluationWoodSampleTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementCloneEvaluationWoodSampleTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementCloneEvaluationWoodSampleTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningDto implements IMeasurementPlaningDto {
    assignmentName!: string | undefined;
    status!: EnumMeasurementPlaningStatus;
    id!: number;

    constructor(data?: IMeasurementPlaningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentName = _data["assignmentName"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementPlaningDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentName"] = this.assignmentName;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementPlaningDto {
    assignmentName: string | undefined;
    status: EnumMeasurementPlaningStatus;
    id: number;
}

export class MeasurementPlaningOptionsDto implements IMeasurementPlaningOptionsDto {
    dapRequired!: boolean;
    heightRequired!: boolean;
    adultObservationCodeRequired!: boolean;
    adultObservationHeightRequired!: boolean;
    frostToleranceCodeRequired!: boolean;
    pestsAndDiseasesCodeRequired!: boolean;
    partialMeasurement!: boolean;
    partialHeight!: boolean;
    standName!: string | undefined;
    trialNumber!: string | undefined;
    trialAge!: number;
    region!: string | undefined;
    trialType!: string | undefined;
    farmName!: string | undefined;
    status!: EnumMeasurementPlaningStatus;
    assignmentName!: string | undefined;
    measurementPlaningId!: number | undefined;
    trialId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementPlaningOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dapRequired = _data["dapRequired"];
            this.heightRequired = _data["heightRequired"];
            this.adultObservationCodeRequired = _data["adultObservationCodeRequired"];
            this.adultObservationHeightRequired = _data["adultObservationHeightRequired"];
            this.frostToleranceCodeRequired = _data["frostToleranceCodeRequired"];
            this.pestsAndDiseasesCodeRequired = _data["pestsAndDiseasesCodeRequired"];
            this.partialMeasurement = _data["partialMeasurement"];
            this.partialHeight = _data["partialHeight"];
            this.standName = _data["standName"];
            this.trialNumber = _data["trialNumber"];
            this.trialAge = _data["trialAge"];
            this.region = _data["region"];
            this.trialType = _data["trialType"];
            this.farmName = _data["farmName"];
            this.status = _data["status"];
            this.assignmentName = _data["assignmentName"];
            this.measurementPlaningId = _data["measurementPlaningId"];
            this.trialId = _data["trialId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementPlaningOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dapRequired"] = this.dapRequired;
        data["heightRequired"] = this.heightRequired;
        data["adultObservationCodeRequired"] = this.adultObservationCodeRequired;
        data["adultObservationHeightRequired"] = this.adultObservationHeightRequired;
        data["frostToleranceCodeRequired"] = this.frostToleranceCodeRequired;
        data["pestsAndDiseasesCodeRequired"] = this.pestsAndDiseasesCodeRequired;
        data["partialMeasurement"] = this.partialMeasurement;
        data["partialHeight"] = this.partialHeight;
        data["standName"] = this.standName;
        data["trialNumber"] = this.trialNumber;
        data["trialAge"] = this.trialAge;
        data["region"] = this.region;
        data["trialType"] = this.trialType;
        data["farmName"] = this.farmName;
        data["status"] = this.status;
        data["assignmentName"] = this.assignmentName;
        data["measurementPlaningId"] = this.measurementPlaningId;
        data["trialId"] = this.trialId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementPlaningOptionsDto {
    dapRequired: boolean;
    heightRequired: boolean;
    adultObservationCodeRequired: boolean;
    adultObservationHeightRequired: boolean;
    frostToleranceCodeRequired: boolean;
    pestsAndDiseasesCodeRequired: boolean;
    partialMeasurement: boolean;
    partialHeight: boolean;
    standName: string | undefined;
    trialNumber: string | undefined;
    trialAge: number;
    region: string | undefined;
    trialType: string | undefined;
    farmName: string | undefined;
    status: EnumMeasurementPlaningStatus;
    assignmentName: string | undefined;
    measurementPlaningId: number | undefined;
    trialId: number | undefined;
    id: number;
}

export class MeasurementPlaningOptionsMeasurementPlaningLookupTableDto implements IMeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningOptionsMeasurementPlaningLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningOptionsMeasurementPlaningLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningOptionsTrialLookupTableDto implements IMeasurementPlaningOptionsTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningOptionsTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningOptionsTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningOptionsTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningOptionsTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningTreatmentDto implements IMeasurementPlaningTreatmentDto {
    treatmentId!: number | undefined;
    measurementPlaningOptionsId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementPlaningTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentId = _data["treatmentId"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentId"] = this.treatmentId;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementPlaningTreatmentDto {
    treatmentId: number | undefined;
    measurementPlaningOptionsId: number | undefined;
    id: number;
}

export class MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto implements IMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningTreatmentTreatmentLookupTableDto implements IMeasurementPlaningTreatmentTreatmentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningTreatmentTreatmentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreatmentTreatmentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreatmentTreatmentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningTreatmentTreatmentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningTreeHeightNumberDto implements IMeasurementPlaningTreeHeightNumberDto {
    treeNumber!: number;
    measurementPlaningOptionsId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementPlaningTreeHeightNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreeHeightNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreeHeightNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementPlaningTreeHeightNumberDto {
    treeNumber: number;
    measurementPlaningOptionsId: number | undefined;
    id: number;
}

export class MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto implements IMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementPlaningTreeNumberDto implements IMeasurementPlaningTreeNumberDto {
    treeNumber!: number;
    measurementPlaningOptionsId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementPlaningTreeNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreeNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreeNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementPlaningTreeNumberDto {
    treeNumber: number;
    measurementPlaningOptionsId: number | undefined;
    id: number;
}

export class MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto implements IMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelection implements IMeasurementSelection {
    tenantId!: number | undefined;
    bV_Vol!: number | undefined;
    stageOneSelection!: boolean;
    stageTwoSelection!: boolean;
    treeIdName!: string;
    nirCode!: string | undefined;
    nirCodeSawdust!: string | undefined;
    dB_Model_Kg_m3!: number | undefined;
    pilodyn!: number | undefined;
    rP_Model_Percentage!: number | undefined;
    rP_Model_Disco_Percentage!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    dB_10!: number | undefined;
    observations!: string | undefined;
    destination!: string | undefined;
    numberT!: string | undefined;
    maxRootingPercentage!: number | undefined;
    numberX!: string | undefined;
    treeId!: number;
    treeFk!: Tree;
    woodSampleStageOneTypeId!: number | undefined;
    woodSampleStageOneTypeFk!: WoodSampleType;
    woodSampleStageTwoTypeId!: number | undefined;
    woodSampleStageTwoTypeFk!: WoodSampleType;
    projectId!: number;
    projectFk!: Project;
    laboratoryId!: string | undefined;
    subProyecto!: string | undefined;
    year!: number | undefined;
    samplingDate!: DateTime | undefined;
    treeAgeSamplingDate!: number | undefined;
    bV_DB_model!: number | undefined;
    bV_RP_model!: number | undefined;
    laboratoryIdDisco!: string | undefined;
    subProyectoDisco!: string | undefined;
    yearDisco!: number | undefined;
    samplingDateDisco!: DateTime | undefined;
    treeAgeSamplingDateDisco!: number | undefined;
    observationsDisco!: string | undefined;
    bbtNumber!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bV_Vol = _data["bV_Vol"];
            this.stageOneSelection = _data["stageOneSelection"];
            this.stageTwoSelection = _data["stageTwoSelection"];
            this.treeIdName = _data["treeIdName"];
            this.nirCode = _data["nirCode"];
            this.nirCodeSawdust = _data["nirCodeSawdust"];
            this.dB_Model_Kg_m3 = _data["dB_Model_Kg_m3"];
            this.pilodyn = _data["pilodyn"];
            this.rP_Model_Percentage = _data["rP_Model_Percentage"];
            this.rP_Model_Disco_Percentage = _data["rP_Model_Disco_Percentage"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.dB_10 = _data["dB_10"];
            this.observations = _data["observations"];
            this.destination = _data["destination"];
            this.numberT = _data["numberT"];
            this.maxRootingPercentage = _data["maxRootingPercentage"];
            this.numberX = _data["numberX"];
            this.treeId = _data["treeId"];
            this.treeFk = _data["treeFk"] ? Tree.fromJS(_data["treeFk"]) : undefined as any;
            this.woodSampleStageOneTypeId = _data["woodSampleStageOneTypeId"];
            this.woodSampleStageOneTypeFk = _data["woodSampleStageOneTypeFk"] ? WoodSampleType.fromJS(_data["woodSampleStageOneTypeFk"]) : undefined as any;
            this.woodSampleStageTwoTypeId = _data["woodSampleStageTwoTypeId"];
            this.woodSampleStageTwoTypeFk = _data["woodSampleStageTwoTypeFk"] ? WoodSampleType.fromJS(_data["woodSampleStageTwoTypeFk"]) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectFk = _data["projectFk"] ? Project.fromJS(_data["projectFk"]) : undefined as any;
            this.laboratoryId = _data["laboratoryId"];
            this.subProyecto = _data["subProyecto"];
            this.year = _data["year"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.treeAgeSamplingDate = _data["treeAgeSamplingDate"];
            this.bV_DB_model = _data["bV_DB_model"];
            this.bV_RP_model = _data["bV_RP_model"];
            this.laboratoryIdDisco = _data["laboratoryIdDisco"];
            this.subProyectoDisco = _data["subProyectoDisco"];
            this.yearDisco = _data["yearDisco"];
            this.samplingDateDisco = _data["samplingDateDisco"] ? DateTime.fromISO(_data["samplingDateDisco"].toString()) : undefined as any;
            this.treeAgeSamplingDateDisco = _data["treeAgeSamplingDateDisco"];
            this.observationsDisco = _data["observationsDisco"];
            this.bbtNumber = _data["bbtNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementSelection {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bV_Vol"] = this.bV_Vol;
        data["stageOneSelection"] = this.stageOneSelection;
        data["stageTwoSelection"] = this.stageTwoSelection;
        data["treeIdName"] = this.treeIdName;
        data["nirCode"] = this.nirCode;
        data["nirCodeSawdust"] = this.nirCodeSawdust;
        data["dB_Model_Kg_m3"] = this.dB_Model_Kg_m3;
        data["pilodyn"] = this.pilodyn;
        data["rP_Model_Percentage"] = this.rP_Model_Percentage;
        data["rP_Model_Disco_Percentage"] = this.rP_Model_Disco_Percentage;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["dB_10"] = this.dB_10;
        data["observations"] = this.observations;
        data["destination"] = this.destination;
        data["numberT"] = this.numberT;
        data["maxRootingPercentage"] = this.maxRootingPercentage;
        data["numberX"] = this.numberX;
        data["treeId"] = this.treeId;
        data["treeFk"] = this.treeFk ? this.treeFk.toJSON() : undefined as any;
        data["woodSampleStageOneTypeId"] = this.woodSampleStageOneTypeId;
        data["woodSampleStageOneTypeFk"] = this.woodSampleStageOneTypeFk ? this.woodSampleStageOneTypeFk.toJSON() : undefined as any;
        data["woodSampleStageTwoTypeId"] = this.woodSampleStageTwoTypeId;
        data["woodSampleStageTwoTypeFk"] = this.woodSampleStageTwoTypeFk ? this.woodSampleStageTwoTypeFk.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectFk"] = this.projectFk ? this.projectFk.toJSON() : undefined as any;
        data["laboratoryId"] = this.laboratoryId;
        data["subProyecto"] = this.subProyecto;
        data["year"] = this.year;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["treeAgeSamplingDate"] = this.treeAgeSamplingDate;
        data["bV_DB_model"] = this.bV_DB_model;
        data["bV_RP_model"] = this.bV_RP_model;
        data["laboratoryIdDisco"] = this.laboratoryIdDisco;
        data["subProyectoDisco"] = this.subProyectoDisco;
        data["yearDisco"] = this.yearDisco;
        data["samplingDateDisco"] = this.samplingDateDisco ? this.samplingDateDisco.toString() : undefined as any;
        data["treeAgeSamplingDateDisco"] = this.treeAgeSamplingDateDisco;
        data["observationsDisco"] = this.observationsDisco;
        data["bbtNumber"] = this.bbtNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementSelection {
    tenantId: number | undefined;
    bV_Vol: number | undefined;
    stageOneSelection: boolean;
    stageTwoSelection: boolean;
    treeIdName: string;
    nirCode: string | undefined;
    nirCodeSawdust: string | undefined;
    dB_Model_Kg_m3: number | undefined;
    pilodyn: number | undefined;
    rP_Model_Percentage: number | undefined;
    rP_Model_Disco_Percentage: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    dB_10: number | undefined;
    observations: string | undefined;
    destination: string | undefined;
    numberT: string | undefined;
    maxRootingPercentage: number | undefined;
    numberX: string | undefined;
    treeId: number;
    treeFk: Tree;
    woodSampleStageOneTypeId: number | undefined;
    woodSampleStageOneTypeFk: WoodSampleType;
    woodSampleStageTwoTypeId: number | undefined;
    woodSampleStageTwoTypeFk: WoodSampleType;
    projectId: number;
    projectFk: Project;
    laboratoryId: string | undefined;
    subProyecto: string | undefined;
    year: number | undefined;
    samplingDate: DateTime | undefined;
    treeAgeSamplingDate: number | undefined;
    bV_DB_model: number | undefined;
    bV_RP_model: number | undefined;
    laboratoryIdDisco: string | undefined;
    subProyectoDisco: string | undefined;
    yearDisco: number | undefined;
    samplingDateDisco: DateTime | undefined;
    treeAgeSamplingDateDisco: number | undefined;
    observationsDisco: string | undefined;
    bbtNumber: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class MeasurementSelectionDto implements IMeasurementSelectionDto {
    bV_Vol!: number | undefined;
    stageOneSelection!: boolean;
    stageTwoSelection!: boolean;
    treeIdName!: string | undefined;
    nirCode!: string | undefined;
    dB_Model_Kg_m3!: number | undefined;
    pilodyn!: number | undefined;
    rP_Model_Percentage!: number | undefined;
    rP_Model_Disco_Percentage!: number | undefined;
    dB_Lab_Kg_m3!: number | undefined;
    dB_10!: number | undefined;
    observations!: string | undefined;
    destination!: string | undefined;
    numberT!: string | undefined;
    maxRootingPercentage!: number | undefined;
    numberX!: string | undefined;
    treeId!: number;
    woodSampleStageOneTypeId!: number | undefined;
    woodSampleStageTwoTypeId!: number | undefined;
    projectId!: number;
    laboratoryId!: string | undefined;
    subProyecto!: string | undefined;
    year!: number | undefined;
    samplingDate!: DateTime | undefined;
    treeAgeSamplingDate!: number | undefined;
    treeStatusId!: number;
    bV_DB_model!: number | undefined;
    bV_RP_model!: number | undefined;
    laboratoryIdDisco!: string | undefined;
    subProyectoDisco!: string | undefined;
    yearDisco!: number;
    samplingDateDisco!: DateTime | undefined;
    treeAgeSamplingDateDisco!: number | undefined;
    observationsDisco!: string | undefined;
    bbtNumber!: number;
    destinationBBX!: string | undefined;
    nirCodeSawdust!: string | undefined;
    id!: number;

    constructor(data?: IMeasurementSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bV_Vol = _data["bV_Vol"];
            this.stageOneSelection = _data["stageOneSelection"];
            this.stageTwoSelection = _data["stageTwoSelection"];
            this.treeIdName = _data["treeIdName"];
            this.nirCode = _data["nirCode"];
            this.dB_Model_Kg_m3 = _data["dB_Model_Kg_m3"];
            this.pilodyn = _data["pilodyn"];
            this.rP_Model_Percentage = _data["rP_Model_Percentage"];
            this.rP_Model_Disco_Percentage = _data["rP_Model_Disco_Percentage"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.dB_10 = _data["dB_10"];
            this.observations = _data["observations"];
            this.destination = _data["destination"];
            this.numberT = _data["numberT"];
            this.maxRootingPercentage = _data["maxRootingPercentage"];
            this.numberX = _data["numberX"];
            this.treeId = _data["treeId"];
            this.woodSampleStageOneTypeId = _data["woodSampleStageOneTypeId"];
            this.woodSampleStageTwoTypeId = _data["woodSampleStageTwoTypeId"];
            this.projectId = _data["projectId"];
            this.laboratoryId = _data["laboratoryId"];
            this.subProyecto = _data["subProyecto"];
            this.year = _data["year"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.treeAgeSamplingDate = _data["treeAgeSamplingDate"];
            this.treeStatusId = _data["treeStatusId"];
            this.bV_DB_model = _data["bV_DB_model"];
            this.bV_RP_model = _data["bV_RP_model"];
            this.laboratoryIdDisco = _data["laboratoryIdDisco"];
            this.subProyectoDisco = _data["subProyectoDisco"];
            this.yearDisco = _data["yearDisco"];
            this.samplingDateDisco = _data["samplingDateDisco"] ? DateTime.fromISO(_data["samplingDateDisco"].toString()) : undefined as any;
            this.treeAgeSamplingDateDisco = _data["treeAgeSamplingDateDisco"];
            this.observationsDisco = _data["observationsDisco"];
            this.bbtNumber = _data["bbtNumber"];
            this.destinationBBX = _data["destinationBBX"];
            this.nirCodeSawdust = _data["nirCodeSawdust"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bV_Vol"] = this.bV_Vol;
        data["stageOneSelection"] = this.stageOneSelection;
        data["stageTwoSelection"] = this.stageTwoSelection;
        data["treeIdName"] = this.treeIdName;
        data["nirCode"] = this.nirCode;
        data["dB_Model_Kg_m3"] = this.dB_Model_Kg_m3;
        data["pilodyn"] = this.pilodyn;
        data["rP_Model_Percentage"] = this.rP_Model_Percentage;
        data["rP_Model_Disco_Percentage"] = this.rP_Model_Disco_Percentage;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["dB_10"] = this.dB_10;
        data["observations"] = this.observations;
        data["destination"] = this.destination;
        data["numberT"] = this.numberT;
        data["maxRootingPercentage"] = this.maxRootingPercentage;
        data["numberX"] = this.numberX;
        data["treeId"] = this.treeId;
        data["woodSampleStageOneTypeId"] = this.woodSampleStageOneTypeId;
        data["woodSampleStageTwoTypeId"] = this.woodSampleStageTwoTypeId;
        data["projectId"] = this.projectId;
        data["laboratoryId"] = this.laboratoryId;
        data["subProyecto"] = this.subProyecto;
        data["year"] = this.year;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["treeAgeSamplingDate"] = this.treeAgeSamplingDate;
        data["treeStatusId"] = this.treeStatusId;
        data["bV_DB_model"] = this.bV_DB_model;
        data["bV_RP_model"] = this.bV_RP_model;
        data["laboratoryIdDisco"] = this.laboratoryIdDisco;
        data["subProyectoDisco"] = this.subProyectoDisco;
        data["yearDisco"] = this.yearDisco;
        data["samplingDateDisco"] = this.samplingDateDisco ? this.samplingDateDisco.toString() : undefined as any;
        data["treeAgeSamplingDateDisco"] = this.treeAgeSamplingDateDisco;
        data["observationsDisco"] = this.observationsDisco;
        data["bbtNumber"] = this.bbtNumber;
        data["destinationBBX"] = this.destinationBBX;
        data["nirCodeSawdust"] = this.nirCodeSawdust;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementSelectionDto {
    bV_Vol: number | undefined;
    stageOneSelection: boolean;
    stageTwoSelection: boolean;
    treeIdName: string | undefined;
    nirCode: string | undefined;
    dB_Model_Kg_m3: number | undefined;
    pilodyn: number | undefined;
    rP_Model_Percentage: number | undefined;
    rP_Model_Disco_Percentage: number | undefined;
    dB_Lab_Kg_m3: number | undefined;
    dB_10: number | undefined;
    observations: string | undefined;
    destination: string | undefined;
    numberT: string | undefined;
    maxRootingPercentage: number | undefined;
    numberX: string | undefined;
    treeId: number;
    woodSampleStageOneTypeId: number | undefined;
    woodSampleStageTwoTypeId: number | undefined;
    projectId: number;
    laboratoryId: string | undefined;
    subProyecto: string | undefined;
    year: number | undefined;
    samplingDate: DateTime | undefined;
    treeAgeSamplingDate: number | undefined;
    treeStatusId: number;
    bV_DB_model: number | undefined;
    bV_RP_model: number | undefined;
    laboratoryIdDisco: string | undefined;
    subProyectoDisco: string | undefined;
    yearDisco: number;
    samplingDateDisco: DateTime | undefined;
    treeAgeSamplingDateDisco: number | undefined;
    observationsDisco: string | undefined;
    bbtNumber: number;
    destinationBBX: string | undefined;
    nirCodeSawdust: string | undefined;
    id: number;
}

export class MeasurementSelectionGenomic implements IMeasurementSelectionGenomic {
    tenantId!: number | undefined;
    bbt!: string | undefined;
    bbtNumber!: number;
    bbx!: string | undefined;
    bbxNumber!: number;
    rootingPercentage!: number | undefined;
    observations!: string | undefined;
    bbT_Destination!: string | undefined;
    bbX_Destination!: string | undefined;
    bluP_Vol!: number;
    err_Blup_Vol!: number;
    acc_Blup_Vol!: number;
    model_Blup_Vol!: number;
    gblup_Vol!: number;
    err_Gblup_VOL!: number;
    acc_Gblup_Vol!: number;
    model_Gblup_Vol!: number;
    hblup_Vol!: number;
    err_Hblup_Vol!: number;
    acc_Hblup_Vol!: number;
    model_Hblup_Vol!: number;
    blup_Rp!: number;
    err_Blup_Rp!: number;
    acc_Blup_Rp!: number;
    model_Blup_Rp!: number;
    gblup_Rp!: number;
    err_Gblup_Rp!: number;
    acc_Gblup_Rp!: number;
    model_Gblup_Rp!: number;
    hblup_Rp!: number;
    err_Hblup_Rp!: number;
    acc_Hblup_Rp!: number;
    model_Hblup_Rp!: number;
    blup_Db!: number;
    err_Blup_Db!: number;
    acc_Blup_Db!: number;
    model_Blup_Db!: number;
    gblup_Db!: number;
    err_Gblup_Db!: number;
    acc_Gblup_Db!: number;
    model_Gblup_Db!: number;
    hblup_Db!: number;
    err_Hblup_Db!: number;
    acc_Hblup_Db!: number;
    model_Hblup_Db!: number;
    seedlingId!: number | undefined;
    seedlingFk!: Seedling;
    projectId!: number | undefined;
    projectFk!: Project;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementSelectionGenomic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bbt = _data["bbt"];
            this.bbtNumber = _data["bbtNumber"];
            this.bbx = _data["bbx"];
            this.bbxNumber = _data["bbxNumber"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.observations = _data["observations"];
            this.bbT_Destination = _data["bbT_Destination"];
            this.bbX_Destination = _data["bbX_Destination"];
            this.bluP_Vol = _data["bluP_Vol"];
            this.err_Blup_Vol = _data["err_Blup_Vol"];
            this.acc_Blup_Vol = _data["acc_Blup_Vol"];
            this.model_Blup_Vol = _data["model_Blup_Vol"];
            this.gblup_Vol = _data["gblup_Vol"];
            this.err_Gblup_VOL = _data["err_Gblup_VOL"];
            this.acc_Gblup_Vol = _data["acc_Gblup_Vol"];
            this.model_Gblup_Vol = _data["model_Gblup_Vol"];
            this.hblup_Vol = _data["hblup_Vol"];
            this.err_Hblup_Vol = _data["err_Hblup_Vol"];
            this.acc_Hblup_Vol = _data["acc_Hblup_Vol"];
            this.model_Hblup_Vol = _data["model_Hblup_Vol"];
            this.blup_Rp = _data["blup_Rp"];
            this.err_Blup_Rp = _data["err_Blup_Rp"];
            this.acc_Blup_Rp = _data["acc_Blup_Rp"];
            this.model_Blup_Rp = _data["model_Blup_Rp"];
            this.gblup_Rp = _data["gblup_Rp"];
            this.err_Gblup_Rp = _data["err_Gblup_Rp"];
            this.acc_Gblup_Rp = _data["acc_Gblup_Rp"];
            this.model_Gblup_Rp = _data["model_Gblup_Rp"];
            this.hblup_Rp = _data["hblup_Rp"];
            this.err_Hblup_Rp = _data["err_Hblup_Rp"];
            this.acc_Hblup_Rp = _data["acc_Hblup_Rp"];
            this.model_Hblup_Rp = _data["model_Hblup_Rp"];
            this.blup_Db = _data["blup_Db"];
            this.err_Blup_Db = _data["err_Blup_Db"];
            this.acc_Blup_Db = _data["acc_Blup_Db"];
            this.model_Blup_Db = _data["model_Blup_Db"];
            this.gblup_Db = _data["gblup_Db"];
            this.err_Gblup_Db = _data["err_Gblup_Db"];
            this.acc_Gblup_Db = _data["acc_Gblup_Db"];
            this.model_Gblup_Db = _data["model_Gblup_Db"];
            this.hblup_Db = _data["hblup_Db"];
            this.err_Hblup_Db = _data["err_Hblup_Db"];
            this.acc_Hblup_Db = _data["acc_Hblup_Db"];
            this.model_Hblup_Db = _data["model_Hblup_Db"];
            this.seedlingId = _data["seedlingId"];
            this.seedlingFk = _data["seedlingFk"] ? Seedling.fromJS(_data["seedlingFk"]) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectFk = _data["projectFk"] ? Project.fromJS(_data["projectFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementSelectionGenomic {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionGenomic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bbt"] = this.bbt;
        data["bbtNumber"] = this.bbtNumber;
        data["bbx"] = this.bbx;
        data["bbxNumber"] = this.bbxNumber;
        data["rootingPercentage"] = this.rootingPercentage;
        data["observations"] = this.observations;
        data["bbT_Destination"] = this.bbT_Destination;
        data["bbX_Destination"] = this.bbX_Destination;
        data["bluP_Vol"] = this.bluP_Vol;
        data["err_Blup_Vol"] = this.err_Blup_Vol;
        data["acc_Blup_Vol"] = this.acc_Blup_Vol;
        data["model_Blup_Vol"] = this.model_Blup_Vol;
        data["gblup_Vol"] = this.gblup_Vol;
        data["err_Gblup_VOL"] = this.err_Gblup_VOL;
        data["acc_Gblup_Vol"] = this.acc_Gblup_Vol;
        data["model_Gblup_Vol"] = this.model_Gblup_Vol;
        data["hblup_Vol"] = this.hblup_Vol;
        data["err_Hblup_Vol"] = this.err_Hblup_Vol;
        data["acc_Hblup_Vol"] = this.acc_Hblup_Vol;
        data["model_Hblup_Vol"] = this.model_Hblup_Vol;
        data["blup_Rp"] = this.blup_Rp;
        data["err_Blup_Rp"] = this.err_Blup_Rp;
        data["acc_Blup_Rp"] = this.acc_Blup_Rp;
        data["model_Blup_Rp"] = this.model_Blup_Rp;
        data["gblup_Rp"] = this.gblup_Rp;
        data["err_Gblup_Rp"] = this.err_Gblup_Rp;
        data["acc_Gblup_Rp"] = this.acc_Gblup_Rp;
        data["model_Gblup_Rp"] = this.model_Gblup_Rp;
        data["hblup_Rp"] = this.hblup_Rp;
        data["err_Hblup_Rp"] = this.err_Hblup_Rp;
        data["acc_Hblup_Rp"] = this.acc_Hblup_Rp;
        data["model_Hblup_Rp"] = this.model_Hblup_Rp;
        data["blup_Db"] = this.blup_Db;
        data["err_Blup_Db"] = this.err_Blup_Db;
        data["acc_Blup_Db"] = this.acc_Blup_Db;
        data["model_Blup_Db"] = this.model_Blup_Db;
        data["gblup_Db"] = this.gblup_Db;
        data["err_Gblup_Db"] = this.err_Gblup_Db;
        data["acc_Gblup_Db"] = this.acc_Gblup_Db;
        data["model_Gblup_Db"] = this.model_Gblup_Db;
        data["hblup_Db"] = this.hblup_Db;
        data["err_Hblup_Db"] = this.err_Hblup_Db;
        data["acc_Hblup_Db"] = this.acc_Hblup_Db;
        data["model_Hblup_Db"] = this.model_Hblup_Db;
        data["seedlingId"] = this.seedlingId;
        data["seedlingFk"] = this.seedlingFk ? this.seedlingFk.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectFk"] = this.projectFk ? this.projectFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementSelectionGenomic {
    tenantId: number | undefined;
    bbt: string | undefined;
    bbtNumber: number;
    bbx: string | undefined;
    bbxNumber: number;
    rootingPercentage: number | undefined;
    observations: string | undefined;
    bbT_Destination: string | undefined;
    bbX_Destination: string | undefined;
    bluP_Vol: number;
    err_Blup_Vol: number;
    acc_Blup_Vol: number;
    model_Blup_Vol: number;
    gblup_Vol: number;
    err_Gblup_VOL: number;
    acc_Gblup_Vol: number;
    model_Gblup_Vol: number;
    hblup_Vol: number;
    err_Hblup_Vol: number;
    acc_Hblup_Vol: number;
    model_Hblup_Vol: number;
    blup_Rp: number;
    err_Blup_Rp: number;
    acc_Blup_Rp: number;
    model_Blup_Rp: number;
    gblup_Rp: number;
    err_Gblup_Rp: number;
    acc_Gblup_Rp: number;
    model_Gblup_Rp: number;
    hblup_Rp: number;
    err_Hblup_Rp: number;
    acc_Hblup_Rp: number;
    model_Hblup_Rp: number;
    blup_Db: number;
    err_Blup_Db: number;
    acc_Blup_Db: number;
    model_Blup_Db: number;
    gblup_Db: number;
    err_Gblup_Db: number;
    acc_Gblup_Db: number;
    model_Gblup_Db: number;
    hblup_Db: number;
    err_Hblup_Db: number;
    acc_Hblup_Db: number;
    model_Hblup_Db: number;
    seedlingId: number | undefined;
    seedlingFk: Seedling;
    projectId: number | undefined;
    projectFk: Project;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class MeasurementSelectionGenomicDto implements IMeasurementSelectionGenomicDto {
    bbt!: string | undefined;
    bbtNumber!: number;
    rootingPercentage!: number | undefined;
    bbx!: string | undefined;
    observations!: string | undefined;
    bbT_Destination!: string | undefined;
    bbX_Destination!: string | undefined;
    bluP_Vol!: number;
    err_Blup_Vol!: number;
    acc_Blup_Vol!: number;
    model_Blup_Vol!: number;
    gblup_Vol!: number;
    err_Gblup_VOL!: number;
    acc_Gblup_Vol!: number;
    model_Gblup_Vol!: number;
    hblup_Vol!: number;
    err_Hblup_Vol!: number;
    acc_Hblup_Vol!: number;
    model_Hblup_Vol!: number;
    blup_Rp!: number;
    err_Blup_Rp!: number;
    acc_Blup_Rp!: number;
    model_Blup_Rp!: number;
    gblup_Rp!: number;
    err_Gblup_Rp!: number;
    acc_Gblup_Rp!: number;
    model_Gblup_Rp!: number;
    hblup_Rp!: number;
    err_Hblup_Rp!: number;
    acc_Hblup_Rp!: number;
    model_Hblup_Rp!: number;
    blup_Db!: number;
    err_Blup_Db!: number;
    acc_Blup_Db!: number;
    model_Blup_Db!: number;
    gblup_Db!: number;
    err_Gblup_Db!: number;
    acc_Gblup_Db!: number;
    model_Gblup_Db!: number;
    hblup_Db!: number;
    err_Hblup_Db!: number;
    acc_Hblup_Db!: number;
    model_Hblup_Db!: number;
    seedlingDto!: SeedlingDto;
    seedlingId!: number | undefined;
    projectId!: number | undefined;
    id!: number;

    constructor(data?: IMeasurementSelectionGenomicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbt = _data["bbt"];
            this.bbtNumber = _data["bbtNumber"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.bbx = _data["bbx"];
            this.observations = _data["observations"];
            this.bbT_Destination = _data["bbT_Destination"];
            this.bbX_Destination = _data["bbX_Destination"];
            this.bluP_Vol = _data["bluP_Vol"];
            this.err_Blup_Vol = _data["err_Blup_Vol"];
            this.acc_Blup_Vol = _data["acc_Blup_Vol"];
            this.model_Blup_Vol = _data["model_Blup_Vol"];
            this.gblup_Vol = _data["gblup_Vol"];
            this.err_Gblup_VOL = _data["err_Gblup_VOL"];
            this.acc_Gblup_Vol = _data["acc_Gblup_Vol"];
            this.model_Gblup_Vol = _data["model_Gblup_Vol"];
            this.hblup_Vol = _data["hblup_Vol"];
            this.err_Hblup_Vol = _data["err_Hblup_Vol"];
            this.acc_Hblup_Vol = _data["acc_Hblup_Vol"];
            this.model_Hblup_Vol = _data["model_Hblup_Vol"];
            this.blup_Rp = _data["blup_Rp"];
            this.err_Blup_Rp = _data["err_Blup_Rp"];
            this.acc_Blup_Rp = _data["acc_Blup_Rp"];
            this.model_Blup_Rp = _data["model_Blup_Rp"];
            this.gblup_Rp = _data["gblup_Rp"];
            this.err_Gblup_Rp = _data["err_Gblup_Rp"];
            this.acc_Gblup_Rp = _data["acc_Gblup_Rp"];
            this.model_Gblup_Rp = _data["model_Gblup_Rp"];
            this.hblup_Rp = _data["hblup_Rp"];
            this.err_Hblup_Rp = _data["err_Hblup_Rp"];
            this.acc_Hblup_Rp = _data["acc_Hblup_Rp"];
            this.model_Hblup_Rp = _data["model_Hblup_Rp"];
            this.blup_Db = _data["blup_Db"];
            this.err_Blup_Db = _data["err_Blup_Db"];
            this.acc_Blup_Db = _data["acc_Blup_Db"];
            this.model_Blup_Db = _data["model_Blup_Db"];
            this.gblup_Db = _data["gblup_Db"];
            this.err_Gblup_Db = _data["err_Gblup_Db"];
            this.acc_Gblup_Db = _data["acc_Gblup_Db"];
            this.model_Gblup_Db = _data["model_Gblup_Db"];
            this.hblup_Db = _data["hblup_Db"];
            this.err_Hblup_Db = _data["err_Hblup_Db"];
            this.acc_Hblup_Db = _data["acc_Hblup_Db"];
            this.model_Hblup_Db = _data["model_Hblup_Db"];
            this.seedlingDto = _data["seedlingDto"] ? SeedlingDto.fromJS(_data["seedlingDto"]) : undefined as any;
            this.seedlingId = _data["seedlingId"];
            this.projectId = _data["projectId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementSelectionGenomicDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionGenomicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbt"] = this.bbt;
        data["bbtNumber"] = this.bbtNumber;
        data["rootingPercentage"] = this.rootingPercentage;
        data["bbx"] = this.bbx;
        data["observations"] = this.observations;
        data["bbT_Destination"] = this.bbT_Destination;
        data["bbX_Destination"] = this.bbX_Destination;
        data["bluP_Vol"] = this.bluP_Vol;
        data["err_Blup_Vol"] = this.err_Blup_Vol;
        data["acc_Blup_Vol"] = this.acc_Blup_Vol;
        data["model_Blup_Vol"] = this.model_Blup_Vol;
        data["gblup_Vol"] = this.gblup_Vol;
        data["err_Gblup_VOL"] = this.err_Gblup_VOL;
        data["acc_Gblup_Vol"] = this.acc_Gblup_Vol;
        data["model_Gblup_Vol"] = this.model_Gblup_Vol;
        data["hblup_Vol"] = this.hblup_Vol;
        data["err_Hblup_Vol"] = this.err_Hblup_Vol;
        data["acc_Hblup_Vol"] = this.acc_Hblup_Vol;
        data["model_Hblup_Vol"] = this.model_Hblup_Vol;
        data["blup_Rp"] = this.blup_Rp;
        data["err_Blup_Rp"] = this.err_Blup_Rp;
        data["acc_Blup_Rp"] = this.acc_Blup_Rp;
        data["model_Blup_Rp"] = this.model_Blup_Rp;
        data["gblup_Rp"] = this.gblup_Rp;
        data["err_Gblup_Rp"] = this.err_Gblup_Rp;
        data["acc_Gblup_Rp"] = this.acc_Gblup_Rp;
        data["model_Gblup_Rp"] = this.model_Gblup_Rp;
        data["hblup_Rp"] = this.hblup_Rp;
        data["err_Hblup_Rp"] = this.err_Hblup_Rp;
        data["acc_Hblup_Rp"] = this.acc_Hblup_Rp;
        data["model_Hblup_Rp"] = this.model_Hblup_Rp;
        data["blup_Db"] = this.blup_Db;
        data["err_Blup_Db"] = this.err_Blup_Db;
        data["acc_Blup_Db"] = this.acc_Blup_Db;
        data["model_Blup_Db"] = this.model_Blup_Db;
        data["gblup_Db"] = this.gblup_Db;
        data["err_Gblup_Db"] = this.err_Gblup_Db;
        data["acc_Gblup_Db"] = this.acc_Gblup_Db;
        data["model_Gblup_Db"] = this.model_Gblup_Db;
        data["hblup_Db"] = this.hblup_Db;
        data["err_Hblup_Db"] = this.err_Hblup_Db;
        data["acc_Hblup_Db"] = this.acc_Hblup_Db;
        data["model_Hblup_Db"] = this.model_Hblup_Db;
        data["seedlingDto"] = this.seedlingDto ? this.seedlingDto.toJSON() : undefined as any;
        data["seedlingId"] = this.seedlingId;
        data["projectId"] = this.projectId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementSelectionGenomicDto {
    bbt: string | undefined;
    bbtNumber: number;
    rootingPercentage: number | undefined;
    bbx: string | undefined;
    observations: string | undefined;
    bbT_Destination: string | undefined;
    bbX_Destination: string | undefined;
    bluP_Vol: number;
    err_Blup_Vol: number;
    acc_Blup_Vol: number;
    model_Blup_Vol: number;
    gblup_Vol: number;
    err_Gblup_VOL: number;
    acc_Gblup_Vol: number;
    model_Gblup_Vol: number;
    hblup_Vol: number;
    err_Hblup_Vol: number;
    acc_Hblup_Vol: number;
    model_Hblup_Vol: number;
    blup_Rp: number;
    err_Blup_Rp: number;
    acc_Blup_Rp: number;
    model_Blup_Rp: number;
    gblup_Rp: number;
    err_Gblup_Rp: number;
    acc_Gblup_Rp: number;
    model_Gblup_Rp: number;
    hblup_Rp: number;
    err_Hblup_Rp: number;
    acc_Hblup_Rp: number;
    model_Hblup_Rp: number;
    blup_Db: number;
    err_Blup_Db: number;
    acc_Blup_Db: number;
    model_Blup_Db: number;
    gblup_Db: number;
    err_Gblup_Db: number;
    acc_Gblup_Db: number;
    model_Gblup_Db: number;
    hblup_Db: number;
    err_Hblup_Db: number;
    acc_Hblup_Db: number;
    model_Hblup_Db: number;
    seedlingDto: SeedlingDto;
    seedlingId: number | undefined;
    projectId: number | undefined;
    id: number;
}

export class MeasurementSelectionGenomicProjectLookupTableDto implements IMeasurementSelectionGenomicProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionGenomicProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionGenomicProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionGenomicProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionGenomicProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelectionGenomicSeedlingLookupTableDto implements IMeasurementSelectionGenomicSeedlingLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionGenomicSeedlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionGenomicSeedlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionGenomicSeedlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionGenomicSeedlingLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelectionOtherProjectDto implements IMeasurementSelectionOtherProjectDto {
    proyecto!: string | undefined;
    subProyecto!: string | undefined;
    ano!: string | undefined;
    iD_Muestra!: string | undefined;
    n_muestra!: string | undefined;
    codigo_NIR!: string | undefined;
    material!: string | undefined;
    tipo_material!: string | undefined;
    zona_muestra!: string | undefined;
    mezcla!: string | undefined;
    calidad_muestra!: string | undefined;
    material_genetico!: string | undefined;
    nLote!: string | undefined;
    nx!: string | undefined;
    especie!: string | undefined;
    fecha_plantacion!: string | undefined;
    fecha_muestreo!: string | undefined;
    fecha_ingreso_lab!: string | undefined;
    fecha_egreso_lab!: string | undefined;
    edad!: string | undefined;
    altura_muestreo!: string | undefined;
    diametro!: string | undefined;
    altura_comercial!: string | undefined;
    altura_total!: string | undefined;
    region!: string | undefined;
    zona!: string | undefined;
    establecimiento!: string | undefined;
    cuadro!: string | undefined;
    coneat!: string | undefined;
    es_de_esnayo!: string | undefined;
    grupo_de_ensayo!: string | undefined;
    ensayo!: string | undefined;
    posicion!: string | undefined;
    bloque!: string | undefined;
    sub_bloque!: string | undefined;
    y!: string | undefined;
    arbol!: string | undefined;
    row!: string | undefined;
    col!: string | undefined;
    id_arbol!: string | undefined;
    id_Campo!: string | undefined;
    idfosa!: string | undefined;
    iD_Laboratorio_Externo!: string | undefined;
    destino!: string | undefined;
    observaciones_1!: string | undefined;
    observaciones_2!: string | undefined;
    observaciones_3!: string | undefined;
    laboratorio!: string | undefined;
    iD_Archivo!: string | undefined;
    deposito_Muestra_1_Caja_Archivo!: string | undefined;
    cajA_VIAL!: string | undefined;
    posicion_dentro_de_la_caja_de_vial!: string | undefined;
    deposito_Contramuestra!: string | undefined;
    rP_Lab!: string | undefined;
    dB_Lab_Kg_m3!: string | undefined;
    pilodyn_prom_cm!: string | undefined;
    alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood!: string | undefined;
    consumo_madera_m3_Adt!: string | undefined;
    productividad_Adt_ha_anio!: string | undefined;
    ashes!: string | undefined;
    acetone_extractives!: string | undefined;
    asl!: string | undefined;
    ail!: string | undefined;
    total_lignin!: string | undefined;
    arabinose!: string | undefined;
    galactose!: string | undefined;
    glucose!: string | undefined;
    xylose!: string | undefined;
    mannose!: string | undefined;
    cellulose!: string | undefined;
    xylan!: string | undefined;
    glucomannan!: string | undefined;
    others_pollysaccharide!: string | undefined;
    total_pollysaccharide!: string | undefined;
    al_mg_Kg_BS!: string | undefined;
    ba_mg_Kg_BS!: string | undefined;
    ca_mg_Kg_BS!: string | undefined;
    cu_mg_Kg_BS!: string | undefined;
    fe_mg_Kg_BS!: string | undefined;
    k_mg_Kg_BS!: string | undefined;
    mg_mg_Kg_BS!: string | undefined;
    mn_mg_Kg_BS!: string | undefined;
    na_mg_Kg_BS!: string | undefined;
    p_mg_Kg_BS!: string | undefined;
    s_mg_Kg_BS!: string | undefined;
    si_mg_Kg_BS!: string | undefined;
    dmc!: string | undefined;
    quimica_1!: string | undefined;
    quimica_2!: string | undefined;
    quimica_3!: string | undefined;
    quimica_4!: string | undefined;
    clorofila_CCL!: string | undefined;
    clorofila_mg_dm2!: string | undefined;
    clorofila_umd_m2!: string | undefined;
    materia_seca!: string | undefined;
    n_total!: string | undefined;
    p!: string | undefined;
    k!: string | undefined;
    ca!: string | undefined;
    mg!: string | undefined;
    s!: string | undefined;
    cl!: string | undefined;
    na_ppm!: string | undefined;
    he_ppm!: string | undefined;
    mn_ppm!: string | undefined;
    zn_ppm!: string | undefined;
    b_ppm!: string | undefined;
    cu_ppm!: string | undefined;
    al_ppm!: string | undefined;
    mo_ppm!: string | undefined;
    macronutriente_1!: string | undefined;
    macronutriente_2!: string | undefined;
    macronutriente_3!: string | undefined;
    micronutriente_1!: string | undefined;
    micronutriente_2!: string | undefined;
    micronutriente_3!: string | undefined;
    masa_g!: string | undefined;
    pbray_1_ppm_P!: string | undefined;
    m_Organica_pct!: string | undefined;
    c_Organico_pct!: string | undefined;
    gravilla_pct!: string | undefined;
    arcilla_pct!: string | undefined;
    limo_pct!: string | undefined;
    arena_pct!: string | undefined;
    pH_H2O!: string | undefined;
    pH_KCl!: string | undefined;
    cE_mmhos_cm!: string | undefined;
    n_pct!: string | undefined;
    n_NO3_ug_N_g!: string | undefined;
    s_SO4_ppm_S!: string | undefined;
    k_meqK_100g!: string | undefined;
    na_meqNa_100g!: string | undefined;
    mg_meqMg_100g!: string | undefined;
    ca_meqCa_100g!: string | undefined;
    a_tit_meq_100g!: string | undefined;
    ciC_meq_100g!: string | undefined;
    al_Interc_meqAl_100g!: string | undefined;
    fe_mg_kg!: string | undefined;
    cu_mg_kg!: string | undefined;
    mn_mg_kg!: string | undefined;
    zn_mg_kg!: string | undefined;
    pH_KCl_2!: string | undefined;
    boro_mg_kg!: string | undefined;
    citrico_ug_P_g!: string | undefined;
    sat_Bases_pct!: string | undefined;
    datoSuelo_1!: string | undefined;
    datoSuelo_2!: string | undefined;
    datoSuelo_3!: string | undefined;
    projectId!: number | undefined;
    cloneId!: number | undefined;
    seedId!: number | undefined;
    woodSampleTypeId!: number | undefined;
    id_Registro!: number;
    id!: number;

    constructor(data?: IMeasurementSelectionOtherProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proyecto = _data["proyecto"];
            this.subProyecto = _data["subProyecto"];
            this.ano = _data["ano"];
            this.iD_Muestra = _data["iD_Muestra"];
            this.n_muestra = _data["n_muestra"];
            this.codigo_NIR = _data["codigo_NIR"];
            this.material = _data["material"];
            this.tipo_material = _data["tipo_material"];
            this.zona_muestra = _data["zona_muestra"];
            this.mezcla = _data["mezcla"];
            this.calidad_muestra = _data["calidad_muestra"];
            this.material_genetico = _data["material_genetico"];
            this.nLote = _data["nLote"];
            this.nx = _data["nx"];
            this.especie = _data["especie"];
            this.fecha_plantacion = _data["fecha_plantacion"];
            this.fecha_muestreo = _data["fecha_muestreo"];
            this.fecha_ingreso_lab = _data["fecha_ingreso_lab"];
            this.fecha_egreso_lab = _data["fecha_egreso_lab"];
            this.edad = _data["edad"];
            this.altura_muestreo = _data["altura_muestreo"];
            this.diametro = _data["diametro"];
            this.altura_comercial = _data["altura_comercial"];
            this.altura_total = _data["altura_total"];
            this.region = _data["region"];
            this.zona = _data["zona"];
            this.establecimiento = _data["establecimiento"];
            this.cuadro = _data["cuadro"];
            this.coneat = _data["coneat"];
            this.es_de_esnayo = _data["es_de_esnayo"];
            this.grupo_de_ensayo = _data["grupo_de_ensayo"];
            this.ensayo = _data["ensayo"];
            this.posicion = _data["posicion"];
            this.bloque = _data["bloque"];
            this.sub_bloque = _data["sub_bloque"];
            this.y = _data["y"];
            this.arbol = _data["arbol"];
            this.row = _data["row"];
            this.col = _data["col"];
            this.id_arbol = _data["id_arbol"];
            this.id_Campo = _data["id_Campo"];
            this.idfosa = _data["idfosa"];
            this.iD_Laboratorio_Externo = _data["iD_Laboratorio_Externo"];
            this.destino = _data["destino"];
            this.observaciones_1 = _data["observaciones_1"];
            this.observaciones_2 = _data["observaciones_2"];
            this.observaciones_3 = _data["observaciones_3"];
            this.laboratorio = _data["laboratorio"];
            this.iD_Archivo = _data["iD_Archivo"];
            this.deposito_Muestra_1_Caja_Archivo = _data["deposito_Muestra_1_Caja_Archivo"];
            this.cajA_VIAL = _data["cajA_VIAL"];
            this.posicion_dentro_de_la_caja_de_vial = _data["posicion_dentro_de_la_caja_de_vial"];
            this.deposito_Contramuestra = _data["deposito_Contramuestra"];
            this.rP_Lab = _data["rP_Lab"];
            this.dB_Lab_Kg_m3 = _data["dB_Lab_Kg_m3"];
            this.pilodyn_prom_cm = _data["pilodyn_prom_cm"];
            this.alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood = _data["alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood"];
            this.consumo_madera_m3_Adt = _data["consumo_madera_m3_Adt"];
            this.productividad_Adt_ha_anio = _data["productividad_Adt_ha_anio"];
            this.ashes = _data["ashes"];
            this.acetone_extractives = _data["acetone_extractives"];
            this.asl = _data["asl"];
            this.ail = _data["ail"];
            this.total_lignin = _data["total_lignin"];
            this.arabinose = _data["arabinose"];
            this.galactose = _data["galactose"];
            this.glucose = _data["glucose"];
            this.xylose = _data["xylose"];
            this.mannose = _data["mannose"];
            this.cellulose = _data["cellulose"];
            this.xylan = _data["xylan"];
            this.glucomannan = _data["glucomannan"];
            this.others_pollysaccharide = _data["others_pollysaccharide"];
            this.total_pollysaccharide = _data["total_pollysaccharide"];
            this.al_mg_Kg_BS = _data["al_mg_Kg_BS"];
            this.ba_mg_Kg_BS = _data["ba_mg_Kg_BS"];
            this.ca_mg_Kg_BS = _data["ca_mg_Kg_BS"];
            this.cu_mg_Kg_BS = _data["cu_mg_Kg_BS"];
            this.fe_mg_Kg_BS = _data["fe_mg_Kg_BS"];
            this.k_mg_Kg_BS = _data["k_mg_Kg_BS"];
            this.mg_mg_Kg_BS = _data["mg_mg_Kg_BS"];
            this.mn_mg_Kg_BS = _data["mn_mg_Kg_BS"];
            this.na_mg_Kg_BS = _data["na_mg_Kg_BS"];
            this.p_mg_Kg_BS = _data["p_mg_Kg_BS"];
            this.s_mg_Kg_BS = _data["s_mg_Kg_BS"];
            this.si_mg_Kg_BS = _data["si_mg_Kg_BS"];
            this.dmc = _data["dmc"];
            this.quimica_1 = _data["quimica_1"];
            this.quimica_2 = _data["quimica_2"];
            this.quimica_3 = _data["quimica_3"];
            this.quimica_4 = _data["quimica_4"];
            this.clorofila_CCL = _data["clorofila_CCL"];
            this.clorofila_mg_dm2 = _data["clorofila_mg_dm2"];
            this.clorofila_umd_m2 = _data["clorofila_umd_m2"];
            this.materia_seca = _data["materia_seca"];
            this.n_total = _data["n_total"];
            this.p = _data["p"];
            this.k = _data["k"];
            this.ca = _data["ca"];
            this.mg = _data["mg"];
            this.s = _data["s"];
            this.cl = _data["cl"];
            this.na_ppm = _data["na_ppm"];
            this.he_ppm = _data["he_ppm"];
            this.mn_ppm = _data["mn_ppm"];
            this.zn_ppm = _data["zn_ppm"];
            this.b_ppm = _data["b_ppm"];
            this.cu_ppm = _data["cu_ppm"];
            this.al_ppm = _data["al_ppm"];
            this.mo_ppm = _data["mo_ppm"];
            this.macronutriente_1 = _data["macronutriente_1"];
            this.macronutriente_2 = _data["macronutriente_2"];
            this.macronutriente_3 = _data["macronutriente_3"];
            this.micronutriente_1 = _data["micronutriente_1"];
            this.micronutriente_2 = _data["micronutriente_2"];
            this.micronutriente_3 = _data["micronutriente_3"];
            this.masa_g = _data["masa_g"];
            this.pbray_1_ppm_P = _data["pbray_1_ppm_P"];
            this.m_Organica_pct = _data["m_Organica_pct"];
            this.c_Organico_pct = _data["c_Organico_pct"];
            this.gravilla_pct = _data["gravilla_pct"];
            this.arcilla_pct = _data["arcilla_pct"];
            this.limo_pct = _data["limo_pct"];
            this.arena_pct = _data["arena_pct"];
            this.pH_H2O = _data["pH_H2O"];
            this.pH_KCl = _data["pH_KCl"];
            this.cE_mmhos_cm = _data["cE_mmhos_cm"];
            this.n_pct = _data["n_pct"];
            this.n_NO3_ug_N_g = _data["n_NO3_ug_N_g"];
            this.s_SO4_ppm_S = _data["s_SO4_ppm_S"];
            this.k_meqK_100g = _data["k_meqK_100g"];
            this.na_meqNa_100g = _data["na_meqNa_100g"];
            this.mg_meqMg_100g = _data["mg_meqMg_100g"];
            this.ca_meqCa_100g = _data["ca_meqCa_100g"];
            this.a_tit_meq_100g = _data["a_tit_meq_100g"];
            this.ciC_meq_100g = _data["ciC_meq_100g"];
            this.al_Interc_meqAl_100g = _data["al_Interc_meqAl_100g"];
            this.fe_mg_kg = _data["fe_mg_kg"];
            this.cu_mg_kg = _data["cu_mg_kg"];
            this.mn_mg_kg = _data["mn_mg_kg"];
            this.zn_mg_kg = _data["zn_mg_kg"];
            this.pH_KCl_2 = _data["pH_KCl_2"];
            this.boro_mg_kg = _data["boro_mg_kg"];
            this.citrico_ug_P_g = _data["citrico_ug_P_g"];
            this.sat_Bases_pct = _data["sat_Bases_pct"];
            this.datoSuelo_1 = _data["datoSuelo_1"];
            this.datoSuelo_2 = _data["datoSuelo_2"];
            this.datoSuelo_3 = _data["datoSuelo_3"];
            this.projectId = _data["projectId"];
            this.cloneId = _data["cloneId"];
            this.seedId = _data["seedId"];
            this.woodSampleTypeId = _data["woodSampleTypeId"];
            this.id_Registro = _data["id_Registro"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasurementSelectionOtherProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionOtherProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proyecto"] = this.proyecto;
        data["subProyecto"] = this.subProyecto;
        data["ano"] = this.ano;
        data["iD_Muestra"] = this.iD_Muestra;
        data["n_muestra"] = this.n_muestra;
        data["codigo_NIR"] = this.codigo_NIR;
        data["material"] = this.material;
        data["tipo_material"] = this.tipo_material;
        data["zona_muestra"] = this.zona_muestra;
        data["mezcla"] = this.mezcla;
        data["calidad_muestra"] = this.calidad_muestra;
        data["material_genetico"] = this.material_genetico;
        data["nLote"] = this.nLote;
        data["nx"] = this.nx;
        data["especie"] = this.especie;
        data["fecha_plantacion"] = this.fecha_plantacion;
        data["fecha_muestreo"] = this.fecha_muestreo;
        data["fecha_ingreso_lab"] = this.fecha_ingreso_lab;
        data["fecha_egreso_lab"] = this.fecha_egreso_lab;
        data["edad"] = this.edad;
        data["altura_muestreo"] = this.altura_muestreo;
        data["diametro"] = this.diametro;
        data["altura_comercial"] = this.altura_comercial;
        data["altura_total"] = this.altura_total;
        data["region"] = this.region;
        data["zona"] = this.zona;
        data["establecimiento"] = this.establecimiento;
        data["cuadro"] = this.cuadro;
        data["coneat"] = this.coneat;
        data["es_de_esnayo"] = this.es_de_esnayo;
        data["grupo_de_ensayo"] = this.grupo_de_ensayo;
        data["ensayo"] = this.ensayo;
        data["posicion"] = this.posicion;
        data["bloque"] = this.bloque;
        data["sub_bloque"] = this.sub_bloque;
        data["y"] = this.y;
        data["arbol"] = this.arbol;
        data["row"] = this.row;
        data["col"] = this.col;
        data["id_arbol"] = this.id_arbol;
        data["id_Campo"] = this.id_Campo;
        data["idfosa"] = this.idfosa;
        data["iD_Laboratorio_Externo"] = this.iD_Laboratorio_Externo;
        data["destino"] = this.destino;
        data["observaciones_1"] = this.observaciones_1;
        data["observaciones_2"] = this.observaciones_2;
        data["observaciones_3"] = this.observaciones_3;
        data["laboratorio"] = this.laboratorio;
        data["iD_Archivo"] = this.iD_Archivo;
        data["deposito_Muestra_1_Caja_Archivo"] = this.deposito_Muestra_1_Caja_Archivo;
        data["cajA_VIAL"] = this.cajA_VIAL;
        data["posicion_dentro_de_la_caja_de_vial"] = this.posicion_dentro_de_la_caja_de_vial;
        data["deposito_Contramuestra"] = this.deposito_Contramuestra;
        data["rP_Lab"] = this.rP_Lab;
        data["dB_Lab_Kg_m3"] = this.dB_Lab_Kg_m3;
        data["pilodyn_prom_cm"] = this.pilodyn_prom_cm;
        data["alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood"] = this.alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood;
        data["consumo_madera_m3_Adt"] = this.consumo_madera_m3_Adt;
        data["productividad_Adt_ha_anio"] = this.productividad_Adt_ha_anio;
        data["ashes"] = this.ashes;
        data["acetone_extractives"] = this.acetone_extractives;
        data["asl"] = this.asl;
        data["ail"] = this.ail;
        data["total_lignin"] = this.total_lignin;
        data["arabinose"] = this.arabinose;
        data["galactose"] = this.galactose;
        data["glucose"] = this.glucose;
        data["xylose"] = this.xylose;
        data["mannose"] = this.mannose;
        data["cellulose"] = this.cellulose;
        data["xylan"] = this.xylan;
        data["glucomannan"] = this.glucomannan;
        data["others_pollysaccharide"] = this.others_pollysaccharide;
        data["total_pollysaccharide"] = this.total_pollysaccharide;
        data["al_mg_Kg_BS"] = this.al_mg_Kg_BS;
        data["ba_mg_Kg_BS"] = this.ba_mg_Kg_BS;
        data["ca_mg_Kg_BS"] = this.ca_mg_Kg_BS;
        data["cu_mg_Kg_BS"] = this.cu_mg_Kg_BS;
        data["fe_mg_Kg_BS"] = this.fe_mg_Kg_BS;
        data["k_mg_Kg_BS"] = this.k_mg_Kg_BS;
        data["mg_mg_Kg_BS"] = this.mg_mg_Kg_BS;
        data["mn_mg_Kg_BS"] = this.mn_mg_Kg_BS;
        data["na_mg_Kg_BS"] = this.na_mg_Kg_BS;
        data["p_mg_Kg_BS"] = this.p_mg_Kg_BS;
        data["s_mg_Kg_BS"] = this.s_mg_Kg_BS;
        data["si_mg_Kg_BS"] = this.si_mg_Kg_BS;
        data["dmc"] = this.dmc;
        data["quimica_1"] = this.quimica_1;
        data["quimica_2"] = this.quimica_2;
        data["quimica_3"] = this.quimica_3;
        data["quimica_4"] = this.quimica_4;
        data["clorofila_CCL"] = this.clorofila_CCL;
        data["clorofila_mg_dm2"] = this.clorofila_mg_dm2;
        data["clorofila_umd_m2"] = this.clorofila_umd_m2;
        data["materia_seca"] = this.materia_seca;
        data["n_total"] = this.n_total;
        data["p"] = this.p;
        data["k"] = this.k;
        data["ca"] = this.ca;
        data["mg"] = this.mg;
        data["s"] = this.s;
        data["cl"] = this.cl;
        data["na_ppm"] = this.na_ppm;
        data["he_ppm"] = this.he_ppm;
        data["mn_ppm"] = this.mn_ppm;
        data["zn_ppm"] = this.zn_ppm;
        data["b_ppm"] = this.b_ppm;
        data["cu_ppm"] = this.cu_ppm;
        data["al_ppm"] = this.al_ppm;
        data["mo_ppm"] = this.mo_ppm;
        data["macronutriente_1"] = this.macronutriente_1;
        data["macronutriente_2"] = this.macronutriente_2;
        data["macronutriente_3"] = this.macronutriente_3;
        data["micronutriente_1"] = this.micronutriente_1;
        data["micronutriente_2"] = this.micronutriente_2;
        data["micronutriente_3"] = this.micronutriente_3;
        data["masa_g"] = this.masa_g;
        data["pbray_1_ppm_P"] = this.pbray_1_ppm_P;
        data["m_Organica_pct"] = this.m_Organica_pct;
        data["c_Organico_pct"] = this.c_Organico_pct;
        data["gravilla_pct"] = this.gravilla_pct;
        data["arcilla_pct"] = this.arcilla_pct;
        data["limo_pct"] = this.limo_pct;
        data["arena_pct"] = this.arena_pct;
        data["pH_H2O"] = this.pH_H2O;
        data["pH_KCl"] = this.pH_KCl;
        data["cE_mmhos_cm"] = this.cE_mmhos_cm;
        data["n_pct"] = this.n_pct;
        data["n_NO3_ug_N_g"] = this.n_NO3_ug_N_g;
        data["s_SO4_ppm_S"] = this.s_SO4_ppm_S;
        data["k_meqK_100g"] = this.k_meqK_100g;
        data["na_meqNa_100g"] = this.na_meqNa_100g;
        data["mg_meqMg_100g"] = this.mg_meqMg_100g;
        data["ca_meqCa_100g"] = this.ca_meqCa_100g;
        data["a_tit_meq_100g"] = this.a_tit_meq_100g;
        data["ciC_meq_100g"] = this.ciC_meq_100g;
        data["al_Interc_meqAl_100g"] = this.al_Interc_meqAl_100g;
        data["fe_mg_kg"] = this.fe_mg_kg;
        data["cu_mg_kg"] = this.cu_mg_kg;
        data["mn_mg_kg"] = this.mn_mg_kg;
        data["zn_mg_kg"] = this.zn_mg_kg;
        data["pH_KCl_2"] = this.pH_KCl_2;
        data["boro_mg_kg"] = this.boro_mg_kg;
        data["citrico_ug_P_g"] = this.citrico_ug_P_g;
        data["sat_Bases_pct"] = this.sat_Bases_pct;
        data["datoSuelo_1"] = this.datoSuelo_1;
        data["datoSuelo_2"] = this.datoSuelo_2;
        data["datoSuelo_3"] = this.datoSuelo_3;
        data["projectId"] = this.projectId;
        data["cloneId"] = this.cloneId;
        data["seedId"] = this.seedId;
        data["woodSampleTypeId"] = this.woodSampleTypeId;
        data["id_Registro"] = this.id_Registro;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeasurementSelectionOtherProjectDto {
    proyecto: string | undefined;
    subProyecto: string | undefined;
    ano: string | undefined;
    iD_Muestra: string | undefined;
    n_muestra: string | undefined;
    codigo_NIR: string | undefined;
    material: string | undefined;
    tipo_material: string | undefined;
    zona_muestra: string | undefined;
    mezcla: string | undefined;
    calidad_muestra: string | undefined;
    material_genetico: string | undefined;
    nLote: string | undefined;
    nx: string | undefined;
    especie: string | undefined;
    fecha_plantacion: string | undefined;
    fecha_muestreo: string | undefined;
    fecha_ingreso_lab: string | undefined;
    fecha_egreso_lab: string | undefined;
    edad: string | undefined;
    altura_muestreo: string | undefined;
    diametro: string | undefined;
    altura_comercial: string | undefined;
    altura_total: string | undefined;
    region: string | undefined;
    zona: string | undefined;
    establecimiento: string | undefined;
    cuadro: string | undefined;
    coneat: string | undefined;
    es_de_esnayo: string | undefined;
    grupo_de_ensayo: string | undefined;
    ensayo: string | undefined;
    posicion: string | undefined;
    bloque: string | undefined;
    sub_bloque: string | undefined;
    y: string | undefined;
    arbol: string | undefined;
    row: string | undefined;
    col: string | undefined;
    id_arbol: string | undefined;
    id_Campo: string | undefined;
    idfosa: string | undefined;
    iD_Laboratorio_Externo: string | undefined;
    destino: string | undefined;
    observaciones_1: string | undefined;
    observaciones_2: string | undefined;
    observaciones_3: string | undefined;
    laboratorio: string | undefined;
    iD_Archivo: string | undefined;
    deposito_Muestra_1_Caja_Archivo: string | undefined;
    cajA_VIAL: string | undefined;
    posicion_dentro_de_la_caja_de_vial: string | undefined;
    deposito_Contramuestra: string | undefined;
    rP_Lab: string | undefined;
    dB_Lab_Kg_m3: string | undefined;
    pilodyn_prom_cm: string | undefined;
    alcali_Consumo_AE_pct_AE_kg_NaOH_kg_OD_wood: string | undefined;
    consumo_madera_m3_Adt: string | undefined;
    productividad_Adt_ha_anio: string | undefined;
    ashes: string | undefined;
    acetone_extractives: string | undefined;
    asl: string | undefined;
    ail: string | undefined;
    total_lignin: string | undefined;
    arabinose: string | undefined;
    galactose: string | undefined;
    glucose: string | undefined;
    xylose: string | undefined;
    mannose: string | undefined;
    cellulose: string | undefined;
    xylan: string | undefined;
    glucomannan: string | undefined;
    others_pollysaccharide: string | undefined;
    total_pollysaccharide: string | undefined;
    al_mg_Kg_BS: string | undefined;
    ba_mg_Kg_BS: string | undefined;
    ca_mg_Kg_BS: string | undefined;
    cu_mg_Kg_BS: string | undefined;
    fe_mg_Kg_BS: string | undefined;
    k_mg_Kg_BS: string | undefined;
    mg_mg_Kg_BS: string | undefined;
    mn_mg_Kg_BS: string | undefined;
    na_mg_Kg_BS: string | undefined;
    p_mg_Kg_BS: string | undefined;
    s_mg_Kg_BS: string | undefined;
    si_mg_Kg_BS: string | undefined;
    dmc: string | undefined;
    quimica_1: string | undefined;
    quimica_2: string | undefined;
    quimica_3: string | undefined;
    quimica_4: string | undefined;
    clorofila_CCL: string | undefined;
    clorofila_mg_dm2: string | undefined;
    clorofila_umd_m2: string | undefined;
    materia_seca: string | undefined;
    n_total: string | undefined;
    p: string | undefined;
    k: string | undefined;
    ca: string | undefined;
    mg: string | undefined;
    s: string | undefined;
    cl: string | undefined;
    na_ppm: string | undefined;
    he_ppm: string | undefined;
    mn_ppm: string | undefined;
    zn_ppm: string | undefined;
    b_ppm: string | undefined;
    cu_ppm: string | undefined;
    al_ppm: string | undefined;
    mo_ppm: string | undefined;
    macronutriente_1: string | undefined;
    macronutriente_2: string | undefined;
    macronutriente_3: string | undefined;
    micronutriente_1: string | undefined;
    micronutriente_2: string | undefined;
    micronutriente_3: string | undefined;
    masa_g: string | undefined;
    pbray_1_ppm_P: string | undefined;
    m_Organica_pct: string | undefined;
    c_Organico_pct: string | undefined;
    gravilla_pct: string | undefined;
    arcilla_pct: string | undefined;
    limo_pct: string | undefined;
    arena_pct: string | undefined;
    pH_H2O: string | undefined;
    pH_KCl: string | undefined;
    cE_mmhos_cm: string | undefined;
    n_pct: string | undefined;
    n_NO3_ug_N_g: string | undefined;
    s_SO4_ppm_S: string | undefined;
    k_meqK_100g: string | undefined;
    na_meqNa_100g: string | undefined;
    mg_meqMg_100g: string | undefined;
    ca_meqCa_100g: string | undefined;
    a_tit_meq_100g: string | undefined;
    ciC_meq_100g: string | undefined;
    al_Interc_meqAl_100g: string | undefined;
    fe_mg_kg: string | undefined;
    cu_mg_kg: string | undefined;
    mn_mg_kg: string | undefined;
    zn_mg_kg: string | undefined;
    pH_KCl_2: string | undefined;
    boro_mg_kg: string | undefined;
    citrico_ug_P_g: string | undefined;
    sat_Bases_pct: string | undefined;
    datoSuelo_1: string | undefined;
    datoSuelo_2: string | undefined;
    datoSuelo_3: string | undefined;
    projectId: number | undefined;
    cloneId: number | undefined;
    seedId: number | undefined;
    woodSampleTypeId: number | undefined;
    id_Registro: number;
    id: number;
}

export class MeasurementSelectionOtherProjectProjectLookupTableDto implements IMeasurementSelectionOtherProjectProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionOtherProjectProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionOtherProjectProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionOtherProjectProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionOtherProjectProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelectionProjectLookupTableDto implements IMeasurementSelectionProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelectionTreeLookupTableDto implements IMeasurementSelectionTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MeasurementSelectionWoodSampleTypeLookupTableDto implements IMeasurementSelectionWoodSampleTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeasurementSelectionWoodSampleTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeasurementSelectionWoodSampleTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSelectionWoodSampleTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeasurementSelectionWoodSampleTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class MemberInfo implements IMemberInfo {
    memberType!: MemberTypes;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (this as any).name = _data["name"];
            (this as any).declaringType = _data["declaringType"];
            (this as any).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export class MesurementCloneEvaluationDto implements IMesurementCloneEvaluationDto {
    bloque!: number | undefined;
    subbloque!: number | undefined;
    year!: number;
    fechaMuestreo!: DateTime;
    fechaPlantacion!: DateTime | undefined;
    edad!: number;
    dB_lab!: number | undefined;
    dB_10!: number | undefined;
    observacion!: string | undefined;
    codigo_Nir!: string | undefined;
    idLab!: string | undefined;
    dB_Modelo!: number | undefined;
    rP_Modelo!: number | undefined;
    pyrodin!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    lignina_FRB!: number | undefined;
    celulosa_FRB!: number | undefined;
    exT_AC_FRB!: number | undefined;
    consumo_AE!: number | undefined;
    ash!: number | undefined;
    extractives!: number | undefined;
    total_Lignin!: number | undefined;
    celullose!: number | undefined;
    glucomanan!: number | undefined;
    others!: number | undefined;
    ai!: number | undefined;
    ba!: number | undefined;
    ca!: number | undefined;
    cu!: number | undefined;
    fe!: number | undefined;
    k!: number | undefined;
    mg!: number | undefined;
    mn!: number | undefined;
    na!: number | undefined;
    p!: number | undefined;
    s!: number | undefined;
    si!: number | undefined;
    xylan!: number | undefined;
    sub_Proyecto!: string | undefined;
    typeMaterial!: string | undefined;
    projectId!: number;
    trialId!: number | undefined;
    treeId!: number | undefined;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    treeStatusId!: number | undefined;
    id!: number;

    constructor(data?: IMesurementCloneEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bloque = _data["bloque"];
            this.subbloque = _data["subbloque"];
            this.year = _data["year"];
            this.fechaMuestreo = _data["fechaMuestreo"] ? DateTime.fromISO(_data["fechaMuestreo"].toString()) : undefined as any;
            this.fechaPlantacion = _data["fechaPlantacion"] ? DateTime.fromISO(_data["fechaPlantacion"].toString()) : undefined as any;
            this.edad = _data["edad"];
            this.dB_lab = _data["dB_lab"];
            this.dB_10 = _data["dB_10"];
            this.observacion = _data["observacion"];
            this.codigo_Nir = _data["codigo_Nir"];
            this.idLab = _data["idLab"];
            this.dB_Modelo = _data["dB_Modelo"];
            this.rP_Modelo = _data["rP_Modelo"];
            this.pyrodin = _data["pyrodin"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.lignina_FRB = _data["lignina_FRB"];
            this.celulosa_FRB = _data["celulosa_FRB"];
            this.exT_AC_FRB = _data["exT_AC_FRB"];
            this.consumo_AE = _data["consumo_AE"];
            this.ash = _data["ash"];
            this.extractives = _data["extractives"];
            this.total_Lignin = _data["total_Lignin"];
            this.celullose = _data["celullose"];
            this.glucomanan = _data["glucomanan"];
            this.others = _data["others"];
            this.ai = _data["ai"];
            this.ba = _data["ba"];
            this.ca = _data["ca"];
            this.cu = _data["cu"];
            this.fe = _data["fe"];
            this.k = _data["k"];
            this.mg = _data["mg"];
            this.mn = _data["mn"];
            this.na = _data["na"];
            this.p = _data["p"];
            this.s = _data["s"];
            this.si = _data["si"];
            this.xylan = _data["xylan"];
            this.sub_Proyecto = _data["sub_Proyecto"];
            this.typeMaterial = _data["typeMaterial"];
            this.projectId = _data["projectId"];
            this.trialId = _data["trialId"];
            this.treeId = _data["treeId"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloque"] = this.bloque;
        data["subbloque"] = this.subbloque;
        data["year"] = this.year;
        data["fechaMuestreo"] = this.fechaMuestreo ? this.fechaMuestreo.toString() : undefined as any;
        data["fechaPlantacion"] = this.fechaPlantacion ? this.fechaPlantacion.toString() : undefined as any;
        data["edad"] = this.edad;
        data["dB_lab"] = this.dB_lab;
        data["dB_10"] = this.dB_10;
        data["observacion"] = this.observacion;
        data["codigo_Nir"] = this.codigo_Nir;
        data["idLab"] = this.idLab;
        data["dB_Modelo"] = this.dB_Modelo;
        data["rP_Modelo"] = this.rP_Modelo;
        data["pyrodin"] = this.pyrodin;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["lignina_FRB"] = this.lignina_FRB;
        data["celulosa_FRB"] = this.celulosa_FRB;
        data["exT_AC_FRB"] = this.exT_AC_FRB;
        data["consumo_AE"] = this.consumo_AE;
        data["ash"] = this.ash;
        data["extractives"] = this.extractives;
        data["total_Lignin"] = this.total_Lignin;
        data["celullose"] = this.celullose;
        data["glucomanan"] = this.glucomanan;
        data["others"] = this.others;
        data["ai"] = this.ai;
        data["ba"] = this.ba;
        data["ca"] = this.ca;
        data["cu"] = this.cu;
        data["fe"] = this.fe;
        data["k"] = this.k;
        data["mg"] = this.mg;
        data["mn"] = this.mn;
        data["na"] = this.na;
        data["p"] = this.p;
        data["s"] = this.s;
        data["si"] = this.si;
        data["xylan"] = this.xylan;
        data["sub_Proyecto"] = this.sub_Proyecto;
        data["typeMaterial"] = this.typeMaterial;
        data["projectId"] = this.projectId;
        data["trialId"] = this.trialId;
        data["treeId"] = this.treeId;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMesurementCloneEvaluationDto {
    bloque: number | undefined;
    subbloque: number | undefined;
    year: number;
    fechaMuestreo: DateTime;
    fechaPlantacion: DateTime | undefined;
    edad: number;
    dB_lab: number | undefined;
    dB_10: number | undefined;
    observacion: string | undefined;
    codigo_Nir: string | undefined;
    idLab: string | undefined;
    dB_Modelo: number | undefined;
    rP_Modelo: number | undefined;
    pyrodin: number | undefined;
    rP_Lab_FRB: number | undefined;
    lignina_FRB: number | undefined;
    celulosa_FRB: number | undefined;
    exT_AC_FRB: number | undefined;
    consumo_AE: number | undefined;
    ash: number | undefined;
    extractives: number | undefined;
    total_Lignin: number | undefined;
    celullose: number | undefined;
    glucomanan: number | undefined;
    others: number | undefined;
    ai: number | undefined;
    ba: number | undefined;
    ca: number | undefined;
    cu: number | undefined;
    fe: number | undefined;
    k: number | undefined;
    mg: number | undefined;
    mn: number | undefined;
    na: number | undefined;
    p: number | undefined;
    s: number | undefined;
    si: number | undefined;
    xylan: number | undefined;
    sub_Proyecto: string | undefined;
    typeMaterial: string | undefined;
    projectId: number;
    trialId: number | undefined;
    treeId: number | undefined;
    seedId: number | undefined;
    cloneId: number | undefined;
    treeStatusId: number | undefined;
    id: number;
}

export class MesurementCloneEvaluationProjectLookupTableDto implements IMesurementCloneEvaluationProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMesurementCloneEvaluationProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMesurementCloneEvaluationProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MesurementCloneEvaluationSeedLookupTableDto implements IMesurementCloneEvaluationSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMesurementCloneEvaluationSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMesurementCloneEvaluationSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MesurementCloneEvaluationTreeLookupTableDto implements IMesurementCloneEvaluationTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMesurementCloneEvaluationTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMesurementCloneEvaluationTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MesurementCloneEvaluationTreeStatusLookupTableDto implements IMesurementCloneEvaluationTreeStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMesurementCloneEvaluationTreeStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationTreeStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationTreeStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMesurementCloneEvaluationTreeStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MesurementCloneEvaluationTrialLookupTableDto implements IMesurementCloneEvaluationTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMesurementCloneEvaluationTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MesurementCloneEvaluationTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MesurementCloneEvaluationTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMesurementCloneEvaluationTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 1,
    Private = 2,
    FamANDAssem = 3,
    Assembly = 4,
    Family = 5,
    FamORAssem = 6,
    Public = 7,
    MemberAccessMask = 8,
    UnmanagedExport = 16,
    Static = 32,
    Final = 64,
    Virtual = 128,
    HideBySig = 256,
    NewSlot = 512,
    VtableLayoutMask = 1024,
    CheckAccessOnOverride = 2048,
    Abstract = 4096,
    SpecialName = 8192,
    RTSpecialName = 16384,
    PinvokeImpl = 32768,
    HasSecurity = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 1,
    Native = 2,
    OPTIL = 3,
    CodeTypeMask = 4,
    Runtime = 8,
    ManagedMask = 16,
    Unmanaged = 32,
    NoInlining = 64,
    ForwardRef = 128,
    Synchronized = 256,
    NoOptimization = 512,
    PreserveSig = 4096,
    AggressiveInlining = 8192,
    AggressiveOptimization = 65535,
}

export class MethodInfo implements IMethodInfo {
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    readonly returnType!: string | undefined;
    returnTypeCustomAttributes!: ICustomAttributeProvider;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : undefined as any;
            (this as any).returnType = _data["returnType"];
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : undefined as any;
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isConstructor = _data["isConstructor"];
            (this as any).isFinal = _data["isFinal"];
            (this as any).isHideBySig = _data["isHideBySig"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isVirtual = _data["isVirtual"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (this as any).isGenericMethod = _data["isGenericMethod"];
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            (this as any).name = _data["name"];
            (this as any).declaringType = _data["declaringType"];
            (this as any).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined as any;
        data["returnType"] = this.returnType;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : undefined as any;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined as any;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMethodInfo {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string | undefined;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class MiniGardenMapConstantsDto implements IMiniGardenMapConstantsDto {
    filterTypes!: FilterTypesDto;
    originTypes!: OriginTypesDto;
    canaletonViews!: CanaletonViewsDto;
    exportTypes!: ExportTypesDto;

    constructor(data?: IMiniGardenMapConstantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterTypes = _data["filterTypes"] ? FilterTypesDto.fromJS(_data["filterTypes"]) : undefined as any;
            this.originTypes = _data["originTypes"] ? OriginTypesDto.fromJS(_data["originTypes"]) : undefined as any;
            this.canaletonViews = _data["canaletonViews"] ? CanaletonViewsDto.fromJS(_data["canaletonViews"]) : undefined as any;
            this.exportTypes = _data["exportTypes"] ? ExportTypesDto.fromJS(_data["exportTypes"]) : undefined as any;
        }
    }

    static fromJS(data: any): MiniGardenMapConstantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MiniGardenMapConstantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterTypes"] = this.filterTypes ? this.filterTypes.toJSON() : undefined as any;
        data["originTypes"] = this.originTypes ? this.originTypes.toJSON() : undefined as any;
        data["canaletonViews"] = this.canaletonViews ? this.canaletonViews.toJSON() : undefined as any;
        data["exportTypes"] = this.exportTypes ? this.exportTypes.toJSON() : undefined as any;
        return data;
    }
}

export interface IMiniGardenMapConstantsDto {
    filterTypes: FilterTypesDto;
    originTypes: OriginTypesDto;
    canaletonViews: CanaletonViewsDto;
    exportTypes: ExportTypesDto;
}

export class MiniGardenMapDataDto implements IMiniGardenMapDataDto {
    canaletones!: CanaletonMapDto[] | undefined;
    speciesColorMapping!: SpeciesColorMappingDto[] | undefined;
    constants!: MiniGardenMapConstantsDto;

    constructor(data?: IMiniGardenMapDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["canaletones"])) {
                this.canaletones = [] as any;
                for (let item of _data["canaletones"])
                    this.canaletones!.push(CanaletonMapDto.fromJS(item));
            }
            if (Array.isArray(_data["speciesColorMapping"])) {
                this.speciesColorMapping = [] as any;
                for (let item of _data["speciesColorMapping"])
                    this.speciesColorMapping!.push(SpeciesColorMappingDto.fromJS(item));
            }
            this.constants = _data["constants"] ? MiniGardenMapConstantsDto.fromJS(_data["constants"]) : undefined as any;
        }
    }

    static fromJS(data: any): MiniGardenMapDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MiniGardenMapDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.canaletones)) {
            data["canaletones"] = [];
            for (let item of this.canaletones)
                data["canaletones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.speciesColorMapping)) {
            data["speciesColorMapping"] = [];
            for (let item of this.speciesColorMapping)
                data["speciesColorMapping"].push(item ? item.toJSON() : undefined as any);
        }
        data["constants"] = this.constants ? this.constants.toJSON() : undefined as any;
        return data;
    }
}

export interface IMiniGardenMapDataDto {
    canaletones: CanaletonMapDto[] | undefined;
    speciesColorMapping: SpeciesColorMappingDto[] | undefined;
    constants: MiniGardenMapConstantsDto;
}

export class Module implements IModule {
    assembly!: Assembly;
    readonly fullyQualifiedName!: string | undefined;
    readonly name!: string | undefined;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | undefined;
    moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            (this as any).fullyQualifiedName = _data["fullyQualifiedName"];
            (this as any).name = _data["name"];
            (this as any).mdStreamVersion = _data["mdStreamVersion"];
            (this as any).moduleVersionId = _data["moduleVersionId"];
            (this as any).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OriginTypesDto implements IOriginTypesDto {
    genomicSelection!: string | undefined;
    imported!: string | undefined;

    constructor(data?: IOriginTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genomicSelection = _data["genomicSelection"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): OriginTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OriginTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genomicSelection"] = this.genomicSelection;
        data["imported"] = this.imported;
        return data;
    }
}

export interface IOriginTypesDto {
    genomicSelection: string | undefined;
    imported: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfCloneLookupTableDto implements IPagedResultDtoOfCloneLookupTableDto {
    totalCount!: number;
    items!: CloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCloneLookupTableDto {
    totalCount: number;
    items: CloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfCloneMeasurementSelectionKPIDto implements IPagedResultDtoOfCloneMeasurementSelectionKPIDto {
    totalCount!: number;
    items!: CloneMeasurementSelectionKPIDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCloneMeasurementSelectionKPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CloneMeasurementSelectionKPIDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCloneMeasurementSelectionKPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCloneMeasurementSelectionKPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCloneMeasurementSelectionKPIDto {
    totalCount: number;
    items: CloneMeasurementSelectionKPIDto[] | undefined;
}

export class PagedResultDtoOfCloneMeasurementSelectionLookupTableDto implements IPagedResultDtoOfCloneMeasurementSelectionLookupTableDto {
    totalCount!: number;
    items!: CloneMeasurementSelectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCloneMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CloneMeasurementSelectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCloneMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCloneMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCloneMeasurementSelectionLookupTableDto {
    totalCount: number;
    items: CloneMeasurementSelectionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfCloneTreeLookupTableDto implements IPagedResultDtoOfCloneTreeLookupTableDto {
    totalCount!: number;
    items!: CloneTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCloneTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CloneTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCloneTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCloneTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCloneTreeLookupTableDto {
    totalCount: number;
    items: CloneTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfControlledCrossingPolenLookupTableDto implements IPagedResultDtoOfControlledCrossingPolenLookupTableDto {
    totalCount!: number;
    items!: ControlledCrossingPolenLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfControlledCrossingPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ControlledCrossingPolenLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfControlledCrossingPolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfControlledCrossingPolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfControlledCrossingPolenLookupTableDto {
    totalCount: number;
    items: ControlledCrossingPolenLookupTableDto[] | undefined;
}

export class PagedResultDtoOfControlledCrossingSeedLookupTableDto implements IPagedResultDtoOfControlledCrossingSeedLookupTableDto {
    totalCount!: number;
    items!: ControlledCrossingSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfControlledCrossingSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ControlledCrossingSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfControlledCrossingSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfControlledCrossingSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfControlledCrossingSeedLookupTableDto {
    totalCount: number;
    items: ControlledCrossingSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfControlledCrossingTreeLookupTableDto implements IPagedResultDtoOfControlledCrossingTreeLookupTableDto {
    totalCount!: number;
    items!: ControlledCrossingTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfControlledCrossingTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ControlledCrossingTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfControlledCrossingTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfControlledCrossingTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfControlledCrossingTreeLookupTableDto {
    totalCount: number;
    items: ControlledCrossingTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfControlledCrossingTrialLookupTableDto implements IPagedResultDtoOfControlledCrossingTrialLookupTableDto {
    totalCount!: number;
    items!: ControlledCrossingTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfControlledCrossingTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ControlledCrossingTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfControlledCrossingTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfControlledCrossingTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfControlledCrossingTrialLookupTableDto {
    totalCount: number;
    items: ControlledCrossingTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfGeneticLookupTableResponseDto implements IPagedResultDtoOfGeneticLookupTableResponseDto {
    totalCount!: number;
    items!: GeneticLookupTableResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGeneticLookupTableResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GeneticLookupTableResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGeneticLookupTableResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGeneticLookupTableResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGeneticLookupTableResponseDto {
    totalCount: number;
    items: GeneticLookupTableResponseDto[] | undefined;
}

export class PagedResultDtoOfGenomicSeleccionProjectLookupTableDto implements IPagedResultDtoOfGenomicSeleccionProjectLookupTableDto {
    totalCount!: number;
    items!: GenomicSeleccionProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGenomicSeleccionProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GenomicSeleccionProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGenomicSeleccionProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGenomicSeleccionProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGenomicSeleccionProjectLookupTableDto {
    totalCount: number;
    items: GenomicSeleccionProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto implements IPagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto {
    totalCount!: number;
    items!: GenomicSeleccionSeedlingLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GenomicSeleccionSeedlingLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGenomicSeleccionSeedlingLookupTableDto {
    totalCount: number;
    items: GenomicSeleccionSeedlingLookupTableDto[] | undefined;
}

export class PagedResultDtoOfGetAdultObservationCodeForViewDto implements IPagedResultDtoOfGetAdultObservationCodeForViewDto {
    totalCount!: number;
    items!: GetAdultObservationCodeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdultObservationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdultObservationCodeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdultObservationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdultObservationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdultObservationCodeForViewDto {
    totalCount: number;
    items: GetAdultObservationCodeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetAllLevelInfestationResponseDto implements IPagedResultDtoOfGetAllLevelInfestationResponseDto {
    totalCount!: number;
    items!: GetAllLevelInfestationResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllLevelInfestationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllLevelInfestationResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllLevelInfestationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllLevelInfestationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllLevelInfestationResponseDto {
    totalCount: number;
    items: GetAllLevelInfestationResponseDto[] | undefined;
}

export class PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto implements IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto {
    totalCount!: number;
    items!: GetAllMeasurementPlaningOptionsTreatmentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllMeasurementPlaningOptionsTreatmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreatmentDto {
    totalCount: number;
    items: GetAllMeasurementPlaningOptionsTreatmentDto[] | undefined;
}

export class PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto implements IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto {
    totalCount!: number;
    items!: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllMeasurementPlaningOptionsTreeNumberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllMeasurementPlaningOptionsTreeNumberDto {
    totalCount: number;
    items: GetAllMeasurementPlaningOptionsTreeNumberDto[] | undefined;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount!: number;
    items!: GetAllSendAttemptsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount: number;
    items: GetAllSendAttemptsOutput[] | undefined;
}

export class PagedResultDtoOfGetAllSilvicultureTrialFilesDto implements IPagedResultDtoOfGetAllSilvicultureTrialFilesDto {
    totalCount!: number;
    items!: GetAllSilvicultureTrialFilesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSilvicultureTrialFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSilvicultureTrialFilesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSilvicultureTrialFilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSilvicultureTrialFilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSilvicultureTrialFilesDto {
    totalCount: number;
    items: GetAllSilvicultureTrialFilesDto[] | undefined;
}

export class PagedResultDtoOfGetBBXDestinationForViewDto implements IPagedResultDtoOfGetBBXDestinationForViewDto {
    totalCount!: number;
    items!: GetBBXDestinationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBBXDestinationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBBXDestinationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBBXDestinationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBBXDestinationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBBXDestinationForViewDto {
    totalCount: number;
    items: GetBBXDestinationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBBXManagementForViewDto implements IPagedResultDtoOfGetBBXManagementForViewDto {
    totalCount!: number;
    items!: GetBBXManagementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBBXManagementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBBXManagementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBBXManagementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBBXManagementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBBXManagementForViewDto {
    totalCount: number;
    items: GetBBXManagementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBBXManagementForViewEditDto implements IPagedResultDtoOfGetBBXManagementForViewEditDto {
    totalCount!: number;
    items!: GetBBXManagementForViewEditDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBBXManagementForViewEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBBXManagementForViewEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBBXManagementForViewEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBBXManagementForViewEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBBXManagementForViewEditDto {
    totalCount: number;
    items: GetBBXManagementForViewEditDto[] | undefined;
}

export class PagedResultDtoOfGetCanaletonPlantationForViewDto implements IPagedResultDtoOfGetCanaletonPlantationForViewDto {
    totalCount!: number;
    items!: GetCanaletonPlantationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCanaletonPlantationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCanaletonPlantationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCanaletonPlantationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCanaletonPlantationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCanaletonPlantationForViewDto {
    totalCount: number;
    items: GetCanaletonPlantationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCategorySeedOriginForViewDto implements IPagedResultDtoOfGetCategorySeedOriginForViewDto {
    totalCount!: number;
    items!: GetCategorySeedOriginForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCategorySeedOriginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCategorySeedOriginForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCategorySeedOriginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCategorySeedOriginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCategorySeedOriginForViewDto {
    totalCount: number;
    items: GetCategorySeedOriginForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCategoryTrialForViewDto implements IPagedResultDtoOfGetCategoryTrialForViewDto {
    totalCount!: number;
    items!: GetCategoryTrialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCategoryTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCategoryTrialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCategoryTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCategoryTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCategoryTrialForViewDto {
    totalCount: number;
    items: GetCategoryTrialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCloneForViewDto implements IPagedResultDtoOfGetCloneForViewDto {
    totalCount!: number;
    items!: GetCloneForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCloneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCloneForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCloneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCloneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCloneForViewDto {
    totalCount: number;
    items: GetCloneForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCloneStatusForViewDto implements IPagedResultDtoOfGetCloneStatusForViewDto {
    totalCount!: number;
    items!: GetCloneStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCloneStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCloneStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCloneStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCloneStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCloneStatusForViewDto {
    totalCount: number;
    items: GetCloneStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetControlledCrossingForViewDto implements IPagedResultDtoOfGetControlledCrossingForViewDto {
    totalCount!: number;
    items!: GetControlledCrossingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetControlledCrossingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetControlledCrossingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetControlledCrossingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetControlledCrossingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetControlledCrossingForViewDto {
    totalCount: number;
    items: GetControlledCrossingForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCrossingTechniqueForViewDto implements IPagedResultDtoOfGetCrossingTechniqueForViewDto {
    totalCount!: number;
    items!: GetCrossingTechniqueForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCrossingTechniqueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCrossingTechniqueForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCrossingTechniqueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCrossingTechniqueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCrossingTechniqueForViewDto {
    totalCount: number;
    items: GetCrossingTechniqueForViewDto[] | undefined;
}

export class PagedResultDtoOfGetDestinoBBXForViewDto implements IPagedResultDtoOfGetDestinoBBXForViewDto {
    totalCount!: number;
    items!: GetDestinoBBXForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDestinoBBXForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDestinoBBXForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDestinoBBXForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDestinoBBXForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDestinoBBXForViewDto {
    totalCount: number;
    items: GetDestinoBBXForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentCategoryForViewDto implements IPagedResultDtoOfGetExperimentCategoryForViewDto {
    totalCount!: number;
    items!: GetExperimentCategoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentCategoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentCategoryForViewDto {
    totalCount: number;
    items: GetExperimentCategoryForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentClasificationtwoForViewDto implements IPagedResultDtoOfGetExperimentClasificationtwoForViewDto {
    totalCount!: number;
    items!: GetExperimentClasificationtwoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentClasificationtwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentClasificationtwoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentClasificationtwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentClasificationtwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentClasificationtwoForViewDto {
    totalCount: number;
    items: GetExperimentClasificationtwoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentClassificationForViewDto implements IPagedResultDtoOfGetExperimentClassificationForViewDto {
    totalCount!: number;
    items!: GetExperimentClassificationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentClassificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentClassificationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentClassificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentClassificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentClassificationForViewDto {
    totalCount: number;
    items: GetExperimentClassificationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentLocationForViewDto implements IPagedResultDtoOfGetExperimentLocationForViewDto {
    totalCount!: number;
    items!: GetExperimentLocationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentLocationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentLocationForViewDto {
    totalCount: number;
    items: GetExperimentLocationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentSpecieForViewDto implements IPagedResultDtoOfGetExperimentSpecieForViewDto {
    totalCount!: number;
    items!: GetExperimentSpecieForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentSpecieForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentSpecieForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentSpecieForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentSpecieForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentSpecieForViewDto {
    totalCount: number;
    items: GetExperimentSpecieForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentSpecieQuantityForViewDto implements IPagedResultDtoOfGetExperimentSpecieQuantityForViewDto {
    totalCount!: number;
    items!: GetExperimentSpecieQuantityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentSpecieQuantityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentSpecieQuantityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentSpecieQuantityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentSpecieQuantityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentSpecieQuantityForViewDto {
    totalCount: number;
    items: GetExperimentSpecieQuantityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentStigmaForViewDto implements IPagedResultDtoOfGetExperimentStigmaForViewDto {
    totalCount!: number;
    items!: GetExperimentStigmaForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentStigmaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentStigmaForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentStigmaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentStigmaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentStigmaForViewDto {
    totalCount: number;
    items: GetExperimentStigmaForViewDto[] | undefined;
}

export class PagedResultDtoOfGetExperimentTypeForViewDto implements IPagedResultDtoOfGetExperimentTypeForViewDto {
    totalCount!: number;
    items!: GetExperimentTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExperimentTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExperimentTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExperimentTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExperimentTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExperimentTypeForViewDto {
    totalCount: number;
    items: GetExperimentTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFileForViewDto implements IPagedResultDtoOfGetFileForViewDto {
    totalCount!: number;
    items!: GetFileForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFileForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFileForViewDto {
    totalCount: number;
    items: GetFileForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFrostToleranceForViewDto implements IPagedResultDtoOfGetFrostToleranceForViewDto {
    totalCount!: number;
    items!: GetFrostToleranceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFrostToleranceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFrostToleranceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFrostToleranceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFrostToleranceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFrostToleranceForViewDto {
    totalCount: number;
    items: GetFrostToleranceForViewDto[] | undefined;
}

export class PagedResultDtoOfGetGenericFilterDto implements IPagedResultDtoOfGetGenericFilterDto {
    totalCount!: number;
    items!: GetGenericFilterDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGenericFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGenericFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGenericFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGenericFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGenericFilterDto {
    totalCount: number;
    items: GetGenericFilterDto[] | undefined;
}

export class PagedResultDtoOfGetGenomicSeleccionForViewDto implements IPagedResultDtoOfGetGenomicSeleccionForViewDto {
    totalCount!: number;
    items!: GetGenomicSeleccionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGenomicSeleccionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGenomicSeleccionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGenomicSeleccionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGenomicSeleccionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGenomicSeleccionForViewDto {
    totalCount: number;
    items: GetGenomicSeleccionForViewDto[] | undefined;
}

export class PagedResultDtoOfGetGroupTrialForViewDto implements IPagedResultDtoOfGetGroupTrialForViewDto {
    totalCount!: number;
    items!: GetGroupTrialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGroupTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGroupTrialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGroupTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGroupTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGroupTrialForViewDto {
    totalCount: number;
    items: GetGroupTrialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetHealthDoseForViewDto implements IPagedResultDtoOfGetHealthDoseForViewDto {
    totalCount!: number;
    items!: GetHealthDoseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHealthDoseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHealthDoseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHealthDoseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHealthDoseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHealthDoseForViewDto {
    totalCount: number;
    items: GetHealthDoseForViewDto[] | undefined;
}

export class PagedResultDtoOfGetHealthcareFormulaDto implements IPagedResultDtoOfGetHealthcareFormulaDto {
    totalCount!: number;
    items!: GetHealthcareFormulaDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHealthcareFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHealthcareFormulaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHealthcareFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHealthcareFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHealthcareFormulaDto {
    totalCount: number;
    items: GetHealthcareFormulaDto[] | undefined;
}

export class PagedResultDtoOfGetHealthcareMastersDto implements IPagedResultDtoOfGetHealthcareMastersDto {
    totalCount!: number;
    items!: GetHealthcareMastersDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHealthcareMastersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHealthcareMastersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHealthcareMastersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHealthcareMastersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHealthcareMastersDto {
    totalCount: number;
    items: GetHealthcareMastersDto[] | undefined;
}

export class PagedResultDtoOfGetHealthcareProductDto implements IPagedResultDtoOfGetHealthcareProductDto {
    totalCount!: number;
    items!: GetHealthcareProductDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHealthcareProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHealthcareProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHealthcareProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHealthcareProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHealthcareProductDto {
    totalCount: number;
    items: GetHealthcareProductDto[] | undefined;
}

export class PagedResultDtoOfGetInterventionFoundationsOneForViewDto implements IPagedResultDtoOfGetInterventionFoundationsOneForViewDto {
    totalCount!: number;
    items!: GetInterventionFoundationsOneForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInterventionFoundationsOneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetInterventionFoundationsOneForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInterventionFoundationsOneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInterventionFoundationsOneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetInterventionFoundationsOneForViewDto {
    totalCount: number;
    items: GetInterventionFoundationsOneForViewDto[] | undefined;
}

export class PagedResultDtoOfGetInterventionFoundationsThreeForViewDto implements IPagedResultDtoOfGetInterventionFoundationsThreeForViewDto {
    totalCount!: number;
    items!: GetInterventionFoundationsThreeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInterventionFoundationsThreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetInterventionFoundationsThreeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInterventionFoundationsThreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInterventionFoundationsThreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetInterventionFoundationsThreeForViewDto {
    totalCount: number;
    items: GetInterventionFoundationsThreeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetInterventionFoundationsTwoForViewDto implements IPagedResultDtoOfGetInterventionFoundationsTwoForViewDto {
    totalCount!: number;
    items!: GetInterventionFoundationsTwoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInterventionFoundationsTwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetInterventionFoundationsTwoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInterventionFoundationsTwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInterventionFoundationsTwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetInterventionFoundationsTwoForViewDto {
    totalCount: number;
    items: GetInterventionFoundationsTwoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetLaboratoryProjectForViewDto implements IPagedResultDtoOfGetLaboratoryProjectForViewDto {
    totalCount!: number;
    items!: GetLaboratoryProjectForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLaboratoryProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLaboratoryProjectForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLaboratoryProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLaboratoryProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLaboratoryProjectForViewDto {
    totalCount: number;
    items: GetLaboratoryProjectForViewDto[] | undefined;
}

export class PagedResultDtoOfGetLaboratoryProjectStatusForViewDto implements IPagedResultDtoOfGetLaboratoryProjectStatusForViewDto {
    totalCount!: number;
    items!: GetLaboratoryProjectStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLaboratoryProjectStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLaboratoryProjectStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLaboratoryProjectStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLaboratoryProjectStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLaboratoryProjectStatusForViewDto {
    totalCount: number;
    items: GetLaboratoryProjectStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementPlaningForViewDto implements IPagedResultDtoOfGetMeasurementPlaningForViewDto {
    totalCount!: number;
    items!: GetMeasurementPlaningForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementPlaningForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementPlaningForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementPlaningForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementPlaningForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementPlaningForViewDto {
    totalCount: number;
    items: GetMeasurementPlaningForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto implements IPagedResultDtoOfGetMeasurementPlaningOptionsForViewDto {
    totalCount!: number;
    items!: GetMeasurementPlaningOptionsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementPlaningOptionsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementPlaningOptionsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementPlaningOptionsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementPlaningOptionsForViewDto {
    totalCount: number;
    items: GetMeasurementPlaningOptionsForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto implements IPagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto {
    totalCount!: number;
    items!: GetMeasurementPlaningTreatmentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementPlaningTreatmentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementPlaningTreatmentForViewDto {
    totalCount: number;
    items: GetMeasurementPlaningTreatmentForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto implements IPagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto {
    totalCount!: number;
    items!: GetMeasurementPlaningTreeHeightNumberForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementPlaningTreeHeightNumberForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementPlaningTreeHeightNumberForViewDto {
    totalCount: number;
    items: GetMeasurementPlaningTreeHeightNumberForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto implements IPagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto {
    totalCount!: number;
    items!: GetMeasurementPlaningTreeNumberForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementPlaningTreeNumberForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementPlaningTreeNumberForViewDto {
    totalCount: number;
    items: GetMeasurementPlaningTreeNumberForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementSelectionForViewDto implements IPagedResultDtoOfGetMeasurementSelectionForViewDto {
    totalCount!: number;
    items!: GetMeasurementSelectionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementSelectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementSelectionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementSelectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementSelectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementSelectionForViewDto {
    totalCount: number;
    items: GetMeasurementSelectionForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto implements IPagedResultDtoOfGetMeasurementSelectionGenomicForViewDto {
    totalCount!: number;
    items!: GetMeasurementSelectionGenomicForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementSelectionGenomicForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementSelectionGenomicForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementSelectionGenomicForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementSelectionGenomicForViewDto {
    totalCount: number;
    items: GetMeasurementSelectionGenomicForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto implements IPagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto {
    totalCount!: number;
    items!: GetMeasurementSelectionOtherProjectForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeasurementSelectionOtherProjectForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMeasurementSelectionOtherProjectForViewDto {
    totalCount: number;
    items: GetMeasurementSelectionOtherProjectForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMesurementCloneEvaluationForViewDto implements IPagedResultDtoOfGetMesurementCloneEvaluationForViewDto {
    totalCount!: number;
    items!: GetMesurementCloneEvaluationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMesurementCloneEvaluationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMesurementCloneEvaluationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMesurementCloneEvaluationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMesurementCloneEvaluationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMesurementCloneEvaluationForViewDto {
    totalCount: number;
    items: GetMesurementCloneEvaluationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetParameterForViewDto implements IPagedResultDtoOfGetParameterForViewDto {
    totalCount!: number;
    items!: GetParameterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetParameterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetParameterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetParameterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetParameterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetParameterForViewDto {
    totalCount: number;
    items: GetParameterForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPestAndDiseaseForViewDto implements IPagedResultDtoOfGetPestAndDiseaseForViewDto {
    totalCount!: number;
    items!: GetPestAndDiseaseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPestAndDiseaseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPestAndDiseaseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPestAndDiseaseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPestAndDiseaseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPestAndDiseaseForViewDto {
    totalCount: number;
    items: GetPestAndDiseaseForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPolenForViewDto implements IPagedResultDtoOfGetPolenForViewDto {
    totalCount!: number;
    items!: GetPolenForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPolenForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPolenForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPolenForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPolenForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPolenForViewDto {
    totalCount: number;
    items: GetPolenForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPolenMixtureForViewDto implements IPagedResultDtoOfGetPolenMixtureForViewDto {
    totalCount!: number;
    items!: GetPolenMixtureForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPolenMixtureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPolenMixtureForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPolenMixtureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPolenMixtureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPolenMixtureForViewDto {
    totalCount: number;
    items: GetPolenMixtureForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPolenStockMovementForViewDto implements IPagedResultDtoOfGetPolenStockMovementForViewDto {
    totalCount!: number;
    items!: GetPolenStockMovementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPolenStockMovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPolenStockMovementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPolenStockMovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPolenStockMovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPolenStockMovementForViewDto {
    totalCount: number;
    items: GetPolenStockMovementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPorcentajeBBXForViewDto implements IPagedResultDtoOfGetPorcentajeBBXForViewDto {
    totalCount!: number;
    items!: GetPorcentajeBBXForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPorcentajeBBXForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPorcentajeBBXForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPorcentajeBBXForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPorcentajeBBXForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPorcentajeBBXForViewDto {
    totalCount: number;
    items: GetPorcentajeBBXForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProgeniesStateForViewDto implements IPagedResultDtoOfGetProgeniesStateForViewDto {
    totalCount!: number;
    items!: GetProgeniesStateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgeniesStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProgeniesStateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgeniesStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProgeniesStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProgeniesStateForViewDto {
    totalCount: number;
    items: GetProgeniesStateForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProgeniesStateTwoForViewDto implements IPagedResultDtoOfGetProgeniesStateTwoForViewDto {
    totalCount!: number;
    items!: GetProgeniesStateTwoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgeniesStateTwoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProgeniesStateTwoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgeniesStateTwoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProgeniesStateTwoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProgeniesStateTwoForViewDto {
    totalCount: number;
    items: GetProgeniesStateTwoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProjectConfigurationForViewDto implements IPagedResultDtoOfGetProjectConfigurationForViewDto {
    totalCount!: number;
    items!: GetProjectConfigurationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProjectConfigurationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProjectConfigurationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProjectConfigurationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProjectConfigurationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProjectConfigurationForViewDto {
    totalCount: number;
    items: GetProjectConfigurationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProjectForViewDto implements IPagedResultDtoOfGetProjectForViewDto {
    totalCount!: number;
    items!: GetProjectForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProjectForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProjectForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProjectForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProjectForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProjectForViewDto {
    totalCount: number;
    items: GetProjectForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPromedioLabBbxForViewDto implements IPagedResultDtoOfGetPromedioLabBbxForViewDto {
    totalCount!: number;
    items!: GetPromedioLabBbxForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPromedioLabBbxForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPromedioLabBbxForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPromedioLabBbxForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPromedioLabBbxForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPromedioLabBbxForViewDto {
    totalCount: number;
    items: GetPromedioLabBbxForViewDto[] | undefined;
}

export class PagedResultDtoOfGetQualityClassificationForViewDto implements IPagedResultDtoOfGetQualityClassificationForViewDto {
    totalCount!: number;
    items!: GetQualityClassificationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQualityClassificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetQualityClassificationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQualityClassificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQualityClassificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQualityClassificationForViewDto {
    totalCount: number;
    items: GetQualityClassificationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetQualityClassificationTypeForViewDto implements IPagedResultDtoOfGetQualityClassificationTypeForViewDto {
    totalCount!: number;
    items!: GetQualityClassificationTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQualityClassificationTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetQualityClassificationTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQualityClassificationTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQualityClassificationTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQualityClassificationTypeForViewDto {
    totalCount: number;
    items: GetQualityClassificationTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetQualityControlForViewDto implements IPagedResultDtoOfGetQualityControlForViewDto {
    totalCount!: number;
    items!: GetQualityControlForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQualityControlForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetQualityControlForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQualityControlForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQualityControlForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQualityControlForViewDto {
    totalCount: number;
    items: GetQualityControlForViewDto[] | undefined;
}

export class PagedResultDtoOfGetRoatingporcentajeTrayForViewDto implements IPagedResultDtoOfGetRoatingporcentajeTrayForViewDto {
    totalCount!: number;
    items!: GetRoatingporcentajeTrayForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRoatingporcentajeTrayForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRoatingporcentajeTrayForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRoatingporcentajeTrayForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRoatingporcentajeTrayForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRoatingporcentajeTrayForViewDto {
    totalCount: number;
    items: GetRoatingporcentajeTrayForViewDto[] | undefined;
}

export class PagedResultDtoOfGetRootingPendingForViewDto implements IPagedResultDtoOfGetRootingPendingForViewDto {
    totalCount!: number;
    items!: GetRootingPendingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRootingPendingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRootingPendingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRootingPendingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRootingPendingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRootingPendingForViewDto {
    totalCount: number;
    items: GetRootingPendingForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedDestinationForViewDto implements IPagedResultDtoOfGetSeedDestinationForViewDto {
    totalCount!: number;
    items!: GetSeedDestinationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedDestinationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedDestinationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedDestinationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedDestinationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedDestinationForViewDto {
    totalCount: number;
    items: GetSeedDestinationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedForViewDto implements IPagedResultDtoOfGetSeedForViewDto {
    totalCount!: number;
    items!: GetSeedForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedForViewDto {
    totalCount: number;
    items: GetSeedForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedMixtureForViewDto implements IPagedResultDtoOfGetSeedMixtureForViewDto {
    totalCount!: number;
    items!: GetSeedMixtureForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedMixtureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedMixtureForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedMixtureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedMixtureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedMixtureForViewDto {
    totalCount: number;
    items: GetSeedMixtureForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedStockForViewDto implements IPagedResultDtoOfGetSeedStockForViewDto {
    totalCount!: number;
    items!: GetSeedStockForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedStockForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedStockForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedStockForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedStockForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedStockForViewDto {
    totalCount: number;
    items: GetSeedStockForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedStockMovementForViewDto implements IPagedResultDtoOfGetSeedStockMovementForViewDto {
    totalCount!: number;
    items!: GetSeedStockMovementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedStockMovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedStockMovementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedStockMovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedStockMovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedStockMovementForViewDto {
    totalCount: number;
    items: GetSeedStockMovementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeedlingForViewDto implements IPagedResultDtoOfGetSeedlingForViewDto {
    totalCount!: number;
    items!: GetSeedlingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeedlingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeedlingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeedlingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeedlingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeedlingForViewDto {
    totalCount: number;
    items: GetSeedlingForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto implements IPagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto {
    totalCount!: number;
    items!: GetSilvicultureTreatmentNutritionalForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSilvicultureTreatmentNutritionalForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSilvicultureTreatmentNutritionalForViewDto {
    totalCount: number;
    items: GetSilvicultureTreatmentNutritionalForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSilvicultureTrialForViewDto implements IPagedResultDtoOfGetSilvicultureTrialForViewDto {
    totalCount!: number;
    items!: GetSilvicultureTrialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSilvicultureTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSilvicultureTrialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSilvicultureTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSilvicultureTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSilvicultureTrialForViewDto {
    totalCount: number;
    items: GetSilvicultureTrialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSourcePlantForViewDto implements IPagedResultDtoOfGetSourcePlantForViewDto {
    totalCount!: number;
    items!: GetSourcePlantForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSourcePlantForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSourcePlantForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSourcePlantForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSourcePlantForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSourcePlantForViewDto {
    totalCount: number;
    items: GetSourcePlantForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSourcePlantPlantationForViewDto implements IPagedResultDtoOfGetSourcePlantPlantationForViewDto {
    totalCount!: number;
    items!: GetSourcePlantPlantationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSourcePlantPlantationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSourcePlantPlantationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSourcePlantPlantationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSourcePlantPlantationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSourcePlantPlantationForViewDto {
    totalCount: number;
    items: GetSourcePlantPlantationForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSpeciesGroupForViewDto implements IPagedResultDtoOfGetSpeciesGroupForViewDto {
    totalCount!: number;
    items!: GetSpeciesGroupForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSpeciesGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSpeciesGroupForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSpeciesGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSpeciesGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSpeciesGroupForViewDto {
    totalCount: number;
    items: GetSpeciesGroupForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSupplierForViewDto implements IPagedResultDtoOfGetSupplierForViewDto {
    totalCount!: number;
    items!: GetSupplierForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSupplierForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSupplierForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSupplierForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSupplierForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSupplierForViewDto {
    totalCount: number;
    items: GetSupplierForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentApplyForViewDto implements IPagedResultDtoOfGetTreatmentApplyForViewDto {
    totalCount!: number;
    items!: GetTreatmentApplyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentApplyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentApplyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentApplyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentApplyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentApplyForViewDto {
    totalCount: number;
    items: GetTreatmentApplyForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentDoseTypeForViewDto implements IPagedResultDtoOfGetTreatmentDoseTypeForViewDto {
    totalCount!: number;
    items!: GetTreatmentDoseTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentDoseTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentDoseTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentDoseTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentDoseTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentDoseTypeForViewDto {
    totalCount: number;
    items: GetTreatmentDoseTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentForViewDto implements IPagedResultDtoOfGetTreatmentForViewDto {
    totalCount!: number;
    items!: GetTreatmentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentForViewDto {
    totalCount: number;
    items: GetTreatmentForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentInterventionForViewDto implements IPagedResultDtoOfGetTreatmentInterventionForViewDto {
    totalCount!: number;
    items!: GetTreatmentInterventionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentInterventionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentInterventionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentInterventionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentInterventionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentInterventionForViewDto {
    totalCount: number;
    items: GetTreatmentInterventionForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentObjectiveForViewDto implements IPagedResultDtoOfGetTreatmentObjectiveForViewDto {
    totalCount!: number;
    items!: GetTreatmentObjectiveForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentObjectiveForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentObjectiveForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentObjectiveForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentObjectiveForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentObjectiveForViewDto {
    totalCount: number;
    items: GetTreatmentObjectiveForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentParcelTypeForViewDto implements IPagedResultDtoOfGetTreatmentParcelTypeForViewDto {
    totalCount!: number;
    items!: GetTreatmentParcelTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentParcelTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentParcelTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentParcelTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentParcelTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentParcelTypeForViewDto {
    totalCount: number;
    items: GetTreatmentParcelTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentProductForViewDto implements IPagedResultDtoOfGetTreatmentProductForViewDto {
    totalCount!: number;
    items!: GetTreatmentProductForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentProductForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentProductForViewDto {
    totalCount: number;
    items: GetTreatmentProductForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreatmentProductTypeForViewDto implements IPagedResultDtoOfGetTreatmentProductTypeForViewDto {
    totalCount!: number;
    items!: GetTreatmentProductTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreatmentProductTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreatmentProductTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreatmentProductTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreatmentProductTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreatmentProductTypeForViewDto {
    totalCount: number;
    items: GetTreatmentProductTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreeForViewDto implements IPagedResultDtoOfGetTreeForViewDto {
    totalCount!: number;
    items!: GetTreeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreeForViewDto {
    totalCount: number;
    items: GetTreeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreeManagementForViewDto implements IPagedResultDtoOfGetTreeManagementForViewDto {
    totalCount!: number;
    items!: GetTreeManagementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreeManagementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreeManagementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreeManagementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreeManagementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreeManagementForViewDto {
    totalCount: number;
    items: GetTreeManagementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreeMeasurementAlertForViewDto implements IPagedResultDtoOfGetTreeMeasurementAlertForViewDto {
    totalCount!: number;
    items!: GetTreeMeasurementAlertForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreeMeasurementAlertForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreeMeasurementAlertForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreeMeasurementAlertForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreeMeasurementAlertForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreeMeasurementAlertForViewDto {
    totalCount: number;
    items: GetTreeMeasurementAlertForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreeMeasurementForViewDto implements IPagedResultDtoOfGetTreeMeasurementForViewDto {
    totalCount!: number;
    items!: GetTreeMeasurementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreeMeasurementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreeMeasurementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreeMeasurementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreeMeasurementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreeMeasurementForViewDto {
    totalCount: number;
    items: GetTreeMeasurementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTreeStatusForViewDto implements IPagedResultDtoOfGetTreeStatusForViewDto {
    totalCount!: number;
    items!: GetTreeStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTreeStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTreeStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTreeStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTreeStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTreeStatusForViewDto {
    totalCount: number;
    items: GetTreeStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrialDesignTypesForViewDto implements IPagedResultDtoOfGetTrialDesignTypesForViewDto {
    totalCount!: number;
    items!: GetTrialDesignTypesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrialDesignTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrialDesignTypesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrialDesignTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrialDesignTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrialDesignTypesForViewDto {
    totalCount: number;
    items: GetTrialDesignTypesForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrialForViewDto implements IPagedResultDtoOfGetTrialForViewDto {
    totalCount!: number;
    items!: GetTrialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrialForViewDto {
    totalCount: number;
    items: GetTrialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrialRDForViewDto implements IPagedResultDtoOfGetTrialRDForViewDto {
    totalCount!: number;
    items!: GetTrialRDForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrialRDForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrialRDForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrialRDForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrialRDForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrialRDForViewDto {
    totalCount: number;
    items: GetTrialRDForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrialStatusForViewDto implements IPagedResultDtoOfGetTrialStatusForViewDto {
    totalCount!: number;
    items!: GetTrialStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrialStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrialStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrialStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrialStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrialStatusForViewDto {
    totalCount: number;
    items: GetTrialStatusForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTypeGeneticMaterialForViewDto implements IPagedResultDtoOfGetTypeGeneticMaterialForViewDto {
    totalCount!: number;
    items!: GetTypeGeneticMaterialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTypeGeneticMaterialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTypeGeneticMaterialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTypeGeneticMaterialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTypeGeneticMaterialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTypeGeneticMaterialForViewDto {
    totalCount: number;
    items: GetTypeGeneticMaterialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTypeSpecieForViewDto implements IPagedResultDtoOfGetTypeSpecieForViewDto {
    totalCount!: number;
    items!: GetTypeSpecieForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTypeSpecieForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTypeSpecieForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTypeSpecieForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTypeSpecieForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTypeSpecieForViewDto {
    totalCount: number;
    items: GetTypeSpecieForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTypeTrialForViewDto implements IPagedResultDtoOfGetTypeTrialForViewDto {
    totalCount!: number;
    items!: GetTypeTrialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTypeTrialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTypeTrialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTypeTrialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTypeTrialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTypeTrialForViewDto {
    totalCount: number;
    items: GetTypeTrialForViewDto[] | undefined;
}

export class PagedResultDtoOfGetWoodSampleTypeForViewDto implements IPagedResultDtoOfGetWoodSampleTypeForViewDto {
    totalCount!: number;
    items!: GetWoodSampleTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWoodSampleTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetWoodSampleTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWoodSampleTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWoodSampleTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWoodSampleTypeForViewDto {
    totalCount: number;
    items: GetWoodSampleTypeForViewDto[] | undefined;
}

export class PagedResultDtoOfGetYoungObservationCodeForViewDto implements IPagedResultDtoOfGetYoungObservationCodeForViewDto {
    totalCount!: number;
    items!: GetYoungObservationCodeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetYoungObservationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetYoungObservationCodeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetYoungObservationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetYoungObservationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetYoungObservationCodeForViewDto {
    totalCount: number;
    items: GetYoungObservationCodeForViewDto[] | undefined;
}

export class PagedResultDtoOfHelperPolenPolenLookupTableDto implements IPagedResultDtoOfHelperPolenPolenLookupTableDto {
    totalCount!: number;
    items!: HelperPolenPolenLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfHelperPolenPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HelperPolenPolenLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHelperPolenPolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHelperPolenPolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfHelperPolenPolenLookupTableDto {
    totalCount: number;
    items: HelperPolenPolenLookupTableDto[] | undefined;
}

export class PagedResultDtoOfHelperSeedSeedLookupTableDto implements IPagedResultDtoOfHelperSeedSeedLookupTableDto {
    totalCount!: number;
    items!: HelperSeedSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfHelperSeedSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HelperSeedSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHelperSeedSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHelperSeedSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfHelperSeedSeedLookupTableDto {
    totalCount: number;
    items: HelperSeedSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto implements IPagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningOptionsMeasurementPlaningLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningOptionsMeasurementPlaningLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningOptionsMeasurementPlaningLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningOptionsMeasurementPlaningLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto implements IPagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningOptionsTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningOptionsTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningOptionsTrialLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningOptionsTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto implements IPagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningTreatmentMeasurementPlaningOptionsLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto implements IPagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningTreatmentTreatmentLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningTreatmentTreatmentLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningTreatmentTreatmentLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningTreatmentTreatmentLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto implements IPagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningTreeHeightNumberMeasurementPlaningOptionsLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto implements IPagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
    totalCount!: number;
    items!: MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto {
    totalCount: number;
    items: MeasurementPlaningTreeNumberMeasurementPlaningOptionsLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto implements IPagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto {
    totalCount!: number;
    items!: MeasurementSelectionGenomicProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementSelectionGenomicProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementSelectionGenomicProjectLookupTableDto {
    totalCount: number;
    items: MeasurementSelectionGenomicProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto implements IPagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto {
    totalCount!: number;
    items!: MeasurementSelectionGenomicSeedlingLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementSelectionGenomicSeedlingLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementSelectionGenomicSeedlingLookupTableDto {
    totalCount: number;
    items: MeasurementSelectionGenomicSeedlingLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto implements IPagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto {
    totalCount!: number;
    items!: MeasurementSelectionOtherProjectProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementSelectionOtherProjectProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementSelectionOtherProjectProjectLookupTableDto {
    totalCount: number;
    items: MeasurementSelectionOtherProjectProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementSelectionProjectLookupTableDto implements IPagedResultDtoOfMeasurementSelectionProjectLookupTableDto {
    totalCount!: number;
    items!: MeasurementSelectionProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementSelectionProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementSelectionProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementSelectionProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementSelectionProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementSelectionProjectLookupTableDto {
    totalCount: number;
    items: MeasurementSelectionProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMeasurementSelectionTreeLookupTableDto implements IPagedResultDtoOfMeasurementSelectionTreeLookupTableDto {
    totalCount!: number;
    items!: MeasurementSelectionTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMeasurementSelectionTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementSelectionTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMeasurementSelectionTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMeasurementSelectionTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMeasurementSelectionTreeLookupTableDto {
    totalCount: number;
    items: MeasurementSelectionTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto implements IPagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto {
    totalCount!: number;
    items!: MesurementCloneEvaluationProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MesurementCloneEvaluationProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMesurementCloneEvaluationProjectLookupTableDto {
    totalCount: number;
    items: MesurementCloneEvaluationProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto implements IPagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto {
    totalCount!: number;
    items!: MesurementCloneEvaluationSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MesurementCloneEvaluationSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMesurementCloneEvaluationSeedLookupTableDto {
    totalCount: number;
    items: MesurementCloneEvaluationSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto implements IPagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto {
    totalCount!: number;
    items!: MesurementCloneEvaluationTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MesurementCloneEvaluationTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMesurementCloneEvaluationTreeLookupTableDto {
    totalCount: number;
    items: MesurementCloneEvaluationTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto implements IPagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto {
    totalCount!: number;
    items!: MesurementCloneEvaluationTreeStatusLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MesurementCloneEvaluationTreeStatusLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMesurementCloneEvaluationTreeStatusLookupTableDto {
    totalCount: number;
    items: MesurementCloneEvaluationTreeStatusLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto implements IPagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto {
    totalCount!: number;
    items!: MesurementCloneEvaluationTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MesurementCloneEvaluationTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMesurementCloneEvaluationTrialLookupTableDto {
    totalCount: number;
    items: MesurementCloneEvaluationTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfPlannedPlantationHeaderDto implements IPagedResultDtoOfPlannedPlantationHeaderDto {
    totalCount!: number;
    items!: PlannedPlantationHeaderDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlannedPlantationHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlannedPlantationHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlannedPlantationHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlannedPlantationHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPlannedPlantationHeaderDto {
    totalCount: number;
    items: PlannedPlantationHeaderDto[] | undefined;
}

export class PagedResultDtoOfPolenLookupTableDto implements IPagedResultDtoOfPolenLookupTableDto {
    totalCount!: number;
    items!: PolenLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolenLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolenLookupTableDto {
    totalCount: number;
    items: PolenLookupTableDto[] | undefined;
}

export class PagedResultDtoOfPolenStockDto implements IPagedResultDtoOfPolenStockDto {
    totalCount!: number;
    items!: PolenStockDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolenStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolenStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolenStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolenStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolenStockDto {
    totalCount: number;
    items: PolenStockDto[] | undefined;
}

export class PagedResultDtoOfPolenSupplierLookupTableDto implements IPagedResultDtoOfPolenSupplierLookupTableDto {
    totalCount!: number;
    items!: PolenSupplierLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolenSupplierLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolenSupplierLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolenSupplierLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolenSupplierLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolenSupplierLookupTableDto {
    totalCount: number;
    items: PolenSupplierLookupTableDto[] | undefined;
}

export class PagedResultDtoOfPolenTreeLookupTableDto implements IPagedResultDtoOfPolenTreeLookupTableDto {
    totalCount!: number;
    items!: PolenTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolenTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolenTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolenTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolenTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolenTreeLookupTableDto {
    totalCount: number;
    items: PolenTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfPolenTrialLookupTableDto implements IPagedResultDtoOfPolenTrialLookupTableDto {
    totalCount!: number;
    items!: PolenTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolenTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolenTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolenTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolenTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolenTrialLookupTableDto {
    totalCount: number;
    items: PolenTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfPorcentajeBBXCloneLookupTableDto implements IPagedResultDtoOfPorcentajeBBXCloneLookupTableDto {
    totalCount!: number;
    items!: PorcentajeBBXCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPorcentajeBBXCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PorcentajeBBXCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPorcentajeBBXCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPorcentajeBBXCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPorcentajeBBXCloneLookupTableDto {
    totalCount: number;
    items: PorcentajeBBXCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto implements IPagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto {
    totalCount!: number;
    items!: PorcentajeBBXMeasurementSelectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PorcentajeBBXMeasurementSelectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPorcentajeBBXMeasurementSelectionLookupTableDto {
    totalCount: number;
    items: PorcentajeBBXMeasurementSelectionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfProjectConfigurationSeedLookupTableDto implements IPagedResultDtoOfProjectConfigurationSeedLookupTableDto {
    totalCount!: number;
    items!: ProjectConfigurationSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProjectConfigurationSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectConfigurationSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectConfigurationSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectConfigurationSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfProjectConfigurationSeedLookupTableDto {
    totalCount: number;
    items: ProjectConfigurationSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto implements IPagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto {
    totalCount!: number;
    items!: RoatingporcentajeTrayCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoatingporcentajeTrayCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoatingporcentajeTrayCloneLookupTableDto {
    totalCount: number;
    items: RoatingporcentajeTrayCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto implements IPagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto {
    totalCount!: number;
    items!: RoatingporcentajeTrayMeasurementSelectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoatingporcentajeTrayMeasurementSelectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoatingporcentajeTrayMeasurementSelectionLookupTableDto {
    totalCount: number;
    items: RoatingporcentajeTrayMeasurementSelectionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto implements IPagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto {
    totalCount!: number;
    items!: RoatingporcentajeTrayProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoatingporcentajeTrayProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoatingporcentajeTrayProjectLookupTableDto {
    totalCount: number;
    items: RoatingporcentajeTrayProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto implements IPagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto {
    totalCount!: number;
    items!: RoatingporcentajeTraySeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoatingporcentajeTraySeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoatingporcentajeTraySeedLookupTableDto {
    totalCount: number;
    items: RoatingporcentajeTraySeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto implements IPagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto {
    totalCount!: number;
    items!: RoatingporcentajeTraySourcePlantLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoatingporcentajeTraySourcePlantLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfRoatingporcentajeTraySourcePlantLookupTableDto {
    totalCount: number;
    items: RoatingporcentajeTraySourcePlantLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedLookupTableDto implements IPagedResultDtoOfSeedLookupTableDto {
    totalCount!: number;
    items!: SeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedLookupTableDto {
    totalCount: number;
    items: SeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedMixtureSeedLookupTableDto implements IPagedResultDtoOfSeedMixtureSeedLookupTableDto {
    totalCount!: number;
    items!: SeedMixtureSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedMixtureSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedMixtureSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedMixtureSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedMixtureSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedMixtureSeedLookupTableDto {
    totalCount: number;
    items: SeedMixtureSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedStockMovementSeedLookupTableDto implements IPagedResultDtoOfSeedStockMovementSeedLookupTableDto {
    totalCount!: number;
    items!: SeedStockMovementSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedStockMovementSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedStockMovementSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedStockMovementSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedStockMovementSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedStockMovementSeedLookupTableDto {
    totalCount: number;
    items: SeedStockMovementSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedStockSeedLookupTableDto implements IPagedResultDtoOfSeedStockSeedLookupTableDto {
    totalCount!: number;
    items!: SeedStockSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedStockSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedStockSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedStockSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedStockSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedStockSeedLookupTableDto {
    totalCount: number;
    items: SeedStockSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedSupplierLookupTableDto implements IPagedResultDtoOfSeedSupplierLookupTableDto {
    totalCount!: number;
    items!: SeedSupplierLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedSupplierLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedSupplierLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedSupplierLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedSupplierLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedSupplierLookupTableDto {
    totalCount: number;
    items: SeedSupplierLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedTreeLookupTableDto implements IPagedResultDtoOfSeedTreeLookupTableDto {
    totalCount!: number;
    items!: SeedTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedTreeLookupTableDto {
    totalCount: number;
    items: SeedTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedTrialLookupTableDto implements IPagedResultDtoOfSeedTrialLookupTableDto {
    totalCount!: number;
    items!: SeedTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedTrialLookupTableDto {
    totalCount: number;
    items: SeedTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedlingCloneLookupTableDto implements IPagedResultDtoOfSeedlingCloneLookupTableDto {
    totalCount!: number;
    items!: SeedlingCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedlingCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedlingCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedlingCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedlingCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedlingCloneLookupTableDto {
    totalCount: number;
    items: SeedlingCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSeedlingSeedLookupTableDto implements IPagedResultDtoOfSeedlingSeedLookupTableDto {
    totalCount!: number;
    items!: SeedlingSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSeedlingSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SeedlingSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSeedlingSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSeedlingSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSeedlingSeedLookupTableDto {
    totalCount: number;
    items: SeedlingSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalCloneLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto implements IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
    totalCount: number;
    items: SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialCloneLookupTableDto implements IPagedResultDtoOfSilvicultureTrialCloneLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialCloneLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentCategoryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentCategoryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentCategoryLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentCategoryLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentClasificationtwoLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentClasificationtwoLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentClasificationtwoLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentClasificationtwoLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentClassificationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentClassificationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentClassificationLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentClassificationLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentLocationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentLocationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentLocationLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentLocationLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentSpecieLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentSpecieLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentSpecieLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentSpecieLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentSpecieQuantityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentSpecieQuantityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentSpecieQuantityLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentSpecieQuantityLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto implements IPagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialExperimentTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialExperimentTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialExperimentTypeLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialExperimentTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto implements IPagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialGroupTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialGroupTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialGroupTrialLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialGroupTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto implements IPagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialTrialDesignTypesLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialTrialDesignTypesLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialTrialDesignTypesLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialTrialDesignTypesLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto implements IPagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto {
    totalCount!: number;
    items!: SilvicultureTrialTrialStatusLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SilvicultureTrialTrialStatusLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSilvicultureTrialTrialStatusLookupTableDto {
    totalCount: number;
    items: SilvicultureTrialTrialStatusLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSourcePlantCloneLookupTableDto implements IPagedResultDtoOfSourcePlantCloneLookupTableDto {
    totalCount!: number;
    items!: SourcePlantCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSourcePlantCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SourcePlantCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSourcePlantCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSourcePlantCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSourcePlantCloneLookupTableDto {
    totalCount: number;
    items: SourcePlantCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto implements IPagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto {
    totalCount!: number;
    items!: SourcePlantMeasurementSelectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SourcePlantMeasurementSelectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSourcePlantMeasurementSelectionLookupTableDto {
    totalCount: number;
    items: SourcePlantMeasurementSelectionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto implements IPagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto {
    totalCount!: number;
    items!: SourcePlantPlantationSourcePlantLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SourcePlantPlantationSourcePlantLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSourcePlantPlantationSourcePlantLookupTableDto {
    totalCount: number;
    items: SourcePlantPlantationSourcePlantLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSourcePlantProjectLookupTableDto implements IPagedResultDtoOfSourcePlantProjectLookupTableDto {
    totalCount!: number;
    items!: SourcePlantProjectLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSourcePlantProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SourcePlantProjectLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSourcePlantProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSourcePlantProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSourcePlantProjectLookupTableDto {
    totalCount: number;
    items: SourcePlantProjectLookupTableDto[] | undefined;
}

export class PagedResultDtoOfSourcePlantSourcePlantLookupTableDto implements IPagedResultDtoOfSourcePlantSourcePlantLookupTableDto {
    totalCount!: number;
    items!: SourcePlantSourcePlantLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSourcePlantSourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SourcePlantSourcePlantLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSourcePlantSourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSourcePlantSourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSourcePlantSourcePlantLookupTableDto {
    totalCount: number;
    items: SourcePlantSourcePlantLookupTableDto[] | undefined;
}

export class PagedResultDtoOfStatusCloneLookupTableDto implements IPagedResultDtoOfStatusCloneLookupTableDto {
    totalCount!: number;
    items!: StatusCloneLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStatusCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusCloneLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStatusCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStatusCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfStatusCloneLookupTableDto {
    totalCount: number;
    items: StatusCloneLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto implements IPagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto {
    totalCount!: number;
    items!: TreatmentProductTreatmentProductTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreatmentProductTreatmentProductTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreatmentProductTreatmentProductTypeLookupTableDto {
    totalCount: number;
    items: TreatmentProductTreatmentProductTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreatmentSeedLookupTableDto implements IPagedResultDtoOfTreatmentSeedLookupTableDto {
    totalCount!: number;
    items!: TreatmentSeedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreatmentSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreatmentSeedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreatmentSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreatmentSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreatmentSeedLookupTableDto {
    totalCount: number;
    items: TreatmentSeedLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreatmentTreeLookupTableDto implements IPagedResultDtoOfTreatmentTreeLookupTableDto {
    totalCount!: number;
    items!: TreatmentTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreatmentTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreatmentTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreatmentTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreatmentTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreatmentTreeLookupTableDto {
    totalCount: number;
    items: TreatmentTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreatmentTrialLookupTableDto implements IPagedResultDtoOfTreatmentTrialLookupTableDto {
    totalCount!: number;
    items!: TreatmentTrialLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreatmentTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreatmentTrialLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreatmentTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreatmentTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreatmentTrialLookupTableDto {
    totalCount: number;
    items: TreatmentTrialLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreeManagementTreeLookupTableDto implements IPagedResultDtoOfTreeManagementTreeLookupTableDto {
    totalCount!: number;
    items!: TreeManagementTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeManagementTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreeManagementTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeManagementTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeManagementTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreeManagementTreeLookupTableDto {
    totalCount: number;
    items: TreeManagementTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreeMeasurementTreeLookupTableDto implements IPagedResultDtoOfTreeMeasurementTreeLookupTableDto {
    totalCount!: number;
    items!: TreeMeasurementTreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeMeasurementTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreeMeasurementTreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeMeasurementTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeMeasurementTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreeMeasurementTreeLookupTableDto {
    totalCount: number;
    items: TreeMeasurementTreeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfTreeTreatmentLookupTableDto implements IPagedResultDtoOfTreeTreatmentLookupTableDto {
    totalCount!: number;
    items!: TreeTreatmentLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeTreatmentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreeTreatmentLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeTreatmentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeTreatmentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTreeTreatmentLookupTableDto {
    totalCount: number;
    items: TreeTreatmentLookupTableDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    totalCount!: number;
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    totalCount: number;
    items: UserLoginAttemptDto[] | undefined;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export class ParameterDto implements IParameterDto {
    name!: string | undefined;
    value!: number | undefined;
    id!: number;

    constructor(data?: IParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IParameterDto {
    name: string | undefined;
    value: number | undefined;
    id: number;
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    readonly name!: string | undefined;
    readonly parameterType!: string | undefined;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | undefined;
    readonly rawDefaultValue!: any | undefined;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : undefined as any;
            (this as any).name = _data["name"];
            (this as any).parameterType = _data["parameterType"];
            (this as any).position = _data["position"];
            (this as any).isIn = _data["isIn"];
            (this as any).isLcid = _data["isLcid"];
            (this as any).isOptional = _data["isOptional"];
            (this as any).isOut = _data["isOut"];
            (this as any).isRetval = _data["isRetval"];
            (this as any).defaultValue = _data["defaultValue"];
            (this as any).rawDefaultValue = _data["rawDefaultValue"];
            (this as any).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined as any;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: string | undefined;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export class PestAndDiseaseDto implements IPestAndDiseaseDto {
    name!: string | undefined;
    code!: number;
    detail!: string | undefined;
    id!: number;

    constructor(data?: IPestAndDiseaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PestAndDiseaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PestAndDiseaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["id"] = this.id;
        return data;
    }
}

export interface IPestAndDiseaseDto {
    name: string | undefined;
    code: number;
    detail: string | undefined;
    id: number;
}

export class PlannedPlantationDetailsDto implements IPlannedPlantationDetailsDto {
    readonly id!: string | undefined;
    standStatusId!: number;
    standStatusName!: string | undefined;
    area!: number;

    constructor(data?: IPlannedPlantationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).id = _data["id"];
            this.standStatusId = _data["standStatusId"];
            this.standStatusName = _data["standStatusName"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): PlannedPlantationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedPlantationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["standStatusId"] = this.standStatusId;
        data["standStatusName"] = this.standStatusName;
        data["area"] = this.area;
        return data;
    }
}

export interface IPlannedPlantationDetailsDto {
    id: string | undefined;
    standStatusId: number;
    standStatusName: string | undefined;
    area: number;
}

export class PlannedPlantationHeaderDto implements IPlannedPlantationHeaderDto {
    vendorId!: number;
    vendorName!: string | undefined;
    periodId!: number;
    periodName!: string | undefined;
    regionId!: number;
    regionName!: string | undefined;
    zoneId!: number;
    zoneName!: string | undefined;
    propertyId!: number;
    propertyName!: string | undefined;
    readonly id!: string | undefined;
    readonly year!: number;
    state!: boolean;
    plannedPlantation!: PlannedPlantationDetailsDto[] | undefined;

    constructor(data?: IPlannedPlantationHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"];
            this.vendorName = _data["vendorName"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.zoneId = _data["zoneId"];
            this.zoneName = _data["zoneName"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            (this as any).id = _data["id"];
            (this as any).year = _data["year"];
            this.state = _data["state"];
            if (Array.isArray(_data["plannedPlantation"])) {
                this.plannedPlantation = [] as any;
                for (let item of _data["plannedPlantation"])
                    this.plannedPlantation!.push(PlannedPlantationDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlannedPlantationHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedPlantationHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["zoneId"] = this.zoneId;
        data["zoneName"] = this.zoneName;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["id"] = this.id;
        data["year"] = this.year;
        data["state"] = this.state;
        if (Array.isArray(this.plannedPlantation)) {
            data["plannedPlantation"] = [];
            for (let item of this.plannedPlantation)
                data["plannedPlantation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlannedPlantationHeaderDto {
    vendorId: number;
    vendorName: string | undefined;
    periodId: number;
    periodName: string | undefined;
    regionId: number;
    regionName: string | undefined;
    zoneId: number;
    zoneName: string | undefined;
    propertyId: number;
    propertyName: string | undefined;
    id: string | undefined;
    year: number;
    state: boolean;
    plannedPlantation: PlannedPlantationDetailsDto[] | undefined;
}

export class PlantPositionDto implements IPlantPositionDto {
    position!: number;
    canaletonNumber!: number;
    groupPlMadre!: string | undefined;
    species!: string | undefined;
    speciesCategory!: string | undefined;
    rootingPercentage!: number | undefined;
    clonalEvaluation!: number | undefined;
    quantityPlanted!: number | undefined;
    stakeCount!: number | undefined;
    color!: string | undefined;
    id!: number;
    bbxCode!: string | undefined;
    originType!: string | undefined;
    additionalInfo!: string | undefined;
    plantasMadre!: PlantaMadreDto[] | undefined;
    productivityGroups!: ProductivityGroupDto[] | undefined;
    totalQuantity!: number;
    density!: number;
    densitySampleCount!: number;
    customSpecie!: string | undefined;

    constructor(data?: IPlantPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.canaletonNumber = _data["canaletonNumber"];
            this.groupPlMadre = _data["groupPlMadre"];
            this.species = _data["species"];
            this.speciesCategory = _data["speciesCategory"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.clonalEvaluation = _data["clonalEvaluation"];
            this.quantityPlanted = _data["quantityPlanted"];
            this.stakeCount = _data["stakeCount"];
            this.color = _data["color"];
            this.id = _data["id"];
            this.bbxCode = _data["bbxCode"];
            this.originType = _data["originType"];
            this.additionalInfo = _data["additionalInfo"];
            if (Array.isArray(_data["plantasMadre"])) {
                this.plantasMadre = [] as any;
                for (let item of _data["plantasMadre"])
                    this.plantasMadre!.push(PlantaMadreDto.fromJS(item));
            }
            if (Array.isArray(_data["productivityGroups"])) {
                this.productivityGroups = [] as any;
                for (let item of _data["productivityGroups"])
                    this.productivityGroups!.push(ProductivityGroupDto.fromJS(item));
            }
            this.totalQuantity = _data["totalQuantity"];
            this.density = _data["density"];
            this.densitySampleCount = _data["densitySampleCount"];
            this.customSpecie = _data["customSpecie"];
        }
    }

    static fromJS(data: any): PlantPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlantPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["canaletonNumber"] = this.canaletonNumber;
        data["groupPlMadre"] = this.groupPlMadre;
        data["species"] = this.species;
        data["speciesCategory"] = this.speciesCategory;
        data["rootingPercentage"] = this.rootingPercentage;
        data["clonalEvaluation"] = this.clonalEvaluation;
        data["quantityPlanted"] = this.quantityPlanted;
        data["stakeCount"] = this.stakeCount;
        data["color"] = this.color;
        data["id"] = this.id;
        data["bbxCode"] = this.bbxCode;
        data["originType"] = this.originType;
        data["additionalInfo"] = this.additionalInfo;
        if (Array.isArray(this.plantasMadre)) {
            data["plantasMadre"] = [];
            for (let item of this.plantasMadre)
                data["plantasMadre"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productivityGroups)) {
            data["productivityGroups"] = [];
            for (let item of this.productivityGroups)
                data["productivityGroups"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalQuantity"] = this.totalQuantity;
        data["density"] = this.density;
        data["densitySampleCount"] = this.densitySampleCount;
        data["customSpecie"] = this.customSpecie;
        return data;
    }
}

export interface IPlantPositionDto {
    position: number;
    canaletonNumber: number;
    groupPlMadre: string | undefined;
    species: string | undefined;
    speciesCategory: string | undefined;
    rootingPercentage: number | undefined;
    clonalEvaluation: number | undefined;
    quantityPlanted: number | undefined;
    stakeCount: number | undefined;
    color: string | undefined;
    id: number;
    bbxCode: string | undefined;
    originType: string | undefined;
    additionalInfo: string | undefined;
    plantasMadre: PlantaMadreDto[] | undefined;
    productivityGroups: ProductivityGroupDto[] | undefined;
    totalQuantity: number;
    density: number;
    densitySampleCount: number;
    customSpecie: string | undefined;
}

export class PlantaMadreDto implements IPlantaMadreDto {
    groupNumber!: number;
    species!: string | undefined;
    rootingPercentage!: number | undefined;
    clonalEvaluation!: number | undefined;
    quantity!: number;
    stakeCount!: number | undefined;
    bbxCode!: string | undefined;
    additionalInfo!: string | undefined;
    density!: number | undefined;
    densitySampleCount!: number | undefined;
    speciesCategory!: string | undefined;
    customSpecie!: string | undefined;

    constructor(data?: IPlantaMadreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupNumber = _data["groupNumber"];
            this.species = _data["species"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.clonalEvaluation = _data["clonalEvaluation"];
            this.quantity = _data["quantity"];
            this.stakeCount = _data["stakeCount"];
            this.bbxCode = _data["bbxCode"];
            this.additionalInfo = _data["additionalInfo"];
            this.density = _data["density"];
            this.densitySampleCount = _data["densitySampleCount"];
            this.speciesCategory = _data["speciesCategory"];
            this.customSpecie = _data["customSpecie"];
        }
    }

    static fromJS(data: any): PlantaMadreDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlantaMadreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupNumber"] = this.groupNumber;
        data["species"] = this.species;
        data["rootingPercentage"] = this.rootingPercentage;
        data["clonalEvaluation"] = this.clonalEvaluation;
        data["quantity"] = this.quantity;
        data["stakeCount"] = this.stakeCount;
        data["bbxCode"] = this.bbxCode;
        data["additionalInfo"] = this.additionalInfo;
        data["density"] = this.density;
        data["densitySampleCount"] = this.densitySampleCount;
        data["speciesCategory"] = this.speciesCategory;
        data["customSpecie"] = this.customSpecie;
        return data;
    }
}

export interface IPlantaMadreDto {
    groupNumber: number;
    species: string | undefined;
    rootingPercentage: number | undefined;
    clonalEvaluation: number | undefined;
    quantity: number;
    stakeCount: number | undefined;
    bbxCode: string | undefined;
    additionalInfo: string | undefined;
    density: number | undefined;
    densitySampleCount: number | undefined;
    speciesCategory: string | undefined;
    customSpecie: string | undefined;
}

export class Polen implements IPolen {
    tenantId!: number | undefined;
    bbp!: string;
    polenNumber!: number;
    physicalBBSTreeId!: string | undefined;
    bbs!: string | undefined;
    physicalBBXTreeId!: string | undefined;
    bbx!: string | undefined;
    originalTree!: string | undefined;
    idPolenHarvest!: string | undefined;
    species!: string;
    harvestDate!: DateTime;
    initialStock!: number;
    currentStock!: number;
    stockLocation!: string | undefined;
    observations!: string | undefined;
    isMixture!: boolean;
    supplierId!: number;
    updateDate!: DateTime | undefined;
    supplierFk!: Supplier;
    trialId!: number | undefined;
    trialFk!: Trial;
    polenMixtures!: PolenMixture[] | undefined;
    siteOrigin!: string | undefined;
    typeHarvest!: EnumTypeHarvest;
    treeId!: number | undefined;
    treeFk!: Tree;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPolen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bbp = _data["bbp"];
            this.polenNumber = _data["polenNumber"];
            this.physicalBBSTreeId = _data["physicalBBSTreeId"];
            this.bbs = _data["bbs"];
            this.physicalBBXTreeId = _data["physicalBBXTreeId"];
            this.bbx = _data["bbx"];
            this.originalTree = _data["originalTree"];
            this.idPolenHarvest = _data["idPolenHarvest"];
            this.species = _data["species"];
            this.harvestDate = _data["harvestDate"] ? DateTime.fromISO(_data["harvestDate"].toString()) : undefined as any;
            this.initialStock = _data["initialStock"];
            this.currentStock = _data["currentStock"];
            this.stockLocation = _data["stockLocation"];
            this.observations = _data["observations"];
            this.isMixture = _data["isMixture"];
            this.supplierId = _data["supplierId"];
            this.updateDate = _data["updateDate"] ? DateTime.fromISO(_data["updateDate"].toString()) : undefined as any;
            this.supplierFk = _data["supplierFk"] ? Supplier.fromJS(_data["supplierFk"]) : undefined as any;
            this.trialId = _data["trialId"];
            this.trialFk = _data["trialFk"] ? Trial.fromJS(_data["trialFk"]) : undefined as any;
            if (Array.isArray(_data["polenMixtures"])) {
                this.polenMixtures = [] as any;
                for (let item of _data["polenMixtures"])
                    this.polenMixtures!.push(PolenMixture.fromJS(item));
            }
            this.siteOrigin = _data["siteOrigin"];
            this.typeHarvest = _data["typeHarvest"];
            this.treeId = _data["treeId"];
            this.treeFk = _data["treeFk"] ? Tree.fromJS(_data["treeFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Polen {
        data = typeof data === 'object' ? data : {};
        let result = new Polen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bbp"] = this.bbp;
        data["polenNumber"] = this.polenNumber;
        data["physicalBBSTreeId"] = this.physicalBBSTreeId;
        data["bbs"] = this.bbs;
        data["physicalBBXTreeId"] = this.physicalBBXTreeId;
        data["bbx"] = this.bbx;
        data["originalTree"] = this.originalTree;
        data["idPolenHarvest"] = this.idPolenHarvest;
        data["species"] = this.species;
        data["harvestDate"] = this.harvestDate ? this.harvestDate.toString() : undefined as any;
        data["initialStock"] = this.initialStock;
        data["currentStock"] = this.currentStock;
        data["stockLocation"] = this.stockLocation;
        data["observations"] = this.observations;
        data["isMixture"] = this.isMixture;
        data["supplierId"] = this.supplierId;
        data["updateDate"] = this.updateDate ? this.updateDate.toString() : undefined as any;
        data["supplierFk"] = this.supplierFk ? this.supplierFk.toJSON() : undefined as any;
        data["trialId"] = this.trialId;
        data["trialFk"] = this.trialFk ? this.trialFk.toJSON() : undefined as any;
        if (Array.isArray(this.polenMixtures)) {
            data["polenMixtures"] = [];
            for (let item of this.polenMixtures)
                data["polenMixtures"].push(item ? item.toJSON() : undefined as any);
        }
        data["siteOrigin"] = this.siteOrigin;
        data["typeHarvest"] = this.typeHarvest;
        data["treeId"] = this.treeId;
        data["treeFk"] = this.treeFk ? this.treeFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolen {
    tenantId: number | undefined;
    bbp: string;
    polenNumber: number;
    physicalBBSTreeId: string | undefined;
    bbs: string | undefined;
    physicalBBXTreeId: string | undefined;
    bbx: string | undefined;
    originalTree: string | undefined;
    idPolenHarvest: string | undefined;
    species: string;
    harvestDate: DateTime;
    initialStock: number;
    currentStock: number;
    stockLocation: string | undefined;
    observations: string | undefined;
    isMixture: boolean;
    supplierId: number;
    updateDate: DateTime | undefined;
    supplierFk: Supplier;
    trialId: number | undefined;
    trialFk: Trial;
    polenMixtures: PolenMixture[] | undefined;
    siteOrigin: string | undefined;
    typeHarvest: EnumTypeHarvest;
    treeId: number | undefined;
    treeFk: Tree;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PolenDto implements IPolenDto {
    bbp!: string | undefined;
    polenNumber!: number;
    physicalBBSTreeId!: string | undefined;
    bbs!: string | undefined;
    physicalBBXTreeId!: string | undefined;
    bbx!: string | undefined;
    generation!: string | undefined;
    originalTree!: string | undefined;
    idPolenHarvest!: string | undefined;
    species!: string | undefined;
    species2!: string | undefined;
    harvestDate!: DateTime;
    initialStock!: number;
    currentStock!: number;
    updateDate!: DateTime | undefined;
    stockLocation!: string | undefined;
    observations!: string | undefined;
    isMixture!: boolean;
    supplierId!: number;
    trialId!: number | undefined;
    polenMixtures!: _definitions_PolenMixtureDto[] | undefined;
    siteOrigin!: string | undefined;
    treeId!: number | undefined;
    id!: number;

    constructor(data?: IPolenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbp = _data["bbp"];
            this.polenNumber = _data["polenNumber"];
            this.physicalBBSTreeId = _data["physicalBBSTreeId"];
            this.bbs = _data["bbs"];
            this.physicalBBXTreeId = _data["physicalBBXTreeId"];
            this.bbx = _data["bbx"];
            this.generation = _data["generation"];
            this.originalTree = _data["originalTree"];
            this.idPolenHarvest = _data["idPolenHarvest"];
            this.species = _data["species"];
            this.species2 = _data["species2"];
            this.harvestDate = _data["harvestDate"] ? DateTime.fromISO(_data["harvestDate"].toString()) : undefined as any;
            this.initialStock = _data["initialStock"];
            this.currentStock = _data["currentStock"];
            this.updateDate = _data["updateDate"] ? DateTime.fromISO(_data["updateDate"].toString()) : undefined as any;
            this.stockLocation = _data["stockLocation"];
            this.observations = _data["observations"];
            this.isMixture = _data["isMixture"];
            this.supplierId = _data["supplierId"];
            this.trialId = _data["trialId"];
            if (Array.isArray(_data["polenMixtures"])) {
                this.polenMixtures = [] as any;
                for (let item of _data["polenMixtures"])
                    this.polenMixtures!.push(_definitions_PolenMixtureDto.fromJS(item));
            }
            this.siteOrigin = _data["siteOrigin"];
            this.treeId = _data["treeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolenDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbp"] = this.bbp;
        data["polenNumber"] = this.polenNumber;
        data["physicalBBSTreeId"] = this.physicalBBSTreeId;
        data["bbs"] = this.bbs;
        data["physicalBBXTreeId"] = this.physicalBBXTreeId;
        data["bbx"] = this.bbx;
        data["generation"] = this.generation;
        data["originalTree"] = this.originalTree;
        data["idPolenHarvest"] = this.idPolenHarvest;
        data["species"] = this.species;
        data["species2"] = this.species2;
        data["harvestDate"] = this.harvestDate ? this.harvestDate.toString() : undefined as any;
        data["initialStock"] = this.initialStock;
        data["currentStock"] = this.currentStock;
        data["updateDate"] = this.updateDate ? this.updateDate.toString() : undefined as any;
        data["stockLocation"] = this.stockLocation;
        data["observations"] = this.observations;
        data["isMixture"] = this.isMixture;
        data["supplierId"] = this.supplierId;
        data["trialId"] = this.trialId;
        if (Array.isArray(this.polenMixtures)) {
            data["polenMixtures"] = [];
            for (let item of this.polenMixtures)
                data["polenMixtures"].push(item ? item.toJSON() : undefined as any);
        }
        data["siteOrigin"] = this.siteOrigin;
        data["treeId"] = this.treeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolenDto {
    bbp: string | undefined;
    polenNumber: number;
    physicalBBSTreeId: string | undefined;
    bbs: string | undefined;
    physicalBBXTreeId: string | undefined;
    bbx: string | undefined;
    generation: string | undefined;
    originalTree: string | undefined;
    idPolenHarvest: string | undefined;
    species: string | undefined;
    species2: string | undefined;
    harvestDate: DateTime;
    initialStock: number;
    currentStock: number;
    updateDate: DateTime | undefined;
    stockLocation: string | undefined;
    observations: string | undefined;
    isMixture: boolean;
    supplierId: number;
    trialId: number | undefined;
    polenMixtures: _definitions_PolenMixtureDto[] | undefined;
    siteOrigin: string | undefined;
    treeId: number | undefined;
    id: number;
}

export class PolenLookupTableDto implements IPolenLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPolenLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PolenLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPolenLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PolenMixture implements IPolenMixture {
    tenantId!: number | undefined;
    bbpCompositionName!: string;
    porcentage!: number;
    polenCompositionId!: number;
    polenComposition!: Polen;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPolenMixture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bbpCompositionName = _data["bbpCompositionName"];
            this.porcentage = _data["porcentage"];
            this.polenCompositionId = _data["polenCompositionId"];
            this.polenComposition = _data["polenComposition"] ? Polen.fromJS(_data["polenComposition"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolenMixture {
        data = typeof data === 'object' ? data : {};
        let result = new PolenMixture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bbpCompositionName"] = this.bbpCompositionName;
        data["porcentage"] = this.porcentage;
        data["polenCompositionId"] = this.polenCompositionId;
        data["polenComposition"] = this.polenComposition ? this.polenComposition.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolenMixture {
    tenantId: number | undefined;
    bbpCompositionName: string;
    porcentage: number;
    polenCompositionId: number;
    polenComposition: Polen;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PolenStockDto implements IPolenStockDto {
    polenId!: number | undefined;
    bbp!: string | undefined;
    polenNumber!: number;
    polenSpecies!: string | undefined;
    polenHarvestDate!: DateTime;
    polenStockLocation!: string | undefined;
    polenObservation!: string | undefined;
    polenUpdateDate!: DateTime | undefined;
    polenCurrentStock!: number | undefined;

    constructor(data?: IPolenStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polenId = _data["polenId"];
            this.bbp = _data["bbp"];
            this.polenNumber = _data["polenNumber"];
            this.polenSpecies = _data["polenSpecies"];
            this.polenHarvestDate = _data["polenHarvestDate"] ? DateTime.fromISO(_data["polenHarvestDate"].toString()) : undefined as any;
            this.polenStockLocation = _data["polenStockLocation"];
            this.polenObservation = _data["polenObservation"];
            this.polenUpdateDate = _data["polenUpdateDate"] ? DateTime.fromISO(_data["polenUpdateDate"].toString()) : undefined as any;
            this.polenCurrentStock = _data["polenCurrentStock"];
        }
    }

    static fromJS(data: any): PolenStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polenId"] = this.polenId;
        data["bbp"] = this.bbp;
        data["polenNumber"] = this.polenNumber;
        data["polenSpecies"] = this.polenSpecies;
        data["polenHarvestDate"] = this.polenHarvestDate ? this.polenHarvestDate.toString() : undefined as any;
        data["polenStockLocation"] = this.polenStockLocation;
        data["polenObservation"] = this.polenObservation;
        data["polenUpdateDate"] = this.polenUpdateDate ? this.polenUpdateDate.toString() : undefined as any;
        data["polenCurrentStock"] = this.polenCurrentStock;
        return data;
    }
}

export interface IPolenStockDto {
    polenId: number | undefined;
    bbp: string | undefined;
    polenNumber: number;
    polenSpecies: string | undefined;
    polenHarvestDate: DateTime;
    polenStockLocation: string | undefined;
    polenObservation: string | undefined;
    polenUpdateDate: DateTime | undefined;
    polenCurrentStock: number | undefined;
}

export class PolenStockMovementDto implements IPolenStockMovementDto {
    stockType!: string | undefined;
    quantityStock!: number;
    updateDate!: DateTime;
    stockLocation!: string | undefined;
    observation!: string | undefined;
    polenId!: number;
    progeniesStatesId!: number;
    progeniesStatesTwoId!: number;
    id!: number;

    constructor(data?: IPolenStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockType = _data["stockType"];
            this.quantityStock = _data["quantityStock"];
            this.updateDate = _data["updateDate"] ? DateTime.fromISO(_data["updateDate"].toString()) : undefined as any;
            this.stockLocation = _data["stockLocation"];
            this.observation = _data["observation"];
            this.polenId = _data["polenId"];
            this.progeniesStatesId = _data["progeniesStatesId"];
            this.progeniesStatesTwoId = _data["progeniesStatesTwoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolenStockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenStockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockType"] = this.stockType;
        data["quantityStock"] = this.quantityStock;
        data["updateDate"] = this.updateDate ? this.updateDate.toString() : undefined as any;
        data["stockLocation"] = this.stockLocation;
        data["observation"] = this.observation;
        data["polenId"] = this.polenId;
        data["progeniesStatesId"] = this.progeniesStatesId;
        data["progeniesStatesTwoId"] = this.progeniesStatesTwoId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolenStockMovementDto {
    stockType: string | undefined;
    quantityStock: number;
    updateDate: DateTime;
    stockLocation: string | undefined;
    observation: string | undefined;
    polenId: number;
    progeniesStatesId: number;
    progeniesStatesTwoId: number;
    id: number;
}

export class PolenSupplierLookupTableDto implements IPolenSupplierLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPolenSupplierLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PolenSupplierLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenSupplierLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPolenSupplierLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PolenTreeLookupTableDto implements IPolenTreeLookupTableDto {
    dataBBS!: string | undefined;
    id!: number;
    displayName!: string | undefined;
    displayTreeName!: string | undefined;
    dataBBX!: string | undefined;
    dataBBT!: string | undefined;
    displayGeneration!: string | undefined;
    dataTrial!: number;
    dataSpecie!: string | undefined;
    dataSpecie2!: string | undefined;
    dataBBSId!: number | undefined;
    dataBBXId!: number | undefined;
    dataBBTId!: number | undefined;
    dataTrialId!: number;
    dataFarmName!: string | undefined;
    dataStandName!: string | undefined;
    dataOriginalTree!: string | undefined;

    constructor(data?: IPolenTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataBBS = _data["dataBBS"];
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBT = _data["dataBBT"];
            this.displayGeneration = _data["displayGeneration"];
            this.dataTrial = _data["dataTrial"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataSpecie2 = _data["dataSpecie2"];
            this.dataBBSId = _data["dataBBSId"];
            this.dataBBXId = _data["dataBBXId"];
            this.dataBBTId = _data["dataBBTId"];
            this.dataTrialId = _data["dataTrialId"];
            this.dataFarmName = _data["dataFarmName"];
            this.dataStandName = _data["dataStandName"];
            this.dataOriginalTree = _data["dataOriginalTree"];
        }
    }

    static fromJS(data: any): PolenTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataBBS"] = this.dataBBS;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeName"] = this.displayTreeName;
        data["dataBBX"] = this.dataBBX;
        data["dataBBT"] = this.dataBBT;
        data["displayGeneration"] = this.displayGeneration;
        data["dataTrial"] = this.dataTrial;
        data["dataSpecie"] = this.dataSpecie;
        data["dataSpecie2"] = this.dataSpecie2;
        data["dataBBSId"] = this.dataBBSId;
        data["dataBBXId"] = this.dataBBXId;
        data["dataBBTId"] = this.dataBBTId;
        data["dataTrialId"] = this.dataTrialId;
        data["dataFarmName"] = this.dataFarmName;
        data["dataStandName"] = this.dataStandName;
        data["dataOriginalTree"] = this.dataOriginalTree;
        return data;
    }
}

export interface IPolenTreeLookupTableDto {
    dataBBS: string | undefined;
    id: number;
    displayName: string | undefined;
    displayTreeName: string | undefined;
    dataBBX: string | undefined;
    dataBBT: string | undefined;
    displayGeneration: string | undefined;
    dataTrial: number;
    dataSpecie: string | undefined;
    dataSpecie2: string | undefined;
    dataBBSId: number | undefined;
    dataBBXId: number | undefined;
    dataBBTId: number | undefined;
    dataTrialId: number;
    dataFarmName: string | undefined;
    dataStandName: string | undefined;
    dataOriginalTree: string | undefined;
}

export class PolenTrialLookupTableDto implements IPolenTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPolenTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PolenTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolenTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPolenTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PorcentajeBBXCloneLookupTableDto implements IPorcentajeBBXCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPorcentajeBBXCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PorcentajeBBXCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PorcentajeBBXCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPorcentajeBBXCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PorcentajeBBXDto implements IPorcentajeBBXDto {
    dateHarvest!: DateTime;
    percentage!: number | undefined;
    cloneId!: number | undefined;
    projectId!: number | undefined;
    measurementSelectionId!: number | undefined;
    id!: number;

    constructor(data?: IPorcentajeBBXDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateHarvest = _data["dateHarvest"] ? DateTime.fromISO(_data["dateHarvest"].toString()) : undefined as any;
            this.percentage = _data["percentage"];
            this.cloneId = _data["cloneId"];
            this.projectId = _data["projectId"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PorcentajeBBXDto {
        data = typeof data === 'object' ? data : {};
        let result = new PorcentajeBBXDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateHarvest"] = this.dateHarvest ? this.dateHarvest.toString() : undefined as any;
        data["percentage"] = this.percentage;
        data["cloneId"] = this.cloneId;
        data["projectId"] = this.projectId;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPorcentajeBBXDto {
    dateHarvest: DateTime;
    percentage: number | undefined;
    cloneId: number | undefined;
    projectId: number | undefined;
    measurementSelectionId: number | undefined;
    id: number;
}

export class PorcentajeBBXMeasurementSelectionLookupTableDto implements IPorcentajeBBXMeasurementSelectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPorcentajeBBXMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PorcentajeBBXMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PorcentajeBBXMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPorcentajeBBXMeasurementSelectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ProductivityGroupDto implements IProductivityGroupDto {
    groupNumber!: number;
    rootingPercentage!: number | undefined;
    totalQuantity!: number;
    stakeCount!: number;
    bbxCode!: string | undefined;

    constructor(data?: IProductivityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupNumber = _data["groupNumber"];
            this.rootingPercentage = _data["rootingPercentage"];
            this.totalQuantity = _data["totalQuantity"];
            this.stakeCount = _data["stakeCount"];
            this.bbxCode = _data["bbxCode"];
        }
    }

    static fromJS(data: any): ProductivityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupNumber"] = this.groupNumber;
        data["rootingPercentage"] = this.rootingPercentage;
        data["totalQuantity"] = this.totalQuantity;
        data["stakeCount"] = this.stakeCount;
        data["bbxCode"] = this.bbxCode;
        return data;
    }
}

export interface IProductivityGroupDto {
    groupNumber: number;
    rootingPercentage: number | undefined;
    totalQuantity: number;
    stakeCount: number;
    bbxCode: string | undefined;
}

export class ProgeniesStateDto implements IProgeniesStateDto {
    state!: string | undefined;
    id!: number;

    constructor(data?: IProgeniesStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgeniesStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgeniesStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface IProgeniesStateDto {
    state: string | undefined;
    id: number;
}

export class ProgeniesStateTwoDto implements IProgeniesStateTwoDto {
    state!: string | undefined;
    id!: number;

    constructor(data?: IProgeniesStateTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgeniesStateTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgeniesStateTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface IProgeniesStateTwoDto {
    state: string | undefined;
    id: number;
}

export class Project implements IProject {
    tenantId!: number | undefined;
    name!: string;
    date!: DateTime;
    laboratoryProjectTypeId!: number;
    laboratoryProjectTypeFk!: LaboratoryProject;
    laboratoryProjectStatusId!: number | undefined;
    laboratoryProjectStatusFk!: LaboratoryProjectStatus;
    measurementSelection!: MeasurementSelection[] | undefined;
    measurementSelectionGenomic!: MeasurementSelectionGenomic[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.laboratoryProjectTypeFk = _data["laboratoryProjectTypeFk"] ? LaboratoryProject.fromJS(_data["laboratoryProjectTypeFk"]) : undefined as any;
            this.laboratoryProjectStatusId = _data["laboratoryProjectStatusId"];
            this.laboratoryProjectStatusFk = _data["laboratoryProjectStatusFk"] ? LaboratoryProjectStatus.fromJS(_data["laboratoryProjectStatusFk"]) : undefined as any;
            if (Array.isArray(_data["measurementSelection"])) {
                this.measurementSelection = [] as any;
                for (let item of _data["measurementSelection"])
                    this.measurementSelection!.push(MeasurementSelection.fromJS(item));
            }
            if (Array.isArray(_data["measurementSelectionGenomic"])) {
                this.measurementSelectionGenomic = [] as any;
                for (let item of _data["measurementSelectionGenomic"])
                    this.measurementSelectionGenomic!.push(MeasurementSelectionGenomic.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["laboratoryProjectTypeFk"] = this.laboratoryProjectTypeFk ? this.laboratoryProjectTypeFk.toJSON() : undefined as any;
        data["laboratoryProjectStatusId"] = this.laboratoryProjectStatusId;
        data["laboratoryProjectStatusFk"] = this.laboratoryProjectStatusFk ? this.laboratoryProjectStatusFk.toJSON() : undefined as any;
        if (Array.isArray(this.measurementSelection)) {
            data["measurementSelection"] = [];
            for (let item of this.measurementSelection)
                data["measurementSelection"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementSelectionGenomic)) {
            data["measurementSelectionGenomic"] = [];
            for (let item of this.measurementSelectionGenomic)
                data["measurementSelectionGenomic"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProject {
    tenantId: number | undefined;
    name: string;
    date: DateTime;
    laboratoryProjectTypeId: number;
    laboratoryProjectTypeFk: LaboratoryProject;
    laboratoryProjectStatusId: number | undefined;
    laboratoryProjectStatusFk: LaboratoryProjectStatus;
    measurementSelection: MeasurementSelection[] | undefined;
    measurementSelectionGenomic: MeasurementSelectionGenomic[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProjectConfiguration implements IProjectConfiguration {
    tenantId!: number | undefined;
    prom_Sob!: number | undefined;
    prom_graves!: number | undefined;
    prom_Zvol_Ha!: number | undefined;
    rank_Zvol_Ha!: number | undefined;
    verEnCampo!: boolean;
    isDiscoSelection!: boolean;
    isChipSelection!: boolean;
    trialsList!: Trial[] | undefined;
    trialNumbers!: string | undefined;
    projectId!: number;
    projectFk!: Project;
    cloneId!: number | undefined;
    cloneFk!: Clone;
    seedId!: number | undefined;
    seedFk!: Seed;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProjectConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.prom_Sob = _data["prom_Sob"];
            this.prom_graves = _data["prom_graves"];
            this.prom_Zvol_Ha = _data["prom_Zvol_Ha"];
            this.rank_Zvol_Ha = _data["rank_Zvol_Ha"];
            this.verEnCampo = _data["verEnCampo"];
            this.isDiscoSelection = _data["isDiscoSelection"];
            this.isChipSelection = _data["isChipSelection"];
            if (Array.isArray(_data["trialsList"])) {
                this.trialsList = [] as any;
                for (let item of _data["trialsList"])
                    this.trialsList!.push(Trial.fromJS(item));
            }
            this.trialNumbers = _data["trialNumbers"];
            this.projectId = _data["projectId"];
            this.projectFk = _data["projectFk"] ? Project.fromJS(_data["projectFk"]) : undefined as any;
            this.cloneId = _data["cloneId"];
            this.cloneFk = _data["cloneFk"] ? Clone.fromJS(_data["cloneFk"]) : undefined as any;
            this.seedId = _data["seedId"];
            this.seedFk = _data["seedFk"] ? Seed.fromJS(_data["seedFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["prom_Sob"] = this.prom_Sob;
        data["prom_graves"] = this.prom_graves;
        data["prom_Zvol_Ha"] = this.prom_Zvol_Ha;
        data["rank_Zvol_Ha"] = this.rank_Zvol_Ha;
        data["verEnCampo"] = this.verEnCampo;
        data["isDiscoSelection"] = this.isDiscoSelection;
        data["isChipSelection"] = this.isChipSelection;
        if (Array.isArray(this.trialsList)) {
            data["trialsList"] = [];
            for (let item of this.trialsList)
                data["trialsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["trialNumbers"] = this.trialNumbers;
        data["projectId"] = this.projectId;
        data["projectFk"] = this.projectFk ? this.projectFk.toJSON() : undefined as any;
        data["cloneId"] = this.cloneId;
        data["cloneFk"] = this.cloneFk ? this.cloneFk.toJSON() : undefined as any;
        data["seedId"] = this.seedId;
        data["seedFk"] = this.seedFk ? this.seedFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectConfiguration {
    tenantId: number | undefined;
    prom_Sob: number | undefined;
    prom_graves: number | undefined;
    prom_Zvol_Ha: number | undefined;
    rank_Zvol_Ha: number | undefined;
    verEnCampo: boolean;
    isDiscoSelection: boolean;
    isChipSelection: boolean;
    trialsList: Trial[] | undefined;
    trialNumbers: string | undefined;
    projectId: number;
    projectFk: Project;
    cloneId: number | undefined;
    cloneFk: Clone;
    seedId: number | undefined;
    seedFk: Seed;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProjectConfigurationDto implements IProjectConfigurationDto {
    prom_Sob!: number | undefined;
    prom_graves!: number | undefined;
    prom_Zvol_Ha!: number | undefined;
    rank_Zvol_Ha!: number | undefined;
    verEnCampo!: boolean;
    isDiscoSelection!: boolean;
    isChipSelection!: boolean;
    cloneId!: number | undefined;
    seedId!: number | undefined;
    projectId!: number;
    trialNumbers!: string | undefined;
    id!: number;

    constructor(data?: IProjectConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prom_Sob = _data["prom_Sob"];
            this.prom_graves = _data["prom_graves"];
            this.prom_Zvol_Ha = _data["prom_Zvol_Ha"];
            this.rank_Zvol_Ha = _data["rank_Zvol_Ha"];
            this.verEnCampo = _data["verEnCampo"];
            this.isDiscoSelection = _data["isDiscoSelection"];
            this.isChipSelection = _data["isChipSelection"];
            this.cloneId = _data["cloneId"];
            this.seedId = _data["seedId"];
            this.projectId = _data["projectId"];
            this.trialNumbers = _data["trialNumbers"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prom_Sob"] = this.prom_Sob;
        data["prom_graves"] = this.prom_graves;
        data["prom_Zvol_Ha"] = this.prom_Zvol_Ha;
        data["rank_Zvol_Ha"] = this.rank_Zvol_Ha;
        data["verEnCampo"] = this.verEnCampo;
        data["isDiscoSelection"] = this.isDiscoSelection;
        data["isChipSelection"] = this.isChipSelection;
        data["cloneId"] = this.cloneId;
        data["seedId"] = this.seedId;
        data["projectId"] = this.projectId;
        data["trialNumbers"] = this.trialNumbers;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectConfigurationDto {
    prom_Sob: number | undefined;
    prom_graves: number | undefined;
    prom_Zvol_Ha: number | undefined;
    rank_Zvol_Ha: number | undefined;
    verEnCampo: boolean;
    isDiscoSelection: boolean;
    isChipSelection: boolean;
    cloneId: number | undefined;
    seedId: number | undefined;
    projectId: number;
    trialNumbers: string | undefined;
    id: number;
}

export class ProjectConfigurationSeedLookupTableDto implements IProjectConfigurationSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IProjectConfigurationSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ProjectConfigurationSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectConfigurationSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IProjectConfigurationSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ProjectDto implements IProjectDto {
    name!: string | undefined;
    date!: DateTime;
    laboratoryProjectTypeId!: number;
    laboratoryProjectStatusId!: number | undefined;
    laboratoryProjectTypeName!: string | undefined;
    laboratoryProjectStatusName!: string | undefined;
    id!: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.laboratoryProjectTypeId = _data["laboratoryProjectTypeId"];
            this.laboratoryProjectStatusId = _data["laboratoryProjectStatusId"];
            this.laboratoryProjectTypeName = _data["laboratoryProjectTypeName"];
            this.laboratoryProjectStatusName = _data["laboratoryProjectStatusName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["laboratoryProjectTypeId"] = this.laboratoryProjectTypeId;
        data["laboratoryProjectStatusId"] = this.laboratoryProjectStatusId;
        data["laboratoryProjectTypeName"] = this.laboratoryProjectTypeName;
        data["laboratoryProjectStatusName"] = this.laboratoryProjectStatusName;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectDto {
    name: string | undefined;
    date: DateTime;
    laboratoryProjectTypeId: number;
    laboratoryProjectStatusId: number | undefined;
    laboratoryProjectTypeName: string | undefined;
    laboratoryProjectStatusName: string | undefined;
    id: number;
}

export class ProjectLaboratoryProjectLookupTableDto implements IProjectLaboratoryProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IProjectLaboratoryProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ProjectLaboratoryProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLaboratoryProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IProjectLaboratoryProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ProjectLaboratoryProjectStatusLookupTableDto implements IProjectLaboratoryProjectStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IProjectLaboratoryProjectStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ProjectLaboratoryProjectStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLaboratoryProjectStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IProjectLaboratoryProjectStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PromedioLabBbxBloque implements IPromedioLabBbxBloque {
    specieName!: string | undefined;
    specie!: string | undefined;
    dB_10!: number;
    age!: number;
    dB_Lab_FRB!: number;
    rP_Lab_FRB!: number;
    rP_Model!: number;
    typeMaterial!: string | undefined;
    bloque!: string | undefined;
    cloneId!: number;
    cloneName!: string | undefined;
    projectId!: number;
    projectName!: string | undefined;
    trialId!: number | undefined;

    constructor(data?: IPromedioLabBbxBloque) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specieName = _data["specieName"];
            this.specie = _data["specie"];
            this.dB_10 = _data["dB_10"];
            this.age = _data["age"];
            this.dB_Lab_FRB = _data["dB_Lab_FRB"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.rP_Model = _data["rP_Model"];
            this.typeMaterial = _data["typeMaterial"];
            this.bloque = _data["bloque"];
            this.cloneId = _data["cloneId"];
            this.cloneName = _data["cloneName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.trialId = _data["trialId"];
        }
    }

    static fromJS(data: any): PromedioLabBbxBloque {
        data = typeof data === 'object' ? data : {};
        let result = new PromedioLabBbxBloque();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specieName"] = this.specieName;
        data["specie"] = this.specie;
        data["dB_10"] = this.dB_10;
        data["age"] = this.age;
        data["dB_Lab_FRB"] = this.dB_Lab_FRB;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["rP_Model"] = this.rP_Model;
        data["typeMaterial"] = this.typeMaterial;
        data["bloque"] = this.bloque;
        data["cloneId"] = this.cloneId;
        data["cloneName"] = this.cloneName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["trialId"] = this.trialId;
        return data;
    }
}

export interface IPromedioLabBbxBloque {
    specieName: string | undefined;
    specie: string | undefined;
    dB_10: number;
    age: number;
    dB_Lab_FRB: number;
    rP_Lab_FRB: number;
    rP_Model: number;
    typeMaterial: string | undefined;
    bloque: string | undefined;
    cloneId: number;
    cloneName: string | undefined;
    projectId: number;
    projectName: string | undefined;
    trialId: number | undefined;
}

export class PromedioLabBbxDto implements IPromedioLabBbxDto {
    fechaCalculo!: DateTime;
    age!: number;
    dB_10!: number | undefined;
    dB_Lab_FRB!: number | undefined;
    rP_Lab_FRB!: number | undefined;
    rP_Model!: number | undefined;
    specieName!: string | undefined;
    specie!: string | undefined;
    bloque!: string | undefined;
    cloneId!: number;
    projectId!: number;
    trialId!: number | undefined;
    id!: number;

    constructor(data?: IPromedioLabBbxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fechaCalculo = _data["fechaCalculo"] ? DateTime.fromISO(_data["fechaCalculo"].toString()) : undefined as any;
            this.age = _data["age"];
            this.dB_10 = _data["dB_10"];
            this.dB_Lab_FRB = _data["dB_Lab_FRB"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.rP_Model = _data["rP_Model"];
            this.specieName = _data["specieName"];
            this.specie = _data["specie"];
            this.bloque = _data["bloque"];
            this.cloneId = _data["cloneId"];
            this.projectId = _data["projectId"];
            this.trialId = _data["trialId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PromedioLabBbxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromedioLabBbxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fechaCalculo"] = this.fechaCalculo ? this.fechaCalculo.toString() : undefined as any;
        data["age"] = this.age;
        data["dB_10"] = this.dB_10;
        data["dB_Lab_FRB"] = this.dB_Lab_FRB;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["rP_Model"] = this.rP_Model;
        data["specieName"] = this.specieName;
        data["specie"] = this.specie;
        data["bloque"] = this.bloque;
        data["cloneId"] = this.cloneId;
        data["projectId"] = this.projectId;
        data["trialId"] = this.trialId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPromedioLabBbxDto {
    fechaCalculo: DateTime;
    age: number;
    dB_10: number | undefined;
    dB_Lab_FRB: number | undefined;
    rP_Lab_FRB: number | undefined;
    rP_Model: number | undefined;
    specieName: string | undefined;
    specie: string | undefined;
    bloque: string | undefined;
    cloneId: number;
    projectId: number;
    trialId: number | undefined;
    id: number;
}

export class PromedioLabBbxEnsayo implements IPromedioLabBbxEnsayo {
    specieName!: string | undefined;
    specie!: string | undefined;
    dB_10!: number;
    age!: number;
    dB_Lab_FRB!: number;
    rP_Lab_FRB!: number;
    rP_Model!: number;
    typeMaterial!: string | undefined;
    cloneId!: number;
    cloneName!: string | undefined;
    projectId!: number;
    projectName!: string | undefined;
    trialId!: number | undefined;
    promBloque!: PromedioLabBbxBloque[] | undefined;

    constructor(data?: IPromedioLabBbxEnsayo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specieName = _data["specieName"];
            this.specie = _data["specie"];
            this.dB_10 = _data["dB_10"];
            this.age = _data["age"];
            this.dB_Lab_FRB = _data["dB_Lab_FRB"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.rP_Model = _data["rP_Model"];
            this.typeMaterial = _data["typeMaterial"];
            this.cloneId = _data["cloneId"];
            this.cloneName = _data["cloneName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.trialId = _data["trialId"];
            if (Array.isArray(_data["promBloque"])) {
                this.promBloque = [] as any;
                for (let item of _data["promBloque"])
                    this.promBloque!.push(PromedioLabBbxBloque.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromedioLabBbxEnsayo {
        data = typeof data === 'object' ? data : {};
        let result = new PromedioLabBbxEnsayo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specieName"] = this.specieName;
        data["specie"] = this.specie;
        data["dB_10"] = this.dB_10;
        data["age"] = this.age;
        data["dB_Lab_FRB"] = this.dB_Lab_FRB;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["rP_Model"] = this.rP_Model;
        data["typeMaterial"] = this.typeMaterial;
        data["cloneId"] = this.cloneId;
        data["cloneName"] = this.cloneName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["trialId"] = this.trialId;
        if (Array.isArray(this.promBloque)) {
            data["promBloque"] = [];
            for (let item of this.promBloque)
                data["promBloque"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPromedioLabBbxEnsayo {
    specieName: string | undefined;
    specie: string | undefined;
    dB_10: number;
    age: number;
    dB_Lab_FRB: number;
    rP_Lab_FRB: number;
    rP_Model: number;
    typeMaterial: string | undefined;
    cloneId: number;
    cloneName: string | undefined;
    projectId: number;
    projectName: string | undefined;
    trialId: number | undefined;
    promBloque: PromedioLabBbxBloque[] | undefined;
}

export class PromedioLabBbxproyecto implements IPromedioLabBbxproyecto {
    specieName!: string | undefined;
    specie!: string | undefined;
    dB_10!: number;
    age!: number;
    dB_Lab_FRB!: number;
    rP_Lab_FRB!: number;
    rP_Model!: number;
    typeMaterial!: string | undefined;
    cloneId!: number;
    cloneName!: string | undefined;
    projectId!: number;
    projectName!: string | undefined;
    trialId!: number | undefined;
    promEnsayo!: PromedioLabBbxEnsayo[] | undefined;

    constructor(data?: IPromedioLabBbxproyecto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specieName = _data["specieName"];
            this.specie = _data["specie"];
            this.dB_10 = _data["dB_10"];
            this.age = _data["age"];
            this.dB_Lab_FRB = _data["dB_Lab_FRB"];
            this.rP_Lab_FRB = _data["rP_Lab_FRB"];
            this.rP_Model = _data["rP_Model"];
            this.typeMaterial = _data["typeMaterial"];
            this.cloneId = _data["cloneId"];
            this.cloneName = _data["cloneName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.trialId = _data["trialId"];
            if (Array.isArray(_data["promEnsayo"])) {
                this.promEnsayo = [] as any;
                for (let item of _data["promEnsayo"])
                    this.promEnsayo!.push(PromedioLabBbxEnsayo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromedioLabBbxproyecto {
        data = typeof data === 'object' ? data : {};
        let result = new PromedioLabBbxproyecto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specieName"] = this.specieName;
        data["specie"] = this.specie;
        data["dB_10"] = this.dB_10;
        data["age"] = this.age;
        data["dB_Lab_FRB"] = this.dB_Lab_FRB;
        data["rP_Lab_FRB"] = this.rP_Lab_FRB;
        data["rP_Model"] = this.rP_Model;
        data["typeMaterial"] = this.typeMaterial;
        data["cloneId"] = this.cloneId;
        data["cloneName"] = this.cloneName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["trialId"] = this.trialId;
        if (Array.isArray(this.promEnsayo)) {
            data["promEnsayo"] = [];
            for (let item of this.promEnsayo)
                data["promEnsayo"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPromedioLabBbxproyecto {
    specieName: string | undefined;
    specie: string | undefined;
    dB_10: number;
    age: number;
    dB_Lab_FRB: number;
    rP_Lab_FRB: number;
    rP_Model: number;
    typeMaterial: string | undefined;
    cloneId: number;
    cloneName: string | undefined;
    projectId: number;
    projectName: string | undefined;
    trialId: number | undefined;
    promEnsayo: PromedioLabBbxEnsayo[] | undefined;
}

export class PromedioLabBbxproyectoPage implements IPromedioLabBbxproyectoPage {
    items!: TreeNodeBackendProyecto[] | undefined;
    totalCount!: number;

    constructor(data?: IPromedioLabBbxproyectoPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TreeNodeBackendProyecto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PromedioLabBbxproyectoPage {
        data = typeof data === 'object' ? data : {};
        let result = new PromedioLabBbxproyectoPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPromedioLabBbxproyectoPage {
    items: TreeNodeBackendProyecto[] | undefined;
    totalCount: number;
}

export class QualityClassificationDto implements IQualityClassificationDto {
    qualityClassificationTypeId!: number;
    classification!: string | undefined;
    id!: number;

    constructor(data?: IQualityClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityClassificationTypeId = _data["qualityClassificationTypeId"];
            this.classification = _data["classification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualityClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualityClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityClassificationTypeId"] = this.qualityClassificationTypeId;
        data["classification"] = this.classification;
        data["id"] = this.id;
        return data;
    }
}

export interface IQualityClassificationDto {
    qualityClassificationTypeId: number;
    classification: string | undefined;
    id: number;
}

export class QualityClassificationTypeDto implements IQualityClassificationTypeDto {
    type!: string | undefined;
    id!: number;

    constructor(data?: IQualityClassificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualityClassificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualityClassificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IQualityClassificationTypeDto {
    type: string | undefined;
    id: number;
}

export class QualityControlDto implements IQualityControlDto {
    qualityCode!: string | undefined;
    trialId!: number;
    controlDate!: DateTime;
    height!: number | undefined;
    dac!: number | undefined;
    qualityAppearanceClassificationId!: number | undefined;
    qualityPanClassificationId!: number | undefined;
    qualityResultClassificationId!: number | undefined;
    qualityAverageClassificationId!: number | undefined;
    qualityFieldObsClassificationId!: number | undefined;
    qualityFieldClassificationId!: number | undefined;
    qualityReplantingReasonClassificationId!: number | undefined;
    qualityReasonClassificationId!: number | undefined;
    qualityObservationClassificationId!: number | undefined;
    id!: number;

    constructor(data?: IQualityControlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityCode = _data["qualityCode"];
            this.trialId = _data["trialId"];
            this.controlDate = _data["controlDate"] ? DateTime.fromISO(_data["controlDate"].toString()) : undefined as any;
            this.height = _data["height"];
            this.dac = _data["dac"];
            this.qualityAppearanceClassificationId = _data["qualityAppearanceClassificationId"];
            this.qualityPanClassificationId = _data["qualityPanClassificationId"];
            this.qualityResultClassificationId = _data["qualityResultClassificationId"];
            this.qualityAverageClassificationId = _data["qualityAverageClassificationId"];
            this.qualityFieldObsClassificationId = _data["qualityFieldObsClassificationId"];
            this.qualityFieldClassificationId = _data["qualityFieldClassificationId"];
            this.qualityReplantingReasonClassificationId = _data["qualityReplantingReasonClassificationId"];
            this.qualityReasonClassificationId = _data["qualityReasonClassificationId"];
            this.qualityObservationClassificationId = _data["qualityObservationClassificationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualityControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualityControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityCode"] = this.qualityCode;
        data["trialId"] = this.trialId;
        data["controlDate"] = this.controlDate ? this.controlDate.toString() : undefined as any;
        data["height"] = this.height;
        data["dac"] = this.dac;
        data["qualityAppearanceClassificationId"] = this.qualityAppearanceClassificationId;
        data["qualityPanClassificationId"] = this.qualityPanClassificationId;
        data["qualityResultClassificationId"] = this.qualityResultClassificationId;
        data["qualityAverageClassificationId"] = this.qualityAverageClassificationId;
        data["qualityFieldObsClassificationId"] = this.qualityFieldObsClassificationId;
        data["qualityFieldClassificationId"] = this.qualityFieldClassificationId;
        data["qualityReplantingReasonClassificationId"] = this.qualityReplantingReasonClassificationId;
        data["qualityReasonClassificationId"] = this.qualityReasonClassificationId;
        data["qualityObservationClassificationId"] = this.qualityObservationClassificationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IQualityControlDto {
    qualityCode: string | undefined;
    trialId: number;
    controlDate: DateTime;
    height: number | undefined;
    dac: number | undefined;
    qualityAppearanceClassificationId: number | undefined;
    qualityPanClassificationId: number | undefined;
    qualityResultClassificationId: number | undefined;
    qualityAverageClassificationId: number | undefined;
    qualityFieldObsClassificationId: number | undefined;
    qualityFieldClassificationId: number | undefined;
    qualityReplantingReasonClassificationId: number | undefined;
    qualityReasonClassificationId: number | undefined;
    qualityObservationClassificationId: number | undefined;
    id: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class RequestFileBlobStorageDto implements IRequestFileBlobStorageDto {
    tag!: string | undefined;
    masterId!: string | undefined;
    masterType!: string | undefined;
    id!: number;

    constructor(data?: IRequestFileBlobStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.masterId = _data["masterId"];
            this.masterType = _data["masterType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestFileBlobStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFileBlobStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["masterId"] = this.masterId;
        data["masterType"] = this.masterType;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestFileBlobStorageDto {
    tag: string | undefined;
    masterId: string | undefined;
    masterType: string | undefined;
    id: number;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RoatingporcentajeTrayCloneLookupTableDto implements IRoatingporcentajeTrayCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRoatingporcentajeTrayCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTrayCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTrayCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoatingporcentajeTrayCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RoatingporcentajeTrayDto implements IRoatingporcentajeTrayDto {
    idBandeja!: number;
    etiquetaBandeja!: string | undefined;
    origenBandeja!: string | undefined;
    fechaConteoInicial!: DateTime;
    cantidadPlantasIniciales!: number;
    zonaCrecimiento!: string | undefined;
    fechaEntradaCrecimiento!: DateTime | undefined;
    fechaEntradaEnraizamiento!: DateTime;
    zonaEnraizamiento!: string | undefined;
    cantidadConteoFinal!: number | undefined;
    fechaPlantasFinal!: DateTime | undefined;
    observacion!: string | undefined;
    fechaCensoFinal!: DateTime | undefined;
    censoFinal!: number | undefined;
    porcentajeEnraizamiento!: number | undefined;
    seedId!: number | undefined;
    projectId!: number | undefined;
    measurementSelectionId!: number | undefined;
    cloneId!: number | undefined;
    sourcePlantId!: number;
    destinos!: string | undefined;
    fechaCosecha!: DateTime | undefined;
    trials!: string | undefined;
    readonly fechaCosechaMesAnio!: string | undefined;
    id!: number;

    constructor(data?: IRoatingporcentajeTrayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idBandeja = _data["idBandeja"];
            this.etiquetaBandeja = _data["etiquetaBandeja"];
            this.origenBandeja = _data["origenBandeja"];
            this.fechaConteoInicial = _data["fechaConteoInicial"] ? DateTime.fromISO(_data["fechaConteoInicial"].toString()) : undefined as any;
            this.cantidadPlantasIniciales = _data["cantidadPlantasIniciales"];
            this.zonaCrecimiento = _data["zonaCrecimiento"];
            this.fechaEntradaCrecimiento = _data["fechaEntradaCrecimiento"] ? DateTime.fromISO(_data["fechaEntradaCrecimiento"].toString()) : undefined as any;
            this.fechaEntradaEnraizamiento = _data["fechaEntradaEnraizamiento"] ? DateTime.fromISO(_data["fechaEntradaEnraizamiento"].toString()) : undefined as any;
            this.zonaEnraizamiento = _data["zonaEnraizamiento"];
            this.cantidadConteoFinal = _data["cantidadConteoFinal"];
            this.fechaPlantasFinal = _data["fechaPlantasFinal"] ? DateTime.fromISO(_data["fechaPlantasFinal"].toString()) : undefined as any;
            this.observacion = _data["observacion"];
            this.fechaCensoFinal = _data["fechaCensoFinal"] ? DateTime.fromISO(_data["fechaCensoFinal"].toString()) : undefined as any;
            this.censoFinal = _data["censoFinal"];
            this.porcentajeEnraizamiento = _data["porcentajeEnraizamiento"];
            this.seedId = _data["seedId"];
            this.projectId = _data["projectId"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.cloneId = _data["cloneId"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.destinos = _data["destinos"];
            this.fechaCosecha = _data["fechaCosecha"] ? DateTime.fromISO(_data["fechaCosecha"].toString()) : undefined as any;
            this.trials = _data["trials"];
            (this as any).fechaCosechaMesAnio = _data["fechaCosechaMesAnio"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTrayDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTrayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idBandeja"] = this.idBandeja;
        data["etiquetaBandeja"] = this.etiquetaBandeja;
        data["origenBandeja"] = this.origenBandeja;
        data["fechaConteoInicial"] = this.fechaConteoInicial ? this.fechaConteoInicial.toString() : undefined as any;
        data["cantidadPlantasIniciales"] = this.cantidadPlantasIniciales;
        data["zonaCrecimiento"] = this.zonaCrecimiento;
        data["fechaEntradaCrecimiento"] = this.fechaEntradaCrecimiento ? this.fechaEntradaCrecimiento.toString() : undefined as any;
        data["fechaEntradaEnraizamiento"] = this.fechaEntradaEnraizamiento ? this.fechaEntradaEnraizamiento.toString() : undefined as any;
        data["zonaEnraizamiento"] = this.zonaEnraizamiento;
        data["cantidadConteoFinal"] = this.cantidadConteoFinal;
        data["fechaPlantasFinal"] = this.fechaPlantasFinal ? this.fechaPlantasFinal.toString() : undefined as any;
        data["observacion"] = this.observacion;
        data["fechaCensoFinal"] = this.fechaCensoFinal ? this.fechaCensoFinal.toString() : undefined as any;
        data["censoFinal"] = this.censoFinal;
        data["porcentajeEnraizamiento"] = this.porcentajeEnraizamiento;
        data["seedId"] = this.seedId;
        data["projectId"] = this.projectId;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["cloneId"] = this.cloneId;
        data["sourcePlantId"] = this.sourcePlantId;
        data["destinos"] = this.destinos;
        data["fechaCosecha"] = this.fechaCosecha ? this.fechaCosecha.toString() : undefined as any;
        data["trials"] = this.trials;
        data["fechaCosechaMesAnio"] = this.fechaCosechaMesAnio;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoatingporcentajeTrayDto {
    idBandeja: number;
    etiquetaBandeja: string | undefined;
    origenBandeja: string | undefined;
    fechaConteoInicial: DateTime;
    cantidadPlantasIniciales: number;
    zonaCrecimiento: string | undefined;
    fechaEntradaCrecimiento: DateTime | undefined;
    fechaEntradaEnraizamiento: DateTime;
    zonaEnraizamiento: string | undefined;
    cantidadConteoFinal: number | undefined;
    fechaPlantasFinal: DateTime | undefined;
    observacion: string | undefined;
    fechaCensoFinal: DateTime | undefined;
    censoFinal: number | undefined;
    porcentajeEnraizamiento: number | undefined;
    seedId: number | undefined;
    projectId: number | undefined;
    measurementSelectionId: number | undefined;
    cloneId: number | undefined;
    sourcePlantId: number;
    destinos: string | undefined;
    fechaCosecha: DateTime | undefined;
    trials: string | undefined;
    fechaCosechaMesAnio: string | undefined;
    id: number;
}

export class RoatingporcentajeTrayMeasurementSelectionLookupTableDto implements IRoatingporcentajeTrayMeasurementSelectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRoatingporcentajeTrayMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTrayMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTrayMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoatingporcentajeTrayMeasurementSelectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RoatingporcentajeTrayProjectLookupTableDto implements IRoatingporcentajeTrayProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRoatingporcentajeTrayProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTrayProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTrayProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoatingporcentajeTrayProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RoatingporcentajeTraySeedLookupTableDto implements IRoatingporcentajeTraySeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRoatingporcentajeTraySeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTraySeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTraySeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoatingporcentajeTraySeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RoatingporcentajeTraySourcePlantLookupTableDto implements IRoatingporcentajeTraySourcePlantLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRoatingporcentajeTraySourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoatingporcentajeTraySourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoatingporcentajeTraySourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoatingporcentajeTraySourcePlantLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
    id: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    readonly value!: any;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).value = _data["value"];
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: any;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : undefined as any;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : undefined as any;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : undefined as any;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined as any;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined as any;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined as any;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class Seed implements ISeed {
    tenantId!: number | undefined;
    bbs!: string;
    loteNumber!: number;
    species!: string;
    speciesNameId!: number | undefined;
    speciesNameFk!: SpeciesGroup;
    receivedDate!: DateTime;
    supplierCode!: string | undefined;
    idMotherTree!: string | undefined;
    bbsMother!: string | undefined;
    blockMother!: number;
    subBlockMother!: number;
    treeNumberMother!: number;
    speciesMother!: string | undefined;
    idTrialMothre!: number | undefined;
    bbxMother!: string | undefined;
    bbxidTreeMother!: string | undefined;
    bbpFather!: string | undefined;
    idFatherTree!: string | undefined;
    idTrialFather!: number | undefined;
    bbsFather!: string | undefined;
    blockFather!: number | undefined;
    subBlockFather!: number | undefined;
    treeNumberFather!: number | undefined;
    specieFather!: string | undefined;
    bbxFather!: string | undefined;
    bbxidTreeFather!: string | undefined;
    isMixSeed!: boolean;
    typeSpecieId!: number | undefined;
    typeSpecieFk!: TypeSpecie;
    categorySeedOriginId!: number;
    categorySeedOriginFk!: CategorySeedOrigin;
    crossingTechniqueId!: number | undefined;
    crossingTechniqueFk!: CrossingTechnique;
    trialId!: number | undefined;
    trialFk!: Trial;
    supplierId!: number;
    supplierFk!: Supplier;
    seedDestinationId!: number | undefined;
    seedDestinationFk!: SeedDestination;
    siteOrigin!: string | undefined;
    seedMixture!: SeedMixture[] | undefined;
    treeMotherId!: number | undefined;
    treeMotherFk!: Tree;
    polenFatherId!: number | undefined;
    polenFatherFk!: Polen;
    originalTreeMother!: string | undefined;
    originalTreeFather!: string | undefined;
    observation!: string | undefined;
    observationSpecie!: string | undefined;
    generation!: string | undefined;
    specie2Calculated!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.bbs = _data["bbs"];
            this.loteNumber = _data["loteNumber"];
            this.species = _data["species"];
            this.speciesNameId = _data["speciesNameId"];
            this.speciesNameFk = _data["speciesNameFk"] ? SpeciesGroup.fromJS(_data["speciesNameFk"]) : undefined as any;
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : undefined as any;
            this.supplierCode = _data["supplierCode"];
            this.idMotherTree = _data["idMotherTree"];
            this.bbsMother = _data["bbsMother"];
            this.blockMother = _data["blockMother"];
            this.subBlockMother = _data["subBlockMother"];
            this.treeNumberMother = _data["treeNumberMother"];
            this.speciesMother = _data["speciesMother"];
            this.idTrialMothre = _data["idTrialMothre"];
            this.bbxMother = _data["bbxMother"];
            this.bbxidTreeMother = _data["bbxidTreeMother"];
            this.bbpFather = _data["bbpFather"];
            this.idFatherTree = _data["idFatherTree"];
            this.idTrialFather = _data["idTrialFather"];
            this.bbsFather = _data["bbsFather"];
            this.blockFather = _data["blockFather"];
            this.subBlockFather = _data["subBlockFather"];
            this.treeNumberFather = _data["treeNumberFather"];
            this.specieFather = _data["specieFather"];
            this.bbxFather = _data["bbxFather"];
            this.bbxidTreeFather = _data["bbxidTreeFather"];
            this.isMixSeed = _data["isMixSeed"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.typeSpecieFk = _data["typeSpecieFk"] ? TypeSpecie.fromJS(_data["typeSpecieFk"]) : undefined as any;
            this.categorySeedOriginId = _data["categorySeedOriginId"];
            this.categorySeedOriginFk = _data["categorySeedOriginFk"] ? CategorySeedOrigin.fromJS(_data["categorySeedOriginFk"]) : undefined as any;
            this.crossingTechniqueId = _data["crossingTechniqueId"];
            this.crossingTechniqueFk = _data["crossingTechniqueFk"] ? CrossingTechnique.fromJS(_data["crossingTechniqueFk"]) : undefined as any;
            this.trialId = _data["trialId"];
            this.trialFk = _data["trialFk"] ? Trial.fromJS(_data["trialFk"]) : undefined as any;
            this.supplierId = _data["supplierId"];
            this.supplierFk = _data["supplierFk"] ? Supplier.fromJS(_data["supplierFk"]) : undefined as any;
            this.seedDestinationId = _data["seedDestinationId"];
            this.seedDestinationFk = _data["seedDestinationFk"] ? SeedDestination.fromJS(_data["seedDestinationFk"]) : undefined as any;
            this.siteOrigin = _data["siteOrigin"];
            if (Array.isArray(_data["seedMixture"])) {
                this.seedMixture = [] as any;
                for (let item of _data["seedMixture"])
                    this.seedMixture!.push(SeedMixture.fromJS(item));
            }
            this.treeMotherId = _data["treeMotherId"];
            this.treeMotherFk = _data["treeMotherFk"] ? Tree.fromJS(_data["treeMotherFk"]) : undefined as any;
            this.polenFatherId = _data["polenFatherId"];
            this.polenFatherFk = _data["polenFatherFk"] ? Polen.fromJS(_data["polenFatherFk"]) : undefined as any;
            this.originalTreeMother = _data["originalTreeMother"];
            this.originalTreeFather = _data["originalTreeFather"];
            this.observation = _data["observation"];
            this.observationSpecie = _data["observationSpecie"];
            this.generation = _data["generation"];
            this.specie2Calculated = _data["specie2Calculated"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Seed {
        data = typeof data === 'object' ? data : {};
        let result = new Seed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["bbs"] = this.bbs;
        data["loteNumber"] = this.loteNumber;
        data["species"] = this.species;
        data["speciesNameId"] = this.speciesNameId;
        data["speciesNameFk"] = this.speciesNameFk ? this.speciesNameFk.toJSON() : undefined as any;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : undefined as any;
        data["supplierCode"] = this.supplierCode;
        data["idMotherTree"] = this.idMotherTree;
        data["bbsMother"] = this.bbsMother;
        data["blockMother"] = this.blockMother;
        data["subBlockMother"] = this.subBlockMother;
        data["treeNumberMother"] = this.treeNumberMother;
        data["speciesMother"] = this.speciesMother;
        data["idTrialMothre"] = this.idTrialMothre;
        data["bbxMother"] = this.bbxMother;
        data["bbxidTreeMother"] = this.bbxidTreeMother;
        data["bbpFather"] = this.bbpFather;
        data["idFatherTree"] = this.idFatherTree;
        data["idTrialFather"] = this.idTrialFather;
        data["bbsFather"] = this.bbsFather;
        data["blockFather"] = this.blockFather;
        data["subBlockFather"] = this.subBlockFather;
        data["treeNumberFather"] = this.treeNumberFather;
        data["specieFather"] = this.specieFather;
        data["bbxFather"] = this.bbxFather;
        data["bbxidTreeFather"] = this.bbxidTreeFather;
        data["isMixSeed"] = this.isMixSeed;
        data["typeSpecieId"] = this.typeSpecieId;
        data["typeSpecieFk"] = this.typeSpecieFk ? this.typeSpecieFk.toJSON() : undefined as any;
        data["categorySeedOriginId"] = this.categorySeedOriginId;
        data["categorySeedOriginFk"] = this.categorySeedOriginFk ? this.categorySeedOriginFk.toJSON() : undefined as any;
        data["crossingTechniqueId"] = this.crossingTechniqueId;
        data["crossingTechniqueFk"] = this.crossingTechniqueFk ? this.crossingTechniqueFk.toJSON() : undefined as any;
        data["trialId"] = this.trialId;
        data["trialFk"] = this.trialFk ? this.trialFk.toJSON() : undefined as any;
        data["supplierId"] = this.supplierId;
        data["supplierFk"] = this.supplierFk ? this.supplierFk.toJSON() : undefined as any;
        data["seedDestinationId"] = this.seedDestinationId;
        data["seedDestinationFk"] = this.seedDestinationFk ? this.seedDestinationFk.toJSON() : undefined as any;
        data["siteOrigin"] = this.siteOrigin;
        if (Array.isArray(this.seedMixture)) {
            data["seedMixture"] = [];
            for (let item of this.seedMixture)
                data["seedMixture"].push(item ? item.toJSON() : undefined as any);
        }
        data["treeMotherId"] = this.treeMotherId;
        data["treeMotherFk"] = this.treeMotherFk ? this.treeMotherFk.toJSON() : undefined as any;
        data["polenFatherId"] = this.polenFatherId;
        data["polenFatherFk"] = this.polenFatherFk ? this.polenFatherFk.toJSON() : undefined as any;
        data["originalTreeMother"] = this.originalTreeMother;
        data["originalTreeFather"] = this.originalTreeFather;
        data["observation"] = this.observation;
        data["observationSpecie"] = this.observationSpecie;
        data["generation"] = this.generation;
        data["specie2Calculated"] = this.specie2Calculated;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeed {
    tenantId: number | undefined;
    bbs: string;
    loteNumber: number;
    species: string;
    speciesNameId: number | undefined;
    speciesNameFk: SpeciesGroup;
    receivedDate: DateTime;
    supplierCode: string | undefined;
    idMotherTree: string | undefined;
    bbsMother: string | undefined;
    blockMother: number;
    subBlockMother: number;
    treeNumberMother: number;
    speciesMother: string | undefined;
    idTrialMothre: number | undefined;
    bbxMother: string | undefined;
    bbxidTreeMother: string | undefined;
    bbpFather: string | undefined;
    idFatherTree: string | undefined;
    idTrialFather: number | undefined;
    bbsFather: string | undefined;
    blockFather: number | undefined;
    subBlockFather: number | undefined;
    treeNumberFather: number | undefined;
    specieFather: string | undefined;
    bbxFather: string | undefined;
    bbxidTreeFather: string | undefined;
    isMixSeed: boolean;
    typeSpecieId: number | undefined;
    typeSpecieFk: TypeSpecie;
    categorySeedOriginId: number;
    categorySeedOriginFk: CategorySeedOrigin;
    crossingTechniqueId: number | undefined;
    crossingTechniqueFk: CrossingTechnique;
    trialId: number | undefined;
    trialFk: Trial;
    supplierId: number;
    supplierFk: Supplier;
    seedDestinationId: number | undefined;
    seedDestinationFk: SeedDestination;
    siteOrigin: string | undefined;
    seedMixture: SeedMixture[] | undefined;
    treeMotherId: number | undefined;
    treeMotherFk: Tree;
    polenFatherId: number | undefined;
    polenFatherFk: Polen;
    originalTreeMother: string | undefined;
    originalTreeFather: string | undefined;
    observation: string | undefined;
    observationSpecie: string | undefined;
    generation: string | undefined;
    specie2Calculated: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SeedCategorySeedOriginLookupTableDto implements ISeedCategorySeedOriginLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedCategorySeedOriginLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedCategorySeedOriginLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedCategorySeedOriginLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedCategorySeedOriginLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedCrossingTechniqueLookupTableDto implements ISeedCrossingTechniqueLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedCrossingTechniqueLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedCrossingTechniqueLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedCrossingTechniqueLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedCrossingTechniqueLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedDestination implements ISeedDestination {
    tenantId!: number | undefined;
    name!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISeedDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedDestination {
        data = typeof data === 'object' ? data : {};
        let result = new SeedDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedDestination {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SeedDestinationDto implements ISeedDestinationDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ISeedDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedDestinationDto {
    name: string | undefined;
    id: number;
}

export class SeedDto implements ISeedDto {
    bbs!: string | undefined;
    loteNumber!: number;
    species!: string | undefined;
    speciesNameId!: number;
    receivedDate!: DateTime;
    idMotherTree!: string | undefined;
    bbsMother!: string | undefined;
    blockMother!: number;
    subBlockMother!: number;
    treeNumberMother!: number;
    speciesMother!: string | undefined;
    bbpFather!: string | undefined;
    idFatherTree!: string | undefined;
    idTrialFather!: number | undefined;
    bbsFather!: string | undefined;
    blockFather!: number;
    subBlockFather!: number;
    treeNumberFather!: number;
    specieFather!: string | undefined;
    supplierCode!: string | undefined;
    isMixSeed!: boolean;
    typeSpecieId!: number;
    categorySeedOriginId!: number;
    crossingTechniqueId!: number | undefined;
    trialId!: number | undefined;
    supplierId!: number;
    seedDestinationId!: number | undefined;
    idTrialMothre!: number | undefined;
    bbxMother!: string | undefined;
    bbxidTreeMother!: string | undefined;
    bbxFather!: string | undefined;
    bbxidTreeFather!: string | undefined;
    siteOrigin!: string | undefined;
    treeMotherId!: number | undefined;
    polenFatherId!: number | undefined;
    originalTreeMother!: string | undefined;
    originalTreeFather!: string | undefined;
    observation!: string | undefined;
    observationSpecie!: string | undefined;
    generation!: string | undefined;
    seedMixture!: SeedMixtureDto[] | undefined;
    specie2Calculated!: string | undefined;
    id!: number;

    constructor(data?: ISeedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbs = _data["bbs"];
            this.loteNumber = _data["loteNumber"];
            this.species = _data["species"];
            this.speciesNameId = _data["speciesNameId"];
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : undefined as any;
            this.idMotherTree = _data["idMotherTree"];
            this.bbsMother = _data["bbsMother"];
            this.blockMother = _data["blockMother"];
            this.subBlockMother = _data["subBlockMother"];
            this.treeNumberMother = _data["treeNumberMother"];
            this.speciesMother = _data["speciesMother"];
            this.bbpFather = _data["bbpFather"];
            this.idFatherTree = _data["idFatherTree"];
            this.idTrialFather = _data["idTrialFather"];
            this.bbsFather = _data["bbsFather"];
            this.blockFather = _data["blockFather"];
            this.subBlockFather = _data["subBlockFather"];
            this.treeNumberFather = _data["treeNumberFather"];
            this.specieFather = _data["specieFather"];
            this.supplierCode = _data["supplierCode"];
            this.isMixSeed = _data["isMixSeed"];
            this.typeSpecieId = _data["typeSpecieId"];
            this.categorySeedOriginId = _data["categorySeedOriginId"];
            this.crossingTechniqueId = _data["crossingTechniqueId"];
            this.trialId = _data["trialId"];
            this.supplierId = _data["supplierId"];
            this.seedDestinationId = _data["seedDestinationId"];
            this.idTrialMothre = _data["idTrialMothre"];
            this.bbxMother = _data["bbxMother"];
            this.bbxidTreeMother = _data["bbxidTreeMother"];
            this.bbxFather = _data["bbxFather"];
            this.bbxidTreeFather = _data["bbxidTreeFather"];
            this.siteOrigin = _data["siteOrigin"];
            this.treeMotherId = _data["treeMotherId"];
            this.polenFatherId = _data["polenFatherId"];
            this.originalTreeMother = _data["originalTreeMother"];
            this.originalTreeFather = _data["originalTreeFather"];
            this.observation = _data["observation"];
            this.observationSpecie = _data["observationSpecie"];
            this.generation = _data["generation"];
            if (Array.isArray(_data["seedMixture"])) {
                this.seedMixture = [] as any;
                for (let item of _data["seedMixture"])
                    this.seedMixture!.push(SeedMixtureDto.fromJS(item));
            }
            this.specie2Calculated = _data["specie2Calculated"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbs"] = this.bbs;
        data["loteNumber"] = this.loteNumber;
        data["species"] = this.species;
        data["speciesNameId"] = this.speciesNameId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : undefined as any;
        data["idMotherTree"] = this.idMotherTree;
        data["bbsMother"] = this.bbsMother;
        data["blockMother"] = this.blockMother;
        data["subBlockMother"] = this.subBlockMother;
        data["treeNumberMother"] = this.treeNumberMother;
        data["speciesMother"] = this.speciesMother;
        data["bbpFather"] = this.bbpFather;
        data["idFatherTree"] = this.idFatherTree;
        data["idTrialFather"] = this.idTrialFather;
        data["bbsFather"] = this.bbsFather;
        data["blockFather"] = this.blockFather;
        data["subBlockFather"] = this.subBlockFather;
        data["treeNumberFather"] = this.treeNumberFather;
        data["specieFather"] = this.specieFather;
        data["supplierCode"] = this.supplierCode;
        data["isMixSeed"] = this.isMixSeed;
        data["typeSpecieId"] = this.typeSpecieId;
        data["categorySeedOriginId"] = this.categorySeedOriginId;
        data["crossingTechniqueId"] = this.crossingTechniqueId;
        data["trialId"] = this.trialId;
        data["supplierId"] = this.supplierId;
        data["seedDestinationId"] = this.seedDestinationId;
        data["idTrialMothre"] = this.idTrialMothre;
        data["bbxMother"] = this.bbxMother;
        data["bbxidTreeMother"] = this.bbxidTreeMother;
        data["bbxFather"] = this.bbxFather;
        data["bbxidTreeFather"] = this.bbxidTreeFather;
        data["siteOrigin"] = this.siteOrigin;
        data["treeMotherId"] = this.treeMotherId;
        data["polenFatherId"] = this.polenFatherId;
        data["originalTreeMother"] = this.originalTreeMother;
        data["originalTreeFather"] = this.originalTreeFather;
        data["observation"] = this.observation;
        data["observationSpecie"] = this.observationSpecie;
        data["generation"] = this.generation;
        if (Array.isArray(this.seedMixture)) {
            data["seedMixture"] = [];
            for (let item of this.seedMixture)
                data["seedMixture"].push(item ? item.toJSON() : undefined as any);
        }
        data["specie2Calculated"] = this.specie2Calculated;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedDto {
    bbs: string | undefined;
    loteNumber: number;
    species: string | undefined;
    speciesNameId: number;
    receivedDate: DateTime;
    idMotherTree: string | undefined;
    bbsMother: string | undefined;
    blockMother: number;
    subBlockMother: number;
    treeNumberMother: number;
    speciesMother: string | undefined;
    bbpFather: string | undefined;
    idFatherTree: string | undefined;
    idTrialFather: number | undefined;
    bbsFather: string | undefined;
    blockFather: number;
    subBlockFather: number;
    treeNumberFather: number;
    specieFather: string | undefined;
    supplierCode: string | undefined;
    isMixSeed: boolean;
    typeSpecieId: number;
    categorySeedOriginId: number;
    crossingTechniqueId: number | undefined;
    trialId: number | undefined;
    supplierId: number;
    seedDestinationId: number | undefined;
    idTrialMothre: number | undefined;
    bbxMother: string | undefined;
    bbxidTreeMother: string | undefined;
    bbxFather: string | undefined;
    bbxidTreeFather: string | undefined;
    siteOrigin: string | undefined;
    treeMotherId: number | undefined;
    polenFatherId: number | undefined;
    originalTreeMother: string | undefined;
    originalTreeFather: string | undefined;
    observation: string | undefined;
    observationSpecie: string | undefined;
    generation: string | undefined;
    seedMixture: SeedMixtureDto[] | undefined;
    specie2Calculated: string | undefined;
    id: number;
}

export class SeedGeneratedClonesDto implements ISeedGeneratedClonesDto {
    bbs!: string | undefined;
    species!: string | undefined;
    specieCategory!: string | undefined;
    fatherTreeId!: string | undefined;
    motherTreeId!: string | undefined;
    bbc!: string | undefined;
    idBBS!: string | undefined;
    bbx!: string | undefined;
    cloneStatus!: string | undefined;
    proyectType!: string | undefined;
    year!: string | undefined;

    constructor(data?: ISeedGeneratedClonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bbs = _data["bbs"];
            this.species = _data["species"];
            this.specieCategory = _data["specieCategory"];
            this.fatherTreeId = _data["fatherTreeId"];
            this.motherTreeId = _data["motherTreeId"];
            this.bbc = _data["bbc"];
            this.idBBS = _data["idBBS"];
            this.bbx = _data["bbx"];
            this.cloneStatus = _data["cloneStatus"];
            this.proyectType = _data["proyectType"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): SeedGeneratedClonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedGeneratedClonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bbs"] = this.bbs;
        data["species"] = this.species;
        data["specieCategory"] = this.specieCategory;
        data["fatherTreeId"] = this.fatherTreeId;
        data["motherTreeId"] = this.motherTreeId;
        data["bbc"] = this.bbc;
        data["idBBS"] = this.idBBS;
        data["bbx"] = this.bbx;
        data["cloneStatus"] = this.cloneStatus;
        data["proyectType"] = this.proyectType;
        data["year"] = this.year;
        return data;
    }
}

export interface ISeedGeneratedClonesDto {
    bbs: string | undefined;
    species: string | undefined;
    specieCategory: string | undefined;
    fatherTreeId: string | undefined;
    motherTreeId: string | undefined;
    bbc: string | undefined;
    idBBS: string | undefined;
    bbx: string | undefined;
    cloneStatus: string | undefined;
    proyectType: string | undefined;
    year: string | undefined;
}

export class SeedLookupTableDto implements ISeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedMixture implements ISeedMixture {
    tenantId!: number | undefined;
    porcentaje!: number;
    seedCompositionName!: string | undefined;
    seedCompositionID!: number;
    seedCompisitonId!: number;
    seedCompisitonFk!: Seed;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISeedMixture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.porcentaje = _data["porcentaje"];
            this.seedCompositionName = _data["seedCompositionName"];
            this.seedCompositionID = _data["seedCompositionID"];
            this.seedCompisitonId = _data["seedCompisitonId"];
            this.seedCompisitonFk = _data["seedCompisitonFk"] ? Seed.fromJS(_data["seedCompisitonFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedMixture {
        data = typeof data === 'object' ? data : {};
        let result = new SeedMixture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["porcentaje"] = this.porcentaje;
        data["seedCompositionName"] = this.seedCompositionName;
        data["seedCompositionID"] = this.seedCompositionID;
        data["seedCompisitonId"] = this.seedCompisitonId;
        data["seedCompisitonFk"] = this.seedCompisitonFk ? this.seedCompisitonFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedMixture {
    tenantId: number | undefined;
    porcentaje: number;
    seedCompositionName: string | undefined;
    seedCompositionID: number;
    seedCompisitonId: number;
    seedCompisitonFk: Seed;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SeedMixtureDto implements ISeedMixtureDto {
    porcentaje!: number;
    seedCompositionID!: number;
    seedCompisitonId!: number;
    seedCompositionName!: string | undefined;
    id!: number;

    constructor(data?: ISeedMixtureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porcentaje = _data["porcentaje"];
            this.seedCompositionID = _data["seedCompositionID"];
            this.seedCompisitonId = _data["seedCompisitonId"];
            this.seedCompositionName = _data["seedCompositionName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedMixtureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedMixtureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porcentaje"] = this.porcentaje;
        data["seedCompositionID"] = this.seedCompositionID;
        data["seedCompisitonId"] = this.seedCompisitonId;
        data["seedCompositionName"] = this.seedCompositionName;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedMixtureDto {
    porcentaje: number;
    seedCompositionID: number;
    seedCompisitonId: number;
    seedCompositionName: string | undefined;
    id: number;
}

export class SeedMixtureSeedLookupTableDto implements ISeedMixtureSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedMixtureSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedMixtureSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedMixtureSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedMixtureSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedSeedDestinationLookupTableDto implements ISeedSeedDestinationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedSeedDestinationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedSeedDestinationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedSeedDestinationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedSeedDestinationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedStockDto implements ISeedStockDto {
    isClean!: boolean;
    unitType!: string | undefined;
    initialStock!: number | undefined;
    currentStock!: number | undefined;
    stockMinimo!: number | undefined;
    lastUpdateDate!: DateTime | undefined;
    caliber059mm!: number | undefined;
    caliber071mm!: number | undefined;
    caliber084mm!: number | undefined;
    caliber100mm!: number | undefined;
    destination!: string | undefined;
    destination2!: string | undefined;
    shelf!: string | undefined;
    quadrant!: string | undefined;
    drawerLocation!: string | undefined;
    bagDetail!: string | undefined;
    comments!: string | undefined;
    seedId!: number | undefined;
    id!: number;

    constructor(data?: ISeedStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isClean = _data["isClean"];
            this.unitType = _data["unitType"];
            this.initialStock = _data["initialStock"];
            this.currentStock = _data["currentStock"];
            this.stockMinimo = _data["stockMinimo"];
            this.lastUpdateDate = _data["lastUpdateDate"] ? DateTime.fromISO(_data["lastUpdateDate"].toString()) : undefined as any;
            this.caliber059mm = _data["caliber059mm"];
            this.caliber071mm = _data["caliber071mm"];
            this.caliber084mm = _data["caliber084mm"];
            this.caliber100mm = _data["caliber100mm"];
            this.destination = _data["destination"];
            this.destination2 = _data["destination2"];
            this.shelf = _data["shelf"];
            this.quadrant = _data["quadrant"];
            this.drawerLocation = _data["drawerLocation"];
            this.bagDetail = _data["bagDetail"];
            this.comments = _data["comments"];
            this.seedId = _data["seedId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClean"] = this.isClean;
        data["unitType"] = this.unitType;
        data["initialStock"] = this.initialStock;
        data["currentStock"] = this.currentStock;
        data["stockMinimo"] = this.stockMinimo;
        data["lastUpdateDate"] = this.lastUpdateDate ? this.lastUpdateDate.toString() : undefined as any;
        data["caliber059mm"] = this.caliber059mm;
        data["caliber071mm"] = this.caliber071mm;
        data["caliber084mm"] = this.caliber084mm;
        data["caliber100mm"] = this.caliber100mm;
        data["destination"] = this.destination;
        data["destination2"] = this.destination2;
        data["shelf"] = this.shelf;
        data["quadrant"] = this.quadrant;
        data["drawerLocation"] = this.drawerLocation;
        data["bagDetail"] = this.bagDetail;
        data["comments"] = this.comments;
        data["seedId"] = this.seedId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedStockDto {
    isClean: boolean;
    unitType: string | undefined;
    initialStock: number | undefined;
    currentStock: number | undefined;
    stockMinimo: number | undefined;
    lastUpdateDate: DateTime | undefined;
    caliber059mm: number | undefined;
    caliber071mm: number | undefined;
    caliber084mm: number | undefined;
    caliber100mm: number | undefined;
    destination: string | undefined;
    destination2: string | undefined;
    shelf: string | undefined;
    quadrant: string | undefined;
    drawerLocation: string | undefined;
    bagDetail: string | undefined;
    comments: string | undefined;
    seedId: number | undefined;
    id: number;
}

export class SeedStockMovementDto implements ISeedStockMovementDto {
    movementDate!: DateTime;
    movementType!: string | undefined;
    quantity!: number;
    unitType!: string | undefined;
    isClean!: boolean;
    destination!: string | undefined;
    destination2!: string | undefined;
    shelf!: string | undefined;
    quadrant!: string | undefined;
    drawerLocation!: string | undefined;
    bagDetail!: string | undefined;
    comments!: string | undefined;
    caliber059mm!: number;
    caliber071mm!: number;
    caliber084mm!: number;
    caliber100mm!: number;
    calibrationObservation!: string | undefined;
    stockMovementQuantity!: number | undefined;
    seedId!: number | undefined;
    id!: number;

    constructor(data?: ISeedStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementDate = _data["movementDate"] ? DateTime.fromISO(_data["movementDate"].toString()) : undefined as any;
            this.movementType = _data["movementType"];
            this.quantity = _data["quantity"];
            this.unitType = _data["unitType"];
            this.isClean = _data["isClean"];
            this.destination = _data["destination"];
            this.destination2 = _data["destination2"];
            this.shelf = _data["shelf"];
            this.quadrant = _data["quadrant"];
            this.drawerLocation = _data["drawerLocation"];
            this.bagDetail = _data["bagDetail"];
            this.comments = _data["comments"];
            this.caliber059mm = _data["caliber059mm"];
            this.caliber071mm = _data["caliber071mm"];
            this.caliber084mm = _data["caliber084mm"];
            this.caliber100mm = _data["caliber100mm"];
            this.calibrationObservation = _data["calibrationObservation"];
            this.stockMovementQuantity = _data["stockMovementQuantity"];
            this.seedId = _data["seedId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedStockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedStockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementDate"] = this.movementDate ? this.movementDate.toString() : undefined as any;
        data["movementType"] = this.movementType;
        data["quantity"] = this.quantity;
        data["unitType"] = this.unitType;
        data["isClean"] = this.isClean;
        data["destination"] = this.destination;
        data["destination2"] = this.destination2;
        data["shelf"] = this.shelf;
        data["quadrant"] = this.quadrant;
        data["drawerLocation"] = this.drawerLocation;
        data["bagDetail"] = this.bagDetail;
        data["comments"] = this.comments;
        data["caliber059mm"] = this.caliber059mm;
        data["caliber071mm"] = this.caliber071mm;
        data["caliber084mm"] = this.caliber084mm;
        data["caliber100mm"] = this.caliber100mm;
        data["calibrationObservation"] = this.calibrationObservation;
        data["stockMovementQuantity"] = this.stockMovementQuantity;
        data["seedId"] = this.seedId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedStockMovementDto {
    movementDate: DateTime;
    movementType: string | undefined;
    quantity: number;
    unitType: string | undefined;
    isClean: boolean;
    destination: string | undefined;
    destination2: string | undefined;
    shelf: string | undefined;
    quadrant: string | undefined;
    drawerLocation: string | undefined;
    bagDetail: string | undefined;
    comments: string | undefined;
    caliber059mm: number;
    caliber071mm: number;
    caliber084mm: number;
    caliber100mm: number;
    calibrationObservation: string | undefined;
    stockMovementQuantity: number | undefined;
    seedId: number | undefined;
    id: number;
}

export class SeedStockMovementSeedLookupTableDto implements ISeedStockMovementSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedStockMovementSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedStockMovementSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedStockMovementSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedStockMovementSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedStockSeedLookupTableDto implements ISeedStockSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedStockSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedStockSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedStockSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedStockSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedSupplierLookupTableDto implements ISeedSupplierLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedSupplierLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedSupplierLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedSupplierLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedSupplierLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedTreeLookupTableDto implements ISeedTreeLookupTableDto {
    dataBBS!: string | undefined;
    id!: number;
    displayName!: string | undefined;
    displayTreeName!: string | undefined;
    dataBBX!: string | undefined;
    dataBBT!: string | undefined;
    dataTrial!: number;
    dataSpecie!: string | undefined;
    dataBBSId!: number | undefined;
    dataBBXId!: number | undefined;
    dataBBTId!: number | undefined;
    dataTrialId!: number;
    dataTreeBlock!: number | undefined;
    dataTreeSubBlock!: number | undefined;
    dataTreeNumber!: number;
    dataOriginSite!: string | undefined;
    dataBBXTreeName!: string | undefined;
    dataOriginalTree!: string | undefined;

    constructor(data?: ISeedTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataBBS = _data["dataBBS"];
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBT = _data["dataBBT"];
            this.dataTrial = _data["dataTrial"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBBSId = _data["dataBBSId"];
            this.dataBBXId = _data["dataBBXId"];
            this.dataBBTId = _data["dataBBTId"];
            this.dataTrialId = _data["dataTrialId"];
            this.dataTreeBlock = _data["dataTreeBlock"];
            this.dataTreeSubBlock = _data["dataTreeSubBlock"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.dataOriginSite = _data["dataOriginSite"];
            this.dataBBXTreeName = _data["dataBBXTreeName"];
            this.dataOriginalTree = _data["dataOriginalTree"];
        }
    }

    static fromJS(data: any): SeedTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataBBS"] = this.dataBBS;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeName"] = this.displayTreeName;
        data["dataBBX"] = this.dataBBX;
        data["dataBBT"] = this.dataBBT;
        data["dataTrial"] = this.dataTrial;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBBSId"] = this.dataBBSId;
        data["dataBBXId"] = this.dataBBXId;
        data["dataBBTId"] = this.dataBBTId;
        data["dataTrialId"] = this.dataTrialId;
        data["dataTreeBlock"] = this.dataTreeBlock;
        data["dataTreeSubBlock"] = this.dataTreeSubBlock;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["dataOriginSite"] = this.dataOriginSite;
        data["dataBBXTreeName"] = this.dataBBXTreeName;
        data["dataOriginalTree"] = this.dataOriginalTree;
        return data;
    }
}

export interface ISeedTreeLookupTableDto {
    dataBBS: string | undefined;
    id: number;
    displayName: string | undefined;
    displayTreeName: string | undefined;
    dataBBX: string | undefined;
    dataBBT: string | undefined;
    dataTrial: number;
    dataSpecie: string | undefined;
    dataBBSId: number | undefined;
    dataBBXId: number | undefined;
    dataBBTId: number | undefined;
    dataTrialId: number;
    dataTreeBlock: number | undefined;
    dataTreeSubBlock: number | undefined;
    dataTreeNumber: number;
    dataOriginSite: string | undefined;
    dataBBXTreeName: string | undefined;
    dataOriginalTree: string | undefined;
}

export class SeedTrialLookupTableDto implements ISeedTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    dataFarmName!: string | undefined;
    dataStandName!: string | undefined;

    constructor(data?: ISeedTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dataFarmName = _data["dataFarmName"];
            this.dataStandName = _data["dataStandName"];
        }
    }

    static fromJS(data: any): SeedTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dataFarmName"] = this.dataFarmName;
        data["dataStandName"] = this.dataStandName;
        return data;
    }
}

export interface ISeedTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
    dataFarmName: string | undefined;
    dataStandName: string | undefined;
}

export class SeedTypeSpecieLookupTableDto implements ISeedTypeSpecieLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedTypeSpecieLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedTypeSpecieLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedTypeSpecieLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedTypeSpecieLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedUnitTypeDto implements ISeedUnitTypeDto {
    value!: number;
    name!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: ISeedUnitTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedUnitTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedUnitTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedUnitTypeDto {
    value: number;
    name: string | undefined;
    displayName: string | undefined;
}

export class Seedling implements ISeedling {
    tenantId!: number | undefined;
    subProject!: string | undefined;
    anio!: number;
    plantinId!: number;
    seedId!: number | undefined;
    seedFk!: Seed;
    cloneId!: number | undefined;
    cloneFk!: Clone;
    samplingDate!: DateTime;
    tag!: string | undefined;
    readonly seedlingName!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISeedling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.subProject = _data["subProject"];
            this.anio = _data["anio"];
            this.plantinId = _data["plantinId"];
            this.seedId = _data["seedId"];
            this.seedFk = _data["seedFk"] ? Seed.fromJS(_data["seedFk"]) : undefined as any;
            this.cloneId = _data["cloneId"];
            this.cloneFk = _data["cloneFk"] ? Clone.fromJS(_data["cloneFk"]) : undefined as any;
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.tag = _data["tag"];
            (this as any).seedlingName = _data["seedlingName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Seedling {
        data = typeof data === 'object' ? data : {};
        let result = new Seedling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subProject"] = this.subProject;
        data["anio"] = this.anio;
        data["plantinId"] = this.plantinId;
        data["seedId"] = this.seedId;
        data["seedFk"] = this.seedFk ? this.seedFk.toJSON() : undefined as any;
        data["cloneId"] = this.cloneId;
        data["cloneFk"] = this.cloneFk ? this.cloneFk.toJSON() : undefined as any;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["tag"] = this.tag;
        data["seedlingName"] = this.seedlingName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedling {
    tenantId: number | undefined;
    subProject: string | undefined;
    anio: number;
    plantinId: number;
    seedId: number | undefined;
    seedFk: Seed;
    cloneId: number | undefined;
    cloneFk: Clone;
    samplingDate: DateTime;
    tag: string | undefined;
    seedlingName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SeedlingCloneLookupTableDto implements ISeedlingCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedlingCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedlingCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedlingCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedlingCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeedlingDto implements ISeedlingDto {
    seedId!: number | undefined;
    cloneId!: number | undefined;
    subProject!: string | undefined;
    anio!: number;
    plantinId!: number;
    samplingDate!: DateTime;
    tag!: string | undefined;
    id!: number;

    constructor(data?: ISeedlingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.subProject = _data["subProject"];
            this.anio = _data["anio"];
            this.plantinId = _data["plantinId"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : undefined as any;
            this.tag = _data["tag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeedlingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedlingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["subProject"] = this.subProject;
        data["anio"] = this.anio;
        data["plantinId"] = this.plantinId;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : undefined as any;
        data["tag"] = this.tag;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeedlingDto {
    seedId: number | undefined;
    cloneId: number | undefined;
    subProject: string | undefined;
    anio: number;
    plantinId: number;
    samplingDate: DateTime;
    tag: string | undefined;
    id: number;
}

export class SeedlingSeedLookupTableDto implements ISeedlingSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeedlingSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeedlingSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeedlingSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeedlingSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class SilvicultureTreatmentNutritionalCloneLookupTableDto implements ISilvicultureTreatmentNutritionalCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalDto implements ISilvicultureTreatmentNutritionalDto {
    treatment!: number;
    treatmentName!: string | undefined;
    treatmentStartDate!: DateTime;
    treatmentTag!: string | undefined;
    interventionDate!: DateTime;
    interventionWidth!: number | undefined;
    dose_Gr_Pl!: number | undefined;
    dose_Kg_Ha_Total!: number | undefined;
    dose_L_Ha_Total!: number | undefined;
    dose_Kg_Ha_Concentrated!: number | undefined;
    dilution!: number | undefined;
    largeTrickle!: number | undefined;
    depth!: number | undefined;
    longitudinalFertilizerBleed!: number | undefined;
    observation!: string | undefined;
    observationOne!: string | undefined;
    silvicultureTrialId!: number;
    treatmentObjectiveId!: number;
    treatmentParcelTypeId!: number;
    cloneId!: number;
    treatmentProductTypeId!: number;
    treatmentProductId!: number;
    treatmentInterventionZoneId!: number;
    treatmentInterventionMomentId!: number;
    treatmentInterventionObjectiveId!: number;
    treatmentApplyOneId!: number | undefined;
    treatmentApplyTwoId!: number | undefined;
    treatmentApplyThreeId!: number | undefined;
    treatmentApplyFourId!: number | undefined;
    treatmentApplyFiveId!: number | undefined;
    interventionFoundationsOneId!: number;
    interventionFoundationsTwoId!: number | undefined;
    interventionFoundationsThreeId!: number | undefined;
    treatmentDoseTypeId!: number | undefined;
    id!: number;

    constructor(data?: ISilvicultureTreatmentNutritionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatment = _data["treatment"];
            this.treatmentName = _data["treatmentName"];
            this.treatmentStartDate = _data["treatmentStartDate"] ? DateTime.fromISO(_data["treatmentStartDate"].toString()) : undefined as any;
            this.treatmentTag = _data["treatmentTag"];
            this.interventionDate = _data["interventionDate"] ? DateTime.fromISO(_data["interventionDate"].toString()) : undefined as any;
            this.interventionWidth = _data["interventionWidth"];
            this.dose_Gr_Pl = _data["dose_Gr_Pl"];
            this.dose_Kg_Ha_Total = _data["dose_Kg_Ha_Total"];
            this.dose_L_Ha_Total = _data["dose_L_Ha_Total"];
            this.dose_Kg_Ha_Concentrated = _data["dose_Kg_Ha_Concentrated"];
            this.dilution = _data["dilution"];
            this.largeTrickle = _data["largeTrickle"];
            this.depth = _data["depth"];
            this.longitudinalFertilizerBleed = _data["longitudinalFertilizerBleed"];
            this.observation = _data["observation"];
            this.observationOne = _data["observationOne"];
            this.silvicultureTrialId = _data["silvicultureTrialId"];
            this.treatmentObjectiveId = _data["treatmentObjectiveId"];
            this.treatmentParcelTypeId = _data["treatmentParcelTypeId"];
            this.cloneId = _data["cloneId"];
            this.treatmentProductTypeId = _data["treatmentProductTypeId"];
            this.treatmentProductId = _data["treatmentProductId"];
            this.treatmentInterventionZoneId = _data["treatmentInterventionZoneId"];
            this.treatmentInterventionMomentId = _data["treatmentInterventionMomentId"];
            this.treatmentInterventionObjectiveId = _data["treatmentInterventionObjectiveId"];
            this.treatmentApplyOneId = _data["treatmentApplyOneId"];
            this.treatmentApplyTwoId = _data["treatmentApplyTwoId"];
            this.treatmentApplyThreeId = _data["treatmentApplyThreeId"];
            this.treatmentApplyFourId = _data["treatmentApplyFourId"];
            this.treatmentApplyFiveId = _data["treatmentApplyFiveId"];
            this.interventionFoundationsOneId = _data["interventionFoundationsOneId"];
            this.interventionFoundationsTwoId = _data["interventionFoundationsTwoId"];
            this.interventionFoundationsThreeId = _data["interventionFoundationsThreeId"];
            this.treatmentDoseTypeId = _data["treatmentDoseTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment;
        data["treatmentName"] = this.treatmentName;
        data["treatmentStartDate"] = this.treatmentStartDate ? this.treatmentStartDate.toString() : undefined as any;
        data["treatmentTag"] = this.treatmentTag;
        data["interventionDate"] = this.interventionDate ? this.interventionDate.toString() : undefined as any;
        data["interventionWidth"] = this.interventionWidth;
        data["dose_Gr_Pl"] = this.dose_Gr_Pl;
        data["dose_Kg_Ha_Total"] = this.dose_Kg_Ha_Total;
        data["dose_L_Ha_Total"] = this.dose_L_Ha_Total;
        data["dose_Kg_Ha_Concentrated"] = this.dose_Kg_Ha_Concentrated;
        data["dilution"] = this.dilution;
        data["largeTrickle"] = this.largeTrickle;
        data["depth"] = this.depth;
        data["longitudinalFertilizerBleed"] = this.longitudinalFertilizerBleed;
        data["observation"] = this.observation;
        data["observationOne"] = this.observationOne;
        data["silvicultureTrialId"] = this.silvicultureTrialId;
        data["treatmentObjectiveId"] = this.treatmentObjectiveId;
        data["treatmentParcelTypeId"] = this.treatmentParcelTypeId;
        data["cloneId"] = this.cloneId;
        data["treatmentProductTypeId"] = this.treatmentProductTypeId;
        data["treatmentProductId"] = this.treatmentProductId;
        data["treatmentInterventionZoneId"] = this.treatmentInterventionZoneId;
        data["treatmentInterventionMomentId"] = this.treatmentInterventionMomentId;
        data["treatmentInterventionObjectiveId"] = this.treatmentInterventionObjectiveId;
        data["treatmentApplyOneId"] = this.treatmentApplyOneId;
        data["treatmentApplyTwoId"] = this.treatmentApplyTwoId;
        data["treatmentApplyThreeId"] = this.treatmentApplyThreeId;
        data["treatmentApplyFourId"] = this.treatmentApplyFourId;
        data["treatmentApplyFiveId"] = this.treatmentApplyFiveId;
        data["interventionFoundationsOneId"] = this.interventionFoundationsOneId;
        data["interventionFoundationsTwoId"] = this.interventionFoundationsTwoId;
        data["interventionFoundationsThreeId"] = this.interventionFoundationsThreeId;
        data["treatmentDoseTypeId"] = this.treatmentDoseTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalDto {
    treatment: number;
    treatmentName: string | undefined;
    treatmentStartDate: DateTime;
    treatmentTag: string | undefined;
    interventionDate: DateTime;
    interventionWidth: number | undefined;
    dose_Gr_Pl: number | undefined;
    dose_Kg_Ha_Total: number | undefined;
    dose_L_Ha_Total: number | undefined;
    dose_Kg_Ha_Concentrated: number | undefined;
    dilution: number | undefined;
    largeTrickle: number | undefined;
    depth: number | undefined;
    longitudinalFertilizerBleed: number | undefined;
    observation: string | undefined;
    observationOne: string | undefined;
    silvicultureTrialId: number;
    treatmentObjectiveId: number;
    treatmentParcelTypeId: number;
    cloneId: number;
    treatmentProductTypeId: number;
    treatmentProductId: number;
    treatmentInterventionZoneId: number;
    treatmentInterventionMomentId: number;
    treatmentInterventionObjectiveId: number;
    treatmentApplyOneId: number | undefined;
    treatmentApplyTwoId: number | undefined;
    treatmentApplyThreeId: number | undefined;
    treatmentApplyFourId: number | undefined;
    treatmentApplyFiveId: number | undefined;
    interventionFoundationsOneId: number;
    interventionFoundationsTwoId: number | undefined;
    interventionFoundationsThreeId: number | undefined;
    treatmentDoseTypeId: number | undefined;
    id: number;
}

export class SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto implements ISilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalInterventionFoundationsOneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto implements ISilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalInterventionFoundationsThreeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto implements ISilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalInterventionFoundationsTwoLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto implements ISilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalSilvicultureTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentApplyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentDoseTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentInterventionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentObjectiveLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentParcelTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentProductLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentProductLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentProductLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto implements ISilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTreatmentNutritionalTreatmentProductTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialCloneLookupTableDto implements ISilvicultureTrialCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialDto implements ISilvicultureTrialDto {
    experimentStigma!: string | undefined;
    region!: string | undefined;
    zone!: string | undefined;
    property!: string | undefined;
    stand!: string | undefined;
    standArea!: number | undefined;
    cycle!: number | undefined;
    rotation!: number | undefined;
    coneat!: string | undefined;
    geology!: string | undefined;
    soilUnit!: string | undefined;
    specialWords!: string | undefined;
    instalationDate!: DateTime;
    instalationYear!: number;
    plantationDate!: DateTime | undefined;
    plantationDensity!: number | undefined;
    treeDistance!: number | undefined;
    rowDistance!: number | undefined;
    treatmentNumber!: number;
    repeats!: number | undefined;
    treeByParcel!: number | undefined;
    totalExperimentTree!: number | undefined;
    experimentArea!: number | undefined;
    observation!: string | undefined;
    observation2!: string | undefined;
    data!: string | undefined;
    standLatitude!: number | undefined;
    standLength!: number | undefined;
    planningRegime!: string | undefined;
    experimentId!: string | undefined;
    groupTrialId!: number;
    experimentTypeId!: number;
    experimentSpecieQuantityId!: number;
    experimentSpecieId!: number;
    stigmaCloneId!: number | undefined;
    experimentLocationId!: number;
    experimentCategoryId!: number;
    experimentClassificationId!: number;
    experimentClasificationtwoId!: number;
    trialDesignTypesId!: number;
    trialStatusId!: number;
    id!: number;

    constructor(data?: ISilvicultureTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentStigma = _data["experimentStigma"];
            this.region = _data["region"];
            this.zone = _data["zone"];
            this.property = _data["property"];
            this.stand = _data["stand"];
            this.standArea = _data["standArea"];
            this.cycle = _data["cycle"];
            this.rotation = _data["rotation"];
            this.coneat = _data["coneat"];
            this.geology = _data["geology"];
            this.soilUnit = _data["soilUnit"];
            this.specialWords = _data["specialWords"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.instalationYear = _data["instalationYear"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.plantationDensity = _data["plantationDensity"];
            this.treeDistance = _data["treeDistance"];
            this.rowDistance = _data["rowDistance"];
            this.treatmentNumber = _data["treatmentNumber"];
            this.repeats = _data["repeats"];
            this.treeByParcel = _data["treeByParcel"];
            this.totalExperimentTree = _data["totalExperimentTree"];
            this.experimentArea = _data["experimentArea"];
            this.observation = _data["observation"];
            this.observation2 = _data["observation2"];
            this.data = _data["data"];
            this.standLatitude = _data["standLatitude"];
            this.standLength = _data["standLength"];
            this.planningRegime = _data["planningRegime"];
            this.experimentId = _data["experimentId"];
            this.groupTrialId = _data["groupTrialId"];
            this.experimentTypeId = _data["experimentTypeId"];
            this.experimentSpecieQuantityId = _data["experimentSpecieQuantityId"];
            this.experimentSpecieId = _data["experimentSpecieId"];
            this.stigmaCloneId = _data["stigmaCloneId"];
            this.experimentLocationId = _data["experimentLocationId"];
            this.experimentCategoryId = _data["experimentCategoryId"];
            this.experimentClassificationId = _data["experimentClassificationId"];
            this.experimentClasificationtwoId = _data["experimentClasificationtwoId"];
            this.trialDesignTypesId = _data["trialDesignTypesId"];
            this.trialStatusId = _data["trialStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SilvicultureTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentStigma"] = this.experimentStigma;
        data["region"] = this.region;
        data["zone"] = this.zone;
        data["property"] = this.property;
        data["stand"] = this.stand;
        data["standArea"] = this.standArea;
        data["cycle"] = this.cycle;
        data["rotation"] = this.rotation;
        data["coneat"] = this.coneat;
        data["geology"] = this.geology;
        data["soilUnit"] = this.soilUnit;
        data["specialWords"] = this.specialWords;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["instalationYear"] = this.instalationYear;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["plantationDensity"] = this.plantationDensity;
        data["treeDistance"] = this.treeDistance;
        data["rowDistance"] = this.rowDistance;
        data["treatmentNumber"] = this.treatmentNumber;
        data["repeats"] = this.repeats;
        data["treeByParcel"] = this.treeByParcel;
        data["totalExperimentTree"] = this.totalExperimentTree;
        data["experimentArea"] = this.experimentArea;
        data["observation"] = this.observation;
        data["observation2"] = this.observation2;
        data["data"] = this.data;
        data["standLatitude"] = this.standLatitude;
        data["standLength"] = this.standLength;
        data["planningRegime"] = this.planningRegime;
        data["experimentId"] = this.experimentId;
        data["groupTrialId"] = this.groupTrialId;
        data["experimentTypeId"] = this.experimentTypeId;
        data["experimentSpecieQuantityId"] = this.experimentSpecieQuantityId;
        data["experimentSpecieId"] = this.experimentSpecieId;
        data["stigmaCloneId"] = this.stigmaCloneId;
        data["experimentLocationId"] = this.experimentLocationId;
        data["experimentCategoryId"] = this.experimentCategoryId;
        data["experimentClassificationId"] = this.experimentClassificationId;
        data["experimentClasificationtwoId"] = this.experimentClasificationtwoId;
        data["trialDesignTypesId"] = this.trialDesignTypesId;
        data["trialStatusId"] = this.trialStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISilvicultureTrialDto {
    experimentStigma: string | undefined;
    region: string | undefined;
    zone: string | undefined;
    property: string | undefined;
    stand: string | undefined;
    standArea: number | undefined;
    cycle: number | undefined;
    rotation: number | undefined;
    coneat: string | undefined;
    geology: string | undefined;
    soilUnit: string | undefined;
    specialWords: string | undefined;
    instalationDate: DateTime;
    instalationYear: number;
    plantationDate: DateTime | undefined;
    plantationDensity: number | undefined;
    treeDistance: number | undefined;
    rowDistance: number | undefined;
    treatmentNumber: number;
    repeats: number | undefined;
    treeByParcel: number | undefined;
    totalExperimentTree: number | undefined;
    experimentArea: number | undefined;
    observation: string | undefined;
    observation2: string | undefined;
    data: string | undefined;
    standLatitude: number | undefined;
    standLength: number | undefined;
    planningRegime: string | undefined;
    experimentId: string | undefined;
    groupTrialId: number;
    experimentTypeId: number;
    experimentSpecieQuantityId: number;
    experimentSpecieId: number;
    stigmaCloneId: number | undefined;
    experimentLocationId: number;
    experimentCategoryId: number;
    experimentClassificationId: number;
    experimentClasificationtwoId: number;
    trialDesignTypesId: number;
    trialStatusId: number;
    id: number;
}

export class SilvicultureTrialExperimentCategoryLookupTableDto implements ISilvicultureTrialExperimentCategoryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentCategoryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentClasificationtwoLookupTableDto implements ISilvicultureTrialExperimentClasificationtwoLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentClasificationtwoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentClasificationtwoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentClasificationtwoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentClasificationtwoLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentClassificationLookupTableDto implements ISilvicultureTrialExperimentClassificationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentClassificationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentClassificationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentClassificationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentClassificationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentLocationLookupTableDto implements ISilvicultureTrialExperimentLocationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentLocationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentSpecieLookupTableDto implements ISilvicultureTrialExperimentSpecieLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentSpecieLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentSpecieLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentSpecieLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentSpecieLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentSpecieQuantityLookupTableDto implements ISilvicultureTrialExperimentSpecieQuantityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentSpecieQuantityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentSpecieQuantityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentSpecieQuantityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentSpecieQuantityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialExperimentTypeLookupTableDto implements ISilvicultureTrialExperimentTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialExperimentTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialExperimentTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialExperimentTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialExperimentTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialGroupTrialLookupTableDto implements ISilvicultureTrialGroupTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialGroupTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialGroupTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialGroupTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialGroupTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialTrialDesignTypesLookupTableDto implements ISilvicultureTrialTrialDesignTypesLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialTrialDesignTypesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialTrialDesignTypesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialTrialDesignTypesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialTrialDesignTypesLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SilvicultureTrialTrialStatusLookupTableDto implements ISilvicultureTrialTrialStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISilvicultureTrialTrialStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SilvicultureTrialTrialStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SilvicultureTrialTrialStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISilvicultureTrialTrialStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SourcePlantCloneLookupTableDto implements ISourcePlantCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displaySpeciesName!: string | undefined;
    displayNameBBT!: string | undefined;
    idBBT!: number | undefined;

    constructor(data?: ISourcePlantCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displaySpeciesName = _data["displaySpeciesName"];
            this.displayNameBBT = _data["displayNameBBT"];
            this.idBBT = _data["idBBT"];
        }
    }

    static fromJS(data: any): SourcePlantCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displaySpeciesName"] = this.displaySpeciesName;
        data["displayNameBBT"] = this.displayNameBBT;
        data["idBBT"] = this.idBBT;
        return data;
    }
}

export interface ISourcePlantCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
    displaySpeciesName: string | undefined;
    displayNameBBT: string | undefined;
    idBBT: number | undefined;
}

export class SourcePlantDto implements ISourcePlantDto {
    groupNumber!: number;
    startDate!: DateTime;
    originSourcePlant!: EnumOriginSourcePlant;
    projectId!: number | undefined;
    measurementSelectionId!: number | undefined;
    cloneId!: number | undefined;
    sourcePlantId!: number | undefined;
    id!: number;

    constructor(data?: ISourcePlantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupNumber = _data["groupNumber"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.originSourcePlant = _data["originSourcePlant"];
            this.projectId = _data["projectId"];
            this.measurementSelectionId = _data["measurementSelectionId"];
            this.cloneId = _data["cloneId"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SourcePlantDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupNumber"] = this.groupNumber;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["originSourcePlant"] = this.originSourcePlant;
        data["projectId"] = this.projectId;
        data["measurementSelectionId"] = this.measurementSelectionId;
        data["cloneId"] = this.cloneId;
        data["sourcePlantId"] = this.sourcePlantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISourcePlantDto {
    groupNumber: number;
    startDate: DateTime;
    originSourcePlant: EnumOriginSourcePlant;
    projectId: number | undefined;
    measurementSelectionId: number | undefined;
    cloneId: number | undefined;
    sourcePlantId: number | undefined;
    id: number;
}

export class SourcePlantMeasurementSelectionLookupTableDto implements ISourcePlantMeasurementSelectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displaySpeciesName!: string | undefined;
    displayNameBBX!: string | undefined;
    idBBX!: number | undefined;

    constructor(data?: ISourcePlantMeasurementSelectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displaySpeciesName = _data["displaySpeciesName"];
            this.displayNameBBX = _data["displayNameBBX"];
            this.idBBX = _data["idBBX"];
        }
    }

    static fromJS(data: any): SourcePlantMeasurementSelectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantMeasurementSelectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displaySpeciesName"] = this.displaySpeciesName;
        data["displayNameBBX"] = this.displayNameBBX;
        data["idBBX"] = this.idBBX;
        return data;
    }
}

export interface ISourcePlantMeasurementSelectionLookupTableDto {
    id: number;
    displayName: string | undefined;
    displaySpeciesName: string | undefined;
    displayNameBBX: string | undefined;
    idBBX: number | undefined;
}

export class SourcePlantPlantationDto implements ISourcePlantPlantationDto {
    plantationDate!: DateTime;
    quantity!: number;
    canaleton!: number;
    position!: number;
    observations!: string | undefined;
    sourcePlantId!: number;
    plantationNumber!: number;
    discardDate!: DateTime | undefined;
    id!: number;

    constructor(data?: ISourcePlantPlantationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.quantity = _data["quantity"];
            this.canaleton = _data["canaleton"];
            this.position = _data["position"];
            this.observations = _data["observations"];
            this.sourcePlantId = _data["sourcePlantId"];
            this.plantationNumber = _data["plantationNumber"];
            this.discardDate = _data["discardDate"] ? DateTime.fromISO(_data["discardDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SourcePlantPlantationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantPlantationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["quantity"] = this.quantity;
        data["canaleton"] = this.canaleton;
        data["position"] = this.position;
        data["observations"] = this.observations;
        data["sourcePlantId"] = this.sourcePlantId;
        data["plantationNumber"] = this.plantationNumber;
        data["discardDate"] = this.discardDate ? this.discardDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ISourcePlantPlantationDto {
    plantationDate: DateTime;
    quantity: number;
    canaleton: number;
    position: number;
    observations: string | undefined;
    sourcePlantId: number;
    plantationNumber: number;
    discardDate: DateTime | undefined;
    id: number;
}

export class SourcePlantPlantationSourcePlantLookupTableDto implements ISourcePlantPlantationSourcePlantLookupTableDto {
    id!: number;
    displayName!: number;

    constructor(data?: ISourcePlantPlantationSourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SourcePlantPlantationSourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantPlantationSourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISourcePlantPlantationSourcePlantLookupTableDto {
    id: number;
    displayName: number;
}

export class SourcePlantProjectLookupTableDto implements ISourcePlantProjectLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISourcePlantProjectLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SourcePlantProjectLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantProjectLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISourcePlantProjectLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SourcePlantSourcePlantLookupTableDto implements ISourcePlantSourcePlantLookupTableDto {
    id!: number;
    displayName!: number;
    displayBBX!: string | undefined;
    displayBBXId!: number | undefined;
    displayBBT!: string | undefined;
    displayBBTId!: number | undefined;
    displaySpecies!: string | undefined;
    displayNameProject!: string | undefined;
    displayNameProjectId!: number | undefined;

    constructor(data?: ISourcePlantSourcePlantLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayBBX = _data["displayBBX"];
            this.displayBBXId = _data["displayBBXId"];
            this.displayBBT = _data["displayBBT"];
            this.displayBBTId = _data["displayBBTId"];
            this.displaySpecies = _data["displaySpecies"];
            this.displayNameProject = _data["displayNameProject"];
            this.displayNameProjectId = _data["displayNameProjectId"];
        }
    }

    static fromJS(data: any): SourcePlantSourcePlantLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcePlantSourcePlantLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayBBX"] = this.displayBBX;
        data["displayBBXId"] = this.displayBBXId;
        data["displayBBT"] = this.displayBBT;
        data["displayBBTId"] = this.displayBBTId;
        data["displaySpecies"] = this.displaySpecies;
        data["displayNameProject"] = this.displayNameProject;
        data["displayNameProjectId"] = this.displayNameProjectId;
        return data;
    }
}

export interface ISourcePlantSourcePlantLookupTableDto {
    id: number;
    displayName: number;
    displayBBX: string | undefined;
    displayBBXId: number | undefined;
    displayBBT: string | undefined;
    displayBBTId: number | undefined;
    displaySpecies: string | undefined;
    displayNameProject: string | undefined;
    displayNameProjectId: number | undefined;
}

export class SpeciesColorMappingDto implements ISpeciesColorMappingDto {
    species!: string | undefined;
    color!: string | undefined;

    constructor(data?: ISpeciesColorMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.species = _data["species"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): SpeciesColorMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesColorMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["species"] = this.species;
        data["color"] = this.color;
        return data;
    }
}

export interface ISpeciesColorMappingDto {
    species: string | undefined;
    color: string | undefined;
}

export class SpeciesGroup implements ISpeciesGroup {
    tenantId!: number | undefined;
    name!: string;
    species!: string | undefined;
    formula!: string | undefined;
    siteClassification!: EnumSiteClassification;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISpeciesGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.species = _data["species"];
            this.formula = _data["formula"];
            this.siteClassification = _data["siteClassification"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SpeciesGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["species"] = this.species;
        data["formula"] = this.formula;
        data["siteClassification"] = this.siteClassification;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISpeciesGroup {
    tenantId: number | undefined;
    name: string;
    species: string | undefined;
    formula: string | undefined;
    siteClassification: EnumSiteClassification;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SpeciesGroupDto implements ISpeciesGroupDto {
    name!: string | undefined;
    species!: string | undefined;
    formula!: string | undefined;
    siteClassification!: EnumSiteClassification;
    id!: number;

    constructor(data?: ISpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.species = _data["species"];
            this.formula = _data["formula"];
            this.siteClassification = _data["siteClassification"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["species"] = this.species;
        data["formula"] = this.formula;
        data["siteClassification"] = this.siteClassification;
        data["id"] = this.id;
        return data;
    }
}

export interface ISpeciesGroupDto {
    name: string | undefined;
    species: string | undefined;
    formula: string | undefined;
    siteClassification: EnumSiteClassification;
    id: number;
}

export class SpeciesGroupLookupTableDto implements ISpeciesGroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISpeciesGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SpeciesGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISpeciesGroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class StatusCloneLookupTableDto implements IStatusCloneLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStatusCloneLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StatusCloneLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCloneLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IStatusCloneLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class Supplier implements ISupplier {
    tenantId!: number | undefined;
    name!: string;
    isFOSA!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isFOSA = _data["isFOSA"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isFOSA"] = this.isFOSA;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISupplier {
    tenantId: number | undefined;
    name: string;
    isFOSA: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SupplierDto implements ISupplierDto {
    name!: string | undefined;
    isFOSA!: boolean;
    id!: number;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isFOSA = _data["isFOSA"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isFOSA"] = this.isFOSA;
        data["id"] = this.id;
        return data;
    }
}

export interface ISupplierDto {
    name: string | undefined;
    isFOSA: boolean;
    id: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : undefined as any;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : undefined as any;
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : undefined as any;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : undefined as any;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : undefined as any;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : undefined as any;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : undefined as any;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined as any;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : undefined as any;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : undefined as any;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : undefined as any;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : undefined as any;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : undefined as any;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined as any;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined as any;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStlye!: string | undefined;
    containerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStlye = _data["titleStlye"];
            this.containerStyle = _data["containerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStlye"] = this.titleStlye;
        data["containerStyle"] = this.containerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStlye: string | undefined;
    containerStyle: string | undefined;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class Treatment implements ITreatment {
    tenantId!: number | undefined;
    number!: number;
    nameTratament!: string | undefined;
    bulk!: boolean | undefined;
    block!: number | undefined;
    subBlock!: number | undefined;
    trialId!: number;
    trialFk!: Trial;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.number = _data["number"];
            this.nameTratament = _data["nameTratament"];
            this.bulk = _data["bulk"];
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.trialId = _data["trialId"];
            this.trialFk = _data["trialFk"] ? Trial.fromJS(_data["trialFk"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Treatment {
        data = typeof data === 'object' ? data : {};
        let result = new Treatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["number"] = this.number;
        data["nameTratament"] = this.nameTratament;
        data["bulk"] = this.bulk;
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["trialId"] = this.trialId;
        data["trialFk"] = this.trialFk ? this.trialFk.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatment {
    tenantId: number | undefined;
    number: number;
    nameTratament: string | undefined;
    bulk: boolean | undefined;
    block: number | undefined;
    subBlock: number | undefined;
    trialId: number;
    trialFk: Trial;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TreatmentApplyDto implements ITreatmentApplyDto {
    apply!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentApplyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apply = _data["apply"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentApplyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentApplyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apply"] = this.apply;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentApplyDto {
    apply: string | undefined;
    id: number;
}

export class TreatmentDoseTypeDto implements ITreatmentDoseTypeDto {
    doseType!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentDoseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseType = _data["doseType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentDoseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentDoseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseType"] = this.doseType;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentDoseTypeDto {
    doseType: string | undefined;
    id: number;
}

export class TreatmentDto implements ITreatmentDto {
    block!: number | undefined;
    subBlock!: number | undefined;
    trialId!: number;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    originalTreeId!: number | undefined;
    trialNumber!: number;
    number!: number;
    nameTratament!: string | undefined;
    bulk!: boolean | undefined;
    id!: number;

    constructor(data?: ITreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.block = _data["block"];
            this.subBlock = _data["subBlock"];
            this.trialId = _data["trialId"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.originalTreeId = _data["originalTreeId"];
            this.trialNumber = _data["trialNumber"];
            this.number = _data["number"];
            this.nameTratament = _data["nameTratament"];
            this.bulk = _data["bulk"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["block"] = this.block;
        data["subBlock"] = this.subBlock;
        data["trialId"] = this.trialId;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["originalTreeId"] = this.originalTreeId;
        data["trialNumber"] = this.trialNumber;
        data["number"] = this.number;
        data["nameTratament"] = this.nameTratament;
        data["bulk"] = this.bulk;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentDto {
    block: number | undefined;
    subBlock: number | undefined;
    trialId: number;
    seedId: number | undefined;
    cloneId: number | undefined;
    originalTreeId: number | undefined;
    trialNumber: number;
    number: number;
    nameTratament: string | undefined;
    bulk: boolean | undefined;
    id: number;
}

export class TreatmentInterventionDto implements ITreatmentInterventionDto {
    zone!: string | undefined;
    moment!: string | undefined;
    objective!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentInterventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zone = _data["zone"];
            this.moment = _data["moment"];
            this.objective = _data["objective"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentInterventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentInterventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone;
        data["moment"] = this.moment;
        data["objective"] = this.objective;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentInterventionDto {
    zone: string | undefined;
    moment: string | undefined;
    objective: string | undefined;
    id: number;
}

export class TreatmentObjectiveDto implements ITreatmentObjectiveDto {
    objective!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objective = _data["objective"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objective"] = this.objective;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentObjectiveDto {
    objective: string | undefined;
    id: number;
}

export class TreatmentParcelTypeDto implements ITreatmentParcelTypeDto {
    parcelType!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentParcelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parcelType = _data["parcelType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentParcelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentParcelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parcelType"] = this.parcelType;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentParcelTypeDto {
    parcelType: string | undefined;
    id: number;
}

export class TreatmentProductDto implements ITreatmentProductDto {
    name!: string | undefined;
    abbreviation!: string | undefined;
    manufacturer!: string | undefined;
    composition!: string | undefined;
    tdl!: string | undefined;
    fertilizerType!: string | undefined;
    formulation!: string | undefined;
    observation!: string | undefined;
    bioforestCode!: string | undefined;
    productName!: string | undefined;
    treatmentProductTypeId!: number;
    id!: number;

    constructor(data?: ITreatmentProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.manufacturer = _data["manufacturer"];
            this.composition = _data["composition"];
            this.tdl = _data["tdl"];
            this.fertilizerType = _data["fertilizerType"];
            this.formulation = _data["formulation"];
            this.observation = _data["observation"];
            this.bioforestCode = _data["bioforestCode"];
            this.productName = _data["productName"];
            this.treatmentProductTypeId = _data["treatmentProductTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["manufacturer"] = this.manufacturer;
        data["composition"] = this.composition;
        data["tdl"] = this.tdl;
        data["fertilizerType"] = this.fertilizerType;
        data["formulation"] = this.formulation;
        data["observation"] = this.observation;
        data["bioforestCode"] = this.bioforestCode;
        data["productName"] = this.productName;
        data["treatmentProductTypeId"] = this.treatmentProductTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentProductDto {
    name: string | undefined;
    abbreviation: string | undefined;
    manufacturer: string | undefined;
    composition: string | undefined;
    tdl: string | undefined;
    fertilizerType: string | undefined;
    formulation: string | undefined;
    observation: string | undefined;
    bioforestCode: string | undefined;
    productName: string | undefined;
    treatmentProductTypeId: number;
    id: number;
}

export class TreatmentProductTreatmentProductTypeLookupTableDto implements ITreatmentProductTreatmentProductTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITreatmentProductTreatmentProductTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TreatmentProductTreatmentProductTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProductTreatmentProductTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITreatmentProductTreatmentProductTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TreatmentProductTypeDto implements ITreatmentProductTypeDto {
    productType!: string | undefined;
    id!: number;

    constructor(data?: ITreatmentProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productType = _data["productType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreatmentProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreatmentProductTypeDto {
    productType: string | undefined;
    id: number;
}

export class TreatmentSeedLookupTableDto implements ITreatmentSeedLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    trialNumber!: number;

    constructor(data?: ITreatmentSeedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.trialNumber = _data["trialNumber"];
        }
    }

    static fromJS(data: any): TreatmentSeedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentSeedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["trialNumber"] = this.trialNumber;
        return data;
    }
}

export interface ITreatmentSeedLookupTableDto {
    id: number;
    displayName: string | undefined;
    trialNumber: number;
}

export class TreatmentTreeLookupTableDto implements ITreatmentTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayTreeName!: string | undefined;
    dataBBS!: string | undefined;
    dataBBX!: string | undefined;
    dataBBT!: string | undefined;
    dataTrial!: number;
    dataSpecie!: string | undefined;
    dataBlock!: number | undefined;
    dataSubBlock!: number | undefined;
    dataY!: number | undefined;
    dataTreeNumber!: number;
    plantationDate!: DateTime;
    dataTrialStandName!: string | undefined;
    standName!: string | undefined;
    dataNS!: string | undefined;
    dataNX!: string | undefined;
    dataBBSId!: number | undefined;
    dataBBXId!: number | undefined;

    constructor(data?: ITreatmentTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBT = _data["dataBBT"];
            this.dataTrial = _data["dataTrial"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBlock = _data["dataBlock"];
            this.dataSubBlock = _data["dataSubBlock"];
            this.dataY = _data["dataY"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.dataTrialStandName = _data["dataTrialStandName"];
            this.standName = _data["standName"];
            this.dataNS = _data["dataNS"];
            this.dataNX = _data["dataNX"];
            this.dataBBSId = _data["dataBBSId"];
            this.dataBBXId = _data["dataBBXId"];
        }
    }

    static fromJS(data: any): TreatmentTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeName"] = this.displayTreeName;
        data["dataBBS"] = this.dataBBS;
        data["dataBBX"] = this.dataBBX;
        data["dataBBT"] = this.dataBBT;
        data["dataTrial"] = this.dataTrial;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBlock"] = this.dataBlock;
        data["dataSubBlock"] = this.dataSubBlock;
        data["dataY"] = this.dataY;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["dataTrialStandName"] = this.dataTrialStandName;
        data["standName"] = this.standName;
        data["dataNS"] = this.dataNS;
        data["dataNX"] = this.dataNX;
        data["dataBBSId"] = this.dataBBSId;
        data["dataBBXId"] = this.dataBBXId;
        return data;
    }
}

export interface ITreatmentTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayTreeName: string | undefined;
    dataBBS: string | undefined;
    dataBBX: string | undefined;
    dataBBT: string | undefined;
    dataTrial: number;
    dataSpecie: string | undefined;
    dataBlock: number | undefined;
    dataSubBlock: number | undefined;
    dataY: number | undefined;
    dataTreeNumber: number;
    plantationDate: DateTime;
    dataTrialStandName: string | undefined;
    standName: string | undefined;
    dataNS: string | undefined;
    dataNX: string | undefined;
    dataBBSId: number | undefined;
    dataBBXId: number | undefined;
}

export class TreatmentTrialLookupTableDto implements ITreatmentTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    status!: string | undefined;
    displayTrialNumber!: number;
    isAlfaLaticeAsterisk!: boolean | undefined;
    isClonalSeedOrchard!: boolean | undefined;
    plantationDate!: DateTime;

    constructor(data?: ITreatmentTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.status = _data["status"];
            this.displayTrialNumber = _data["displayTrialNumber"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TreatmentTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["status"] = this.status;
        data["displayTrialNumber"] = this.displayTrialNumber;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        return data;
    }
}

export interface ITreatmentTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
    status: string | undefined;
    displayTrialNumber: number;
    isAlfaLaticeAsterisk: boolean | undefined;
    isClonalSeedOrchard: boolean | undefined;
    plantationDate: DateTime;
}

export class Tree implements ITree {
    tenantId!: number | undefined;
    treeNumber!: number;
    specie!: string | undefined;
    plantationDate!: DateTime | undefined;
    ns!: string | undefined;
    nx!: string | undefined;
    row!: number | undefined;
    plot!: string | undefined;
    x!: number | undefined;
    y!: number | undefined;
    order!: number;
    seedId!: number | undefined;
    seedFk!: Seed;
    cloneId!: number | undefined;
    cloneFk!: Clone;
    treatmentId!: number;
    treatmentFk!: Treatment;
    originalTreeId!: number | undefined;
    originalTreeFk!: Tree;
    treeStatusId!: number | undefined;
    treeStatusFk!: TreeStatus;
    seedlingId!: number | undefined;
    seedling!: Seedling;
    originTrayId!: EnumOriginSourcePlant;
    qualityCode!: string | undefined;
    renewalDate!: DateTime | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.treeNumber = _data["treeNumber"];
            this.specie = _data["specie"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.ns = _data["ns"];
            this.nx = _data["nx"];
            this.row = _data["row"];
            this.plot = _data["plot"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.order = _data["order"];
            this.seedId = _data["seedId"];
            this.seedFk = _data["seedFk"] ? Seed.fromJS(_data["seedFk"]) : undefined as any;
            this.cloneId = _data["cloneId"];
            this.cloneFk = _data["cloneFk"] ? Clone.fromJS(_data["cloneFk"]) : undefined as any;
            this.treatmentId = _data["treatmentId"];
            this.treatmentFk = _data["treatmentFk"] ? Treatment.fromJS(_data["treatmentFk"]) : undefined as any;
            this.originalTreeId = _data["originalTreeId"];
            this.originalTreeFk = _data["originalTreeFk"] ? Tree.fromJS(_data["originalTreeFk"]) : undefined as any;
            this.treeStatusId = _data["treeStatusId"];
            this.treeStatusFk = _data["treeStatusFk"] ? TreeStatus.fromJS(_data["treeStatusFk"]) : undefined as any;
            this.seedlingId = _data["seedlingId"];
            this.seedling = _data["seedling"] ? Seedling.fromJS(_data["seedling"]) : undefined as any;
            this.originTrayId = _data["originTrayId"];
            this.qualityCode = _data["qualityCode"];
            this.renewalDate = _data["renewalDate"] ? DateTime.fromISO(_data["renewalDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tree {
        data = typeof data === 'object' ? data : {};
        let result = new Tree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["treeNumber"] = this.treeNumber;
        data["specie"] = this.specie;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["ns"] = this.ns;
        data["nx"] = this.nx;
        data["row"] = this.row;
        data["plot"] = this.plot;
        data["x"] = this.x;
        data["y"] = this.y;
        data["order"] = this.order;
        data["seedId"] = this.seedId;
        data["seedFk"] = this.seedFk ? this.seedFk.toJSON() : undefined as any;
        data["cloneId"] = this.cloneId;
        data["cloneFk"] = this.cloneFk ? this.cloneFk.toJSON() : undefined as any;
        data["treatmentId"] = this.treatmentId;
        data["treatmentFk"] = this.treatmentFk ? this.treatmentFk.toJSON() : undefined as any;
        data["originalTreeId"] = this.originalTreeId;
        data["originalTreeFk"] = this.originalTreeFk ? this.originalTreeFk.toJSON() : undefined as any;
        data["treeStatusId"] = this.treeStatusId;
        data["treeStatusFk"] = this.treeStatusFk ? this.treeStatusFk.toJSON() : undefined as any;
        data["seedlingId"] = this.seedlingId;
        data["seedling"] = this.seedling ? this.seedling.toJSON() : undefined as any;
        data["originTrayId"] = this.originTrayId;
        data["qualityCode"] = this.qualityCode;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITree {
    tenantId: number | undefined;
    treeNumber: number;
    specie: string | undefined;
    plantationDate: DateTime | undefined;
    ns: string | undefined;
    nx: string | undefined;
    row: number | undefined;
    plot: string | undefined;
    x: number | undefined;
    y: number | undefined;
    order: number;
    seedId: number | undefined;
    seedFk: Seed;
    cloneId: number | undefined;
    cloneFk: Clone;
    treatmentId: number;
    treatmentFk: Treatment;
    originalTreeId: number | undefined;
    originalTreeFk: Tree;
    treeStatusId: number | undefined;
    treeStatusFk: TreeStatus;
    seedlingId: number | undefined;
    seedling: Seedling;
    originTrayId: EnumOriginSourcePlant;
    qualityCode: string | undefined;
    renewalDate: DateTime | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TreeDto implements ITreeDto {
    treeNumber!: number;
    specie!: string | undefined;
    plantationDate!: DateTime | undefined;
    ns!: string | undefined;
    nx!: string | undefined;
    order!: number;
    row!: number | undefined;
    plot!: string | undefined;
    x!: number | undefined;
    y!: number | undefined;
    treatmentId!: number;
    treeStatusId!: number | undefined;
    treeStatusName!: string | undefined;
    seedId!: number | undefined;
    cloneId!: number | undefined;
    originTrayId!: EnumOriginSourcePlant;
    qualityCode!: string | undefined;
    renewalDate!: DateTime | undefined;
    originTrayName!: string | undefined;
    originalTreeName!: string | undefined;
    originalTreeId!: number | undefined;
    id!: number;

    constructor(data?: ITreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNumber = _data["treeNumber"];
            this.specie = _data["specie"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.ns = _data["ns"];
            this.nx = _data["nx"];
            this.order = _data["order"];
            this.row = _data["row"];
            this.plot = _data["plot"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.treatmentId = _data["treatmentId"];
            this.treeStatusId = _data["treeStatusId"];
            this.treeStatusName = _data["treeStatusName"];
            this.seedId = _data["seedId"];
            this.cloneId = _data["cloneId"];
            this.originTrayId = _data["originTrayId"];
            this.qualityCode = _data["qualityCode"];
            this.renewalDate = _data["renewalDate"] ? DateTime.fromISO(_data["renewalDate"].toString()) : undefined as any;
            this.originTrayName = _data["originTrayName"];
            this.originalTreeName = _data["originalTreeName"];
            this.originalTreeId = _data["originalTreeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNumber"] = this.treeNumber;
        data["specie"] = this.specie;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["ns"] = this.ns;
        data["nx"] = this.nx;
        data["order"] = this.order;
        data["row"] = this.row;
        data["plot"] = this.plot;
        data["x"] = this.x;
        data["y"] = this.y;
        data["treatmentId"] = this.treatmentId;
        data["treeStatusId"] = this.treeStatusId;
        data["treeStatusName"] = this.treeStatusName;
        data["seedId"] = this.seedId;
        data["cloneId"] = this.cloneId;
        data["originTrayId"] = this.originTrayId;
        data["qualityCode"] = this.qualityCode;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toString() : undefined as any;
        data["originTrayName"] = this.originTrayName;
        data["originalTreeName"] = this.originalTreeName;
        data["originalTreeId"] = this.originalTreeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeDto {
    treeNumber: number;
    specie: string | undefined;
    plantationDate: DateTime | undefined;
    ns: string | undefined;
    nx: string | undefined;
    order: number;
    row: number | undefined;
    plot: string | undefined;
    x: number | undefined;
    y: number | undefined;
    treatmentId: number;
    treeStatusId: number | undefined;
    treeStatusName: string | undefined;
    seedId: number | undefined;
    cloneId: number | undefined;
    originTrayId: EnumOriginSourcePlant;
    qualityCode: string | undefined;
    renewalDate: DateTime | undefined;
    originTrayName: string | undefined;
    originalTreeName: string | undefined;
    originalTreeId: number | undefined;
    id: number;
}

export class TreeManagementDto implements ITreeManagementDto {
    treeOld!: string | undefined;
    treeNew!: string | undefined;
    dateModified!: DateTime;
    treeId!: number;
    id!: number;

    constructor(data?: ITreeManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeOld = _data["treeOld"];
            this.treeNew = _data["treeNew"];
            this.dateModified = _data["dateModified"] ? DateTime.fromISO(_data["dateModified"].toString()) : undefined as any;
            this.treeId = _data["treeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeOld"] = this.treeOld;
        data["treeNew"] = this.treeNew;
        data["dateModified"] = this.dateModified ? this.dateModified.toString() : undefined as any;
        data["treeId"] = this.treeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeManagementDto {
    treeOld: string | undefined;
    treeNew: string | undefined;
    dateModified: DateTime;
    treeId: number;
    id: number;
}

export class TreeManagementTreeLookupTableDto implements ITreeManagementTreeLookupTableDto {
    dataBBS!: string | undefined;
    id!: number;
    displayName!: string | undefined;
    displayTreeName!: string | undefined;
    dataBBX!: string | undefined;
    dataBBT!: string | undefined;
    dataTrial!: number;
    dataSpecie!: string | undefined;
    dataBBSId!: number | undefined;
    dataBBXId!: number | undefined;
    dataBBTId!: number | undefined;
    dataTrialId!: number;
    dataTreeBlock!: number | undefined;
    dataTreeSubBlock!: number | undefined;
    dataTreeNumber!: number;
    dataOriginSite!: string | undefined;

    constructor(data?: ITreeManagementTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataBBS = _data["dataBBS"];
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBT = _data["dataBBT"];
            this.dataTrial = _data["dataTrial"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBBSId = _data["dataBBSId"];
            this.dataBBXId = _data["dataBBXId"];
            this.dataBBTId = _data["dataBBTId"];
            this.dataTrialId = _data["dataTrialId"];
            this.dataTreeBlock = _data["dataTreeBlock"];
            this.dataTreeSubBlock = _data["dataTreeSubBlock"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.dataOriginSite = _data["dataOriginSite"];
        }
    }

    static fromJS(data: any): TreeManagementTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeManagementTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataBBS"] = this.dataBBS;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeName"] = this.displayTreeName;
        data["dataBBX"] = this.dataBBX;
        data["dataBBT"] = this.dataBBT;
        data["dataTrial"] = this.dataTrial;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBBSId"] = this.dataBBSId;
        data["dataBBXId"] = this.dataBBXId;
        data["dataBBTId"] = this.dataBBTId;
        data["dataTrialId"] = this.dataTrialId;
        data["dataTreeBlock"] = this.dataTreeBlock;
        data["dataTreeSubBlock"] = this.dataTreeSubBlock;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["dataOriginSite"] = this.dataOriginSite;
        return data;
    }
}

export interface ITreeManagementTreeLookupTableDto {
    dataBBS: string | undefined;
    id: number;
    displayName: string | undefined;
    displayTreeName: string | undefined;
    dataBBX: string | undefined;
    dataBBT: string | undefined;
    dataTrial: number;
    dataSpecie: string | undefined;
    dataBBSId: number | undefined;
    dataBBXId: number | undefined;
    dataBBTId: number | undefined;
    dataTrialId: number;
    dataTreeBlock: number | undefined;
    dataTreeSubBlock: number | undefined;
    dataTreeNumber: number;
    dataOriginSite: string | undefined;
}

export class TreeMeasurementAdultObservationCodeLookupTableDto implements ITreeMeasurementAdultObservationCodeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITreeMeasurementAdultObservationCodeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TreeMeasurementAdultObservationCodeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementAdultObservationCodeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITreeMeasurementAdultObservationCodeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TreeMeasurementAlertDto implements ITreeMeasurementAlertDto {
    date!: DateTime;
    code!: EnumTreeMeasurementAlert;
    height!: number | undefined;
    dap!: number | undefined;
    trialId!: number;
    treeName!: string | undefined;
    previousHeight!: number | undefined;
    previousDap!: number | undefined;
    defectHeight!: number | undefined;
    observations!: string | undefined;
    adultObservationCodeId!: number | undefined;
    adultObservationCodeDetail!: string | undefined;
    measurementPlanningOptionsName!: string | undefined;
    measurementPlanningOptionsAssignmentName!: string | undefined;
    treeStatusName!: string | undefined;
    id!: number;

    constructor(data?: ITreeMeasurementAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.code = _data["code"];
            this.height = _data["height"];
            this.dap = _data["dap"];
            this.trialId = _data["trialId"];
            this.treeName = _data["treeName"];
            this.previousHeight = _data["previousHeight"];
            this.previousDap = _data["previousDap"];
            this.defectHeight = _data["defectHeight"];
            this.observations = _data["observations"];
            this.adultObservationCodeId = _data["adultObservationCodeId"];
            this.adultObservationCodeDetail = _data["adultObservationCodeDetail"];
            this.measurementPlanningOptionsName = _data["measurementPlanningOptionsName"];
            this.measurementPlanningOptionsAssignmentName = _data["measurementPlanningOptionsAssignmentName"];
            this.treeStatusName = _data["treeStatusName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeMeasurementAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["code"] = this.code;
        data["height"] = this.height;
        data["dap"] = this.dap;
        data["trialId"] = this.trialId;
        data["treeName"] = this.treeName;
        data["previousHeight"] = this.previousHeight;
        data["previousDap"] = this.previousDap;
        data["defectHeight"] = this.defectHeight;
        data["observations"] = this.observations;
        data["adultObservationCodeId"] = this.adultObservationCodeId;
        data["adultObservationCodeDetail"] = this.adultObservationCodeDetail;
        data["measurementPlanningOptionsName"] = this.measurementPlanningOptionsName;
        data["measurementPlanningOptionsAssignmentName"] = this.measurementPlanningOptionsAssignmentName;
        data["treeStatusName"] = this.treeStatusName;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeMeasurementAlertDto {
    date: DateTime;
    code: EnumTreeMeasurementAlert;
    height: number | undefined;
    dap: number | undefined;
    trialId: number;
    treeName: string | undefined;
    previousHeight: number | undefined;
    previousDap: number | undefined;
    defectHeight: number | undefined;
    observations: string | undefined;
    adultObservationCodeId: number | undefined;
    adultObservationCodeDetail: string | undefined;
    measurementPlanningOptionsName: string | undefined;
    measurementPlanningOptionsAssignmentName: string | undefined;
    treeStatusName: string | undefined;
    id: number;
}

export class TreeMeasurementDto implements ITreeMeasurementDto {
    measurementDate!: DateTime;
    dap!: number | undefined;
    height!: number | undefined;
    volume!: number | undefined;
    defectHeight!: number | undefined;
    sobre!: number | undefined;
    observations!: string | undefined;
    flia!: string | undefined;
    treeId!: number;
    adultObservationCodeId!: number | undefined;
    frostToleranceCodeId!: number | undefined;
    pestAndDiseaseCodeId!: number | undefined;
    pestAndDiseaseCodeIntensity!: number | undefined;
    pestAndDiseaseCodeSeverity!: number | undefined;
    measurementPlaningOptionsId!: number | undefined;
    id!: number;

    constructor(data?: ITreeMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementDate = _data["measurementDate"] ? DateTime.fromISO(_data["measurementDate"].toString()) : undefined as any;
            this.dap = _data["dap"];
            this.height = _data["height"];
            this.volume = _data["volume"];
            this.defectHeight = _data["defectHeight"];
            this.sobre = _data["sobre"];
            this.observations = _data["observations"];
            this.flia = _data["flia"];
            this.treeId = _data["treeId"];
            this.adultObservationCodeId = _data["adultObservationCodeId"];
            this.frostToleranceCodeId = _data["frostToleranceCodeId"];
            this.pestAndDiseaseCodeId = _data["pestAndDiseaseCodeId"];
            this.pestAndDiseaseCodeIntensity = _data["pestAndDiseaseCodeIntensity"];
            this.pestAndDiseaseCodeSeverity = _data["pestAndDiseaseCodeSeverity"];
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toString() : undefined as any;
        data["dap"] = this.dap;
        data["height"] = this.height;
        data["volume"] = this.volume;
        data["defectHeight"] = this.defectHeight;
        data["sobre"] = this.sobre;
        data["observations"] = this.observations;
        data["flia"] = this.flia;
        data["treeId"] = this.treeId;
        data["adultObservationCodeId"] = this.adultObservationCodeId;
        data["frostToleranceCodeId"] = this.frostToleranceCodeId;
        data["pestAndDiseaseCodeId"] = this.pestAndDiseaseCodeId;
        data["pestAndDiseaseCodeIntensity"] = this.pestAndDiseaseCodeIntensity;
        data["pestAndDiseaseCodeSeverity"] = this.pestAndDiseaseCodeSeverity;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeMeasurementDto {
    measurementDate: DateTime;
    dap: number | undefined;
    height: number | undefined;
    volume: number | undefined;
    defectHeight: number | undefined;
    sobre: number | undefined;
    observations: string | undefined;
    flia: string | undefined;
    treeId: number;
    adultObservationCodeId: number | undefined;
    frostToleranceCodeId: number | undefined;
    pestAndDiseaseCodeId: number | undefined;
    pestAndDiseaseCodeIntensity: number | undefined;
    pestAndDiseaseCodeSeverity: number | undefined;
    measurementPlaningOptionsId: number | undefined;
    id: number;
}

export class TreeMeasurementFrostToleranceCodeLookupTableDto implements ITreeMeasurementFrostToleranceCodeLookupTableDto {
    id!: number;
    code!: number;
    displayName!: string | undefined;

    constructor(data?: ITreeMeasurementFrostToleranceCodeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TreeMeasurementFrostToleranceCodeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementFrostToleranceCodeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITreeMeasurementFrostToleranceCodeLookupTableDto {
    id: number;
    code: number;
    displayName: string | undefined;
}

export class TreeMeasurementPestAndDiseaseCodeLookupTableDto implements ITreeMeasurementPestAndDiseaseCodeLookupTableDto {
    id!: number;
    code!: number;
    displayName!: string | undefined;

    constructor(data?: ITreeMeasurementPestAndDiseaseCodeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TreeMeasurementPestAndDiseaseCodeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementPestAndDiseaseCodeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITreeMeasurementPestAndDiseaseCodeLookupTableDto {
    id: number;
    code: number;
    displayName: string | undefined;
}

export class TreeMeasurementTreeLookupTableDto implements ITreeMeasurementTreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayTreeName!: string | undefined;
    dataBBS!: string | undefined;
    dataBBX!: string | undefined;
    dataBBT!: string | undefined;
    dataTrial!: number;
    dataSpecie!: string | undefined;
    dataBlock!: number | undefined;
    dataSubBlock!: number | undefined;
    dataY!: number | undefined;
    dataTreeNumber!: number;
    plantationDate!: DateTime;
    dataTrialStandName!: string | undefined;
    standName!: string | undefined;
    dataNS!: string | undefined;
    dataNX!: string | undefined;
    dataPlot!: number | undefined;
    dataNameTreatment!: string | undefined;
    dataTrialId!: number;

    constructor(data?: ITreeMeasurementTreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreeName = _data["displayTreeName"];
            this.dataBBS = _data["dataBBS"];
            this.dataBBX = _data["dataBBX"];
            this.dataBBT = _data["dataBBT"];
            this.dataTrial = _data["dataTrial"];
            this.dataSpecie = _data["dataSpecie"];
            this.dataBlock = _data["dataBlock"];
            this.dataSubBlock = _data["dataSubBlock"];
            this.dataY = _data["dataY"];
            this.dataTreeNumber = _data["dataTreeNumber"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.dataTrialStandName = _data["dataTrialStandName"];
            this.standName = _data["standName"];
            this.dataNS = _data["dataNS"];
            this.dataNX = _data["dataNX"];
            this.dataPlot = _data["dataPlot"];
            this.dataNameTreatment = _data["dataNameTreatment"];
            this.dataTrialId = _data["dataTrialId"];
        }
    }

    static fromJS(data: any): TreeMeasurementTreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMeasurementTreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreeName"] = this.displayTreeName;
        data["dataBBS"] = this.dataBBS;
        data["dataBBX"] = this.dataBBX;
        data["dataBBT"] = this.dataBBT;
        data["dataTrial"] = this.dataTrial;
        data["dataSpecie"] = this.dataSpecie;
        data["dataBlock"] = this.dataBlock;
        data["dataSubBlock"] = this.dataSubBlock;
        data["dataY"] = this.dataY;
        data["dataTreeNumber"] = this.dataTreeNumber;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["dataTrialStandName"] = this.dataTrialStandName;
        data["standName"] = this.standName;
        data["dataNS"] = this.dataNS;
        data["dataNX"] = this.dataNX;
        data["dataPlot"] = this.dataPlot;
        data["dataNameTreatment"] = this.dataNameTreatment;
        data["dataTrialId"] = this.dataTrialId;
        return data;
    }
}

export interface ITreeMeasurementTreeLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayTreeName: string | undefined;
    dataBBS: string | undefined;
    dataBBX: string | undefined;
    dataBBT: string | undefined;
    dataTrial: number;
    dataSpecie: string | undefined;
    dataBlock: number | undefined;
    dataSubBlock: number | undefined;
    dataY: number | undefined;
    dataTreeNumber: number;
    plantationDate: DateTime;
    dataTrialStandName: string | undefined;
    standName: string | undefined;
    dataNS: string | undefined;
    dataNX: string | undefined;
    dataPlot: number | undefined;
    dataNameTreatment: string | undefined;
    dataTrialId: number;
}

export class TreeNodeBackendProyecto implements ITreeNodeBackendProyecto {
    data!: PromedioLabBbxproyecto;
    children!: any | undefined;

    constructor(data?: ITreeNodeBackendProyecto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PromedioLabBbxproyecto.fromJS(_data["data"]) : undefined as any;
            this.children = _data["children"];
        }
    }

    static fromJS(data: any): TreeNodeBackendProyecto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeBackendProyecto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["children"] = this.children;
        return data;
    }
}

export interface ITreeNodeBackendProyecto {
    data: PromedioLabBbxproyecto;
    children: any | undefined;
}

export class TreeStatus implements ITreeStatus {
    tenantId!: number | undefined;
    name!: string;
    code!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITreeStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TreeStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeStatus {
    tenantId: number | undefined;
    name: string;
    code: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TreeStatusDto implements ITreeStatusDto {
    name!: string | undefined;
    code!: number;
    id!: number;

    constructor(data?: ITreeStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeStatusDto {
    name: string | undefined;
    code: number;
    id: number;
}

export class TreeStatusLookupTableDto implements ITreeStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITreeStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TreeStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITreeStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TreeToMeasureDto implements ITreeToMeasureDto {
    oldTreeMeasurementDto!: TreeMeasurementDto;
    newTreeMeasurementDto!: TreeMeasurementDto;
    measurementPlaningOptionsId!: number;
    treeName!: string | undefined;
    number!: number;
    order!: number;
    treatmentId!: number;
    statusId!: number | undefined;
    treatmentName!: string | undefined;
    treatmentBlock!: number | undefined;
    statusName!: string | undefined;
    statusTreeIsStanding!: boolean | undefined;
    validTreeMeasure!: boolean;
    trialId!: number;
    id!: number;

    constructor(data?: ITreeToMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldTreeMeasurementDto = _data["oldTreeMeasurementDto"] ? TreeMeasurementDto.fromJS(_data["oldTreeMeasurementDto"]) : undefined as any;
            this.newTreeMeasurementDto = _data["newTreeMeasurementDto"] ? TreeMeasurementDto.fromJS(_data["newTreeMeasurementDto"]) : undefined as any;
            this.measurementPlaningOptionsId = _data["measurementPlaningOptionsId"];
            this.treeName = _data["treeName"];
            this.number = _data["number"];
            this.order = _data["order"];
            this.treatmentId = _data["treatmentId"];
            this.statusId = _data["statusId"];
            this.treatmentName = _data["treatmentName"];
            this.treatmentBlock = _data["treatmentBlock"];
            this.statusName = _data["statusName"];
            this.statusTreeIsStanding = _data["statusTreeIsStanding"];
            this.validTreeMeasure = _data["validTreeMeasure"];
            this.trialId = _data["trialId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeToMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeToMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldTreeMeasurementDto"] = this.oldTreeMeasurementDto ? this.oldTreeMeasurementDto.toJSON() : undefined as any;
        data["newTreeMeasurementDto"] = this.newTreeMeasurementDto ? this.newTreeMeasurementDto.toJSON() : undefined as any;
        data["measurementPlaningOptionsId"] = this.measurementPlaningOptionsId;
        data["treeName"] = this.treeName;
        data["number"] = this.number;
        data["order"] = this.order;
        data["treatmentId"] = this.treatmentId;
        data["statusId"] = this.statusId;
        data["treatmentName"] = this.treatmentName;
        data["treatmentBlock"] = this.treatmentBlock;
        data["statusName"] = this.statusName;
        data["statusTreeIsStanding"] = this.statusTreeIsStanding;
        data["validTreeMeasure"] = this.validTreeMeasure;
        data["trialId"] = this.trialId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITreeToMeasureDto {
    oldTreeMeasurementDto: TreeMeasurementDto;
    newTreeMeasurementDto: TreeMeasurementDto;
    measurementPlaningOptionsId: number;
    treeName: string | undefined;
    number: number;
    order: number;
    treatmentId: number;
    statusId: number | undefined;
    treatmentName: string | undefined;
    treatmentBlock: number | undefined;
    statusName: string | undefined;
    statusTreeIsStanding: boolean | undefined;
    validTreeMeasure: boolean;
    trialId: number;
    id: number;
}

export class TreeTreatmentLookupTableDto implements ITreeTreatmentLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    displayTreatmentName!: string | undefined;

    constructor(data?: ITreeTreatmentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayTreatmentName = _data["displayTreatmentName"];
        }
    }

    static fromJS(data: any): TreeTreatmentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeTreatmentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayTreatmentName"] = this.displayTreatmentName;
        return data;
    }
}

export interface ITreeTreatmentLookupTableDto {
    id: number;
    displayName: string | undefined;
    displayTreatmentName: string | undefined;
}

export class Trial implements ITrial {
    tenantId!: number | undefined;
    trialNumber!: number;
    region!: string;
    typeTrialFk!: TypeTrial;
    oldTrialDenomination!: string | undefined;
    district!: string | undefined;
    zone!: string;
    plantationDate!: DateTime;
    area!: number;
    treatments!: number;
    totalTrees!: number;
    observation!: string | undefined;
    distanceBetweenPlants!: number;
    distanceBetweenRows!: number;
    data!: number;
    apsServiceOrder!: boolean;
    planningStatus!: string | undefined;
    instalationDate!: DateTime | undefined;
    standName!: string;
    farmName!: string;
    oldStandName!: string | undefined;
    coneat!: string;
    typeTrialId!: number;
    trialDesignTypesId!: number;
    trialDesignTypesFk!: TrialDesignTypes;
    trialStatusId!: number;
    trialStatusFk!: TrialStatus;
    density!: number;
    treatmentsList!: Treatment[] | undefined;
    projectConfigurationsList!: ProjectConfiguration[] | undefined;
    isGenomicSelection!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITrial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.trialNumber = _data["trialNumber"];
            this.region = _data["region"];
            this.typeTrialFk = _data["typeTrialFk"] ? TypeTrial.fromJS(_data["typeTrialFk"]) : undefined as any;
            this.oldTrialDenomination = _data["oldTrialDenomination"];
            this.district = _data["district"];
            this.zone = _data["zone"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.area = _data["area"];
            this.treatments = _data["treatments"];
            this.totalTrees = _data["totalTrees"];
            this.observation = _data["observation"];
            this.distanceBetweenPlants = _data["distanceBetweenPlants"];
            this.distanceBetweenRows = _data["distanceBetweenRows"];
            this.data = _data["data"];
            this.apsServiceOrder = _data["apsServiceOrder"];
            this.planningStatus = _data["planningStatus"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.standName = _data["standName"];
            this.farmName = _data["farmName"];
            this.oldStandName = _data["oldStandName"];
            this.coneat = _data["coneat"];
            this.typeTrialId = _data["typeTrialId"];
            this.trialDesignTypesId = _data["trialDesignTypesId"];
            this.trialDesignTypesFk = _data["trialDesignTypesFk"] ? TrialDesignTypes.fromJS(_data["trialDesignTypesFk"]) : undefined as any;
            this.trialStatusId = _data["trialStatusId"];
            this.trialStatusFk = _data["trialStatusFk"] ? TrialStatus.fromJS(_data["trialStatusFk"]) : undefined as any;
            this.density = _data["density"];
            if (Array.isArray(_data["treatmentsList"])) {
                this.treatmentsList = [] as any;
                for (let item of _data["treatmentsList"])
                    this.treatmentsList!.push(Treatment.fromJS(item));
            }
            if (Array.isArray(_data["projectConfigurationsList"])) {
                this.projectConfigurationsList = [] as any;
                for (let item of _data["projectConfigurationsList"])
                    this.projectConfigurationsList!.push(ProjectConfiguration.fromJS(item));
            }
            this.isGenomicSelection = _data["isGenomicSelection"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Trial {
        data = typeof data === 'object' ? data : {};
        let result = new Trial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["trialNumber"] = this.trialNumber;
        data["region"] = this.region;
        data["typeTrialFk"] = this.typeTrialFk ? this.typeTrialFk.toJSON() : undefined as any;
        data["oldTrialDenomination"] = this.oldTrialDenomination;
        data["district"] = this.district;
        data["zone"] = this.zone;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["area"] = this.area;
        data["treatments"] = this.treatments;
        data["totalTrees"] = this.totalTrees;
        data["observation"] = this.observation;
        data["distanceBetweenPlants"] = this.distanceBetweenPlants;
        data["distanceBetweenRows"] = this.distanceBetweenRows;
        data["data"] = this.data;
        data["apsServiceOrder"] = this.apsServiceOrder;
        data["planningStatus"] = this.planningStatus;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["standName"] = this.standName;
        data["farmName"] = this.farmName;
        data["oldStandName"] = this.oldStandName;
        data["coneat"] = this.coneat;
        data["typeTrialId"] = this.typeTrialId;
        data["trialDesignTypesId"] = this.trialDesignTypesId;
        data["trialDesignTypesFk"] = this.trialDesignTypesFk ? this.trialDesignTypesFk.toJSON() : undefined as any;
        data["trialStatusId"] = this.trialStatusId;
        data["trialStatusFk"] = this.trialStatusFk ? this.trialStatusFk.toJSON() : undefined as any;
        data["density"] = this.density;
        if (Array.isArray(this.treatmentsList)) {
            data["treatmentsList"] = [];
            for (let item of this.treatmentsList)
                data["treatmentsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectConfigurationsList)) {
            data["projectConfigurationsList"] = [];
            for (let item of this.projectConfigurationsList)
                data["projectConfigurationsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["isGenomicSelection"] = this.isGenomicSelection;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrial {
    tenantId: number | undefined;
    trialNumber: number;
    region: string;
    typeTrialFk: TypeTrial;
    oldTrialDenomination: string | undefined;
    district: string | undefined;
    zone: string;
    plantationDate: DateTime;
    area: number;
    treatments: number;
    totalTrees: number;
    observation: string | undefined;
    distanceBetweenPlants: number;
    distanceBetweenRows: number;
    data: number;
    apsServiceOrder: boolean;
    planningStatus: string | undefined;
    instalationDate: DateTime | undefined;
    standName: string;
    farmName: string;
    oldStandName: string | undefined;
    coneat: string;
    typeTrialId: number;
    trialDesignTypesId: number;
    trialDesignTypesFk: TrialDesignTypes;
    trialStatusId: number;
    trialStatusFk: TrialStatus;
    density: number;
    treatmentsList: Treatment[] | undefined;
    projectConfigurationsList: ProjectConfiguration[] | undefined;
    isGenomicSelection: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TrialDesignTypes implements ITrialDesignTypes {
    tenantId!: number | undefined;
    name!: string;
    isDividedPlots!: boolean;
    isAlfaLaticeAsterisk!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITrialDesignTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDividedPlots = _data["isDividedPlots"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialDesignTypes {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDesignTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDividedPlots"] = this.isDividedPlots;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialDesignTypes {
    tenantId: number | undefined;
    name: string;
    isDividedPlots: boolean;
    isAlfaLaticeAsterisk: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TrialDesignTypesDto implements ITrialDesignTypesDto {
    name!: string | undefined;
    isDividedPlots!: boolean;
    isAlfaLaticeAsterisk!: boolean;
    id!: number;

    constructor(data?: ITrialDesignTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDividedPlots = _data["isDividedPlots"];
            this.isAlfaLaticeAsterisk = _data["isAlfaLaticeAsterisk"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialDesignTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDesignTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDividedPlots"] = this.isDividedPlots;
        data["isAlfaLaticeAsterisk"] = this.isAlfaLaticeAsterisk;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialDesignTypesDto {
    name: string | undefined;
    isDividedPlots: boolean;
    isAlfaLaticeAsterisk: boolean;
    id: number;
}

export class TrialDto implements ITrialDto {
    trialNumber!: number;
    region!: string | undefined;
    oldTrialDenomination!: string | undefined;
    district!: string | undefined;
    zone!: string | undefined;
    plantationDate!: DateTime;
    area!: number | undefined;
    treatments!: number | undefined;
    totalTrees!: number | undefined;
    observation!: string | undefined;
    distanceBetweenPlants!: number;
    distanceBetweenRows!: number;
    data!: number | undefined;
    apsServiceOrder!: boolean;
    planningStatus!: string | undefined;
    instalationDate!: DateTime | undefined;
    blocks!: number;
    standName!: string | undefined;
    farmName!: string | undefined;
    oldStandName!: string | undefined;
    coneat!: string | undefined;
    typeTrialId!: number;
    trialDesignTypesId!: number;
    trialStatusId!: number;
    density!: number;
    treatmentsList!: TreatmentDto[] | undefined;
    projectConfigurationsList!: ProjectConfigurationDto[] | undefined;
    isGenomicSelection!: boolean;
    id!: number;

    constructor(data?: ITrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trialNumber = _data["trialNumber"];
            this.region = _data["region"];
            this.oldTrialDenomination = _data["oldTrialDenomination"];
            this.district = _data["district"];
            this.zone = _data["zone"];
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.area = _data["area"];
            this.treatments = _data["treatments"];
            this.totalTrees = _data["totalTrees"];
            this.observation = _data["observation"];
            this.distanceBetweenPlants = _data["distanceBetweenPlants"];
            this.distanceBetweenRows = _data["distanceBetweenRows"];
            this.data = _data["data"];
            this.apsServiceOrder = _data["apsServiceOrder"];
            this.planningStatus = _data["planningStatus"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.blocks = _data["blocks"];
            this.standName = _data["standName"];
            this.farmName = _data["farmName"];
            this.oldStandName = _data["oldStandName"];
            this.coneat = _data["coneat"];
            this.typeTrialId = _data["typeTrialId"];
            this.trialDesignTypesId = _data["trialDesignTypesId"];
            this.trialStatusId = _data["trialStatusId"];
            this.density = _data["density"];
            if (Array.isArray(_data["treatmentsList"])) {
                this.treatmentsList = [] as any;
                for (let item of _data["treatmentsList"])
                    this.treatmentsList!.push(TreatmentDto.fromJS(item));
            }
            if (Array.isArray(_data["projectConfigurationsList"])) {
                this.projectConfigurationsList = [] as any;
                for (let item of _data["projectConfigurationsList"])
                    this.projectConfigurationsList!.push(ProjectConfigurationDto.fromJS(item));
            }
            this.isGenomicSelection = _data["isGenomicSelection"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trialNumber"] = this.trialNumber;
        data["region"] = this.region;
        data["oldTrialDenomination"] = this.oldTrialDenomination;
        data["district"] = this.district;
        data["zone"] = this.zone;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["area"] = this.area;
        data["treatments"] = this.treatments;
        data["totalTrees"] = this.totalTrees;
        data["observation"] = this.observation;
        data["distanceBetweenPlants"] = this.distanceBetweenPlants;
        data["distanceBetweenRows"] = this.distanceBetweenRows;
        data["data"] = this.data;
        data["apsServiceOrder"] = this.apsServiceOrder;
        data["planningStatus"] = this.planningStatus;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["blocks"] = this.blocks;
        data["standName"] = this.standName;
        data["farmName"] = this.farmName;
        data["oldStandName"] = this.oldStandName;
        data["coneat"] = this.coneat;
        data["typeTrialId"] = this.typeTrialId;
        data["trialDesignTypesId"] = this.trialDesignTypesId;
        data["trialStatusId"] = this.trialStatusId;
        data["density"] = this.density;
        if (Array.isArray(this.treatmentsList)) {
            data["treatmentsList"] = [];
            for (let item of this.treatmentsList)
                data["treatmentsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectConfigurationsList)) {
            data["projectConfigurationsList"] = [];
            for (let item of this.projectConfigurationsList)
                data["projectConfigurationsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["isGenomicSelection"] = this.isGenomicSelection;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialDto {
    trialNumber: number;
    region: string | undefined;
    oldTrialDenomination: string | undefined;
    district: string | undefined;
    zone: string | undefined;
    plantationDate: DateTime;
    area: number | undefined;
    treatments: number | undefined;
    totalTrees: number | undefined;
    observation: string | undefined;
    distanceBetweenPlants: number;
    distanceBetweenRows: number;
    data: number | undefined;
    apsServiceOrder: boolean;
    planningStatus: string | undefined;
    instalationDate: DateTime | undefined;
    blocks: number;
    standName: string | undefined;
    farmName: string | undefined;
    oldStandName: string | undefined;
    coneat: string | undefined;
    typeTrialId: number;
    trialDesignTypesId: number;
    trialStatusId: number;
    density: number;
    treatmentsList: TreatmentDto[] | undefined;
    projectConfigurationsList: ProjectConfigurationDto[] | undefined;
    isGenomicSelection: boolean;
    id: number;
}

export class TrialLookupDto implements ITrialLookupDto {
    id!: number;
    trialNumber!: number;
    displayText!: string | undefined;

    constructor(data?: ITrialLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trialNumber = _data["trialNumber"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): TrialLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trialNumber"] = this.trialNumber;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ITrialLookupDto {
    id: number;
    trialNumber: number;
    displayText: string | undefined;
}

export class TrialRDDto implements ITrialRDDto {
    groupTrial!: string | undefined;
    trialNumber!: string | undefined;
    trialArea!: number | undefined;
    experimentType!: string | undefined;
    trialType!: string | undefined;
    region!: string | undefined;
    zone!: string | undefined;
    instalationDate!: DateTime;
    plantationDate!: DateTime | undefined;
    id!: number;

    constructor(data?: ITrialRDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupTrial = _data["groupTrial"];
            this.trialNumber = _data["trialNumber"];
            this.trialArea = _data["trialArea"];
            this.experimentType = _data["experimentType"];
            this.trialType = _data["trialType"];
            this.region = _data["region"];
            this.zone = _data["zone"];
            this.instalationDate = _data["instalationDate"] ? DateTime.fromISO(_data["instalationDate"].toString()) : undefined as any;
            this.plantationDate = _data["plantationDate"] ? DateTime.fromISO(_data["plantationDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialRDDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialRDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupTrial"] = this.groupTrial;
        data["trialNumber"] = this.trialNumber;
        data["trialArea"] = this.trialArea;
        data["experimentType"] = this.experimentType;
        data["trialType"] = this.trialType;
        data["region"] = this.region;
        data["zone"] = this.zone;
        data["instalationDate"] = this.instalationDate ? this.instalationDate.toString() : undefined as any;
        data["plantationDate"] = this.plantationDate ? this.plantationDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialRDDto {
    groupTrial: string | undefined;
    trialNumber: string | undefined;
    trialArea: number | undefined;
    experimentType: string | undefined;
    trialType: string | undefined;
    region: string | undefined;
    zone: string | undefined;
    instalationDate: DateTime;
    plantationDate: DateTime | undefined;
    id: number;
}

export class TrialStatus implements ITrialStatus {
    tenantId!: number | undefined;
    name!: string;
    isPlanned!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITrialStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isPlanned = _data["isPlanned"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TrialStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isPlanned"] = this.isPlanned;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialStatus {
    tenantId: number | undefined;
    name: string;
    isPlanned: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TrialStatusDto implements ITrialStatusDto {
    name!: string | undefined;
    isPlanned!: boolean;
    id!: number;

    constructor(data?: ITrialStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPlanned = _data["isPlanned"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrialStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPlanned"] = this.isPlanned;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrialStatusDto {
    name: string | undefined;
    isPlanned: boolean;
    id: number;
}

export class TrialTrialDesignTypesLookupTableDto implements ITrialTrialDesignTypesLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrialTrialDesignTypesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrialTrialDesignTypesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialTrialDesignTypesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrialTrialDesignTypesLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TrialTrialStatusLookupTableDto implements ITrialTrialStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrialTrialStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrialTrialStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialTrialStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrialTrialStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TrialTypeTrialLookupTableDto implements ITrialTypeTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    groupName!: string | undefined;

    constructor(data?: ITrialTypeTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): TrialTypeTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialTypeTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface ITrialTypeTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
    groupName: string | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class TypeGeneticMaterialDto implements ITypeGeneticMaterialDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ITypeGeneticMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeGeneticMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeGeneticMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeGeneticMaterialDto {
    name: string | undefined;
    id: number;
}

export class TypeSpecie implements ITypeSpecie {
    tenantId!: number | undefined;
    name!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITypeSpecie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeSpecie {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSpecie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeSpecie {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TypeSpecieDto implements ITypeSpecieDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ITypeSpecieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeSpecieDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSpecieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeSpecieDto {
    name: string | undefined;
    id: number;
}

export class TypeTrial implements ITypeTrial {
    tenantId!: number | undefined;
    name!: string;
    category!: string;
    groupTrialId!: number;
    groupTrialFk!: GroupTrial;
    isClonalSeedOrchard!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITypeTrial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.groupTrialId = _data["groupTrialId"];
            this.groupTrialFk = _data["groupTrialFk"] ? GroupTrial.fromJS(_data["groupTrialFk"]) : undefined as any;
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeTrial {
        data = typeof data === 'object' ? data : {};
        let result = new TypeTrial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["category"] = this.category;
        data["groupTrialId"] = this.groupTrialId;
        data["groupTrialFk"] = this.groupTrialFk ? this.groupTrialFk.toJSON() : undefined as any;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeTrial {
    tenantId: number | undefined;
    name: string;
    category: string;
    groupTrialId: number;
    groupTrialFk: GroupTrial;
    isClonalSeedOrchard: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TypeTrialDto implements ITypeTrialDto {
    name!: string | undefined;
    category!: string | undefined;
    groupTrialId!: number;
    isClonalSeedOrchard!: boolean;
    id!: number;

    constructor(data?: ITypeTrialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.groupTrialId = _data["groupTrialId"];
            this.isClonalSeedOrchard = _data["isClonalSeedOrchard"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeTrialDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeTrialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["groupTrialId"] = this.groupTrialId;
        data["isClonalSeedOrchard"] = this.isClonalSeedOrchard;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeTrialDto {
    name: string | undefined;
    category: string | undefined;
    groupTrialId: number;
    isClonalSeedOrchard: boolean;
    id: number;
}

export class TypeTrialGroupTrialLookupTableDto implements ITypeTrialGroupTrialLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITypeTrialGroupTrialLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TypeTrialGroupTrialLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeTrialGroupTrialLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITypeTrialGroupTrialLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : undefined as any;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : undefined as any;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateMassDiscardDateInput implements IUpdateMassDiscardDateInput {
    ids!: number[] | undefined;
    discardDate!: DateTime | undefined;

    constructor(data?: IUpdateMassDiscardDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.discardDate = _data["discardDate"] ? DateTime.fromISO(_data["discardDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateMassDiscardDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMassDiscardDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["discardDate"] = this.discardDate ? this.discardDate.toString() : undefined as any;
        return data;
    }
}

export interface IUpdateMassDiscardDateInput {
    ids: number[] | undefined;
    discardDate: DateTime | undefined;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    useGravatarProfilePicture!: boolean;
    userId!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    useGravatarProfilePicture: boolean;
    userId: number | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : undefined as any;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (this as any).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (this as any).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined as any;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message!: string | undefined;
    members!: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class WebhookEvent implements IWebhookEvent {
    webhookName!: string;
    data!: string | undefined;
    creationTime!: DateTime;
    tenantId!: number | undefined;
    isDeleted!: boolean;
    deletionTime!: DateTime | undefined;
    id!: string;

    constructor(data?: IWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookEvent {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookEvent {
    webhookName: string;
    data: string | undefined;
    creationTime: DateTime;
    tenantId: number | undefined;
    isDeleted: boolean;
    deletionTime: DateTime | undefined;
    id: string;
}

export class WebhookSubscription implements IWebhookSubscription {
    tenantId!: number | undefined;
    webhookUri!: string | undefined;
    secret!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    headers!: { [key: string]: string; } | undefined;
    id!: string;

    constructor(data?: IWebhookSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.webhookUri = _data["webhookUri"];
            this.secret = _data["secret"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (this.headers as any)![key] = _data["headers"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["webhookUri"] = this.webhookUri;
        data["secret"] = this.secret;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (data["headers"] as any)[key] = (this.headers as any)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookSubscription {
    tenantId: number | undefined;
    webhookUri: string | undefined;
    secret: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    headers: { [key: string]: string; } | undefined;
    id: string;
}

export class WoodSampleType implements IWoodSampleType {
    tenantId!: number | undefined;
    name!: string;
    isTreeCut!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IWoodSampleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isTreeCut = _data["isTreeCut"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodSampleType {
        data = typeof data === 'object' ? data : {};
        let result = new WoodSampleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isTreeCut"] = this.isTreeCut;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodSampleType {
    tenantId: number | undefined;
    name: string;
    isTreeCut: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class WoodSampleTypeDto implements IWoodSampleTypeDto {
    name!: string | undefined;
    isTreeCut!: boolean;
    id!: number;

    constructor(data?: IWoodSampleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isTreeCut = _data["isTreeCut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodSampleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodSampleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isTreeCut"] = this.isTreeCut;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodSampleTypeDto {
    name: string | undefined;
    isTreeCut: boolean;
    id: number;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class YoungObservationCodeDto implements IYoungObservationCodeDto {
    code!: number;
    detail!: string | undefined;
    treeStatusId!: number;
    id!: number;

    constructor(data?: IYoungObservationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.detail = _data["detail"];
            this.treeStatusId = _data["treeStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): YoungObservationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoungObservationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["detail"] = this.detail;
        data["treeStatusId"] = this.treeStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface IYoungObservationCodeDto {
    code: number;
    detail: string | undefined;
    treeStatusId: number;
    id: number;
}

export class Nodosangre implements INodosangre {
    granEspecie!: string | undefined;
    sangre!: number;
    clasificacion!: EnumSiteClassification;

    constructor(data?: INodosangre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.granEspecie = _data["granEspecie"];
            this.sangre = _data["sangre"];
            this.clasificacion = _data["clasificacion"];
        }
    }

    static fromJS(data: any): Nodosangre {
        data = typeof data === 'object' ? data : {};
        let result = new Nodosangre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["granEspecie"] = this.granEspecie;
        data["sangre"] = this.sangre;
        data["clasificacion"] = this.clasificacion;
        return data;
    }
}

export interface INodosangre {
    granEspecie: string | undefined;
    sangre: number;
    clasificacion: EnumSiteClassification;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        (this.paypal as any)![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        (this.stripe as any)![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    (data["Paypal"] as any)[key] = (this.paypal as any)[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    (data["Stripe"] as any)[key] = (this.stripe as any)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}